// bwip-js // Barcode Writer in Pure JavaScript
// https://github.com/metafloor/bwip-js
//
// This code was automatically generated from:
// Barcode Writer in Pure PostScript - Version 2016-08-29
//
// Copyright (c) 2011-2016 Mark Warren
// Copyright (c) 2004-2014 Terry Burton
//
// Licensed MIT. See the LICENSE file in the bwip-js root directory.
function BWIPP() {
	// bwip-js/barcode-hdr.js
	//
	// This code is injected above the cross-compiled barcode.ps.

	// The BWIPJS object (graphics interface)
	var $$ = null;

	// The global dictionary.  Each renderer and encoder declare a
	// $1 local dict.
	var $0 = {
		$error: {} // the postscript error object
	};

	var $j = 0; // stack pointer
	var $k = []; // operand stack

	// Array ctor
	//	$a()	: Build a new array up to the Infinity-marker on the stack.
	//	$a(arr)	: Convert native array to a "view" of the array.
	//	$a(len)	: Create a new array of length `len`
	function $a(a) {
		if (!arguments.length) {
			for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i--);
			if (i < 0) {
				throw new Error('array-marker-not-found');
			}
			a = $k.splice(i + 1, $j - 1 - i);
			$j = i;
		} else if (!(a instanceof Array)) {
			a = new Array(+arguments[0]);
			for (var i = 0, l = a.length; i < l; i++) {
				a[i] = null;
			}
		}
		a.b = a; // base array
		a.o = 0; // offset into base
		return a;
	}

	// dict ctor
	//	$d() : look for the Infinity marker on the stack
	function $d() {
		var d = {};
		for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i -= 2) {
			if ($k[i - 1] === Infinity) {
				throw new Error('dict-malformed-stack');
			}
			// Unlike javascript, postscript dict keys differentiate between
			// numbers and the string representation of a number.
			var k = $k[i - 1]; // "key" into the dict entry
			var t = typeof k;
			if (t === 'number') {
				d['\uffff' + k] = $k[i];
			} else if (t === 'string') {
				d[k] = $k[i];
			} else if (k instanceof Uint8Array) {
				d[$z(k)] = $k[i];
			} else {
				throw 'dict-not-a-valid-key(' + k + ')';
			}
		}
		if (i < 0) {
			throw 'dict-marker-not-found';
		}
		$j = i;
		return d;
	}

	// string ctor
	//	s(number)	: create zero-filled string of number-length
	//	s(string)	: make a copy of the string
	//	s(uint8[])	: make a copy of the string
	//
	// Returns a Uint8Array-string.
	function $s(v) {
		var t = typeof v;
		if (t === 'number') {
			return new Uint8Array(v);
		}
		if (t !== 'string') {
			v = '' + v;
		}
		var s = new Uint8Array(v.length);
		for (var i = 0; i < v.length; i++) {
			s[i] = v.charCodeAt(i);
		}
		return s;
	}

	// Primarily designed to convert uint8-string to string, but will call the
	// the toString() method on any value.
	function $z(s) {
		if (s instanceof Uint8Array) {
			// Postscript treats nul-char as end of string, even if string is
			// longer.
			for (var i = 0, l = s.length; i < l && s[i]; i++);
			if (i < l) {
				return String.fromCharCode.apply(null, s.subarray(0, i));
			}
			return String.fromCharCode.apply(null, s)
		}
		return '' + s;
	}

	// Copies source to dest and returns a view of just the copied characters
	function $strcpy(dst, src) {
		if (typeof dst === 'string') {
			dst = $s(dst);
		}
		if (src instanceof Uint8Array) {
			for (var i = 0, l = src.length; i < l; i++) {
				dst[i] = src[i];
			}
		} else {
			for (var i = 0, l = src.length; i < l; i++) {
				dst[i] = src.charCodeAt(i);
			}
		}
		return src.length < dst.length ? dst.subarray(0, src.length) : dst;
	}

	// cvs operator - convert a value to its string representation
	//	s : string to store into
	//	v : any value
	function $cvs(s, v) {
		var t = typeof v;
		if (t == 'number' || t == 'boolean' || v === null) {
			v = '' + v;
		} else if (t !== 'string') {
			v = '--nostringval--';
		}
		for (var i = 0, l = v.length; i < l; i++) {
			s[i] = v.charCodeAt(i);
		}
		$k[$j++] = i < s.length ? s.subarray(0, i) : s;
	}
	// cvrs operator - convert a number to a radix string
	//	s : string to store into
	//	n : number
	//	r : radix
	function $cvrs(s, n, r) {
		return $strcpy(s, (~~n).toString(r).toUpperCase());
	}

	// get operator
	//	s : source
	//	k : key
	function $get(s, k) {
		if (s instanceof Uint8Array) {
			return s[k];
		}
		if (typeof s === 'string') {
			return s.charCodeAt(k);
		}
		if (s instanceof Array) {
			return s.b[s.o + k];
		}
		// Must be a dict object : with postscript dict objects, a number key
		// is differerent than its string representation.  postscript uses
		// 8-bit strings, so \uffff can never be in a key value.
		if (typeof k === 'number') {
			return s['\uffff' + k];
		}
		if (k instanceof Uint8Array) {
			return s[$z(k)];
		}
		return s[k];
	}

	// put operator
	//	d : dest
	//	k : key
	//	v : value
	function $put(d, k, v) {
		if (d instanceof Uint8Array) {
			d[k] = v;
		} else if (d instanceof Array) {
			d.b[d.o + k] = v;
		} else if (typeof d == 'object') {
			if (k instanceof Uint8Array) {
				d[$z(k)] = v;
			} else {
				d[typeof k == 'number' ? '\uffff' + k : k] = v;
			}
		} else {
			throw 'put-not-writable-' + (typeof d);
		}
	}

	// getinterval operator
	//	s : src
	//	o : offset
	//	l : length
	function $geti(s, o, l) {
		if (s instanceof Uint8Array) {
			return s.subarray(o, o + l);
		}
		if (s instanceof Array) {
			var a = new Array(l);
			a.b = s.b; // base array
			a.o = s.o + o; // offset into base
			return a;
		}
		// Must be a string
		return s.substr(o, l);
	}

	// putinterval operator
	//	d : dst
	//	o : offset
	//	s : src
	function $puti(d, o, s) {
		if (d instanceof Uint8Array) {
			if (typeof s == 'string') {
				for (var i = 0, l = s.length; i < l; i++) {
					d[o + i] = s.charCodeAt(i);
				}
			} else {
				// When both d and s are the same, we want to copy
				// backwards, which works for the general case as well.
				for (var i = s.length - 1; i >= 0; i--) {
					d[o + i] = s[i];
				}
			}
		} else if (d instanceof Array) {
			// Operate on the base arrays
			var darr = d.b;
			var doff = o + d.o;
			var sarr = s.b;
			var soff = s.o;

			for (var i = 0, l = s.length; i < l; i++) {
				darr[doff + i] = sarr[soff + i];
			}
		} else {
			throw 'putinterval-not-writable-' + (typeof d);
		}
	}

	// type operator
	function $type(v) {
		// null can be mis-typed - get it out of the way
		if (v === null || v === undefined) {
			return 'nulltype';
		}
		var t = typeof v;
		if (t == 'number') {
			return v % 1 ? 'realtype' : 'integertype';
		}
		if (t == 'boolean') {
			return 'booleantype';
		}
		if (t == 'string' || v instanceof Uint8Array) {
			return 'stringtype';
		}
		if (t == 'function') {
			return 'operatortype';
		}
		if (v instanceof Array) {
			return 'arraytype';
		}
		return 'dicttype';
		// filetype
		// fonttype
		// gstatetype
		// marktype	(v === Infinity)
		// nametype
		// savetype
	}

	// search operator
	//		string seek search suffix match prefix true %if-found
	//						   string false				%if-not-found
	function $search(str, seek) {
		if (!(str instanceof Uint8Array)) {
			str = $s(str);
		}
		var ls = str.length;

		// Virtually all uses of search in BWIPP are for single-characters.
		// Optimize for that case.
		if (seek.length == 1) {
			var lk = 1;
			var cd = seek instanceof Uint8Array ? seek[0] : seek.charCodeAt(0);
			for (var i = 0; i < ls && str[i] != cd; i++);
		} else {
			// Slow path, 
			if (!(seek instanceof Uint8Array)) {
				seek = $(seek);
			}
			var lk = seek.length;
			var cd = seek[0];
			for (var i = 0; i < ls && str[i] != cd; i++);
			while (i < ls) {
				for (var j = 1; j < lk && str[i + j] === seek[j]; j++);
				if (j === lk) {
					break;
				}
				for (i++; i < ls && str[i] != cd; i++);
			}
		}
		if (i < ls) {
			$k[$j++] = str.subarray(i + lk);
			$k[$j++] = str.subarray(i, i + lk);
			$k[$j++] = str.subarray(0, i);
			$k[$j++] = true;
		} else {
			$k[$j++] = str;
			$k[$j++] = false;
		}
	}

	// The callback is omitted when forall is being used just to push onto the
	// stack.
	function $forall(o, cb) {
		if (o instanceof Uint8Array) {
			for (var i = 0, l = o.length; i < l; i++) {
				$k[$j++] = o[i];
				cb && cb();
			}
		} else if (o instanceof Array) {
			// The array may be a view.
			for (var a = o.b, i = o.o, l = o.o + o.length; i < l; i++) {
				$k[$j++] = a[i];
				cb && cb();
			}
		} else if (typeof o === 'string') {
			for (var i = 0, l = o.length; i < l; i++) {
				$k[$j++] = o.charCodeAt(i);
				cb && cb();
			}
		} else {
			for (var id in o) {
				$k[$j++] = id;
				$k[$j++] = o[id];
				cb && cb();
			}
		}
	}

	function $cleartomark() {
		while ($j > 0 && $k[--$j] !== Infinity);
	}

	function $counttomark() {
		for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i--);
		return $j - i - 1;
	}

	function $aload(a) {
		for (var i = 0, l = a.length, b = a.b, o = a.o; i < l; i++) {
			$k[$j++] = b[o + i];
		}
		// This push has been optimized out.  See $.aload() in psc.js.
		//$k[$j++] = a;
	}

	function $astore(a) {
		for (var i = 0, l = a.length, b = a.b, o = a.o + l - 1; i < l; i++) {
			b[o - i] = $k[--$j];
		}
		$k[$j++] = a;
	}

	function $eq(a, b) {
		if (typeof a === 'string' && typeof b === 'string') {
			return a == b;
		}
		if (a instanceof Uint8Array && b instanceof Uint8Array) {
			if (a.length != b.length) {
				return false;
			}
			for (var i = 0, l = a.length; i < l; i++) {
				if (a[i] != b[i]) {
					return false;
				}
			}
			return true;
		}
		if (a instanceof Uint8Array && typeof b === 'string' ||
			b instanceof Uint8Array && typeof a === 'string') {
			if (a instanceof Uint8Array) {
				a = $z(a);
			} else {
				b = $z(b);
			}
			return a == b;
		}
		return a == b;
	}

	function $ne(a, b) {
		return !$eq(a, b);
	}

	function $lt(a, b) {
		if (a instanceof Uint8Array) {
			a = $z(a);
		}
		if (b instanceof Uint8Array) {
			b = $z(b);
		}
		return a < b;
	}

	function $le(a, b) {
		if (a instanceof Uint8Array) {
			a = $z(a);
		}
		if (b instanceof Uint8Array) {
			b = $z(b);
		}
		return a <= b;
	}

	function $gt(a, b) {
		if (a instanceof Uint8Array) {
			a = $z(a);
		}
		if (b instanceof Uint8Array) {
			b = $z(b);
		}
		return a > b;
	}

	function $ge(a, b) {
		if (a instanceof Uint8Array) {
			a = $z(a);
		}
		if (b instanceof Uint8Array) {
			b = $z(b);
		}
		return a >= b;
	}

	function $an(a, b) { // and
		return (typeof a === 'boolean') ? a && b : a & b;
	}

	function $or(a, b) { // or
		return (typeof a === 'boolean') ? a || b : a | b;
	}

	function $xo(a, b) { // xor
		return (typeof a === 'boolean') ? !a && b || a && !b : a ^ b;
	}

	// DEBUG-BEGIN
	function $stack() {
		console.log('[[[');
		for (var i = $j - 1; i >= 0; i--) {
			console.log(tostring($k[i]));
		}
		console.log(']]]');

		function tostring(v) {
			// null can be mis-typed - get it out of the way
			if (v === null) {
				return 'null';
			} else if (v === undefined) {
				return '<undefined>';
			} else if (v instanceof Array) {
				var s = '<array,' + v.o + ',' + v.length + '>[';
				for (var j = v.o, a = v.b, l = v.length + v.o; j < l; j++) {
					s += (j == v.o ? '' : ',') + tostring(a[j]);
				}
				return s + ']';
			} else if (v instanceof Uint8Array) {
				return '(' + $z[v] + ')';
			} else if (typeof v === 'object') {
				var s = '<<';
				for (var id in v) {
					s += (s.length == 7 ? '' : ',') + id + ':' + tostring(v[id]);
				}
				return s + '>>';
			} else if (typeof v === 'string') {
				return '"' + v + '"';
			} else {
				return '' + v;
			}
		}
	}
	// DEBUG-END
	$0.raiseerror = function() {
		$0.$error.errorinfo = $k[--$j]; /*55*/
		$0.$error.errorname = $k[--$j]; /*56*/
		$0.$error.command = null; /*57*/
		$0.$error.newerror = true; /*58*/
		throw new Error($0.$error.errorname + ": " + $0.$error.errorinfo); /*59*/
	};
	$0.ean5 = function() {
		var $1 = {}; /*650*/
		$1.options = $k[--$j]; /*652*/
		$1.barcode = $k[--$j]; /*653*/
		$1.dontdraw = false; /*655*/
		$1.includetext = false; /*656*/
		$1.textfont = "Helvetica"; /*657*/
		$1.textsize = 12; /*658*/
		$1.textxoffset = 0; /*659*/
		$1.textyoffset = "unset"; /*660*/
		$1.height = 0.7; /*661*/
		$forall($1.options, function() { /*672*/
			var _3 = $k[--$j]; /*672*/
			$1[$k[--$j]] = _3; /*672*/
		}); /*672*/
		$1.textfont = "" + $1.textfont; /*674*/
		$1.textsize = +$1.textsize; /*675*/
		$1.height = +$1.height; /*676*/
		$1.textxoffset = +$1.textxoffset; /*677*/
		if ($eq($1.textyoffset, "unset")) { /*681*/
			$1.textyoffset = ($1.height * 72) + 1; /*679*/
		} else { /*681*/
			$1.textyoffset = +$1.textyoffset; /*681*/
		} /*681*/
		if ($1.barcode.length != 5) { /*687*/
			$k[$j++] = "bwipp.ean5badLength"; /*686*/
			$k[$j++] = "EAN-5 add-on must be 5 digits"; /*686*/
			$0.raiseerror(); /*686*/
		} /*686*/
		$forall($1.barcode, function() { /*692*/
			var _E = $k[--$j]; /*689*/
			if ((_E < 48) || (_E > 57)) { /*691*/
				$k[$j++] = "bwipp.ean5badCharacter"; /*690*/
				$k[$j++] = "EAN-5 add-on must contain only digits"; /*690*/
				$0.raiseerror(); /*690*/
			} /*690*/
		}); /*690*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "112", "11"]); /*699*/
		$1.barchars = "0123456789"; /*702*/
		$1.mirrormaps = $a(["11000", "10100", "10010", "10001", "01100", "00110", "00011", "01010", "01001", "00101"]); /*708*/
		$1.checksum = 0; /*709*/
		for (var _H = 0; _H <= 4; _H += 1) { /*718*/
			$1.i = _H; /*711*/
			$1.barchar = $get($1.barcode, $1.i) - 48; /*712*/
			if (($1.i % 2) == 0) { /*716*/
				$1.checksum = ($1.barchar * 3) + $1.checksum; /*714*/
			} else { /*716*/
				$1.checksum = ($1.barchar * 9) + $1.checksum; /*716*/
			} /*716*/
		} /*716*/
		$1.checksum = $1.checksum % 10; /*719*/
		$1.mirrormap = $get($1.mirrormaps, $1.checksum); /*720*/
		$1.sbs = $s(31); /*722*/
		$1.txt = $a(5); /*723*/
		for (var _W = 0; _W <= 4; _W += 1) { /*753*/
			$1.i = _W; /*726*/
			if ($1.i == 0) { /*732*/
				$puti($1.sbs, 0, $get($1.encs, 10)); /*730*/
			} else { /*732*/
				$puti($1.sbs, (($1.i - 1) * 6) + 7, $get($1.encs, 11)); /*732*/
			} /*732*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*736*/
			$j--; /*737*/
			$1.indx = $k[--$j].length; /*738*/
			$j -= 2; /*739*/
			$1.enc = $get($1.encs, $1.indx); /*740*/
			if ($get($1.mirrormap, $1.i) == 49) { /*750*/
				$1.enclen = $1.enc.length; /*742*/
				$1.revenc = $s($1.enclen); /*743*/
				for (var _v = 0, _u = $1.enclen - 1; _v <= _u; _v += 1) { /*748*/
					$1.j = _v; /*745*/
					$1.char = $get($1.enc, $1.j); /*746*/
					$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*747*/
				} /*747*/
				$1.enc = $1.revenc; /*749*/
			} /*749*/
			$puti($1.sbs, ($1.i * 6) + 3, $1.enc); /*751*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 9) + 13) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*752*/
		} /*752*/
		$k[$j++] = Infinity; /*767*/
		$k[$j++] = "ren"; /*759*/
		$k[$j++] = $0.renlinear; /*759*/
		$k[$j++] = "sbs"; /*759*/
		$k[$j++] = Infinity; /*759*/
		var _1I = $1.sbs; /*758*/
		for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*758*/
			$k[$j++] = $get(_1I, _1J) - 48; /*758*/
		} /*758*/
		var _1M = $a(); /*759*/
		$k[$j++] = _1M; /*760*/
		$k[$j++] = "bhs"; /*760*/
		$k[$j++] = Infinity; /*760*/
		for (var _1N = 0, _1O = 16; _1N < _1O; _1N++) { /*759*/
			$k[$j++] = $1.height; /*759*/
		} /*759*/
		var _1Q = $a(); /*760*/
		$k[$j++] = _1Q; /*761*/
		$k[$j++] = "bbs"; /*761*/
		$k[$j++] = Infinity; /*761*/
		for (var _1R = 0, _1S = 16; _1R < _1S; _1R++) { /*760*/
			$k[$j++] = 0; /*760*/
		} /*760*/
		var _1T = $a(); /*761*/
		$k[$j++] = _1T; /*763*/
		if ($1.includetext) { /*763*/
			$k[$j++] = "txt"; /*762*/
			$k[$j++] = $1.txt; /*762*/
		} /*762*/
		$k[$j++] = "opt"; /*767*/
		$k[$j++] = $1.options; /*767*/
		$k[$j++] = "guardrightpos"; /*767*/
		$k[$j++] = 10; /*767*/
		$k[$j++] = "guardrightypos"; /*767*/
		$k[$j++] = $1.textyoffset + 4; /*767*/
		$k[$j++] = "bordertop"; /*767*/
		$k[$j++] = 10; /*767*/
		var _1Y = $d(); /*767*/
		$k[$j++] = _1Y; /*770*/
		if (!$1.dontdraw) { /*770*/
			$0.renlinear(); /*770*/
		} /*770*/
	};
	$0.ean2 = function() {
		var $1 = {}; /*797*/
		$1.options = $k[--$j]; /*799*/
		$1.barcode = $k[--$j]; /*800*/
		$1.dontdraw = false; /*802*/
		$1.includetext = false; /*803*/
		$1.textfont = "Helvetica"; /*804*/
		$1.textsize = 12; /*805*/
		$1.textxoffset = 0; /*806*/
		$1.textyoffset = "unset"; /*807*/
		$1.height = 0.7; /*808*/
		$forall($1.options, function() { /*819*/
			var _3 = $k[--$j]; /*819*/
			$1[$k[--$j]] = _3; /*819*/
		}); /*819*/
		$1.textfont = "" + $1.textfont; /*821*/
		$1.textsize = +$1.textsize; /*822*/
		$1.height = +$1.height; /*823*/
		$1.textxoffset = +$1.textxoffset; /*824*/
		if ($eq($1.textyoffset, "unset")) { /*828*/
			$1.textyoffset = ($1.height * 72) + 1; /*826*/
		} else { /*828*/
			$1.textyoffset = +$1.textyoffset; /*828*/
		} /*828*/
		if ($1.barcode.length != 2) { /*834*/
			$k[$j++] = "bwipp.ean2badLength"; /*833*/
			$k[$j++] = "EAN-2 add-on must be 2 digits"; /*833*/
			$0.raiseerror(); /*833*/
		} /*833*/
		$forall($1.barcode, function() { /*839*/
			var _E = $k[--$j]; /*836*/
			if ((_E < 48) || (_E > 57)) { /*838*/
				$k[$j++] = "bwipp.ean2badCharacter"; /*837*/
				$k[$j++] = "EAN-2 add-on must contain only digits"; /*837*/
				$0.raiseerror(); /*837*/
			} /*837*/
		}); /*837*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "112", "11"]); /*846*/
		$1.barchars = "0123456789"; /*849*/
		$1.mirrormap = $get($a(["00", "01", "10", "11"]), (~~$z($geti($1.barcode, 0, 2))) % 4); /*852*/
		$1.sbs = $s(13); /*854*/
		$1.txt = $a(2); /*855*/
		for (var _M = 0; _M <= 1; _M += 1) { /*885*/
			$1.i = _M; /*858*/
			if ($1.i == 0) { /*864*/
				$puti($1.sbs, 0, $get($1.encs, 10)); /*862*/
			} else { /*864*/
				$puti($1.sbs, (($1.i - 1) * 6) + 7, $get($1.encs, 11)); /*864*/
			} /*864*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*868*/
			$j--; /*869*/
			$1.indx = $k[--$j].length; /*870*/
			$j -= 2; /*871*/
			$1.enc = $get($1.encs, $1.indx); /*872*/
			if ($get($1.mirrormap, $1.i) == 49) { /*882*/
				$1.enclen = $1.enc.length; /*874*/
				$1.revenc = $s($1.enclen); /*875*/
				for (var _l = 0, _k = $1.enclen - 1; _l <= _k; _l += 1) { /*880*/
					$1.j = _l; /*877*/
					$1.char = $get($1.enc, $1.j); /*878*/
					$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*879*/
				} /*879*/
				$1.enc = $1.revenc; /*881*/
			} /*881*/
			$puti($1.sbs, ($1.i * 6) + 3, $1.enc); /*883*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 9) + 13) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*884*/
		} /*884*/
		$k[$j++] = Infinity; /*899*/
		$k[$j++] = "ren"; /*891*/
		$k[$j++] = $0.renlinear; /*891*/
		$k[$j++] = "sbs"; /*891*/
		$k[$j++] = Infinity; /*891*/
		var _18 = $1.sbs; /*890*/
		for (var _19 = 0, _1A = _18.length; _19 < _1A; _19++) { /*890*/
			$k[$j++] = $get(_18, _19) - 48; /*890*/
		} /*890*/
		var _1C = $a(); /*891*/
		$k[$j++] = _1C; /*892*/
		$k[$j++] = "bhs"; /*892*/
		$k[$j++] = Infinity; /*892*/
		for (var _1D = 0, _1E = 12; _1D < _1E; _1D++) { /*891*/
			$k[$j++] = $1.height; /*891*/
		} /*891*/
		var _1G = $a(); /*892*/
		$k[$j++] = _1G; /*893*/
		$k[$j++] = "bbs"; /*893*/
		$k[$j++] = Infinity; /*893*/
		for (var _1H = 0, _1I = 12; _1H < _1I; _1H++) { /*892*/
			$k[$j++] = 0; /*892*/
		} /*892*/
		var _1J = $a(); /*893*/
		$k[$j++] = _1J; /*895*/
		if ($1.includetext) { /*895*/
			$k[$j++] = "txt"; /*894*/
			$k[$j++] = $1.txt; /*894*/
		} /*894*/
		$k[$j++] = "opt"; /*899*/
		$k[$j++] = $1.options; /*899*/
		$k[$j++] = "guardrightpos"; /*899*/
		$k[$j++] = 10; /*899*/
		$k[$j++] = "guardrightypos"; /*899*/
		$k[$j++] = $1.textyoffset + 4; /*899*/
		$k[$j++] = "bordertop"; /*899*/
		$k[$j++] = 10; /*899*/
		var _1O = $d(); /*899*/
		$k[$j++] = _1O; /*902*/
		if (!$1.dontdraw) { /*902*/
			$0.renlinear(); /*902*/
		} /*902*/
	};
	$0.ean13 = function() {
		var $1 = {}; /*931*/
		$1.options = $k[--$j]; /*933*/
		$1.barcode = $k[--$j]; /*934*/
		$1.dontdraw = false; /*936*/
		$1.includetext = false; /*937*/
		$1.textfont = "Helvetica"; /*938*/
		$1.textsize = 12; /*939*/
		$1.textxoffset = -10; /*940*/
		$1.textyoffset = -4.5; /*941*/
		$1.height = 1; /*942*/
		$1.addongap = 12; /*943*/
		$1.addontextfont = "unset"; /*944*/
		$1.addontextsize = "unset"; /*945*/
		$1.addontextxoffset = "unset"; /*946*/
		$1.addontextyoffset = "unset"; /*947*/
		$forall($1.options, function() { /*958*/
			var _3 = $k[--$j]; /*958*/
			$1[$k[--$j]] = _3; /*958*/
		}); /*958*/
		$1.textfont = "" + $1.textfont; /*960*/
		$1.textsize = +$1.textsize; /*961*/
		$1.textxoffset = +$1.textxoffset; /*962*/
		$1.textyoffset = +$1.textyoffset; /*963*/
		$1.height = +$1.height; /*964*/
		$1.addongap = +$1.addongap; /*965*/
		if ($ne($1.addontextfont, "unset")) { /*966*/
			$1.addontextfont = "" + $1.addontextfont; /*966*/
		} /*966*/
		if ($ne($1.addontextsize, "unset")) { /*967*/
			$1.addontextsize = +$1.addontextsize; /*967*/
		} /*967*/
		if ($ne($1.addontextxoffset, "unset")) { /*968*/
			$1.addontextxoffset = +$1.addontextxoffset; /*968*/
		} /*968*/
		if ($ne($1.addontextyoffset, "unset")) { /*969*/
			$1.addontextyoffset = +$1.addontextyoffset; /*969*/
		} /*969*/
		$search($1.barcode, " "); /*972*/
		if ($k[--$j]) { /*978*/
			$1.barcode = $k[--$j]; /*973*/
			$j--; /*974*/
			$1.addon = $k[--$j]; /*975*/
		} else { /*978*/
			$j--; /*977*/
			$1.addon = ""; /*978*/
		} /*978*/
		if (($1.barcode.length != 12) && ($1.barcode.length != 13)) { /*984*/
			$k[$j++] = "bwipp.ean13badLength"; /*983*/
			$k[$j++] = "EAN-13 must be 12 or 13 digits"; /*983*/
			$0.raiseerror(); /*983*/
		} /*983*/
		$forall($1.barcode, function() { /*989*/
			var _Q = $k[--$j]; /*986*/
			if ((_Q < 48) || (_Q > 57)) { /*988*/
				$k[$j++] = "bwipp.ean13badCharacter"; /*987*/
				$k[$j++] = "EAN-13 must contain only digits"; /*987*/
				$0.raiseerror(); /*987*/
			} /*987*/
		}); /*987*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*992*/
			$k[$j++] = "bwipp.ean13badAddOnLength"; /*991*/
			$k[$j++] = "Add-on for EAN-13 must be 2 or 5 digits"; /*991*/
			$0.raiseerror(); /*991*/
		} /*991*/
		$1.pad = $s(13); /*995*/
		$1.checksum = 0; /*996*/
		for (var _V = 0; _V <= 11; _V += 1) { /*1005*/
			$1.i = _V; /*998*/
			$1.barchar = $get($1.barcode, $1.i) - 48; /*999*/
			if (($1.i % 2) == 0) { /*1003*/
				$1.checksum = $1.barchar + $1.checksum; /*1001*/
			} else { /*1003*/
				$1.checksum = ($1.barchar * 3) + $1.checksum; /*1003*/
			} /*1003*/
		} /*1003*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1006*/
		if ($1.barcode.length == 13) { /*1011*/
			if ($get($1.barcode, 12) != ($1.checksum + 48)) { /*1010*/
				$k[$j++] = "bwipp.ean13badCheckDigit"; /*1009*/
				$k[$j++] = "Incorrect EAN-13 check digit provided"; /*1009*/
				$0.raiseerror(); /*1009*/
			} /*1009*/
		} /*1009*/
		$puti($1.pad, 0, $1.barcode); /*1012*/
		$put($1.pad, 12, $1.checksum + 48); /*1013*/
		$1.barcode = $1.pad; /*1014*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1021*/
		$1.barchars = "0123456789"; /*1024*/
		$1.mirrormaps = $a(["000000", "001011", "001101", "001110", "010011", "011001", "011100", "010101", "010110", "011010"]); /*1030*/
		$1.sbs = $s(59); /*1032*/
		$1.txt = $a(13); /*1033*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*1036*/
		$1.mirrormap = $get($1.mirrormaps, $get($1.barcode, 0) - 48); /*1039*/
		$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1040*/
		for (var _17 = 1; _17 <= 6; _17 += 1) { /*1063*/
			$1.i = _17; /*1045*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1046*/
			$j--; /*1047*/
			$1.indx = $k[--$j].length; /*1048*/
			$j -= 2; /*1049*/
			$1.enc = $get($1.encs, $1.indx); /*1050*/
			if ($get($1.mirrormap, $1.i - 1) == 49) { /*1060*/
				$1.enclen = $1.enc.length; /*1052*/
				$1.revenc = $s($1.enclen); /*1053*/
				for (var _1O = 0, _1N = $1.enclen - 1; _1O <= _1N; _1O += 1) { /*1058*/
					$1.j = _1O; /*1055*/
					$1.char = $get($1.enc, $1.j); /*1056*/
					$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*1057*/
				} /*1057*/
				$1.enc = $1.revenc; /*1059*/
			} /*1059*/
			$puti($1.sbs, (($1.i - 1) * 4) + 3, $1.enc); /*1061*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 14) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1062*/
		} /*1062*/
		$puti($1.sbs, ((7 - 1) * 4) + 3, $get($1.encs, 11)); /*1066*/
		for (var _1o = 7; _1o <= 12; _1o += 1) { /*1079*/
			$1.i = _1o; /*1071*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1072*/
			$j--; /*1073*/
			$1.indx = $k[--$j].length; /*1074*/
			$j -= 2; /*1075*/
			$1.enc = $get($1.encs, $1.indx); /*1076*/
			$puti($1.sbs, (($1.i - 1) * 4) + 8, $1.enc); /*1077*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 18) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1078*/
		} /*1078*/
		$puti($1.sbs, 56, $get($1.encs, 12)); /*1082*/
		$k[$j++] = Infinity; /*1084*/
		var _2E = $1.sbs; /*1084*/
		for (var _2F = 0, _2G = _2E.length; _2F < _2G; _2F++) { /*1084*/
			$k[$j++] = $get(_2E, _2F) - 48; /*1084*/
		} /*1084*/
		$1.sbs = $a(); /*1084*/
		if ($1.includetext) { /*1091*/
			$k[$j++] = Infinity; /*1086*/
			$k[$j++] = $1.height; /*1086*/
			$k[$j++] = $1.height; /*1086*/
			for (var _2M = 0, _2N = 12; _2M < _2N; _2M++) { /*1086*/
				$k[$j++] = $1.height - 0.075; /*1086*/
			} /*1086*/
			$k[$j++] = $1.height; /*1086*/
			$k[$j++] = $1.height; /*1086*/
			for (var _2R = 0, _2S = 12; _2R < _2S; _2R++) { /*1086*/
				$k[$j++] = $1.height - 0.075; /*1086*/
			} /*1086*/
			$k[$j++] = $1.height; /*1086*/
			$k[$j++] = $1.height; /*1086*/
			$1.bhs = $a(); /*1086*/
			$k[$j++] = Infinity; /*1087*/
			$k[$j++] = 0; /*1087*/
			$k[$j++] = 0; /*1087*/
			for (var _2X = 0, _2Y = 12; _2X < _2Y; _2X++) { /*1087*/
				$k[$j++] = 0.075; /*1087*/
			} /*1087*/
			$k[$j++] = 0; /*1087*/
			$k[$j++] = 0; /*1087*/
			for (var _2Z = 0, _2a = 12; _2Z < _2a; _2Z++) { /*1087*/
				$k[$j++] = 0.075; /*1087*/
			} /*1087*/
			$k[$j++] = 0; /*1087*/
			$k[$j++] = 0; /*1087*/
			$1.bbs = $a(); /*1087*/
		} else { /*1091*/
			$k[$j++] = Infinity; /*1089*/
			for (var _2c = 0, _2d = 30; _2c < _2d; _2c++) { /*1089*/
				$k[$j++] = $1.height; /*1089*/
			} /*1089*/
			$1.bhs = $a(); /*1089*/
			$k[$j++] = Infinity; /*1090*/
			for (var _2g = 0, _2h = 30; _2g < _2h; _2g++) { /*1090*/
				$k[$j++] = 0; /*1090*/
			} /*1090*/
			$1.bbs = $a(); /*1090*/
			$1.txt = $a([]); /*1091*/
		} /*1091*/
		$1.guardrightypos = 0; /*1093*/
		if ($ne($1.addon, "")) { /*1114*/
			$k[$j++] = "addopts"; /*1104*/
			$k[$j++] = Infinity; /*1104*/
			$k[$j++] = "dontdraw"; /*1101*/
			$k[$j++] = true; /*1101*/
			$k[$j++] = "includetext"; /*1101*/
			$k[$j++] = true; /*1101*/
			$k[$j++] = "height"; /*1101*/
			$k[$j++] = $1.height - 0.15; /*1101*/
			$k[$j++] = "textxoffset"; /*1101*/
			if ($1.addontextxoffset != "unset") { /*1101*/
				$k[$j++] = $1.addontextxoffset; /*1101*/
			} else { /*1101*/
				$k[$j++] = 95 + $1.addongap; /*1101*/
			} /*1101*/
			if ($1.addontextyoffset != "unset") { /*1102*/
				$k[$j++] = "textyoffset"; /*1102*/
				$k[$j++] = $1.addontextyoffset; /*1102*/
			} /*1102*/
			$k[$j++] = "textsize"; /*1103*/
			if ($1.addontextsize != "unset") { /*1103*/
				$k[$j++] = $1.addontextsize; /*1103*/
			} else { /*1103*/
				$k[$j++] = $1.textsize; /*1103*/
			} /*1103*/
			$k[$j++] = "textfont"; /*1104*/
			if ($ne($1.addontextfont, "unset")) { /*1104*/
				$k[$j++] = $1.addontextfont; /*1104*/
			} else { /*1104*/
				$k[$j++] = $1.textfont; /*1104*/
			} /*1104*/
			var _2x = $d(); /*1104*/
			$1[$k[--$j]] = _2x; /*1105*/
			if ($1.addon.length == 2) { /*1106*/
				$k[$j++] = $1.addon; /*1106*/
				$k[$j++] = $1.addopts; /*1106*/
				$0.ean2(); /*1106*/
			} /*1106*/
			if ($1.addon.length == 5) { /*1107*/
				$k[$j++] = $1.addon; /*1107*/
				$k[$j++] = $1.addopts; /*1107*/
				$0.ean5(); /*1107*/
			} /*1107*/
			$1.addcode = $k[--$j]; /*1108*/
			$k[$j++] = Infinity; /*1109*/
			$aload($1.sbs); /*1109*/
			$k[$j++] = $1.addongap; /*1109*/
			$aload($1.addcode.sbs); /*1109*/
			$1.sbs = $a(); /*1109*/
			$k[$j++] = Infinity; /*1110*/
			$aload($1.bhs); /*1110*/
			$forall($1.addcode.bhs, function() { /*1110*/
				var _3E = $k[--$j]; /*1110*/
				$k[$j++] = _3E - 0.075; /*1110*/
			}); /*1110*/
			$1.bhs = $a(); /*1110*/
			$k[$j++] = Infinity; /*1111*/
			$aload($1.bbs); /*1111*/
			$forall($1.addcode.bbs, function() { /*1111*/
				var _3J = $k[--$j]; /*1111*/
				$k[$j++] = _3J + 0.075; /*1111*/
			}); /*1111*/
			$1.bbs = $a(); /*1111*/
			$k[$j++] = Infinity; /*1112*/
			$aload($1.txt); /*1112*/
			$aload($1.addcode.txt); /*1112*/
			$1.txt = $a(); /*1112*/
			$1.guardrightypos = ($1.height * 72) - 6; /*1113*/
		} /*1113*/
		var _3W = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			txt: $1.txt,
			opt: $1.options,
			guardrightpos: 10,
			guardrightypos: $1.guardrightypos,
			borderbottom: 5
		}; /*1126*/
		$k[$j++] = _3W; /*1129*/
		if (!$1.dontdraw) { /*1129*/
			$0.renlinear(); /*1129*/
		} /*1129*/
	};
	$0.ean8 = function() {
		var $1 = {}; /*1158*/
		$1.options = $k[--$j]; /*1160*/
		$1.barcode = $k[--$j]; /*1161*/
		$1.dontdraw = false; /*1163*/
		$1.includetext = false; /*1164*/
		$1.textfont = "Helvetica"; /*1165*/
		$1.textsize = 12; /*1166*/
		$1.textxoffset = 4; /*1167*/
		$1.textyoffset = -4.5; /*1168*/
		$1.height = 1; /*1169*/
		$1.addongap = 12; /*1170*/
		$1.addontextfont = "unset"; /*1171*/
		$1.addontextsize = "unset"; /*1172*/
		$1.addontextxoffset = "unset"; /*1173*/
		$1.addontextyoffset = "unset"; /*1174*/
		$forall($1.options, function() { /*1185*/
			var _3 = $k[--$j]; /*1185*/
			$1[$k[--$j]] = _3; /*1185*/
		}); /*1185*/
		$1.textfont = "" + $1.textfont; /*1187*/
		$1.textsize = +$1.textsize; /*1188*/
		$1.textxoffset = +$1.textxoffset; /*1189*/
		$1.textyoffset = +$1.textyoffset; /*1190*/
		$1.height = +$1.height; /*1191*/
		$1.addongap = +$1.addongap; /*1192*/
		if ($ne($1.addontextfont, "unset")) { /*1193*/
			$1.addontextfont = "" + $1.addontextfont; /*1193*/
		} /*1193*/
		if ($ne($1.addontextsize, "unset")) { /*1194*/
			$1.addontextsize = +$1.addontextsize; /*1194*/
		} /*1194*/
		if ($ne($1.addontextxoffset, "unset")) { /*1195*/
			$1.addontextxoffset = +$1.addontextxoffset; /*1195*/
		} /*1195*/
		if ($ne($1.addontextyoffset, "unset")) { /*1196*/
			$1.addontextyoffset = +$1.addontextyoffset; /*1196*/
		} /*1196*/
		$search($1.barcode, " "); /*1199*/
		if ($k[--$j]) { /*1205*/
			$1.barcode = $k[--$j]; /*1200*/
			$j--; /*1201*/
			$1.addon = $k[--$j]; /*1202*/
		} else { /*1205*/
			$j--; /*1204*/
			$1.addon = ""; /*1205*/
		} /*1205*/
		if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*1211*/
			$k[$j++] = "bwipp.ean8badLength"; /*1210*/
			$k[$j++] = "EAN-8 must be 7 or 8 digits"; /*1210*/
			$0.raiseerror(); /*1210*/
		} /*1210*/
		$forall($1.barcode, function() { /*1216*/
			var _Q = $k[--$j]; /*1213*/
			if ((_Q < 48) || (_Q > 57)) { /*1215*/
				$k[$j++] = "bwipp.ean8badCharacter"; /*1214*/
				$k[$j++] = "EAN-8 must contain only digits"; /*1214*/
				$0.raiseerror(); /*1214*/
			} /*1214*/
		}); /*1214*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1219*/
			$k[$j++] = "bwipp.ean8badAddOnLength"; /*1218*/
			$k[$j++] = "Add-on for EAN-8 must be 2 or 5 digits"; /*1218*/
			$0.raiseerror(); /*1218*/
		} /*1218*/
		$1.pad = $s(8); /*1222*/
		$1.checksum = 0; /*1223*/
		for (var _V = 0; _V <= 6; _V += 1) { /*1232*/
			$1.i = _V; /*1225*/
			$1.barchar = $get($1.barcode, $1.i) - 48; /*1226*/
			if (($1.i % 2) != 0) { /*1230*/
				$1.checksum = $1.barchar + $1.checksum; /*1228*/
			} else { /*1230*/
				$1.checksum = ($1.barchar * 3) + $1.checksum; /*1230*/
			} /*1230*/
		} /*1230*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1233*/
		if ($1.barcode.length == 8) { /*1238*/
			if ($get($1.barcode, 7) != ($1.checksum + 48)) { /*1237*/
				$k[$j++] = "bwipp.ean8badCheckDigit"; /*1236*/
				$k[$j++] = "Incorrect EAN-8 check digit provided"; /*1236*/
				$0.raiseerror(); /*1236*/
			} /*1236*/
		} /*1236*/
		$puti($1.pad, 0, $1.barcode); /*1239*/
		$put($1.pad, 7, $1.checksum + 48); /*1240*/
		$1.barcode = $1.pad; /*1241*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1248*/
		$1.barchars = "0123456789"; /*1251*/
		$1.sbs = $s(43); /*1253*/
		$1.txt = $a(8); /*1254*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*1257*/
		for (var _u = 0; _u <= 3; _u += 1) { /*1270*/
			$1.i = _u; /*1262*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1263*/
			$j--; /*1264*/
			$1.indx = $k[--$j].length; /*1265*/
			$j -= 2; /*1266*/
			$1.enc = $get($1.encs, $1.indx); /*1267*/
			$puti($1.sbs, ($1.i * 4) + 3, $1.enc); /*1268*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 7) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1269*/
		} /*1269*/
		$puti($1.sbs, (4 * 4) + 3, $get($1.encs, 11)); /*1273*/
		for (var _1K = 4; _1K <= 7; _1K += 1) { /*1286*/
			$1.i = _1K; /*1278*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1279*/
			$j--; /*1280*/
			$1.indx = $k[--$j].length; /*1281*/
			$j -= 2; /*1282*/
			$1.enc = $get($1.encs, $1.indx); /*1283*/
			$puti($1.sbs, ($1.i * 4) + 8, $1.enc); /*1284*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + $1.textxoffset) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*1285*/
		} /*1285*/
		$puti($1.sbs, 40, $get($1.encs, 12)); /*1289*/
		$k[$j++] = Infinity; /*1291*/
		var _1k = $1.sbs; /*1291*/
		for (var _1l = 0, _1m = _1k.length; _1l < _1m; _1l++) { /*1291*/
			$k[$j++] = $get(_1k, _1l) - 48; /*1291*/
		} /*1291*/
		$1.sbs = $a(); /*1291*/
		if ($1.includetext) { /*1298*/
			$k[$j++] = Infinity; /*1293*/
			$k[$j++] = $1.height; /*1293*/
			$k[$j++] = $1.height; /*1293*/
			for (var _1s = 0, _1t = 8; _1s < _1t; _1s++) { /*1293*/
				$k[$j++] = $1.height - 0.075; /*1293*/
			} /*1293*/
			$k[$j++] = $1.height; /*1293*/
			$k[$j++] = $1.height; /*1293*/
			for (var _1x = 0, _1y = 8; _1x < _1y; _1x++) { /*1293*/
				$k[$j++] = $1.height - 0.075; /*1293*/
			} /*1293*/
			$k[$j++] = $1.height; /*1293*/
			$k[$j++] = $1.height; /*1293*/
			$1.bhs = $a(); /*1293*/
			$k[$j++] = Infinity; /*1294*/
			$k[$j++] = 0; /*1294*/
			$k[$j++] = 0; /*1294*/
			for (var _23 = 0, _24 = 8; _23 < _24; _23++) { /*1294*/
				$k[$j++] = 0.075; /*1294*/
			} /*1294*/
			$k[$j++] = 0; /*1294*/
			$k[$j++] = 0; /*1294*/
			for (var _25 = 0, _26 = 8; _25 < _26; _25++) { /*1294*/
				$k[$j++] = 0.075; /*1294*/
			} /*1294*/
			$k[$j++] = 0; /*1294*/
			$k[$j++] = 0; /*1294*/
			$1.bbs = $a(); /*1294*/
		} else { /*1298*/
			$k[$j++] = Infinity; /*1296*/
			for (var _28 = 0, _29 = 22; _28 < _29; _28++) { /*1296*/
				$k[$j++] = $1.height; /*1296*/
			} /*1296*/
			$1.bhs = $a(); /*1296*/
			$k[$j++] = Infinity; /*1297*/
			for (var _2C = 0, _2D = 22; _2C < _2D; _2C++) { /*1297*/
				$k[$j++] = 0; /*1297*/
			} /*1297*/
			$1.bbs = $a(); /*1297*/
			$1.txt = $a([]); /*1298*/
		} /*1298*/
		$1.guardrightypos = 0; /*1300*/
		if ($ne($1.addon, "")) { /*1321*/
			$k[$j++] = "addopts"; /*1311*/
			$k[$j++] = Infinity; /*1311*/
			$k[$j++] = "dontdraw"; /*1308*/
			$k[$j++] = true; /*1308*/
			$k[$j++] = "includetext"; /*1308*/
			$k[$j++] = true; /*1308*/
			$k[$j++] = "height"; /*1308*/
			$k[$j++] = $1.height - 0.15; /*1308*/
			$k[$j++] = "textxoffset"; /*1308*/
			if ($1.addontextxoffset != "unset") { /*1308*/
				$k[$j++] = $1.addontextxoffset; /*1308*/
			} else { /*1308*/
				$k[$j++] = 67 + $1.addongap; /*1308*/
			} /*1308*/
			if ($1.addontextyoffset != "unset") { /*1309*/
				$k[$j++] = "textyoffset"; /*1309*/
				$k[$j++] = $1.addontextyoffset; /*1309*/
			} /*1309*/
			$k[$j++] = "textsize"; /*1310*/
			if ($1.addontextsize != "unset") { /*1310*/
				$k[$j++] = $1.addontextsize; /*1310*/
			} else { /*1310*/
				$k[$j++] = $1.textsize; /*1310*/
			} /*1310*/
			$k[$j++] = "textfont"; /*1311*/
			if ($ne($1.addontextfont, "unset")) { /*1311*/
				$k[$j++] = $1.addontextfont; /*1311*/
			} else { /*1311*/
				$k[$j++] = $1.textfont; /*1311*/
			} /*1311*/
			var _2T = $d(); /*1311*/
			$1[$k[--$j]] = _2T; /*1312*/
			if ($1.addon.length == 2) { /*1313*/
				$k[$j++] = $1.addon; /*1313*/
				$k[$j++] = $1.addopts; /*1313*/
				$0.ean2(); /*1313*/
			} /*1313*/
			if ($1.addon.length == 5) { /*1314*/
				$k[$j++] = $1.addon; /*1314*/
				$k[$j++] = $1.addopts; /*1314*/
				$0.ean5(); /*1314*/
			} /*1314*/
			$1.addcode = $k[--$j]; /*1315*/
			$k[$j++] = Infinity; /*1316*/
			$aload($1.sbs); /*1316*/
			$k[$j++] = $1.addongap; /*1316*/
			$aload($1.addcode.sbs); /*1316*/
			$1.sbs = $a(); /*1316*/
			$k[$j++] = Infinity; /*1317*/
			$aload($1.bhs); /*1317*/
			$forall($1.addcode.bhs, function() { /*1317*/
				var _2k = $k[--$j]; /*1317*/
				$k[$j++] = _2k - 0.075; /*1317*/
			}); /*1317*/
			$1.bhs = $a(); /*1317*/
			$k[$j++] = Infinity; /*1318*/
			$aload($1.bbs); /*1318*/
			$forall($1.addcode.bbs, function() { /*1318*/
				var _2p = $k[--$j]; /*1318*/
				$k[$j++] = _2p + 0.075; /*1318*/
			}); /*1318*/
			$1.bbs = $a(); /*1318*/
			$k[$j++] = Infinity; /*1319*/
			$aload($1.txt); /*1319*/
			$aload($1.addcode.txt); /*1319*/
			$1.txt = $a(); /*1319*/
			$1.guardrightypos = ($1.height * 72) - 6; /*1320*/
		} /*1320*/
		var _32 = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			txt: $1.txt,
			opt: $1.options,
			guardleftpos: 10,
			guardrightpos: 10,
			guardrightypos: $1.guardrightypos,
			borderbottom: 5
		}; /*1334*/
		$k[$j++] = _32; /*1337*/
		if (!$1.dontdraw) { /*1337*/
			$0.renlinear(); /*1337*/
		} /*1337*/
	};
	$0.upca = function() {
		var $1 = {}; /*1366*/
		$1.options = $k[--$j]; /*1368*/
		$1.barcode = $k[--$j]; /*1369*/
		$1.dontdraw = false; /*1371*/
		$1.includetext = false; /*1372*/
		$1.textfont = "Helvetica"; /*1373*/
		$1.textsize = 12; /*1374*/
		$1.textxoffset = -7; /*1375*/
		$1.textyoffset = -4.5; /*1376*/
		$1.height = 1; /*1377*/
		$1.addongap = 12; /*1378*/
		$1.addontextfont = "unset"; /*1379*/
		$1.addontextsize = "unset"; /*1380*/
		$1.addontextxoffset = "unset"; /*1381*/
		$1.addontextyoffset = "unset"; /*1382*/
		$forall($1.options, function() { /*1393*/
			var _3 = $k[--$j]; /*1393*/
			$1[$k[--$j]] = _3; /*1393*/
		}); /*1393*/
		$1.textfont = "" + $1.textfont; /*1395*/
		$1.textsize = +$1.textsize; /*1396*/
		$1.textxoffset = +$1.textxoffset; /*1397*/
		$1.textyoffset = +$1.textyoffset; /*1398*/
		$1.height = +$1.height; /*1399*/
		$1.addongap = +$1.addongap; /*1400*/
		if ($ne($1.addontextfont, "unset")) { /*1401*/
			$1.addontextfont = "" + $1.addontextfont; /*1401*/
		} /*1401*/
		if ($ne($1.addontextsize, "unset")) { /*1402*/
			$1.addontextsize = +$1.addontextsize; /*1402*/
		} /*1402*/
		if ($ne($1.addontextxoffset, "unset")) { /*1403*/
			$1.addontextxoffset = +$1.addontextxoffset; /*1403*/
		} /*1403*/
		if ($ne($1.addontextyoffset, "unset")) { /*1404*/
			$1.addontextyoffset = +$1.addontextyoffset; /*1404*/
		} /*1404*/
		$search($1.barcode, " "); /*1407*/
		if ($k[--$j]) { /*1413*/
			$1.barcode = $k[--$j]; /*1408*/
			$j--; /*1409*/
			$1.addon = $k[--$j]; /*1410*/
		} else { /*1413*/
			$j--; /*1412*/
			$1.addon = ""; /*1413*/
		} /*1413*/
		if (($1.barcode.length == 7) || ($1.barcode.length == 8)) { /*1459*/
			$forall($1.barcode, function() { /*1423*/
				var _Q = $k[--$j]; /*1420*/
				if ((_Q < 48) || (_Q > 57)) { /*1422*/
					$k[$j++] = "bwipp.upcAupcEbadCharacter"; /*1421*/
					$k[$j++] = "UPC-E must contain only digits"; /*1421*/
					$0.raiseerror(); /*1421*/
				} /*1421*/
			}); /*1421*/
			var _S = $get($1.barcode, 0); /*1424*/
			if ((_S != 48) && (_S != 49)) { /*1426*/
				$k[$j++] = "bwipp.upcAupcEbadNumberSystem"; /*1425*/
				$k[$j++] = "UPC-E must have number system 0 or 1"; /*1425*/
				$0.raiseerror(); /*1425*/
			} /*1425*/
			for (var _T = 0, _U = 1; _T < _U; _T++) { /*1454*/
				var _W = ($1.barcode.length == 8) ? 12 : 11; /*1428*/
				$1.upcacode = $s(_W); /*1428*/
				if (($get($1.barcode, 6) - 48) <= 2) { /*1435*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 3)); /*1430*/
					$puti($1.upcacode, 3, $geti($1.barcode, 6, 1)); /*1431*/
					$puti($1.upcacode, 4, "0000"); /*1432*/
					$puti($1.upcacode, 8, $geti($1.barcode, 3, 3)); /*1433*/
					break; /*1434*/
				} /*1434*/
				if (($get($1.barcode, 6) - 48) == 3) { /*1441*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 4)); /*1437*/
					$puti($1.upcacode, 4, "00000"); /*1438*/
					$puti($1.upcacode, 9, $geti($1.barcode, 4, 2)); /*1439*/
					break; /*1440*/
				} /*1440*/
				if (($get($1.barcode, 6) - 48) == 4) { /*1447*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 5)); /*1443*/
					$puti($1.upcacode, 5, "00000"); /*1444*/
					$puti($1.upcacode, 10, $geti($1.barcode, 5, 1)); /*1445*/
					break; /*1446*/
				} /*1446*/
				if (($get($1.barcode, 6) - 48) >= 5) { /*1453*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 6)); /*1449*/
					$puti($1.upcacode, 6, "0000"); /*1450*/
					$puti($1.upcacode, 10, $geti($1.barcode, 6, 1)); /*1451*/
					break; /*1452*/
				} /*1452*/
			} /*1452*/
			if ($1.barcode.length == 8) { /*1457*/
				$puti($1.upcacode, 11, $geti($1.barcode, 7, 1)); /*1456*/
			} /*1456*/
			$1.barcode = $1.upcacode; /*1458*/
		} /*1458*/
		if (($1.barcode.length != 11) && ($1.barcode.length != 12)) { /*1464*/
			$k[$j++] = "bwipp.upcAbadLength"; /*1463*/
			$k[$j++] = "UPC-A must be 11 or 12 digits"; /*1463*/
			$0.raiseerror(); /*1463*/
		} /*1463*/
		var _1I = $1.barcode; /*1465*/
		for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*1469*/
			var _1L = $get(_1I, _1J); /*1469*/
			if ((_1L < 48) || (_1L > 57)) { /*1468*/
				$k[$j++] = "bwipp.upcAbadCharacter"; /*1467*/
				$k[$j++] = "UPC-A must contain only digits"; /*1467*/
				$0.raiseerror(); /*1467*/
			} /*1467*/
		} /*1467*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1472*/
			$k[$j++] = "bwipp.upcAbadAddOnLength"; /*1471*/
			$k[$j++] = "Add-on for UPC-A must be 2 or 5 digits"; /*1471*/
			$0.raiseerror(); /*1471*/
		} /*1471*/
		$1.pad = $s(12); /*1475*/
		$1.checksum = 0; /*1476*/
		for (var _1Q = 0; _1Q <= 10; _1Q += 1) { /*1485*/
			$1.i = _1Q; /*1478*/
			$1.barchar = $get($1.barcode, $1.i) - 48; /*1479*/
			if (($1.i % 2) != 0) { /*1483*/
				$1.checksum = $1.checksum + $1.barchar; /*1481*/
			} else { /*1483*/
				$1.checksum = $1.checksum + ($1.barchar * 3); /*1483*/
			} /*1483*/
		} /*1483*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1486*/
		if ($1.barcode.length == 12) { /*1491*/
			if ($get($1.barcode, 11) != ($1.checksum + 48)) { /*1490*/
				$k[$j++] = "bwipp.upcAbadCheckDigit"; /*1489*/
				$k[$j++] = "Incorrect UPC check digit provided"; /*1489*/
				$0.raiseerror(); /*1489*/
			} /*1489*/
		} /*1489*/
		$puti($1.pad, 0, $1.barcode); /*1492*/
		$put($1.pad, 11, $1.checksum + 48); /*1493*/
		$1.barcode = $1.pad; /*1494*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1501*/
		$1.barchars = "0123456789"; /*1504*/
		$1.sbs = $s(59); /*1506*/
		$1.txt = $a(12); /*1507*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*1510*/
		for (var _1p = 0; _1p <= 5; _1p += 1) { /*1527*/
			$1.i = _1p; /*1515*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1516*/
			$j--; /*1517*/
			$1.indx = $k[--$j].length; /*1518*/
			$j -= 2; /*1519*/
			$1.enc = $get($1.encs, $1.indx); /*1520*/
			$puti($1.sbs, ($1.i * 4) + 3, $1.enc); /*1521*/
			if ($1.i == 0) { /*1525*/
				$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1523*/
			} else { /*1525*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + 11) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1525*/
			} /*1525*/
		} /*1525*/
		$puti($1.sbs, (6 * 4) + 3, $get($1.encs, 11)); /*1530*/
		for (var _2O = 6; _2O <= 11; _2O += 1) { /*1547*/
			$1.i = _2O; /*1535*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1536*/
			$j--; /*1537*/
			$1.indx = $k[--$j].length; /*1538*/
			$j -= 2; /*1539*/
			$1.enc = $get($1.encs, $1.indx); /*1540*/
			$puti($1.sbs, ($1.i * 4) + 8, $1.enc); /*1541*/
			if ($1.i == 11) { /*1545*/
				$put($1.txt, 11, $a([$geti($1.barcode, 11, 1), $1.textxoffset + 103, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1543*/
			} else { /*1545*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + $1.textxoffset) + 15, $1.textyoffset, $1.textfont, $1.textsize])); /*1545*/
			} /*1545*/
		} /*1545*/
		$puti($1.sbs, 56, $get($1.encs, 12)); /*1550*/
		$k[$j++] = Infinity; /*1552*/
		var _2x = $1.sbs; /*1552*/
		for (var _2y = 0, _2z = _2x.length; _2y < _2z; _2y++) { /*1552*/
			$k[$j++] = $get(_2x, _2y) - 48; /*1552*/
		} /*1552*/
		$1.sbs = $a(); /*1552*/
		if ($1.includetext) { /*1559*/
			$k[$j++] = Infinity; /*1554*/
			for (var _33 = 0, _34 = 4; _33 < _34; _33++) { /*1554*/
				$k[$j++] = $1.height; /*1554*/
			} /*1554*/
			for (var _36 = 0, _37 = 10; _36 < _37; _36++) { /*1554*/
				$k[$j++] = $1.height - 0.075; /*1554*/
			} /*1554*/
			$k[$j++] = $1.height; /*1554*/
			$k[$j++] = $1.height; /*1554*/
			for (var _3B = 0, _3C = 10; _3B < _3C; _3B++) { /*1554*/
				$k[$j++] = $1.height - 0.075; /*1554*/
			} /*1554*/
			for (var _3E = 0, _3F = 4; _3E < _3F; _3E++) { /*1554*/
				$k[$j++] = $1.height; /*1554*/
			} /*1554*/
			$1.bhs = $a(); /*1554*/
			$k[$j++] = Infinity; /*1555*/
			$k[$j++] = 0; /*1555*/
			$k[$j++] = 0; /*1555*/
			$k[$j++] = 0; /*1555*/
			$k[$j++] = 0; /*1555*/
			for (var _3I = 0, _3J = 10; _3I < _3J; _3I++) { /*1555*/
				$k[$j++] = 0.075; /*1555*/
			} /*1555*/
			$k[$j++] = 0; /*1555*/
			$k[$j++] = 0; /*1555*/
			for (var _3K = 0, _3L = 10; _3K < _3L; _3K++) { /*1555*/
				$k[$j++] = 0.075; /*1555*/
			} /*1555*/
			$k[$j++] = 0; /*1555*/
			$k[$j++] = 0; /*1555*/
			$k[$j++] = 0; /*1555*/
			$k[$j++] = 0; /*1555*/
			$1.bbs = $a(); /*1555*/
		} else { /*1559*/
			$k[$j++] = Infinity; /*1557*/
			for (var _3N = 0, _3O = 30; _3N < _3O; _3N++) { /*1557*/
				$k[$j++] = $1.height; /*1557*/
			} /*1557*/
			$1.bhs = $a(); /*1557*/
			$k[$j++] = Infinity; /*1558*/
			for (var _3R = 0, _3S = 30; _3R < _3S; _3R++) { /*1558*/
				$k[$j++] = 0; /*1558*/
			} /*1558*/
			$1.bbs = $a(); /*1558*/
			$1.txt = $a([]); /*1559*/
		} /*1559*/
		$1.guardrightypos = 0; /*1561*/
		if ($ne($1.addon, "")) { /*1582*/
			$k[$j++] = "addopts"; /*1572*/
			$k[$j++] = Infinity; /*1572*/
			$k[$j++] = "dontdraw"; /*1569*/
			$k[$j++] = true; /*1569*/
			$k[$j++] = "includetext"; /*1569*/
			$k[$j++] = true; /*1569*/
			$k[$j++] = "height"; /*1569*/
			$k[$j++] = $1.height - 0.15; /*1569*/
			$k[$j++] = "textxoffset"; /*1569*/
			if ($1.addontextxoffset != "unset") { /*1569*/
				$k[$j++] = $1.addontextxoffset; /*1569*/
			} else { /*1569*/
				$k[$j++] = 95 + $1.addongap; /*1569*/
			} /*1569*/
			if ($1.addontextyoffset != "unset") { /*1570*/
				$k[$j++] = "textyoffset"; /*1570*/
				$k[$j++] = $1.addontextyoffset; /*1570*/
			} /*1570*/
			$k[$j++] = "textsize"; /*1571*/
			if ($1.addontextsize != "unset") { /*1571*/
				$k[$j++] = $1.addontextsize; /*1571*/
			} else { /*1571*/
				$k[$j++] = $1.textsize; /*1571*/
			} /*1571*/
			$k[$j++] = "textfont"; /*1572*/
			if ($ne($1.addontextfont, "unset")) { /*1572*/
				$k[$j++] = $1.addontextfont; /*1572*/
			} else { /*1572*/
				$k[$j++] = $1.textfont; /*1572*/
			} /*1572*/
			var _3i = $d(); /*1572*/
			$1[$k[--$j]] = _3i; /*1573*/
			if ($1.addon.length == 2) { /*1574*/
				$k[$j++] = $1.addon; /*1574*/
				$k[$j++] = $1.addopts; /*1574*/
				$0.ean2(); /*1574*/
			} /*1574*/
			if ($1.addon.length == 5) { /*1575*/
				$k[$j++] = $1.addon; /*1575*/
				$k[$j++] = $1.addopts; /*1575*/
				$0.ean5(); /*1575*/
			} /*1575*/
			$1.addcode = $k[--$j]; /*1576*/
			$k[$j++] = Infinity; /*1577*/
			$aload($1.sbs); /*1577*/
			$k[$j++] = $1.addongap; /*1577*/
			$aload($1.addcode.sbs); /*1577*/
			$1.sbs = $a(); /*1577*/
			$k[$j++] = Infinity; /*1578*/
			$aload($1.bhs); /*1578*/
			$forall($1.addcode.bhs, function() { /*1578*/
				var _3z = $k[--$j]; /*1578*/
				$k[$j++] = _3z - 0.075; /*1578*/
			}); /*1578*/
			$1.bhs = $a(); /*1578*/
			$k[$j++] = Infinity; /*1579*/
			$aload($1.bbs); /*1579*/
			$forall($1.addcode.bbs, function() { /*1579*/
				var _44 = $k[--$j]; /*1579*/
				$k[$j++] = _44 + 0.075; /*1579*/
			}); /*1579*/
			$1.bbs = $a(); /*1579*/
			$k[$j++] = Infinity; /*1580*/
			$aload($1.txt); /*1580*/
			$aload($1.addcode.txt); /*1580*/
			$1.txt = $a(); /*1580*/
			$1.guardrightypos = ($1.height * 72) - 6; /*1581*/
		} /*1581*/
		var _4H = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			txt: $1.txt,
			opt: $1.options,
			guardrightpos: 10,
			guardrightypos: $1.guardrightypos,
			borderbottom: 5
		}; /*1594*/
		$k[$j++] = _4H; /*1597*/
		if (!$1.dontdraw) { /*1597*/
			$0.renlinear(); /*1597*/
		} /*1597*/
	};
	$0.upce = function() {
		var $1 = {}; /*1626*/
		$1.options = $k[--$j]; /*1628*/
		$1.barcode = $k[--$j]; /*1629*/
		$1.dontdraw = false; /*1631*/
		$1.includetext = false; /*1632*/
		$1.textfont = "Helvetica"; /*1633*/
		$1.textsize = 12; /*1634*/
		$1.textxoffset = -7; /*1635*/
		$1.textyoffset = -4.5; /*1636*/
		$1.height = 1; /*1637*/
		$1.addongap = 12; /*1638*/
		$1.addontextfont = "unset"; /*1639*/
		$1.addontextsize = "unset"; /*1640*/
		$1.addontextxoffset = "unset"; /*1641*/
		$1.addontextyoffset = "unset"; /*1642*/
		$forall($1.options, function() { /*1653*/
			var _3 = $k[--$j]; /*1653*/
			$1[$k[--$j]] = _3; /*1653*/
		}); /*1653*/
		$1.textfont = "" + $1.textfont; /*1655*/
		$1.textsize = +$1.textsize; /*1656*/
		$1.textxoffset = +$1.textxoffset; /*1657*/
		$1.textyoffset = +$1.textyoffset; /*1658*/
		$1.height = +$1.height; /*1659*/
		$1.addongap = +$1.addongap; /*1660*/
		if ($ne($1.addontextfont, "unset")) { /*1661*/
			$1.addontextfont = "" + $1.addontextfont; /*1661*/
		} /*1661*/
		if ($ne($1.addontextsize, "unset")) { /*1662*/
			$1.addontextsize = +$1.addontextsize; /*1662*/
		} /*1662*/
		if ($ne($1.addontextxoffset, "unset")) { /*1663*/
			$1.addontextxoffset = +$1.addontextxoffset; /*1663*/
		} /*1663*/
		if ($ne($1.addontextyoffset, "unset")) { /*1664*/
			$1.addontextyoffset = +$1.addontextyoffset; /*1664*/
		} /*1664*/
		$search($1.barcode, " "); /*1667*/
		if ($k[--$j]) { /*1673*/
			$1.barcode = $k[--$j]; /*1668*/
			$j--; /*1669*/
			$1.addon = $k[--$j]; /*1670*/
		} else { /*1673*/
			$j--; /*1672*/
			$1.addon = ""; /*1673*/
		} /*1673*/
		if (($1.barcode.length == 11) || ($1.barcode.length == 12)) { /*1715*/
			$forall($1.barcode, function() { /*1683*/
				var _Q = $k[--$j]; /*1680*/
				if ((_Q < 48) || (_Q > 57)) { /*1682*/
					$k[$j++] = "bwipp.upcEupcAbadCharacter"; /*1681*/
					$k[$j++] = "UPC-A must contain only digits"; /*1681*/
					$0.raiseerror(); /*1681*/
				} /*1681*/
			}); /*1681*/
			for (var _R = 0, _S = 1; _R < _S; _R++) { /*1710*/
				var _U = ($1.barcode.length == 12) ? 8 : 7; /*1685*/
				$1.upcecode = $s(_U); /*1685*/
				if ((($get($1.barcode, 3) - 48) <= 2) && $eq($geti($1.barcode, 4, 4), "0000")) { /*1691*/
					$puti($1.upcecode, 0, $geti($1.barcode, 0, 3)); /*1687*/
					$puti($1.upcecode, 3, $geti($1.barcode, 8, 3)); /*1688*/
					$puti($1.upcecode, 6, $geti($1.barcode, 3, 1)); /*1689*/
					break; /*1690*/
				} /*1690*/
				if ($eq($geti($1.barcode, 4, 5), "00000")) { /*1697*/
					$puti($1.upcecode, 0, $geti($1.barcode, 0, 4)); /*1693*/
					$puti($1.upcecode, 4, $geti($1.barcode, 9, 2)); /*1694*/
					$puti($1.upcecode, 6, "3"); /*1695*/
					break; /*1696*/
				} /*1696*/
				if ($eq($geti($1.barcode, 5, 5), "00000")) { /*1703*/
					$puti($1.upcecode, 0, $geti($1.barcode, 0, 5)); /*1699*/
					$puti($1.upcecode, 5, $geti($1.barcode, 10, 1)); /*1700*/
					$puti($1.upcecode, 6, "4"); /*1701*/
					break; /*1702*/
				} /*1702*/
				if ((($get($1.barcode, 10) - 48) >= 5) && $eq($geti($1.barcode, 6, 4), "0000")) { /*1708*/
					$puti($1.upcecode, 0, $geti($1.barcode, 0, 6)); /*1705*/
					$puti($1.upcecode, 6, $geti($1.barcode, 10, 1)); /*1706*/
					break; /*1707*/
				} /*1707*/
				$k[$j++] = "bwipp.upcEupcAnotCompressible"; /*1709*/
				$k[$j++] = "UPC-A cannot be converted to a UPC-E"; /*1709*/
				$0.raiseerror(); /*1709*/
			} /*1709*/
			if ($1.barcode.length == 12) { /*1713*/
				$puti($1.upcecode, 7, $geti($1.barcode, 11, 1)); /*1712*/
			} /*1712*/
			$1.barcode = $1.upcecode; /*1714*/
		} /*1714*/
		if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*1720*/
			$k[$j++] = "bwipp.upcEbadLength"; /*1719*/
			$k[$j++] = "UPC-E must be 7 or 8 digits"; /*1719*/
			$0.raiseerror(); /*1719*/
		} /*1719*/
		var _1I = $1.barcode; /*1721*/
		for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*1725*/
			var _1L = $get(_1I, _1J); /*1725*/
			if ((_1L < 48) || (_1L > 57)) { /*1724*/
				$k[$j++] = "bwipp.upcEbadCharacter"; /*1723*/
				$k[$j++] = "UPC-E must contain only digits"; /*1723*/
				$0.raiseerror(); /*1723*/
			} /*1723*/
		} /*1723*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1728*/
			$k[$j++] = "bwipp.upcEbadAddOnLength"; /*1727*/
			$k[$j++] = "Add-on for UPC-E must be 2 or 5 digits"; /*1727*/
			$0.raiseerror(); /*1727*/
		} /*1727*/
		var _1Q = $get($1.barcode, 0); /*1731*/
		if ((_1Q != 48) && (_1Q != 49)) { /*1733*/
			$k[$j++] = "bwipp.upcEbadNumberSystem"; /*1732*/
			$k[$j++] = "UPC-E must have number system 0 or 1"; /*1732*/
			$0.raiseerror(); /*1732*/
		} /*1732*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "111111"]); /*1740*/
		$1.barchars = "0123456789"; /*1743*/
		$1.mirrormaps = $a(["000111", "001011", "001101", "001110", "010011", "011001", "011100", "010101", "010110", "011010"]); /*1748*/
		for (var _1T = 0, _1U = 1; _1T < _1U; _1T++) { /*1778*/
			$1.upcacode = $s(11); /*1752*/
			if (($get($1.barcode, 6) - 48) <= 2) { /*1759*/
				$puti($1.upcacode, 0, $geti($1.barcode, 0, 3)); /*1754*/
				$puti($1.upcacode, 3, $geti($1.barcode, 6, 1)); /*1755*/
				$puti($1.upcacode, 4, "0000"); /*1756*/
				$puti($1.upcacode, 8, $geti($1.barcode, 3, 3)); /*1757*/
				break; /*1758*/
			} /*1758*/
			if (($get($1.barcode, 6) - 48) == 3) { /*1765*/
				$puti($1.upcacode, 0, $geti($1.barcode, 0, 4)); /*1761*/
				$puti($1.upcacode, 4, "00000"); /*1762*/
				$puti($1.upcacode, 9, $geti($1.barcode, 4, 2)); /*1763*/
				break; /*1764*/
			} /*1764*/
			if (($get($1.barcode, 6) - 48) == 4) { /*1771*/
				$puti($1.upcacode, 0, $geti($1.barcode, 0, 5)); /*1767*/
				$puti($1.upcacode, 5, "00000"); /*1768*/
				$puti($1.upcacode, 10, $geti($1.barcode, 5, 1)); /*1769*/
				break; /*1770*/
			} /*1770*/
			if (($get($1.barcode, 6) - 48) >= 5) { /*1777*/
				$puti($1.upcacode, 0, $geti($1.barcode, 0, 6)); /*1773*/
				$puti($1.upcacode, 6, "0000"); /*1774*/
				$puti($1.upcacode, 10, $geti($1.barcode, 6, 1)); /*1775*/
				break; /*1776*/
			} /*1776*/
		} /*1776*/
		$1.checksum = 0; /*1779*/
		for (var _29 = 0; _29 <= 10; _29 += 1) { /*1788*/
			$1.i = _29; /*1781*/
			$1.barchar = $get($1.upcacode, $1.i) - 48; /*1782*/
			if (($1.i % 2) != 0) { /*1786*/
				$1.checksum = $1.checksum + $1.barchar; /*1784*/
			} else { /*1786*/
				$1.checksum = $1.checksum + ($1.barchar * 3); /*1786*/
			} /*1786*/
		} /*1786*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1789*/
		if ($1.barcode.length == 8) { /*1794*/
			if ($get($1.barcode, 7) != ($1.checksum + 48)) { /*1793*/
				$k[$j++] = "bwipp.upcEbadCheckDigit"; /*1792*/
				$k[$j++] = "Incorrect UPC check digit provided"; /*1792*/
				$0.raiseerror(); /*1792*/
			} /*1792*/
		} /*1792*/
		$1.pad = $s(8); /*1795*/
		$puti($1.pad, 0, $1.barcode); /*1796*/
		$put($1.pad, 7, $1.checksum + 48); /*1797*/
		$1.barcode = $1.pad; /*1798*/
		$1.txt = $a(8); /*1799*/
		$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1800*/
		$1.mirrormap = $get($1.mirrormaps, $1.checksum); /*1803*/
		if ($get($1.barcode, 0) == 48) { /*1817*/
			$1.invt = $s($1.mirrormap.length); /*1807*/
			for (var _2l = 0, _2k = $1.mirrormap.length - 1; _2l <= _2k; _2l += 1) { /*1815*/
				$1.i = _2l; /*1809*/
				if ($get($1.mirrormap, $1.i) == 48) { /*1813*/
					$put($1.invt, $1.i, 49); /*1811*/
				} else { /*1813*/
					$put($1.invt, $1.i, 48); /*1813*/
				} /*1813*/
			} /*1813*/
			$1.mirrormap = $1.invt; /*1816*/
		} /*1816*/
		$1.sbs = $s(33); /*1819*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*1822*/
		for (var _2y = 1; _2y <= 6; _2y += 1) { /*1844*/
			$1.i = _2y; /*1825*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1827*/
			$j--; /*1828*/
			$1.indx = $k[--$j].length; /*1829*/
			$j -= 2; /*1830*/
			$1.enc = $get($1.encs, $1.indx); /*1831*/
			if ($get($1.mirrormap, $1.i - 1) == 49) { /*1841*/
				$1.enclen = $1.enc.length; /*1833*/
				$1.revenc = $s($1.enclen); /*1834*/
				for (var _3F = 0, _3E = $1.enclen - 1; _3F <= _3E; _3F += 1) { /*1839*/
					$1.j = _3F; /*1836*/
					$1.char = $get($1.enc, $1.j); /*1837*/
					$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*1838*/
				} /*1838*/
				$1.enc = $1.revenc; /*1840*/
			} /*1840*/
			$puti($1.sbs, (($1.i - 1) * 4) + 3, $1.enc); /*1842*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 11) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1843*/
		} /*1843*/
		$put($1.txt, 7, $a([$geti($1.barcode, 7, 1), ((6 * 7) + 18) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1846*/
		$puti($1.sbs, 27, $get($1.encs, 11)); /*1849*/
		$k[$j++] = Infinity; /*1851*/
		var _3n = $1.sbs; /*1851*/
		for (var _3o = 0, _3p = _3n.length; _3o < _3p; _3o++) { /*1851*/
			$k[$j++] = $get(_3n, _3o) - 48; /*1851*/
		} /*1851*/
		$1.sbs = $a(); /*1851*/
		if ($1.includetext) { /*1858*/
			$k[$j++] = Infinity; /*1853*/
			$k[$j++] = $1.height; /*1853*/
			$k[$j++] = $1.height; /*1853*/
			for (var _3v = 0, _3w = 12; _3v < _3w; _3v++) { /*1853*/
				$k[$j++] = $1.height - 0.075; /*1853*/
			} /*1853*/
			$k[$j++] = $1.height; /*1853*/
			$k[$j++] = $1.height; /*1853*/
			$k[$j++] = $1.height; /*1853*/
			$1.bhs = $a(); /*1853*/
			$k[$j++] = Infinity; /*1854*/
			$k[$j++] = 0; /*1854*/
			$k[$j++] = 0; /*1854*/
			for (var _42 = 0, _43 = 12; _42 < _43; _42++) { /*1854*/
				$k[$j++] = 0.075; /*1854*/
			} /*1854*/
			$k[$j++] = 0; /*1854*/
			$k[$j++] = 0; /*1854*/
			$k[$j++] = 0; /*1854*/
			$1.bbs = $a(); /*1854*/
		} else { /*1858*/
			$k[$j++] = Infinity; /*1856*/
			for (var _45 = 0, _46 = 17; _45 < _46; _45++) { /*1856*/
				$k[$j++] = $1.height; /*1856*/
			} /*1856*/
			$1.bhs = $a(); /*1856*/
			$k[$j++] = Infinity; /*1857*/
			for (var _49 = 0, _4A = 17; _49 < _4A; _49++) { /*1857*/
				$k[$j++] = 0; /*1857*/
			} /*1857*/
			$1.bbs = $a(); /*1857*/
			$1.txt = $a([]); /*1858*/
		} /*1858*/
		$1.guardrightypos = 0; /*1860*/
		if ($ne($1.addon, "")) { /*1881*/
			$k[$j++] = "addopts"; /*1871*/
			$k[$j++] = Infinity; /*1871*/
			$k[$j++] = "dontdraw"; /*1868*/
			$k[$j++] = true; /*1868*/
			$k[$j++] = "includetext"; /*1868*/
			$k[$j++] = true; /*1868*/
			$k[$j++] = "height"; /*1868*/
			$k[$j++] = $1.height - 0.15; /*1868*/
			$k[$j++] = "textxoffset"; /*1868*/
			if ($1.addontextxoffset != "unset") { /*1868*/
				$k[$j++] = $1.addontextxoffset; /*1868*/
			} else { /*1868*/
				$k[$j++] = 51 + $1.addongap; /*1868*/
			} /*1868*/
			if ($1.addontextyoffset != "unset") { /*1869*/
				$k[$j++] = "textyoffset"; /*1869*/
				$k[$j++] = $1.addontextyoffset; /*1869*/
			} /*1869*/
			$k[$j++] = "textsize"; /*1870*/
			if ($1.addontextsize != "unset") { /*1870*/
				$k[$j++] = $1.addontextsize; /*1870*/
			} else { /*1870*/
				$k[$j++] = $1.textsize; /*1870*/
			} /*1870*/
			$k[$j++] = "textfont"; /*1871*/
			if ($ne($1.addontextfont, "unset")) { /*1871*/
				$k[$j++] = $1.addontextfont; /*1871*/
			} else { /*1871*/
				$k[$j++] = $1.textfont; /*1871*/
			} /*1871*/
			var _4Q = $d(); /*1871*/
			$1[$k[--$j]] = _4Q; /*1872*/
			if ($1.addon.length == 2) { /*1873*/
				$k[$j++] = $1.addon; /*1873*/
				$k[$j++] = $1.addopts; /*1873*/
				$0.ean2(); /*1873*/
			} /*1873*/
			if ($1.addon.length == 5) { /*1874*/
				$k[$j++] = $1.addon; /*1874*/
				$k[$j++] = $1.addopts; /*1874*/
				$0.ean5(); /*1874*/
			} /*1874*/
			$1.addcode = $k[--$j]; /*1875*/
			$k[$j++] = Infinity; /*1876*/
			$aload($1.sbs); /*1876*/
			$k[$j++] = $1.addongap; /*1876*/
			$aload($1.addcode.sbs); /*1876*/
			$1.sbs = $a(); /*1876*/
			$k[$j++] = Infinity; /*1877*/
			$aload($1.bhs); /*1877*/
			$forall($1.addcode.bhs, function() { /*1877*/
				var _4h = $k[--$j]; /*1877*/
				$k[$j++] = _4h - 0.075; /*1877*/
			}); /*1877*/
			$1.bhs = $a(); /*1877*/
			$k[$j++] = Infinity; /*1878*/
			$aload($1.bbs); /*1878*/
			$forall($1.addcode.bbs, function() { /*1878*/
				var _4m = $k[--$j]; /*1878*/
				$k[$j++] = _4m + 0.075; /*1878*/
			}); /*1878*/
			$1.bbs = $a(); /*1878*/
			$k[$j++] = Infinity; /*1879*/
			$aload($1.txt); /*1879*/
			$aload($1.addcode.txt); /*1879*/
			$1.txt = $a(); /*1879*/
			$1.guardrightypos = ($1.height * 72) - 6; /*1880*/
		} /*1880*/
		var _4z = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			txt: $1.txt,
			opt: $1.options,
			guardrightpos: 10,
			guardrightypos: $1.guardrightypos,
			borderbottom: 5
		}; /*1893*/
		$k[$j++] = _4z; /*1896*/
		if (!$1.dontdraw) { /*1896*/
			$0.renlinear(); /*1896*/
		} /*1896*/
	};
	$0.isbn = function() {
		var $1 = {}; /*1924*/
		$1.options = $k[--$j]; /*1926*/
		$1.barcode = $k[--$j]; /*1927*/
		$1.dontdraw = false; /*1929*/
		$1.includetext = false; /*1930*/
		$1.isbntextfont = "OCR-A"; /*1931*/
		$1.isbntextsize = 8.5; /*1932*/
		$1.isbntextxoffset = "unset"; /*1933*/
		$1.isbntextyoffset = "unset"; /*1934*/
		$1.height = 1; /*1935*/
		$1.addongap = 12; /*1936*/
		$1.legacy = false; /*1937*/
		$forall($1.options, function() { /*1948*/
			var _3 = $k[--$j]; /*1948*/
			$1[$k[--$j]] = _3; /*1948*/
		}); /*1948*/
		$1.isbntextfont = "" + $1.isbntextfont; /*1950*/
		$1.isbntextsize = +$1.isbntextsize; /*1951*/
		if ($ne($1.isbntextxoffset, "unset")) { /*1952*/
			$1.isbntextxoffset = +$1.isbntextxoffset; /*1952*/
		} /*1952*/
		if ($ne($1.isbntextyoffset, "unset")) { /*1953*/
			$1.isbntextyoffset = +$1.isbntextyoffset; /*1953*/
		} /*1953*/
		$1.height = +$1.height; /*1954*/
		$1.addongap = +$1.addongap; /*1955*/
		$search($1.barcode, " "); /*1958*/
		if ($k[--$j]) { /*1964*/
			$1.barcode = $k[--$j]; /*1959*/
			$j--; /*1960*/
			$1.addon = $k[--$j]; /*1961*/
		} else { /*1964*/
			$j--; /*1963*/
			$1.addon = ""; /*1964*/
		} /*1964*/
		if ((($1.barcode.length != 15) && ($1.barcode.length != 17)) && (($1.barcode.length != 11) && ($1.barcode.length != 13))) { /*1971*/
			$k[$j++] = "bwipp.isbnBadLength"; /*1970*/
			$k[$j++] = "ISBN-13 must be 15 or 17 characters including dashes. ISBN-10 must be 11 or 13 characters including dashes"; /*1970*/
			$0.raiseerror(); /*1970*/
		} /*1970*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1974*/
			$k[$j++] = "bwipp.isbnBadAddOnLength"; /*1973*/
			$k[$j++] = "Add-on for ISBN must be 2 or 5 digits"; /*1973*/
			$0.raiseerror(); /*1973*/
		} /*1973*/
		if ($1.barcode.length >= 15) { /*2038*/
			var _Q = $geti($1.barcode, 0, 4); /*1976*/
			if ($ne(_Q, "978-") && $ne(_Q, "979-")) { /*1978*/
				$k[$j++] = "bwipp.isbn13badPrefix"; /*1977*/
				$k[$j++] = "ISBN-13 prefix must be 978- or 979-"; /*1977*/
				$0.raiseerror(); /*1977*/
			} /*1977*/
			$1.wasdash = false; /*1979*/
			$1.numdash = 0; /*1979*/
			$1.numdigit = 0; /*1979*/
			$forall($geti($1.barcode, 5, 9), function() { /*1993*/
				var _T = $k[--$j]; /*1981*/
				$k[$j++] = _T; /*1988*/
				if (_T == 45) { /*1988*/
					if ($1.wasdash) { /*1985*/
						$k[$j++] = "bwipp.isbn13adjacentDashes"; /*1984*/
						$k[$j++] = "ISBN-13 does not permit adjacent dashes"; /*1984*/
						$0.raiseerror(); /*1984*/
					} /*1984*/
					$1.wasdash = true; /*1986*/
					$1.numdash = $1.numdash + 1; /*1987*/
				} /*1987*/
				var _W = $k[--$j]; /*1989*/
				if ((_W >= 48) && (_W <= 57)) { /*1992*/
					$1.wasdash = false; /*1990*/
					$1.numdigit = $1.numdigit + 1; /*1991*/
				} /*1991*/
			}); /*1991*/
			if (($1.numdash != 2) || ($1.numdigit != 7)) { /*1996*/
				$k[$j++] = "bwipp.isbn13numDashesDigits"; /*1995*/
				$k[$j++] = "Incorrect number of dashes and digits for ISBN-13"; /*1995*/
				$0.raiseerror(); /*1995*/
			} /*1995*/
			var _b = $get($1.barcode, 14); /*1997*/
			if ((_b < 48) || (_b > 57)) { /*1999*/
				$k[$j++] = "bwipp.isbn13character15"; /*1998*/
				$k[$j++] = "ISBN-13 character 15 must be a digit"; /*1998*/
				$0.raiseerror(); /*1998*/
			} /*1998*/
			if ($1.barcode.length == 17) { /*2007*/
				if ($ne($geti($1.barcode, 15, 1), "-")) { /*2003*/
					$k[$j++] = "bwipp.isbn13character16"; /*2002*/
					$k[$j++] = "ISBN-13 penultimate character must be a dash"; /*2002*/
					$0.raiseerror(); /*2002*/
				} /*2002*/
				var _g = $get($1.barcode, 16); /*2004*/
				if ((_g < 48) || (_g > 57)) { /*2006*/
					$k[$j++] = "bwipp.isbn13character17"; /*2005*/
					$k[$j++] = "ISBN-13 final character must be a digit"; /*2005*/
					$0.raiseerror(); /*2005*/
				} /*2005*/
			} /*2005*/
		} else { /*2038*/
			var _i = $get($1.barcode, 0); /*2009*/
			if ((_i < 48) || (_i > 57)) { /*2011*/
				$k[$j++] = "bwipp.isbn10FirstDigit"; /*2010*/
				$k[$j++] = "ISBN-10 first character must be a digit"; /*2010*/
				$0.raiseerror(); /*2010*/
			} /*2010*/
			$1.wasdash = false; /*2012*/
			$1.numdash = 0; /*2012*/
			$1.numdigit = 0; /*2012*/
			$forall($geti($1.barcode, 1, 9), function() { /*2026*/
				var _l = $k[--$j]; /*2014*/
				$k[$j++] = _l; /*2021*/
				if (_l == 45) { /*2021*/
					if ($1.wasdash) { /*2018*/
						$k[$j++] = "bwipp.isbn10adjacentDashes"; /*2017*/
						$k[$j++] = "ISBN-10 does not permit adjacent dashes"; /*2017*/
						$0.raiseerror(); /*2017*/
					} /*2017*/
					$1.wasdash = true; /*2019*/
					$1.numdash = $1.numdash + 1; /*2020*/
				} /*2020*/
				var _o = $k[--$j]; /*2022*/
				if ((_o >= 48) && (_o <= 57)) { /*2025*/
					$1.wasdash = false; /*2023*/
					$1.numdigit = $1.numdigit + 1; /*2024*/
				} /*2024*/
			}); /*2024*/
			if (($1.numdash != 2) || ($1.numdigit != 7)) { /*2029*/
				$k[$j++] = "bwipp.isbn10numDashesDigits"; /*2028*/
				$k[$j++] = "Incorrect number of dashes and digits for ISBN-10"; /*2028*/
				$0.raiseerror(); /*2028*/
			} /*2028*/
			var _t = $get($1.barcode, 10); /*2030*/
			if ((_t < 48) || (_t > 57)) { /*2032*/
				$k[$j++] = "bwipp.isbn10character11"; /*2031*/
				$k[$j++] = "ISBN-10 character 11 must be a digit"; /*2031*/
				$0.raiseerror(); /*2031*/
			} /*2031*/
			if ($1.barcode.length == 13) { /*2040*/
				if ($ne($geti($1.barcode, 11, 1), "-")) { /*2036*/
					$k[$j++] = "bwipp.isbn10character12"; /*2035*/
					$k[$j++] = "ISBN-10 penultimate character must be a dash"; /*2035*/
					$0.raiseerror(); /*2035*/
				} /*2035*/
				var _y = $get($1.barcode, 12); /*2037*/
				if (((_y < 48) || (_y > 57)) && (_y != 88)) { /*2039*/
					$k[$j++] = "bwipp.isbn10character13"; /*2038*/
					$k[$j++] = "ISBN-10 final character must be a digit or X"; /*2038*/
					$0.raiseerror(); /*2038*/
				} /*2038*/
			} /*2038*/
		} /*2038*/
		$1.isbntxt = $1.barcode; /*2043*/
		if ($1.isbntxt.length <= 13) { /*2069*/
			$1.isbn = $s(10); /*2047*/
			$1.checksum = 0; /*2048*/
			$1.i = 0; /*2049*/
			$1.n = 0; /*2049*/
			for (;;) { /*2061*/
				$1.isbnchar = $get($1.isbntxt, $1.i) - 48; /*2051*/
				if ($1.isbnchar != -3) { /*2058*/
					$put($1.isbn, $1.n, $1.isbnchar + 48); /*2053*/
					if ($1.n < 9) { /*2056*/
						$1.checksum = $1.checksum + ((10 - $1.n) * $1.isbnchar); /*2055*/
					} /*2055*/
					$1.n = $1.n + 1; /*2057*/
				} /*2057*/
				$1.i = $1.i + 1; /*2059*/
				if ($1.i == $1.isbntxt.length) { /*2060*/
					break; /*2060*/
				} /*2060*/
			} /*2060*/
			var _1I = (11 - ($1.checksum % 11)) % 11; /*2062*/
			$k[$j++] = "checksum"; /*2062*/
			$k[$j++] = _1I; /*2062*/
			if (_1I == 10) { /*2062*/
				$j--; /*2062*/
				$k[$j++] = 40; /*2062*/
			} /*2062*/
			var _1J = $k[--$j]; /*2062*/
			$1[$k[--$j]] = _1J + 48; /*2062*/
			$1.isbn = $geti($1.isbn, 0, 9); /*2063*/
			if ($1.isbntxt.length == 13) { /*2068*/
				if ($get($1.isbntxt, 12) != $1.checksum) { /*2067*/
					$k[$j++] = "bwipp.isbn10badCheckDigit"; /*2066*/
					$k[$j++] = "Incorrect ISBN-10 check digit provided"; /*2066*/
					$0.raiseerror(); /*2066*/
				} /*2066*/
			} /*2066*/
		} /*2066*/
		if ((!$1.legacy) || ($1.isbntxt.length >= 15)) { /*2105*/
			if ($1.isbntxt.length <= 13) { /*2079*/
				$1.pad = $s(15); /*2075*/
				$puti($1.pad, 0, "978-"); /*2076*/
				$puti($1.pad, 4, $geti($1.isbntxt, 0, 11)); /*2077*/
				$1.isbntxt = $1.pad; /*2078*/
			} /*2078*/
			$1.isbn = $s(13); /*2082*/
			$1.checksum = 0; /*2083*/
			$1.i = 0; /*2084*/
			$1.n = 0; /*2084*/
			for (;;) { /*2096*/
				$1.isbnchar = $get($1.isbntxt, $1.i) - 48; /*2086*/
				if ($1.isbnchar != -3) { /*2093*/
					$put($1.isbn, $1.n, $1.isbnchar + 48); /*2088*/
					if ($1.n < 12) { /*2091*/
						$k[$j++] = "checksum"; /*2090*/
						$k[$j++] = $1.isbnchar; /*2090*/
						if (($1.n % 2) != 0) { /*2090*/
							var _1l = $k[--$j]; /*2090*/
							$k[$j++] = _1l * 3; /*2090*/
						} /*2090*/
						var _1n = $k[--$j]; /*2090*/
						$1[$k[--$j]] = _1n + $1.checksum; /*2090*/
					} /*2090*/
					$1.n = $1.n + 1; /*2092*/
				} /*2092*/
				$1.i = $1.i + 1; /*2094*/
				if ($1.i == $1.isbntxt.length) { /*2095*/
					break; /*2095*/
				} /*2095*/
			} /*2095*/
			$1.checksum = ((10 - ($1.checksum % 10)) % 10) + 48; /*2097*/
			$1.isbn = $geti($1.isbn, 0, 12); /*2098*/
			if ($1.isbntxt.length == 17) { /*2103*/
				if ($get($1.isbntxt, 16) != $1.checksum) { /*2102*/
					$k[$j++] = "bwipp.isbn13badCheckDigit"; /*2101*/
					$k[$j++] = "Incorrect ISBN-13 check digit provided"; /*2101*/
					$0.raiseerror(); /*2101*/
				} /*2101*/
			} /*2101*/
		} /*2101*/
		var _21 = ($1.isbn.length == 12) ? 22 : 18; /*2108*/
		$1.pad = $s(_21); /*2108*/
		$puti($1.pad, 0, "ISBN "); /*2109*/
		$puti($1.pad, 5, $1.isbntxt); /*2110*/
		$put($1.pad, $1.pad.length - 2, 45); /*2111*/
		$put($1.pad, $1.pad.length - 1, $1.checksum); /*2112*/
		$1.isbntxt = $1.pad; /*2113*/
		$1.barcode = $s(12); /*2116*/
		if ($1.isbn.length == 9) { /*2121*/
			$puti($1.barcode, 0, "978"); /*2118*/
			$puti($1.barcode, 3, $1.isbn); /*2119*/
		} else { /*2121*/
			$puti($1.barcode, 0, $1.isbn); /*2121*/
		} /*2121*/
		if ($ne($1.addon, "")) { /*2131*/
			var _2L = $s((12 + $1.addon.length) + 1); /*2126*/
			$puti(_2L, 0, $1.barcode); /*2127*/
			$puti(_2L, 12, " "); /*2128*/
			$puti(_2L, 13, $1.addon); /*2129*/
			$1.barcode = _2L; /*2130*/
		} /*2130*/
		$1.options.dontdraw = true; /*2134*/
		$1.options.addongap = $1.addongap; /*2135*/
		$k[$j++] = "args"; /*2136*/
		$k[$j++] = $1.barcode; /*2136*/
		$k[$j++] = $1.options; /*2136*/
		$0.ean13(); /*2136*/
		var _2T = $k[--$j]; /*2136*/
		$1[$k[--$j]] = _2T; /*2136*/
		if ($1.includetext) { /*2155*/
			if ($1.isbntextxoffset == "unset") { /*2142*/
				$k[$j++] = "isbntextxoffset"; /*2141*/
				if ($1.isbn.length == 9) { /*2141*/
					$k[$j++] = -1; /*2141*/
				} else { /*2141*/
					$k[$j++] = -12; /*2141*/
				} /*2141*/
				var _2Y = $k[--$j]; /*2141*/
				$1[$k[--$j]] = _2Y; /*2141*/
			} /*2141*/
			if ($1.isbntextyoffset == "unset") { /*2145*/
				$1.isbntextyoffset = ($1.height * 72) + 3; /*2144*/
			} /*2144*/
			var _2d = $1.args.txt !== undefined; /*2146*/
			if (_2d) { /*2153*/
				$1.txt = $1.args.txt; /*2147*/
				$1.newtxt = $a($1.txt.length + 1); /*2148*/
				$puti($1.newtxt, 0, $1.txt); /*2149*/
				$put($1.newtxt, $1.newtxt.length - 1, $a([$1.isbntxt, $1.isbntextxoffset, $1.isbntextyoffset, $1.isbntextfont, $1.isbntextsize])); /*2150*/
				$1.args.txt = $1.newtxt; /*2151*/
			} else { /*2153*/
				$1.args.txt = $a([$a([$1.isbntxt, $1.isbntextxoffset, $1.isbntextyoffset, $1.isbntextfont, $1.isbntextsize])]); /*2153*/
			} /*2153*/
		} /*2153*/
		$1.args.opt = $1.options; /*2157*/
		$k[$j++] = $1.args; /*2160*/
		if (!$1.dontdraw) { /*2160*/
			$0.renlinear(); /*2160*/
		} /*2160*/
	};
	$0.ismn = function() {
		var $1 = {}; /*2188*/
		$1.options = $k[--$j]; /*2190*/
		$1.barcode = $k[--$j]; /*2191*/
		$1.dontdraw = false; /*2193*/
		$1.includetext = false; /*2194*/
		$1.ismntextfont = "OCR-A"; /*2195*/
		$1.ismntextsize = 8.5; /*2196*/
		$1.ismntextxoffset = "unset"; /*2197*/
		$1.ismntextyoffset = "unset"; /*2198*/
		$1.height = 1; /*2199*/
		$1.addongap = 12; /*2200*/
		$1.legacy = false; /*2201*/
		$forall($1.options, function() { /*2212*/
			var _3 = $k[--$j]; /*2212*/
			$1[$k[--$j]] = _3; /*2212*/
		}); /*2212*/
		$1.ismntextfont = "" + $1.ismntextfont; /*2214*/
		$1.ismntextsize = +$1.ismntextsize; /*2215*/
		if ($ne($1.ismntextxoffset, "unset")) { /*2216*/
			$1.ismntextxoffset = +$1.ismntextxoffset; /*2216*/
		} /*2216*/
		if ($ne($1.ismntextyoffset, "unset")) { /*2217*/
			$1.ismntextyoffset = +$1.ismntextyoffset; /*2217*/
		} /*2217*/
		$1.height = +$1.height; /*2218*/
		$1.addongap = +$1.addongap; /*2219*/
		$search($1.barcode, " "); /*2222*/
		if ($k[--$j]) { /*2228*/
			$1.barcode = $k[--$j]; /*2223*/
			$j--; /*2224*/
			$1.addon = $k[--$j]; /*2225*/
		} else { /*2228*/
			$j--; /*2227*/
			$1.addon = ""; /*2228*/
		} /*2228*/
		if ((($1.barcode.length != 15) && ($1.barcode.length != 17)) && (($1.barcode.length != 11) && ($1.barcode.length != 13))) { /*2235*/
			$k[$j++] = "bwipp.ismnBadLength"; /*2234*/
			$k[$j++] = "ISMN-13 must be 15 or 17 characters including dashes. ISMN-10 must be 11 or 13 characters including dashes"; /*2234*/
			$0.raiseerror(); /*2234*/
		} /*2234*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*2238*/
			$k[$j++] = "bwipp.ismnBadAddOnLength"; /*2237*/
			$k[$j++] = "Add-on for ISMN must be 2 or 5 digits"; /*2237*/
			$0.raiseerror(); /*2237*/
		} /*2237*/
		if ($1.barcode.length >= 15) { /*2305*/
			if ($ne($geti($1.barcode, 0, 4), "979-")) { /*2242*/
				$k[$j++] = "bwipp.ismn13badPrefix"; /*2241*/
				$k[$j++] = "ISMN-13 prefix must be 979-"; /*2241*/
				$0.raiseerror(); /*2241*/
			} /*2241*/
			$1.wasdash = false; /*2243*/
			$1.numdash = 0; /*2243*/
			$1.numdigit = 0; /*2243*/
			$forall($geti($1.barcode, 5, 9), function() { /*2257*/
				var _T = $k[--$j]; /*2245*/
				$k[$j++] = _T; /*2252*/
				if (_T == 45) { /*2252*/
					if ($1.wasdash) { /*2249*/
						$k[$j++] = "bwipp.ismn13adjacentDashes"; /*2248*/
						$k[$j++] = "ISMN-13 does not permit adjacent dashes"; /*2248*/
						$0.raiseerror(); /*2248*/
					} /*2248*/
					$1.wasdash = true; /*2250*/
					$1.numdash = $1.numdash + 1; /*2251*/
				} /*2251*/
				var _W = $k[--$j]; /*2253*/
				if ((_W >= 48) && (_W <= 57)) { /*2256*/
					$1.wasdash = false; /*2254*/
					$1.numdigit = $1.numdigit + 1; /*2255*/
				} /*2255*/
			}); /*2255*/
			if (($1.numdash != 2) || ($1.numdigit != 7)) { /*2260*/
				$k[$j++] = "bwipp.ismn13numDashesDigits"; /*2259*/
				$k[$j++] = "Incorrect number of dashes and digits for ISMN-13"; /*2259*/
				$0.raiseerror(); /*2259*/
			} /*2259*/
			var _b = $get($1.barcode, 14); /*2261*/
			if ((_b < 48) || (_b > 57)) { /*2263*/
				$k[$j++] = "bwipp.ismn13character15"; /*2262*/
				$k[$j++] = "ISMN-13 character 15 must be a digit"; /*2262*/
				$0.raiseerror(); /*2262*/
			} /*2262*/
			if ($1.barcode.length == 17) { /*2271*/
				if ($ne($geti($1.barcode, 15, 1), "-")) { /*2267*/
					$k[$j++] = "bwipp.ismn13character16"; /*2266*/
					$k[$j++] = "ISMN-13 penultimate character must be a dash"; /*2266*/
					$0.raiseerror(); /*2266*/
				} /*2266*/
				var _g = $get($1.barcode, 16); /*2268*/
				if ((_g < 48) || (_g > 57)) { /*2270*/
					$k[$j++] = "bwipp.ismn13character17"; /*2269*/
					$k[$j++] = "ISMN-13 final character must be a digit"; /*2269*/
					$0.raiseerror(); /*2269*/
				} /*2269*/
			} /*2269*/
		} else { /*2305*/
			if ($ne($geti($1.barcode, 0, 2), "M-")) { /*2275*/
				$k[$j++] = "bwipp.ismn10badPrefix"; /*2274*/
				$k[$j++] = "ISMN-10 prefix must be M-"; /*2274*/
				$0.raiseerror(); /*2274*/
			} /*2274*/
			var _k = $get($1.barcode, 2); /*2276*/
			if ((_k < 48) || (_k > 57)) { /*2278*/
				$k[$j++] = "bwipp.ismn10character3"; /*2277*/
				$k[$j++] = "ISMN-10 character 3 must be a digit"; /*2277*/
				$0.raiseerror(); /*2277*/
			} /*2277*/
			$1.wasdash = false; /*2279*/
			$1.numdash = 0; /*2279*/
			$1.numdigit = 0; /*2279*/
			$forall($geti($1.barcode, 3, 7), function() { /*2293*/
				var _n = $k[--$j]; /*2281*/
				$k[$j++] = _n; /*2288*/
				if (_n == 45) { /*2288*/
					if ($1.wasdash) { /*2285*/
						$k[$j++] = "bwipp.ismn10adjacentDashes"; /*2284*/
						$k[$j++] = "ISMN-10 does not permit adjacent dashes"; /*2284*/
						$0.raiseerror(); /*2284*/
					} /*2284*/
					$1.wasdash = true; /*2286*/
					$1.numdash = $1.numdash + 1; /*2287*/
				} /*2287*/
				var _q = $k[--$j]; /*2289*/
				if ((_q >= 48) && (_q <= 57)) { /*2292*/
					$1.wasdash = false; /*2290*/
					$1.numdigit = $1.numdigit + 1; /*2291*/
				} /*2291*/
			}); /*2291*/
			if (($1.numdash != 1) || ($1.numdigit != 6)) { /*2296*/
				$k[$j++] = "bwipp.ismn10numDashesDigits"; /*2295*/
				$k[$j++] = "Incorrect number of dashes and digits for ISMN-10"; /*2295*/
				$0.raiseerror(); /*2295*/
			} /*2295*/
			var _v = $get($1.barcode, 10); /*2297*/
			if ((_v < 48) || (_v > 57)) { /*2299*/
				$k[$j++] = "bwipp.ismn10character11"; /*2298*/
				$k[$j++] = "ISMN-10 character 11 must be a digit"; /*2298*/
				$0.raiseerror(); /*2298*/
			} /*2298*/
			if ($1.barcode.length == 13) { /*2307*/
				if ($ne($geti($1.barcode, 11, 1), "-")) { /*2303*/
					$k[$j++] = "bwipp.ismn10character12"; /*2302*/
					$k[$j++] = "ISMN-10 penultimate character must be a dash"; /*2302*/
					$0.raiseerror(); /*2302*/
				} /*2302*/
				var _10 = $get($1.barcode, 12); /*2304*/
				if (((_10 < 48) || (_10 > 57)) && (_10 != 88)) { /*2306*/
					$k[$j++] = "bwipp.ismn10character13"; /*2305*/
					$k[$j++] = "ISMN-10 final character must be a digit or X"; /*2305*/
					$0.raiseerror(); /*2305*/
				} /*2305*/
			} /*2305*/
		} /*2305*/
		$1.ismntxt = $1.barcode; /*2310*/
		$1.legacytxt = ""; /*2313*/
		if ($1.ismntxt.length <= 13) { /*2320*/
			$1.legacytxt = $1.ismntxt; /*2315*/
			$1.pad = $s($1.ismntxt.length + 4); /*2316*/
			$puti($1.pad, 0, "979-0-"); /*2317*/
			$puti($1.pad, 6, $geti($1.ismntxt, 2, $1.ismntxt.length - 2)); /*2318*/
			$1.ismntxt = $1.pad; /*2319*/
		} /*2319*/
		$1.ismn = $s(13); /*2323*/
		$1.checksum = 0; /*2324*/
		$1.i = 0; /*2325*/
		$1.n = 0; /*2325*/
		for (;;) { /*2341*/
			$1.ismnchar = $get($1.ismntxt, $1.i) - 48; /*2327*/
			if ($1.ismnchar != -3) { /*2338*/
				$put($1.ismn, $1.n, $1.ismnchar + 48); /*2329*/
				if ($1.n < 12) { /*2336*/
					if (($1.n % 2) == 0) { /*2334*/
						$1.checksum = $1.ismnchar + $1.checksum; /*2332*/
					} else { /*2334*/
						$1.checksum = ($1.ismnchar * 3) + $1.checksum; /*2334*/
					} /*2334*/
				} /*2334*/
				$1.n = $1.n + 1; /*2337*/
			} /*2337*/
			$1.i = $1.i + 1; /*2339*/
			if ($1.i == $1.ismntxt.length) { /*2340*/
				break; /*2340*/
			} /*2340*/
		} /*2340*/
		$1.checksum = ((10 - ($1.checksum % 10)) % 10) + 48; /*2342*/
		if (($1.barcode.length == 13) || ($1.barcode.length == 17)) { /*2349*/
			var _1X = $1.barcode; /*2346*/
			if ($get(_1X, _1X.length - 1) != $1.checksum) { /*2348*/
				$k[$j++] = "bwipp.ismnBadCheckDigit"; /*2347*/
				$k[$j++] = "Incorrect ISMN check digit provided"; /*2347*/
				$0.raiseerror(); /*2347*/
			} /*2347*/
		} /*2347*/
		if ($1.legacy && $ne($1.legacytxt, "")) { /*2356*/
			$1.ismntxt = $1.legacytxt; /*2353*/
			$1.pad = $s(18); /*2354*/
		} else { /*2356*/
			$1.pad = $s(22); /*2356*/
		} /*2356*/
		$puti($1.pad, 0, "ISMN "); /*2358*/
		$puti($1.pad, 5, $1.ismntxt); /*2359*/
		$put($1.pad, $1.pad.length - 2, 45); /*2360*/
		$put($1.pad, $1.pad.length - 1, $1.checksum); /*2361*/
		$1.ismntxt = $1.pad; /*2362*/
		$1.barcode = $geti($1.ismn, 0, 12); /*2365*/
		if ($ne($1.addon, "")) { /*2374*/
			var _1s = $s((12 + $1.addon.length) + 1); /*2369*/
			$puti(_1s, 0, $1.barcode); /*2370*/
			$puti(_1s, 12, " "); /*2371*/
			$puti(_1s, 13, $1.addon); /*2372*/
			$1.barcode = _1s; /*2373*/
		} /*2373*/
		$1.options.dontdraw = true; /*2377*/
		$1.options.addongap = $1.addongap; /*2378*/
		$k[$j++] = "args"; /*2379*/
		$k[$j++] = $1.barcode; /*2379*/
		$k[$j++] = $1.options; /*2379*/
		$0.ean13(); /*2379*/
		var _20 = $k[--$j]; /*2379*/
		$1[$k[--$j]] = _20; /*2379*/
		if ($1.includetext) { /*2398*/
			if ($1.ismntextxoffset == "unset") { /*2385*/
				$k[$j++] = "ismntextxoffset"; /*2384*/
				if ($1.ismntxt.length == 18) { /*2384*/
					$k[$j++] = -1; /*2384*/
				} else { /*2384*/
					$k[$j++] = -12; /*2384*/
				} /*2384*/
				var _25 = $k[--$j]; /*2384*/
				$1[$k[--$j]] = _25; /*2384*/
			} /*2384*/
			if ($1.ismntextyoffset == "unset") { /*2388*/
				$1.ismntextyoffset = ($1.height * 72) + 3; /*2387*/
			} /*2387*/
			var _2A = $1.args.txt !== undefined; /*2389*/
			if (_2A) { /*2396*/
				$1.txt = $1.args.txt; /*2390*/
				$1.newtxt = $a($1.txt.length + 1); /*2391*/
				$puti($1.newtxt, 0, $1.txt); /*2392*/
				$put($1.newtxt, $1.newtxt.length - 1, $a([$1.ismntxt, $1.ismntextxoffset, $1.ismntextyoffset, $1.ismntextfont, $1.ismntextsize])); /*2393*/
				$1.args.txt = $1.newtxt; /*2394*/
			} else { /*2396*/
				$1.args.txt = $a([$a([$1.ismntxt, $1.ismntextxoffset, $1.ismntextyoffset, $1.ismntextfont, $1.ismntextsize])]); /*2396*/
			} /*2396*/
		} /*2396*/
		$1.args.opt = $1.options; /*2400*/
		$k[$j++] = $1.args; /*2403*/
		if (!$1.dontdraw) { /*2403*/
			$0.renlinear(); /*2403*/
		} /*2403*/
	};
	$0.issn = function() {
		var $1 = {}; /*2431*/
		$1.options = $k[--$j]; /*2433*/
		$1.issntxt = $k[--$j]; /*2434*/
		$1.dontdraw = false; /*2436*/
		$1.includetext = false; /*2437*/
		$1.issntextfont = "OCR-A"; /*2438*/
		$1.issntextsize = 8.5; /*2439*/
		$1.issntextxoffset = "unset"; /*2440*/
		$1.issntextyoffset = "unset"; /*2441*/
		$1.height = 1; /*2442*/
		$1.addongap = 12; /*2443*/
		$forall($1.options, function() { /*2454*/
			var _3 = $k[--$j]; /*2454*/
			$1[$k[--$j]] = _3; /*2454*/
		}); /*2454*/
		$1.issntextfont = "" + $1.issntextfont; /*2456*/
		$1.issntextsize = +$1.issntextsize; /*2457*/
		if ($ne($1.issntextxoffset, "unset")) { /*2458*/
			$1.issntextxoffset = +$1.issntextxoffset; /*2458*/
		} /*2458*/
		if ($ne($1.issntextyoffset, "unset")) { /*2459*/
			$1.issntextyoffset = +$1.issntextyoffset; /*2459*/
		} /*2459*/
		$1.height = +$1.height; /*2460*/
		$1.addongap = +$1.addongap; /*2461*/
		$search($1.issntxt, " "); /*2464*/
		if ($k[--$j]) { /*2470*/
			$1.issntxt = $k[--$j]; /*2465*/
			$j--; /*2466*/
			$1.seqvar = $k[--$j]; /*2467*/
		} else { /*2470*/
			$j--; /*2469*/
			$1.seqvar = ""; /*2470*/
		} /*2470*/
		$search($1.seqvar, " "); /*2474*/
		if ($k[--$j]) { /*2481*/
			$1.seqvar = $k[--$j]; /*2475*/
			$j--; /*2476*/
			$1.addon = $k[--$j]; /*2477*/
		} else { /*2481*/
			$j--; /*2479*/
			$1.addon = $1.seqvar; /*2480*/
			$1.seqvar = "00"; /*2481*/
		} /*2481*/
		if (($1.issntxt.length != 8) && ($1.issntxt.length != 9)) { /*2487*/
			$k[$j++] = "bwipp.issnBadLength"; /*2486*/
			$k[$j++] = "ISSN must be 8 or 9 characters including dash"; /*2486*/
			$0.raiseerror(); /*2486*/
		} /*2486*/
		$forall($geti($1.issntxt, 0, 4), function() { /*2492*/
			var _Q = $k[--$j]; /*2489*/
			if ((_Q < 48) || (_Q > 57)) { /*2491*/
				$k[$j++] = "bwipp.issnBadFormat"; /*2490*/
				$k[$j++] = "ISSN must have the format XXXX-XXXX"; /*2490*/
				$0.raiseerror(); /*2490*/
			} /*2490*/
		}); /*2490*/
		if ($ne($geti($1.issntxt, 4, 1), "-")) { /*2495*/
			$k[$j++] = "bwipp.issnBadFormat"; /*2494*/
			$k[$j++] = "ISSN must have the format XXXX-XXXX"; /*2494*/
			$0.raiseerror(); /*2494*/
		} /*2494*/
		$forall($geti($1.issntxt, 5, 3), function() { /*2500*/
			var _V = $k[--$j]; /*2497*/
			if ((_V < 48) || (_V > 57)) { /*2499*/
				$k[$j++] = "bwipp.issnBadFormat"; /*2498*/
				$k[$j++] = "ISSN must have the format XXXX-XXXX"; /*2498*/
				$0.raiseerror(); /*2498*/
			} /*2498*/
		}); /*2498*/
		if ($1.issntxt.length == 9) { /*2505*/
			var _Y = $get($1.issntxt, 8); /*2502*/
			if (((_Y < 48) || (_Y > 57)) && (_Y != 88)) { /*2504*/
				$k[$j++] = "bwipp.issnBadFormat"; /*2503*/
				$k[$j++] = "ISSN must have the format XXXX-XXXX"; /*2503*/
				$0.raiseerror(); /*2503*/
			} /*2503*/
		} /*2503*/
		if ($1.seqvar.length != 2) { /*2508*/
			$k[$j++] = "bwipp.issnBadSequenceVariantLength"; /*2507*/
			$k[$j++] = "Sequence variant for ISSN must be 2 digits"; /*2507*/
			$0.raiseerror(); /*2507*/
		} /*2507*/
		var _a = $1.seqvar; /*2509*/
		for (var _b = 0, _c = _a.length; _b < _c; _b++) { /*2513*/
			var _d = $get(_a, _b); /*2513*/
			if ((_d < 48) || (_d > 57)) { /*2512*/
				$k[$j++] = "bwipp.issnSequenceVariantBadCharacter"; /*2511*/
				$k[$j++] = "Sequence variant for ISSN must contain only digits"; /*2511*/
				$0.raiseerror(); /*2511*/
			} /*2511*/
		} /*2511*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*2516*/
			$k[$j++] = "bwipp.issnBadAddOnLength"; /*2515*/
			$k[$j++] = "Add-on for ISSN must be 2 or 5 digits"; /*2515*/
			$0.raiseerror(); /*2515*/
		} /*2515*/
		$1.issn = $s(8); /*2519*/
		$1.checksum = 0; /*2520*/
		$1.i = 0; /*2521*/
		$1.n = 0; /*2521*/
		for (;;) { /*2533*/
			$1.issnchar = $get($1.issntxt, $1.i) - 48; /*2523*/
			if ($1.issnchar != -3) { /*2530*/
				$put($1.issn, $1.n, $1.issnchar + 48); /*2525*/
				if ($1.n < 7) { /*2528*/
					$1.checksum = $1.checksum + ($1.issnchar * (8 - $1.n)); /*2527*/
				} /*2527*/
				$1.n = $1.n + 1; /*2529*/
			} /*2529*/
			$1.i = $1.i + 1; /*2531*/
			if ($1.i == $1.issntxt.length) { /*2532*/
				break; /*2532*/
			} /*2532*/
		} /*2532*/
		$1.checksum = (11 - ($1.checksum % 11)) % 11; /*2534*/
		var _z = $1.checksum + 48; /*2535*/
		$k[$j++] = "checksum"; /*2535*/
		$k[$j++] = _z; /*2535*/
		if (_z == 58) { /*2535*/
			$j--; /*2535*/
			$k[$j++] = 88; /*2535*/
		} /*2535*/
		var _10 = $k[--$j]; /*2535*/
		$1[$k[--$j]] = _10; /*2535*/
		if ($1.issntxt.length == 9) { /*2540*/
			if ($get($1.issntxt, 8) != $1.checksum) { /*2539*/
				$k[$j++] = "bwipp.issnBadCheckDigit"; /*2538*/
				$k[$j++] = "Incorrect ISSN check digit provided"; /*2538*/
				$0.raiseerror(); /*2538*/
			} /*2538*/
		} /*2538*/
		$1.pad = $s(14); /*2543*/
		$puti($1.pad, 0, "ISSN "); /*2544*/
		$puti($1.pad, 5, $1.issntxt); /*2545*/
		$put($1.pad, 13, $1.checksum); /*2546*/
		$1.issntxt = $1.pad; /*2547*/
		$1.barcode = $geti($1.issn, 0, 7); /*2550*/
		$1.barcode = $s(12); /*2553*/
		$puti($1.barcode, 0, "977"); /*2554*/
		$puti($1.barcode, 3, $1.issn); /*2555*/
		$puti($1.barcode, 10, $1.seqvar); /*2556*/
		if ($ne($1.addon, "")) { /*2565*/
			var _1N = $s((12 + $1.addon.length) + 1); /*2560*/
			$puti(_1N, 0, $1.barcode); /*2561*/
			$puti(_1N, 12, " "); /*2562*/
			$puti(_1N, 13, $1.addon); /*2563*/
			$1.barcode = _1N; /*2564*/
		} /*2564*/
		$1.options.dontdraw = true; /*2568*/
		$1.options.addongap = $1.addongap; /*2569*/
		$k[$j++] = "args"; /*2570*/
		$k[$j++] = $1.barcode; /*2570*/
		$k[$j++] = $1.options; /*2570*/
		$0.ean13(); /*2570*/
		var _1V = $k[--$j]; /*2570*/
		$1[$k[--$j]] = _1V; /*2570*/
		if ($1.includetext) { /*2587*/
			if ($1.issntextxoffset == "unset") { /*2574*/
				$1.issntextxoffset = 10; /*2574*/
			} /*2574*/
			if ($1.issntextyoffset == "unset") { /*2577*/
				$1.issntextyoffset = ($1.height * 72) + 3; /*2576*/
			} /*2576*/
			var _1c = $1.args.txt !== undefined; /*2578*/
			if (_1c) { /*2585*/
				$1.txt = $1.args.txt; /*2579*/
				$1.newtxt = $a($1.txt.length + 1); /*2580*/
				$puti($1.newtxt, 0, $1.txt); /*2581*/
				$put($1.newtxt, $1.newtxt.length - 1, $a([$1.issntxt, $1.issntextxoffset, $1.issntextyoffset, $1.issntextfont, $1.issntextsize])); /*2582*/
				$1.args.txt = $1.newtxt; /*2583*/
			} else { /*2585*/
				$1.args.txt = $a([$a([$1.issntxt, $1.issntextxoffset, $1.issntextyoffset, $1.issntextfont, $1.issntextsize])]); /*2585*/
			} /*2585*/
		} /*2585*/
		$1.args.opt = $1.options; /*2589*/
		$k[$j++] = $1.args; /*2592*/
		if (!$1.dontdraw) { /*2592*/
			$0.renlinear(); /*2592*/
		} /*2592*/
	};
	$0.code128 = function() {
		var $1 = {}; /*2619*/
		$1.options = $k[--$j]; /*2621*/
		$1.barcode = $k[--$j]; /*2622*/
		$1.dontdraw = false; /*2624*/
		$1.includetext = false; /*2625*/
		$1.textfont = "Courier"; /*2626*/
		$1.textsize = 10; /*2627*/
		$1.textxoffset = 0; /*2628*/
		$1.textyoffset = -8.5; /*2629*/
		$1.height = 1; /*2630*/
		$1.encoding = "auto"; /*2631*/
		$1.raw = false; /*2632*/
		$1.parse = false; /*2633*/
		$1.parsefnc = false; /*2634*/
		$forall($1.options, function() { /*2645*/
			var _3 = $k[--$j]; /*2645*/
			$1[$k[--$j]] = _3; /*2645*/
		}); /*2645*/
		$1.textfont = "" + $1.textfont; /*2647*/
		$1.textsize = +$1.textsize; /*2648*/
		$1.textxoffset = +$1.textxoffset; /*2649*/
		$1.textyoffset = +$1.textyoffset; /*2650*/
		$1.height = +$1.height; /*2651*/
		$1.barlen = $1.barcode.length; /*2674*/
		$1.sta = -1; /*2677*/
		$1.stb = -2; /*2677*/
		$1.stc = -3; /*2677*/
		$1.swa = -4; /*2678*/
		$1.swb = -5; /*2678*/
		$1.swc = -6; /*2678*/
		$1.fn1 = -7; /*2679*/
		$1.fn2 = -8; /*2679*/
		$1.fn3 = -9; /*2679*/
		$1.fn4 = -10; /*2680*/
		$1.sft = -11; /*2680*/
		$1.stp = -12; /*2680*/
		$1.lka = -13; /*2681*/
		$1.lkc = -14; /*2681*/
		$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sft, $1.sft, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.sta, $1.sta, $1.sta]), $a([$1.stb, $1.stb, $1.stb]), $a([$1.stc, $1.stc, $1.stc]), $a([$1.stp, $1.stp, $1.stp])]); /*2722*/
		$1.charvals = $a([{}, {}, {}]); /*2725*/
		for (var _2R = 0, _2Q = $1.charmaps.length - 1; _2R <= _2Q; _2R += 1) { /*2734*/
			$1.i = _2R; /*2727*/
			$1.encs = $get($1.charmaps, $1.i); /*2728*/
			for (var _2V = 0; _2V <= 2; _2V += 1) { /*2733*/
				$1.j = _2V; /*2730*/
				var _2Y = $get($1.encs, $1.j); /*2731*/
				$k[$j++] = _2Y; /*2731*/
				if ($eq($type(_2Y), "stringtype")) { /*2731*/
					var _2b = $get($k[--$j], 0); /*2731*/
					$k[$j++] = _2b; /*2731*/
				} /*2731*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*2732*/
			} /*2732*/
		} /*2732*/
		$1.seta = $get($1.charvals, 0); /*2735*/
		$1.setb = $get($1.charvals, 1); /*2736*/
		$1.setc = $get($1.charvals, 2); /*2737*/
		$put($1.seta, $1.lka, $get($1.seta, $1.swb)); /*2740*/
		$put($1.seta, $1.lkc, $get($1.seta, $1.swc)); /*2740*/
		$put($1.setb, $1.lka, $get($1.setb, $1.swc)); /*2741*/
		$put($1.setb, $1.lkc, $get($1.setb, $1.swa)); /*2741*/
		$put($1.setc, $1.lka, $get($1.setc, $1.swa)); /*2742*/
		$put($1.setc, $1.lkc, $get($1.setc, $1.swb)); /*2742*/
		if ($1.raw) { /*2744*/
			$1.encoding = "raw"; /*2744*/
		} /*2744*/
		if ($eq($1.encoding, "raw")) { /*2758*/
			$1.cws = $a($1.barlen); /*2747*/
			$1.i = 0; /*2748*/
			$1.j = 0; /*2748*/
			for (;;) { /*2755*/
				if ($1.i == $1.barlen) { /*2750*/
					break; /*2750*/
				} /*2750*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*2751*/
				$put($1.cws, $1.j, $1.cw); /*2752*/
				$1.i = $1.i + 4; /*2753*/
				$1.j = $1.j + 1; /*2754*/
			} /*2754*/
			$1.cws = $geti($1.cws, 0, $1.j); /*2756*/
			$1.text = ""; /*2757*/
		} /*2757*/
		if ($eq($1.encoding, "auto")) { /*3008*/
			var _3e = {
				FNC1: $1.fn1,
				FNC2: $1.fn2,
				FNC3: $1.fn3,
				LNKA: $1.lka,
				LNKC: $1.lkc
			}; /*2768*/
			$1.fncvals = _3e; /*2769*/
			$1.msg = $a($1.barlen); /*2772*/
			$1.text = $s($1.barlen); /*2773*/
			$1.i = 0; /*2774*/
			$1.j = 0; /*2774*/
			for (;;) { /*2790*/
				if ($1.i == $1.barlen) { /*2775*/
					break; /*2775*/
				} /*2775*/
				$1.char = $get($1.barcode, $1.i); /*2776*/
				$put($1.text, $1.j, $1.char); /*2777*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*2786*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*2784*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*2780*/
						$puti($1.text, $1.j, " "); /*2781*/
						$1.i = $1.i + 4; /*2782*/
					} else { /*2784*/
						$1.i = $1.i + 1; /*2784*/
					} /*2784*/
				} /*2784*/
				$put($1.msg, $1.j, $1.char); /*2787*/
				$1.i = $1.i + 1; /*2788*/
				$1.j = $1.j + 1; /*2789*/
			} /*2789*/
			$1.msg = $geti($1.msg, 0, $1.j); /*2791*/
			$1.msglen = $1.msg.length; /*2792*/
			$1.text = $geti($1.text, 0, $1.j); /*2793*/
			$k[$j++] = Infinity; /*2796*/
			for (var _4K = 0, _4L = $1.msglen; _4K < _4L; _4K++) { /*2796*/
				$k[$j++] = 0; /*2796*/
			} /*2796*/
			$k[$j++] = 0; /*2796*/
			$1.numSA = $a(); /*2796*/
			$k[$j++] = Infinity; /*2797*/
			for (var _4O = 0, _4P = $1.msglen; _4O < _4P; _4O++) { /*2797*/
				$k[$j++] = 0; /*2797*/
			} /*2797*/
			$k[$j++] = 0; /*2797*/
			$1.numEA = $a(); /*2797*/
			for (var _4S = $1.msglen - 1; _4S >= 0; _4S -= 1) { /*2807*/
				$1.i = _4S; /*2799*/
				if ($get($1.msg, $1.i) >= 0) { /*2806*/
					if ($get($1.msg, $1.i) >= 128) { /*2804*/
						$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*2802*/
					} else { /*2804*/
						$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*2804*/
					} /*2804*/
				} /*2804*/
			} /*2804*/
			$1.ea = false; /*2810*/
			$1.msgtmp = $a([]); /*2810*/
			for (var _4m = 0, _4l = $1.msglen - 1; _4m <= _4l; _4m += 1) { /*2825*/
				$1.i = _4m; /*2812*/
				$1.c = $get($1.msg, $1.i); /*2813*/
				if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*2823*/
					if ($1.ea) { /*2815*/
						$k[$j++] = $1.numSA; /*2815*/
					} else { /*2815*/
						$k[$j++] = $1.numEA; /*2815*/
					} /*2815*/
					var _4y = $get($k[--$j], $1.i); /*2815*/
					var _51 = ((_4y + $1.i) == $1.msglen) ? 3 : 5; /*2816*/
					if (_4y < _51) { /*2821*/
						$k[$j++] = Infinity; /*2818*/
						$aload($1.msgtmp); /*2818*/
						$k[$j++] = $1.fn4; /*2818*/
						$1.msgtmp = $a(); /*2818*/
					} else { /*2821*/
						$k[$j++] = Infinity; /*2820*/
						$aload($1.msgtmp); /*2820*/
						$k[$j++] = $1.fn4; /*2820*/
						$k[$j++] = $1.fn4; /*2820*/
						$1.msgtmp = $a(); /*2820*/
						$1.ea = !$1.ea; /*2821*/
					} /*2821*/
				} /*2821*/
				$k[$j++] = Infinity; /*2824*/
				$aload($1.msgtmp); /*2824*/
				if ($1.c >= 0) { /*2824*/
					$k[$j++] = $1.c & 127; /*2824*/
				} else { /*2824*/
					$k[$j++] = $1.c; /*2824*/
				} /*2824*/
				$1.msgtmp = $a(); /*2824*/
			} /*2824*/
			$1.msg = $1.msgtmp; /*2826*/
			$1.msglen = $1.msg.length; /*2827*/
			$1.numsscr = function() {
				$1.n = 0; /*2831*/
				$1.s = 0; /*2831*/
				$1.p = $k[--$j]; /*2832*/
				for (;;) { /*2843*/
					if ($1.p >= $1.msglen) { /*2833*/
						break; /*2833*/
					} /*2833*/
					var _5M = $get($1.msg, $1.p); /*2834*/
					var _5O = $get($1.setc, _5M) !== undefined; /*2835*/
					$k[$j++] = _5M; /*2835*/
					if (!_5O) { /*2835*/
						$j--; /*2835*/
						break; /*2835*/
					} /*2835*/
					if ($k[--$j] == $1.fn1) { /*2839*/
						if (($1.s % 2) == 0) { /*2838*/
							$1.s = $1.s + 1; /*2838*/
						} else { /*2838*/
							break; /*2838*/
						} /*2838*/
					} /*2838*/
					$1.n = $1.n + 1; /*2840*/
					$1.s = $1.s + 1; /*2841*/
					$1.p = $1.p + 1; /*2842*/
				} /*2842*/
				$k[$j++] = $1.n; /*2844*/
				$k[$j++] = $1.s; /*2844*/
			}; /*2845*/
			$1.enca = function() {
				$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*2849*/
				$1.j = $1.j + 1; /*2850*/
			}; /*2851*/
			$1.encb = function() {
				$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*2853*/
				$1.j = $1.j + 1; /*2854*/
			}; /*2855*/
			$1.encc = function() {
				var _5k = $k[--$j]; /*2857*/
				$k[$j++] = _5k; /*2861*/
				if ($ne($type(_5k), "arraytype")) { /*2860*/
					var _5o = $get($1.setc, $k[--$j]); /*2858*/
					$k[$j++] = _5o; /*2858*/
				} else { /*2860*/
					$aload($k[--$j]); /*2860*/
					var _5q = $k[--$j]; /*2860*/
					var _5r = $k[--$j]; /*2860*/
					$k[$j++] = (_5q - 48) + ((_5r - 48) * 10); /*2860*/
				} /*2860*/
				$put($1.cws, $1.j, $k[--$j]); /*2862*/
				$1.j = $1.j + 1; /*2863*/
			}; /*2864*/
			$1.anotb = function() {
				var _5w = $k[--$j]; /*2867*/
				var _5y = $get($1.seta, _5w) !== undefined; /*2867*/
				var _60 = $get($1.setb, _5w) !== undefined; /*2867*/
				$k[$j++] = _5y && (!_60); /*2867*/
			}; /*2867*/
			$1.bnota = function() {
				var _61 = $k[--$j]; /*2868*/
				var _63 = $get($1.setb, _61) !== undefined; /*2868*/
				var _65 = $get($1.seta, _61) !== undefined; /*2868*/
				$k[$j++] = _63 && (!_65); /*2868*/
			}; /*2868*/
			$k[$j++] = Infinity; /*2871*/
			for (var _67 = 0, _68 = $1.msg.length; _67 < _68; _67++) { /*2871*/
				$k[$j++] = 0; /*2871*/
			} /*2871*/
			$k[$j++] = 9999; /*2871*/
			$1.nextanotb = $a(); /*2871*/
			$k[$j++] = Infinity; /*2872*/
			for (var _6B = 0, _6C = $1.msg.length; _6B < _6C; _6B++) { /*2872*/
				$k[$j++] = 0; /*2872*/
			} /*2872*/
			$k[$j++] = 9999; /*2872*/
			$1.nextbnota = $a(); /*2872*/
			for (var _6F = $1.msg.length - 1; _6F >= 0; _6F -= 1) { /*2885*/
				$1.i = _6F; /*2874*/
				$k[$j++] = $get($1.msg, $1.i); /*2875*/
				$1.anotb(); /*2875*/
				if ($k[--$j]) { /*2878*/
					$put($1.nextanotb, $1.i, 0); /*2876*/
				} else { /*2878*/
					$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*2878*/
				} /*2878*/
				$k[$j++] = $get($1.msg, $1.i); /*2880*/
				$1.bnota(); /*2880*/
				if ($k[--$j]) { /*2883*/
					$put($1.nextbnota, $1.i, 0); /*2881*/
				} else { /*2883*/
					$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*2883*/
				} /*2883*/
			} /*2883*/
			$1.abeforeb = function() {
				var _6c = $k[--$j]; /*2888*/
				$k[$j++] = $lt($get($1.nextanotb, _6c), $get($1.nextbnota, _6c)); /*2888*/
			}; /*2888*/
			$1.bbeforea = function() {
				var _6h = $k[--$j]; /*2889*/
				$k[$j++] = $lt($get($1.nextbnota, _6h), $get($1.nextanotb, _6h)); /*2889*/
			}; /*2889*/
			$1.cws = $a(($1.barcode.length * 2) + 3); /*2891*/
			$1.j = 0; /*2894*/
			if ($1.msglen > 0) { /*2895*/
				$k[$j++] = 0; /*2895*/
				$1.numsscr(); /*2895*/
			} else { /*2895*/
				$k[$j++] = -1; /*2895*/
				$k[$j++] = -1; /*2895*/
			} /*2895*/
			$1.nums = $k[--$j]; /*2895*/
			$1.nchars = $k[--$j]; /*2895*/
			for (;;) { /*2920*/
				if ($1.msglen == 0) { /*2901*/
					$k[$j++] = $1.stb; /*2898*/
					$1.enca(); /*2898*/
					$1.cset = "setb"; /*2899*/
					break; /*2900*/
				} /*2900*/
				if (($1.msglen == 2) && ($1.nums == 2)) { /*2906*/
					$k[$j++] = $1.stc; /*2903*/
					$1.enca(); /*2903*/
					$1.cset = "setc"; /*2904*/
					break; /*2905*/
				} /*2905*/
				if ($1.nums >= 4) { /*2911*/
					$k[$j++] = $1.stc; /*2908*/
					$1.enca(); /*2908*/
					$1.cset = "setc"; /*2909*/
					break; /*2910*/
				} /*2910*/
				$k[$j++] = 0; /*2912*/
				$1.abeforeb(); /*2912*/
				if ($k[--$j]) { /*2916*/
					$k[$j++] = $1.sta; /*2913*/
					$1.enca(); /*2913*/
					$1.cset = "seta"; /*2914*/
					break; /*2915*/
				} /*2915*/
				$k[$j++] = $1.stb; /*2917*/
				$1.enca(); /*2917*/
				$1.cset = "setb"; /*2918*/
				break; /*2919*/
			} /*2919*/
			$1.i = 0; /*2923*/
			for (;;) { /*3006*/
				if ($1.i == $1.msglen) { /*2924*/
					break; /*2924*/
				} /*2924*/
				$k[$j++] = $1.i; /*2926*/
				$1.numsscr(); /*2926*/
				$1.nums = $k[--$j]; /*2926*/
				$1.nchars = $k[--$j]; /*2926*/
				for (;;) { /*3004*/
					if ((($eq($1.cset, "seta") || $eq($1.cset, "setb")) && ($1.nums >= 4)) && ($get($1.msg, $1.i) != $1.fn1)) { /*2943*/
						if (($1.nums % 2) == 0) { /*2941*/
							$k[$j++] = $1.swc; /*2933*/
							if ($eq($1.cset, "seta")) { /*2933*/
								$1.enca(); /*2933*/
							} else { /*2933*/
								$1.encb(); /*2933*/
							} /*2933*/
							$1.cset = "setc"; /*2934*/
							break; /*2935*/
						} else { /*2941*/
							$k[$j++] = $get($1.msg, $1.i); /*2937*/
							if ($eq($1.cset, "seta")) { /*2937*/
								$1.enca(); /*2937*/
							} else { /*2937*/
								$1.encb(); /*2937*/
							} /*2937*/
							$1.i = $1.i + 1; /*2938*/
							$k[$j++] = $1.swc; /*2939*/
							if ($eq($1.cset, "seta")) { /*2939*/
								$1.enca(); /*2939*/
							} else { /*2939*/
								$1.encb(); /*2939*/
							} /*2939*/
							$1.cset = "setc"; /*2940*/
							break; /*2941*/
						} /*2941*/
					} /*2941*/
					$k[$j++] = $eq($1.cset, "setb"); /*2944*/
					$k[$j++] = $get($1.msg, $1.i); /*2944*/
					$1.anotb(); /*2944*/
					var _7R = $k[--$j]; /*2944*/
					if (($k[--$j] && _7R)) { /*2956*/
						if ($1.i < ($1.msglen - 1)) { /*2952*/
							$k[$j++] = $1.i + 1; /*2946*/
							$1.bbeforea(); /*2946*/
							if ($k[--$j]) { /*2951*/
								$k[$j++] = $1.sft; /*2947*/
								$1.encb(); /*2947*/
								$k[$j++] = $get($1.msg, $1.i); /*2948*/
								$1.enca(); /*2948*/
								$1.i = $1.i + 1; /*2949*/
								break; /*2950*/
							} /*2950*/
						} /*2950*/
						$k[$j++] = $1.swa; /*2953*/
						$1.encb(); /*2953*/
						$1.cset = "seta"; /*2954*/
						break; /*2955*/
					} /*2955*/
					$k[$j++] = $eq($1.cset, "seta"); /*2957*/
					$k[$j++] = $get($1.msg, $1.i); /*2957*/
					$1.bnota(); /*2957*/
					var _7h = $k[--$j]; /*2957*/
					if (($k[--$j] && _7h)) { /*2969*/
						if ($1.i < ($1.msglen - 1)) { /*2965*/
							$k[$j++] = $1.i + 1; /*2959*/
							$1.abeforeb(); /*2959*/
							if ($k[--$j]) { /*2964*/
								$k[$j++] = $1.sft; /*2960*/
								$1.enca(); /*2960*/
								$k[$j++] = $get($1.msg, $1.i); /*2961*/
								$1.encb(); /*2961*/
								$1.i = $1.i + 1; /*2962*/
								break; /*2963*/
							} /*2963*/
						} /*2963*/
						$k[$j++] = $1.swb; /*2966*/
						$1.enca(); /*2966*/
						$1.cset = "setb"; /*2967*/
						break; /*2968*/
					} /*2968*/
					if ($eq($1.cset, "setc") && ($1.nums < 2)) { /*2979*/
						$k[$j++] = $1.i; /*2971*/
						$1.abeforeb(); /*2971*/
						if ($k[--$j]) { /*2975*/
							$k[$j++] = $1.swa; /*2972*/
							$1.encc(); /*2972*/
							$1.cset = "seta"; /*2973*/
							break; /*2974*/
						} /*2974*/
						$k[$j++] = $1.swb; /*2976*/
						$1.encc(); /*2976*/
						$1.cset = "setb"; /*2977*/
						break; /*2978*/
					} /*2978*/
					if ($eq($1.cset, "seta")) { /*2986*/
						$k[$j++] = $get($1.msg, $1.i); /*2983*/
						$1.enca(); /*2983*/
						$1.i = $1.i + 1; /*2984*/
						break; /*2985*/
					} /*2985*/
					if ($eq($1.cset, "setb")) { /*2991*/
						$k[$j++] = $get($1.msg, $1.i); /*2988*/
						$1.encb(); /*2988*/
						$1.i = $1.i + 1; /*2989*/
						break; /*2990*/
					} /*2990*/
					if ($eq($1.cset, "setc")) { /*3001*/
						if ($get($1.msg, $1.i) == $1.fn1) { /*2998*/
							$k[$j++] = $1.fn1; /*2994*/
							$1.encc(); /*2994*/
							$1.i = $1.i + 1; /*2995*/
						} else { /*2998*/
							$k[$j++] = $geti($1.msg, $1.i, 2); /*2997*/
							$1.encc(); /*2997*/
							$1.i = $1.i + 2; /*2998*/
						} /*2998*/
						break; /*3000*/
					} /*3000*/
					break; /*3003*/
				} /*3003*/
			} /*3003*/
			$1.cws = $geti($1.cws, 0, $1.j); /*3007*/
		} /*3007*/
		var _8O = $a($1.j + 2); /*3011*/
		$puti(_8O, 0, $1.cws); /*3011*/
		$1.cws = _8O; /*3011*/
		$1.csum = $get($1.cws, 0); /*3012*/
		for (var _8U = 1, _8T = $1.j - 1; _8U <= _8T; _8U += 1) { /*3016*/
			$1.i = _8U; /*3014*/
			$1.csum = $1.csum + ($get($1.cws, $1.i) * $1.i); /*3015*/
		} /*3015*/
		$1.csum = $1.csum % 103; /*3017*/
		$put($1.cws, $1.j, $1.csum); /*3018*/
		$put($1.cws, $1.j + 1, $get($1.seta, $1.stp)); /*3019*/
		$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "211214", "211232", "2331112"]); /*3039*/
		$1.sbs = $s(($1.cws.length * 6) + 1); /*3042*/
		for (var _8o = 0, _8n = $1.cws.length - 1; _8o <= _8n; _8o += 1) { /*3046*/
			$1.i = _8o; /*3044*/
			$puti($1.sbs, $1.i * 6, $get($1.encs, $get($1.cws, $1.i))); /*3045*/
		} /*3045*/
		$k[$j++] = Infinity; /*3056*/
		$k[$j++] = "ren"; /*3052*/
		$k[$j++] = $0.renlinear; /*3052*/
		$k[$j++] = "sbs"; /*3052*/
		$k[$j++] = Infinity; /*3052*/
		var _8w = $1.sbs; /*3051*/
		for (var _8x = 0, _8y = _8w.length; _8x < _8y; _8x++) { /*3051*/
			$k[$j++] = $get(_8w, _8x) - 48; /*3051*/
		} /*3051*/
		var _90 = $a(); /*3052*/
		$k[$j++] = _90; /*3053*/
		$k[$j++] = "bhs"; /*3053*/
		$k[$j++] = Infinity; /*3053*/
		for (var _92 = 0, _93 = ~~(($1.sbs.length + 1) / 2); _92 < _93; _92++) { /*3052*/
			$k[$j++] = $1.height; /*3052*/
		} /*3052*/
		var _95 = $a(); /*3053*/
		$k[$j++] = _95; /*3054*/
		$k[$j++] = "bbs"; /*3054*/
		$k[$j++] = Infinity; /*3054*/
		for (var _97 = 0, _98 = ~~(($1.sbs.length + 1) / 2); _97 < _98; _97++) { /*3053*/
			$k[$j++] = 0; /*3053*/
		} /*3053*/
		var _99 = $a(); /*3054*/
		$k[$j++] = _99; /*3056*/
		$k[$j++] = "txt"; /*3056*/
		$k[$j++] = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3056*/
		$k[$j++] = "textxalign"; /*3056*/
		$k[$j++] = "center"; /*3056*/
		$k[$j++] = "opt"; /*3056*/
		$k[$j++] = $1.options; /*3056*/
		var _9I = $d(); /*3056*/
		$k[$j++] = _9I; /*3059*/
		if (!$1.dontdraw) { /*3059*/
			$0.renlinear(); /*3059*/
		} /*3059*/
	};
	$0["gs1-128"] = function() {
		var $1 = {}; /*3087*/
		$1.options = $k[--$j]; /*3089*/
		$1.barcode = $k[--$j]; /*3090*/
		$1.dontdraw = false; /*3092*/
		$1.includetext = false; /*3093*/
		$1.textfont = "Courier"; /*3094*/
		$1.textsize = 10; /*3095*/
		$1.textxoffset = 0; /*3096*/
		$1.textyoffset = -8.5; /*3097*/
		$1.height = 0.5; /*3098*/
		$1.linkagea = false; /*3099*/
		$1.linkagec = false; /*3100*/
		$forall($1.options, function() { /*3111*/
			var _3 = $k[--$j]; /*3111*/
			$1[$k[--$j]] = _3; /*3111*/
		}); /*3111*/
		$1.textfont = "" + $1.textfont; /*3113*/
		$1.textsize = +$1.textsize; /*3114*/
		$1.textxoffset = +$1.textxoffset; /*3115*/
		$1.textyoffset = +$1.textyoffset; /*3116*/
		$1.height = +$1.height; /*3117*/
		$1.text = $1.barcode; /*3119*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*3123*/
			$1.out = $s($1.in.length); /*3124*/
			$1.j = 0; /*3125*/
			$k[$j++] = $1.in; /*3139*/
			for (;;) { /*3139*/
				$search($k[--$j], "^"); /*3128*/
				if ($k[--$j]) { /*3137*/
					var _H = $k[--$j]; /*3129*/
					$puti($1.out, $1.j, _H); /*3129*/
					$1.j = (_H.length + $1.j) + 1; /*3130*/
					$j--; /*3131*/
					var _L = $k[--$j]; /*3132*/
					$put($1.out, $1.j - 1, ~~$z($geti(_L, 0, 3))); /*3132*/
					$k[$j++] = $geti(_L, 3, _L.length - 3); /*3133*/
				} else { /*3137*/
					var _Q = $k[--$j]; /*3135*/
					$puti($1.out, $1.j, _Q); /*3135*/
					$1.j = _Q.length + $1.j; /*3136*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*3137*/
					break; /*3137*/
				} /*3137*/
			} /*3137*/
		}; /*3140*/
		$1.ais = $a([]); /*3143*/
		$1.aival = {}; /*3144*/
		var _Y = $1.barcode; /*3145*/
		$k[$j++] = $geti(_Y, 1, _Y.length - 1); /*3157*/
		for (;;) { /*3157*/
			var _a = $k[--$j]; /*3147*/
			$k[$j++] = _a; /*3147*/
			if ($eq(_a, "")) { /*3147*/
				break; /*3147*/
			} /*3147*/
			$search($k[--$j], ")"); /*3148*/
			$j--; /*3148*/
			var _c = $k[--$j]; /*3149*/
			var _d = $k[--$j]; /*3149*/
			var _e = $k[--$j]; /*3150*/
			$k[$j++] = _c; /*3150*/
			$search(_e, "("); /*3150*/
			if ($k[--$j]) { /*3153*/
				var _g = $k[--$j]; /*3151*/
				var _h = $k[--$j]; /*3151*/
				var _i = $k[--$j]; /*3151*/
				var _j = $k[--$j]; /*3151*/
				$k[$j++] = _i; /*3151*/
				$k[$j++] = _j; /*3151*/
				$k[$j++] = _g; /*3151*/
			} else { /*3153*/
				var _k = $k[--$j]; /*3153*/
				var _l = $k[--$j]; /*3153*/
				$k[$j++] = ""; /*3153*/
				$k[$j++] = _l; /*3153*/
				$k[$j++] = _k; /*3153*/
			} /*3153*/
			$k[$j++] = Infinity; /*3155*/
			$aload($1.ais); /*3155*/
			var _o = $k[$j - 1 - ($counttomark() + 2)]; /*3155*/
			$k[$j++] = _o; /*3155*/
			$1.ais = $a(); /*3155*/
			var _r = $k[--$j]; /*3156*/
			var _s = $k[--$j]; /*3156*/
			$k[$j++] = $1.aival; /*3156*/
			$k[$j++] = _s; /*3156*/
			$k[$j++] = _r; /*3156*/
			$1.expand(); /*3156*/
			var _t = $k[--$j]; /*3156*/
			var _u = $k[--$j]; /*3156*/
			$put($k[--$j], _u, _t); /*3156*/
		} /*3156*/
		$j--; /*3158*/
		$1.aifixed = {}; /*3163*/
		$k[$j++] = Infinity; /*3165*/
		for (var _w = 0; _w <= 4; _w += 1) { /*3165*/
			$k[$j++] = _w; /*3165*/
		} /*3165*/
		var _x = $a(); /*3165*/
		for (var _y = 0, _z = _x.length; _y < _z; _y++) { /*3168*/
			var _12 = $strcpy($s(2), "00"); /*3167*/
			$put(_12, 1, $get(_x, _y) + 48); /*3167*/
			$put($1.aifixed, _12, _12); /*3167*/
		} /*3167*/
		$k[$j++] = Infinity; /*3173*/
		for (var _14 = 11; _14 <= 20; _14 += 1) { /*3170*/
			$k[$j++] = _14; /*3170*/
		} /*3170*/
		$k[$j++] = 23; /*3172*/
		for (var _15 = 31; _15 <= 36; _15 += 1) { /*3172*/
			$k[$j++] = _15; /*3172*/
		} /*3172*/
		$k[$j++] = 41; /*3173*/
		var _16 = $a(); /*3173*/
		for (var _17 = 0, _18 = _16.length; _17 < _18; _17++) { /*3176*/
			var _1B = $cvrs($s(2), $get(_16, _17), 10); /*3175*/
			$put($1.aifixed, _1B, _1B); /*3175*/
		} /*3175*/
		$1.fnc1 = -1; /*3179*/
		$1.c128 = $a([$1.fnc1]); /*3180*/
		for (var _1H = 0, _1G = $1.ais.length - 1; _1H <= _1G; _1H += 1) { /*3196*/
			$1.i = _1H; /*3182*/
			$1.ai = $get($1.ais, $1.i); /*3183*/
			$1.val = $get($1.aival, $1.ai); /*3184*/
			var _1R = $a(($1.c128.length + $1.ai.length) + $1.val.length); /*3185*/
			$puti(_1R, 0, $1.c128); /*3186*/
			$k[$j++] = _1R; /*3187*/
			$k[$j++] = _1R; /*3187*/
			$k[$j++] = $1.c128.length; /*3187*/
			$k[$j++] = $1.ai; /*3187*/
			$k[$j++] = Infinity; /*3187*/
			var _1V = $k[--$j]; /*3187*/
			var _1W = $k[--$j]; /*3187*/
			$k[$j++] = _1V; /*3187*/
			$forall(_1W); /*3187*/
			var _1X = $a(); /*3187*/
			var _1Y = $k[--$j]; /*3187*/
			$puti($k[--$j], _1Y, _1X); /*3187*/
			var _1a = $k[--$j]; /*3188*/
			$k[$j++] = _1a; /*3188*/
			$k[$j++] = _1a; /*3188*/
			$k[$j++] = $1.c128.length + $1.ai.length; /*3188*/
			$k[$j++] = $1.val; /*3188*/
			$k[$j++] = Infinity; /*3188*/
			var _1e = $k[--$j]; /*3188*/
			var _1f = $k[--$j]; /*3188*/
			$k[$j++] = _1e; /*3188*/
			$forall(_1f); /*3188*/
			var _1g = $a(); /*3188*/
			var _1h = $k[--$j]; /*3188*/
			$puti($k[--$j], _1h, _1g); /*3188*/
			$1.c128 = $k[--$j]; /*3189*/
			var _1p = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*3190*/
			if (($1.i != ($1.ais.length - 1)) && (!_1p)) { /*3195*/
				var _1r = $a($1.c128.length + 1); /*3191*/
				$puti(_1r, 0, $1.c128); /*3192*/
				$put(_1r, $1.c128.length, $1.fnc1); /*3193*/
				$1.c128 = _1r; /*3194*/
			} /*3194*/
		} /*3194*/
		$1.barcode = $s(($1.c128.length + 1) * 5); /*3199*/
		$1.i = 0; /*3200*/
		$1.j = 0; /*3200*/
		for (;;) { /*3210*/
			if ($1.i == $1.c128.length) { /*3201*/
				break; /*3201*/
			} /*3201*/
			var _21 = $get($1.c128, $1.i); /*3202*/
			$k[$j++] = _21; /*3207*/
			if (_21 == $1.fnc1) { /*3206*/
				$j--; /*3203*/
				$puti($1.barcode, $1.j, "^FNC1"); /*3203*/
				$1.j = $1.j + 4; /*3204*/
			} else { /*3206*/
				$put($1.barcode, $1.j, $k[--$j]); /*3206*/
			} /*3206*/
			$1.i = $1.i + 1; /*3208*/
			$1.j = $1.j + 1; /*3209*/
		} /*3209*/
		if ($1.linkagea || $1.linkagec) { /*3214*/
			$k[$j++] = $1.barcode; /*3212*/
			$k[$j++] = $1.j; /*3212*/
			if ($1.linkagea) { /*3212*/
				$k[$j++] = "^LNKA"; /*3212*/
			} else { /*3212*/
				$k[$j++] = "^LNKC"; /*3212*/
			} /*3212*/
			var _2G = $k[--$j]; /*3212*/
			var _2H = $k[--$j]; /*3212*/
			$puti($k[--$j], _2H, _2G); /*3212*/
			$1.j = $1.j + 5; /*3213*/
		} /*3213*/
		$1.barcode = $geti($1.barcode, 0, $1.j); /*3215*/
		$1.options.height = $1.height; /*3218*/
		$1.options.dontdraw = true; /*3219*/
		$1.options.parsefnc = true; /*3220*/
		$k[$j++] = "args"; /*3221*/
		$k[$j++] = $1.barcode; /*3221*/
		$k[$j++] = $1.options; /*3221*/
		$0.code128(); /*3221*/
		var _2T = $k[--$j]; /*3221*/
		$1[$k[--$j]] = _2T; /*3221*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3223*/
		$1.args.textxalign = "center"; /*3224*/
		$1.args.opt = $1.options; /*3225*/
		$k[$j++] = $1.args; /*3228*/
		if (!$1.dontdraw) { /*3228*/
			$0.renlinear(); /*3228*/
		} /*3228*/
	};
	$0.ean14 = function() {
		var $1 = {}; /*3256*/
		$1.options = $k[--$j]; /*3258*/
		$1.barcode = $k[--$j]; /*3259*/
		$1.dontdraw = false; /*3261*/
		$1.includetext = false; /*3262*/
		$1.textfont = "Courier"; /*3263*/
		$1.textsize = 10; /*3264*/
		$1.textxoffset = 0; /*3265*/
		$1.textyoffset = -8.5; /*3266*/
		$1.height = 1; /*3267*/
		$forall($1.options, function() { /*3278*/
			var _3 = $k[--$j]; /*3278*/
			$1[$k[--$j]] = _3; /*3278*/
		}); /*3278*/
		$1.textfont = "" + $1.textfont; /*3280*/
		$1.textsize = +$1.textsize; /*3281*/
		$1.textxoffset = +$1.textxoffset; /*3282*/
		$1.textyoffset = +$1.textyoffset; /*3283*/
		$1.height = +$1.height; /*3284*/
		$1.text = $1.barcode; /*3287*/
		var _B = $1.barcode; /*3288*/
		$k[$j++] = $s(_B.length); /*3289*/
		$k[$j++] = 0; /*3289*/
		$forall(_B, function() { /*3289*/
			var _D = $k[--$j]; /*3289*/
			$k[$j++] = _D; /*3289*/
			if (_D != 32) { /*3289*/
				var _E = $k[--$j]; /*3289*/
				var _F = $k[--$j]; /*3289*/
				var _G = $k[--$j]; /*3289*/
				$put(_G, _F, _E); /*3289*/
				$k[$j++] = _G; /*3289*/
				$k[$j++] = _F + 1; /*3289*/
			} else { /*3289*/
				$j--; /*3289*/
			} /*3289*/
		}); /*3289*/
		var _H = $k[--$j]; /*3290*/
		$1.barcode = $geti($k[--$j], 0, _H); /*3290*/
		$1.hasspace = $1.text.length != $1.barcode.length; /*3291*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*3296*/
			$k[$j++] = "bwipp.ean14badAI"; /*3295*/
			$k[$j++] = "GS1-14 must begin with (01) application identifier"; /*3295*/
			$0.raiseerror(); /*3295*/
		} /*3295*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*3299*/
			$k[$j++] = "bwipp.ean14badLength"; /*3298*/
			$k[$j++] = "GS1-14 must be 13 or 14 digits"; /*3298*/
			$0.raiseerror(); /*3298*/
		} /*3298*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*3304*/
			var _T = $k[--$j]; /*3301*/
			if ((_T < 48) || (_T > 57)) { /*3303*/
				$k[$j++] = "bwipp.ean14badCharacter"; /*3302*/
				$k[$j++] = "GS1-14 must contain only digits"; /*3302*/
				$0.raiseerror(); /*3302*/
			} /*3302*/
		}); /*3302*/
		$1.checksum = 0; /*3307*/
		for (var _U = 0; _U <= 12; _U += 1) { /*3311*/
			$1.i = _U; /*3309*/
			$k[$j++] = "checksum"; /*3310*/
			$k[$j++] = $1.checksum; /*3310*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*3310*/
			if (($1.i % 2) == 0) { /*3310*/
				var _a = $k[--$j]; /*3310*/
				$k[$j++] = _a * 3; /*3310*/
			} /*3310*/
			var _b = $k[--$j]; /*3310*/
			var _c = $k[--$j]; /*3310*/
			$1[$k[--$j]] = _c + _b; /*3310*/
		} /*3310*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*3312*/
		if ($1.barcode.length == 18) { /*3326*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*3316*/
				$k[$j++] = "bwipp.ean14badCheckDigit"; /*3315*/
				$k[$j++] = "Incorrect GS1-14 check digit provided"; /*3315*/
				$0.raiseerror(); /*3315*/
			} /*3315*/
		} else { /*3326*/
			var _j = $s(18); /*3318*/
			$puti(_j, 0, $1.barcode); /*3319*/
			$put(_j, 17, $1.checksum + 48); /*3320*/
			$1.barcode = _j; /*3321*/
			var _o = $1.hasspace ? 2 : 1; /*3322*/
			var _p = $s($1.text.length + _o); /*3322*/
			$puti(_p, _p.length - 2, " "); /*3323*/
			$put(_p, _p.length - 1, $1.checksum + 48); /*3324*/
			$puti(_p, 0, $1.text); /*3325*/
			$1.text = _p; /*3326*/
		} /*3326*/
		$1.gtin = $geti($1.barcode, 4, 14); /*3328*/
		$1.barcode = $s(21); /*3331*/
		$puti($1.barcode, 0, "^FNC101"); /*3332*/
		$puti($1.barcode, 7, $1.gtin); /*3333*/
		$1.options.dontdraw = true; /*3336*/
		$1.options.parsefnc = true; /*3337*/
		$k[$j++] = "args"; /*3338*/
		$k[$j++] = $1.barcode; /*3338*/
		$k[$j++] = $1.options; /*3338*/
		$0.code128(); /*3338*/
		var _12 = $k[--$j]; /*3338*/
		$1[$k[--$j]] = _12; /*3338*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3340*/
		$1.args.textxalign = "center"; /*3341*/
		$1.args.opt = $1.options; /*3342*/
		$k[$j++] = $1.args; /*3345*/
		if (!$1.dontdraw) { /*3345*/
			$0.renlinear(); /*3345*/
		} /*3345*/
	};
	$0.sscc18 = function() {
		var $1 = {}; /*3373*/
		$1.options = $k[--$j]; /*3375*/
		$1.barcode = $k[--$j]; /*3376*/
		$1.dontdraw = false; /*3378*/
		$1.includetext = false; /*3379*/
		$1.textfont = "Courier"; /*3380*/
		$1.textsize = 10; /*3381*/
		$1.textxoffset = 0; /*3382*/
		$1.textyoffset = -8.5; /*3383*/
		$1.height = 1; /*3384*/
		$forall($1.options, function() { /*3395*/
			var _3 = $k[--$j]; /*3395*/
			$1[$k[--$j]] = _3; /*3395*/
		}); /*3395*/
		$1.textfont = "" + $1.textfont; /*3397*/
		$1.textsize = +$1.textsize; /*3398*/
		$1.textxoffset = +$1.textxoffset; /*3399*/
		$1.textyoffset = +$1.textyoffset; /*3400*/
		$1.height = +$1.height; /*3401*/
		$1.text = $1.barcode; /*3404*/
		var _B = $1.barcode; /*3405*/
		$k[$j++] = $s(_B.length); /*3406*/
		$k[$j++] = 0; /*3406*/
		$forall(_B, function() { /*3406*/
			var _D = $k[--$j]; /*3406*/
			$k[$j++] = _D; /*3406*/
			if (_D != 32) { /*3406*/
				var _E = $k[--$j]; /*3406*/
				var _F = $k[--$j]; /*3406*/
				var _G = $k[--$j]; /*3406*/
				$put(_G, _F, _E); /*3406*/
				$k[$j++] = _G; /*3406*/
				$k[$j++] = _F + 1; /*3406*/
			} else { /*3406*/
				$j--; /*3406*/
			} /*3406*/
		}); /*3406*/
		var _H = $k[--$j]; /*3407*/
		$1.barcode = $geti($k[--$j], 0, _H); /*3407*/
		$1.hasspace = $1.text.length != $1.barcode.length; /*3408*/
		if ($ne($geti($1.barcode, 0, 4), "(00)")) { /*3413*/
			$k[$j++] = "bwipp.sscc18badAI"; /*3412*/
			$k[$j++] = "SSCC-18 must begin with (00) application identifier"; /*3412*/
			$0.raiseerror(); /*3412*/
		} /*3412*/
		if (($1.barcode.length != 21) && ($1.barcode.length != 22)) { /*3416*/
			$k[$j++] = "bwipp.sscc18badLength"; /*3415*/
			$k[$j++] = "SSCC-18 must be 17 or 18 digits"; /*3415*/
			$0.raiseerror(); /*3415*/
		} /*3415*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*3421*/
			var _T = $k[--$j]; /*3418*/
			if ((_T < 48) || (_T > 57)) { /*3420*/
				$k[$j++] = "bwipp.sscc18badCharacter"; /*3419*/
				$k[$j++] = "SSCC-18 must contain only digits"; /*3419*/
				$0.raiseerror(); /*3419*/
			} /*3419*/
		}); /*3419*/
		$1.checksum = 0; /*3424*/
		for (var _U = 0; _U <= 16; _U += 1) { /*3428*/
			$1.i = _U; /*3426*/
			$k[$j++] = "checksum"; /*3427*/
			$k[$j++] = $1.checksum; /*3427*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*3427*/
			if (($1.i % 2) == 0) { /*3427*/
				var _a = $k[--$j]; /*3427*/
				$k[$j++] = _a * 3; /*3427*/
			} /*3427*/
			var _b = $k[--$j]; /*3427*/
			var _c = $k[--$j]; /*3427*/
			$1[$k[--$j]] = _c + _b; /*3427*/
		} /*3427*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*3429*/
		if ($1.barcode.length == 22) { /*3443*/
			if ($get($1.barcode, 21) != ($1.checksum + 48)) { /*3433*/
				$k[$j++] = "bwipp.sscc18badCheckDigit"; /*3432*/
				$k[$j++] = "Incorrect SSCC-18 check digit provided"; /*3432*/
				$0.raiseerror(); /*3432*/
			} /*3432*/
		} else { /*3443*/
			var _j = $s(22); /*3435*/
			$puti(_j, 0, $1.barcode); /*3436*/
			$put(_j, 21, $1.checksum + 48); /*3437*/
			$1.barcode = _j; /*3438*/
			var _o = $1.hasspace ? 2 : 1; /*3439*/
			var _p = $s($1.text.length + _o); /*3439*/
			$puti(_p, _p.length - 2, " "); /*3440*/
			$put(_p, _p.length - 1, $1.checksum + 48); /*3441*/
			$puti(_p, 0, $1.text); /*3442*/
			$1.text = _p; /*3443*/
		} /*3443*/
		$1.sscc = $geti($1.barcode, 4, 18); /*3445*/
		$1.barcode = $s(25); /*3448*/
		$puti($1.barcode, 0, "^FNC100"); /*3449*/
		$puti($1.barcode, 7, $1.sscc); /*3450*/
		$1.options.dontdraw = true; /*3453*/
		$1.options.parsefnc = true; /*3454*/
		$k[$j++] = "args"; /*3455*/
		$k[$j++] = $1.barcode; /*3455*/
		$k[$j++] = $1.options; /*3455*/
		$0.code128(); /*3455*/
		var _12 = $k[--$j]; /*3455*/
		$1[$k[--$j]] = _12; /*3455*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3457*/
		$1.args.textxalign = "center"; /*3458*/
		$1.args.opt = $1.options; /*3459*/
		$k[$j++] = $1.args; /*3462*/
		if (!$1.dontdraw) { /*3462*/
			$0.renlinear(); /*3462*/
		} /*3462*/
	};
	$0.code39 = function() {
		var $1 = {}; /*3489*/
		$1.options = $k[--$j]; /*3491*/
		$1.barcode = $k[--$j]; /*3492*/
		$1.dontdraw = false; /*3494*/
		$1.includecheck = false; /*3495*/
		$1.validatecheck = false; /*3496*/
		$1.includetext = false; /*3497*/
		$1.includecheckintext = false; /*3498*/
		$1.hidestars = false; /*3499*/
		$1.textfont = "Courier"; /*3500*/
		$1.textsize = 10; /*3501*/
		$1.textyoffset = -8.5; /*3502*/
		$1.height = 1; /*3503*/
		$forall($1.options, function() { /*3514*/
			var _3 = $k[--$j]; /*3514*/
			$1[$k[--$j]] = _3; /*3514*/
		}); /*3514*/
		$1.textfont = "" + $1.textfont; /*3516*/
		$1.textsize = +$1.textsize; /*3517*/
		$1.textyoffset = +$1.textyoffset; /*3518*/
		$1.height = +$1.height; /*3519*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*3522*/
		$1.charvals = {}; /*3523*/
		for (var _9 = 0; _9 <= 42; _9 += 1) { /*3524*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*3524*/
		} /*3524*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*3531*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*3528*/
			if (!_J) { /*3530*/
				$k[$j++] = "bwipp.code39badCharacter"; /*3529*/
				$k[$j++] = "Code 39 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*3529*/
				$0.raiseerror(); /*3529*/
			} /*3529*/
		} /*3529*/
		$k[$j++] = "barlen"; /*3533*/
		$k[$j++] = $1.barcode.length; /*3533*/
		if ($1.validatecheck) { /*3533*/
			var _M = $k[--$j]; /*3533*/
			$k[$j++] = _M - 1; /*3533*/
		} /*3533*/
		var _N = $k[--$j]; /*3533*/
		$1[$k[--$j]] = _N; /*3533*/
		$1.checksum = 0; /*3535*/
		for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*3539*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*3538*/
		} /*3538*/
		$1.checksum = $1.checksum % 43; /*3540*/
		if ($1.validatecheck) { /*3547*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*3544*/
				$k[$j++] = "bwipp.code39badCheckDigit"; /*3543*/
				$k[$j++] = "Incorrect Code 39 check digit provided"; /*3543*/
				$0.raiseerror(); /*3543*/
			} /*3543*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*3545*/
			$1.includecheck = true; /*3546*/
		} /*3546*/
		$1.encs = $a(["1113313111", "3113111131", "1133111131", "3133111111", "1113311131", "3113311111", "1133311111", "1113113131", "3113113111", "1133113111", "3111131131", "1131131131", "3131131111", "1111331131", "3111331111", "1131331111", "1111133131", "3111133111", "1131133111", "1111333111", "3111111331", "1131111331", "3131111311", "1111311331", "3111311311", "1131311311", "1111113331", "3111113311", "1131113311", "1111313311", "3311111131", "1331111131", "3331111111", "1311311131", "3311311111", "1331311111", "1311113131", "3311113111", "1331113111", "1313131111", "1313111311", "1311131311", "1113131311", "1311313111"]); /*3560*/
		var _l = $1.includecheck ? 3 : 2; /*3562*/
		$1.sbs = $s(($1.barlen + _l) * 10); /*3562*/
		var _p = $1.includecheck ? 3 : 2; /*3563*/
		$1.txt = $a($1.barlen + _p); /*3563*/
		$puti($1.sbs, 0, $get($1.encs, 43)); /*3566*/
		if (!$1.hidestars) { /*3570*/
			$put($1.txt, 0, $a(["*", 0, $1.textyoffset, $1.textfont, $1.textsize])); /*3568*/
		} else { /*3570*/
			$put($1.txt, 0, $a(["", 0, $1.textyoffset, $1.textfont, $1.textsize])); /*3570*/
		} /*3570*/
		for (var _17 = 0, _16 = $1.barlen - 1; _17 <= _16; _17 += 1) { /*3578*/
			$1.i = _17; /*3574*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*3575*/
			$puti($1.sbs, ($1.i * 10) + 10, $get($1.encs, $1.indx)); /*3576*/
			$put($1.txt, $1.i + 1, $a([$geti($1.barcode, $1.i, 1), ($1.i + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3577*/
		} /*3577*/
		if ($1.includecheck) { /*3599*/
			$puti($1.sbs, ($1.barlen * 10) + 10, $get($1.encs, $1.checksum)); /*3582*/
			if ($1.includecheckintext) { /*3586*/
				$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3584*/
			} else { /*3586*/
				$put($1.txt, $1.barlen + 1, $a(["", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3586*/
			} /*3586*/
			$puti($1.sbs, ($1.barlen * 10) + 20, $get($1.encs, 43)); /*3588*/
			if (!$1.hidestars) { /*3592*/
				$put($1.txt, $1.barlen + 2, $a(["*", ($1.barlen + 2) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3590*/
			} else { /*3592*/
				$put($1.txt, $1.barlen + 2, $a(["", ($1.barlen + 2) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3592*/
			} /*3592*/
		} else { /*3599*/
			$puti($1.sbs, ($1.barlen * 10) + 10, $get($1.encs, 43)); /*3595*/
			if (!$1.hidestars) { /*3599*/
				$put($1.txt, $1.barlen + 1, $a(["*", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3597*/
			} else { /*3599*/
				$put($1.txt, $1.barlen + 1, $a(["", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3599*/
			} /*3599*/
		} /*3599*/
		$k[$j++] = Infinity; /*3612*/
		$k[$j++] = "ren"; /*3607*/
		$k[$j++] = $0.renlinear; /*3607*/
		$k[$j++] = "sbs"; /*3607*/
		$k[$j++] = Infinity; /*3607*/
		var _2S = $1.sbs; /*3606*/
		for (var _2T = 0, _2U = _2S.length; _2T < _2U; _2T++) { /*3606*/
			$k[$j++] = $get(_2S, _2T) - 48; /*3606*/
		} /*3606*/
		var _2W = $a(); /*3607*/
		$k[$j++] = _2W; /*3608*/
		$k[$j++] = "bhs"; /*3608*/
		$k[$j++] = Infinity; /*3608*/
		for (var _2Y = 0, _2Z = ~~(($1.sbs.length + 1) / 2); _2Y < _2Z; _2Y++) { /*3607*/
			$k[$j++] = $1.height; /*3607*/
		} /*3607*/
		var _2b = $a(); /*3608*/
		$k[$j++] = _2b; /*3609*/
		$k[$j++] = "bbs"; /*3609*/
		$k[$j++] = Infinity; /*3609*/
		for (var _2d = 0, _2e = ~~(($1.sbs.length + 1) / 2); _2d < _2e; _2d++) { /*3608*/
			$k[$j++] = 0; /*3608*/
		} /*3608*/
		var _2f = $a(); /*3609*/
		$k[$j++] = _2f; /*3611*/
		if ($1.includetext) { /*3611*/
			$k[$j++] = "txt"; /*3610*/
			$k[$j++] = $1.txt; /*3610*/
		} /*3610*/
		$k[$j++] = "opt"; /*3612*/
		$k[$j++] = $1.options; /*3612*/
		var _2j = $d(); /*3612*/
		$k[$j++] = _2j; /*3615*/
		if (!$1.dontdraw) { /*3615*/
			$0.renlinear(); /*3615*/
		} /*3615*/
	};
	$0.code39ext = function() {
		var $1 = {}; /*3643*/
		$1.options = $k[--$j]; /*3645*/
		$1.barcode = $k[--$j]; /*3646*/
		$1.dontdraw = false; /*3648*/
		$1.includetext = false; /*3649*/
		$1.parse = false; /*3650*/
		$forall($1.options, function() { /*3661*/
			var _3 = $k[--$j]; /*3661*/
			$1[$k[--$j]] = _3; /*3661*/
		}); /*3661*/
		$forall($1.barcode, function() { /*3689*/
			if ($k[--$j] >= 128) { /*3688*/
				$k[$j++] = "bwipp.code39extBadCharacter"; /*3687*/
				$k[$j++] = "Code 39 Extended must contain only ASCII characters"; /*3687*/
				$0.raiseerror(); /*3687*/
			} /*3687*/
		}); /*3687*/
		$1.barlen = $1.barcode.length; /*3691*/
		$1.extencs = $a(["%U", "$A", "$B", "$C", "$D", "$E", "$F", "$G", "$H", "$I", "$J", "$K", "$L", "$M", "$N", "$O", "$P", "$Q", "$R", "$S", "$T", "$U", "$V", "$W", "$X", "$Y", "$Z", "%A", "%B", "%C", "%D", "%E", " ", "/A", "/B", "/C", "/D", "/E", "/F", "/G", "/H", "/I", "/J", "/K", "/L", "-", ".", "/O", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "/Z", "%F", "%G", "%H", "%I", "%J", "%V", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "%K", "%L", "%M", "%N", "%O", "%W", "+A", "+B", "+C", "+D", "+E", "+F", "+G", "+H", "+I", "+J", "+K", "+L", "+M", "+N", "+O", "+P", "+Q", "+R", "+S", "+T", "+U", "+V", "+W", "+X", "+Y", "+Z", "%P", "%Q", "%R", "%S", "%T"]); /*3703*/
		$1.newcode = $s($1.barlen * 2); /*3705*/
		$1.newtext = $s($1.barlen * 2); /*3706*/
		$1.j = 0; /*3707*/
		for (var _F = 0, _E = $1.barlen - 1; _F <= _E; _F += 1) { /*3715*/
			$1.i = _F; /*3709*/
			$1.extchar = $get($1.extencs, $get($1.barcode, $1.i)); /*3710*/
			$puti($1.newcode, $1.j, $1.extchar); /*3711*/
			$put($1.newtext, $1.j, $get($1.barcode, $1.i)); /*3712*/
			if ($1.extchar.length != 1) { /*3713*/
				$puti($1.newtext, $1.j + 1, " "); /*3713*/
			} /*3713*/
			$1.j = $1.j + $1.extchar.length; /*3714*/
		} /*3714*/
		$1.newcode = $geti($1.newcode, 0, $1.j); /*3716*/
		$1.newtext = $geti($1.newtext, 0, $1.j); /*3717*/
		$1.options.dontdraw = true; /*3720*/
		$k[$j++] = "args"; /*3721*/
		$k[$j++] = $1.newcode; /*3721*/
		$k[$j++] = $1.options; /*3721*/
		$0.code39(); /*3721*/
		var _h = $k[--$j]; /*3721*/
		$1[$k[--$j]] = _h; /*3721*/
		if ($1.includetext) { /*3733*/
			$1.txt = $1.args.txt; /*3725*/
			for (var _o = 0, _n = $1.newtext.length - 1; _o <= _n; _o += 1) { /*3731*/
				$1.i = _o; /*3727*/
				$1.txtentry = $get($1.txt, $1.i + 1); /*3728*/
				$put($1.txtentry, 0, $geti($1.newtext, $1.i, 1)); /*3729*/
				$put($1.txt, $1.i + 1, $1.txtentry); /*3730*/
			} /*3730*/
			$1.args.txt = $1.txt; /*3732*/
		} /*3732*/
		$1.args.opt = $1.options; /*3734*/
		$k[$j++] = $1.args; /*3737*/
		if (!$1.dontdraw) { /*3737*/
			$0.renlinear(); /*3737*/
		} /*3737*/
	};
	$0.code32 = function() {
		var $1 = {}; /*3765*/
		$1.options = $k[--$j]; /*3767*/
		$1.barcode = $k[--$j]; /*3768*/
		$1.dontdraw = false; /*3770*/
		$1.includetext = false; /*3771*/
		$1.textfont = "Courier"; /*3772*/
		$1.textsize = 10; /*3773*/
		$1.textyoffset = -8.5; /*3774*/
		$1.textxoffset = 0; /*3775*/
		$1.height = 1; /*3776*/
		$forall($1.options, function() { /*3787*/
			var _3 = $k[--$j]; /*3787*/
			$1[$k[--$j]] = _3; /*3787*/
		}); /*3787*/
		$1.textfont = "" + $1.textfont; /*3789*/
		$1.textsize = +$1.textsize; /*3790*/
		$1.textyoffset = +$1.textyoffset; /*3791*/
		$1.height = +$1.height; /*3792*/
		if (($1.barcode.length != 8) && ($1.barcode.length != 9)) { /*3797*/
			$k[$j++] = "bwipp.code32badLength"; /*3796*/
			$k[$j++] = "Italian Pharmacode must be 8 or 9 digits"; /*3796*/
			$0.raiseerror(); /*3796*/
		} /*3796*/
		$forall($1.barcode, function() { /*3802*/
			var _C = $k[--$j]; /*3799*/
			if ((_C < 48) || (_C > 57)) { /*3801*/
				$k[$j++] = "bwipp.code32badCharacter"; /*3800*/
				$k[$j++] = "Italian Pharmacode must contain only digits"; /*3800*/
				$0.raiseerror(); /*3800*/
			} /*3800*/
		}); /*3800*/
		$1.checksum = 0; /*3805*/
		for (var _D = 0; _D <= 7; _D += 1) { /*3810*/
			$1.i = _D; /*3807*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*3808*/
			if (($1.i % 2) != 0) { /*3808*/
				var _I = $k[--$j]; /*3808*/
				$k[$j++] = _I * 2; /*3808*/
			} /*3808*/
			var _J = $k[--$j]; /*3808*/
			$k[$j++] = _J; /*3808*/
			if (_J > 9) { /*3808*/
				var _K = $k[--$j]; /*3808*/
				$k[$j++] = _K - 9; /*3808*/
			} /*3808*/
			$1.checksum = $k[--$j] + $1.checksum; /*3809*/
		} /*3809*/
		$1.checksum = $1.checksum % 10; /*3811*/
		if ($1.barcode.length == 9) { /*3816*/
			if ($get($1.barcode, 8) != ($1.checksum + 48)) { /*3815*/
				$k[$j++] = "bwipp.code32badCheckDigit"; /*3814*/
				$k[$j++] = "Incorrect Italian Pharmacode check digit provided"; /*3814*/
				$0.raiseerror(); /*3814*/
			} /*3814*/
		} /*3814*/
		var _S = $s(10); /*3817*/
		$puti(_S, 0, $1.barcode); /*3818*/
		$put(_S, 8, $1.checksum + 48); /*3819*/
		$1.text = _S; /*3820*/
		$1.val = $cvrs($1.barcode, ~~$z($1.text), 32); /*3823*/
		$1.barcode = $s(6); /*3824*/
		for (var _Z = 0; _Z <= 5; _Z += 1) { /*3825*/
			$put($1.barcode, _Z, 48); /*3825*/
		} /*3825*/
		$puti($1.barcode, 6 - $1.val.length, $1.val); /*3826*/
		for (var _e = 0; _e <= 5; _e += 1) { /*3833*/
			var _g = $get($1.barcode, _e); /*3830*/
			$k[$j++] = _e; /*3831*/
			$k[$j++] = _g; /*3831*/
			$k[$j++] = _g; /*3831*/
			for (var _h = 0, _i = "AEIO".length; _h < _i; _h++) { /*3831*/
				if ($k[--$j] >= $get("AEIO", _h)) { /*3831*/
					var _l = $k[--$j]; /*3831*/
					$k[$j++] = _l + 1; /*3831*/
				} /*3831*/
				var _m = $k[--$j]; /*3831*/
				$k[$j++] = _m; /*3831*/
				$k[$j++] = _m; /*3831*/
			} /*3831*/
			$j--; /*3831*/
			var _o = $k[--$j]; /*3832*/
			$put($1.barcode, $k[--$j], _o); /*3832*/
		} /*3832*/
		$puti($1.text, 1, $geti($1.text, 0, 9)); /*3836*/
		$put($1.text, 0, 65); /*3837*/
		$1.options.dontdraw = true; /*3840*/
		$k[$j++] = "args"; /*3841*/
		$k[$j++] = $1.barcode; /*3841*/
		$k[$j++] = $1.options; /*3841*/
		$0.code39(); /*3841*/
		var _x = $k[--$j]; /*3841*/
		$1[$k[--$j]] = _x; /*3841*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3843*/
		$1.args.textxalign = "center"; /*3844*/
		$1.args.opt = $1.options; /*3845*/
		$k[$j++] = $1.args; /*3848*/
		if (!$1.dontdraw) { /*3848*/
			$0.renlinear(); /*3848*/
		} /*3848*/
	};
	$0.pzn = function() {
		var $1 = {}; /*3876*/
		$1.options = $k[--$j]; /*3878*/
		$1.barcode = $k[--$j]; /*3879*/
		$1.dontdraw = false; /*3881*/
		$1.includetext = false; /*3882*/
		$1.textfont = "Courier"; /*3883*/
		$1.textsize = 10; /*3884*/
		$1.textyoffset = -8.5; /*3885*/
		$1.textxoffset = 0; /*3886*/
		$1.height = 1; /*3887*/
		$1.pzn8 = false; /*3888*/
		$forall($1.options, function() { /*3899*/
			var _3 = $k[--$j]; /*3899*/
			$1[$k[--$j]] = _3; /*3899*/
		}); /*3899*/
		$1.textfont = "" + $1.textfont; /*3901*/
		$1.textsize = +$1.textsize; /*3902*/
		$1.textyoffset = +$1.textyoffset; /*3903*/
		$1.textxoffset = +$1.textxoffset; /*3904*/
		$1.height = +$1.height; /*3905*/
		if ($1.pzn8) { /*3914*/
			if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*3911*/
				$k[$j++] = "bwipp.pzn8badLength"; /*3910*/
				$k[$j++] = "PZN8 must be 7 or 8 digits"; /*3910*/
				$0.raiseerror(); /*3910*/
			} /*3910*/
		} else { /*3914*/
			if (($1.barcode.length != 6) && ($1.barcode.length != 7)) { /*3915*/
				$k[$j++] = "bwipp.pzn7badLength"; /*3914*/
				$k[$j++] = "PZN7 must be 6 or 7 digits"; /*3914*/
				$0.raiseerror(); /*3914*/
			} /*3914*/
		} /*3914*/
		$forall($1.barcode, function() { /*3921*/
			var _G = $k[--$j]; /*3918*/
			if ((_G < 48) || (_G > 57)) { /*3920*/
				$k[$j++] = "bwipp.pznBadCharacter"; /*3919*/
				$k[$j++] = "PZN must contain only digits"; /*3919*/
				$0.raiseerror(); /*3919*/
			} /*3919*/
		}); /*3919*/
		var _I = $1.pzn8 ? 9 : 8; /*3924*/
		$1.msglen = _I; /*3924*/
		$1.checksum = 0; /*3925*/
		for (var _L = 0, _K = $1.msglen - 3; _L <= _K; _L += 1) { /*3930*/
			$1.i = _L; /*3927*/
			var _R = $1.pzn8 ? 1 : 2; /*3928*/
			$1.checksum = (($get($1.barcode, $1.i) - 48) * ($1.i + _R)) + $1.checksum; /*3929*/
		} /*3929*/
		$1.checksum = $1.checksum % 11; /*3931*/
		if ($1.checksum == 10) { /*3934*/
			$k[$j++] = "bwipp.pznBadInputSequence"; /*3933*/
			$k[$j++] = "Incorrect PZN input sequence provided"; /*3933*/
			$0.raiseerror(); /*3933*/
		} /*3933*/
		if ($1.barcode.length == ($1.msglen - 1)) { /*3939*/
			if ($get($1.barcode, $1.msglen - 2) != ($1.checksum + 48)) { /*3938*/
				$k[$j++] = "bwipp.pznBadCheckDigit"; /*3937*/
				$k[$j++] = "Incorrect PZN check digit provided"; /*3937*/
				$0.raiseerror(); /*3937*/
			} /*3937*/
		} /*3937*/
		var _c = $s($1.msglen); /*3940*/
		$put(_c, 0, 45); /*3941*/
		$puti(_c, 1, $1.barcode); /*3942*/
		$put(_c, $1.msglen - 1, $1.checksum + 48); /*3943*/
		$1.msg = _c; /*3944*/
		$1.options.dontdraw = true; /*3947*/
		$k[$j++] = "args"; /*3948*/
		$k[$j++] = $1.msg; /*3948*/
		$k[$j++] = $1.options; /*3948*/
		$0.code39(); /*3948*/
		var _j = $k[--$j]; /*3948*/
		$1[$k[--$j]] = _j; /*3948*/
		$1.text = $s($1.msglen + 5); /*3951*/
		$puti($1.text, 0, "PZN - "); /*3952*/
		$puti($1.text, 6, $geti($1.msg, 1, $1.msglen - 1)); /*3953*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3955*/
		$1.args.textxalign = "center"; /*3956*/
		$1.args.opt = $1.options; /*3957*/
		$k[$j++] = $1.args; /*3960*/
		if (!$1.dontdraw) { /*3960*/
			$0.renlinear(); /*3960*/
		} /*3960*/
	};
	$0.code93 = function() {
		var $1 = {}; /*3987*/
		$1.options = $k[--$j]; /*3989*/
		$1.barcode = $k[--$j]; /*3990*/
		$1.dontdraw = false; /*3992*/
		$1.includecheck = false; /*3993*/
		$1.includetext = false; /*3994*/
		$1.textfont = "Courier"; /*3995*/
		$1.textsize = 10; /*3996*/
		$1.textyoffset = -8.5; /*3997*/
		$1.height = 1; /*3998*/
		$1.parsefnc = false; /*3999*/
		$forall($1.options, function() { /*4010*/
			var _3 = $k[--$j]; /*4010*/
			$1[$k[--$j]] = _3; /*4010*/
		}); /*4010*/
		$1.textfont = "" + $1.textfont; /*4012*/
		$1.textsize = +$1.textsize; /*4013*/
		$1.textyoffset = +$1.textyoffset; /*4014*/
		$1.height = +$1.height; /*4015*/
		$1.encs = $a(["131112", "111213", "111312", "111411", "121113", "121212", "121311", "111114", "131211", "141111", "211113", "211212", "211311", "221112", "221211", "231111", "112113", "112212", "112311", "122112", "132111", "111123", "111222", "111321", "121122", "131121", "212112", "212211", "211122", "211221", "221121", "222111", "112122", "112221", "122121", "123111", "121131", "311112", "311211", "321111", "112131", "113121", "211131", "121221", "312111", "311121", "122211", "111141", "1111411"]); /*4028*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*4031*/
		$1.barlen = $1.barcode.length; /*4033*/
		$1.sft1 = -1; /*4036*/
		$1.sft2 = -2; /*4036*/
		$1.sft3 = -3; /*4036*/
		$1.sft4 = -4; /*4036*/
		var _F = {
			"SFT$": $1.sft1,
			"SFT%": $1.sft2,
			"SFT/": $1.sft3,
			"SFT+": $1.sft4
		}; /*4041*/
		$1.fncvals = _F; /*4042*/
		$1.msg = $a($1.barlen); /*4045*/
		$1.i = 0; /*4046*/
		$1.j = 0; /*4046*/
		for (;;) { /*4060*/
			if ($1.i == $1.barlen) { /*4047*/
				break; /*4047*/
			} /*4047*/
			$1.char = $get($1.barcode, $1.i); /*4048*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*4056*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*4054*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*4051*/
					$1.i = $1.i + 4; /*4052*/
				} else { /*4054*/
					$1.i = $1.i + 1; /*4054*/
				} /*4054*/
			} /*4054*/
			$put($1.msg, $1.j, $1.char); /*4057*/
			$1.i = $1.i + 1; /*4058*/
			$1.j = $1.j + 1; /*4059*/
		} /*4059*/
		$1.msg = $geti($1.msg, 0, $1.j); /*4061*/
		$1.msglen = $1.msg.length; /*4062*/
		if ($1.includecheck) { /*4067*/
			$1.sbs = $s(($1.msglen * 6) + 25); /*4065*/
		} else { /*4067*/
			$1.sbs = $s(($1.msglen * 6) + 13); /*4067*/
		} /*4067*/
		$1.txt = $a($1.msglen); /*4069*/
		$puti($1.sbs, 0, $get($1.encs, 47)); /*4072*/
		$1.checksum1 = 0; /*4074*/
		$1.checksum2 = 0; /*4074*/
		for (var _w = 0, _v = $1.msglen - 1; _w <= _v; _w += 1) { /*4093*/
			$1.i = _w; /*4076*/
			var _z = $get($1.msg, $1.i); /*4078*/
			$k[$j++] = _z; /*4087*/
			if (_z < 0) { /*4086*/
				$1.indx = 42 - $k[--$j]; /*4079*/
				$1.char = " "; /*4080*/
			} else { /*4086*/
				var _11 = $s(1); /*4082*/
				$put(_11, 0, $k[--$j]); /*4082*/
				$1.char = _11; /*4082*/
				$search($1.barchars, $1.char); /*4083*/
				$j--; /*4084*/
				$1.indx = $k[--$j].length; /*4085*/
				$j -= 2; /*4086*/
			} /*4086*/
			$1.enc = $get($1.encs, $1.indx); /*4088*/
			$puti($1.sbs, ($1.i * 6) + 6, $1.enc); /*4089*/
			$put($1.txt, $1.i, $a([$1.char, ($1.i * 9) + 9, $1.textyoffset, $1.textfont, $1.textsize])); /*4090*/
			$1.checksum1 = $1.checksum1 + ((((($1.msglen - $1.i) - 1) % 20) + 1) * $1.indx); /*4091*/
			$1.checksum2 = $1.checksum2 + (((($1.msglen - $1.i) % 15) + 1) * $1.indx); /*4092*/
		} /*4092*/
		if ($1.includecheck) { /*4105*/
			$1.checksum1 = $1.checksum1 % 47; /*4097*/
			$1.checksum2 = ($1.checksum2 + $1.checksum1) % 47; /*4098*/
			$puti($1.sbs, ($1.msglen * 6) + 6, $get($1.encs, $1.checksum1)); /*4099*/
			$puti($1.sbs, ($1.msglen * 6) + 12, $get($1.encs, $1.checksum2)); /*4100*/
			$puti($1.sbs, ($1.msglen * 6) + 18, $get($1.encs, 48)); /*4102*/
		} else { /*4105*/
			$puti($1.sbs, ($1.msglen * 6) + 6, $get($1.encs, 48)); /*4105*/
		} /*4105*/
		$k[$j++] = Infinity; /*4117*/
		$k[$j++] = "ren"; /*4112*/
		$k[$j++] = $0.renlinear; /*4112*/
		$k[$j++] = "sbs"; /*4112*/
		$k[$j++] = Infinity; /*4112*/
		var _1o = $1.sbs; /*4111*/
		for (var _1p = 0, _1q = _1o.length; _1p < _1q; _1p++) { /*4111*/
			$k[$j++] = $get(_1o, _1p) - 48; /*4111*/
		} /*4111*/
		var _1s = $a(); /*4112*/
		$k[$j++] = _1s; /*4113*/
		$k[$j++] = "bhs"; /*4113*/
		$k[$j++] = Infinity; /*4113*/
		for (var _1u = 0, _1v = ~~(($1.sbs.length + 1) / 2); _1u < _1v; _1u++) { /*4112*/
			$k[$j++] = $1.height; /*4112*/
		} /*4112*/
		var _1x = $a(); /*4113*/
		$k[$j++] = _1x; /*4114*/
		$k[$j++] = "bbs"; /*4114*/
		$k[$j++] = Infinity; /*4114*/
		for (var _1z = 0, _20 = ~~(($1.sbs.length + 1) / 2); _1z < _20; _1z++) { /*4113*/
			$k[$j++] = 0; /*4113*/
		} /*4113*/
		var _21 = $a(); /*4114*/
		$k[$j++] = _21; /*4116*/
		if ($1.includetext) { /*4116*/
			$k[$j++] = "txt"; /*4115*/
			$k[$j++] = $1.txt; /*4115*/
		} /*4115*/
		$k[$j++] = "opt"; /*4117*/
		$k[$j++] = $1.options; /*4117*/
		var _25 = $d(); /*4117*/
		$k[$j++] = _25; /*4120*/
		if (!$1.dontdraw) { /*4120*/
			$0.renlinear(); /*4120*/
		} /*4120*/
	};
	$0.code93ext = function() {
		var $1 = {}; /*4148*/
		$1.options = $k[--$j]; /*4150*/
		$1.barcode = $k[--$j]; /*4151*/
		$1.dontdraw = false; /*4153*/
		$1.includetext = false; /*4154*/
		$1.parse = false; /*4155*/
		$forall($1.options, function() { /*4166*/
			var _3 = $k[--$j]; /*4166*/
			$1[$k[--$j]] = _3; /*4166*/
		}); /*4166*/
		$1.barlen = $1.barcode.length; /*4189*/
		$1.extencs = $a(["^SFT%U", "^SFT$A", "^SFT$B", "^SFT$C", "^SFT$D", "^SFT$E", "^SFT$F", "^SFT$G", "^SFT$H", "^SFT$I", "^SFT$J", "^SFT$K", "^SFT$L", "^SFT$M", "^SFT$N", "^SFT$O", "^SFT$P", "^SFT$Q", "^SFT$R", "^SFT$S", "^SFT$T", "^SFT$U", "^SFT$V", "^SFT$W", "^SFT$X", "^SFT$Y", "^SFT$Z", "^SFT%A", "^SFT%B", "^SFT%C", "^SFT%D", "^SFT%E", " ", "^SFT/A", "^SFT/B", "^SFT/C", "^SFT/D", "^SFT/E", "^SFT/F", "^SFT/G", "^SFT/H", "^SFT/I", "^SFT/J", "^SFT/K", "^SFT/L", "-", ".", "^SFT/O", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "^SFT/Z", "^SFT%F", "^SFT%G", "^SFT%H", "^SFT%I", "^SFT%J", "^SFT%V", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "^SFT%K", "^SFT%L", "^SFT%M", "^SFT%N", "^SFT%O", "^SFT%W", "^SFT+A", "^SFT+B", "^SFT+C", "^SFT+D", "^SFT+E", "^SFT+F", "^SFT+G", "^SFT+H", "^SFT+I", "^SFT+J", "^SFT+K", "^SFT+L", "^SFT+M", "^SFT+N", "^SFT+O", "^SFT+P", "^SFT+Q", "^SFT+R", "^SFT+S", "^SFT+T", "^SFT+U", "^SFT+V", "^SFT+W", "^SFT+X", "^SFT+Y", "^SFT+Z", "^SFT%P", "^SFT%Q", "^SFT%R", "^SFT%S", "^SFT%T"]); /*4209*/
		$1.newcode = $s($1.barlen * 6); /*4211*/
		$1.newtext = $s($1.barlen * 6); /*4212*/
		$1.j = 0; /*4213*/
		$1.k = 0; /*4213*/
		for (var _D = 0, _C = $1.barlen - 1; _D <= _C; _D += 1) { /*4223*/
			$1.i = _D; /*4215*/
			$1.extchar = $get($1.extencs, $get($1.barcode, $1.i)); /*4216*/
			$1.extlen = $1.extchar.length; /*4217*/
			$puti($1.newcode, $1.j, $1.extchar); /*4218*/
			$put($1.newtext, $1.k, $get($1.barcode, $1.i)); /*4219*/
			if ($1.extlen != 1) { /*4220*/
				$puti($1.newtext, $1.k + 1, " "); /*4220*/
			} /*4220*/
			$1.j = $1.j + $1.extlen; /*4221*/
			var _Z = ($1.extlen == 1) ? 1 : 2; /*4222*/
			$1.k = $1.k + _Z; /*4222*/
		} /*4222*/
		$1.newcode = $geti($1.newcode, 0, $1.j); /*4224*/
		$1.newtext = $geti($1.newtext, 0, $1.k); /*4225*/
		$1.options.dontdraw = true; /*4228*/
		$1.options.parsefnc = true; /*4229*/
		$k[$j++] = "args"; /*4230*/
		$k[$j++] = $1.newcode; /*4230*/
		$k[$j++] = $1.options; /*4230*/
		$0.code93(); /*4230*/
		var _k = $k[--$j]; /*4230*/
		$1[$k[--$j]] = _k; /*4230*/
		if ($1.includetext) { /*4242*/
			$1.txt = $1.args.txt; /*4234*/
			for (var _r = 0, _q = $1.newtext.length - 1; _r <= _q; _r += 1) { /*4240*/
				$1.i = _r; /*4236*/
				$1.txtentry = $get($1.txt, $1.i); /*4237*/
				$put($1.txtentry, 0, $geti($1.newtext, $1.i, 1)); /*4238*/
				$put($1.txt, $1.i, $1.txtentry); /*4239*/
			} /*4239*/
			$1.args.txt = $1.txt; /*4241*/
		} /*4241*/
		$1.args.opt = $1.options; /*4243*/
		$k[$j++] = $1.args; /*4246*/
		if (!$1.dontdraw) { /*4246*/
			$0.renlinear(); /*4246*/
		} /*4246*/
	};
	$0.interleaved2of5 = function() {
		var $1 = {}; /*4273*/
		$1.options = $k[--$j]; /*4275*/
		$1.barcode = $k[--$j]; /*4276*/
		$1.dontdraw = false; /*4278*/
		$1.includecheck = false; /*4279*/
		$1.includetext = false; /*4280*/
		$1.includecheckintext = false; /*4281*/
		$1.textfont = "Courier"; /*4282*/
		$1.textsize = 10; /*4283*/
		$1.textyoffset = -8.5; /*4284*/
		$1.height = 1; /*4285*/
		$forall($1.options, function() { /*4296*/
			var _3 = $k[--$j]; /*4296*/
			$1[$k[--$j]] = _3; /*4296*/
		}); /*4296*/
		$1.textfont = "" + $1.textfont; /*4298*/
		$1.textsize = +$1.textsize; /*4299*/
		$1.textyoffset = +$1.textyoffset; /*4300*/
		$1.height = +$1.height; /*4301*/
		$forall($1.barcode, function() { /*4308*/
			var _A = $k[--$j]; /*4305*/
			if ((_A < 48) || (_A > 57)) { /*4307*/
				$k[$j++] = "bwipp.interleaved2of5badCharacter"; /*4306*/
				$k[$j++] = "Interleaved 2 of 5 must contain only digits"; /*4306*/
				$0.raiseerror(); /*4306*/
			} /*4306*/
		}); /*4306*/
		$1.barlen = $1.barcode.length; /*4310*/
		if (((($1.barlen % 2) == 0) && $1.includecheck) || ((($1.barlen % 2) != 0) && (!$1.includecheck))) { /*4321*/
			$1.pad = $s($1.barlen + 1); /*4316*/
			$put($1.pad, 0, 48); /*4317*/
			$puti($1.pad, 1, $1.barcode); /*4318*/
			$1.barcode = $1.pad; /*4319*/
			$1.barlen = $1.barlen + 1; /*4320*/
		} /*4320*/
		if ($1.includecheck) { /*4340*/
			$1.checksum = 0; /*4325*/
			for (var _Q = 0, _P = $1.barlen - 1; _Q <= _P; _Q += 1) { /*4333*/
				$1.i = _Q; /*4327*/
				if (($1.i % 2) == 0) { /*4331*/
					$1.checksum = $1.checksum + (($get($1.barcode, $1.i) - 48) * 3); /*4329*/
				} else { /*4331*/
					$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*4331*/
				} /*4331*/
			} /*4331*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4334*/
			$1.pad = $s($1.barlen + 1); /*4335*/
			$puti($1.pad, 0, $1.barcode); /*4336*/
			$put($1.pad, $1.barlen, $1.checksum + 48); /*4337*/
			$1.barcode = $1.pad; /*4338*/
			$1.barlen = $1.barlen + 1; /*4339*/
		} /*4339*/
		$1.encs = $a(["11221", "21112", "12112", "22111", "11212", "21211", "12211", "11122", "21121", "12121", "1111", "2111"]); /*4347*/
		$1.barchars = "0123456789"; /*4350*/
		$1.sbs = $s(($1.barlen * 5) + 8); /*4351*/
		$1.txt = $a($1.barlen); /*4352*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*4355*/
		for (var _u = 0, _t = $1.barlen - 1; _u <= _t; _u += 2) { /*4389*/
			$1.i = _u; /*4358*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*4360*/
			$j--; /*4361*/
			$1.indx = $k[--$j].length; /*4362*/
			$j -= 2; /*4363*/
			$1.enca = $get($1.encs, $1.indx); /*4364*/
			$search($1.barchars, $geti($1.barcode, $1.i + 1, 1)); /*4366*/
			$j--; /*4367*/
			$1.indx = $k[--$j].length; /*4368*/
			$j -= 2; /*4369*/
			$1.encb = $get($1.encs, $1.indx); /*4370*/
			$1.intl = $s($1.enca.length * 2); /*4373*/
			for (var _1F = 0, _1E = $1.enca.length - 1; _1F <= _1E; _1F += 1) { /*4380*/
				$1.j = _1F; /*4375*/
				$1.achar = $get($1.enca, $1.j); /*4376*/
				$1.bchar = $get($1.encb, $1.j); /*4377*/
				$put($1.intl, $1.j * 2, $1.achar); /*4378*/
				$put($1.intl, ($1.j * 2) + 1, $1.bchar); /*4379*/
			} /*4379*/
			$puti($1.sbs, ($1.i * 5) + 4, $1.intl); /*4382*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4383*/
			if (($1.includecheck && (!$1.includecheckintext)) && (($1.barlen - 2) == $1.i)) { /*4387*/
				$put($1.txt, $1.i + 1, $a([" ", (($1.i + 1) * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4385*/
			} else { /*4387*/
				$put($1.txt, $1.i + 1, $a([$geti($1.barcode, $1.i + 1, 1), (($1.i + 1) * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4387*/
			} /*4387*/
		} /*4387*/
		$puti($1.sbs, ($1.barlen * 5) + 4, $get($1.encs, 11)); /*4392*/
		$k[$j++] = Infinity; /*4405*/
		$k[$j++] = "ren"; /*4398*/
		$k[$j++] = $0.renlinear; /*4398*/
		$k[$j++] = "sbs"; /*4398*/
		$k[$j++] = Infinity; /*4398*/
		var _24 = $1.sbs; /*4397*/
		for (var _25 = 0, _26 = _24.length; _25 < _26; _25++) { /*4397*/
			$k[$j++] = $get(_24, _25) - 48; /*4397*/
		} /*4397*/
		var _28 = $a(); /*4398*/
		$k[$j++] = _28; /*4399*/
		$k[$j++] = "bhs"; /*4399*/
		$k[$j++] = Infinity; /*4399*/
		for (var _2A = 0, _2B = ~~(($1.sbs.length + 1) / 2); _2A < _2B; _2A++) { /*4398*/
			$k[$j++] = $1.height; /*4398*/
		} /*4398*/
		var _2D = $a(); /*4399*/
		$k[$j++] = _2D; /*4400*/
		$k[$j++] = "bbs"; /*4400*/
		$k[$j++] = Infinity; /*4400*/
		for (var _2F = 0, _2G = ~~(($1.sbs.length + 1) / 2); _2F < _2G; _2F++) { /*4399*/
			$k[$j++] = 0; /*4399*/
		} /*4399*/
		var _2H = $a(); /*4400*/
		$k[$j++] = _2H; /*4402*/
		if ($1.includetext) { /*4402*/
			$k[$j++] = "txt"; /*4401*/
			$k[$j++] = $1.txt; /*4401*/
		} /*4401*/
		$k[$j++] = "barratio"; /*4405*/
		$k[$j++] = 2; /*4405*/
		$k[$j++] = "spaceratio"; /*4405*/
		$k[$j++] = 2; /*4405*/
		$k[$j++] = "opt"; /*4405*/
		$k[$j++] = $1.options; /*4405*/
		var _2L = $d(); /*4405*/
		$k[$j++] = _2L; /*4408*/
		if (!$1.dontdraw) { /*4408*/
			$0.renlinear(); /*4408*/
		} /*4408*/
	};
	$0.itf14 = function() {
		var $1 = {}; /*4436*/
		$1.options = $k[--$j]; /*4438*/
		$1.barcode = $k[--$j]; /*4439*/
		$1.dontdraw = false; /*4441*/
		$1.includetext = false; /*4442*/
		$1.includecheckintext = true; /*4443*/
		$1.textfont = "Courier"; /*4444*/
		$1.textsize = 10; /*4445*/
		$1.textxoffset = 0; /*4446*/
		$1.textyoffset = 3; /*4447*/
		$1.height = 0.5; /*4448*/
		$1.showborder = true; /*4449*/
		$1.borderwidth = 4; /*4450*/
		$1.borderleft = 15; /*4451*/
		$1.borderright = 15; /*4452*/
		$forall($1.options, function() { /*4463*/
			var _3 = $k[--$j]; /*4463*/
			$1[$k[--$j]] = _3; /*4463*/
		}); /*4463*/
		$1.textfont = "" + $1.textfont; /*4465*/
		$1.textsize = +$1.textsize; /*4466*/
		$1.textxoffset = +$1.textxoffset; /*4467*/
		$1.textyoffset = +$1.textyoffset; /*4468*/
		$1.height = +$1.height; /*4469*/
		$1.borderwidth = +$1.borderwidth; /*4470*/
		$1.borderleft = +$1.borderleft; /*4471*/
		$1.borderright = +$1.borderright; /*4472*/
		$1.text = $1.barcode; /*4475*/
		var _E = $1.barcode; /*4476*/
		$k[$j++] = $s(_E.length); /*4477*/
		$k[$j++] = 0; /*4477*/
		$forall(_E, function() { /*4477*/
			var _G = $k[--$j]; /*4477*/
			$k[$j++] = _G; /*4477*/
			if (_G != 32) { /*4477*/
				var _H = $k[--$j]; /*4477*/
				var _I = $k[--$j]; /*4477*/
				var _J = $k[--$j]; /*4477*/
				$put(_J, _I, _H); /*4477*/
				$k[$j++] = _J; /*4477*/
				$k[$j++] = _I + 1; /*4477*/
			} else { /*4477*/
				$j--; /*4477*/
			} /*4477*/
		}); /*4477*/
		var _K = $k[--$j]; /*4478*/
		$1.barcode = $geti($k[--$j], 0, _K); /*4478*/
		$1.hasspace = $1.text.length != $1.barcode.length; /*4479*/
		if (($1.barcode.length != 13) && ($1.barcode.length != 14)) { /*4484*/
			$k[$j++] = "bwipp.itf14badLength"; /*4483*/
			$k[$j++] = "ITF-14 must be 13 or 14 digits"; /*4483*/
			$0.raiseerror(); /*4483*/
		} /*4483*/
		$forall($1.barcode, function() { /*4489*/
			var _S = $k[--$j]; /*4486*/
			if ((_S < 48) || (_S > 57)) { /*4488*/
				$k[$j++] = "bwipp.itf14badCharacter"; /*4487*/
				$k[$j++] = "ITF-14 must contain only digits"; /*4487*/
				$0.raiseerror(); /*4487*/
			} /*4487*/
		}); /*4487*/
		$1.checksum = 0; /*4492*/
		for (var _T = 0; _T <= 12; _T += 1) { /*4496*/
			$1.i = _T; /*4494*/
			$k[$j++] = "checksum"; /*4495*/
			$k[$j++] = $1.checksum; /*4495*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*4495*/
			if (($1.i % 2) == 0) { /*4495*/
				var _Z = $k[--$j]; /*4495*/
				$k[$j++] = _Z * 3; /*4495*/
			} /*4495*/
			var _a = $k[--$j]; /*4495*/
			var _b = $k[--$j]; /*4495*/
			$1[$k[--$j]] = _b + _a; /*4495*/
		} /*4495*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4497*/
		if ($1.barcode.length == 14) { /*4511*/
			if ($get($1.barcode, 13) != ($1.checksum + 48)) { /*4501*/
				$k[$j++] = "bwipp.itf14badCheckDigit"; /*4500*/
				$k[$j++] = "Incorrect ITF-14 check digit provided"; /*4500*/
				$0.raiseerror(); /*4500*/
			} /*4500*/
		} else { /*4511*/
			var _i = $s(14); /*4503*/
			$puti(_i, 0, $1.barcode); /*4504*/
			$put(_i, 13, $1.checksum + 48); /*4505*/
			$1.barcode = _i; /*4506*/
			var _n = $1.hasspace ? 2 : 1; /*4507*/
			var _o = $s($1.text.length + _n); /*4507*/
			$puti(_o, _o.length - 2, " "); /*4508*/
			$put(_o, _o.length - 1, $1.checksum + 48); /*4509*/
			$puti(_o, 0, $1.text); /*4510*/
			$1.text = _o; /*4511*/
		} /*4511*/
		$1.options.dontdraw = true; /*4515*/
		$1.options.showborder = $1.showborder; /*4516*/
		$1.options.borderwidth = $1.borderwidth; /*4517*/
		$1.options.borderleft = $1.borderleft; /*4518*/
		$1.options.borderright = $1.borderright; /*4519*/
		$1.options.height = $1.height; /*4520*/
		$1.options.textyoffset = $1.textyoffset; /*4521*/
		$k[$j++] = "args"; /*4522*/
		$k[$j++] = $1.barcode; /*4522*/
		$k[$j++] = $1.options; /*4522*/
		$0.interleaved2of5(); /*4522*/
		var _16 = $k[--$j]; /*4522*/
		$1[$k[--$j]] = _16; /*4522*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4524*/
		$1.args.textxalign = "center"; /*4525*/
		$1.args.opt = $1.options; /*4526*/
		$k[$j++] = $1.args; /*4529*/
		if (!$1.dontdraw) { /*4529*/
			$0.renlinear(); /*4529*/
		} /*4529*/
	};
	$0.identcode = function() {
		var $1 = {}; /*4557*/
		$1.options = $k[--$j]; /*4559*/
		$1.barcode = $k[--$j]; /*4560*/
		$1.dontdraw = false; /*4562*/
		$1.includetext = false; /*4563*/
		$1.textfont = "Courier"; /*4564*/
		$1.textsize = 10; /*4565*/
		$1.textxoffset = 0; /*4566*/
		$1.textyoffset = -8.5; /*4567*/
		$1.height = 1; /*4568*/
		$forall($1.options, function() { /*4579*/
			var _3 = $k[--$j]; /*4579*/
			$1[$k[--$j]] = _3; /*4579*/
		}); /*4579*/
		$1.textfont = "" + $1.textfont; /*4581*/
		$1.textsize = +$1.textsize; /*4582*/
		$1.textxoffset = +$1.textxoffset; /*4583*/
		$1.textyoffset = +$1.textyoffset; /*4584*/
		$1.height = +$1.height; /*4585*/
		if (($1.barcode.length != 11) && ($1.barcode.length != 12)) { /*4590*/
			$k[$j++] = "bwipp.identcodeBadLength"; /*4589*/
			$k[$j++] = "Deutsche Post Identcode must be 11 or 12 digits"; /*4589*/
			$0.raiseerror(); /*4589*/
		} /*4589*/
		$forall($1.barcode, function() { /*4595*/
			var _D = $k[--$j]; /*4592*/
			if ((_D < 48) || (_D > 57)) { /*4594*/
				$k[$j++] = "bwipp.identcodeBadCharacter"; /*4593*/
				$k[$j++] = "Deutsche Post Identcode must contain only digits"; /*4593*/
				$0.raiseerror(); /*4593*/
			} /*4593*/
		}); /*4593*/
		$1.checksum = 0; /*4598*/
		for (var _E = 0; _E <= 10; _E += 1) { /*4602*/
			$1.i = _E; /*4600*/
			$k[$j++] = "checksum"; /*4601*/
			$k[$j++] = $1.checksum; /*4601*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*4601*/
			if (($1.i % 2) == 0) { /*4601*/
				var _K = $k[--$j]; /*4601*/
				$k[$j++] = _K * 4; /*4601*/
			} else { /*4601*/
				var _L = $k[--$j]; /*4601*/
				$k[$j++] = _L * 9; /*4601*/
			} /*4601*/
			var _M = $k[--$j]; /*4601*/
			var _N = $k[--$j]; /*4601*/
			$1[$k[--$j]] = _N + _M; /*4601*/
		} /*4601*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4603*/
		if ($1.barcode.length == 12) { /*4608*/
			if ($get($1.barcode, 11) != ($1.checksum + 48)) { /*4607*/
				$k[$j++] = "bwipp.identcodeBadCheckDigit"; /*4606*/
				$k[$j++] = "Incorrect Deutsche Post Identcode check digit provided"; /*4606*/
				$0.raiseerror(); /*4606*/
			} /*4606*/
		} /*4606*/
		var _U = $s(12); /*4609*/
		$puti(_U, 0, $1.barcode); /*4610*/
		$put(_U, 11, $1.checksum + 48); /*4611*/
		$1.barcode = _U; /*4612*/
		$1.text = $strcpy($s(16), "  .       .     "); /*4615*/
		$puti($1.text, 0, $geti($1.barcode, 0, 2)); /*4616*/
		$puti($1.text, 3, $geti($1.barcode, 2, 3)); /*4617*/
		$puti($1.text, 7, $geti($1.barcode, 5, 3)); /*4618*/
		$puti($1.text, 11, $geti($1.barcode, 8, 3)); /*4619*/
		$puti($1.text, 15, $geti($1.barcode, 11, 1)); /*4620*/
		$1.options.dontdraw = true; /*4623*/
		$1.options.includecheck = false; /*4624*/
		$k[$j++] = "args"; /*4625*/
		$k[$j++] = $1.barcode; /*4625*/
		$k[$j++] = $1.options; /*4625*/
		$0.interleaved2of5(); /*4625*/
		var _s = $k[--$j]; /*4625*/
		$1[$k[--$j]] = _s; /*4625*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4627*/
		$1.args.textxalign = "center"; /*4628*/
		$1.args.opt = $1.options; /*4629*/
		$k[$j++] = $1.args; /*4632*/
		if (!$1.dontdraw) { /*4632*/
			$0.renlinear(); /*4632*/
		} /*4632*/
	};
	$0.leitcode = function() {
		var $1 = {}; /*4660*/
		$1.options = $k[--$j]; /*4662*/
		$1.barcode = $k[--$j]; /*4663*/
		$1.dontdraw = false; /*4665*/
		$1.includetext = false; /*4666*/
		$1.textfont = "Courier"; /*4667*/
		$1.textsize = 10; /*4668*/
		$1.textxoffset = 0; /*4669*/
		$1.textyoffset = -8.5; /*4670*/
		$1.height = 1; /*4671*/
		$forall($1.options, function() { /*4682*/
			var _3 = $k[--$j]; /*4682*/
			$1[$k[--$j]] = _3; /*4682*/
		}); /*4682*/
		$1.textfont = "" + $1.textfont; /*4684*/
		$1.textsize = +$1.textsize; /*4685*/
		$1.textxoffset = +$1.textxoffset; /*4686*/
		$1.textyoffset = +$1.textyoffset; /*4687*/
		$1.height = +$1.height; /*4688*/
		if (($1.barcode.length != 13) && ($1.barcode.length != 14)) { /*4693*/
			$k[$j++] = "bwipp.leitcodeBadLength"; /*4692*/
			$k[$j++] = "Deutsche Post Leitcode must be 13 or 14 digits"; /*4692*/
			$0.raiseerror(); /*4692*/
		} /*4692*/
		$forall($1.barcode, function() { /*4698*/
			var _D = $k[--$j]; /*4695*/
			if ((_D < 48) || (_D > 57)) { /*4697*/
				$k[$j++] = "bwipp.leitcodeBadCharacter"; /*4696*/
				$k[$j++] = "Deutsche Post Leitcode must contain only digits"; /*4696*/
				$0.raiseerror(); /*4696*/
			} /*4696*/
		}); /*4696*/
		$1.checksum = 0; /*4701*/
		for (var _E = 0; _E <= 12; _E += 1) { /*4705*/
			$1.i = _E; /*4703*/
			$k[$j++] = "checksum"; /*4704*/
			$k[$j++] = $1.checksum; /*4704*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*4704*/
			if (($1.i % 2) == 0) { /*4704*/
				var _K = $k[--$j]; /*4704*/
				$k[$j++] = _K * 4; /*4704*/
			} else { /*4704*/
				var _L = $k[--$j]; /*4704*/
				$k[$j++] = _L * 9; /*4704*/
			} /*4704*/
			var _M = $k[--$j]; /*4704*/
			var _N = $k[--$j]; /*4704*/
			$1[$k[--$j]] = _N + _M; /*4704*/
		} /*4704*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4706*/
		if ($1.barcode.length == 14) { /*4711*/
			if ($get($1.barcode, 13) != ($1.checksum + 48)) { /*4710*/
				$k[$j++] = "bwipp.leitcodeBadCheckDigit"; /*4709*/
				$k[$j++] = "Incorrect Deutsche Post Leitcode check digit provided"; /*4709*/
				$0.raiseerror(); /*4709*/
			} /*4709*/
		} /*4709*/
		var _U = $s(14); /*4712*/
		$puti(_U, 0, $1.barcode); /*4713*/
		$put(_U, 13, $1.checksum + 48); /*4714*/
		$1.barcode = _U; /*4715*/
		$1.text = $strcpy($s(18), "     .   .   .    "); /*4718*/
		$puti($1.text, 0, $geti($1.barcode, 0, 5)); /*4719*/
		$puti($1.text, 6, $geti($1.barcode, 5, 3)); /*4720*/
		$puti($1.text, 10, $geti($1.barcode, 8, 3)); /*4721*/
		$puti($1.text, 14, $geti($1.barcode, 11, 2)); /*4722*/
		$puti($1.text, 17, $geti($1.barcode, 13, 1)); /*4723*/
		$1.options.dontdraw = true; /*4726*/
		$1.options.includecheck = false; /*4727*/
		$k[$j++] = "args"; /*4728*/
		$k[$j++] = $1.barcode; /*4728*/
		$k[$j++] = $1.options; /*4728*/
		$0.interleaved2of5(); /*4728*/
		var _s = $k[--$j]; /*4728*/
		$1[$k[--$j]] = _s; /*4728*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4730*/
		$1.args.textxalign = "center"; /*4731*/
		$1.args.opt = $1.options; /*4732*/
		$k[$j++] = $1.args; /*4735*/
		if (!$1.dontdraw) { /*4735*/
			$0.renlinear(); /*4735*/
		} /*4735*/
	};
	$0.databaromni = function() {
		var $1 = {}; /*4763*/
		$1.options = $k[--$j]; /*4765*/
		$1.barcode = $k[--$j]; /*4766*/
		$1.dontdraw = false; /*4768*/
		$1.height = 33 / 72; /*4769*/
		$1.linkage = false; /*4770*/
		$1.format = "omni"; /*4771*/
		$forall($1.options, function() { /*4782*/
			var _3 = $k[--$j]; /*4782*/
			$1[$k[--$j]] = _3; /*4782*/
		}); /*4782*/
		if ($eq($1.format, "truncated")) { /*4784*/
			$1.height = 13 / 72; /*4784*/
		} /*4784*/
		$1.height = +$1.height; /*4785*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*4790*/
			$k[$j++] = "bwipp.databaromniBadAI"; /*4789*/
			$k[$j++] = "GS1 DataBar Omnidirectional must begin with (01) application identifier"; /*4789*/
			$0.raiseerror(); /*4789*/
		} /*4789*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*4793*/
			$k[$j++] = "bwipp.databaromniBadLength"; /*4792*/
			$k[$j++] = "GS1 DataBar Omnidirectional must be 13 or 14 digits"; /*4792*/
			$0.raiseerror(); /*4792*/
		} /*4792*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*4798*/
			var _E = $k[--$j]; /*4795*/
			if ((_E < 48) || (_E > 57)) { /*4797*/
				$k[$j++] = "bwipp.databaromniBadCharacter"; /*4796*/
				$k[$j++] = "GS1 DataBar Omnidirectional must contain only digits"; /*4796*/
				$0.raiseerror(); /*4796*/
			} /*4796*/
		}); /*4796*/
		$1.checksum = 0; /*4801*/
		for (var _F = 0; _F <= 12; _F += 1) { /*4805*/
			$1.i = _F; /*4803*/
			$k[$j++] = "checksum"; /*4804*/
			$k[$j++] = $1.checksum; /*4804*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*4804*/
			if (($1.i % 2) == 0) { /*4804*/
				var _L = $k[--$j]; /*4804*/
				$k[$j++] = _L * 3; /*4804*/
			} /*4804*/
			var _M = $k[--$j]; /*4804*/
			var _N = $k[--$j]; /*4804*/
			$1[$k[--$j]] = _N + _M; /*4804*/
		} /*4804*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4806*/
		if ($1.barcode.length == 18) { /*4811*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*4810*/
				$k[$j++] = "bwipp.databaromniBadCheckDigit"; /*4809*/
				$k[$j++] = "Incorrect GS1 DataBar Omnidirectional check digit provided"; /*4809*/
				$0.raiseerror(); /*4809*/
			} /*4809*/
		} /*4809*/
		var _U = $s(18); /*4812*/
		$puti(_U, 0, $1.barcode); /*4813*/
		$put(_U, 17, $1.checksum + 48); /*4814*/
		$1.barcode = _U; /*4815*/
		$1.txt = $a($1.barcode.length); /*4818*/
		for (var _b = 0, _a = $1.barcode.length - 1; _b <= _a; _b += 1) { /*4822*/
			$1.i = _b; /*4820*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*4821*/
		} /*4821*/
		$1.ncr = function() {
			var _i = $k[--$j]; /*4825*/
			var _j = $k[--$j]; /*4825*/
			var _k = _j - _i; /*4825*/
			if (_i < (_j - _i)) { /*4825*/
				var _ = _k; /*4825*/
				_k = _i; /*4825*/
				_i = _; /*4825*/
			} /*4825*/
			$k[$j++] = _k; /*4832*/
			$k[$j++] = 1; /*4832*/
			$k[$j++] = 1; /*4832*/
			for (var _m = _j, _l = _i + 1; _m >= _l; _m -= 1) { /*4832*/
				var _n = $k[--$j]; /*4828*/
				var _o = $k[--$j]; /*4829*/
				var _p = $k[--$j]; /*4829*/
				$k[$j++] = _p; /*4831*/
				$k[$j++] = _o; /*4831*/
				$k[$j++] = _n * _m; /*4831*/
				if ($le(_o, _p)) { /*4831*/
					var _q = $k[--$j]; /*4830*/
					var _r = $k[--$j]; /*4830*/
					$k[$j++] = _r + 1; /*4830*/
					$k[$j++] = ~~(_q / _r); /*4830*/
				} /*4830*/
			} /*4830*/
			for (;;) { /*4836*/
				var _s = $k[--$j]; /*4834*/
				var _t = $k[--$j]; /*4834*/
				var _u = $k[--$j]; /*4834*/
				$k[$j++] = _u; /*4834*/
				$k[$j++] = _t; /*4834*/
				$k[$j++] = _s; /*4834*/
				if ($gt(_t, _u)) { /*4834*/
					break; /*4834*/
				} /*4834*/
				var _v = $k[--$j]; /*4835*/
				var _w = $k[--$j]; /*4835*/
				$k[$j++] = _w + 1; /*4835*/
				$k[$j++] = ~~(_v / _w); /*4835*/
			} /*4835*/
			var _x = $k[--$j]; /*4837*/
			var _y = $k[--$j]; /*4837*/
			var _z = $k[--$j]; /*4837*/
			$k[$j++] = _x; /*4837*/
		}; /*4838*/
		$1.getRSSwidths = function() {
			$1.oe = $k[--$j]; /*4841*/
			$1.el = $k[--$j]; /*4842*/
			$1.mw = $k[--$j]; /*4843*/
			$1.nm = $k[--$j]; /*4844*/
			$1.val = $k[--$j]; /*4845*/
			$1.out = $a($1.el); /*4846*/
			$1.mask = 0; /*4847*/
			for (var _19 = 0, _18 = $1.el - 2; _19 <= _18; _19 += 1) { /*4874*/
				$1.bar = _19; /*4849*/
				$1.ew = 1; /*4850*/
				var _1B = $1.bar; /*4851*/
				$1.mask = $1.mask | ((_1B < 0 ? 1 >>> -_1B : 1 << _1B)); /*4851*/
				for (;;) { /*4870*/
					$k[$j++] = "sval"; /*4852*/
					$k[$j++] = ($1.nm - $1.ew) - 1; /*4852*/
					$k[$j++] = ($1.el - $1.bar) - 2; /*4852*/
					$1.ncr(); /*4852*/
					var _1G = $k[--$j]; /*4852*/
					$1[$k[--$j]] = _1G; /*4852*/
					if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*4855*/
						$k[$j++] = "sval"; /*4854*/
						$k[$j++] = $1.sval; /*4854*/
						$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*4854*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*4854*/
						$1.ncr(); /*4854*/
						var _1V = $k[--$j]; /*4854*/
						var _1W = $k[--$j]; /*4854*/
						$1[$k[--$j]] = _1W - _1V; /*4854*/
					} /*4854*/
					if (($1.el - $1.bar) > 2) { /*4864*/
						$1.lval = 0; /*4857*/
						for (var _1g = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _1f = $1.mw + 1; _1g >= _1f; _1g -= 1) { /*4861*/
							$k[$j++] = (($1.nm - _1g) - $1.ew) - 1; /*4859*/
							$k[$j++] = ($1.el - $1.bar) - 3; /*4859*/
							$1.ncr(); /*4859*/
							$1.lval = $k[--$j] + $1.lval; /*4860*/
						} /*4860*/
						$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*4862*/
					} else { /*4864*/
						if (($1.nm - $1.ew) > $1.mw) { /*4864*/
							$1.sval = $1.sval - 1; /*4864*/
						} /*4864*/
					} /*4864*/
					$1.val = $1.val - $1.sval; /*4866*/
					if ($1.val < 0) { /*4867*/
						break; /*4867*/
					} /*4867*/
					$1.ew = $1.ew + 1; /*4868*/
					var _20 = $1.bar; /*4869*/
					$1.mask = $1.mask & (~((_20 < 0 ? 1 >>> -_20 : 1 << _20))); /*4869*/
				} /*4869*/
				$1.val = $1.val + $1.sval; /*4871*/
				$1.nm = $1.nm - $1.ew; /*4872*/
				$put($1.out, $1.bar, $1.ew); /*4873*/
			} /*4873*/
			$put($1.out, $1.el - 1, $1.nm); /*4875*/
			$k[$j++] = $1.out; /*4876*/
		}; /*4877*/
		$k[$j++] = Infinity; /*4882*/
		var _2D = $1.linkage ? 1 : 0; /*4880*/
		$k[$j++] = _2D; /*4881*/
		$forall($geti($1.barcode, 4, 13), function() { /*4881*/
			var _2G = $k[--$j]; /*4881*/
			$k[$j++] = _2G - 48; /*4881*/
		}); /*4881*/
		$1.binval = $a(); /*4882*/
		for (var _2I = 0; _2I <= 12; _2I += 1) { /*4888*/
			$1.i = _2I; /*4885*/
			var _2J = $1.binval; /*4886*/
			var _2K = $1.i; /*4886*/
			$put(_2J, _2K + 1, $get(_2J, _2K + 1) + (($get($1.binval, $1.i) % 4537077) * 10)); /*4886*/
			$put($1.binval, $1.i, ~~($get($1.binval, $1.i) / 4537077)); /*4887*/
		} /*4887*/
		$1.right = $get($1.binval, 13) % 4537077; /*4889*/
		var _2W = $1.binval; /*4890*/
		$put(_2W, 13, ~~($get(_2W, 13) / 4537077)); /*4890*/
		$1.left = 0; /*4892*/
		$1.i = true; /*4893*/
		for (var _2Y = 0; _2Y <= 13; _2Y += 1) { /*4903*/
			$1.j = _2Y; /*4895*/
			var _2b = $get($1.binval, $1.j); /*4896*/
			$k[$j++] = _2b; /*4902*/
			if ((_2b == 0) && $1.i) { /*4901*/
				$j--; /*4898*/
			} else { /*4901*/
				$1.i = false; /*4900*/
				$1.left = $1.left + ($k[--$j] * (~~Math.pow(10, 13 - $1.j))); /*4901*/
			} /*4901*/
		} /*4901*/
		$1.d1 = ~~($1.left / 1597); /*4905*/
		$1.d2 = $1.left % 1597; /*4906*/
		$1.d3 = ~~($1.right / 1597); /*4907*/
		$1.d4 = $1.right % 1597; /*4908*/
		$1.tab164 = $a([160, 0, 12, 4, 8, 1, 161, 1, 960, 161, 10, 6, 6, 3, 80, 10, 2014, 961, 8, 8, 4, 5, 31, 34, 2714, 2015, 6, 10, 3, 6, 10, 70, 2840, 2715, 4, 12, 1, 8, 1, 126]); /*4916*/
		$1.tab154 = $a([335, 0, 5, 10, 2, 7, 4, 84, 1035, 336, 7, 8, 4, 5, 20, 35, 1515, 1036, 9, 6, 6, 3, 48, 10, 1596, 1516, 11, 4, 8, 1, 81, 1]); /*4923*/
		$1.i = 0; /*4925*/
		for (;;) { /*4935*/
			if ($1.d1 <= $get($1.tab164, $1.i)) { /*4933*/
				$forall($geti($1.tab164, $1.i + 1, 7)); /*4927*/
				$1.d1te = $k[--$j]; /*4928*/
				$1.d1to = $k[--$j]; /*4928*/
				$1.d1mwe = $k[--$j]; /*4929*/
				$1.d1mwo = $k[--$j]; /*4929*/
				$1.d1ele = $k[--$j]; /*4930*/
				$1.d1elo = $k[--$j]; /*4930*/
				$1.d1gs = $k[--$j]; /*4931*/
				break; /*4932*/
			} /*4932*/
			$1.i = $1.i + 8; /*4934*/
		} /*4934*/
		$1.i = 0; /*4937*/
		for (;;) { /*4947*/
			if ($1.d2 <= $get($1.tab154, $1.i)) { /*4945*/
				$forall($geti($1.tab154, $1.i + 1, 7)); /*4939*/
				$1.d2te = $k[--$j]; /*4940*/
				$1.d2to = $k[--$j]; /*4940*/
				$1.d2mwe = $k[--$j]; /*4941*/
				$1.d2mwo = $k[--$j]; /*4941*/
				$1.d2ele = $k[--$j]; /*4942*/
				$1.d2elo = $k[--$j]; /*4942*/
				$1.d2gs = $k[--$j]; /*4943*/
				break; /*4944*/
			} /*4944*/
			$1.i = $1.i + 8; /*4946*/
		} /*4946*/
		$1.i = 0; /*4949*/
		for (;;) { /*4959*/
			if ($1.d3 <= $get($1.tab164, $1.i)) { /*4957*/
				$forall($geti($1.tab164, $1.i + 1, 7)); /*4951*/
				$1.d3te = $k[--$j]; /*4952*/
				$1.d3to = $k[--$j]; /*4952*/
				$1.d3mwe = $k[--$j]; /*4953*/
				$1.d3mwo = $k[--$j]; /*4953*/
				$1.d3ele = $k[--$j]; /*4954*/
				$1.d3elo = $k[--$j]; /*4954*/
				$1.d3gs = $k[--$j]; /*4955*/
				break; /*4956*/
			} /*4956*/
			$1.i = $1.i + 8; /*4958*/
		} /*4958*/
		$1.i = 0; /*4961*/
		for (;;) { /*4971*/
			if ($1.d4 <= $get($1.tab154, $1.i)) { /*4969*/
				$forall($geti($1.tab154, $1.i + 1, 7)); /*4963*/
				$1.d4te = $k[--$j]; /*4964*/
				$1.d4to = $k[--$j]; /*4964*/
				$1.d4mwe = $k[--$j]; /*4965*/
				$1.d4mwo = $k[--$j]; /*4965*/
				$1.d4ele = $k[--$j]; /*4966*/
				$1.d4elo = $k[--$j]; /*4966*/
				$1.d4gs = $k[--$j]; /*4967*/
				break; /*4968*/
			} /*4968*/
			$1.i = $1.i + 8; /*4970*/
		} /*4970*/
		$k[$j++] = "d1wo"; /*4973*/
		$k[$j++] = ~~(($1.d1 - $1.d1gs) / $1.d1te); /*4973*/
		$k[$j++] = $1.d1elo; /*4973*/
		$k[$j++] = $1.d1mwo; /*4973*/
		$k[$j++] = 4; /*4973*/
		$k[$j++] = false; /*4973*/
		$1.getRSSwidths(); /*4973*/
		var _3p = $k[--$j]; /*4973*/
		$1[$k[--$j]] = _3p; /*4973*/
		$k[$j++] = "d1we"; /*4974*/
		$k[$j++] = ($1.d1 - $1.d1gs) % $1.d1te; /*4974*/
		$k[$j++] = $1.d1ele; /*4974*/
		$k[$j++] = $1.d1mwe; /*4974*/
		$k[$j++] = 4; /*4974*/
		$k[$j++] = true; /*4974*/
		$1.getRSSwidths(); /*4974*/
		var _3w = $k[--$j]; /*4974*/
		$1[$k[--$j]] = _3w; /*4974*/
		$k[$j++] = "d2wo"; /*4975*/
		$k[$j++] = ($1.d2 - $1.d2gs) % $1.d2to; /*4975*/
		$k[$j++] = $1.d2elo; /*4975*/
		$k[$j++] = $1.d2mwo; /*4975*/
		$k[$j++] = 4; /*4975*/
		$k[$j++] = true; /*4975*/
		$1.getRSSwidths(); /*4975*/
		var _43 = $k[--$j]; /*4975*/
		$1[$k[--$j]] = _43; /*4975*/
		$k[$j++] = "d2we"; /*4976*/
		$k[$j++] = ~~(($1.d2 - $1.d2gs) / $1.d2to); /*4976*/
		$k[$j++] = $1.d2ele; /*4976*/
		$k[$j++] = $1.d2mwe; /*4976*/
		$k[$j++] = 4; /*4976*/
		$k[$j++] = false; /*4976*/
		$1.getRSSwidths(); /*4976*/
		var _4A = $k[--$j]; /*4976*/
		$1[$k[--$j]] = _4A; /*4976*/
		$k[$j++] = "d3wo"; /*4977*/
		$k[$j++] = ~~(($1.d3 - $1.d3gs) / $1.d3te); /*4977*/
		$k[$j++] = $1.d3elo; /*4977*/
		$k[$j++] = $1.d3mwo; /*4977*/
		$k[$j++] = 4; /*4977*/
		$k[$j++] = false; /*4977*/
		$1.getRSSwidths(); /*4977*/
		var _4H = $k[--$j]; /*4977*/
		$1[$k[--$j]] = _4H; /*4977*/
		$k[$j++] = "d3we"; /*4978*/
		$k[$j++] = ($1.d3 - $1.d3gs) % $1.d3te; /*4978*/
		$k[$j++] = $1.d3ele; /*4978*/
		$k[$j++] = $1.d3mwe; /*4978*/
		$k[$j++] = 4; /*4978*/
		$k[$j++] = true; /*4978*/
		$1.getRSSwidths(); /*4978*/
		var _4O = $k[--$j]; /*4978*/
		$1[$k[--$j]] = _4O; /*4978*/
		$k[$j++] = "d4wo"; /*4979*/
		$k[$j++] = ($1.d4 - $1.d4gs) % $1.d4to; /*4979*/
		$k[$j++] = $1.d4elo; /*4979*/
		$k[$j++] = $1.d4mwo; /*4979*/
		$k[$j++] = 4; /*4979*/
		$k[$j++] = true; /*4979*/
		$1.getRSSwidths(); /*4979*/
		var _4V = $k[--$j]; /*4979*/
		$1[$k[--$j]] = _4V; /*4979*/
		$k[$j++] = "d4we"; /*4980*/
		$k[$j++] = ~~(($1.d4 - $1.d4gs) / $1.d4to); /*4980*/
		$k[$j++] = $1.d4ele; /*4980*/
		$k[$j++] = $1.d4mwe; /*4980*/
		$k[$j++] = 4; /*4980*/
		$k[$j++] = false; /*4980*/
		$1.getRSSwidths(); /*4980*/
		var _4c = $k[--$j]; /*4980*/
		$1[$k[--$j]] = _4c; /*4980*/
		$1.d1w = $a(8); /*4982*/
		for (var _4f = 0; _4f <= 3; _4f += 1) { /*4987*/
			$1.i = _4f; /*4984*/
			$put($1.d1w, $1.i * 2, $get($1.d1wo, $1.i)); /*4985*/
			$put($1.d1w, ($1.i * 2) + 1, $get($1.d1we, $1.i)); /*4986*/
		} /*4986*/
		$1.d2w = $a(8); /*4989*/
		for (var _4r = 0; _4r <= 3; _4r += 1) { /*4994*/
			$1.i = _4r; /*4991*/
			$put($1.d2w, 7 - ($1.i * 2), $get($1.d2wo, $1.i)); /*4992*/
			$put($1.d2w, 6 - ($1.i * 2), $get($1.d2we, $1.i)); /*4993*/
		} /*4993*/
		$1.d3w = $a(8); /*4996*/
		for (var _53 = 0; _53 <= 3; _53 += 1) { /*5001*/
			$1.i = _53; /*4998*/
			$put($1.d3w, 7 - ($1.i * 2), $get($1.d3wo, $1.i)); /*4999*/
			$put($1.d3w, 6 - ($1.i * 2), $get($1.d3we, $1.i)); /*5000*/
		} /*5000*/
		$1.d4w = $a(8); /*5003*/
		for (var _5F = 0; _5F <= 3; _5F += 1) { /*5008*/
			$1.i = _5F; /*5005*/
			$put($1.d4w, $1.i * 2, $get($1.d4wo, $1.i)); /*5006*/
			$put($1.d4w, ($1.i * 2) + 1, $get($1.d4we, $1.i)); /*5007*/
		} /*5007*/
		$k[$j++] = Infinity; /*5015*/
		var _5Q = $1.d1w; /*5011*/
		for (var _5R = 0, _5S = _5Q.length; _5R < _5S; _5R++) { /*5011*/
			$k[$j++] = $get(_5Q, _5R); /*5011*/
		} /*5011*/
		var _5U = $1.d2w; /*5012*/
		for (var _5V = 0, _5W = _5U.length; _5V < _5W; _5V++) { /*5012*/
			$k[$j++] = $get(_5U, _5V); /*5012*/
		} /*5012*/
		var _5Y = $1.d3w; /*5013*/
		for (var _5Z = 0, _5a = _5Y.length; _5Z < _5a; _5Z++) { /*5013*/
			$k[$j++] = $get(_5Y, _5Z); /*5013*/
		} /*5013*/
		var _5c = $1.d4w; /*5014*/
		for (var _5d = 0, _5e = _5c.length; _5d < _5e; _5d++) { /*5014*/
			$k[$j++] = $get(_5c, _5d); /*5014*/
		} /*5014*/
		$1.widths = $a(); /*5015*/
		$1.checkweights = $a([1, 3, 9, 27, 2, 6, 18, 54, 58, 72, 24, 8, 29, 36, 12, 4, 74, 51, 17, 32, 37, 65, 48, 16, 64, 34, 23, 69, 49, 68, 46, 59]); /*5022*/
		$1.checkwidths = $a([3, 8, 2, 1, 1, 3, 5, 5, 1, 1, 3, 3, 7, 1, 1, 3, 1, 9, 1, 1, 2, 7, 4, 1, 1, 2, 5, 6, 1, 1, 2, 3, 8, 1, 1, 1, 5, 7, 1, 1, 1, 3, 9, 1, 1]); /*5028*/
		$1.checksum = 0; /*5030*/
		for (var _5j = 0; _5j <= 31; _5j += 1) { /*5034*/
			$1.i = _5j; /*5032*/
			$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweights, $1.i)); /*5033*/
		} /*5033*/
		$1.checksum = $1.checksum % 79; /*5035*/
		if ($1.checksum >= 8) { /*5036*/
			$1.checksum = $1.checksum + 1; /*5036*/
		} /*5036*/
		if ($1.checksum >= 72) { /*5037*/
			$1.checksum = $1.checksum + 1; /*5037*/
		} /*5037*/
		$1.checklt = $geti($1.checkwidths, (~~($1.checksum / 9)) * 5, 5); /*5038*/
		$1.checkrtrev = $geti($1.checkwidths, ($1.checksum % 9) * 5, 5); /*5039*/
		$1.checkrt = $a(5); /*5040*/
		for (var _63 = 0; _63 <= 4; _63 += 1) { /*5044*/
			$1.i = _63; /*5042*/
			$put($1.checkrt, $1.i, $get($1.checkrtrev, 4 - $1.i)); /*5043*/
		} /*5043*/
		if ($eq($1.format, "omni") || $eq($1.format, "truncated")) { /*5163*/
			$k[$j++] = Infinity; /*5052*/
			var _6B = $1.d1w; /*5050*/
			$k[$j++] = 1; /*5050*/
			for (var _6C = 0, _6D = _6B.length; _6C < _6D; _6C++) { /*5050*/
				$k[$j++] = $get(_6B, _6C); /*5050*/
			} /*5050*/
			$forall($1.checklt); /*5050*/
			var _6G = $1.d2w; /*5050*/
			for (var _6H = 0, _6I = _6G.length; _6H < _6I; _6H++) { /*5050*/
				$k[$j++] = $get(_6G, _6H); /*5050*/
			} /*5050*/
			var _6K = $1.d4w; /*5051*/
			for (var _6L = 0, _6M = _6K.length; _6L < _6M; _6L++) { /*5051*/
				$k[$j++] = $get(_6K, _6L); /*5051*/
			} /*5051*/
			var _6O = $1.checkrt; /*5051*/
			for (var _6P = 0, _6Q = _6O.length; _6P < _6Q; _6P++) { /*5051*/
				$k[$j++] = $get(_6O, _6P); /*5051*/
			} /*5051*/
			var _6S = $1.d3w; /*5051*/
			for (var _6T = 0, _6U = _6S.length; _6T < _6U; _6T++) { /*5051*/
				$k[$j++] = $get(_6S, _6T); /*5051*/
			} /*5051*/
			$k[$j++] = 1; /*5051*/
			$k[$j++] = 1; /*5051*/
			$1.sbs = $a(); /*5052*/
			$k[$j++] = Infinity; /*5061*/
			$k[$j++] = "ren"; /*5058*/
			$k[$j++] = $0.renlinear; /*5058*/
			$k[$j++] = "sbs"; /*5058*/
			$k[$j++] = $1.sbs; /*5058*/
			$k[$j++] = "bhs"; /*5058*/
			$k[$j++] = Infinity; /*5058*/
			for (var _6Z = 0, _6a = ~~(($1.sbs.length + 1) / 2); _6Z < _6a; _6Z++) { /*5057*/
				$k[$j++] = $1.height; /*5057*/
			} /*5057*/
			var _6c = $a(); /*5058*/
			$k[$j++] = _6c; /*5059*/
			$k[$j++] = "bbs"; /*5059*/
			$k[$j++] = Infinity; /*5059*/
			for (var _6e = 0, _6f = ~~(($1.sbs.length + 1) / 2); _6e < _6f; _6e++) { /*5058*/
				$k[$j++] = 0; /*5058*/
			} /*5058*/
			var _6g = $a(); /*5059*/
			$k[$j++] = _6g; /*5061*/
			$k[$j++] = "txt"; /*5061*/
			$k[$j++] = $1.txt; /*5061*/
			$k[$j++] = "textxalign"; /*5061*/
			$k[$j++] = "center"; /*5061*/
			$k[$j++] = "opt"; /*5061*/
			$k[$j++] = $1.options; /*5061*/
			var _6j = $d(); /*5061*/
			$k[$j++] = _6j; /*5064*/
			if (!$1.dontdraw) { /*5064*/
				$0.renlinear(); /*5064*/
			} /*5064*/
		} else { /*5163*/
			$k[$j++] = Infinity; /*5068*/
			var _6l = $1.d1w; /*5068*/
			$k[$j++] = 1; /*5068*/
			$k[$j++] = 1; /*5068*/
			for (var _6m = 0, _6n = _6l.length; _6m < _6n; _6m++) { /*5068*/
				$k[$j++] = $get(_6l, _6m); /*5068*/
			} /*5068*/
			$forall($1.checklt); /*5068*/
			var _6q = $1.d2w; /*5068*/
			for (var _6r = 0, _6s = _6q.length; _6r < _6s; _6r++) { /*5068*/
				$k[$j++] = $get(_6q, _6r); /*5068*/
			} /*5068*/
			$k[$j++] = 1; /*5068*/
			$k[$j++] = 1; /*5068*/
			$k[$j++] = 0; /*5068*/
			$1.top = $a(); /*5068*/
			$k[$j++] = Infinity; /*5069*/
			var _6v = $1.d4w; /*5069*/
			$k[$j++] = 1; /*5069*/
			$k[$j++] = 1; /*5069*/
			for (var _6w = 0, _6x = _6v.length; _6w < _6x; _6w++) { /*5069*/
				$k[$j++] = $get(_6v, _6w); /*5069*/
			} /*5069*/
			var _6z = $1.checkrt; /*5069*/
			for (var _70 = 0, _71 = _6z.length; _70 < _71; _70++) { /*5069*/
				$k[$j++] = $get(_6z, _70); /*5069*/
			} /*5069*/
			var _73 = $1.d3w; /*5069*/
			for (var _74 = 0, _75 = _73.length; _74 < _75; _74++) { /*5069*/
				$k[$j++] = $get(_73, _74); /*5069*/
			} /*5069*/
			$k[$j++] = 1; /*5069*/
			$k[$j++] = 1; /*5069*/
			$k[$j++] = 0; /*5069*/
			$1.bot = $a(); /*5069*/
			for (var _78 = 0; _78 <= 24; _78 += 2) { /*5074*/
				$1.i = _78; /*5071*/
				for (var _7C = 0, _7D = $get($1.top, $1.i); _7C < _7D; _7C++) { /*5072*/
					$k[$j++] = 0; /*5072*/
				} /*5072*/
				for (var _7H = 0, _7I = $get($1.top, $1.i + 1); _7H < _7I; _7H++) { /*5073*/
					$k[$j++] = 1; /*5073*/
				} /*5073*/
			} /*5073*/
			$astore($a(50)); /*5075*/
			$1.top = $k[--$j]; /*5075*/
			for (var _7L = 0; _7L <= 24; _7L += 2) { /*5080*/
				$1.i = _7L; /*5077*/
				for (var _7P = 0, _7Q = $get($1.bot, $1.i); _7P < _7Q; _7P++) { /*5078*/
					$k[$j++] = 1; /*5078*/
				} /*5078*/
				for (var _7U = 0, _7V = $get($1.bot, $1.i + 1); _7U < _7V; _7U++) { /*5079*/
					$k[$j++] = 0; /*5079*/
				} /*5079*/
			} /*5079*/
			$astore($a(50)); /*5081*/
			$1.bot = $k[--$j]; /*5081*/
			if ($eq($1.format, "stacked")) { /*5100*/
				$k[$j++] = Infinity; /*5085*/
				for (var _7Z = 0, _7a = 50; _7Z < _7a; _7Z++) { /*5085*/
					$k[$j++] = 0; /*5085*/
				} /*5085*/
				$1.sep = $a(); /*5085*/
				for (var _7c = 4; _7c <= 45; _7c += 1) { /*5093*/
					$1.i = _7c; /*5087*/
					if ($eq($get($1.top, $1.i), $get($1.bot, $1.i))) { /*5091*/
						$put($1.sep, $1.i, 1 - $get($1.top, $1.i)); /*5089*/
					} else { /*5091*/
						$put($1.sep, $1.i, 1 - $get($1.sep, $1.i - 1)); /*5091*/
					} /*5091*/
				} /*5091*/
				$k[$j++] = Infinity; /*5098*/
				for (var _7t = 0, _7u = 5; _7t < _7u; _7t++) { /*5095*/
					$aload($1.top); /*5095*/
				} /*5095*/
				$aload($1.sep); /*5096*/
				for (var _7x = 0, _7y = 7; _7x < _7y; _7x++) { /*5097*/
					$aload($1.bot); /*5097*/
				} /*5097*/
				$1.pixs = $a(); /*5098*/
				$1.pixy = ~~($1.pixs.length / 50); /*5099*/
			} /*5099*/
			if ($eq($1.format, "stackedomni")) { /*5150*/
				$k[$j++] = Infinity; /*5104*/
				$forall($1.top, function() { /*5104*/
					var _84 = $k[--$j]; /*5104*/
					$k[$j++] = 1 - _84; /*5104*/
				}); /*5104*/
				$1.sep1 = $a(); /*5104*/
				$puti($1.sep1, 0, $a([0, 0, 0, 0])); /*5105*/
				$puti($1.sep1, 46, $a([0, 0, 0, 0])); /*5106*/
				for (var _8A = 18; _8A <= 30; _8A += 1) { /*5119*/
					$1.i = _8A; /*5108*/
					if ($get($1.top, $1.i) == 0) { /*5116*/
						if ($get($1.top, $1.i - 1) == 1) { /*5113*/
							$k[$j++] = 1; /*5111*/
						} else { /*5113*/
							var _8K = ($get($1.sep1, $1.i - 1) == 0) ? 1 : 0; /*5113*/
							$k[$j++] = _8K; /*5113*/
						} /*5113*/
					} else { /*5116*/
						$k[$j++] = 0; /*5116*/
					} /*5116*/
					$put($1.sep1, $1.i, $k[--$j]); /*5118*/
				} /*5118*/
				$k[$j++] = Infinity; /*5120*/
				$k[$j++] = 0; /*5120*/
				$k[$j++] = 0; /*5120*/
				$k[$j++] = 0; /*5120*/
				$k[$j++] = 0; /*5120*/
				for (var _8O = 0, _8P = 21; _8O < _8P; _8O++) { /*5120*/
					$k[$j++] = 0; /*5120*/
					$k[$j++] = 1; /*5120*/
				} /*5120*/
				$k[$j++] = 0; /*5120*/
				$k[$j++] = 0; /*5120*/
				$k[$j++] = 0; /*5120*/
				$k[$j++] = 0; /*5120*/
				$1.sep2 = $a(); /*5120*/
				$k[$j++] = Infinity; /*5121*/
				$forall($1.bot, function() { /*5121*/
					var _8S = $k[--$j]; /*5121*/
					$k[$j++] = 1 - _8S; /*5121*/
				}); /*5121*/
				$1.sep3 = $a(); /*5121*/
				$puti($1.sep3, 0, $a([0, 0, 0, 0])); /*5122*/
				$puti($1.sep3, 46, $a([0, 0, 0, 0])); /*5123*/
				for (var _8Y = 19; _8Y <= 31; _8Y += 1) { /*5136*/
					$1.i = _8Y; /*5125*/
					if ($get($1.bot, $1.i) == 0) { /*5133*/
						if ($get($1.bot, $1.i - 1) == 1) { /*5130*/
							$k[$j++] = 1; /*5128*/
						} else { /*5130*/
							var _8i = ($get($1.sep3, $1.i - 1) == 0) ? 1 : 0; /*5130*/
							$k[$j++] = _8i; /*5130*/
						} /*5130*/
					} else { /*5133*/
						$k[$j++] = 0; /*5133*/
					} /*5133*/
					$put($1.sep3, $1.i, $k[--$j]); /*5135*/
				} /*5135*/
				$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*5137*/
				$k[$j++] = true; /*5138*/
				for (var _8n = 0; _8n <= 12; _8n += 1) { /*5138*/
					var _8s = $k[--$j]; /*5138*/
					$k[$j++] = _8s && $eq($get($1.bot, _8n + 19), $get($1.f3, _8n)); /*5138*/
				} /*5138*/
				if ($k[--$j]) { /*5141*/
					$puti($1.sep3, 19, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*5140*/
				} /*5140*/
				$k[$j++] = Infinity; /*5148*/
				for (var _8w = 0, _8x = 33; _8w < _8x; _8w++) { /*5143*/
					$aload($1.top); /*5143*/
				} /*5143*/
				$aload($1.sep1); /*5144*/
				$aload($1.sep2); /*5145*/
				$aload($1.sep3); /*5146*/
				for (var _92 = 0, _93 = 33; _92 < _93; _92++) { /*5147*/
					$aload($1.bot); /*5147*/
				} /*5147*/
				$1.pixs = $a(); /*5148*/
				$1.pixy = ~~($1.pixs.length / 50); /*5149*/
			} /*5149*/
			var _9B = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: 50,
				pixy: $1.pixy,
				height: $1.pixy / 72,
				width: 50 / 72,
				opt: $1.options
			}; /*5160*/
			$k[$j++] = _9B; /*5163*/
			if (!$1.dontdraw) { /*5163*/
				$0.renmatrix(); /*5163*/
			} /*5163*/
		} /*5163*/
	};
	$0.databarstacked = function() {
		var $1 = {}; /*5193*/
		$1.options = $k[--$j]; /*5195*/
		$1.barcode = $k[--$j]; /*5196*/
		$1.dontdraw = false; /*5198*/
		$forall($1.options, function() { /*5209*/
			var _3 = $k[--$j]; /*5209*/
			$1[$k[--$j]] = _3; /*5209*/
		}); /*5209*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5214*/
			$k[$j++] = "bwipp.databarstackedBadAI"; /*5213*/
			$k[$j++] = "GS1 DataBar Stacked must begin with (01) application identifier"; /*5213*/
			$0.raiseerror(); /*5213*/
		} /*5213*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5217*/
			$k[$j++] = "bwipp.databarstackedBadLength"; /*5216*/
			$k[$j++] = "GS1 DataBar Stacked must be 13 or 14 digits"; /*5216*/
			$0.raiseerror(); /*5216*/
		} /*5216*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5222*/
			var _C = $k[--$j]; /*5219*/
			if ((_C < 48) || (_C > 57)) { /*5221*/
				$k[$j++] = "bwipp.databarstackedBadCharacter"; /*5220*/
				$k[$j++] = "GS1 DataBar Stacked must contain only digits"; /*5220*/
				$0.raiseerror(); /*5220*/
			} /*5220*/
		}); /*5220*/
		$1.checksum = 0; /*5225*/
		for (var _D = 0; _D <= 12; _D += 1) { /*5229*/
			$1.i = _D; /*5227*/
			$k[$j++] = "checksum"; /*5228*/
			$k[$j++] = $1.checksum; /*5228*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5228*/
			if (($1.i % 2) == 0) { /*5228*/
				var _J = $k[--$j]; /*5228*/
				$k[$j++] = _J * 3; /*5228*/
			} /*5228*/
			var _K = $k[--$j]; /*5228*/
			var _L = $k[--$j]; /*5228*/
			$1[$k[--$j]] = _L + _K; /*5228*/
		} /*5228*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5230*/
		if ($1.barcode.length == 18) { /*5235*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5234*/
				$k[$j++] = "bwipp.databarstackedBadCheckDigit"; /*5233*/
				$k[$j++] = "Incorrect GS1 DataBar Stacked check digit provided"; /*5233*/
				$0.raiseerror(); /*5233*/
			} /*5233*/
		} /*5233*/
		var _S = $s(18); /*5236*/
		$puti(_S, 0, $1.barcode); /*5237*/
		$put(_S, 17, $1.checksum + 48); /*5238*/
		$1.barcode = _S; /*5239*/
		$1.options.dontdraw = true; /*5242*/
		$1.options.format = "stacked"; /*5243*/
		$k[$j++] = "args"; /*5245*/
		$k[$j++] = $1.barcode; /*5245*/
		$k[$j++] = $1.options; /*5245*/
		$0.databaromni(); /*5245*/
		var _Z = $k[--$j]; /*5245*/
		$1[$k[--$j]] = _Z; /*5245*/
		$1.args.opt = $1.options; /*5247*/
		$k[$j++] = $1.args; /*5250*/
		if (!$1.dontdraw) { /*5250*/
			$0.renmatrix(); /*5250*/
		} /*5250*/
	};
	$0.databarstackedomni = function() {
		var $1 = {}; /*5278*/
		$1.options = $k[--$j]; /*5280*/
		$1.barcode = $k[--$j]; /*5281*/
		$1.dontdraw = false; /*5283*/
		$forall($1.options, function() { /*5294*/
			var _3 = $k[--$j]; /*5294*/
			$1[$k[--$j]] = _3; /*5294*/
		}); /*5294*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5299*/
			$k[$j++] = "bwipp.databarstackedomniBadAI"; /*5298*/
			$k[$j++] = "GS1 DataBar Stacked Omnidirectional must begin with (01) application identifier"; /*5298*/
			$0.raiseerror(); /*5298*/
		} /*5298*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5302*/
			$k[$j++] = "bwipp.databarstackedomniBadLength"; /*5301*/
			$k[$j++] = "GS1 DataBar Stacked Omnidirectional must be 13 or 14 digits"; /*5301*/
			$0.raiseerror(); /*5301*/
		} /*5301*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5307*/
			var _C = $k[--$j]; /*5304*/
			if ((_C < 48) || (_C > 57)) { /*5306*/
				$k[$j++] = "bwipp.databarstackedomniBadCharacter"; /*5305*/
				$k[$j++] = "GS1 DataBar Stacked Omnidirectional must contain only digits"; /*5305*/
				$0.raiseerror(); /*5305*/
			} /*5305*/
		}); /*5305*/
		$1.checksum = 0; /*5310*/
		for (var _D = 0; _D <= 12; _D += 1) { /*5314*/
			$1.i = _D; /*5312*/
			$k[$j++] = "checksum"; /*5313*/
			$k[$j++] = $1.checksum; /*5313*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5313*/
			if (($1.i % 2) == 0) { /*5313*/
				var _J = $k[--$j]; /*5313*/
				$k[$j++] = _J * 3; /*5313*/
			} /*5313*/
			var _K = $k[--$j]; /*5313*/
			var _L = $k[--$j]; /*5313*/
			$1[$k[--$j]] = _L + _K; /*5313*/
		} /*5313*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5315*/
		if ($1.barcode.length == 18) { /*5320*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5319*/
				$k[$j++] = "bwipp.databarstackedomniBadCheckDigit"; /*5318*/
				$k[$j++] = "Incorrect GS1 DataBar Stacked Omnidirectional check digit provided"; /*5318*/
				$0.raiseerror(); /*5318*/
			} /*5318*/
		} /*5318*/
		var _S = $s(18); /*5321*/
		$puti(_S, 0, $1.barcode); /*5322*/
		$put(_S, 17, $1.checksum + 48); /*5323*/
		$1.barcode = _S; /*5324*/
		$1.options.dontdraw = true; /*5327*/
		$1.options.format = "stackedomni"; /*5328*/
		$k[$j++] = "args"; /*5330*/
		$k[$j++] = $1.barcode; /*5330*/
		$k[$j++] = $1.options; /*5330*/
		$0.databaromni(); /*5330*/
		var _Z = $k[--$j]; /*5330*/
		$1[$k[--$j]] = _Z; /*5330*/
		$1.args.opt = $1.options; /*5332*/
		$k[$j++] = $1.args; /*5335*/
		if (!$1.dontdraw) { /*5335*/
			$0.renmatrix(); /*5335*/
		} /*5335*/
	};
	$0.databartruncated = function() {
		var $1 = {}; /*5363*/
		$1.options = $k[--$j]; /*5365*/
		$1.barcode = $k[--$j]; /*5366*/
		$1.dontdraw = false; /*5368*/
		$forall($1.options, function() { /*5379*/
			var _3 = $k[--$j]; /*5379*/
			$1[$k[--$j]] = _3; /*5379*/
		}); /*5379*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5384*/
			$k[$j++] = "bwipp.databartruncatedBadAI"; /*5383*/
			$k[$j++] = "GS1 DataBar Truncated must begin with (01) application identifier"; /*5383*/
			$0.raiseerror(); /*5383*/
		} /*5383*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5387*/
			$k[$j++] = "bwipp.databartruncatedBadLength"; /*5386*/
			$k[$j++] = "GS1 DataBar Truncated must be 13 or 14 digits"; /*5386*/
			$0.raiseerror(); /*5386*/
		} /*5386*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5392*/
			var _C = $k[--$j]; /*5389*/
			if ((_C < 48) || (_C > 57)) { /*5391*/
				$k[$j++] = "bwipp.databartruncatedBadCharacter"; /*5390*/
				$k[$j++] = "GS1 DataBar Truncated must contain only digits"; /*5390*/
				$0.raiseerror(); /*5390*/
			} /*5390*/
		}); /*5390*/
		$1.checksum = 0; /*5395*/
		for (var _D = 0; _D <= 12; _D += 1) { /*5399*/
			$1.i = _D; /*5397*/
			$k[$j++] = "checksum"; /*5398*/
			$k[$j++] = $1.checksum; /*5398*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5398*/
			if (($1.i % 2) == 0) { /*5398*/
				var _J = $k[--$j]; /*5398*/
				$k[$j++] = _J * 3; /*5398*/
			} /*5398*/
			var _K = $k[--$j]; /*5398*/
			var _L = $k[--$j]; /*5398*/
			$1[$k[--$j]] = _L + _K; /*5398*/
		} /*5398*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5400*/
		if ($1.barcode.length == 18) { /*5405*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5404*/
				$k[$j++] = "bwipp.databartruncatedBadCheckDigit"; /*5403*/
				$k[$j++] = "Incorrect GS1 DataBar Truncated check digit provided"; /*5403*/
				$0.raiseerror(); /*5403*/
			} /*5403*/
		} /*5403*/
		var _S = $s(18); /*5406*/
		$puti(_S, 0, $1.barcode); /*5407*/
		$put(_S, 17, $1.checksum + 48); /*5408*/
		$1.barcode = _S; /*5409*/
		$1.options.dontdraw = true; /*5412*/
		$1.options.format = "truncated"; /*5413*/
		$k[$j++] = "args"; /*5415*/
		$k[$j++] = $1.barcode; /*5415*/
		$k[$j++] = $1.options; /*5415*/
		$0.databaromni(); /*5415*/
		var _Z = $k[--$j]; /*5415*/
		$1[$k[--$j]] = _Z; /*5415*/
		$1.args.opt = $1.options; /*5417*/
		$k[$j++] = $1.args; /*5420*/
		if (!$1.dontdraw) { /*5420*/
			$0.renlinear(); /*5420*/
		} /*5420*/
	};
	$0.databarlimited = function() {
		var $1 = {}; /*5447*/
		$1.options = $k[--$j]; /*5449*/
		$1.barcode = $k[--$j]; /*5450*/
		$1.dontdraw = false; /*5452*/
		$1.height = 10 / 72; /*5453*/
		$1.linkage = false; /*5454*/
		$forall($1.options, function() { /*5465*/
			var _3 = $k[--$j]; /*5465*/
			$1[$k[--$j]] = _3; /*5465*/
		}); /*5465*/
		$1.height = +$1.height; /*5467*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5472*/
			$k[$j++] = "bwipp.databarlimitedBadAI"; /*5471*/
			$k[$j++] = "GS1 DataBar Limited must begin with (01) application identifier"; /*5471*/
			$0.raiseerror(); /*5471*/
		} /*5471*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5475*/
			$k[$j++] = "bwipp.databarlimitedBadLength"; /*5474*/
			$k[$j++] = "GS1 DataBar Limited must be 13 or 14 digits"; /*5474*/
			$0.raiseerror(); /*5474*/
		} /*5474*/
		var _B = $get($1.barcode, 4); /*5476*/
		if ((_B < 48) || (_B > 49)) { /*5478*/
			$k[$j++] = "bwipp.databarlimitedBadStartDigit"; /*5477*/
			$k[$j++] = "GS1 DataBar Limited must begin with 0 or 1"; /*5477*/
			$0.raiseerror(); /*5477*/
		} /*5477*/
		$forall($geti($1.barcode, 5, $1.barcode.length - 5), function() { /*5483*/
			var _F = $k[--$j]; /*5480*/
			if ((_F < 48) || (_F > 57)) { /*5482*/
				$k[$j++] = "bwipp.databarlimitedBadCharacter"; /*5481*/
				$k[$j++] = "GS1 DataBar Limited must contain only digits"; /*5481*/
				$0.raiseerror(); /*5481*/
			} /*5481*/
		}); /*5481*/
		$1.checksum = 0; /*5486*/
		for (var _G = 0; _G <= 12; _G += 1) { /*5490*/
			$1.i = _G; /*5488*/
			$k[$j++] = "checksum"; /*5489*/
			$k[$j++] = $1.checksum; /*5489*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5489*/
			if (($1.i % 2) == 0) { /*5489*/
				var _M = $k[--$j]; /*5489*/
				$k[$j++] = _M * 3; /*5489*/
			} /*5489*/
			var _N = $k[--$j]; /*5489*/
			var _O = $k[--$j]; /*5489*/
			$1[$k[--$j]] = _O + _N; /*5489*/
		} /*5489*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5491*/
		if ($1.barcode.length == 18) { /*5496*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5495*/
				$k[$j++] = "bwipp.databaromniBadCheckDigit"; /*5494*/
				$k[$j++] = "Incorrect GS1 DataBar Limited check digit provided"; /*5494*/
				$0.raiseerror(); /*5494*/
			} /*5494*/
		} /*5494*/
		var _V = $s(18); /*5497*/
		$puti(_V, 0, $1.barcode); /*5498*/
		$put(_V, 17, $1.checksum + 48); /*5499*/
		$1.barcode = _V; /*5500*/
		$k[$j++] = Infinity; /*5505*/
		$forall($geti($1.barcode, 4, 13), function() { /*5504*/
			var _a = $k[--$j]; /*5504*/
			$k[$j++] = _a - 48; /*5504*/
		}); /*5504*/
		$1.binval = $a(); /*5505*/
		if ($1.linkage) { /*5512*/
			$1.linkval = $a([2, 0, 1, 5, 1, 3, 3, 5, 3, 1, 0, 9, 6]); /*5507*/
			for (var _g = 0, _f = $1.binval.length - 1; _g <= _f; _g += 1) { /*5511*/
				$1.i = _g; /*5509*/
				$put($1.binval, $1.i, $get($1.binval, $1.i) + $get($1.linkval, $1.i)); /*5510*/
			} /*5510*/
		} /*5510*/
		$1.txt = $a($1.barcode.length); /*5515*/
		for (var _t = 0, _s = $1.barcode.length - 1; _t <= _s; _t += 1) { /*5519*/
			$1.i = _t; /*5517*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*5518*/
		} /*5518*/
		$1.ncr = function() {
			var _10 = $k[--$j]; /*5522*/
			var _11 = $k[--$j]; /*5522*/
			var _12 = _11 - _10; /*5522*/
			if (_10 < (_11 - _10)) { /*5522*/
				var _ = _12; /*5522*/
				_12 = _10; /*5522*/
				_10 = _; /*5522*/
			} /*5522*/
			$k[$j++] = _12; /*5529*/
			$k[$j++] = 1; /*5529*/
			$k[$j++] = 1; /*5529*/
			for (var _14 = _11, _13 = _10 + 1; _14 >= _13; _14 -= 1) { /*5529*/
				var _15 = $k[--$j]; /*5525*/
				var _16 = $k[--$j]; /*5526*/
				var _17 = $k[--$j]; /*5526*/
				$k[$j++] = _17; /*5528*/
				$k[$j++] = _16; /*5528*/
				$k[$j++] = _15 * _14; /*5528*/
				if ($le(_16, _17)) { /*5528*/
					var _18 = $k[--$j]; /*5527*/
					var _19 = $k[--$j]; /*5527*/
					$k[$j++] = _19 + 1; /*5527*/
					$k[$j++] = ~~(_18 / _19); /*5527*/
				} /*5527*/
			} /*5527*/
			for (;;) { /*5533*/
				var _1A = $k[--$j]; /*5531*/
				var _1B = $k[--$j]; /*5531*/
				var _1C = $k[--$j]; /*5531*/
				$k[$j++] = _1C; /*5531*/
				$k[$j++] = _1B; /*5531*/
				$k[$j++] = _1A; /*5531*/
				if ($gt(_1B, _1C)) { /*5531*/
					break; /*5531*/
				} /*5531*/
				var _1D = $k[--$j]; /*5532*/
				var _1E = $k[--$j]; /*5532*/
				$k[$j++] = _1E + 1; /*5532*/
				$k[$j++] = ~~(_1D / _1E); /*5532*/
			} /*5532*/
			var _1F = $k[--$j]; /*5534*/
			var _1G = $k[--$j]; /*5534*/
			var _1H = $k[--$j]; /*5534*/
			$k[$j++] = _1F; /*5534*/
		}; /*5535*/
		$1.getRSSwidths = function() {
			$1.oe = $k[--$j]; /*5538*/
			$1.el = $k[--$j]; /*5539*/
			$1.mw = $k[--$j]; /*5540*/
			$1.nm = $k[--$j]; /*5541*/
			$1.val = $k[--$j]; /*5542*/
			$1.out = $a($1.el); /*5543*/
			$1.mask = 0; /*5544*/
			for (var _1R = 0, _1Q = $1.el - 2; _1R <= _1Q; _1R += 1) { /*5571*/
				$1.bar = _1R; /*5546*/
				$1.ew = 1; /*5547*/
				var _1T = $1.bar; /*5548*/
				$1.mask = $1.mask | ((_1T < 0 ? 1 >>> -_1T : 1 << _1T)); /*5548*/
				for (;;) { /*5567*/
					$k[$j++] = "sval"; /*5549*/
					$k[$j++] = ($1.nm - $1.ew) - 1; /*5549*/
					$k[$j++] = ($1.el - $1.bar) - 2; /*5549*/
					$1.ncr(); /*5549*/
					var _1Y = $k[--$j]; /*5549*/
					$1[$k[--$j]] = _1Y; /*5549*/
					if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*5552*/
						$k[$j++] = "sval"; /*5551*/
						$k[$j++] = $1.sval; /*5551*/
						$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*5551*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*5551*/
						$1.ncr(); /*5551*/
						var _1n = $k[--$j]; /*5551*/
						var _1o = $k[--$j]; /*5551*/
						$1[$k[--$j]] = _1o - _1n; /*5551*/
					} /*5551*/
					if (($1.el - $1.bar) > 2) { /*5561*/
						$1.lval = 0; /*5554*/
						for (var _1y = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _1x = $1.mw + 1; _1y >= _1x; _1y -= 1) { /*5558*/
							$k[$j++] = (($1.nm - _1y) - $1.ew) - 1; /*5556*/
							$k[$j++] = ($1.el - $1.bar) - 3; /*5556*/
							$1.ncr(); /*5556*/
							$1.lval = $k[--$j] + $1.lval; /*5557*/
						} /*5557*/
						$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*5559*/
					} else { /*5561*/
						if (($1.nm - $1.ew) > $1.mw) { /*5561*/
							$1.sval = $1.sval - 1; /*5561*/
						} /*5561*/
					} /*5561*/
					$1.val = $1.val - $1.sval; /*5563*/
					if ($1.val < 0) { /*5564*/
						break; /*5564*/
					} /*5564*/
					$1.ew = $1.ew + 1; /*5565*/
					var _2I = $1.bar; /*5566*/
					$1.mask = $1.mask & (~((_2I < 0 ? 1 >>> -_2I : 1 << _2I))); /*5566*/
				} /*5566*/
				$1.val = $1.val + $1.sval; /*5568*/
				$1.nm = $1.nm - $1.ew; /*5569*/
				$put($1.out, $1.bar, $1.ew); /*5570*/
			} /*5570*/
			$put($1.out, $1.el - 1, $1.nm); /*5572*/
			$k[$j++] = $1.out; /*5573*/
		}; /*5574*/
		for (var _2U = 0; _2U <= 11; _2U += 1) { /*5580*/
			$1.i = _2U; /*5577*/
			var _2V = $1.binval; /*5578*/
			var _2W = $1.i; /*5578*/
			$put(_2V, _2W + 1, $get(_2V, _2W + 1) + (($get($1.binval, $1.i) % 2013571) * 10)); /*5578*/
			$put($1.binval, $1.i, ~~($get($1.binval, $1.i) / 2013571)); /*5579*/
		} /*5579*/
		$1.d2 = $get($1.binval, 12) % 2013571; /*5581*/
		var _2i = $1.binval; /*5582*/
		$put(_2i, 12, ~~($get(_2i, 12) / 2013571)); /*5582*/
		$1.d1 = 0; /*5584*/
		$1.i = true; /*5585*/
		for (var _2k = 0; _2k <= 12; _2k += 1) { /*5595*/
			$1.j = _2k; /*5587*/
			var _2n = $get($1.binval, $1.j); /*5588*/
			$k[$j++] = _2n; /*5594*/
			if ((_2n == 0) && $1.i) { /*5593*/
				$j--; /*5590*/
			} else { /*5593*/
				$1.i = false; /*5592*/
				$1.d1 = $1.d1 + ($k[--$j] * (~~Math.pow(10, 12 - $1.j))); /*5593*/
			} /*5593*/
		} /*5593*/
		$1.tab267 = $a([183063, 0, 17, 9, 6, 3, 6538, 28, 820063, 183064, 13, 13, 5, 4, 875, 728, 1000775, 820064, 9, 17, 3, 6, 28, 6454, 1491020, 1000776, 15, 11, 5, 4, 2415, 203, 1979844, 1491021, 11, 15, 4, 5, 203, 2408, 1996938, 1979845, 19, 7, 8, 1, 17094, 1, 2013570, 1996939, 7, 19, 1, 8, 1, 16632]); /*5605*/
		$1.i = 0; /*5607*/
		for (;;) { /*5617*/
			if ($1.d1 <= $get($1.tab267, $1.i)) { /*5615*/
				$forall($geti($1.tab267, $1.i + 1, 7)); /*5609*/
				$1.d1te = $k[--$j]; /*5610*/
				$1.d1to = $k[--$j]; /*5610*/
				$1.d1mwe = $k[--$j]; /*5611*/
				$1.d1mwo = $k[--$j]; /*5611*/
				$1.d1ele = $k[--$j]; /*5612*/
				$1.d1elo = $k[--$j]; /*5612*/
				$1.d1gs = $k[--$j]; /*5613*/
				break; /*5614*/
			} /*5614*/
			$1.i = $1.i + 8; /*5616*/
		} /*5616*/
		$1.i = 0; /*5619*/
		for (;;) { /*5629*/
			if ($1.d2 <= $get($1.tab267, $1.i)) { /*5627*/
				$forall($geti($1.tab267, $1.i + 1, 7)); /*5621*/
				$1.d2te = $k[--$j]; /*5622*/
				$1.d2to = $k[--$j]; /*5622*/
				$1.d2mwe = $k[--$j]; /*5623*/
				$1.d2mwo = $k[--$j]; /*5623*/
				$1.d2ele = $k[--$j]; /*5624*/
				$1.d2elo = $k[--$j]; /*5624*/
				$1.d2gs = $k[--$j]; /*5625*/
				break; /*5626*/
			} /*5626*/
			$1.i = $1.i + 8; /*5628*/
		} /*5628*/
		$k[$j++] = "d1wo"; /*5631*/
		$k[$j++] = ~~(($1.d1 - $1.d1gs) / $1.d1te); /*5631*/
		$k[$j++] = $1.d1elo; /*5631*/
		$k[$j++] = $1.d1mwo; /*5631*/
		$k[$j++] = 7; /*5631*/
		$k[$j++] = false; /*5631*/
		$1.getRSSwidths(); /*5631*/
		var _3S = $k[--$j]; /*5631*/
		$1[$k[--$j]] = _3S; /*5631*/
		$k[$j++] = "d1we"; /*5632*/
		$k[$j++] = ($1.d1 - $1.d1gs) % $1.d1te; /*5632*/
		$k[$j++] = $1.d1ele; /*5632*/
		$k[$j++] = $1.d1mwe; /*5632*/
		$k[$j++] = 7; /*5632*/
		$k[$j++] = true; /*5632*/
		$1.getRSSwidths(); /*5632*/
		var _3Z = $k[--$j]; /*5632*/
		$1[$k[--$j]] = _3Z; /*5632*/
		$k[$j++] = "d2wo"; /*5633*/
		$k[$j++] = ~~(($1.d2 - $1.d2gs) / $1.d2te); /*5633*/
		$k[$j++] = $1.d2elo; /*5633*/
		$k[$j++] = $1.d2mwo; /*5633*/
		$k[$j++] = 7; /*5633*/
		$k[$j++] = false; /*5633*/
		$1.getRSSwidths(); /*5633*/
		var _3g = $k[--$j]; /*5633*/
		$1[$k[--$j]] = _3g; /*5633*/
		$k[$j++] = "d2we"; /*5634*/
		$k[$j++] = ($1.d2 - $1.d2gs) % $1.d2te; /*5634*/
		$k[$j++] = $1.d2ele; /*5634*/
		$k[$j++] = $1.d2mwe; /*5634*/
		$k[$j++] = 7; /*5634*/
		$k[$j++] = true; /*5634*/
		$1.getRSSwidths(); /*5634*/
		var _3n = $k[--$j]; /*5634*/
		$1[$k[--$j]] = _3n; /*5634*/
		$1.d1w = $a(14); /*5636*/
		for (var _3q = 0; _3q <= 6; _3q += 1) { /*5641*/
			$1.i = _3q; /*5638*/
			$put($1.d1w, $1.i * 2, $get($1.d1wo, $1.i)); /*5639*/
			$put($1.d1w, ($1.i * 2) + 1, $get($1.d1we, $1.i)); /*5640*/
		} /*5640*/
		$1.d2w = $a(14); /*5643*/
		for (var _42 = 0; _42 <= 6; _42 += 1) { /*5648*/
			$1.i = _42; /*5645*/
			$put($1.d2w, $1.i * 2, $get($1.d2wo, $1.i)); /*5646*/
			$put($1.d2w, ($1.i * 2) + 1, $get($1.d2we, $1.i)); /*5647*/
		} /*5647*/
		$k[$j++] = Infinity; /*5653*/
		var _4D = $1.d1w; /*5651*/
		for (var _4E = 0, _4F = _4D.length; _4E < _4F; _4E++) { /*5651*/
			$k[$j++] = $get(_4D, _4E); /*5651*/
		} /*5651*/
		var _4H = $1.d2w; /*5652*/
		for (var _4I = 0, _4J = _4H.length; _4I < _4J; _4I++) { /*5652*/
			$k[$j++] = $get(_4H, _4I); /*5652*/
		} /*5652*/
		$1.widths = $a(); /*5653*/
		$1.checkweights = $a([1, 3, 9, 27, 81, 65, 17, 51, 64, 14, 42, 37, 22, 66, 20, 60, 2, 6, 18, 54, 73, 41, 34, 13, 39, 28, 84, 74]); /*5658*/
		$k[$j++] = Infinity; /*5674*/
		for (var _4N = 0; _4N <= 43; _4N += 1) { /*5661*/
			$k[$j++] = _4N; /*5661*/
		} /*5661*/
		$k[$j++] = 45; /*5663*/
		$k[$j++] = 52; /*5663*/
		$k[$j++] = 57; /*5663*/
		for (var _4O = 63; _4O <= 66; _4O += 1) { /*5663*/
			$k[$j++] = _4O; /*5663*/
		} /*5663*/
		for (var _4P = 73; _4P <= 79; _4P += 1) { /*5664*/
			$k[$j++] = _4P; /*5664*/
		} /*5664*/
		$k[$j++] = 82; /*5666*/
		for (var _4Q = 126; _4Q <= 130; _4Q += 1) { /*5666*/
			$k[$j++] = _4Q; /*5666*/
		} /*5666*/
		$k[$j++] = 132; /*5668*/
		for (var _4R = 141; _4R <= 146; _4R += 1) { /*5668*/
			$k[$j++] = _4R; /*5668*/
		} /*5668*/
		for (var _4S = 210; _4S <= 217; _4S += 1) { /*5669*/
			$k[$j++] = _4S; /*5669*/
		} /*5669*/
		$k[$j++] = 220; /*5671*/
		for (var _4T = 316; _4T <= 320; _4T += 1) { /*5671*/
			$k[$j++] = _4T; /*5671*/
		} /*5671*/
		$k[$j++] = 322; /*5673*/
		$k[$j++] = 323; /*5673*/
		$k[$j++] = 326; /*5673*/
		$k[$j++] = 337; /*5673*/
		$1.checkseq = $a(); /*5674*/
		$1.checksum = 0; /*5676*/
		for (var _4V = 0; _4V <= 27; _4V += 1) { /*5680*/
			$1.i = _4V; /*5678*/
			$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweights, $1.i)); /*5679*/
		} /*5679*/
		$1.checksum = $1.checksum % 89; /*5681*/
		$1.seq = $get($1.checkseq, $1.checksum); /*5682*/
		$k[$j++] = "swidths"; /*5683*/
		$k[$j++] = ~~($1.seq / 21); /*5683*/
		$k[$j++] = 8; /*5683*/
		$k[$j++] = 3; /*5683*/
		$k[$j++] = 6; /*5683*/
		$k[$j++] = false; /*5683*/
		$1.getRSSwidths(); /*5683*/
		var _4i = $k[--$j]; /*5683*/
		$1[$k[--$j]] = _4i; /*5683*/
		$k[$j++] = "bwidths"; /*5684*/
		$k[$j++] = $1.seq % 21; /*5684*/
		$k[$j++] = 8; /*5684*/
		$k[$j++] = 3; /*5684*/
		$k[$j++] = 6; /*5684*/
		$k[$j++] = false; /*5684*/
		$1.getRSSwidths(); /*5684*/
		var _4l = $k[--$j]; /*5684*/
		$1[$k[--$j]] = _4l; /*5684*/
		$1.checkwidths = $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1]); /*5686*/
		for (var _4o = 0; _4o <= 5; _4o += 1) { /*5691*/
			$1.i = _4o; /*5688*/
			$put($1.checkwidths, $1.i * 2, $get($1.swidths, $1.i)); /*5689*/
			$put($1.checkwidths, ($1.i * 2) + 1, $get($1.bwidths, $1.i)); /*5690*/
		} /*5690*/
		$k[$j++] = Infinity; /*5695*/
		var _4z = $1.d1w; /*5694*/
		$k[$j++] = 1; /*5694*/
		for (var _50 = 0, _51 = _4z.length; _50 < _51; _50++) { /*5694*/
			$k[$j++] = $get(_4z, _50); /*5694*/
		} /*5694*/
		var _53 = $1.checkwidths; /*5694*/
		for (var _54 = 0, _55 = _53.length; _54 < _55; _54++) { /*5694*/
			$k[$j++] = $get(_53, _54); /*5694*/
		} /*5694*/
		var _57 = $1.d2w; /*5694*/
		for (var _58 = 0, _59 = _57.length; _58 < _59; _58++) { /*5694*/
			$k[$j++] = $get(_57, _58); /*5694*/
		} /*5694*/
		$k[$j++] = 1; /*5694*/
		$k[$j++] = 1; /*5694*/
		$1.sbs = $a(); /*5695*/
		$k[$j++] = Infinity; /*5705*/
		$k[$j++] = "ren"; /*5702*/
		$k[$j++] = $0.renlinear; /*5702*/
		$k[$j++] = "sbs"; /*5702*/
		$k[$j++] = $1.sbs; /*5702*/
		$k[$j++] = "bhs"; /*5702*/
		$k[$j++] = Infinity; /*5702*/
		for (var _5E = 0, _5F = ~~(($1.sbs.length + 1) / 2); _5E < _5F; _5E++) { /*5701*/
			$k[$j++] = $1.height; /*5701*/
		} /*5701*/
		var _5H = $a(); /*5702*/
		$k[$j++] = _5H; /*5703*/
		$k[$j++] = "bbs"; /*5703*/
		$k[$j++] = Infinity; /*5703*/
		for (var _5J = 0, _5K = ~~(($1.sbs.length + 1) / 2); _5J < _5K; _5J++) { /*5702*/
			$k[$j++] = 0; /*5702*/
		} /*5702*/
		var _5L = $a(); /*5703*/
		$k[$j++] = _5L; /*5705*/
		$k[$j++] = "txt"; /*5705*/
		$k[$j++] = $1.txt; /*5705*/
		$k[$j++] = "textxalign"; /*5705*/
		$k[$j++] = "center"; /*5705*/
		$k[$j++] = "opt"; /*5705*/
		$k[$j++] = $1.options; /*5705*/
		var _5O = $d(); /*5705*/
		$k[$j++] = _5O; /*5708*/
		if (!$1.dontdraw) { /*5708*/
			$0.renlinear(); /*5708*/
		} /*5708*/
	};
	$0.databarexpanded = function() {
		var $1 = {}; /*5736*/
		$1.options = $k[--$j]; /*5738*/
		$1.barcode = $k[--$j]; /*5739*/
		$1.dontdraw = false; /*5741*/
		$1.height = 34 / 72; /*5742*/
		$1.format = "expanded"; /*5743*/
		$1.segments = -1; /*5744*/
		$1.linkage = false; /*5745*/
		$forall($1.options, function() { /*5756*/
			var _3 = $k[--$j]; /*5756*/
			$1[$k[--$j]] = _3; /*5756*/
		}); /*5756*/
		$1.height = +$1.height; /*5758*/
		$1.segments = ~~$1.segments; /*5759*/
		if ($1.segments == -1) { /*5763*/
			var _9 = $eq($1.format, "expandedstacked") ? 4 : 22; /*5762*/
			$1.segments = _9; /*5762*/
		} /*5762*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*5767*/
			$1.out = $s($1.in.length); /*5768*/
			$1.j = 0; /*5769*/
			$k[$j++] = $1.in; /*5783*/
			for (;;) { /*5783*/
				$search($k[--$j], "^"); /*5772*/
				if ($k[--$j]) { /*5781*/
					var _G = $k[--$j]; /*5773*/
					$puti($1.out, $1.j, _G); /*5773*/
					$1.j = (_G.length + $1.j) + 1; /*5774*/
					$j--; /*5775*/
					var _K = $k[--$j]; /*5776*/
					$put($1.out, $1.j - 1, ~~$z($geti(_K, 0, 3))); /*5776*/
					$k[$j++] = $geti(_K, 3, _K.length - 3); /*5777*/
				} else { /*5781*/
					var _P = $k[--$j]; /*5779*/
					$puti($1.out, $1.j, _P); /*5779*/
					$1.j = _P.length + $1.j; /*5780*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*5781*/
					break; /*5781*/
				} /*5781*/
			} /*5781*/
		}; /*5784*/
		$1.ais = $a([]); /*5787*/
		$1.aival = {}; /*5788*/
		var _X = $1.barcode; /*5789*/
		$k[$j++] = $geti(_X, 1, _X.length - 1); /*5801*/
		for (;;) { /*5801*/
			var _Z = $k[--$j]; /*5791*/
			$k[$j++] = _Z; /*5791*/
			if ($eq(_Z, "")) { /*5791*/
				break; /*5791*/
			} /*5791*/
			$search($k[--$j], ")"); /*5792*/
			$j--; /*5792*/
			var _b = $k[--$j]; /*5793*/
			var _c = $k[--$j]; /*5793*/
			var _d = $k[--$j]; /*5794*/
			$k[$j++] = _b; /*5794*/
			$search(_d, "("); /*5794*/
			if ($k[--$j]) { /*5797*/
				var _f = $k[--$j]; /*5795*/
				var _g = $k[--$j]; /*5795*/
				var _h = $k[--$j]; /*5795*/
				var _i = $k[--$j]; /*5795*/
				$k[$j++] = _h; /*5795*/
				$k[$j++] = _i; /*5795*/
				$k[$j++] = _f; /*5795*/
			} else { /*5797*/
				var _j = $k[--$j]; /*5797*/
				var _k = $k[--$j]; /*5797*/
				$k[$j++] = ""; /*5797*/
				$k[$j++] = _k; /*5797*/
				$k[$j++] = _j; /*5797*/
			} /*5797*/
			$k[$j++] = Infinity; /*5799*/
			$aload($1.ais); /*5799*/
			var _n = $k[$j - 1 - ($counttomark() + 2)]; /*5799*/
			$k[$j++] = _n; /*5799*/
			$1.ais = $a(); /*5799*/
			var _q = $k[--$j]; /*5800*/
			var _r = $k[--$j]; /*5800*/
			$k[$j++] = $1.aival; /*5800*/
			$k[$j++] = _r; /*5800*/
			$k[$j++] = _q; /*5800*/
			$1.expand(); /*5800*/
			var _s = $k[--$j]; /*5800*/
			var _t = $k[--$j]; /*5800*/
			$put($k[--$j], _t, _s); /*5800*/
		} /*5800*/
		$j--; /*5802*/
		for (;;) { /*5889*/
			if ($1.ais.length == 2) { /*5814*/
				if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3103")) { /*5813*/
					if ($eq($geti($1.aival["01"], 0, 1), "9") && ((~~$z($1.aival["3103"])) <= 32767)) { /*5812*/
						$k[$j++] = "0100"; /*5811*/
						$k[$j++] = false; /*5811*/
						break; /*5811*/
					} /*5811*/
				} /*5811*/
			} /*5811*/
			if ($1.ais.length == 2) { /*5823*/
				if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3202")) { /*5822*/
					if ($eq($geti($1.aival["01"], 0, 1), "9") && ((~~$z($1.aival["3202"])) <= 9999)) { /*5821*/
						$k[$j++] = "0101"; /*5820*/
						$k[$j++] = false; /*5820*/
						break; /*5820*/
					} /*5820*/
				} /*5820*/
			} /*5820*/
			if ($1.ais.length == 2) { /*5832*/
				if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3203")) { /*5831*/
					if ($eq($geti($1.aival["01"], 0, 1), "9") && ((~~$z($1.aival["3203"])) <= 22767)) { /*5830*/
						$k[$j++] = "0101"; /*5829*/
						$k[$j++] = false; /*5829*/
						break; /*5829*/
					} /*5829*/
				} /*5829*/
			} /*5829*/
			var _1Q = $1.ais.length; /*5835*/
			if ((_1Q == 2) || (_1Q == 3)) { /*5865*/
				$k[$j++] = "ai310x"; /*5836*/
				$k[$j++] = false; /*5836*/
				for (var _1R = 3100; _1R <= 3109; _1R += 1) { /*5836*/
					var _1W = $k[--$j]; /*5836*/
					$k[$j++] = _1W || $eq($cvrs($s(4), _1R, 10), $get($1.ais, 1)); /*5836*/
				} /*5836*/
				var _1X = $k[--$j]; /*5836*/
				$1[$k[--$j]] = _1X; /*5836*/
				$k[$j++] = "ai320x"; /*5837*/
				$k[$j++] = false; /*5837*/
				for (var _1Z = 3200; _1Z <= 3209; _1Z += 1) { /*5837*/
					var _1e = $k[--$j]; /*5837*/
					$k[$j++] = _1e || $eq($cvrs($s(4), _1Z, 10), $get($1.ais, 1)); /*5837*/
				} /*5837*/
				var _1f = $k[--$j]; /*5837*/
				$1[$k[--$j]] = _1f; /*5837*/
				if ($1.ais.length == 3) { /*5841*/
					var _1i = $a(["11", "13", "15", "17"]); /*5839*/
					$k[$j++] = "aibad"; /*5839*/
					$k[$j++] = true; /*5839*/
					for (var _1j = 0, _1k = _1i.length; _1j < _1k; _1j++) { /*5839*/
						var _1o = $k[--$j]; /*5839*/
						$k[$j++] = _1o && $ne($get(_1i, _1j), $get($1.ais, 2)); /*5839*/
					} /*5839*/
					var _1p = $k[--$j]; /*5839*/
					$1[$k[--$j]] = _1p; /*5839*/
				} else { /*5841*/
					$1.aibad = false; /*5841*/
				} /*5841*/
				if (($eq($get($1.ais, 0), "01") && ($1.ai310x || $1.ai320x)) && (!$1.aibad)) { /*5864*/
					if ($1.ais.length == 3) { /*5861*/
						if (($eq($geti($1.aival["01"], 0, 1), "9") && ((~~$z($get($1.aival, $get($1.ais, 1)))) <= 99999)) && ((~~$z($get($1.aival, $get($1.ais, 2)))) <= 999999)) { /*5856*/
							if ($1.ai310x && $eq($get($1.ais, 2), "11")) { /*5848*/
								$k[$j++] = "0111000"; /*5848*/
								$k[$j++] = false; /*5848*/
								break; /*5848*/
							} /*5848*/
							if ($1.ai320x && $eq($get($1.ais, 2), "11")) { /*5849*/
								$k[$j++] = "0111001"; /*5849*/
								$k[$j++] = false; /*5849*/
								break; /*5849*/
							} /*5849*/
							if ($1.ai310x && $eq($get($1.ais, 2), "13")) { /*5850*/
								$k[$j++] = "0111010"; /*5850*/
								$k[$j++] = false; /*5850*/
								break; /*5850*/
							} /*5850*/
							if ($1.ai320x && $eq($get($1.ais, 2), "13")) { /*5851*/
								$k[$j++] = "0111011"; /*5851*/
								$k[$j++] = false; /*5851*/
								break; /*5851*/
							} /*5851*/
							if ($1.ai310x && $eq($get($1.ais, 2), "15")) { /*5852*/
								$k[$j++] = "0111100"; /*5852*/
								$k[$j++] = false; /*5852*/
								break; /*5852*/
							} /*5852*/
							if ($1.ai320x && $eq($get($1.ais, 2), "15")) { /*5853*/
								$k[$j++] = "0111101"; /*5853*/
								$k[$j++] = false; /*5853*/
								break; /*5853*/
							} /*5853*/
							if ($1.ai310x && $eq($get($1.ais, 2), "17")) { /*5854*/
								$k[$j++] = "0111110"; /*5854*/
								$k[$j++] = false; /*5854*/
								break; /*5854*/
							} /*5854*/
							if ($1.ai320x && $eq($get($1.ais, 2), "17")) { /*5855*/
								$k[$j++] = "0111111"; /*5855*/
								$k[$j++] = false; /*5855*/
								break; /*5855*/
							} /*5855*/
						} /*5855*/
					} else { /*5861*/
						if ($eq($geti($1.aival["01"], 0, 1), "9") && ((~~$z($get($1.aival, $get($1.ais, 1)))) <= 99999)) { /*5862*/
							if ($1.ai310x) { /*5860*/
								$k[$j++] = "0111000"; /*5860*/
								$k[$j++] = false; /*5860*/
								break; /*5860*/
							} /*5860*/
							if ($1.ai320x) { /*5861*/
								$k[$j++] = "0111001"; /*5861*/
								$k[$j++] = false; /*5861*/
								break; /*5861*/
							} /*5861*/
						} /*5861*/
					} /*5861*/
				} /*5861*/
			} /*5861*/
			if ($1.ais.length >= 2) { /*5873*/
				$k[$j++] = "ai392x"; /*5869*/
				$k[$j++] = false; /*5869*/
				for (var _2g = 3920; _2g <= 3923; _2g += 1) { /*5869*/
					var _2l = $k[--$j]; /*5869*/
					$k[$j++] = _2l || $eq($cvrs($s(4), _2g, 10), $get($1.ais, 1)); /*5869*/
				} /*5869*/
				var _2m = $k[--$j]; /*5869*/
				$1[$k[--$j]] = _2m; /*5869*/
				if ($eq($get($1.ais, 0), "01") && $1.ai392x) { /*5872*/
					if ($eq($geti($1.aival["01"], 0, 1), "9")) { /*5871*/
						$k[$j++] = "01100"; /*5871*/
						$k[$j++] = true; /*5871*/
						break; /*5871*/
					} /*5871*/
				} /*5871*/
			} /*5871*/
			if ($1.ais.length >= 2) { /*5881*/
				$k[$j++] = "ai393x"; /*5877*/
				$k[$j++] = false; /*5877*/
				for (var _2v = 3930; _2v <= 3933; _2v += 1) { /*5877*/
					var _30 = $k[--$j]; /*5877*/
					$k[$j++] = _30 || $eq($cvrs($s(4), _2v, 10), $get($1.ais, 1)); /*5877*/
				} /*5877*/
				var _31 = $k[--$j]; /*5877*/
				$1[$k[--$j]] = _31; /*5877*/
				if ($eq($get($1.ais, 0), "01") && $1.ai393x) { /*5880*/
					if ($eq($geti($1.aival["01"], 0, 1), "9")) { /*5879*/
						$k[$j++] = "01101"; /*5879*/
						$k[$j++] = true; /*5879*/
						break; /*5879*/
					} /*5879*/
				} /*5879*/
			} /*5879*/
			if ($eq($get($1.ais, 0), "01")) { /*5884*/
				$k[$j++] = "1"; /*5884*/
				$k[$j++] = true; /*5884*/
				break; /*5884*/
			} /*5884*/
			$k[$j++] = "00"; /*5887*/
			$k[$j++] = true; /*5887*/
			break; /*5887*/
		} /*5887*/
		$1.gpfallow = $k[--$j]; /*5890*/
		$1.method = $k[--$j]; /*5891*/
		$1.conv12to40 = function() {
			var _3E = $strcpy($s(40), "0000000000000000000000000000000000000000"); /*5894*/
			var _3F = $k[--$j]; /*5895*/
			var _3J = $cvrs($s(10), ~~$z($geti(_3F, 0, 3)), 2); /*5895*/
			$puti($geti(_3E, 0, 10), 10 - _3J.length, _3J); /*5895*/
			var _3N = $cvrs($s(10), ~~$z($geti(_3F, 3, 3)), 2); /*5896*/
			$puti($geti(_3E, 10, 10), 10 - _3N.length, _3N); /*5896*/
			var _3R = $cvrs($s(10), ~~$z($geti(_3F, 6, 3)), 2); /*5897*/
			$puti($geti(_3E, 20, 10), 10 - _3R.length, _3R); /*5897*/
			var _3V = $cvrs($s(10), ~~$z($geti(_3F, 9, 3)), 2); /*5898*/
			$puti($geti(_3E, 30, 10), 10 - _3V.length, _3V); /*5898*/
			$k[$j++] = _3E; /*5899*/
		}; /*5900*/
		$1.conv13to44 = function() {
			var _3X = $strcpy($s(44), "00000000000000000000000000000000000000000000"); /*5903*/
			var _3Y = $k[--$j]; /*5904*/
			var _3c = $cvrs($s(4), ~~$z($geti(_3Y, 0, 1)), 2); /*5904*/
			$puti($geti(_3X, 0, 4), 4 - _3c.length, _3c); /*5904*/
			$k[$j++] = _3X; /*5905*/
			$k[$j++] = _3X; /*5905*/
			$k[$j++] = $geti(_3Y, 1, 12); /*5905*/
			$1.conv12to40(); /*5905*/
			var _3e = $k[--$j]; /*5905*/
			$puti($k[--$j], 4, _3e); /*5905*/
		}; /*5906*/
		$1.tobin = function() {
			var _3h = $s($k[--$j]); /*5909*/
			$k[$j++] = _3h; /*5909*/
			for (var _3j = 0, _3i = _3h.length - 1; _3j <= _3i; _3j += 1) { /*5909*/
				var _3k = $k[--$j]; /*5909*/
				$put(_3k, _3j, 48); /*5909*/
				$k[$j++] = _3k; /*5909*/
			} /*5909*/
			var _3l = $k[--$j]; /*5910*/
			var _3o = $cvrs($s(_3l.length), $k[--$j], 2); /*5910*/
			$puti(_3l, _3l.length - _3o.length, _3o); /*5910*/
			$k[$j++] = _3l; /*5910*/
		}; /*5911*/
		if ($eq($1.method, "00")) { /*5916*/
			$1.cdf = $a([]); /*5914*/
			$1.gpf = $a([]); /*5915*/
		} /*5915*/
		if ($eq($1.method, "1")) { /*5923*/
			$k[$j++] = "cdf"; /*5919*/
			$k[$j++] = $geti($1.aival["01"], 0, 13); /*5919*/
			$1.conv13to44(); /*5919*/
			var _3w = $k[--$j]; /*5919*/
			$1[$k[--$j]] = _3w; /*5919*/
			$k[$j++] = Infinity; /*5920*/
			var _3y = $1.cdf; /*5920*/
			for (var _3z = 0, _40 = _3y.length; _3z < _40; _3z++) { /*5920*/
				$k[$j++] = $get(_3y, _3z) - 48; /*5920*/
			} /*5920*/
			$1.cdf = $a(); /*5920*/
			$1.gpf = $a([]); /*5921*/
			$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*5922*/
		} /*5922*/
		if ($eq($1.method, "0100")) { /*5932*/
			$1.cdf = $s(55); /*5926*/
			$k[$j++] = $1.cdf; /*5927*/
			$k[$j++] = 0; /*5927*/
			$k[$j++] = $geti($1.aival["01"], 1, 12); /*5927*/
			$1.conv12to40(); /*5927*/
			var _4D = $k[--$j]; /*5927*/
			var _4E = $k[--$j]; /*5927*/
			$puti($k[--$j], _4E, _4D); /*5927*/
			$k[$j++] = $1.cdf; /*5928*/
			$k[$j++] = 40; /*5928*/
			$k[$j++] = ~~$z($1.aival["3103"]); /*5928*/
			$k[$j++] = 15; /*5928*/
			$1.tobin(); /*5928*/
			var _4J = $k[--$j]; /*5928*/
			var _4K = $k[--$j]; /*5928*/
			$puti($k[--$j], _4K, _4J); /*5928*/
			$k[$j++] = Infinity; /*5929*/
			var _4M = $1.cdf; /*5929*/
			for (var _4N = 0, _4O = _4M.length; _4N < _4O; _4N++) { /*5929*/
				$k[$j++] = $get(_4M, _4N) - 48; /*5929*/
			} /*5929*/
			$1.cdf = $a(); /*5929*/
			$1.gpf = $a([]); /*5930*/
			$1.ais = $a([]); /*5931*/
		} /*5931*/
		if ($eq($1.method, "0101")) { /*5946*/
			$1.cdf = $s(55); /*5935*/
			$k[$j++] = $1.cdf; /*5936*/
			$k[$j++] = 0; /*5936*/
			$k[$j++] = $geti($1.aival["01"], 1, 12); /*5936*/
			$1.conv12to40(); /*5936*/
			var _4Z = $k[--$j]; /*5936*/
			var _4a = $k[--$j]; /*5936*/
			$puti($k[--$j], _4a, _4Z); /*5936*/
			if ($eq($get($1.ais, 1), "3202")) { /*5940*/
				$k[$j++] = ~~$z($1.aival["3202"]); /*5938*/
				$k[$j++] = 15; /*5938*/
				$1.tobin(); /*5938*/
			} else { /*5940*/
				$k[$j++] = (~~$z($1.aival["3203"])) + 10000; /*5940*/
				$k[$j++] = 15; /*5940*/
				$1.tobin(); /*5940*/
			} /*5940*/
			$puti($1.cdf, 40, $k[--$j]); /*5942*/
			$k[$j++] = Infinity; /*5943*/
			var _4k = $1.cdf; /*5943*/
			for (var _4l = 0, _4m = _4k.length; _4l < _4m; _4l++) { /*5943*/
				$k[$j++] = $get(_4k, _4l) - 48; /*5943*/
			} /*5943*/
			$1.cdf = $a(); /*5943*/
			$1.gpf = $a([]); /*5944*/
			$1.ais = $a([]); /*5945*/
		} /*5945*/
		if ($1.method.length == 7) { /*5966*/
			$1.cdf = $s(76); /*5949*/
			$k[$j++] = $1.cdf; /*5950*/
			$k[$j++] = 0; /*5950*/
			$k[$j++] = $geti($1.aival["01"], 1, 12); /*5950*/
			$1.conv12to40(); /*5950*/
			var _4x = $k[--$j]; /*5950*/
			var _4y = $k[--$j]; /*5950*/
			$puti($k[--$j], _4y, _4x); /*5950*/
			var _50 = $s(6); /*5951*/
			$puti(_50, 0, $geti($get($1.ais, 1), 3, 1)); /*5951*/
			$puti(_50, 1, $geti($get($1.aival, $get($1.ais, 1)), 1, 5)); /*5952*/
			$k[$j++] = ~~$z(_50); /*5952*/
			$k[$j++] = 20; /*5952*/
			$1.tobin(); /*5952*/
			$puti($1.cdf, 40, $k[--$j]); /*5953*/
			if ($1.ais.length == 3) { /*5960*/
				var _5F = $get($1.aival, $get($1.ais, 2)); /*5955*/
				$k[$j++] = ((~~$z($geti(_5F, 0, 2))) * 384) + ((((~~$z($geti(_5F, 2, 2))) - 1) * 32) + (~~$z($geti(_5F, 4, 2)))); /*5958*/
			} else { /*5960*/
				$k[$j++] = 38400; /*5960*/
			} /*5960*/
			$k[$j++] = 16; /*5962*/
			$1.tobin(); /*5962*/
			$puti($1.cdf, 60, $k[--$j]); /*5962*/
			$k[$j++] = Infinity; /*5963*/
			var _5L = $1.cdf; /*5963*/
			for (var _5M = 0, _5N = _5L.length; _5M < _5N; _5M++) { /*5963*/
				$k[$j++] = $get(_5L, _5M) - 48; /*5963*/
			} /*5963*/
			$1.cdf = $a(); /*5963*/
			$1.gpf = $a([]); /*5964*/
			$1.ais = $a([]); /*5965*/
		} /*5965*/
		if ($eq($1.method, "01100")) { /*5975*/
			$1.cdf = $s(42); /*5969*/
			$k[$j++] = $1.cdf; /*5970*/
			$k[$j++] = 0; /*5970*/
			$k[$j++] = $geti($1.aival["01"], 1, 12); /*5970*/
			$1.conv12to40(); /*5970*/
			var _5Y = $k[--$j]; /*5970*/
			var _5Z = $k[--$j]; /*5970*/
			$puti($k[--$j], _5Z, _5Y); /*5970*/
			$k[$j++] = $1.cdf; /*5971*/
			$k[$j++] = 40; /*5971*/
			$k[$j++] = ~~$z($geti($get($1.ais, 1), 3, 1)); /*5971*/
			$k[$j++] = 2; /*5971*/
			$1.tobin(); /*5971*/
			var _5f = $k[--$j]; /*5971*/
			var _5g = $k[--$j]; /*5971*/
			$puti($k[--$j], _5g, _5f); /*5971*/
			$k[$j++] = Infinity; /*5972*/
			var _5i = $1.cdf; /*5972*/
			for (var _5j = 0, _5k = _5i.length; _5j < _5k; _5j++) { /*5972*/
				$k[$j++] = $get(_5i, _5j) - 48; /*5972*/
			} /*5972*/
			$1.cdf = $a(); /*5972*/
			$k[$j++] = Infinity; /*5973*/
			$forall($get($1.aival, $get($1.ais, 1))); /*5973*/
			$1.gpf = $a(); /*5973*/
			$1.ais = $geti($1.ais, 2, $1.ais.length - 2); /*5974*/
		} /*5974*/
		if ($eq($1.method, "01101")) { /*5985*/
			$1.cdf = $s(52); /*5978*/
			$k[$j++] = $1.cdf; /*5979*/
			$k[$j++] = 0; /*5979*/
			$k[$j++] = $geti($1.aival["01"], 1, 12); /*5979*/
			$1.conv12to40(); /*5979*/
			var _61 = $k[--$j]; /*5979*/
			var _62 = $k[--$j]; /*5979*/
			$puti($k[--$j], _62, _61); /*5979*/
			$k[$j++] = $1.cdf; /*5980*/
			$k[$j++] = 40; /*5980*/
			$k[$j++] = ~~$z($geti($get($1.ais, 1), 3, 1)); /*5980*/
			$k[$j++] = 2; /*5980*/
			$1.tobin(); /*5980*/
			var _68 = $k[--$j]; /*5980*/
			var _69 = $k[--$j]; /*5980*/
			$puti($k[--$j], _69, _68); /*5980*/
			$k[$j++] = $1.cdf; /*5981*/
			$k[$j++] = 42; /*5981*/
			$k[$j++] = ~~$z($geti($get($1.aival, $get($1.ais, 1)), 0, 3)); /*5981*/
			$k[$j++] = 10; /*5981*/
			$1.tobin(); /*5981*/
			var _6H = $k[--$j]; /*5981*/
			var _6I = $k[--$j]; /*5981*/
			$puti($k[--$j], _6I, _6H); /*5981*/
			$k[$j++] = Infinity; /*5982*/
			var _6K = $1.cdf; /*5982*/
			for (var _6L = 0, _6M = _6K.length; _6L < _6M; _6L++) { /*5982*/
				$k[$j++] = $get(_6K, _6L) - 48; /*5982*/
			} /*5982*/
			$1.cdf = $a(); /*5982*/
			$k[$j++] = Infinity; /*5983*/
			var _6S = $get($1.aival, $get($1.ais, 1)); /*5983*/
			$forall($geti(_6S, 3, _6S.length - 3)); /*5983*/
			$1.gpf = $a(); /*5983*/
			$1.ais = $geti($1.ais, 2, $1.ais.length - 2); /*5984*/
		} /*5984*/
		if ($1.gpfallow) { /*5991*/
			$1.vlf = $a(2); /*5989*/
		} else { /*5991*/
			$1.vlf = $a([]); /*5991*/
		} /*5991*/
		$1.aifixed = {}; /*5997*/
		$k[$j++] = Infinity; /*5999*/
		for (var _6b = 0; _6b <= 4; _6b += 1) { /*5999*/
			$k[$j++] = _6b; /*5999*/
		} /*5999*/
		var _6c = $a(); /*5999*/
		for (var _6d = 0, _6e = _6c.length; _6d < _6e; _6d++) { /*6002*/
			var _6h = $strcpy($s(2), "00"); /*6001*/
			$put(_6h, 1, $get(_6c, _6d) + 48); /*6001*/
			$put($1.aifixed, _6h, _6h); /*6001*/
		} /*6001*/
		$k[$j++] = Infinity; /*6007*/
		for (var _6j = 11; _6j <= 20; _6j += 1) { /*6004*/
			$k[$j++] = _6j; /*6004*/
		} /*6004*/
		$k[$j++] = 23; /*6006*/
		for (var _6k = 31; _6k <= 36; _6k += 1) { /*6006*/
			$k[$j++] = _6k; /*6006*/
		} /*6006*/
		$k[$j++] = 41; /*6007*/
		var _6l = $a(); /*6007*/
		for (var _6m = 0, _6n = _6l.length; _6m < _6n; _6m++) { /*6010*/
			var _6q = $cvrs($s(2), $get(_6l, _6m), 10); /*6009*/
			$put($1.aifixed, _6q, _6q); /*6009*/
		} /*6009*/
		$1.fnc1 = -1; /*6012*/
		$1.lnumeric = -2; /*6012*/
		$1.lalphanumeric = -3; /*6012*/
		$1.liso646 = -4; /*6012*/
		$k[$j++] = "numeric"; /*6024*/
		$k[$j++] = Infinity; /*6024*/
		for (var _6s = 0; _6s <= 119; _6s += 1) { /*6023*/
			var _6u = $strcpy($s(2), "00"); /*6016*/
			var _6w = $cvrs($s(2), _6s, 11); /*6016*/
			$puti(_6u, 2 - _6w.length, _6w); /*6017*/
			$k[$j++] = _6s; /*6018*/
			$k[$j++] = _6u; /*6018*/
			if ($get(_6u, 0) == 65) { /*6018*/
				var _6y = $k[--$j]; /*6018*/
				$put(_6y, 0, 94); /*6018*/
				$k[$j++] = _6y; /*6018*/
			} /*6018*/
			var _6z = $k[--$j]; /*6019*/
			$k[$j++] = _6z; /*6019*/
			if ($get(_6z, 1) == 65) { /*6019*/
				var _71 = $k[--$j]; /*6019*/
				$put(_71, 1, 94); /*6019*/
				$k[$j++] = _71; /*6019*/
			} /*6019*/
			var _72 = $k[--$j]; /*6020*/
			var _75 = $strcpy($s(7), "0000000"); /*6021*/
			var _77 = $cvrs($s(7), $k[--$j] + 8, 2); /*6021*/
			$puti(_75, 7 - _77.length, _77); /*6022*/
			$k[$j++] = _72; /*6022*/
			$k[$j++] = _75; /*6022*/
		} /*6022*/
		$k[$j++] = $1.lalphanumeric; /*6024*/
		$k[$j++] = "0000"; /*6024*/
		var _79 = $d(); /*6024*/
		$1[$k[--$j]] = _79; /*6025*/
		$k[$j++] = "alphanumeric"; /*6034*/
		$k[$j++] = Infinity; /*6034*/
		for (var _7B = 48; _7B <= 57; _7B += 1) { /*6028*/
			$k[$j++] = _7B; /*6028*/
			$k[$j++] = _7B - 43; /*6028*/
			$k[$j++] = 5; /*6028*/
			$1.tobin(); /*6028*/
		} /*6028*/
		$k[$j++] = $1.fnc1; /*6030*/
		$k[$j++] = "01111"; /*6030*/
		for (var _7D = 65; _7D <= 90; _7D += 1) { /*6030*/
			$k[$j++] = _7D; /*6030*/
			$k[$j++] = _7D - 33; /*6030*/
			$k[$j++] = 6; /*6030*/
			$1.tobin(); /*6030*/
		} /*6030*/
		$k[$j++] = 42; /*6032*/
		$k[$j++] = "111010"; /*6032*/
		for (var _7E = 44; _7E <= 47; _7E += 1) { /*6032*/
			$k[$j++] = _7E; /*6032*/
			$k[$j++] = _7E + 15; /*6032*/
			$k[$j++] = 6; /*6032*/
			$1.tobin(); /*6032*/
		} /*6032*/
		$k[$j++] = $1.lnumeric; /*6034*/
		$k[$j++] = "000"; /*6034*/
		$k[$j++] = $1.liso646; /*6034*/
		$k[$j++] = "00100"; /*6034*/
		var _7H = $d(); /*6034*/
		$1[$k[--$j]] = _7H; /*6035*/
		$k[$j++] = "iso646"; /*6049*/
		$k[$j++] = Infinity; /*6049*/
		for (var _7J = 48; _7J <= 57; _7J += 1) { /*6038*/
			$k[$j++] = _7J; /*6038*/
			$k[$j++] = _7J - 43; /*6038*/
			$k[$j++] = 5; /*6038*/
			$1.tobin(); /*6038*/
		} /*6038*/
		$k[$j++] = $1.fnc1; /*6040*/
		$k[$j++] = "01111"; /*6040*/
		for (var _7L = 65; _7L <= 90; _7L += 1) { /*6040*/
			$k[$j++] = _7L; /*6040*/
			$k[$j++] = _7L - 1; /*6040*/
			$k[$j++] = 7; /*6040*/
			$1.tobin(); /*6040*/
		} /*6040*/
		for (var _7M = 97; _7M <= 122; _7M += 1) { /*6041*/
			$k[$j++] = _7M; /*6041*/
			$k[$j++] = _7M - 7; /*6041*/
			$k[$j++] = 7; /*6041*/
			$1.tobin(); /*6041*/
		} /*6041*/
		$k[$j++] = 33; /*6044*/
		$k[$j++] = "11101000"; /*6044*/
		$k[$j++] = 34; /*6044*/
		$k[$j++] = "11101001"; /*6044*/
		for (var _7N = 37; _7N <= 47; _7N += 1) { /*6044*/
			$k[$j++] = _7N; /*6044*/
			$k[$j++] = _7N + 197; /*6044*/
			$k[$j++] = 8; /*6044*/
			$1.tobin(); /*6044*/
		} /*6044*/
		for (var _7O = 58; _7O <= 63; _7O += 1) { /*6045*/
			$k[$j++] = _7O; /*6045*/
			$k[$j++] = _7O + 187; /*6045*/
			$k[$j++] = 8; /*6045*/
			$1.tobin(); /*6045*/
		} /*6045*/
		$k[$j++] = 95; /*6049*/
		$k[$j++] = "11111011"; /*6049*/
		$k[$j++] = 32; /*6049*/
		$k[$j++] = "11111100"; /*6049*/
		$k[$j++] = $1.lnumeric; /*6049*/
		$k[$j++] = "000"; /*6049*/
		$k[$j++] = $1.lalphanumeric; /*6049*/
		$k[$j++] = "00100"; /*6049*/
		var _7R = $d(); /*6049*/
		$1[$k[--$j]] = _7R; /*6050*/
		for (var _7V = 0, _7U = $1.ais.length - 1; _7V <= _7U; _7V += 1) { /*6068*/
			$1.i = _7V; /*6054*/
			$1.ai = $get($1.ais, $1.i); /*6055*/
			$1.val = $get($1.aival, $1.ai); /*6056*/
			var _7f = $a(($1.gpf.length + $1.ai.length) + $1.val.length); /*6057*/
			$puti(_7f, 0, $1.gpf); /*6058*/
			$k[$j++] = _7f; /*6059*/
			$k[$j++] = _7f; /*6059*/
			$k[$j++] = $1.gpf.length; /*6059*/
			$k[$j++] = $1.ai; /*6059*/
			$k[$j++] = Infinity; /*6059*/
			var _7j = $k[--$j]; /*6059*/
			var _7k = $k[--$j]; /*6059*/
			$k[$j++] = _7j; /*6059*/
			$forall(_7k); /*6059*/
			var _7l = $a(); /*6059*/
			var _7m = $k[--$j]; /*6059*/
			$puti($k[--$j], _7m, _7l); /*6059*/
			var _7o = $k[--$j]; /*6060*/
			$k[$j++] = _7o; /*6060*/
			$k[$j++] = _7o; /*6060*/
			$k[$j++] = $1.gpf.length + $1.ai.length; /*6060*/
			$k[$j++] = $1.val; /*6060*/
			$k[$j++] = Infinity; /*6060*/
			var _7s = $k[--$j]; /*6060*/
			var _7t = $k[--$j]; /*6060*/
			$k[$j++] = _7s; /*6060*/
			$forall(_7t); /*6060*/
			var _7u = $a(); /*6060*/
			var _7v = $k[--$j]; /*6060*/
			$puti($k[--$j], _7v, _7u); /*6060*/
			$1.gpf = $k[--$j]; /*6061*/
			var _83 = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*6062*/
			if (($1.i != ($1.ais.length - 1)) && (!_83)) { /*6067*/
				var _85 = $a($1.gpf.length + 1); /*6063*/
				$puti(_85, 0, $1.gpf); /*6064*/
				$put(_85, $1.gpf.length, $1.fnc1); /*6065*/
				$1.gpf = _85; /*6066*/
			} /*6066*/
		} /*6066*/
		$1.rembits = function() {
			var _89 = $k[--$j]; /*6072*/
			var _8A = 48; /*6074*/
			var _8B = (~~Math.ceil(_89 / 12)) * 12; /*6074*/
			if (((~~Math.ceil(_89 / 12)) * 12) < 48) { /*6074*/
				var _ = _8A; /*6074*/
				_8A = _8B; /*6074*/
				_8B = _; /*6074*/
			} /*6074*/
			var _8C = ~~(_8B / 12); /*6075*/
			$k[$j++] = _89; /*6079*/
			$k[$j++] = _8B; /*6079*/
			$k[$j++] = _8C; /*6079*/
			if ((_8C % $1.segments) == 1) { /*6078*/
				var _8E = $k[--$j]; /*6076*/
				var _8F = $k[--$j]; /*6076*/
				$k[$j++] = (_8E + 1) * 12; /*6076*/
			} else { /*6078*/
				$j--; /*6078*/
			} /*6078*/
			var _8G = $k[--$j]; /*6080*/
			var _8H = $k[--$j]; /*6080*/
			$k[$j++] = _8G - _8H; /*6080*/
		}; /*6081*/
		$1.encode = function() {
			var _8I = $k[--$j]; /*6084*/
			$k[$j++] = _8I; /*6084*/
			if ($ne(_8I, "raw")) { /*6084*/
				var _8J = $k[--$j]; /*6084*/
				var _8L = $get(_8J, $k[--$j]); /*6084*/
				$k[$j++] = _8L; /*6084*/
			} else { /*6084*/
				$j--; /*6084*/
			} /*6084*/
			$k[$j++] = Infinity; /*6085*/
			var _8M = $k[--$j]; /*6085*/
			var _8N = $k[--$j]; /*6085*/
			$k[$j++] = _8M; /*6085*/
			$forall(_8N, function() { /*6085*/
				var _8O = $k[--$j]; /*6085*/
				$k[$j++] = _8O - 48; /*6085*/
			}); /*6085*/
			var _8P = $a(); /*6085*/
			$puti($1.gpfenc, $1.j, _8P); /*6087*/
			$1.j = _8P.length + $1.j; /*6088*/
		}; /*6089*/
		$k[$j++] = Infinity; /*6092*/
		for (var _8U = 0, _8V = $1.gpf.length; _8U < _8V; _8U++) { /*6092*/
			$k[$j++] = 0; /*6092*/
		} /*6092*/
		$k[$j++] = 0; /*6092*/
		$k[$j++] = -1; /*6092*/
		$1.numericruns = $a(); /*6092*/
		$k[$j++] = Infinity; /*6093*/
		for (var _8Y = 0, _8Z = $1.gpf.length; _8Y < _8Z; _8Y++) { /*6093*/
			$k[$j++] = 0; /*6093*/
		} /*6093*/
		$k[$j++] = 0; /*6093*/
		$1.alphanumericruns = $a(); /*6093*/
		$k[$j++] = Infinity; /*6094*/
		for (var _8c = 0, _8d = $1.gpf.length; _8c < _8d; _8c++) { /*6094*/
			$k[$j++] = 0; /*6094*/
		} /*6094*/
		$k[$j++] = 9999; /*6094*/
		$1.nextiso646only = $a(); /*6094*/
		for (var _8g = $1.gpf.length - 1; _8g >= 0; _8g -= 1) { /*6116*/
			$1.i = _8g; /*6096*/
			var _8l = $strcpy($s(2), "00"); /*6098*/
			var _8o = $get($1.gpf, $1.i); /*6099*/
			$k[$j++] = $get($1.gpf, $1.i); /*6099*/
			$k[$j++] = _8l; /*6099*/
			$k[$j++] = _8l; /*6099*/
			$k[$j++] = 0; /*6099*/
			$k[$j++] = _8o; /*6099*/
			if (_8o == $1.fnc1) { /*6099*/
				$j--; /*6099*/
				$k[$j++] = 94; /*6099*/
			} /*6099*/
			var _8q = $k[--$j]; /*6099*/
			var _8r = $k[--$j]; /*6099*/
			$put($k[--$j], _8r, _8q); /*6099*/
			if ($1.i < ($1.gpf.length - 1)) { /*6100*/
				var _8v = $k[--$j]; /*6100*/
				var _8y = $get($1.gpf, $1.i + 1); /*6100*/
				$k[$j++] = _8v; /*6100*/
				$k[$j++] = _8v; /*6100*/
				$k[$j++] = 1; /*6100*/
				$k[$j++] = _8y; /*6100*/
				if (_8y == $1.fnc1) { /*6100*/
					$j--; /*6100*/
					$k[$j++] = 94; /*6100*/
				} /*6100*/
				var _90 = $k[--$j]; /*6100*/
				var _91 = $k[--$j]; /*6100*/
				$put($k[--$j], _91, _90); /*6100*/
			} /*6100*/
			var _95 = $get($1.numeric, $k[--$j]) !== undefined; /*6101*/
			if (_95) { /*6104*/
				$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 2) + 2); /*6102*/
			} else { /*6104*/
				$put($1.numericruns, $1.i, 0); /*6104*/
			} /*6104*/
			var _9D = $k[--$j]; /*6106*/
			var _9F = $get($1.alphanumeric, _9D) !== undefined; /*6106*/
			$k[$j++] = _9D; /*6110*/
			if (_9F) { /*6109*/
				$put($1.alphanumericruns, $1.i, $get($1.alphanumericruns, $1.i + 1) + 1); /*6107*/
			} else { /*6109*/
				$put($1.alphanumericruns, $1.i, 0); /*6109*/
			} /*6109*/
			var _9N = $k[--$j]; /*6111*/
			var _9P = $get($1.iso646, _9N) !== undefined; /*6111*/
			var _9R = $get($1.alphanumeric, _9N) !== undefined; /*6111*/
			if (_9P && (!_9R)) { /*6114*/
				$put($1.nextiso646only, $1.i, 0); /*6112*/
			} else { /*6114*/
				$put($1.nextiso646only, $1.i, $get($1.nextiso646only, $1.i + 1) + 1); /*6114*/
			} /*6114*/
		} /*6114*/
		$1.gpfenc = $a(252); /*6119*/
		$1.i = 0; /*6120*/
		$1.j = 0; /*6120*/
		$1.mode = "numeric"; /*6120*/
		for (;;) { /*6210*/
			if ($1.i == $1.gpf.length) { /*6122*/
				break; /*6122*/
			} /*6122*/
			for (;;) { /*6209*/
				if ($eq($1.mode, "numeric")) { /*6158*/
					if ($1.i <= ($1.gpf.length - 2)) { /*6155*/
						var _9f = $s(2); /*6127*/
						var _9i = $get($1.gpf, $1.i); /*6128*/
						$k[$j++] = _9f; /*6128*/
						$k[$j++] = _9f; /*6128*/
						$k[$j++] = 0; /*6128*/
						$k[$j++] = _9i; /*6128*/
						if (_9i == $1.fnc1) { /*6128*/
							$j--; /*6128*/
							$k[$j++] = 94; /*6128*/
						} /*6128*/
						var _9k = $k[--$j]; /*6128*/
						var _9l = $k[--$j]; /*6128*/
						$put($k[--$j], _9l, _9k); /*6128*/
						var _9n = $k[--$j]; /*6129*/
						var _9q = $get($1.gpf, $1.i + 1); /*6129*/
						$k[$j++] = _9n; /*6129*/
						$k[$j++] = _9n; /*6129*/
						$k[$j++] = 1; /*6129*/
						$k[$j++] = _9q; /*6129*/
						if (_9q == $1.fnc1) { /*6129*/
							$j--; /*6129*/
							$k[$j++] = 94; /*6129*/
						} /*6129*/
						var _9s = $k[--$j]; /*6129*/
						var _9t = $k[--$j]; /*6129*/
						$put($k[--$j], _9t, _9s); /*6129*/
						var _9v = $k[--$j]; /*6130*/
						var _9x = $get($1.numeric, _9v) !== undefined; /*6130*/
						$k[$j++] = _9v; /*6134*/
						if (_9x) { /*6134*/
							$k[$j++] = $1.numeric; /*6131*/
							$1.encode(); /*6131*/
							$1.i = $1.i + 2; /*6132*/
							break; /*6133*/
						} /*6133*/
						$j--; /*6135*/
						$k[$j++] = $1.lalphanumeric; /*6136*/
						$k[$j++] = $1.numeric; /*6136*/
						$1.encode(); /*6136*/
						$1.mode = "alphanumeric"; /*6137*/
						break; /*6138*/
					} else { /*6155*/
						var _A4 = $get($1.gpf, $1.i); /*6140*/
						if ((_A4 < 48) || (_A4 > 57)) { /*6144*/
							$k[$j++] = $1.lalphanumeric; /*6141*/
							$k[$j++] = $1.numeric; /*6141*/
							$1.encode(); /*6141*/
							$1.mode = "alphanumeric"; /*6142*/
							break; /*6143*/
						} /*6143*/
						$k[$j++] = "rem"; /*6145*/
						$k[$j++] = ((((12 + 1) + $1.method.length) + $1.vlf.length) + $1.cdf.length) + $1.j; /*6145*/
						$1.rembits(); /*6145*/
						var _AB = $k[--$j]; /*6145*/
						$1[$k[--$j]] = _AB; /*6145*/
						if (($1.rem >= 4) && ($1.rem <= 6)) { /*6155*/
							var _AI = $geti($strcpy($s(6), "000000"), 0, $1.rem); /*6147*/
							var _AN = $cvrs($s(4), $get($1.gpf, $1.i) - 47, 2); /*6148*/
							$puti(_AI, 4 - _AN.length, _AN); /*6149*/
							$k[$j++] = _AI; /*6149*/
							$k[$j++] = "raw"; /*6149*/
							$1.encode(); /*6149*/
							$1.i = $1.i + 1; /*6150*/
							break; /*6151*/
						} else { /*6155*/
							var _AP = $s(2); /*6153*/
							$put(_AP, 0, $get($1.gpf, $1.i)); /*6153*/
							$put(_AP, 1, 94); /*6153*/
							$k[$j++] = _AP; /*6153*/
							$k[$j++] = $1.numeric; /*6153*/
							$1.encode(); /*6153*/
							$1.i = $1.i + 1; /*6154*/
							break; /*6155*/
						} /*6155*/
					} /*6155*/
				} /*6155*/
				if ($eq($1.mode, "alphanumeric")) { /*6185*/
					if ($get($1.gpf, $1.i) == $1.fnc1) { /*6166*/
						$k[$j++] = $1.fnc1; /*6162*/
						$k[$j++] = $1.alphanumeric; /*6162*/
						$1.encode(); /*6162*/
						$1.mode = "numeric"; /*6163*/
						$1.i = $1.i + 1; /*6164*/
						break; /*6165*/
					} /*6165*/
					var _Af = $get($1.gpf, $1.i); /*6167*/
					var _Ah = $get($1.iso646, _Af) !== undefined; /*6167*/
					var _Aj = $get($1.alphanumeric, _Af) !== undefined; /*6167*/
					if (_Ah && (!_Aj)) { /*6171*/
						$k[$j++] = $1.liso646; /*6168*/
						$k[$j++] = $1.alphanumeric; /*6168*/
						$1.encode(); /*6168*/
						$1.mode = "iso646"; /*6169*/
						break; /*6170*/
					} /*6170*/
					if ($get($1.numericruns, $1.i) >= 6) { /*6176*/
						$k[$j++] = $1.lnumeric; /*6173*/
						$k[$j++] = $1.alphanumeric; /*6173*/
						$1.encode(); /*6173*/
						$1.mode = "numeric"; /*6174*/
						break; /*6175*/
					} /*6175*/
					var _At = $get($1.numericruns, $1.i); /*6177*/
					if ((_At >= 4) && ((_At + $1.i) == $1.gpf.length)) { /*6181*/
						$k[$j++] = $1.lnumeric; /*6178*/
						$k[$j++] = $1.alphanumeric; /*6178*/
						$1.encode(); /*6178*/
						$1.mode = "numeric"; /*6179*/
						break; /*6180*/
					} /*6180*/
					$k[$j++] = $get($1.gpf, $1.i); /*6182*/
					$k[$j++] = $1.alphanumeric; /*6182*/
					$1.encode(); /*6182*/
					$1.i = $1.i + 1; /*6183*/
					break; /*6184*/
				} /*6184*/
				if ($eq($1.mode, "iso646")) { /*6207*/
					if ($get($1.gpf, $1.i) == $1.fnc1) { /*6193*/
						$k[$j++] = $1.fnc1; /*6189*/
						$k[$j++] = $1.iso646; /*6189*/
						$1.encode(); /*6189*/
						$1.mode = "numeric"; /*6190*/
						$1.i = $1.i + 1; /*6191*/
						break; /*6192*/
					} /*6192*/
					if (($get($1.numericruns, $1.i) >= 4) && ($get($1.nextiso646only, $1.i) >= 10)) { /*6198*/
						$k[$j++] = $1.lnumeric; /*6195*/
						$k[$j++] = $1.iso646; /*6195*/
						$1.encode(); /*6195*/
						$1.mode = "numeric"; /*6196*/
						break; /*6197*/
					} /*6197*/
					if (($get($1.alphanumericruns, $1.i) >= 5) && ($get($1.nextiso646only, $1.i) >= 10)) { /*6203*/
						$k[$j++] = $1.lalphanumeric; /*6200*/
						$k[$j++] = $1.iso646; /*6200*/
						$1.encode(); /*6200*/
						$1.mode = "alphanumeric"; /*6201*/
						break; /*6202*/
					} /*6202*/
					$k[$j++] = $get($1.gpf, $1.i); /*6204*/
					$k[$j++] = $1.iso646; /*6204*/
					$1.encode(); /*6204*/
					$1.i = $1.i + 1; /*6205*/
					break; /*6206*/
				} /*6206*/
			} /*6206*/
		} /*6206*/
		$1.gpf = $geti($1.gpfenc, 0, $1.j); /*6211*/
		var _Bd = ((((1 + 12) + $1.method.length) + $1.vlf.length) + $1.cdf.length) + $1.gpf.length; /*6215*/
		$k[$j++] = _Bd; /*6215*/
		$k[$j++] = _Bd; /*6215*/
		$1.rembits(); /*6215*/
		var _Be = $k[--$j]; /*6215*/
		$1.pad = $a(_Be); /*6215*/
		$k[$j++] = _Be; /*6222*/
		if ($1.vlf.length != 0) { /*6221*/
			var _Bh = $k[--$j]; /*6217*/
			var _Bj = ~~(($k[--$j] + _Bh) / 12); /*6218*/
			$put($1.vlf, 0, _Bj % 2); /*6218*/
			var _Bl = (_Bj <= 14) ? 0 : 1; /*6219*/
			$put($1.vlf, 1, _Bl); /*6219*/
		} else { /*6221*/
			$j -= 2; /*6221*/
		} /*6221*/
		if ($1.pad.length > 0) { /*6231*/
			for (var _Bq = 0, _Bp = $1.pad.length - 1; _Bq <= _Bp; _Bq += 5) { /*6227*/
				$1.i = _Bq; /*6225*/
				var _Br = $1.pad; /*6226*/
				var _Bs = $1.i; /*6226*/
				var _Bt = $a([0, 0, 1, 0, 0]); /*6226*/
				var _Bu = $1.pad; /*6226*/
				var _Bv = $1.i; /*6226*/
				var _Bw = 5; /*6226*/
				var _Bx = _Bu.length - _Bv; /*6226*/
				if ((_Bu.length - _Bv) > 5) { /*6226*/
					var _ = _Bw; /*6226*/
					_Bw = _Bx; /*6226*/
					_Bx = _; /*6226*/
				} /*6226*/
				$puti(_Br, _Bs, $geti(_Bt, 0, _Bx)); /*6226*/
			} /*6226*/
			if ($eq($1.mode, "numeric")) { /*6230*/
				$k[$j++] = "pad"; /*6229*/
				$k[$j++] = Infinity; /*6229*/
				$k[$j++] = 0; /*6229*/
				$k[$j++] = 0; /*6229*/
				$k[$j++] = 0; /*6229*/
				$k[$j++] = 0; /*6229*/
				$aload($1.pad); /*6229*/
				var _C3 = $geti($a(), 0, $1.pad.length); /*6229*/
				$1[$k[--$j]] = _C3; /*6229*/
			} /*6229*/
		} /*6229*/
		$k[$j++] = Infinity; /*6241*/
		var _C6 = $1.linkage ? 1 : 0; /*6235*/
		$k[$j++] = _C6; /*6236*/
		$forall($1.method, function() { /*6236*/
			var _C8 = $k[--$j]; /*6236*/
			$k[$j++] = _C8 - 48; /*6236*/
		}); /*6236*/
		$aload($1.vlf); /*6237*/
		$aload($1.cdf); /*6238*/
		$aload($1.gpf); /*6239*/
		$aload($1.pad); /*6240*/
		$1.binval = $a(); /*6241*/
		$1.datalen = ~~($1.binval.length / 12); /*6242*/
		$1.ncr = function() {
			var _CF = $k[--$j]; /*6245*/
			var _CG = $k[--$j]; /*6245*/
			var _CH = _CG - _CF; /*6245*/
			if (_CF < (_CG - _CF)) { /*6245*/
				var _ = _CH; /*6245*/
				_CH = _CF; /*6245*/
				_CF = _; /*6245*/
			} /*6245*/
			$k[$j++] = _CH; /*6252*/
			$k[$j++] = 1; /*6252*/
			$k[$j++] = 1; /*6252*/
			for (var _CJ = _CG, _CI = _CF + 1; _CJ >= _CI; _CJ -= 1) { /*6252*/
				var _CK = $k[--$j]; /*6248*/
				var _CL = $k[--$j]; /*6249*/
				var _CM = $k[--$j]; /*6249*/
				$k[$j++] = _CM; /*6251*/
				$k[$j++] = _CL; /*6251*/
				$k[$j++] = _CK * _CJ; /*6251*/
				if ($le(_CL, _CM)) { /*6251*/
					var _CN = $k[--$j]; /*6250*/
					var _CO = $k[--$j]; /*6250*/
					$k[$j++] = _CO + 1; /*6250*/
					$k[$j++] = ~~(_CN / _CO); /*6250*/
				} /*6250*/
			} /*6250*/
			for (;;) { /*6256*/
				var _CP = $k[--$j]; /*6254*/
				var _CQ = $k[--$j]; /*6254*/
				var _CR = $k[--$j]; /*6254*/
				$k[$j++] = _CR; /*6254*/
				$k[$j++] = _CQ; /*6254*/
				$k[$j++] = _CP; /*6254*/
				if ($gt(_CQ, _CR)) { /*6254*/
					break; /*6254*/
				} /*6254*/
				var _CS = $k[--$j]; /*6255*/
				var _CT = $k[--$j]; /*6255*/
				$k[$j++] = _CT + 1; /*6255*/
				$k[$j++] = ~~(_CS / _CT); /*6255*/
			} /*6255*/
			var _CU = $k[--$j]; /*6257*/
			var _CV = $k[--$j]; /*6257*/
			var _CW = $k[--$j]; /*6257*/
			$k[$j++] = _CU; /*6257*/
		}; /*6258*/
		$1.getRSSwidths = function() {
			$1.oe = $k[--$j]; /*6261*/
			$1.el = $k[--$j]; /*6262*/
			$1.mw = $k[--$j]; /*6263*/
			$1.nm = $k[--$j]; /*6264*/
			$1.val = $k[--$j]; /*6265*/
			$1.out = $a($1.el); /*6266*/
			$1.mask = 0; /*6267*/
			for (var _Cg = 0, _Cf = $1.el - 2; _Cg <= _Cf; _Cg += 1) { /*6294*/
				$1.bar = _Cg; /*6269*/
				$1.ew = 1; /*6270*/
				var _Ci = $1.bar; /*6271*/
				$1.mask = $1.mask | ((_Ci < 0 ? 1 >>> -_Ci : 1 << _Ci)); /*6271*/
				for (;;) { /*6290*/
					$k[$j++] = "sval"; /*6272*/
					$k[$j++] = ($1.nm - $1.ew) - 1; /*6272*/
					$k[$j++] = ($1.el - $1.bar) - 2; /*6272*/
					$1.ncr(); /*6272*/
					var _Cn = $k[--$j]; /*6272*/
					$1[$k[--$j]] = _Cn; /*6272*/
					if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*6275*/
						$k[$j++] = "sval"; /*6274*/
						$k[$j++] = $1.sval; /*6274*/
						$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*6274*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*6274*/
						$1.ncr(); /*6274*/
						var _D2 = $k[--$j]; /*6274*/
						var _D3 = $k[--$j]; /*6274*/
						$1[$k[--$j]] = _D3 - _D2; /*6274*/
					} /*6274*/
					if (($1.el - $1.bar) > 2) { /*6284*/
						$1.lval = 0; /*6277*/
						for (var _DD = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _DC = $1.mw + 1; _DD >= _DC; _DD -= 1) { /*6281*/
							$k[$j++] = (($1.nm - _DD) - $1.ew) - 1; /*6279*/
							$k[$j++] = ($1.el - $1.bar) - 3; /*6279*/
							$1.ncr(); /*6279*/
							$1.lval = $k[--$j] + $1.lval; /*6280*/
						} /*6280*/
						$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*6282*/
					} else { /*6284*/
						if (($1.nm - $1.ew) > $1.mw) { /*6284*/
							$1.sval = $1.sval - 1; /*6284*/
						} /*6284*/
					} /*6284*/
					$1.val = $1.val - $1.sval; /*6286*/
					if ($1.val < 0) { /*6287*/
						break; /*6287*/
					} /*6287*/
					$1.ew = $1.ew + 1; /*6288*/
					var _DX = $1.bar; /*6289*/
					$1.mask = $1.mask & (~((_DX < 0 ? 1 >>> -_DX : 1 << _DX))); /*6289*/
				} /*6289*/
				$1.val = $1.val + $1.sval; /*6291*/
				$1.nm = $1.nm - $1.ew; /*6292*/
				$put($1.out, $1.bar, $1.ew); /*6293*/
			} /*6293*/
			$put($1.out, $1.el - 1, $1.nm); /*6295*/
			$k[$j++] = $1.out; /*6296*/
		}; /*6297*/
		$1.tab174 = $a([347, 0, 12, 5, 7, 2, 87, 4, 1387, 348, 10, 7, 5, 4, 52, 20, 2947, 1388, 8, 9, 4, 5, 30, 52, 3987, 2948, 6, 11, 3, 6, 10, 104, 4191, 3988, 4, 13, 1, 8, 1, 204]); /*6305*/
		$1.dxw = $a($1.datalen); /*6307*/
		for (var _Do = 0, _Dn = $1.datalen - 1; _Do <= _Dn; _Do += 1) { /*6348*/
			$1.x = _Do; /*6311*/
			$1.d = $geti($1.binval, $1.x * 12, 12); /*6313*/
			$k[$j++] = "d"; /*6314*/
			$k[$j++] = 0; /*6314*/
			for (var _Ds = 0; _Ds <= 11; _Ds += 1) { /*6314*/
				$1.j = _Ds; /*6314*/
				var _Dx = $k[--$j]; /*6314*/
				$k[$j++] = _Dx + ((~~Math.pow(2, 11 - $1.j)) * $get($1.d, $1.j)); /*6314*/
			} /*6314*/
			var _Dy = $k[--$j]; /*6314*/
			$1[$k[--$j]] = _Dy; /*6314*/
			$1.j = 0; /*6316*/
			for (;;) { /*6326*/
				if ($le($1.d, $get($1.tab174, $1.j))) { /*6324*/
					$forall($geti($1.tab174, $1.j + 1, 7)); /*6318*/
					$1.dte = $k[--$j]; /*6319*/
					$1.dto = $k[--$j]; /*6319*/
					$1.dmwe = $k[--$j]; /*6320*/
					$1.dmwo = $k[--$j]; /*6320*/
					$1.dele = $k[--$j]; /*6321*/
					$1.delo = $k[--$j]; /*6321*/
					$1.dgs = $k[--$j]; /*6322*/
					break; /*6323*/
				} /*6323*/
				$1.j = $1.j + 8; /*6325*/
			} /*6325*/
			$k[$j++] = "dwo"; /*6328*/
			$k[$j++] = ~~(($1.d - $1.dgs) / $1.dte); /*6328*/
			$k[$j++] = $1.delo; /*6328*/
			$k[$j++] = $1.dmwo; /*6328*/
			$k[$j++] = 4; /*6328*/
			$k[$j++] = true; /*6328*/
			$1.getRSSwidths(); /*6328*/
			var _EK = $k[--$j]; /*6328*/
			$1[$k[--$j]] = _EK; /*6328*/
			$k[$j++] = "dwe"; /*6329*/
			$k[$j++] = ($1.d - $1.dgs) % $1.dte; /*6329*/
			$k[$j++] = $1.dele; /*6329*/
			$k[$j++] = $1.dmwe; /*6329*/
			$k[$j++] = 4; /*6329*/
			$k[$j++] = false; /*6329*/
			$1.getRSSwidths(); /*6329*/
			var _ER = $k[--$j]; /*6329*/
			$1[$k[--$j]] = _ER; /*6329*/
			$1.dw = $a(8); /*6331*/
			if (($1.x % 2) == 0) { /*6342*/
				for (var _EV = 0; _EV <= 3; _EV += 1) { /*6337*/
					$1.j = _EV; /*6334*/
					$put($1.dw, 7 - ($1.j * 2), $get($1.dwo, $1.j)); /*6335*/
					$put($1.dw, 6 - ($1.j * 2), $get($1.dwe, $1.j)); /*6336*/
				} /*6336*/
			} else { /*6342*/
				for (var _Eg = 0; _Eg <= 3; _Eg += 1) { /*6343*/
					$1.j = _Eg; /*6340*/
					$put($1.dw, $1.j * 2, $get($1.dwo, $1.j)); /*6341*/
					$put($1.dw, ($1.j * 2) + 1, $get($1.dwe, $1.j)); /*6342*/
				} /*6342*/
			} /*6342*/
			$put($1.dxw, $1.x, $1.dw); /*6346*/
		} /*6346*/
		$1.finderwidths = $a([1, 8, 4, 1, 1, 1, 1, 4, 8, 1, 3, 6, 4, 1, 1, 1, 1, 4, 6, 3, 3, 4, 6, 1, 1, 1, 1, 6, 4, 3, 3, 2, 8, 1, 1, 1, 1, 8, 2, 3, 2, 6, 5, 1, 1, 1, 1, 5, 6, 2, 2, 2, 9, 1, 1, 1, 1, 9, 2, 2]); /*6357*/
		$1.finderseq = $a([$a([0, 1]), $a([0, 3, 2]), $a([0, 5, 2, 7]), $a([0, 9, 2, 7, 4]), $a([0, 9, 2, 7, 6, 11]), $a([0, 9, 2, 7, 8, 11, 10]), $a([0, 1, 2, 3, 4, 5, 6, 7]), $a([0, 1, 2, 3, 4, 5, 6, 9, 8]), $a([0, 1, 2, 3, 4, 5, 6, 9, 10, 11]), $a([0, 1, 2, 3, 4, 7, 6, 9, 8, 11, 10])]); /*6370*/
		$1.seq = $get($1.finderseq, ~~(($1.datalen - 2) / 2)); /*6372*/
		$1.fxw = $a($1.seq.length); /*6373*/
		for (var _FD = 0, _FC = $1.seq.length - 1; _FD <= _FC; _FD += 1) { /*6377*/
			$1.x = _FD; /*6375*/
			$put($1.fxw, $1.x, $geti($1.finderwidths, $get($1.seq, $1.x) * 5, 5)); /*6376*/
		} /*6376*/
		$1.checkweights = $a([-1, -1, -1, -1, -1, -1, -1, -1, 77, 96, 32, 81, 27, 9, 3, 1, 20, 60, 180, 118, 143, 7, 21, 63, 205, 209, 140, 117, 39, 13, 145, 189, 193, 157, 49, 147, 19, 57, 171, 91, 132, 44, 85, 169, 197, 136, 186, 62, 185, 133, 188, 142, 4, 12, 36, 108, 50, 87, 29, 80, 97, 173, 128, 113, 150, 28, 84, 41, 123, 158, 52, 156, 166, 196, 206, 139, 187, 203, 138, 46, 76, 17, 51, 153, 37, 111, 122, 155, 146, 119, 110, 107, 106, 176, 129, 43, 16, 48, 144, 10, 30, 90, 59, 177, 164, 125, 112, 178, 200, 137, 116, 109, 70, 210, 208, 202, 184, 130, 179, 115, 190, 204, 68, 93, 31, 151, 191, 134, 148, 22, 66, 198, 172, 94, 71, 2, 40, 154, 192, 64, 162, 54, 18, 6, 120, 149, 25, 75, 14, 42, 126, 167, 175, 199, 207, 69, 23, 78, 26, 79, 103, 98, 83, 38, 114, 131, 182, 124, 159, 53, 88, 170, 127, 183, 61, 161, 55, 165, 73, 8, 24, 72, 5, 15, 89, 100, 174, 58, 160, 194, 135, 45]); /*6404*/
		$k[$j++] = "checkweightseq"; /*6408*/
		$k[$j++] = Infinity; /*6408*/
		$forall($1.seq, function() { /*6407*/
			$aload($geti($1.checkweights, $k[--$j] * 16, 16)); /*6407*/
		}); /*6407*/
		var _FQ = $a(); /*6408*/
		$1[$k[--$j]] = $geti(_FQ, 8, _FQ.length - 8); /*6408*/
		$k[$j++] = Infinity; /*6412*/
		var _FT = $1.dxw; /*6411*/
		for (var _FU = 0, _FV = _FT.length; _FU < _FV; _FU++) { /*6411*/
			$forall($get(_FT, _FU)); /*6411*/
		} /*6411*/
		$1.widths = $a(); /*6412*/
		$1.checksum = 0; /*6414*/
		for (var _Fa = 0, _FZ = $1.widths.length - 1; _Fa <= _FZ; _Fa += 1) { /*6418*/
			$1.i = _Fa; /*6416*/
			$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweightseq, $1.i)); /*6417*/
		} /*6417*/
		$1.checksum = ($1.checksum % 211) + (($1.datalen - 3) * 211); /*6419*/
		$1.i = 0; /*6421*/
		for (;;) { /*6431*/
			if ($1.checksum <= $get($1.tab174, $1.i)) { /*6429*/
				$forall($geti($1.tab174, $1.i + 1, 7)); /*6423*/
				$1.cte = $k[--$j]; /*6424*/
				$1.cto = $k[--$j]; /*6424*/
				$1.cmwe = $k[--$j]; /*6425*/
				$1.cmwo = $k[--$j]; /*6425*/
				$1.cele = $k[--$j]; /*6426*/
				$1.celo = $k[--$j]; /*6426*/
				$1.cgs = $k[--$j]; /*6427*/
				break; /*6428*/
			} /*6428*/
			$1.i = $1.i + 8; /*6430*/
		} /*6430*/
		$k[$j++] = "cwo"; /*6433*/
		$k[$j++] = ~~(($1.checksum - $1.cgs) / $1.cte); /*6433*/
		$k[$j++] = $1.celo; /*6433*/
		$k[$j++] = $1.cmwo; /*6433*/
		$k[$j++] = 4; /*6433*/
		$k[$j++] = true; /*6433*/
		$1.getRSSwidths(); /*6433*/
		var _G4 = $k[--$j]; /*6433*/
		$1[$k[--$j]] = _G4; /*6433*/
		$k[$j++] = "cwe"; /*6434*/
		$k[$j++] = ($1.checksum - $1.cgs) % $1.cte; /*6434*/
		$k[$j++] = $1.cele; /*6434*/
		$k[$j++] = $1.cmwe; /*6434*/
		$k[$j++] = 4; /*6434*/
		$k[$j++] = false; /*6434*/
		$1.getRSSwidths(); /*6434*/
		var _GB = $k[--$j]; /*6434*/
		$1[$k[--$j]] = _GB; /*6434*/
		$1.cw = $a(8); /*6436*/
		for (var _GE = 0; _GE <= 3; _GE += 1) { /*6441*/
			$1.i = _GE; /*6438*/
			$put($1.cw, $1.i * 2, $get($1.cwo, $1.i)); /*6439*/
			$put($1.cw, ($1.i * 2) + 1, $get($1.cwe, $1.i)); /*6440*/
		} /*6440*/
		var _GP = $a(22); /*6443*/
		$put(_GP, 0, $1.cw); /*6444*/
		$puti(_GP, 1, $1.dxw); /*6444*/
		$1.dxw = $geti(_GP, 0, $1.datalen + 1); /*6445*/
		$1.datalen = $1.dxw.length; /*6446*/
		$1.rows = $a(~~Math.ceil($1.datalen / $1.segments)); /*6449*/
		$1.numrows = $1.rows.length; /*6450*/
		for (var _Gb = 0, _Ga = $1.numrows - 1; _Gb <= _Ga; _Gb += 1) { /*6465*/
			$1.r = _Gb; /*6452*/
			$k[$j++] = Infinity; /*6453*/
			if ((($1.segments % 4) != 0) && (($1.r % 2) == 1)) { /*6454*/
				$k[$j++] = 0; /*6454*/
			} /*6454*/
			$k[$j++] = 1; /*6462*/
			$k[$j++] = 1; /*6462*/
			for (var _Gg = 0, _Gf = $1.segments - 1; _Gg <= _Gf; _Gg += 1) { /*6462*/
				$1.pos = _Gg + ($1.r * $1.segments); /*6457*/
				if ($1.pos < $1.datalen) { /*6461*/
					$forall($get($1.dxw, $1.pos)); /*6459*/
					if (($1.pos % 2) == 0) { /*6460*/
						$forall($get($1.fxw, ~~($1.pos / 2))); /*6460*/
					} /*6460*/
				} /*6460*/
			} /*6460*/
			var _Gs = $counttomark() + 2; /*6464*/
			$k[$j++] = 1; /*6464*/
			$k[$j++] = 1; /*6464*/
			$astore($a(_Gs)); /*6464*/
			$put($1.rows, $1.r, $k[--$j]); /*6464*/
			$j--; /*6464*/
		} /*6464*/
		if ($ne($1.format, "expandedstacked")) { /*6589*/
			var _Gz = $get($1.rows, 0); /*6470*/
			$1.sbs = $geti(_Gz, 1, _Gz.length - 1); /*6470*/
			$k[$j++] = Infinity; /*6480*/
			$k[$j++] = 1; /*6478*/
			for (var _H3 = 0, _H2 = $1.datalen - 1; _H3 <= _H2; _H3 += 1) { /*6478*/
				$1.i = _H3; /*6475*/
				$forall($get($1.dxw, $1.i)); /*6476*/
				if (($1.i % 2) == 0) { /*6477*/
					$forall($get($1.fxw, ~~($1.i / 2))); /*6477*/
				} /*6477*/
			} /*6477*/
			$k[$j++] = 1; /*6479*/
			$k[$j++] = 1; /*6479*/
			$1.sbs = $a(); /*6480*/
			$k[$j++] = Infinity; /*6487*/
			$k[$j++] = "ren"; /*6486*/
			$k[$j++] = $0.renlinear; /*6486*/
			$k[$j++] = "sbs"; /*6486*/
			$k[$j++] = $1.sbs; /*6486*/
			$k[$j++] = "bhs"; /*6486*/
			$k[$j++] = Infinity; /*6486*/
			for (var _HE = 0, _HF = ~~(($1.sbs.length + 1) / 2); _HE < _HF; _HE++) { /*6485*/
				$k[$j++] = $1.height; /*6485*/
			} /*6485*/
			var _HH = $a(); /*6486*/
			$k[$j++] = _HH; /*6487*/
			$k[$j++] = "bbs"; /*6487*/
			$k[$j++] = Infinity; /*6487*/
			for (var _HJ = 0, _HK = ~~(($1.sbs.length + 1) / 2); _HJ < _HK; _HJ++) { /*6486*/
				$k[$j++] = 0; /*6486*/
			} /*6486*/
			var _HL = $a(); /*6487*/
			$k[$j++] = _HL; /*6487*/
			$k[$j++] = "opt"; /*6487*/
			$k[$j++] = $1.options; /*6487*/
			var _HN = $d(); /*6487*/
			$k[$j++] = _HN; /*6490*/
			if (!$1.dontdraw) { /*6490*/
				$0.renlinear(); /*6490*/
			} /*6490*/
		} else { /*6589*/
			$1.seps = $a($1.numrows); /*6494*/
			for (var _HT = 0, _HS = $1.numrows - 1; _HT <= _HS; _HT += 1) { /*6550*/
				$1.r = _HT; /*6497*/
				$1.row = $get($1.rows, $1.r); /*6498*/
				$k[$j++] = Infinity; /*6501*/
				for (var _HZ = 0, _HY = $1.row.length - 1; _HZ <= _HY; _HZ += 2) { /*6506*/
					$1.i = _HZ; /*6503*/
					for (var _Hd = 0, _He = $get($1.row, $1.i); _Hd < _He; _Hd++) { /*6504*/
						$k[$j++] = 0; /*6504*/
					} /*6504*/
					if ($1.i < ($1.row.length - 1)) { /*6505*/
						for (var _Hk = 0, _Hl = $get($1.row, $1.i + 1); _Hk < _Hl; _Hk++) { /*6505*/
							$k[$j++] = 1; /*6505*/
						} /*6505*/
					} /*6505*/
				} /*6505*/
				$astore($a($counttomark())); /*6507*/
				$1.row = $k[--$j]; /*6507*/
				$j--; /*6507*/
				$k[$j++] = Infinity; /*6510*/
				$forall($1.row, function() { /*6510*/
					var _Hq = $k[--$j]; /*6510*/
					$k[$j++] = 1 - _Hq; /*6510*/
				}); /*6510*/
				$1.sep = $a(); /*6510*/
				$puti($1.sep, 0, $a([0, 0, 0, 0])); /*6511*/
				$puti($1.sep, $1.row.length - 4, $a([0, 0, 0, 0])); /*6512*/
				$k[$j++] = Infinity; /*6516*/
				for (var _Hz = 19, _Hy = $1.row.length - 13; _Hz <= _Hy; _Hz += 98) { /*6514*/
					$k[$j++] = _Hz; /*6514*/
				} /*6514*/
				for (var _I2 = 68, _I1 = $1.row.length - 13; _I2 <= _I1; _I2 += 98) { /*6515*/
					$k[$j++] = _I2; /*6515*/
				} /*6515*/
				$1.finderpos = $a(); /*6516*/
				var _I4 = $1.finderpos; /*6517*/
				for (var _I5 = 0, _I6 = _I4.length; _I5 < _I6; _I5++) { /*6531*/
					var _I7 = $get(_I4, _I5); /*6531*/
					for (var _I9 = _I7, _I8 = _I7 + 14; _I9 <= _I8; _I9 += 1) { /*6530*/
						$1.i = _I9; /*6519*/
						if ($get($1.row, $1.i) == 0) { /*6527*/
							if ($get($1.row, $1.i - 1) == 1) { /*6524*/
								$k[$j++] = 1; /*6522*/
							} else { /*6524*/
								var _IJ = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*6524*/
								$k[$j++] = _IJ; /*6524*/
							} /*6524*/
						} else { /*6527*/
							$k[$j++] = 0; /*6527*/
						} /*6527*/
						$put($1.sep, $1.i, $k[--$j]); /*6529*/
					} /*6529*/
				} /*6529*/
				if ((($1.segments % 4) == 0) && (($1.r % 2) == 1)) { /*6545*/
					if (($get($1.rows, $1.r).length != $get($1.rows, 0).length) && (($1.finderpos.length % 2) == 1)) { /*6543*/
						$k[$j++] = Infinity; /*6537*/
						$k[$j++] = 0; /*6537*/
						$aload($1.row); /*6537*/
						$1.row = $a(); /*6537*/
						$k[$j++] = Infinity; /*6538*/
						$k[$j++] = 0; /*6538*/
						$aload($1.sep); /*6538*/
						$1.sep = $a(); /*6538*/
					} else { /*6543*/
						for (var _Ia = $1.row.length - 1; _Ia >= 0; _Ia -= 1) { /*6540*/
							$k[$j++] = $get($1.row, _Ia); /*6540*/
						} /*6540*/
						$astore($1.row); /*6541*/
						$j--; /*6541*/
						for (var _If = $1.sep.length - 1; _If >= 0; _If -= 1) { /*6542*/
							$k[$j++] = $get($1.sep, _If); /*6542*/
						} /*6542*/
						$astore($1.sep); /*6543*/
						$j--; /*6543*/
					} /*6543*/
				} /*6543*/
				$put($1.rows, $1.r, $1.row); /*6547*/
				$put($1.seps, $1.r, $1.sep); /*6548*/
			} /*6548*/
			$1.pixx = $get($1.rows, 0).length; /*6553*/
			$k[$j++] = Infinity; /*6554*/
			for (var _Is = 0, _It = $1.pixx; _Is < _It; _Is++) { /*6554*/
				$k[$j++] = 0; /*6554*/
			} /*6554*/
			var _Iu = $a(); /*6554*/
			$puti(_Iu, 0, $get($1.rows, $1.numrows - 1)); /*6554*/
			$put($1.rows, $1.numrows - 1, _Iu); /*6555*/
			$k[$j++] = Infinity; /*6556*/
			for (var _J1 = 0, _J2 = $1.pixx; _J1 < _J2; _J1++) { /*6556*/
				$k[$j++] = 0; /*6556*/
			} /*6556*/
			var _J3 = $a(); /*6556*/
			$puti(_J3, 0, $get($1.seps, $1.numrows - 1)); /*6556*/
			$put($1.seps, $1.numrows - 1, _J3); /*6557*/
			$k[$j++] = "sep"; /*6560*/
			$k[$j++] = Infinity; /*6560*/
			for (var _JA = 0, _JB = (~~($1.pixx / 2)) + 1; _JA < _JB; _JA++) { /*6560*/
				$k[$j++] = 0; /*6560*/
				$k[$j++] = 1; /*6560*/
			} /*6560*/
			var _JE = $geti($a(), 0, $1.pixx); /*6560*/
			$1[$k[--$j]] = _JE; /*6560*/
			$puti($1.sep, 0, $a([0, 0, 0, 0])); /*6561*/
			$puti($1.sep, $1.pixx - 4, $a([0, 0, 0, 0])); /*6562*/
			$k[$j++] = Infinity; /*6577*/
			for (var _JN = 0, _JM = $1.numrows - 1; _JN <= _JM; _JN += 1) { /*6576*/
				$1.r = _JN; /*6567*/
				if ($1.r != 0) { /*6570*/
					$aload($get($1.seps, $1.r)); /*6569*/
				} /*6569*/
				for (var _JS = 0, _JT = 34; _JS < _JT; _JS++) { /*6571*/
					$aload($get($1.rows, $1.r)); /*6571*/
				} /*6571*/
				if ($1.r != ($1.numrows - 1)) { /*6575*/
					$aload($get($1.seps, $1.r)); /*6573*/
					$aload($1.sep); /*6574*/
				} /*6574*/
			} /*6574*/
			$1.pixs = $a(); /*6577*/
			var _Jm = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.pixx,
				pixy: ~~($1.pixs.length / $1.pixx),
				height: (~~($1.pixs.length / $1.pixx)) / 72,
				width: $1.pixx / 72,
				opt: $1.options
			}; /*6586*/
			$k[$j++] = _Jm; /*6589*/
			if (!$1.dontdraw) { /*6589*/
				$0.renmatrix(); /*6589*/
			} /*6589*/
		} /*6589*/
	};
	$0.databarexpandedstacked = function() {
		var $1 = {}; /*6619*/
		$1.options = $k[--$j]; /*6621*/
		$1.barcode = $k[--$j]; /*6622*/
		$1.dontdraw = false; /*6624*/
		$forall($1.options, function() { /*6635*/
			var _3 = $k[--$j]; /*6635*/
			$1[$k[--$j]] = _3; /*6635*/
		}); /*6635*/
		$1.options.dontdraw = true; /*6638*/
		$1.options.format = "expandedstacked"; /*6639*/
		$k[$j++] = "args"; /*6641*/
		$k[$j++] = $1.barcode; /*6641*/
		$k[$j++] = $1.options; /*6641*/
		$0.databarexpanded(); /*6641*/
		var _9 = $k[--$j]; /*6641*/
		$1[$k[--$j]] = _9; /*6641*/
		$1.args.opt = $1.options; /*6643*/
		$k[$j++] = $1.args; /*6646*/
		if (!$1.dontdraw) { /*6646*/
			$0.renmatrix(); /*6646*/
		} /*6646*/
	};
	$0.pharmacode = function() {
		var $1 = {}; /*6673*/
		$1.options = $k[--$j]; /*6675*/
		$1.barcode = $k[--$j]; /*6676*/
		$1.dontdraw = false; /*6678*/
		$1.height = (8 * 2.835) / 72; /*6679*/
		$1.nwidth = 0.5 * 2.835; /*6680*/
		$1.wwidth = 1.5 * 2.835; /*6681*/
		$1.swidth = 1 * 2.835; /*6682*/
		$forall($1.options, function() { /*6693*/
			var _3 = $k[--$j]; /*6693*/
			$1[$k[--$j]] = _3; /*6693*/
		}); /*6693*/
		$1.height = +$1.height; /*6695*/
		$1.nwidth = +$1.nwidth; /*6696*/
		$1.wwidth = +$1.wwidth; /*6697*/
		$1.swidth = +$1.swidth; /*6698*/
		if (($1.barcode.length < 1) || ($1.barcode.length > 6)) { /*6703*/
			$k[$j++] = "bwipp.pharmacodeBadLength"; /*6702*/
			$k[$j++] = "Pharmacode must be 1 to 6 digits"; /*6702*/
			$0.raiseerror(); /*6702*/
		} /*6702*/
		$forall($1.barcode, function() { /*6708*/
			var _C = $k[--$j]; /*6705*/
			if ((_C < 48) || (_C > 57)) { /*6707*/
				$k[$j++] = "bwipp.pharmacodeBadCharacter"; /*6706*/
				$k[$j++] = "Pharmacode must contain only digits"; /*6706*/
				$0.raiseerror(); /*6706*/
			} /*6706*/
		}); /*6706*/
		var _E = ~~$z($1.barcode); /*6709*/
		if ((_E < 3) || (_E > 131070)) { /*6711*/
			$k[$j++] = "bwipp.pharmacodeBadValue"; /*6710*/
			$k[$j++] = "Pharmacode value must be between 3 and 131070"; /*6710*/
			$0.raiseerror(); /*6710*/
		} /*6710*/
		$1.txt = $a($1.barcode.length); /*6714*/
		for (var _J = 0, _I = $1.barcode.length - 1; _J <= _I; _J += 1) { /*6718*/
			$1.i = _J; /*6716*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*6717*/
		} /*6717*/
		$1.barcode = $cvrs($s(17), (~~$z($1.barcode)) + 1, 2); /*6721*/
		$1.barcode = $geti($1.barcode, 1, $1.barcode.length - 1); /*6722*/
		$1.barlen = $1.barcode.length; /*6724*/
		$1.sbs = $a($1.barlen * 2); /*6725*/
		for (var _b = 0, _a = $1.barlen - 1; _b <= _a; _b += 1) { /*6736*/
			$1.i = _b; /*6728*/
			$1.enc = $geti($1.barcode, $1.i, 1); /*6729*/
			if ($eq($1.enc, "0")) { /*6733*/
				$put($1.sbs, $1.i * 2, $1.nwidth); /*6731*/
			} else { /*6733*/
				$put($1.sbs, $1.i * 2, $1.wwidth); /*6733*/
			} /*6733*/
			$put($1.sbs, ($1.i * 2) + 1, $1.swidth); /*6735*/
		} /*6735*/
		$k[$j++] = Infinity; /*6746*/
		$k[$j++] = "ren"; /*6743*/
		$k[$j++] = $0.renlinear; /*6743*/
		$k[$j++] = "sbs"; /*6743*/
		$k[$j++] = $1.sbs; /*6743*/
		$k[$j++] = "bhs"; /*6743*/
		$k[$j++] = Infinity; /*6743*/
		for (var _r = 0, _s = ~~(($1.sbs.length + 1) / 2); _r < _s; _r++) { /*6742*/
			$k[$j++] = $1.height; /*6742*/
		} /*6742*/
		var _u = $a(); /*6743*/
		$k[$j++] = _u; /*6744*/
		$k[$j++] = "bbs"; /*6744*/
		$k[$j++] = Infinity; /*6744*/
		for (var _w = 0, _x = ~~(($1.sbs.length + 1) / 2); _w < _x; _w++) { /*6743*/
			$k[$j++] = 0; /*6743*/
		} /*6743*/
		var _y = $a(); /*6744*/
		$k[$j++] = _y; /*6746*/
		$k[$j++] = "txt"; /*6746*/
		$k[$j++] = $1.txt; /*6746*/
		$k[$j++] = "textxalign"; /*6746*/
		$k[$j++] = "center"; /*6746*/
		$k[$j++] = "opt"; /*6746*/
		$k[$j++] = $1.options; /*6746*/
		var _11 = $d(); /*6746*/
		$k[$j++] = _11; /*6749*/
		if (!$1.dontdraw) { /*6749*/
			$0.renlinear(); /*6749*/
		} /*6749*/
	};
	$0.pharmacode2 = function() {
		var $1 = {}; /*6776*/
		$1.options = $k[--$j]; /*6778*/
		$1.barcode = $k[--$j]; /*6779*/
		$1.dontdraw = false; /*6781*/
		$1.includetext = false; /*6782*/
		$1.height = 4; /*6783*/
		$forall($1.options, function() { /*6794*/
			var _3 = $k[--$j]; /*6794*/
			$1[$k[--$j]] = _3; /*6794*/
		}); /*6794*/
		$1.height = +$1.height; /*6796*/
		if (($1.barcode.length < 1) || ($1.barcode.length > 8)) { /*6801*/
			$k[$j++] = "bwipp.pharmacode2BadLength"; /*6800*/
			$k[$j++] = "Two-track Pharmacode must be 1 to 6 digits"; /*6800*/
			$0.raiseerror(); /*6800*/
		} /*6800*/
		$forall($1.barcode, function() { /*6806*/
			var _9 = $k[--$j]; /*6803*/
			if ((_9 < 48) || (_9 > 57)) { /*6805*/
				$k[$j++] = "bwipp.pharmacode2badCharacter"; /*6804*/
				$k[$j++] = "Two-track Pharmacode must contain only digits"; /*6804*/
				$0.raiseerror(); /*6804*/
			} /*6804*/
		}); /*6804*/
		var _B = ~~$z($1.barcode); /*6807*/
		if ((_B < 4) || (_B > 64570080)) { /*6809*/
			$k[$j++] = "bwipp.pharmacode2badValue"; /*6808*/
			$k[$j++] = "Two-track Pharmacode value must be between 4 and 64570080"; /*6808*/
			$0.raiseerror(); /*6808*/
		} /*6808*/
		$1.txt = $a($1.barcode.length); /*6812*/
		for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*6816*/
			$1.i = _G; /*6814*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*6815*/
		} /*6815*/
		$1.encstr = $s(16); /*6818*/
		$1.bhs = $a(16); /*6819*/
		$1.bbs = $a(16); /*6820*/
		$1.sbs = $a(32); /*6821*/
		$1.bar = (1 / 25.4) * $1.height; /*6822*/
		$1.spc = (1 / 25.4) * 72; /*6823*/
		$1.i = 15; /*6826*/
		$1.val = ~~$z($1.barcode); /*6827*/
		for (;;) { /*6834*/
			if ($1.val == 0) { /*6829*/
				break; /*6829*/
			} /*6829*/
			var _V = $1.val % 3; /*6830*/
			$1.val = ~~(($1.val - $get($a([3, 1, 2]), _V)) / 3); /*6831*/
			$put($1.encstr, $1.i, $get($a([2, 0, 1]), _V)); /*6832*/
			$1.i = $1.i - 1; /*6833*/
		} /*6833*/
		$1.encstr = $geti($1.encstr, $1.i + 1, 15 - $1.i); /*6835*/
		for (var _k = 0, _j = $1.encstr.length - 1; _k <= _j; _k += 1) { /*6843*/
			$1.i = _k; /*6839*/
			var _n = $get($1.encstr, $1.i); /*6840*/
			$put($1.bhs, $1.i, $1.bar * $get($a([1, 1, 2]), _n)); /*6841*/
			$put($1.bbs, $1.i, $get($a([0, $1.bar, 0]), _n)); /*6842*/
		} /*6842*/
		$k[$j++] = Infinity; /*6854*/
		$k[$j++] = "ren"; /*6851*/
		$k[$j++] = $0.renlinear; /*6851*/
		$k[$j++] = "bhs"; /*6851*/
		$k[$j++] = $1.bhs; /*6851*/
		$k[$j++] = "bbs"; /*6851*/
		$k[$j++] = $1.bbs; /*6851*/
		$k[$j++] = "sbs"; /*6851*/
		$k[$j++] = Infinity; /*6851*/
		for (var _11 = 0, _12 = $1.encstr.length * 2; _11 < _12; _11++) { /*6850*/
			$k[$j++] = $1.spc; /*6850*/
		} /*6850*/
		var _14 = $a(); /*6851*/
		$k[$j++] = _14; /*6854*/
		$k[$j++] = "txt"; /*6854*/
		$k[$j++] = $1.txt; /*6854*/
		$k[$j++] = "textxalign"; /*6854*/
		$k[$j++] = "center"; /*6854*/
		$k[$j++] = "textyoffset"; /*6854*/
		$k[$j++] = 4; /*6854*/
		$k[$j++] = "opt"; /*6854*/
		$k[$j++] = $1.options; /*6854*/
		var _17 = $d(); /*6854*/
		$k[$j++] = _17; /*6857*/
		if (!$1.dontdraw) { /*6857*/
			$0.renlinear(); /*6857*/
		} /*6857*/
	};
	$0.code2of5 = function() {
		var $1 = {}; /*6884*/
		$1.options = $k[--$j]; /*6886*/
		$1.barcode = $k[--$j]; /*6887*/
		$1.dontdraw = false; /*6889*/
		$1.includecheck = false; /*6890*/
		$1.validatecheck = false; /*6891*/
		$1.includetext = false; /*6892*/
		$1.includecheckintext = false; /*6893*/
		$1.textfont = "Courier"; /*6894*/
		$1.textsize = 10; /*6895*/
		$1.textyoffset = -8.5; /*6896*/
		$1.height = 1; /*6897*/
		$1.version = "industrial"; /*6898*/
		$forall($1.options, function() { /*6909*/
			var _3 = $k[--$j]; /*6909*/
			$1[$k[--$j]] = _3; /*6909*/
		}); /*6909*/
		$1.textfont = "" + $1.textfont; /*6911*/
		$1.textsize = +$1.textsize; /*6912*/
		$1.textyoffset = +$1.textyoffset; /*6913*/
		$1.height = +$1.height; /*6914*/
		$forall($1.barcode, function() { /*6921*/
			var _A = $k[--$j]; /*6918*/
			if ((_A < 48) || (_A > 57)) { /*6920*/
				$k[$j++] = "bwipp.code2of5badCharacter"; /*6919*/
				$k[$j++] = "Code 25 must contain only digits"; /*6919*/
				$0.raiseerror(); /*6919*/
			} /*6919*/
		}); /*6919*/
		$k[$j++] = "barlen"; /*6923*/
		$k[$j++] = $1.barcode.length; /*6923*/
		if ($1.validatecheck) { /*6923*/
			var _D = $k[--$j]; /*6923*/
			$k[$j++] = _D - 1; /*6923*/
		} /*6923*/
		var _E = $k[--$j]; /*6923*/
		$1[$k[--$j]] = _E; /*6923*/
		$1.checksum = 0; /*6925*/
		for (var _I = 0, _H = $1.barlen - 1; _I <= _H; _I += 1) { /*6929*/
			$1.i = _I; /*6927*/
			$k[$j++] = "checksum"; /*6928*/
			$k[$j++] = $1.checksum; /*6928*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*6928*/
			if ((($1.barlen - $1.i) % 2) != 0) { /*6928*/
				var _P = $k[--$j]; /*6928*/
				$k[$j++] = _P * 3; /*6928*/
			} /*6928*/
			var _Q = $k[--$j]; /*6928*/
			var _R = $k[--$j]; /*6928*/
			$1[$k[--$j]] = _R + _Q; /*6928*/
		} /*6928*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*6930*/
		if ($1.validatecheck) { /*6937*/
			if ($get($1.barcode, $1.barlen) != ($1.checksum + 48)) { /*6934*/
				$k[$j++] = "bwipp.code2of5badCheckDigit"; /*6933*/
				$k[$j++] = "Incorrect Code 25 check digit provided"; /*6933*/
				$0.raiseerror(); /*6933*/
			} /*6933*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*6935*/
			$1.includecheck = true; /*6936*/
		} /*6936*/
		var _h = {
			industrial: $a(["1111313111", "3111111131", "1131111131", "3131111111", "1111311131", "3111311111", "1131311111", "1111113131", "3111113111", "1131113111", "313111", "31113"]),
			iata: $a(["1111313111", "3111111131", "1131111131", "3131111111", "1111311131", "3111311111", "1131311111", "1111113131", "3111113111", "1131113111", "1111", "311"]),
			matrix: $a(["113311", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "131311", "311111", "31111"]),
			coop: $a(["331111", "111331", "113131", "113311", "131131", "131311", "133111", "311131", "311311", "313111", "3131", "133"]),
			datalogic: $a(["113311", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "131311", "1111", "311"])
		}; /*6961*/
		$1.versions = _h; /*6963*/
		var _k = $get($1.versions, $1.version) !== undefined; /*6964*/
		if (!_k) { /*6966*/
			$k[$j++] = "bwipp.code2of5badVersion"; /*6965*/
			$k[$j++] = "Unrecognised Code 25 version"; /*6965*/
			$0.raiseerror(); /*6965*/
		} /*6965*/
		$1.encs = $get($1.versions, $1.version); /*6967*/
		$1.cs = $get($1.encs, 0).length; /*6969*/
		$k[$j++] = "cw"; /*6970*/
		$k[$j++] = 0; /*6970*/
		$forall($get($1.encs, 0), function() { /*6970*/
			var _s = $k[--$j]; /*6970*/
			var _t = $k[--$j]; /*6970*/
			$k[$j++] = _t + (_s - 48); /*6970*/
		}); /*6970*/
		var _u = $k[--$j]; /*6970*/
		$1[$k[--$j]] = _u; /*6970*/
		var _w = $1.encs; /*6971*/
		$1.ss = $get(_w, _w.length - 2).length; /*6971*/
		var _y = $1.encs; /*6972*/
		$k[$j++] = "sw"; /*6972*/
		$k[$j++] = 0; /*6972*/
		$forall($get(_y, _y.length - 2), function() { /*6972*/
			var _10 = $k[--$j]; /*6972*/
			var _11 = $k[--$j]; /*6972*/
			$k[$j++] = _11 + (_10 - 48); /*6972*/
		}); /*6972*/
		var _12 = $k[--$j]; /*6972*/
		$1[$k[--$j]] = _12; /*6972*/
		$1.barchars = "0123456789"; /*6975*/
		$k[$j++] = "sbs"; /*6977*/
		$k[$j++] = $1.barlen; /*6977*/
		if ($1.includecheck) { /*6977*/
			var _16 = $k[--$j]; /*6977*/
			$k[$j++] = _16 + 1; /*6977*/
		} /*6977*/
		var _1B = $s((($k[--$j] * $1.cs) + $1.ss) + $1.ss); /*6977*/
		$1[$k[--$j]] = _1B; /*6977*/
		$k[$j++] = "txt"; /*6978*/
		$k[$j++] = $1.barlen; /*6978*/
		if ($1.includecheck) { /*6978*/
			var _1F = $k[--$j]; /*6978*/
			$k[$j++] = _1F + 1; /*6978*/
		} /*6978*/
		var _1H = $a($k[--$j]); /*6978*/
		$1[$k[--$j]] = _1H; /*6978*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*6981*/
		for (var _1O = 0, _1N = $1.barlen - 1; _1O <= _1N; _1O += 1) { /*6992*/
			$1.i = _1O; /*6983*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*6985*/
			$j--; /*6986*/
			$1.indx = $k[--$j].length; /*6987*/
			$j -= 2; /*6988*/
			$1.enc = $get($1.encs, $1.indx); /*6989*/
			$puti($1.sbs, ($1.i * $1.cs) + $1.ss, $1.enc); /*6990*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*6991*/
		} /*6991*/
		if ($1.includecheck) { /*7004*/
			$puti($1.sbs, ($1.barlen * $1.cs) + $1.ss, $get($1.encs, $1.checksum)); /*6996*/
			$puti($1.sbs, (($1.barlen * $1.cs) + $1.cs) + $1.ss, $get($1.encs, 11)); /*6997*/
			if ($1.includecheckintext) { /*7001*/
				$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*6999*/
			} else { /*7001*/
				$put($1.txt, $1.barlen, $a([" ", ($1.barlen * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*7001*/
			} /*7001*/
		} else { /*7004*/
			$puti($1.sbs, ($1.barlen * $1.cs) + $1.ss, $get($1.encs, 11)); /*7004*/
		} /*7004*/
		$k[$j++] = Infinity; /*7016*/
		$k[$j++] = "ren"; /*7011*/
		$k[$j++] = $0.renlinear; /*7011*/
		$k[$j++] = "sbs"; /*7011*/
		$k[$j++] = Infinity; /*7011*/
		$forall($1.sbs, function() { /*7010*/
			var _2W = $k[--$j]; /*7010*/
			$k[$j++] = _2W - 48; /*7010*/
		}); /*7010*/
		var _2X = $a(); /*7011*/
		$k[$j++] = _2X; /*7012*/
		$k[$j++] = "bhs"; /*7012*/
		$k[$j++] = Infinity; /*7012*/
		for (var _2Z = 0, _2a = ~~(($1.sbs.length + 1) / 2); _2Z < _2a; _2Z++) { /*7011*/
			$k[$j++] = $1.height; /*7011*/
		} /*7011*/
		var _2c = $a(); /*7012*/
		$k[$j++] = _2c; /*7013*/
		$k[$j++] = "bbs"; /*7013*/
		$k[$j++] = Infinity; /*7013*/
		for (var _2e = 0, _2f = ~~(($1.sbs.length + 1) / 2); _2e < _2f; _2e++) { /*7012*/
			$k[$j++] = 0; /*7012*/
		} /*7012*/
		var _2g = $a(); /*7013*/
		$k[$j++] = _2g; /*7015*/
		if ($1.includetext) { /*7015*/
			$k[$j++] = "txt"; /*7014*/
			$k[$j++] = $1.txt; /*7014*/
		} /*7014*/
		$k[$j++] = "opt"; /*7016*/
		$k[$j++] = $1.options; /*7016*/
		var _2k = $d(); /*7016*/
		$k[$j++] = _2k; /*7019*/
		if (!$1.dontdraw) { /*7019*/
			$0.renlinear(); /*7019*/
		} /*7019*/
	};
	$0.industrial2of5 = function() {
		var $1 = {}; /*7047*/
		$1.options = $k[--$j]; /*7049*/
		$1.barcode = $k[--$j]; /*7050*/
		$1.dontdraw = false; /*7052*/
		$1.includetext = false; /*7053*/
		$1.textfont = "Courier"; /*7054*/
		$1.textsize = 10; /*7055*/
		$1.textxoffset = 0; /*7056*/
		$1.textyoffset = -8.5; /*7057*/
		$1.height = 1; /*7058*/
		$forall($1.options, function() { /*7069*/
			var _3 = $k[--$j]; /*7069*/
			$1[$k[--$j]] = _3; /*7069*/
		}); /*7069*/
		$1.textfont = "" + $1.textfont; /*7071*/
		$1.textsize = +$1.textsize; /*7072*/
		$1.textxoffset = +$1.textxoffset; /*7073*/
		$1.textyoffset = +$1.textyoffset; /*7074*/
		$1.height = +$1.height; /*7075*/
		$1.options.dontdraw = true; /*7078*/
		$1.options.version = "industrial"; /*7079*/
		$k[$j++] = "args"; /*7081*/
		$k[$j++] = $1.barcode; /*7081*/
		$k[$j++] = $1.options; /*7081*/
		$0.code2of5(); /*7081*/
		var _E = $k[--$j]; /*7081*/
		$1[$k[--$j]] = _E; /*7081*/
		$1.args.opt = $1.options; /*7083*/
		$k[$j++] = $1.args; /*7086*/
		if (!$1.dontdraw) { /*7086*/
			$0.renlinear(); /*7086*/
		} /*7086*/
	};
	$0.iata2of5 = function() {
		var $1 = {}; /*7114*/
		$1.options = $k[--$j]; /*7116*/
		$1.barcode = $k[--$j]; /*7117*/
		$1.dontdraw = false; /*7119*/
		$1.includetext = false; /*7120*/
		$1.textfont = "Courier"; /*7121*/
		$1.textsize = 10; /*7122*/
		$1.textxoffset = 0; /*7123*/
		$1.textyoffset = -8.5; /*7124*/
		$1.height = 1; /*7125*/
		$forall($1.options, function() { /*7136*/
			var _3 = $k[--$j]; /*7136*/
			$1[$k[--$j]] = _3; /*7136*/
		}); /*7136*/
		$1.textfont = "" + $1.textfont; /*7138*/
		$1.textsize = +$1.textsize; /*7139*/
		$1.textxoffset = +$1.textxoffset; /*7140*/
		$1.textyoffset = +$1.textyoffset; /*7141*/
		$1.height = +$1.height; /*7142*/
		$1.options.dontdraw = true; /*7145*/
		$1.options.version = "iata"; /*7146*/
		$k[$j++] = "args"; /*7148*/
		$k[$j++] = $1.barcode; /*7148*/
		$k[$j++] = $1.options; /*7148*/
		$0.code2of5(); /*7148*/
		var _E = $k[--$j]; /*7148*/
		$1[$k[--$j]] = _E; /*7148*/
		$1.args.opt = $1.options; /*7150*/
		$k[$j++] = $1.args; /*7153*/
		if (!$1.dontdraw) { /*7153*/
			$0.renlinear(); /*7153*/
		} /*7153*/
	};
	$0.matrix2of5 = function() {
		var $1 = {}; /*7181*/
		$1.options = $k[--$j]; /*7183*/
		$1.barcode = $k[--$j]; /*7184*/
		$1.dontdraw = false; /*7186*/
		$1.includetext = false; /*7187*/
		$1.textfont = "Courier"; /*7188*/
		$1.textsize = 10; /*7189*/
		$1.textxoffset = 0; /*7190*/
		$1.textyoffset = -8.5; /*7191*/
		$1.height = 1; /*7192*/
		$forall($1.options, function() { /*7203*/
			var _3 = $k[--$j]; /*7203*/
			$1[$k[--$j]] = _3; /*7203*/
		}); /*7203*/
		$1.textfont = "" + $1.textfont; /*7205*/
		$1.textsize = +$1.textsize; /*7206*/
		$1.textxoffset = +$1.textxoffset; /*7207*/
		$1.textyoffset = +$1.textyoffset; /*7208*/
		$1.height = +$1.height; /*7209*/
		$1.options.dontdraw = true; /*7212*/
		$1.options.version = "matrix"; /*7213*/
		$k[$j++] = "args"; /*7215*/
		$k[$j++] = $1.barcode; /*7215*/
		$k[$j++] = $1.options; /*7215*/
		$0.code2of5(); /*7215*/
		var _E = $k[--$j]; /*7215*/
		$1[$k[--$j]] = _E; /*7215*/
		$1.args.opt = $1.options; /*7217*/
		$k[$j++] = $1.args; /*7220*/
		if (!$1.dontdraw) { /*7220*/
			$0.renlinear(); /*7220*/
		} /*7220*/
	};
	$0.coop2of5 = function() {
		var $1 = {}; /*7248*/
		$1.options = $k[--$j]; /*7250*/
		$1.barcode = $k[--$j]; /*7251*/
		$1.dontdraw = false; /*7253*/
		$1.includetext = false; /*7254*/
		$1.textfont = "Courier"; /*7255*/
		$1.textsize = 10; /*7256*/
		$1.textxoffset = 0; /*7257*/
		$1.textyoffset = -8.5; /*7258*/
		$1.height = 1; /*7259*/
		$forall($1.options, function() { /*7270*/
			var _3 = $k[--$j]; /*7270*/
			$1[$k[--$j]] = _3; /*7270*/
		}); /*7270*/
		$1.textfont = "" + $1.textfont; /*7272*/
		$1.textsize = +$1.textsize; /*7273*/
		$1.textxoffset = +$1.textxoffset; /*7274*/
		$1.textyoffset = +$1.textyoffset; /*7275*/
		$1.height = +$1.height; /*7276*/
		$1.options.dontdraw = true; /*7279*/
		$1.options.version = "coop"; /*7280*/
		$k[$j++] = "args"; /*7282*/
		$k[$j++] = $1.barcode; /*7282*/
		$k[$j++] = $1.options; /*7282*/
		$0.code2of5(); /*7282*/
		var _E = $k[--$j]; /*7282*/
		$1[$k[--$j]] = _E; /*7282*/
		$1.args.opt = $1.options; /*7284*/
		$k[$j++] = $1.args; /*7287*/
		if (!$1.dontdraw) { /*7287*/
			$0.renlinear(); /*7287*/
		} /*7287*/
	};
	$0.datalogic2of5 = function() {
		var $1 = {}; /*7315*/
		$1.options = $k[--$j]; /*7317*/
		$1.barcode = $k[--$j]; /*7318*/
		$1.dontdraw = false; /*7320*/
		$1.includetext = false; /*7321*/
		$1.textfont = "Courier"; /*7322*/
		$1.textsize = 10; /*7323*/
		$1.textxoffset = 0; /*7324*/
		$1.textyoffset = -8.5; /*7325*/
		$1.height = 1; /*7326*/
		$forall($1.options, function() { /*7337*/
			var _3 = $k[--$j]; /*7337*/
			$1[$k[--$j]] = _3; /*7337*/
		}); /*7337*/
		$1.textfont = "" + $1.textfont; /*7339*/
		$1.textsize = +$1.textsize; /*7340*/
		$1.textxoffset = +$1.textxoffset; /*7341*/
		$1.textyoffset = +$1.textyoffset; /*7342*/
		$1.height = +$1.height; /*7343*/
		$1.options.dontdraw = true; /*7346*/
		$1.options.version = "datalogic"; /*7347*/
		$k[$j++] = "args"; /*7349*/
		$k[$j++] = $1.barcode; /*7349*/
		$k[$j++] = $1.options; /*7349*/
		$0.code2of5(); /*7349*/
		var _E = $k[--$j]; /*7349*/
		$1[$k[--$j]] = _E; /*7349*/
		$1.args.opt = $1.options; /*7351*/
		$k[$j++] = $1.args; /*7354*/
		if (!$1.dontdraw) { /*7354*/
			$0.renlinear(); /*7354*/
		} /*7354*/
	};
	$0.code11 = function() {
		var $1 = {}; /*7381*/
		$1.options = $k[--$j]; /*7383*/
		$1.barcode = $k[--$j]; /*7384*/
		$1.dontdraw = false; /*7386*/
		$1.includecheck = false; /*7387*/
		$1.validatecheck = false; /*7388*/
		$1.includetext = false; /*7389*/
		$1.includecheckintext = false; /*7390*/
		$1.textfont = "Courier"; /*7391*/
		$1.textsize = 10; /*7392*/
		$1.textyoffset = -8.5; /*7393*/
		$1.height = 1; /*7394*/
		$forall($1.options, function() { /*7405*/
			var _3 = $k[--$j]; /*7405*/
			$1[$k[--$j]] = _3; /*7405*/
		}); /*7405*/
		$1.textfont = "" + $1.textfont; /*7407*/
		$1.textsize = +$1.textsize; /*7408*/
		$1.textyoffset = +$1.textyoffset; /*7409*/
		$1.height = +$1.height; /*7410*/
		$1.encs = $a(["111131", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "311111", "113111", "113311"]); /*7417*/
		$1.barchars = "0123456789-"; /*7420*/
		$1.charvals = {}; /*7421*/
		for (var _A = 0; _A <= 10; _A += 1) { /*7422*/
			$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*7422*/
		} /*7422*/
		for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*7429*/
			var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*7426*/
			if (!_K) { /*7428*/
				$k[$j++] = "bwipp.code11badCharacter"; /*7427*/
				$k[$j++] = "Code 11 must contain only digits and dashes"; /*7427*/
				$0.raiseerror(); /*7427*/
			} /*7427*/
		} /*7427*/
		$1.barlen = $1.barcode.length; /*7431*/
		if ($1.validatecheck) { /*7437*/
			if ($1.barlen == 11) { /*7435*/
				$k[$j++] = "bwipp.code11badLength"; /*7434*/
				$k[$j++] = "Code 11 cannot be 11 characters using check digits"; /*7434*/
				$0.raiseerror(); /*7434*/
			} /*7434*/
			var _Q = ($1.barlen <= 10) ? 1 : 2; /*7436*/
			$1.barlen = $1.barlen - _Q; /*7436*/
		} /*7436*/
		$k[$j++] = "numchecks"; /*7439*/
		if ($1.includecheck || $1.validatecheck) { /*7439*/
			var _U = ($1.barlen >= 10) ? 2 : 1; /*7439*/
			$k[$j++] = _U; /*7439*/
		} else { /*7439*/
			$k[$j++] = 0; /*7439*/
		} /*7439*/
		var _V = $k[--$j]; /*7439*/
		$1[$k[--$j]] = _V; /*7439*/
		$1.checksum1 = 0; /*7440*/
		$1.checksum2 = 0; /*7440*/
		for (var _Z = 0, _Y = $1.barlen - 1; _Z <= _Y; _Z += 1) { /*7446*/
			$1.i = _Z; /*7442*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7443*/
			$1.checksum1 = $1.checksum1 + ((((($1.barlen - $1.i) - 1) % 10) + 1) * $1.indx); /*7444*/
			$1.checksum2 = $1.checksum2 + (((($1.barlen - $1.i) % 9) + 1) * $1.indx); /*7445*/
		} /*7445*/
		$1.checksum1 = $1.checksum1 % 11; /*7447*/
		$1.checksum2 = ($1.checksum2 + $1.checksum1) % 11; /*7448*/
		if ($1.validatecheck) { /*7462*/
			if ($1.numchecks == 1) { /*7457*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) { /*7453*/
					$k[$j++] = "bwipp.code11badCheckDigit"; /*7452*/
					$k[$j++] = "Incorrect Code 11 check digit provided"; /*7452*/
					$0.raiseerror(); /*7452*/
				} /*7452*/
			} else { /*7457*/
				if (($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) || ($get($1.barcode, $1.barlen + 1) != $get($1.barchars, $1.checksum2))) { /*7458*/
					$k[$j++] = "bwipp.code11badCheckDigits"; /*7457*/
					$k[$j++] = "Incorrect Code 11 check digits provided"; /*7457*/
					$0.raiseerror(); /*7457*/
				} /*7457*/
			} /*7457*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*7460*/
			$1.includecheck = true; /*7461*/
		} /*7461*/
		$1.sbs = $s((($1.barlen + $1.numchecks) * 6) + 12); /*7464*/
		$1.txt = $a($1.barlen + $1.numchecks); /*7465*/
		$puti($1.sbs, 0, $get($1.encs, 11)); /*7468*/
		$1.xpos = 8; /*7470*/
		for (var _1O = 0, _1N = $1.barlen - 1; _1O <= _1N; _1O += 1) { /*7480*/
			$1.i = _1O; /*7472*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7473*/
			$1.enc = $get($1.encs, $1.indx); /*7474*/
			$puti($1.sbs, ($1.i * 6) + 6, $1.enc); /*7475*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7476*/
			for (var _1k = 0; _1k <= 5; _1k += 1) { /*7479*/
				$1.xpos = ($get($1.enc, _1k) - 48) + $1.xpos; /*7478*/
			} /*7478*/
		} /*7478*/
		if ($1.includecheck) { /*7509*/
			if ($1.barlen >= 10) { /*7506*/
				$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, $1.checksum1)); /*7485*/
				$puti($1.sbs, ($1.barlen * 6) + 12, $get($1.encs, $1.checksum2)); /*7486*/
				if ($1.includecheckintext) { /*7496*/
					$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7488*/
					$1.enc = $get($1.encs, $1.checksum1); /*7489*/
					for (var _2E = 0; _2E <= 5; _2E += 1) { /*7492*/
						$1.xpos = ($get($1.enc, _2E) - 48) + $1.xpos; /*7491*/
					} /*7491*/
					$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum2, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7493*/
				} else { /*7496*/
					$put($1.txt, $1.barlen, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7495*/
					$put($1.txt, $1.barlen + 1, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7496*/
				} /*7496*/
				$puti($1.sbs, ($1.barlen * 6) + 18, $get($1.encs, 11)); /*7498*/
			} else { /*7506*/
				$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, $1.checksum1)); /*7500*/
				if ($1.includecheckintext) { /*7504*/
					$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7502*/
				} else { /*7504*/
					$put($1.txt, $1.barlen, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7504*/
				} /*7504*/
				$puti($1.sbs, ($1.barlen * 6) + 12, $get($1.encs, 11)); /*7506*/
			} /*7506*/
		} else { /*7509*/
			$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, 11)); /*7509*/
		} /*7509*/
		$k[$j++] = Infinity; /*7521*/
		$k[$j++] = "ren"; /*7516*/
		$k[$j++] = $0.renlinear; /*7516*/
		$k[$j++] = "sbs"; /*7516*/
		$k[$j++] = Infinity; /*7516*/
		var _3F = $1.sbs; /*7515*/
		for (var _3G = 0, _3H = _3F.length; _3G < _3H; _3G++) { /*7515*/
			$k[$j++] = $get(_3F, _3G) - 48; /*7515*/
		} /*7515*/
		var _3J = $a(); /*7516*/
		$k[$j++] = _3J; /*7517*/
		$k[$j++] = "bhs"; /*7517*/
		$k[$j++] = Infinity; /*7517*/
		for (var _3L = 0, _3M = ~~(($1.sbs.length + 1) / 2); _3L < _3M; _3L++) { /*7516*/
			$k[$j++] = $1.height; /*7516*/
		} /*7516*/
		var _3O = $a(); /*7517*/
		$k[$j++] = _3O; /*7518*/
		$k[$j++] = "bbs"; /*7518*/
		$k[$j++] = Infinity; /*7518*/
		for (var _3Q = 0, _3R = ~~(($1.sbs.length + 1) / 2); _3Q < _3R; _3Q++) { /*7517*/
			$k[$j++] = 0; /*7517*/
		} /*7517*/
		var _3S = $a(); /*7518*/
		$k[$j++] = _3S; /*7520*/
		if ($1.includetext) { /*7520*/
			$k[$j++] = "txt"; /*7519*/
			$k[$j++] = $1.txt; /*7519*/
		} /*7519*/
		$k[$j++] = "opt"; /*7521*/
		$k[$j++] = $1.options; /*7521*/
		var _3W = $d(); /*7521*/
		$k[$j++] = _3W; /*7524*/
		if (!$1.dontdraw) { /*7524*/
			$0.renlinear(); /*7524*/
		} /*7524*/
	};
	$0.bc412 = function() {
		var $1 = {}; /*7551*/
		$1.options = $k[--$j]; /*7553*/
		$1.barcode = $k[--$j]; /*7554*/
		$1.dontdraw = false; /*7556*/
		$1.includecheck = false; /*7557*/
		$1.validatecheck = false; /*7558*/
		$1.includetext = false; /*7559*/
		$1.includecheckintext = false; /*7560*/
		$1.includestartstop = false; /*7561*/
		$1.semi = false; /*7562*/
		$1.textfont = "Courier"; /*7563*/
		$1.textsize = 10; /*7564*/
		$1.textyoffset = -8.5; /*7565*/
		$1.height = 1; /*7566*/
		$forall($1.options, function() { /*7577*/
			var _3 = $k[--$j]; /*7577*/
			$1[$k[--$j]] = _3; /*7577*/
		}); /*7577*/
		$1.textfont = "" + $1.textfont; /*7579*/
		$1.textsize = +$1.textsize; /*7580*/
		$1.textyoffset = +$1.textyoffset; /*7581*/
		$1.height = +$1.height; /*7582*/
		if ($1.semi) { /*7587*/
			$1.includecheck = true; /*7585*/
			$1.includestartstop = true; /*7586*/
		} /*7586*/
		$1.barchars = "0R9GLVHA8EZ4NTS1J2Q6C7DYKBUIX3FWP5M"; /*7590*/
		$1.charvals = {}; /*7591*/
		for (var _A = 0; _A <= 34; _A += 1) { /*7592*/
			$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*7592*/
		} /*7592*/
		for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*7599*/
			var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*7596*/
			if (!_K) { /*7598*/
				$k[$j++] = "bwipp.bc412badCharacter"; /*7597*/
				$k[$j++] = "BC412 must contain only digits and capital letters except O"; /*7597*/
				$0.raiseerror(); /*7597*/
			} /*7597*/
		} /*7597*/
		$k[$j++] = "barlen"; /*7601*/
		$k[$j++] = $1.barcode.length; /*7601*/
		if ($1.validatecheck) { /*7601*/
			var _N = $k[--$j]; /*7601*/
			$k[$j++] = _N - 1; /*7601*/
		} /*7601*/
		var _O = $k[--$j]; /*7601*/
		$1[$k[--$j]] = _O; /*7601*/
		$1.checksum = 0; /*7603*/
		for (var _S = 0, _R = $1.barlen - 1; _S <= _R; _S += 1) { /*7607*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _S, 1)) + $1.checksum; /*7606*/
		} /*7606*/
		$1.checksum = $1.checksum % 35; /*7608*/
		if ($1.validatecheck) { /*7615*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*7612*/
				$k[$j++] = "bwipp.bc412badCheckDigit"; /*7611*/
				$k[$j++] = "Incorrect BC412 check digit provided"; /*7611*/
				$0.raiseerror(); /*7611*/
			} /*7611*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*7613*/
			$1.includecheck = true; /*7614*/
		} /*7614*/
		$1.encs = $a(["11111115", "13111212", "11131113", "12111213", "12121311", "13131111", "12111312", "11131212", "11121411", "11151111", "15111111", "11111511", "12131211", "13121112", "13111212", "11111214", "12121113", "11111313", "13111113", "11121213", "11141112", "11121312", "11141211", "14121111", "12121212", "11131311", "13121211", "12111411", "14111211", "11111412", "12111114", "14111112", "12141111", "11121114", "12131112", "12", "111"]); /*7627*/
		$1.sbs = $s((($1.barlen + 1) * 8) + 5); /*7629*/
		if ($1.includecheck) { /*7633*/
			$1.txt = $a($1.barlen + 1); /*7631*/
		} else { /*7633*/
			$1.txt = $a($1.barlen); /*7633*/
		} /*7633*/
		if ($1.includestartstop) { /*7643*/
			$puti($1.sbs, 0, $get($1.encs, 35)); /*7638*/
			$1.pos = 2; /*7639*/
			$1.txtpos = 3; /*7640*/
		} else { /*7643*/
			$1.pos = 0; /*7642*/
			$1.txtpos = 0; /*7643*/
		} /*7643*/
		for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*7652*/
			$1.i = _x; /*7647*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7648*/
			$puti($1.sbs, $1.pos, $get($1.encs, $1.indx)); /*7649*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7650*/
			$1.pos = $1.pos + 8; /*7651*/
		} /*7651*/
		if ($1.includecheck) { /*7663*/
			$puti($1.sbs, $1.pos, $get($1.encs, $1.checksum)); /*7656*/
			if ($1.includecheckintext) { /*7660*/
				$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7658*/
			} else { /*7660*/
				$put($1.txt, $1.barlen, $a(["", ($1.barlen * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7660*/
			} /*7660*/
			$1.pos = $1.pos + 8; /*7662*/
		} /*7662*/
		if ($1.includestartstop) { /*7669*/
			$puti($1.sbs, $1.pos, $get($1.encs, 36)); /*7667*/
			$1.pos = $1.pos + 2; /*7668*/
		} /*7668*/
		$1.sbs = $geti($1.sbs, 0, $1.pos); /*7672*/
		$k[$j++] = Infinity; /*7681*/
		$k[$j++] = "ren"; /*7676*/
		$k[$j++] = $0.renlinear; /*7676*/
		$k[$j++] = "sbs"; /*7676*/
		$k[$j++] = Infinity; /*7676*/
		$forall($1.sbs, function() { /*7675*/
			var _1v = $k[--$j]; /*7675*/
			$k[$j++] = _1v - 48; /*7675*/
		}); /*7675*/
		var _1w = $a(); /*7676*/
		$k[$j++] = _1w; /*7677*/
		$k[$j++] = "bhs"; /*7677*/
		$k[$j++] = Infinity; /*7677*/
		for (var _1y = 0, _1z = ~~(($1.sbs.length + 1) / 2); _1y < _1z; _1y++) { /*7676*/
			$k[$j++] = $1.height; /*7676*/
		} /*7676*/
		var _21 = $a(); /*7677*/
		$k[$j++] = _21; /*7678*/
		$k[$j++] = "bbs"; /*7678*/
		$k[$j++] = Infinity; /*7678*/
		for (var _23 = 0, _24 = ~~(($1.sbs.length + 1) / 2); _23 < _24; _23++) { /*7677*/
			$k[$j++] = 0; /*7677*/
		} /*7677*/
		var _25 = $a(); /*7678*/
		$k[$j++] = _25; /*7680*/
		if ($1.includetext) { /*7680*/
			$k[$j++] = "txt"; /*7679*/
			$k[$j++] = $1.txt; /*7679*/
		} /*7679*/
		$k[$j++] = "opt"; /*7681*/
		$k[$j++] = $1.options; /*7681*/
		var _29 = $d(); /*7681*/
		$k[$j++] = _29; /*7684*/
		if (!$1.dontdraw) { /*7684*/
			$0.renlinear(); /*7684*/
		} /*7684*/
	};
	$0.rationalizedCodabar = function() {
		var $1 = {}; /*7711*/
		$1.options = $k[--$j]; /*7713*/
		$1.barcode = $k[--$j]; /*7714*/
		$1.dontdraw = false; /*7716*/
		$1.altstartstop = false; /*7717*/
		$1.includecheck = false; /*7718*/
		$1.validatecheck = false; /*7719*/
		$1.includetext = false; /*7720*/
		$1.includecheckintext = false; /*7721*/
		$1.textfont = "Courier"; /*7722*/
		$1.textsize = 10; /*7723*/
		$1.textyoffset = -8.5; /*7724*/
		$1.height = 1; /*7725*/
		$forall($1.options, function() { /*7736*/
			var _3 = $k[--$j]; /*7736*/
			$1[$k[--$j]] = _3; /*7736*/
		}); /*7736*/
		$1.textfont = "" + $1.textfont; /*7738*/
		$1.textsize = +$1.textsize; /*7739*/
		$1.textyoffset = +$1.textyoffset; /*7740*/
		$1.height = +$1.height; /*7741*/
		$1.encs = $a(["11111331", "11113311", "11131131", "33111111", "11311311", "31111311", "13111131", "13113111", "13311111", "31131111", "11133111", "11331111", "31113131", "31311131", "31313111", "11313131", "11331311", "13131131", "11131331", "11133311"]); /*7749*/
		if ($1.altstartstop) { /*7755*/
			$1.barchars = "0123456789-$:/.+TN*E"; /*7753*/
		} else { /*7755*/
			$1.barchars = "0123456789-$:/.+ABCD"; /*7755*/
		} /*7755*/
		$1.charvals = {}; /*7757*/
		for (var _B = 0; _B <= 19; _B += 1) { /*7758*/
			$put($1.charvals, $geti($1.barchars, _B, 1), _B); /*7758*/
		} /*7758*/
		$1.bodyvals = {}; /*7759*/
		for (var _F = 0; _F <= 15; _F += 1) { /*7760*/
			$put($1.bodyvals, $geti($1.barchars, _F, 1), _F); /*7760*/
		} /*7760*/
		$1.ssvals = {}; /*7761*/
		for (var _J = 16; _J <= 19; _J += 1) { /*7762*/
			$put($1.ssvals, $geti($1.barchars, _J, 1), _J); /*7762*/
		} /*7762*/
		var _Q = $get($1.ssvals, $geti($1.barcode, 0, 1)) !== undefined; /*7765*/
		var _V = $get($1.ssvals, $geti($1.barcode, $1.barcode.length - 1, 1)) !== undefined; /*7766*/
		if ((!_Q) || (!_V)) { /*7772*/
			if ($1.altstartstop) { /*7770*/
				$k[$j++] = "bwipp.rationalizedCodabarBadAltStartStop"; /*7768*/
				$k[$j++] = "Codabar start and stop characters must be one of E N T or *"; /*7768*/
				$0.raiseerror(); /*7768*/
			} else { /*7770*/
				$k[$j++] = "bwipp.rationalizedCodabarBadStartStop"; /*7770*/
				$k[$j++] = "Codabar start and stop characters must be one of A B C or D"; /*7770*/
				$0.raiseerror(); /*7770*/
			} /*7770*/
		} /*7770*/
		for (var _Z = 1, _Y = $1.barcode.length - 2; _Z <= _Y; _Z += 1) { /*7777*/
			var _d = $get($1.bodyvals, $geti($1.barcode, _Z, 1)) !== undefined; /*7774*/
			if (!_d) { /*7776*/
				$k[$j++] = "bwipp.rationalizedCodabarBadCharacter"; /*7775*/
				$k[$j++] = "Codabar body must contain only digits and symbols - $ : / . +"; /*7775*/
				$0.raiseerror(); /*7775*/
			} /*7775*/
		} /*7775*/
		$k[$j++] = "barlen"; /*7779*/
		$k[$j++] = $1.barcode.length; /*7779*/
		if ($1.validatecheck) { /*7779*/
			var _g = $k[--$j]; /*7779*/
			$k[$j++] = _g - 1; /*7779*/
		} /*7779*/
		var _h = $k[--$j]; /*7779*/
		$1[$k[--$j]] = _h; /*7779*/
		$1.checksum = 0; /*7781*/
		for (var _l = 0, _k = $1.barlen - 2; _l <= _k; _l += 1) { /*7785*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _l, 1)) + $1.checksum; /*7784*/
		} /*7784*/
		$1.checksum = $get($1.charvals, $geti($1.barcode, $1.barcode.length - 1, 1)) + $1.checksum; /*7787*/
		$1.checksum = (16 - ($1.checksum % 16)) % 16; /*7788*/
		if ($1.validatecheck) { /*7798*/
			if ($get($1.barcode, $1.barlen - 1) != $get($1.barchars, $1.checksum)) { /*7792*/
				$k[$j++] = "bwipp.rationalizedCodabarBadCheckDigit"; /*7791*/
				$k[$j++] = "Incorrect Codabar check digit provided"; /*7791*/
				$0.raiseerror(); /*7791*/
			} /*7791*/
			var _16 = $s($1.barlen); /*7793*/
			$puti(_16, 0, $geti($1.barcode, 0, $1.barlen - 1)); /*7794*/
			$puti(_16, $1.barlen - 1, $geti($1.barcode, $1.barlen, 1)); /*7795*/
			$1.barcode = _16; /*7796*/
			$1.includecheck = true; /*7797*/
		} /*7797*/
		$k[$j++] = "sbs"; /*7800*/
		$k[$j++] = $1.barlen; /*7800*/
		if ($1.includecheck) { /*7800*/
			var _1G = $k[--$j]; /*7800*/
			$k[$j++] = _1G + 1; /*7800*/
		} /*7800*/
		var _1I = $s($k[--$j] * 8); /*7800*/
		$1[$k[--$j]] = _1I; /*7800*/
		$k[$j++] = "txt"; /*7801*/
		$k[$j++] = $1.barlen; /*7801*/
		if ($1.includecheck) { /*7801*/
			var _1M = $k[--$j]; /*7801*/
			$k[$j++] = _1M + 1; /*7801*/
		} /*7801*/
		var _1O = $a($k[--$j]); /*7801*/
		$1[$k[--$j]] = _1O; /*7801*/
		$1.xpos = 0; /*7803*/
		for (var _1S = 0, _1R = $1.barlen - 2; _1S <= _1R; _1S += 1) { /*7813*/
			$1.i = _1S; /*7805*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7806*/
			$1.enc = $get($1.encs, $1.indx); /*7807*/
			$puti($1.sbs, $1.i * 8, $1.enc); /*7808*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7809*/
			for (var _1o = 0; _1o <= 7; _1o += 1) { /*7812*/
				$1.xpos = ($get($1.enc, _1o) - 48) + $1.xpos; /*7811*/
			} /*7811*/
		} /*7811*/
		if ($1.includecheck) { /*7837*/
			$puti($1.sbs, ($1.barlen * 8) - 8, $get($1.encs, $1.checksum)); /*7818*/
			if ($1.includecheckintext) { /*7822*/
				$put($1.txt, $1.barlen - 1, $a([$geti($1.barchars, $1.checksum, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7820*/
			} else { /*7822*/
				$put($1.txt, $1.barlen - 1, $a([" ", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7822*/
			} /*7822*/
			for (var _2G = 0; _2G <= 7; _2G += 1) { /*7826*/
				$1.xpos = ($get($get($1.encs, $1.checksum), _2G) - 48) + $1.xpos; /*7825*/
			} /*7825*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.barlen - 1, 1)); /*7828*/
			$1.enc = $get($1.encs, $1.indx); /*7829*/
			$puti($1.sbs, $1.barlen * 8, $1.enc); /*7830*/
			$put($1.txt, $1.barlen, $a([$geti($1.barcode, $1.barlen - 1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7831*/
		} else { /*7837*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.barlen - 1, 1)); /*7834*/
			$1.enc = $get($1.encs, $1.indx); /*7835*/
			$puti($1.sbs, ($1.barlen * 8) - 8, $1.enc); /*7836*/
			$put($1.txt, $1.barlen - 1, $a([$geti($1.barcode, $1.barlen - 1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7837*/
		} /*7837*/
		$k[$j++] = Infinity; /*7849*/
		$k[$j++] = "ren"; /*7844*/
		$k[$j++] = $0.renlinear; /*7844*/
		$k[$j++] = "sbs"; /*7844*/
		$k[$j++] = Infinity; /*7844*/
		$forall($1.sbs, function() { /*7843*/
			var _33 = $k[--$j]; /*7843*/
			$k[$j++] = _33 - 48; /*7843*/
		}); /*7843*/
		var _34 = $a(); /*7844*/
		$k[$j++] = _34; /*7845*/
		$k[$j++] = "bhs"; /*7845*/
		$k[$j++] = Infinity; /*7845*/
		for (var _36 = 0, _37 = ~~(($1.sbs.length + 1) / 2); _36 < _37; _36++) { /*7844*/
			$k[$j++] = $1.height; /*7844*/
		} /*7844*/
		var _39 = $a(); /*7845*/
		$k[$j++] = _39; /*7846*/
		$k[$j++] = "bbs"; /*7846*/
		$k[$j++] = Infinity; /*7846*/
		for (var _3B = 0, _3C = ~~(($1.sbs.length + 1) / 2); _3B < _3C; _3B++) { /*7845*/
			$k[$j++] = 0; /*7845*/
		} /*7845*/
		var _3D = $a(); /*7846*/
		$k[$j++] = _3D; /*7848*/
		if ($1.includetext) { /*7848*/
			$k[$j++] = "txt"; /*7847*/
			$k[$j++] = $1.txt; /*7847*/
		} /*7847*/
		$k[$j++] = "opt"; /*7849*/
		$k[$j++] = $1.options; /*7849*/
		var _3H = $d(); /*7849*/
		$k[$j++] = _3H; /*7852*/
		if (!$1.dontdraw) { /*7852*/
			$0.renlinear(); /*7852*/
		} /*7852*/
	};
	$0.onecode = function() {
		var $1 = {}; /*7879*/
		$1.options = $k[--$j]; /*7881*/
		$1.barcode = $k[--$j]; /*7882*/
		$1.dontdraw = false; /*7884*/
		$1.height = 0.15; /*7885*/
		$forall($1.options, function() { /*7896*/
			var _3 = $k[--$j]; /*7896*/
			$1[$k[--$j]] = _3; /*7896*/
		}); /*7896*/
		$1.height = +$1.height; /*7898*/
		$1.barlen = $1.barcode.length; /*7900*/
		$k[$j++] = "txtdict"; /*7909*/
		$k[$j++] = Infinity; /*7909*/
		var _9 = $eq($geti($1.barcode, 5, 1), "9") ? 14 : 11; /*7906*/
		$k[$j++] = 2; /*7909*/
		$k[$j++] = 2; /*7909*/
		$k[$j++] = 5; /*7909*/
		$k[$j++] = 5; /*7909*/
		$k[$j++] = _9; /*7909*/
		$k[$j++] = _9; /*7909*/
		$k[$j++] = 20; /*7909*/
		$k[$j++] = 20; /*7909*/
		$k[$j++] = 25; /*7909*/
		$k[$j++] = 25; /*7909*/
		$k[$j++] = 29; /*7909*/
		$k[$j++] = 29; /*7909*/
		var _A = $d(); /*7909*/
		$1[$k[--$j]] = _A; /*7910*/
		$1.txt = $a($1.barlen + 6); /*7911*/
		$1.spacecnt = 0; /*7912*/
		for (var _G = 0, _F = $1.barlen - 1; _G <= _F; _G += 1) { /*7920*/
			$1.i = _G; /*7914*/
			var _J = $get($1.txtdict, $1.i) !== undefined; /*7915*/
			if (_J) { /*7918*/
				$put($1.txt, $1.i + $1.spacecnt, $a([" ", 0, 0, "", 0])); /*7916*/
				$1.spacecnt = $1.spacecnt + 1; /*7917*/
			} /*7917*/
			$put($1.txt, $1.i + $1.spacecnt, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*7919*/
		} /*7919*/
		$1.txt = $geti($1.txt, 0, $1.barcode.length + $1.spacecnt); /*7921*/
		$1.normalize = function() {
			$1.base = $k[--$j]; /*7924*/
			$1.num = $k[--$j]; /*7925*/
			for (var _d = $1.num.length - 1; _d >= 1; _d -= 1) { /*7930*/
				$1.i = _d; /*7927*/
				var _e = $1.num; /*7928*/
				var _f = $1.i; /*7928*/
				$put(_e, _f - 1, $get(_e, _f - 1) + (~~($get($1.num, $1.i) / $1.base))); /*7928*/
				$put($1.num, $1.i, $get($1.num, $1.i) % $1.base); /*7929*/
			} /*7929*/
			for (;;) { /*7936*/
				if ($lt($get($1.num, 0), $1.base)) { /*7932*/
					break; /*7932*/
				} /*7932*/
				$k[$j++] = Infinity; /*7933*/
				$k[$j++] = 0; /*7933*/
				$forall($1.num); /*7933*/
				$1.num = $a(); /*7933*/
				$put($1.num, 0, $get($1.num, 0) + (~~($get($1.num, 1) / $1.base))); /*7934*/
				$put($1.num, 1, $get($1.num, 1) % $1.base); /*7935*/
			} /*7935*/
			$k[$j++] = Infinity; /*7938*/
			$1.i = true; /*7938*/
			var _16 = $1.num; /*7938*/
			for (var _17 = 0, _18 = _16.length; _17 < _18; _17++) { /*7938*/
				var _19 = $get(_16, _17); /*7938*/
				$k[$j++] = _19; /*7938*/
				if ((_19 == 0) && $1.i) { /*7938*/
					$j--; /*7938*/
				} else { /*7938*/
					$1.i = false; /*7938*/
				} /*7938*/
			} /*7938*/
			$1.num = $a(); /*7938*/
			if ($1.num.length == 0) { /*7939*/
				$1.num = $a([0]); /*7939*/
			} /*7939*/
			$k[$j++] = $1.num; /*7940*/
		}; /*7941*/
		$1.bigadd = function() {
			var _1F = $k[--$j]; /*7944*/
			var _1G = $k[--$j]; /*7944*/
			$1.offset = Math.abs(_1F.length - _1G.length); /*7945*/
			if (_1F.length < _1G.length) { /*7946*/
				var _ = _1F; /*7946*/
				_1F = _1G; /*7946*/
				_1G = _; /*7946*/
			} /*7946*/
			$1.a = _1F; /*7947*/
			$1.b = _1G; /*7947*/
			for (var _1J = 0, _1I = $1.b.length - 1; _1J <= _1I; _1J += 1) { /*7950*/
				var _1K = $1.a; /*7949*/
				var _1L = $1.offset; /*7949*/
				$put(_1K, _1J + _1L, $get(_1K, _1J + _1L) + $get($1.b, _1J)); /*7949*/
			} /*7949*/
			$k[$j++] = $1.a; /*7951*/
		}; /*7952*/
		if ($1.barlen == 20) { /*7955*/
			$k[$j++] = $a([0]); /*7955*/
		} /*7955*/
		if ($1.barlen == 25) { /*7956*/
			$k[$j++] = $a([1]); /*7956*/
		} /*7956*/
		if ($1.barlen == 29) { /*7957*/
			$k[$j++] = $a([1, 0, 0, 0, 0, 1]); /*7957*/
		} /*7957*/
		if ($1.barlen == 31) { /*7958*/
			$k[$j++] = $a([1, 0, 0, 0, 1, 0, 0, 0, 0, 1]); /*7958*/
		} /*7958*/
		var _1Y = $k[--$j]; /*7959*/
		$k[$j++] = "binval"; /*7959*/
		$k[$j++] = _1Y; /*7959*/
		$k[$j++] = Infinity; /*7959*/
		$forall($geti($1.barcode, 20, $1.barlen - 20), function() { /*7959*/
			var _1c = $k[--$j]; /*7959*/
			$k[$j++] = _1c - 48; /*7959*/
		}); /*7959*/
		var _1d = $a(); /*7959*/
		$k[$j++] = _1d; /*7959*/
		$1.bigadd(); /*7959*/
		var _1e = $k[--$j]; /*7959*/
		$1[$k[--$j]] = _1e; /*7959*/
		$k[$j++] = Infinity; /*7960*/
		var _1g = $1.binval; /*7960*/
		for (var _1h = 0, _1i = _1g.length; _1h < _1i; _1h++) { /*7960*/
			$k[$j++] = $get(_1g, _1h); /*7960*/
		} /*7960*/
		$k[$j++] = $get($1.barcode, 0) - 48; /*7960*/
		$1.binval = $a(); /*7960*/
		$k[$j++] = "binval"; /*7961*/
		$k[$j++] = Infinity; /*7961*/
		var _1n = $1.binval; /*7961*/
		for (var _1o = 0, _1p = _1n.length; _1o < _1p; _1o++) { /*7961*/
			$k[$j++] = $get(_1n, _1o) * 5; /*7961*/
		} /*7961*/
		var _1r = $a(); /*7961*/
		$k[$j++] = _1r; /*7961*/
		$k[$j++] = $a([$get($1.barcode, 1) - 48]); /*7961*/
		$1.bigadd(); /*7961*/
		$k[$j++] = 10; /*7961*/
		$1.normalize(); /*7961*/
		var _1v = $k[--$j]; /*7961*/
		$1[$k[--$j]] = _1v; /*7961*/
		$k[$j++] = Infinity; /*7962*/
		var _1x = $1.binval; /*7962*/
		for (var _1y = 0, _1z = _1x.length; _1y < _1z; _1y++) { /*7962*/
			$k[$j++] = $get(_1x, _1y); /*7962*/
		} /*7962*/
		$forall($geti($1.barcode, 2, 18), function() { /*7962*/
			var _23 = $k[--$j]; /*7962*/
			$k[$j++] = _23 - 48; /*7962*/
		}); /*7962*/
		$1.binval = $a(); /*7962*/
		$1.bytes = $a(13); /*7965*/
		$k[$j++] = Infinity; /*7966*/
		var _26 = $1.binval; /*7966*/
		for (var _27 = 0, _28 = _26.length; _27 < _28; _27++) { /*7966*/
			$k[$j++] = $get(_26, _27); /*7966*/
		} /*7966*/
		$1.bintmp = $a(); /*7966*/
		for (var _2B = 12; _2B >= 0; _2B -= 1) { /*7976*/
			$1.i = _2B; /*7968*/
			for (var _2E = 0, _2D = $1.bintmp.length - 2; _2E <= _2D; _2E += 1) { /*7973*/
				$1.j = _2E; /*7970*/
				var _2F = $1.bintmp; /*7971*/
				var _2G = $1.j; /*7971*/
				$put(_2F, _2G + 1, $get(_2F, _2G + 1) + (($get($1.bintmp, $1.j) % 256) * 10)); /*7971*/
				$put($1.bintmp, $1.j, ~~($get($1.bintmp, $1.j) / 256)); /*7972*/
			} /*7972*/
			$put($1.bytes, $1.i, $get($1.bintmp, $1.bintmp.length - 1) % 256); /*7974*/
			var _2V = $1.bintmp; /*7975*/
			var _2W = $1.bintmp; /*7975*/
			$put(_2V, _2W.length - 1, ~~($get(_2V, _2W.length - 1) / 256)); /*7975*/
		} /*7975*/
		$1.fcs = 2047; /*7979*/
		$1.dat = $get($1.bytes, 0) << 5; /*7980*/
		for (var _2a = 0, _2b = 6; _2a < _2b; _2a++) { /*7989*/
			if ((($1.fcs ^ $1.dat) & 1024) != 0) { /*7985*/
				$1.fcs = ($1.fcs << 1) ^ 3893; /*7983*/
			} else { /*7985*/
				$1.fcs = $1.fcs << 1; /*7985*/
			} /*7985*/
			$1.fcs = $1.fcs & 2047; /*7987*/
			$1.dat = $1.dat << 1; /*7988*/
		} /*7988*/
		for (var _2i = 1; _2i <= 12; _2i += 1) { /*8001*/
			$1.dat = $get($1.bytes, _2i) << 3; /*7991*/
			for (var _2l = 0, _2m = 8; _2l < _2m; _2l++) { /*8000*/
				if ((($1.fcs ^ $1.dat) & 1024) != 0) { /*7996*/
					$1.fcs = ($1.fcs << 1) ^ 3893; /*7994*/
				} else { /*7996*/
					$1.fcs = $1.fcs << 1; /*7996*/
				} /*7996*/
				$1.fcs = $1.fcs & 2047; /*7998*/
				$1.dat = $1.dat << 1; /*7999*/
			} /*7999*/
		} /*7999*/
		$1.codewords = $a(10); /*8004*/
		for (var _2u = 9; _2u >= 0; _2u -= 1) { /*8019*/
			$1.i = _2u; /*8006*/
			if ($1.i == 9) { /*8010*/
				$1.b = 636; /*8008*/
			} else { /*8010*/
				$1.b = 1365; /*8010*/
			} /*8010*/
			for (var _2y = 0, _2x = $1.binval.length - 2; _2y <= _2x; _2y += 1) { /*8016*/
				$1.j = _2y; /*8013*/
				var _2z = $1.binval; /*8014*/
				var _30 = $1.j; /*8014*/
				$put(_2z, _30 + 1, $get(_2z, _30 + 1) + (($get($1.binval, $1.j) % $1.b) * 10)); /*8014*/
				$put($1.binval, $1.j, ~~($get($1.binval, $1.j) / $1.b)); /*8015*/
			} /*8015*/
			$put($1.codewords, $1.i, $get($1.binval, $1.binval.length - 1) % $1.b); /*8017*/
			var _3I = $1.binval; /*8018*/
			var _3J = $1.binval; /*8018*/
			$put(_3I, _3J.length - 1, ~~($get(_3I, _3J.length - 1) / $1.b)); /*8018*/
		} /*8018*/
		$put($1.codewords, 9, $get($1.codewords, 9) * 2); /*8022*/
		if (($1.fcs & 1024) != 0) { /*8025*/
			$put($1.codewords, 0, $get($1.codewords, 0) + 659); /*8024*/
		} /*8024*/
		$1.tab513 = $a([31, 7936, 47, 7808, 55, 7552, 59, 7040, 61, 6016, 62, 3968, 79, 7744, 87, 7488, 91, 6976, 93, 5952, 94, 3904, 103, 7360, 107, 6848, 109, 5824, 110, 3776, 115, 6592, 117, 5568, 118, 3520, 121, 5056, 122, 3008, 124, 1984, 143, 7712, 151, 7456, 155, 6944, 157, 5920, 158, 3872, 167, 7328, 171, 6816, 173, 5792, 174, 3744, 179, 6560, 181, 5536, 182, 3488, 185, 5024, 186, 2976, 188, 1952, 199, 7264, 203, 6752, 205, 5728, 206, 3680, 211, 6496, 213, 5472, 214, 3424, 217, 4960, 218, 2912, 220, 1888, 227, 6368, 229, 5344, 230, 3296, 233, 4832, 234, 2784, 236, 1760, 241, 4576, 242, 2528, 244, 1504, 248, 992, 271, 7696, 279, 7440, 283, 6928, 285, 5904, 286, 3856, 295, 7312, 299, 6800, 301, 5776, 302, 3728, 307, 6544, 309, 5520, 310, 3472, 313, 5008, 314, 2960, 316, 1936, 327, 7248, 331, 6736, 333, 5712, 334, 3664, 339, 6480, 341, 5456, 342, 3408, 345, 4944, 346, 2896, 348, 1872, 355, 6352, 357, 5328, 358, 3280, 361, 4816, 362, 2768, 364, 1744, 369, 4560, 370, 2512, 372, 1488, 376, 976, 391, 7216, 395, 6704, 397, 5680, 398, 3632, 403, 6448, 405, 5424, 406, 3376, 409, 4912, 410, 2864, 412, 1840, 419, 6320, 421, 5296, 422, 3248, 425, 4784, 426, 2736, 428, 1712, 433, 4528, 434, 2480, 436, 1456, 440, 944, 451, 6256, 453, 5232, 454, 3184, 457, 4720, 458, 2672, 460, 1648, 465, 4464, 466, 2416, 468, 1392, 472, 880, 481, 4336, 482, 2288, 484, 1264, 488, 752, 527, 7688, 535, 7432, 539, 6920, 541, 5896, 542, 3848, 551, 7304, 555, 6792, 557, 5768, 558, 3720, 563, 6536, 565, 5512, 566, 3464, 569, 5000, 570, 2952, 572, 1928, 583, 7240, 587, 6728, 589, 5704, 590, 3656, 595, 6472, 597, 5448, 598, 3400, 601, 4936, 602, 2888, 604, 1864, 611, 6344, 613, 5320, 614, 3272, 617, 4808, 618, 2760, 620, 1736, 625, 4552, 626, 2504, 628, 1480, 632, 968, 647, 7208, 651, 6696, 653, 5672, 654, 3624, 659, 6440, 661, 5416, 662, 3368, 665, 4904, 666, 2856, 668, 1832, 675, 6312, 677, 5288, 678, 3240, 681, 4776, 682, 2728, 684, 1704, 689, 4520, 690, 2472, 692, 1448, 696, 936, 707, 6248, 709, 5224, 710, 3176, 713, 4712, 714, 2664, 716, 1640, 721, 4456, 722, 2408, 724, 1384, 728, 872, 737, 4328, 738, 2280, 740, 1256, 775, 7192, 779, 6680, 781, 5656, 782, 3608, 787, 6424, 789, 5400, 790, 3352, 793, 4888, 794, 2840, 796, 1816, 803, 6296, 805, 5272, 806, 3224, 809, 4760, 810, 2712, 812, 1688, 817, 4504, 818, 2456, 820, 1432, 824, 920, 835, 6232, 837, 5208, 838, 3160, 841, 4696, 842, 2648, 844, 1624, 849, 4440, 850, 2392, 852, 1368, 865, 4312, 866, 2264, 868, 1240, 899, 6200, 901, 5176, 902, 3128, 905, 4664, 906, 2616, 908, 1592, 913, 4408, 914, 2360, 916, 1336, 929, 4280, 930, 2232, 932, 1208, 961, 4216, 962, 2168, 964, 1144, 1039, 7684, 1047, 7428, 1051, 6916, 1053, 5892, 1054, 3844, 1063, 7300, 1067, 6788, 1069, 5764, 1070, 3716, 1075, 6532, 1077, 5508, 1078, 3460, 1081, 4996, 1082, 2948, 1084, 1924, 1095, 7236, 1099, 6724, 1101, 5700, 1102, 3652, 1107, 6468, 1109, 5444, 1110, 3396, 1113, 4932, 1114, 2884, 1116, 1860, 1123, 6340, 1125, 5316, 1126, 3268, 1129, 4804, 1130, 2756, 1132, 1732, 1137, 4548, 1138, 2500, 1140, 1476, 1159, 7204, 1163, 6692, 1165, 5668, 1166, 3620, 1171, 6436, 1173, 5412, 1174, 3364, 1177, 4900, 1178, 2852, 1180, 1828, 1187, 6308, 1189, 5284, 1190, 3236, 1193, 4772, 1194, 2724, 1196, 1700, 1201, 4516, 1202, 2468, 1204, 1444, 1219, 6244, 1221, 5220, 1222, 3172, 1225, 4708, 1226, 2660, 1228, 1636, 1233, 4452, 1234, 2404, 1236, 1380, 1249, 4324, 1250, 2276, 1287, 7188, 1291, 6676, 1293, 5652, 1294, 3604, 1299, 6420, 1301, 5396, 1302, 3348, 1305, 4884, 1306, 2836, 1308, 1812, 1315, 6292, 1317, 5268, 1318, 3220, 1321, 4756, 1322, 2708, 1324, 1684, 1329, 4500, 1330, 2452, 1332, 1428, 1347, 6228, 1349, 5204, 1350, 3156, 1353, 4692, 1354, 2644, 1356, 1620, 1361, 4436, 1362, 2388, 1377, 4308, 1378, 2260, 1411, 6196, 1413, 5172, 1414, 3124, 1417, 4660, 1418, 2612, 1420, 1588, 1425, 4404, 1426, 2356, 1441, 4276, 1442, 2228, 1473, 4212, 1474, 2164, 1543, 7180, 1547, 6668, 1549, 5644, 1550, 3596, 1555, 6412, 1557, 5388, 1558, 3340, 1561, 4876, 1562, 2828, 1564, 1804, 1571, 6284, 1573, 5260, 1574, 3212, 1577, 4748, 1578, 2700, 1580, 1676, 1585, 4492, 1586, 2444, 1603, 6220, 1605, 5196, 1606, 3148, 1609, 4684, 1610, 2636, 1617, 4428, 1618, 2380, 1633, 4300, 1634, 2252, 1667, 6188, 1669, 5164, 1670, 3116, 1673, 4652, 1674, 2604, 1681, 4396, 1682, 2348, 1697, 4268, 1698, 2220, 1729, 4204, 1730, 2156, 1795, 6172, 1797, 5148, 1798, 3100, 1801, 4636, 1802, 2588, 1809, 4380, 1810, 2332, 1825, 4252, 1826, 2204, 1857, 4188, 1858, 2140, 1921, 4156, 1922, 2108, 2063, 7682, 2071, 7426, 2075, 6914, 2077, 5890, 2078, 3842, 2087, 7298, 2091, 6786, 2093, 5762, 2094, 3714, 2099, 6530, 2101, 5506, 2102, 3458, 2105, 4994, 2106, 2946, 2119, 7234, 2123, 6722, 2125, 5698, 2126, 3650, 2131, 6466, 2133, 5442, 2134, 3394, 2137, 4930, 2138, 2882, 2147, 6338, 2149, 5314, 2150, 3266, 2153, 4802, 2154, 2754, 2161, 4546, 2162, 2498, 2183, 7202, 2187, 6690, 2189, 5666, 2190, 3618, 2195, 6434, 2197, 5410, 2198, 3362, 2201, 4898, 2202, 2850, 2211, 6306, 2213, 5282, 2214, 3234, 2217, 4770, 2218, 2722, 2225, 4514, 2226, 2466, 2243, 6242, 2245, 5218, 2246, 3170, 2249, 4706, 2250, 2658, 2257, 4450, 2258, 2402, 2273, 4322, 2311, 7186, 2315, 6674, 2317, 5650, 2318, 3602, 2323, 6418, 2325, 5394, 2326, 3346, 2329, 4882, 2330, 2834, 2339, 6290, 2341, 5266, 2342, 3218, 2345, 4754, 2346, 2706, 2353, 4498, 2354, 2450, 2371, 6226, 2373, 5202, 2374, 3154, 2377, 4690, 2378, 2642, 2385, 4434, 2401, 4306, 2435, 6194, 2437, 5170, 2438, 3122, 2441, 4658, 2442, 2610, 2449, 4402, 2465, 4274, 2497, 4210, 2567, 7178, 2571, 6666, 2573, 5642, 2574, 3594, 2579, 6410, 2581, 5386, 2582, 3338, 2585, 4874, 2586, 2826, 2595, 6282, 2597, 5258, 2598, 3210, 2601, 4746, 2602, 2698, 2609, 4490, 2627, 6218, 2629, 5194, 2630, 3146, 2633, 4682, 2641, 4426, 2657, 4298, 2691, 6186, 2693, 5162, 2694, 3114, 2697, 4650, 2705, 4394, 2721, 4266, 2753, 4202, 2819, 6170, 2821, 5146, 2822, 3098, 2825, 4634, 2833, 4378, 2849, 4250, 2881, 4186, 2945, 4154, 3079, 7174, 3083, 6662, 3085, 5638, 3086, 3590, 3091, 6406, 3093, 5382, 3094, 3334, 3097, 4870, 3107, 6278, 3109, 5254, 3110, 3206, 3113, 4742, 3121, 4486, 3139, 6214, 3141, 5190, 3145, 4678, 3153, 4422, 3169, 4294, 3203, 6182, 3205, 5158, 3209, 4646, 3217, 4390, 3233, 4262, 3265, 4198, 3331, 6166, 3333, 5142, 3337, 4630, 3345, 4374, 3361, 4246, 3393, 4182, 3457, 4150, 3587, 6158, 3589, 5134, 3593, 4622, 3601, 4366, 3617, 4238, 3649, 4174, 3713, 4142, 3841, 4126, 4111, 7681, 4119, 7425, 4123, 6913, 4125, 5889, 4135, 7297, 4139, 6785, 4141, 5761, 4147, 6529, 4149, 5505, 4153, 4993, 4167, 7233, 4171, 6721, 4173, 5697, 4179, 6465, 4181, 5441, 4185, 4929, 4195, 6337, 4197, 5313, 4201, 4801, 4209, 4545, 4231, 7201, 4235, 6689, 4237, 5665, 4243, 6433, 4245, 5409, 4249, 4897, 4259, 6305, 4261, 5281, 4265, 4769, 4273, 4513, 4291, 6241, 4293, 5217, 4297, 4705, 4305, 4449, 4359, 7185, 4363, 6673, 4365, 5649, 4371, 6417, 4373, 5393, 4377, 4881, 4387, 6289, 4389, 5265, 4393, 4753, 4401, 4497, 4419, 6225, 4421, 5201, 4425, 4689, 4483, 6193, 4485, 5169, 4489, 4657, 4615, 7177, 4619, 6665, 4621, 5641, 4627, 6409, 4629, 5385, 4633, 4873, 4643, 6281, 4645, 5257, 4649, 4745, 4675, 6217, 4677, 5193, 4739, 6185, 4741, 5161, 4867, 6169, 4869, 5145, 5127, 7173, 5131, 6661, 5133, 5637, 5139, 6405, 5141, 5381, 5155, 6277, 5157, 5253, 5187, 6213, 5251, 6181, 5379, 6165, 5635, 6157, 6151, 7171, 6155, 6659, 6163, 6403, 6179, 6275, 6211, 5189, 4681, 4433, 4321, 3142, 2634, 2386, 2274, 1612, 1364, 1252, 856, 744, 496]); /*8115*/
		$1.tab213 = $a([3, 6144, 5, 5120, 6, 3072, 9, 4608, 10, 2560, 12, 1536, 17, 4352, 18, 2304, 20, 1280, 24, 768, 33, 4224, 34, 2176, 36, 1152, 40, 640, 48, 384, 65, 4160, 66, 2112, 68, 1088, 72, 576, 80, 320, 96, 192, 129, 4128, 130, 2080, 132, 1056, 136, 544, 144, 288, 257, 4112, 258, 2064, 260, 1040, 264, 528, 513, 4104, 514, 2056, 516, 1032, 1025, 4100, 1026, 2052, 2049, 4098, 4097, 2050, 1028, 520, 272, 160]); /*8124*/
		$1.chars = $a(10); /*8126*/
		for (var _3W = 0; _3W <= 9; _3W += 1) { /*8135*/
			$1.i = _3W; /*8128*/
			var _3Z = $get($1.codewords, $1.i); /*8129*/
			$k[$j++] = _3Z; /*8133*/
			if (_3Z <= 1286) { /*8132*/
				var _3c = $get($1.tab513, $k[--$j]); /*8130*/
				$k[$j++] = _3c; /*8130*/
			} else { /*8132*/
				var _3f = $get($1.tab213, $k[--$j] - 1287); /*8132*/
				$k[$j++] = _3f; /*8132*/
			} /*8132*/
			$put($1.chars, $1.i, $k[--$j]); /*8134*/
		} /*8134*/
		for (var _3j = 9; _3j >= 0; _3j -= 1) { /*8142*/
			$1.i = _3j; /*8138*/
			if (((~~Math.pow(2, $1.i)) & $1.fcs) != 0) { /*8141*/
				$put($1.chars, $1.i, $get($1.chars, $1.i) ^ 8191); /*8140*/
			} /*8140*/
		} /*8140*/
		$1.barmap = $a([7, 2, 4, 3, 1, 10, 0, 0, 9, 12, 2, 8, 5, 5, 6, 11, 8, 9, 3, 1, 0, 1, 5, 12, 2, 5, 1, 8, 4, 4, 9, 11, 6, 3, 8, 10, 3, 9, 7, 6, 5, 11, 1, 4, 8, 5, 2, 12, 9, 10, 0, 2, 7, 1, 6, 7, 3, 6, 4, 9, 0, 3, 8, 6, 6, 4, 2, 7, 1, 1, 9, 9, 7, 10, 5, 2, 4, 0, 3, 8, 6, 2, 0, 4, 8, 11, 1, 0, 9, 8, 3, 12, 2, 6, 7, 7, 5, 1, 4, 10, 1, 12, 6, 9, 7, 3, 8, 0, 5, 8, 9, 7, 4, 6, 2, 10, 3, 4, 0, 5, 8, 4, 5, 7, 7, 11, 1, 9, 6, 0, 9, 6, 0, 6, 4, 8, 2, 1, 3, 2, 5, 9, 8, 12, 4, 11, 6, 1, 9, 5, 7, 4, 3, 3, 1, 2, 0, 7, 2, 0, 1, 3, 4, 1, 6, 10, 3, 5, 8, 7, 9, 4, 2, 11, 5, 6, 0, 8, 7, 12, 4, 2, 8, 1, 5, 10, 3, 0, 9, 3, 0, 9, 6, 5, 2, 4, 7, 8, 1, 7, 5, 0, 4, 5, 2, 3, 0, 10, 6, 12, 9, 2, 3, 11, 1, 6, 8, 8, 7, 9, 5, 4, 0, 11, 1, 5, 2, 2, 9, 1, 4, 12, 8, 3, 6, 6, 7, 0, 3, 7, 4, 7, 7, 5, 0, 12, 1, 11, 2, 9, 9, 0, 6, 8, 5, 3, 3, 10, 8, 2]); /*8159*/
		$1.bbs = $a(65); /*8161*/
		$1.bhs = $a(65); /*8162*/
		for (var _3u = 0; _3u <= 64; _3u += 1) { /*8183*/
			$1.i = _3u; /*8164*/
			$1.dec = ($get($1.chars, $get($1.barmap, $1.i * 4)) & (~~Math.pow(2, $get($1.barmap, ($1.i * 4) + 1)))) != 0; /*8165*/
			$1.asc = ($get($1.chars, $get($1.barmap, ($1.i * 4) + 2)) & (~~Math.pow(2, $get($1.barmap, ($1.i * 4) + 3)))) != 0; /*8166*/
			if ((!$1.dec) && (!$1.asc)) { /*8170*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8168*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*8169*/
			} /*8169*/
			if ((!$1.dec) && $1.asc) { /*8174*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8172*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8173*/
			} /*8173*/
			if ($1.dec && (!$1.asc)) { /*8178*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8176*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8177*/
			} /*8177*/
			if ($1.dec && $1.asc) { /*8182*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8180*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*8181*/
			} /*8181*/
		} /*8181*/
		$k[$j++] = Infinity; /*8196*/
		$k[$j++] = "ren"; /*8191*/
		$k[$j++] = $0.renlinear; /*8191*/
		$k[$j++] = "bbs"; /*8191*/
		$k[$j++] = $1.bbs; /*8191*/
		$k[$j++] = "bhs"; /*8191*/
		$k[$j++] = $1.bhs; /*8191*/
		$k[$j++] = "sbs"; /*8191*/
		$k[$j++] = Infinity; /*8191*/
		for (var _4k = 0, _4l = $1.bhs.length - 1; _4k < _4l; _4k++) { /*8190*/
			$k[$j++] = 1.44; /*8190*/
			$k[$j++] = 1.872; /*8190*/
		} /*8190*/
		$k[$j++] = 1.44; /*8190*/
		var _4m = $a(); /*8191*/
		$k[$j++] = _4m; /*8196*/
		$k[$j++] = "txt"; /*8196*/
		$k[$j++] = $1.txt; /*8196*/
		$k[$j++] = "textxalign"; /*8196*/
		$k[$j++] = "left"; /*8196*/
		$k[$j++] = "textfont"; /*8196*/
		$k[$j++] = "Helvetica"; /*8196*/
		$k[$j++] = "textyoffset"; /*8196*/
		$k[$j++] = 1; /*8196*/
		$k[$j++] = "textxoffset"; /*8196*/
		$k[$j++] = -0.3; /*8196*/
		$k[$j++] = "opt"; /*8196*/
		$k[$j++] = $1.options; /*8196*/
		var _4p = $d(); /*8196*/
		$k[$j++] = _4p; /*8199*/
		if (!$1.dontdraw) { /*8199*/
			$0.renlinear(); /*8199*/
		} /*8199*/
	};
	$0.postnet = function() {
		var $1 = {}; /*8226*/
		$1.options = $k[--$j]; /*8228*/
		$1.barcode = $k[--$j]; /*8229*/
		$1.dontdraw = false; /*8231*/
		$1.includetext = false; /*8232*/
		$1.validatecheck = false; /*8233*/
		$1.includecheckintext = false; /*8234*/
		$1.textfont = "Courier"; /*8235*/
		$1.textsize = 10; /*8236*/
		$1.textyoffset = -8.5; /*8237*/
		$1.height = 0.125; /*8238*/
		$forall($1.options, function() { /*8249*/
			var _3 = $k[--$j]; /*8249*/
			$1[$k[--$j]] = _3; /*8249*/
		}); /*8249*/
		$1.textfont = "" + $1.textfont; /*8251*/
		$1.textsize = +$1.textsize; /*8252*/
		$1.textyoffset = +$1.textyoffset; /*8253*/
		$1.height = +$1.height; /*8254*/
		$k[$j++] = "barlen"; /*8256*/
		$k[$j++] = $1.barcode.length; /*8256*/
		if ($1.validatecheck) { /*8256*/
			var _B = $k[--$j]; /*8256*/
			$k[$j++] = _B - 1; /*8256*/
		} /*8256*/
		var _C = $k[--$j]; /*8256*/
		$1[$k[--$j]] = _C; /*8256*/
		if ((($1.barlen != 5) && ($1.barlen != 9)) && ($1.barlen != 11)) { /*8261*/
			$k[$j++] = "bwipp.postnetBadLength"; /*8260*/
			$k[$j++] = "USPS POSTNET must be 5, 9 or 11 digits excluding check digit"; /*8260*/
			$0.raiseerror(); /*8260*/
		} /*8260*/
		$forall($1.barcode, function() { /*8266*/
			var _I = $k[--$j]; /*8263*/
			if ((_I < 48) || (_I > 57)) { /*8265*/
				$k[$j++] = "bwipp.postnetBadCharacter"; /*8264*/
				$k[$j++] = "USPS POSTNET must contain only digits"; /*8264*/
				$0.raiseerror(); /*8264*/
			} /*8264*/
		}); /*8264*/
		$1.barchars = "0123456789"; /*8269*/
		$1.checksum = 0; /*8271*/
		for (var _L = 0, _K = $1.barlen - 1; _L <= _K; _L += 1) { /*8275*/
			$1.i = _L; /*8273*/
			$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*8274*/
		} /*8274*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*8276*/
		if ($1.validatecheck) { /*8282*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8280*/
				$k[$j++] = "bwipp.postnetBadCheckDigit"; /*8279*/
				$k[$j++] = "Incorrect USPS POSTNET check digit provided"; /*8279*/
				$0.raiseerror(); /*8279*/
			} /*8279*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8281*/
		} /*8281*/
		$1.encs = $a(["55222", "22255", "22525", "22552", "25225", "25252", "25522", "52225", "52252", "52522", "5", "5"]); /*8289*/
		$1.bhs = $a(($1.barlen * 5) + 7); /*8291*/
		$1.txt = $a($1.barlen + 1); /*8292*/
		$1.enc = $get($1.encs, 10); /*8295*/
		$1.heights = $a($1.enc.length); /*8296*/
		for (var _m = 0, _l = $1.enc.length - 1; _m <= _l; _m += 1) { /*8300*/
			$1.j = _m; /*8298*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8299*/
		} /*8299*/
		$puti($1.bhs, 0, $1.heights); /*8301*/
		for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*8313*/
			$1.i = _x; /*8304*/
			$1.enc = $get($1.encs, $get($1.barcode, $1.i) - 48); /*8305*/
			$1.heights = $a($1.enc.length); /*8306*/
			for (var _17 = 0, _16 = $1.enc.length - 1; _17 <= _16; _17 += 1) { /*8310*/
				$1.j = _17; /*8308*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8309*/
			} /*8309*/
			$puti($1.bhs, ($1.i * 5) + 1, $1.heights); /*8311*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8312*/
		} /*8312*/
		$1.enc = $get($1.encs, $1.checksum); /*8316*/
		$1.heights = $a($1.enc.length); /*8317*/
		for (var _1Y = 0, _1X = $1.enc.length - 1; _1Y <= _1X; _1Y += 1) { /*8321*/
			$1.j = _1Y; /*8319*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8320*/
		} /*8320*/
		$puti($1.bhs, ($1.barlen * 5) + 1, $1.heights); /*8322*/
		if ($1.includecheckintext) { /*8327*/
			$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8325*/
		} else { /*8327*/
			$put($1.txt, $1.barlen, $a([" ", ((($1.barlen * 5) + 1) * 72) / 25, $1.textyoffset, $1.textfont, $1.textsize])); /*8327*/
		} /*8327*/
		$1.enc = $get($1.encs, 11); /*8331*/
		$1.heights = $a($1.enc.length); /*8332*/
		for (var _26 = 0, _25 = $1.enc.length - 1; _26 <= _25; _26 += 1) { /*8336*/
			$1.j = _26; /*8334*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8335*/
		} /*8335*/
		$puti($1.bhs, ($1.barlen * 5) + 6, $1.heights); /*8337*/
		$k[$j++] = Infinity; /*8348*/
		$k[$j++] = "ren"; /*8344*/
		$k[$j++] = $0.renlinear; /*8344*/
		$k[$j++] = "bhs"; /*8344*/
		$k[$j++] = $1.bhs; /*8344*/
		$k[$j++] = "bbs"; /*8344*/
		$k[$j++] = Infinity; /*8344*/
		for (var _2I = 0, _2J = $1.bhs.length; _2I < _2J; _2I++) { /*8343*/
			$k[$j++] = 0; /*8343*/
		} /*8343*/
		var _2K = $a(); /*8344*/
		$k[$j++] = _2K; /*8345*/
		$k[$j++] = "sbs"; /*8345*/
		$k[$j++] = Infinity; /*8345*/
		for (var _2M = 0, _2N = $1.bhs.length - 1; _2M < _2N; _2M++) { /*8344*/
			$k[$j++] = 1.44; /*8344*/
			$k[$j++] = 1.872; /*8344*/
		} /*8344*/
		$k[$j++] = 1.44; /*8344*/
		var _2O = $a(); /*8345*/
		$k[$j++] = _2O; /*8347*/
		if ($1.includetext) { /*8347*/
			$k[$j++] = "txt"; /*8346*/
			$k[$j++] = $1.txt; /*8346*/
		} /*8346*/
		$k[$j++] = "opt"; /*8348*/
		$k[$j++] = $1.options; /*8348*/
		var _2S = $d(); /*8348*/
		$k[$j++] = _2S; /*8351*/
		if (!$1.dontdraw) { /*8351*/
			$0.renlinear(); /*8351*/
		} /*8351*/
	};
	$0.planet = function() {
		var $1 = {}; /*8378*/
		$1.options = $k[--$j]; /*8380*/
		$1.barcode = $k[--$j]; /*8381*/
		$1.dontdraw = false; /*8383*/
		$1.includetext = false; /*8384*/
		$1.validatecheck = false; /*8385*/
		$1.includecheckintext = false; /*8386*/
		$1.textfont = "Courier"; /*8387*/
		$1.textsize = 10; /*8388*/
		$1.textyoffset = -8.5; /*8389*/
		$1.height = 0.125; /*8390*/
		$forall($1.options, function() { /*8401*/
			var _3 = $k[--$j]; /*8401*/
			$1[$k[--$j]] = _3; /*8401*/
		}); /*8401*/
		$1.textfont = "" + $1.textfont; /*8403*/
		$1.textsize = +$1.textsize; /*8404*/
		$1.textyoffset = +$1.textyoffset; /*8405*/
		$1.height = +$1.height; /*8406*/
		$k[$j++] = "barlen"; /*8408*/
		$k[$j++] = $1.barcode.length; /*8408*/
		if ($1.validatecheck) { /*8408*/
			var _B = $k[--$j]; /*8408*/
			$k[$j++] = _B - 1; /*8408*/
		} /*8408*/
		var _C = $k[--$j]; /*8408*/
		$1[$k[--$j]] = _C; /*8408*/
		if (($1.barlen != 11) && ($1.barlen != 13)) { /*8413*/
			$k[$j++] = "bwipp.planetBadLength"; /*8412*/
			$k[$j++] = "USPS PLANET must be 11 or 13 digits excluding check digit"; /*8412*/
			$0.raiseerror(); /*8412*/
		} /*8412*/
		$forall($1.barcode, function() { /*8418*/
			var _H = $k[--$j]; /*8415*/
			if ((_H < 48) || (_H > 57)) { /*8417*/
				$k[$j++] = "bwipp.planetBadCharacter"; /*8416*/
				$k[$j++] = "USPS PLANET must contain only digits"; /*8416*/
				$0.raiseerror(); /*8416*/
			} /*8416*/
		}); /*8416*/
		$1.barchars = "0123456789"; /*8421*/
		$1.checksum = 0; /*8424*/
		for (var _K = 0, _J = $1.barlen - 1; _K <= _J; _K += 1) { /*8428*/
			$1.i = _K; /*8426*/
			$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*8427*/
		} /*8427*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*8429*/
		if ($1.validatecheck) { /*8435*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8433*/
				$k[$j++] = "bwipp.planetBadCheckDigit"; /*8432*/
				$k[$j++] = "Incorrect USPS PLANET check digit provided"; /*8432*/
				$0.raiseerror(); /*8432*/
			} /*8432*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8434*/
		} /*8434*/
		$1.encs = $a(["22555", "55522", "55252", "55225", "52552", "52525", "52255", "25552", "25525", "25255", "5", "5"]); /*8442*/
		$1.bhs = $a(($1.barlen * 5) + 7); /*8444*/
		$1.txt = $a($1.barlen + 1); /*8445*/
		$1.enc = $get($1.encs, 10); /*8448*/
		$1.heights = $a($1.enc.length); /*8449*/
		for (var _l = 0, _k = $1.enc.length - 1; _l <= _k; _l += 1) { /*8453*/
			$1.j = _l; /*8451*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8452*/
		} /*8452*/
		$puti($1.bhs, 0, $1.heights); /*8454*/
		for (var _w = 0, _v = $1.barlen - 1; _w <= _v; _w += 1) { /*8466*/
			$1.i = _w; /*8457*/
			$1.enc = $get($1.encs, $get($1.barcode, $1.i) - 48); /*8458*/
			$1.heights = $a($1.enc.length); /*8459*/
			for (var _16 = 0, _15 = $1.enc.length - 1; _16 <= _15; _16 += 1) { /*8463*/
				$1.j = _16; /*8461*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8462*/
			} /*8462*/
			$puti($1.bhs, ($1.i * 5) + 1, $1.heights); /*8464*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8465*/
		} /*8465*/
		$1.enc = $get($1.encs, $1.checksum); /*8469*/
		$1.heights = $a($1.enc.length); /*8470*/
		for (var _1X = 0, _1W = $1.enc.length - 1; _1X <= _1W; _1X += 1) { /*8474*/
			$1.j = _1X; /*8472*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8473*/
		} /*8473*/
		$puti($1.bhs, ($1.barlen * 5) + 1, $1.heights); /*8475*/
		if ($1.includecheckintext) { /*8480*/
			$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8478*/
		} else { /*8480*/
			$put($1.txt, $1.barlen, $a([" ", ((($1.barlen * 5) + 1) * 72) / 25, $1.textyoffset, $1.textfont, $1.textsize])); /*8480*/
		} /*8480*/
		$1.enc = $get($1.encs, 11); /*8484*/
		$1.heights = $a($1.enc.length); /*8485*/
		for (var _25 = 0, _24 = $1.enc.length - 1; _25 <= _24; _25 += 1) { /*8489*/
			$1.j = _25; /*8487*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8488*/
		} /*8488*/
		$puti($1.bhs, ($1.barlen * 5) + 6, $1.heights); /*8490*/
		$k[$j++] = Infinity; /*8501*/
		$k[$j++] = "ren"; /*8497*/
		$k[$j++] = $0.renlinear; /*8497*/
		$k[$j++] = "bhs"; /*8497*/
		$k[$j++] = $1.bhs; /*8497*/
		$k[$j++] = "bbs"; /*8497*/
		$k[$j++] = Infinity; /*8497*/
		for (var _2H = 0, _2I = $1.bhs.length; _2H < _2I; _2H++) { /*8496*/
			$k[$j++] = 0; /*8496*/
		} /*8496*/
		var _2J = $a(); /*8497*/
		$k[$j++] = _2J; /*8498*/
		$k[$j++] = "sbs"; /*8498*/
		$k[$j++] = Infinity; /*8498*/
		for (var _2L = 0, _2M = $1.bhs.length - 1; _2L < _2M; _2L++) { /*8497*/
			$k[$j++] = 1.44; /*8497*/
			$k[$j++] = 1.872; /*8497*/
		} /*8497*/
		$k[$j++] = 1.44; /*8497*/
		var _2N = $a(); /*8498*/
		$k[$j++] = _2N; /*8500*/
		if ($1.includetext) { /*8500*/
			$k[$j++] = "txt"; /*8499*/
			$k[$j++] = $1.txt; /*8499*/
		} /*8499*/
		$k[$j++] = "opt"; /*8501*/
		$k[$j++] = $1.options; /*8501*/
		var _2R = $d(); /*8501*/
		$k[$j++] = _2R; /*8504*/
		if (!$1.dontdraw) { /*8504*/
			$0.renlinear(); /*8504*/
		} /*8504*/
	};
	$0.royalmail = function() {
		var $1 = {}; /*8531*/
		$1.options = $k[--$j]; /*8533*/
		$1.barcode = $k[--$j]; /*8534*/
		$1.dontdraw = false; /*8536*/
		$1.includetext = false; /*8537*/
		$1.validatecheck = false; /*8538*/
		$1.includecheckintext = false; /*8539*/
		$1.textfont = "Courier"; /*8540*/
		$1.textsize = 10; /*8541*/
		$1.textyoffset = -8.5; /*8542*/
		$1.height = 0.175; /*8543*/
		$forall($1.options, function() { /*8554*/
			var _3 = $k[--$j]; /*8554*/
			$1[$k[--$j]] = _3; /*8554*/
		}); /*8554*/
		$1.textfont = "" + $1.textfont; /*8556*/
		$1.textsize = +$1.textsize; /*8557*/
		$1.textyoffset = +$1.textyoffset; /*8558*/
		$1.height = +$1.height; /*8559*/
		$1.barchars = "ZUVWXY501234B6789AHCDEFGNIJKLMTOPQRS"; /*8562*/
		$1.charvals = {}; /*8563*/
		for (var _9 = 0; _9 <= 35; _9 += 1) { /*8564*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*8564*/
		} /*8564*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*8571*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*8568*/
			if (!_J) { /*8570*/
				$k[$j++] = "bwipp.royalmailBadCharacter"; /*8569*/
				$k[$j++] = "RM4SCC must contain only capital letters and digits"; /*8569*/
				$0.raiseerror(); /*8569*/
			} /*8569*/
		} /*8569*/
		$k[$j++] = "barlen"; /*8573*/
		$k[$j++] = $1.barcode.length; /*8573*/
		if ($1.validatecheck) { /*8573*/
			var _M = $k[--$j]; /*8573*/
			$k[$j++] = _M - 1; /*8573*/
		} /*8573*/
		var _N = $k[--$j]; /*8573*/
		$1[$k[--$j]] = _N; /*8573*/
		$1.checksumrow = 0; /*8575*/
		$1.checksumcol = 0; /*8576*/
		for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*8582*/
			$1.i = _R; /*8578*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8579*/
			$1.checksumrow = $1.checksumrow + (~~($1.indx / 6)); /*8580*/
			$1.checksumcol = $1.checksumcol + ($1.indx % 6); /*8581*/
		} /*8581*/
		$1.checksum = (($1.checksumrow % 6) * 6) + ($1.checksumcol % 6); /*8583*/
		if ($1.validatecheck) { /*8589*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8587*/
				$k[$j++] = "bwipp.royalmailBadCheckDigit"; /*8586*/
				$k[$j++] = "Incorrect RM4SCC check digit provided"; /*8586*/
				$0.raiseerror(); /*8586*/
			} /*8586*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8588*/
		} /*8588*/
		$1.encs = $a(["3300", "2211", "2301", "2310", "3201", "3210", "1122", "0033", "0123", "0132", "1023", "1032", "1302", "0213", "0303", "0312", "1203", "1212", "1320", "0231", "0321", "0330", "1221", "1230", "3102", "2013", "2103", "2112", "3003", "3012", "3120", "2031", "2121", "2130", "3021", "3030", "2", "3"]); /*8600*/
		$1.encstr = $s(($1.barlen * 4) + 6); /*8602*/
		$1.txt = $a($1.barlen + 1); /*8603*/
		$puti($1.encstr, 0, $get($1.encs, 36)); /*8606*/
		for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*8613*/
			$1.i = _x; /*8609*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8610*/
			$puti($1.encstr, ($1.i * 4) + 1, $get($1.encs, $1.indx)); /*8611*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8612*/
		} /*8612*/
		$puti($1.encstr, ($1.barlen * 4) + 1, $get($1.encs, $1.checksum)); /*8616*/
		if ($1.includecheckintext) { /*8620*/
			$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8618*/
		} else { /*8620*/
			$put($1.txt, $1.barlen, $a([" ", (($1.barlen * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8620*/
		} /*8620*/
		$puti($1.encstr, ($1.barlen * 4) + 5, $get($1.encs, 37)); /*8624*/
		$1.bbs = $a($1.encstr.length); /*8626*/
		$1.bhs = $a($1.encstr.length); /*8627*/
		for (var _1p = 0, _1o = $1.encstr.length - 1; _1p <= _1o; _1p += 1) { /*8647*/
			$1.i = _1p; /*8629*/
			$1.enc = $geti($1.encstr, $1.i, 1); /*8630*/
			if ($eq($1.enc, "0")) { /*8634*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8632*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*8633*/
			} /*8633*/
			if ($eq($1.enc, "1")) { /*8638*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8636*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8637*/
			} /*8637*/
			if ($eq($1.enc, "2")) { /*8642*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8640*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8641*/
			} /*8641*/
			if ($eq($1.enc, "3")) { /*8646*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8644*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*8645*/
			} /*8645*/
		} /*8645*/
		$k[$j++] = Infinity; /*8658*/
		$k[$j++] = "ren"; /*8655*/
		$k[$j++] = $0.renlinear; /*8655*/
		$k[$j++] = "bbs"; /*8655*/
		$k[$j++] = $1.bbs; /*8655*/
		$k[$j++] = "bhs"; /*8655*/
		$k[$j++] = $1.bhs; /*8655*/
		$k[$j++] = "sbs"; /*8655*/
		$k[$j++] = Infinity; /*8655*/
		for (var _2O = 0, _2P = $1.bhs.length - 1; _2O < _2P; _2O++) { /*8654*/
			$k[$j++] = 1.44; /*8654*/
			$k[$j++] = 1.872; /*8654*/
		} /*8654*/
		$k[$j++] = 1.44; /*8654*/
		var _2Q = $a(); /*8655*/
		$k[$j++] = _2Q; /*8657*/
		if ($1.includetext) { /*8657*/
			$k[$j++] = "txt"; /*8656*/
			$k[$j++] = $1.txt; /*8656*/
		} /*8656*/
		$k[$j++] = "opt"; /*8658*/
		$k[$j++] = $1.options; /*8658*/
		var _2U = $d(); /*8658*/
		$k[$j++] = _2U; /*8661*/
		if (!$1.dontdraw) { /*8661*/
			$0.renlinear(); /*8661*/
		} /*8661*/
	};
	$0.auspost = function() {
		var $1 = {}; /*8688*/
		$1.options = $k[--$j]; /*8690*/
		$1.barcode = $k[--$j]; /*8691*/
		$1.dontdraw = false; /*8693*/
		$1.includetext = false; /*8694*/
		$1.textfont = "Courier"; /*8695*/
		$1.textsize = 10; /*8696*/
		$1.textyoffset = -8.5; /*8697*/
		$1.height = 0.175; /*8698*/
		$1.custinfoenc = "character"; /*8699*/
		$forall($1.options, function() { /*8710*/
			var _3 = $k[--$j]; /*8710*/
			$1[$k[--$j]] = _3; /*8710*/
		}); /*8710*/
		$1.textfont = "" + $1.textfont; /*8712*/
		$1.textsize = +$1.textsize; /*8713*/
		$1.textyoffset = +$1.textyoffset; /*8714*/
		$1.height = +$1.height; /*8715*/
		$1.encs = $a(["000", "001", "002", "010", "011", "012", "020", "021", "022", "100", "101", "102", "110", "111", "112", "120", "121", "122", "200", "201", "202", "210", "211", "212", "220", "221", "222", "300", "301", "302", "310", "311", "312", "320", "321", "322", "023", "030", "031", "032", "033", "103", "113", "123", "130", "131", "132", "133", "203", "213", "223", "230", "231", "232", "233", "303", "313", "323", "330", "331", "332", "333", "003", "013", "00", "01", "02", "10", "11", "12", "20", "21", "22", "30", "13", "3"]); /*8729*/
		$1.barchars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz #"; /*8732*/
		$1.barlen = $1.barcode.length; /*8734*/
		if ($eq($geti($1.barcode, 0, 2), "11")) { /*8735*/
			$k[$j++] = 37; /*8735*/
		} /*8735*/
		if ($eq($geti($1.barcode, 0, 2), "45")) { /*8736*/
			$k[$j++] = 37; /*8736*/
		} /*8736*/
		if ($eq($geti($1.barcode, 0, 2), "59")) { /*8737*/
			$k[$j++] = 52; /*8737*/
		} /*8737*/
		if ($eq($geti($1.barcode, 0, 2), "62")) { /*8738*/
			$k[$j++] = 67; /*8738*/
		} /*8738*/
		$1.encstr = $s($k[--$j]); /*8739*/
		$1.txt = $a($1.barlen - 2); /*8740*/
		$puti($1.encstr, 0, $get($1.encs, 74)); /*8743*/
		for (var _Q = 0; _Q <= 1; _Q += 1) { /*8750*/
			$1.i = _Q; /*8747*/
			$puti($1.encstr, ($1.i * 2) + 2, $get($1.encs, (~~$z($geti($1.barcode, $1.i, 1))) + 64)); /*8749*/
		} /*8749*/
		for (var _Y = 2; _Y <= 9; _Y += 1) { /*8758*/
			$1.i = _Y; /*8754*/
			$puti($1.encstr, ($1.i * 2) + 2, $get($1.encs, (~~$z($geti($1.barcode, $1.i, 1))) + 64)); /*8756*/
			$put($1.txt, $1.i - 2, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 2) * 2) + 6) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8757*/
		} /*8757*/
		if ($eq($1.custinfoenc, "numeric")) { /*8780*/
			for (var _t = 0, _s = $1.barlen - 11; _t <= _s; _t += 1) { /*8767*/
				$1.i = _t; /*8763*/
				$puti($1.encstr, ($1.i * 2) + 22, $get($1.encs, (~~$z($geti($1.barcode, $1.i + 10, 1))) + 64)); /*8765*/
				$put($1.txt, $1.i + 8, $a([$geti($1.barcode, $1.i + 10, 1), (($1.i * 2) + 22) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8766*/
			} /*8766*/
			$1.ciflen = ($1.barlen - 10) * 2; /*8768*/
		} else { /*8780*/
			for (var _1E = 0, _1D = $1.barlen - 11; _1E <= _1D; _1E += 1) { /*8779*/
				$1.i = _1E; /*8771*/
				$search($1.barchars, $geti($1.barcode, $1.i + 10, 1)); /*8772*/
				$j--; /*8773*/
				$1.indx = $k[--$j].length; /*8774*/
				$j -= 2; /*8775*/
				$1.enc = $get($1.encs, $1.indx); /*8776*/
				$puti($1.encstr, ($1.i * 3) + 22, $1.enc); /*8777*/
				$put($1.txt, $1.i + 8, $a([$geti($1.barcode, $1.i + 10, 1), (($1.i * 3) + 22) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8778*/
			} /*8778*/
			$1.ciflen = ($1.barlen - 10) * 3; /*8780*/
		} /*8780*/
		for (var _1e = 22 + $1.ciflen, _1d = $1.encstr.length - 14; _1e <= _1d; _1e += 1) { /*8786*/
			$puti($1.encstr, _1e, $get($1.encs, 75)); /*8785*/
		} /*8785*/
		$1.rstable = $a(64 * 64); /*8789*/
		$k[$j++] = $1.rstable; /*8790*/
		$k[$j++] = 0; /*8790*/
		$k[$j++] = Infinity; /*8790*/
		for (var _1k = 0, _1l = 64; _1k < _1l; _1k++) { /*8790*/
			$k[$j++] = 0; /*8790*/
		} /*8790*/
		var _1m = $a(); /*8790*/
		var _1n = $k[--$j]; /*8790*/
		$puti($k[--$j], _1n, _1m); /*8790*/
		$k[$j++] = $1.rstable; /*8791*/
		$k[$j++] = 64; /*8791*/
		$k[$j++] = Infinity; /*8791*/
		for (var _1q = 0; _1q <= 63; _1q += 1) { /*8791*/
			$k[$j++] = _1q; /*8791*/
		} /*8791*/
		var _1r = $a(); /*8791*/
		var _1s = $k[--$j]; /*8791*/
		$puti($k[--$j], _1s, _1r); /*8791*/
		$1.prev = 1; /*8792*/
		for (var _1u = 0, _1v = 64; _1u < _1v; _1u++) { /*8807*/
			$1.next = $1.prev << 1; /*8794*/
			if (($1.next & 64) != 0) { /*8797*/
				$1.next = $1.next ^ 67; /*8796*/
			} /*8796*/
			for (var _1z = 0; _1z <= 63; _1z += 1) { /*8805*/
				$1.j = _1z; /*8799*/
				$1.nextcell = function() {
					$k[$j++] = $1.rstable; /*8800*/
					$k[$j++] = (64 * $1.next) + $1.j; /*8800*/
				}; /*8800*/
				$1.nextcell(); /*8801*/
				var _27 = $k[--$j]; /*8801*/
				$put($k[--$j], _27, $get($1.rstable, (64 * $1.prev) + $1.j) << 1); /*8801*/
				$1.nextcell(); /*8802*/
				var _29 = $k[--$j]; /*8802*/
				if (($get($k[--$j], _29) & 64) != 0) { /*8804*/
					$1.nextcell(); /*8803*/
					$1.nextcell(); /*8803*/
					var _2C = $k[--$j]; /*8803*/
					var _2E = $get($k[--$j], _2C); /*8803*/
					var _2F = $k[--$j]; /*8803*/
					$put($k[--$j], _2F, _2E ^ 67); /*8803*/
				} /*8803*/
			} /*8803*/
			$1.prev = $1.next; /*8806*/
		} /*8806*/
		$1.rscodes = $a((~~(($1.encstr.length - 16) / 3)) + 4); /*8810*/
		$k[$j++] = $1.rscodes; /*8811*/
		$k[$j++] = 0; /*8811*/
		$k[$j++] = Infinity; /*8811*/
		for (var _2L = 0, _2M = 4; _2L < _2M; _2L++) { /*8811*/
			$k[$j++] = 0; /*8811*/
		} /*8811*/
		var _2N = $a(); /*8811*/
		var _2O = $k[--$j]; /*8811*/
		$puti($k[--$j], _2O, _2N); /*8811*/
		for (var _2S = 2, _2R = $1.encstr.length - 16; _2S <= _2R; _2S += 3) { /*8819*/
			$1.i = _2S; /*8813*/
			$put($1.rscodes, ($1.rscodes.length - (~~(($1.i - 2) / 3))) - 1, (((~~$z($geti($1.encstr, $1.i, 1))) * 16) + ((~~$z($geti($1.encstr, $1.i + 1, 1))) * 4)) + (~~$z($geti($1.encstr, $1.i + 2, 1)))); /*8818*/
		} /*8818*/
		for (var _2g = $1.rscodes.length - 5; _2g >= 0; _2g -= 1) { /*8828*/
			$1.i = _2g; /*8821*/
			for (var _2h = 0; _2h <= 4; _2h += 1) { /*8827*/
				$1.j = _2h; /*8823*/
				$put($1.rscodes, $1.i + $1.j, $xo($get($1.rscodes, $1.i + $1.j), $get($1.rstable, (64 * $get($a([48, 17, 29, 30, 1]), $1.j)) + $get($1.rscodes, $1.i + 4)))); /*8826*/
			} /*8826*/
		} /*8826*/
		$1.checkcode = $strcpy($s(12), "000000000000"); /*8829*/
		for (var _2z = 0; _2z <= 3; _2z += 1) { /*8834*/
			$1.i = _2z; /*8831*/
			$1.enc = $cvrs($s(3), $get($1.rscodes, 3 - $1.i), 4); /*8832*/
			$puti($1.checkcode, ($1.i * 3) + (3 - $1.enc.length), $1.enc); /*8833*/
		} /*8833*/
		$puti($1.encstr, $1.encstr.length - 14, $1.checkcode); /*8837*/
		$puti($1.encstr, $1.encstr.length - 2, $get($1.encs, 74)); /*8838*/
		$1.bbs = $a($1.encstr.length); /*8840*/
		$1.bhs = $a($1.encstr.length); /*8841*/
		for (var _3M = 0, _3L = $1.encstr.length - 1; _3M <= _3L; _3M += 1) { /*8861*/
			$1.i = _3M; /*8843*/
			$1.enc = $geti($1.encstr, $1.i, 1); /*8844*/
			if ($eq($1.enc, "0")) { /*8848*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8846*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*8847*/
			} /*8847*/
			if ($eq($1.enc, "1")) { /*8852*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8850*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8851*/
			} /*8851*/
			if ($eq($1.enc, "2")) { /*8856*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8854*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8855*/
			} /*8855*/
			if ($eq($1.enc, "3")) { /*8860*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8858*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*8859*/
			} /*8859*/
		} /*8859*/
		$k[$j++] = Infinity; /*8872*/
		$k[$j++] = "ren"; /*8869*/
		$k[$j++] = $0.renlinear; /*8869*/
		$k[$j++] = "bbs"; /*8869*/
		$k[$j++] = $1.bbs; /*8869*/
		$k[$j++] = "bhs"; /*8869*/
		$k[$j++] = $1.bhs; /*8869*/
		$k[$j++] = "sbs"; /*8869*/
		$k[$j++] = Infinity; /*8869*/
		for (var _3v = 0, _3w = $1.bhs.length - 1; _3v < _3w; _3v++) { /*8868*/
			$k[$j++] = 1.44; /*8868*/
			$k[$j++] = 1.872; /*8868*/
		} /*8868*/
		$k[$j++] = 1.44; /*8868*/
		var _3x = $a(); /*8869*/
		$k[$j++] = _3x; /*8871*/
		if ($1.includetext) { /*8871*/
			$k[$j++] = "txt"; /*8870*/
			$k[$j++] = $1.txt; /*8870*/
		} /*8870*/
		$k[$j++] = "opt"; /*8872*/
		$k[$j++] = $1.options; /*8872*/
		var _41 = $d(); /*8872*/
		$k[$j++] = _41; /*8875*/
		if (!$1.dontdraw) { /*8875*/
			$0.renlinear(); /*8875*/
		} /*8875*/
	};
	$0.kix = function() {
		var $1 = {}; /*8902*/
		$1.options = $k[--$j]; /*8904*/
		$1.barcode = $k[--$j]; /*8905*/
		$1.dontdraw = false; /*8907*/
		$1.includetext = false; /*8908*/
		$1.textfont = "Courier"; /*8909*/
		$1.textsize = 10; /*8910*/
		$1.textyoffset = -8.5; /*8911*/
		$1.height = 0.175; /*8912*/
		$forall($1.options, function() { /*8923*/
			var _3 = $k[--$j]; /*8923*/
			$1[$k[--$j]] = _3; /*8923*/
		}); /*8923*/
		$1.textfont = "" + $1.textfont; /*8925*/
		$1.textsize = +$1.textsize; /*8926*/
		$1.textyoffset = +$1.textyoffset; /*8927*/
		$1.height = +$1.height; /*8928*/
		$1.encs = $a(["0033", "0123", "0132", "1023", "1032", "1122", "0213", "0303", "0312", "1203", "1212", "1302", "0231", "0321", "0330", "1221", "1230", "1320", "2013", "2103", "2112", "3003", "3012", "3102", "2031", "2121", "2130", "3021", "3030", "3120", "2211", "2301", "2310", "3201", "3210", "3300"]); /*8938*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"; /*8941*/
		$1.charvals = {}; /*8942*/
		for (var _A = 0; _A <= 35; _A += 1) { /*8943*/
			$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*8943*/
		} /*8943*/
		for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*8950*/
			var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*8947*/
			if (!_K) { /*8949*/
				$k[$j++] = "bwipp.kixBadCharacter"; /*8948*/
				$k[$j++] = "KIX must contain only capital letters and digits"; /*8948*/
				$0.raiseerror(); /*8948*/
			} /*8948*/
		} /*8948*/
		$1.barlen = $1.barcode.length; /*8952*/
		$1.encstr = $s($1.barlen * 4); /*8953*/
		$1.txt = $a($1.barlen); /*8954*/
		for (var _S = 0, _R = $1.barlen - 1; _S <= _R; _S += 1) { /*8961*/
			$1.i = _S; /*8957*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8958*/
			$puti($1.encstr, $1.i * 4, $get($1.encs, $1.indx)); /*8959*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 4) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8960*/
		} /*8960*/
		$1.bbs = $a($1.encstr.length); /*8963*/
		$1.bhs = $a($1.encstr.length); /*8964*/
		for (var _t = 0, _s = $1.encstr.length - 1; _t <= _s; _t += 1) { /*8984*/
			$1.i = _t; /*8966*/
			$1.enc = $geti($1.encstr, $1.i, 1); /*8967*/
			if ($eq($1.enc, "0")) { /*8971*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8969*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*8970*/
			} /*8970*/
			if ($eq($1.enc, "1")) { /*8975*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8973*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8974*/
			} /*8974*/
			if ($eq($1.enc, "2")) { /*8979*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8977*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8978*/
			} /*8978*/
			if ($eq($1.enc, "3")) { /*8983*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8981*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*8982*/
			} /*8982*/
		} /*8982*/
		$k[$j++] = Infinity; /*8995*/
		$k[$j++] = "ren"; /*8992*/
		$k[$j++] = $0.renlinear; /*8992*/
		$k[$j++] = "bbs"; /*8992*/
		$k[$j++] = $1.bbs; /*8992*/
		$k[$j++] = "bhs"; /*8992*/
		$k[$j++] = $1.bhs; /*8992*/
		$k[$j++] = "sbs"; /*8992*/
		$k[$j++] = Infinity; /*8992*/
		for (var _1S = 0, _1T = $1.bhs.length - 1; _1S < _1T; _1S++) { /*8991*/
			$k[$j++] = 1.44; /*8991*/
			$k[$j++] = 1.872; /*8991*/
		} /*8991*/
		$k[$j++] = 1.44; /*8991*/
		var _1U = $a(); /*8992*/
		$k[$j++] = _1U; /*8994*/
		if ($1.includetext) { /*8994*/
			$k[$j++] = "txt"; /*8993*/
			$k[$j++] = $1.txt; /*8993*/
		} /*8993*/
		$k[$j++] = "opt"; /*8995*/
		$k[$j++] = $1.options; /*8995*/
		var _1Y = $d(); /*8995*/
		$k[$j++] = _1Y; /*8998*/
		if (!$1.dontdraw) { /*8998*/
			$0.renlinear(); /*8998*/
		} /*8998*/
	};
	$0.japanpost = function() {
		var $1 = {}; /*9025*/
		$1.options = $k[--$j]; /*9027*/
		$1.barcode = $k[--$j]; /*9028*/
		$1.dontdraw = false; /*9030*/
		$1.includetext = false; /*9031*/
		$1.includecheckintext = false; /*9032*/
		$1.textfont = "Courier"; /*9033*/
		$1.textsize = 10; /*9034*/
		$1.textyoffset = -8.5; /*9035*/
		$1.height = 0.175; /*9036*/
		$forall($1.options, function() { /*9047*/
			var _3 = $k[--$j]; /*9047*/
			$1[$k[--$j]] = _3; /*9047*/
		}); /*9047*/
		$1.textfont = "" + $1.textfont; /*9049*/
		$1.textsize = +$1.textsize; /*9050*/
		$1.textyoffset = +$1.textyoffset; /*9051*/
		$1.height = +$1.height; /*9052*/
		$1.encs = $a(["300", "330", "312", "132", "321", "303", "123", "231", "213", "033", "030", "120", "102", "210", "012", "201", "021", "003", "333", "31", "13"]); /*9060*/
		$1.barchars = "0123456789-ABCDEFGHIJKLMNOPQRSTUVWXYZ"; /*9063*/
		$1.barlen = $1.barcode.length; /*9064*/
		$1.encstr = $s(((20 + 1) * 3) + 4); /*9066*/
		$1.digits = $a(20); /*9067*/
		$1.txt = $a($1.barlen + 1); /*9068*/
		$puti($1.encstr, 0, $get($1.encs, 19)); /*9071*/
		$1.checksum = 0; /*9073*/
		$1.j = 0; /*9074*/
		$1.i = 0; /*9074*/
		for (var _K = 0, _J = $1.barlen - 1; _K <= _J; _K += 1) { /*9108*/
			$1.i = _K; /*9076*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*9077*/
			$j--; /*9078*/
			$1.indx = $k[--$j].length; /*9079*/
			$j -= 2; /*9080*/
			if (($1.indx >= 11) && ($1.indx < 37)) { /*9091*/
				if ($1.j > 18) { /*9082*/
					break; /*9082*/
				} /*9082*/
				$1.digit = (~~(($1.indx - 1) / 10)) + 10; /*9086*/
				$puti($1.encstr, ($1.j * 3) + 2, $get($1.encs, $1.digit)); /*9087*/
				$1.checksum = $1.checksum + $1.digit; /*9088*/
				$put($1.digits, $1.j, $1.digit); /*9089*/
				$1.j = $1.j + 1; /*9090*/
			} /*9090*/
			if ($1.j > 19) { /*9092*/
				break; /*9092*/
			} /*9092*/
			$1.digit = 0; /*9093*/
			if ($1.indx == 37) { /*9096*/
				$1.digit = 14; /*9095*/
			} /*9095*/
			if (($1.indx >= 11) && ($1.indx < 37)) { /*9099*/
				$1.digit = ($1.indx - 1) % 10; /*9098*/
			} /*9098*/
			if ($1.indx < 11) { /*9102*/
				$1.digit = $1.indx; /*9101*/
			} /*9101*/
			$puti($1.encstr, ($1.j * 3) + 2, $get($1.encs, $1.digit)); /*9103*/
			$1.checksum = $1.checksum + $1.digit; /*9104*/
			$put($1.digits, $1.j, $1.digit); /*9105*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.j * 3) + 2) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9106*/
			$1.j = $1.j + 1; /*9107*/
		} /*9107*/
		for (var _19 = $1.j, _18 = 20 - 1; _19 <= _18; _19 += 1) { /*9116*/
			$1.k = _19; /*9112*/
			$puti($1.encstr, ($1.k * 3) + 2, $get($1.encs, 14)); /*9113*/
			$1.checksum = $1.checksum + 14; /*9114*/
			$put($1.digits, $1.k, 14); /*9115*/
		} /*9115*/
		$1.checksum = 19 - ($1.checksum % 19); /*9119*/
		$puti($1.encstr, 2 + (20 * 3), $get($1.encs, $1.checksum)); /*9120*/
		$puti($1.encstr, 2 + (21 * 3), $get($1.encs, 20)); /*9123*/
		$1.checkdigit = " "; /*9124*/
		if ($1.includecheckintext) { /*9127*/
			$1.checkdigit = $geti($1.barchars, $1.checksum, 1); /*9126*/
		} /*9126*/
		$put($1.txt, $1.i + 1, $a([$1.checkdigit, ((20 * 3) + 2) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9128*/
		$puti($1.encstr, ((20 + 1) * 3) + 2, $get($1.encs, 20)); /*9131*/
		$1.bbs = $a((21 * 3) + 4); /*9133*/
		$1.bhs = $a($1.bbs.length); /*9134*/
		for (var _1i = 0, _1h = $1.bbs.length - 1; _1i <= _1h; _1i += 1) { /*9158*/
			$1.i = _1i; /*9136*/
			$1.enc = $geti($1.encstr, $1.i, 1); /*9137*/
			$1.bunit = 0; /*9138*/
			$1.hunit = 0; /*9139*/
			if ($eq($1.enc, "0")) { /*9143*/
				$1.bunit = 3; /*9141*/
				$1.hunit = 2; /*9142*/
			} /*9142*/
			if ($eq($1.enc, "1")) { /*9147*/
				$1.bunit = 0; /*9145*/
				$1.hunit = 5; /*9146*/
			} /*9146*/
			if ($eq($1.enc, "2")) { /*9151*/
				$1.bunit = 3; /*9149*/
				$1.hunit = 5; /*9150*/
			} /*9150*/
			if ($eq($1.enc, "3")) { /*9155*/
				$1.bunit = 0; /*9153*/
				$1.hunit = 8; /*9154*/
			} /*9154*/
			$put($1.bbs, $1.i, ($1.bunit * $1.height) / 8); /*9156*/
			$put($1.bhs, $1.i, ($1.hunit * $1.height) / 8); /*9157*/
		} /*9157*/
		$k[$j++] = Infinity; /*9169*/
		$k[$j++] = "ren"; /*9166*/
		$k[$j++] = $0.renlinear; /*9166*/
		$k[$j++] = "bbs"; /*9166*/
		$k[$j++] = $1.bbs; /*9166*/
		$k[$j++] = "bhs"; /*9166*/
		$k[$j++] = $1.bhs; /*9166*/
		$k[$j++] = "sbs"; /*9166*/
		$k[$j++] = Infinity; /*9166*/
		for (var _21 = 0, _22 = $1.bhs.length - 1; _21 < _22; _21++) { /*9165*/
			$k[$j++] = 1.44; /*9165*/
			$k[$j++] = 1.872; /*9165*/
		} /*9165*/
		$k[$j++] = 1.44; /*9165*/
		var _23 = $a(); /*9166*/
		$k[$j++] = _23; /*9168*/
		if ($1.includetext) { /*9168*/
			$k[$j++] = "txt"; /*9167*/
			$k[$j++] = $1.txt; /*9167*/
		} /*9167*/
		$k[$j++] = "opt"; /*9169*/
		$k[$j++] = $1.options; /*9169*/
		var _27 = $d(); /*9169*/
		$k[$j++] = _27; /*9172*/
		if (!$1.dontdraw) { /*9172*/
			$0.renlinear(); /*9172*/
		} /*9172*/
	};
	$0.msi = function() {
		var $1 = {}; /*9199*/
		$1.options = $k[--$j]; /*9201*/
		$1.barcode = $k[--$j]; /*9202*/
		$1.dontdraw = false; /*9204*/
		$1.includecheck = false; /*9205*/
		$1.includetext = false; /*9206*/
		$1.includecheckintext = false; /*9207*/
		$1.checktype = "mod10"; /*9208*/
		$1.badmod11 = false; /*9209*/
		$1.textfont = "Courier"; /*9210*/
		$1.textsize = 10; /*9211*/
		$1.textyoffset = -8.5; /*9212*/
		$1.height = 1; /*9213*/
		$forall($1.options, function() { /*9224*/
			var _3 = $k[--$j]; /*9224*/
			$1[$k[--$j]] = _3; /*9224*/
		}); /*9224*/
		$1.textfont = "" + $1.textfont; /*9226*/
		$1.textsize = +$1.textsize; /*9227*/
		$1.textyoffset = +$1.textyoffset; /*9228*/
		$1.height = +$1.height; /*9229*/
		$1.encs = $a(["12121212", "12121221", "12122112", "12122121", "12211212", "12211221", "12212112", "12212121", "21121212", "21121221", "21", "121"]); /*9236*/
		$1.barchars = "0123456789"; /*9239*/
		$1.barlen = $1.barcode.length; /*9241*/
		$1.txtlen = $1.barlen; /*9242*/
		$1.mod10 = function() {
			$1.code = $k[--$j]; /*9245*/
			$k[$j++] = 0; /*9246*/
			$k[$j++] = 0; /*9246*/
			$forall($1.code, function() { /*9246*/
				var _E = $k[--$j]; /*9246*/
				var _F = $k[--$j]; /*9246*/
				var _G = $k[--$j]; /*9246*/
				$k[$j++] = (_E - 48) + (_F * 10); /*9246*/
				$k[$j++] = _G; /*9246*/
			}); /*9246*/
			$j--; /*9246*/
			var _H = $k[--$j]; /*9246*/
			$k[$j++] = _H * 2; /*9247*/
			$k[$j++] = 0; /*9247*/
			for (;;) { /*9247*/
				var _I = $k[--$j]; /*9247*/
				var _J = $k[--$j]; /*9247*/
				var _K = ~~(_J / 10); /*9247*/
				$k[$j++] = _I + (_J % 10); /*9247*/
				$k[$j++] = _K; /*9247*/
				if (_K == 0) { /*9247*/
					$j--; /*9247*/
					break; /*9247*/
				} /*9247*/
				var _L = $k[--$j]; /*9247*/
				var _M = $k[--$j]; /*9247*/
				$k[$j++] = _L; /*9247*/
				$k[$j++] = _M; /*9247*/
			} /*9247*/
			$k[$j++] = 0; /*9248*/
			$k[$j++] = 0; /*9248*/
			$forall($1.code, function() { /*9248*/
				var _O = $k[--$j]; /*9248*/
				var _P = $k[--$j]; /*9248*/
				var _Q = $k[--$j]; /*9248*/
				$k[$j++] = _P + (_O - 48); /*9248*/
				$k[$j++] = _Q; /*9248*/
			}); /*9248*/
			var _R = $k[--$j]; /*9248*/
			var _S = $k[--$j]; /*9248*/
			var _V = $s($1.code.length + 1); /*9250*/
			$puti(_V, 0, $1.code); /*9250*/
			$put(_V, $1.code.length, ((10 - (($k[--$j] + _R) % 10)) % 10) + 48); /*9250*/
			$k[$j++] = _V; /*9250*/
		}; /*9251*/
		$1.mod11 = function() {
			$1.code = $k[--$j]; /*9254*/
			$k[$j++] = $1.code.length - 1; /*9255*/
			$forall($1.code, function() { /*9255*/
				var _b = $k[--$j]; /*9255*/
				var _c = $k[--$j]; /*9255*/
				$k[$j++] = _b - 48; /*9255*/
				$k[$j++] = (_c % 6) + 2; /*9255*/
				$k[$j++] = _c - 1; /*9255*/
			}); /*9255*/
			$j--; /*9255*/
			$k[$j++] = 0; /*9256*/
			for (var _e = 0, _f = $1.code.length; _e < _f; _e++) { /*9256*/
				var _g = $k[--$j]; /*9256*/
				var _h = $k[--$j]; /*9256*/
				var _i = $k[--$j]; /*9256*/
				$k[$j++] = _g + (_i * _h); /*9256*/
			} /*9256*/
			var _k = (11 - ($k[--$j] % 11)) % 11; /*9258*/
			$k[$j++] = _k; /*9262*/
			if ((_k == 10) && $1.badmod11) { /*9261*/
				$j--; /*9259*/
				var _n = $s($1.code.length + 2); /*9259*/
				$puti(_n, 0, $1.code); /*9259*/
				$puti(_n, $1.code.length, "10"); /*9259*/
				$k[$j++] = _n; /*9259*/
			} else { /*9261*/
				var _r = $s($1.code.length + 1); /*9261*/
				$puti(_r, 0, $1.code); /*9261*/
				$put(_r, $1.code.length, $k[--$j] + 48); /*9261*/
				$k[$j++] = _r; /*9261*/
			} /*9261*/
		}; /*9263*/
		$1.ncrmod11 = function() {
			$1.code = $k[--$j]; /*9266*/
			$k[$j++] = $1.code.length - 1; /*9267*/
			$forall($1.code, function() { /*9267*/
				var _y = $k[--$j]; /*9267*/
				var _z = $k[--$j]; /*9267*/
				$k[$j++] = _y - 48; /*9267*/
				$k[$j++] = (_z % 8) + 2; /*9267*/
				$k[$j++] = _z - 1; /*9267*/
			}); /*9267*/
			$j--; /*9267*/
			$k[$j++] = 0; /*9268*/
			for (var _11 = 0, _12 = $1.code.length; _11 < _12; _11++) { /*9268*/
				var _13 = $k[--$j]; /*9268*/
				var _14 = $k[--$j]; /*9268*/
				var _15 = $k[--$j]; /*9268*/
				$k[$j++] = _13 + (_15 * _14); /*9268*/
			} /*9268*/
			var _17 = (11 - ($k[--$j] % 11)) % 11; /*9270*/
			$k[$j++] = _17; /*9274*/
			if ((_17 == 10) && $1.badmod11) { /*9273*/
				$j--; /*9271*/
				var _1A = $s($1.code.length + 2); /*9271*/
				$puti(_1A, 0, $1.code); /*9271*/
				$puti(_1A, $1.code.length, "10"); /*9271*/
				$k[$j++] = _1A; /*9271*/
			} else { /*9273*/
				var _1E = $s($1.code.length + 1); /*9273*/
				$puti(_1E, 0, $1.code); /*9273*/
				$put(_1E, $1.code.length, $k[--$j] + 48); /*9273*/
				$k[$j++] = _1E; /*9273*/
			} /*9273*/
		}; /*9275*/
		if ($1.includecheck) { /*9288*/
			if ($eq($1.checktype, "mod10")) { /*9279*/
				$k[$j++] = $1.barcode; /*9279*/
				$1.mod10(); /*9279*/
			} /*9279*/
			if ($eq($1.checktype, "mod1010")) { /*9280*/
				$k[$j++] = $1.barcode; /*9280*/
				$1.mod10(); /*9280*/
				$1.mod10(); /*9280*/
			} /*9280*/
			if ($eq($1.checktype, "mod11")) { /*9281*/
				$k[$j++] = $1.barcode; /*9281*/
				$1.mod11(); /*9281*/
			} /*9281*/
			if ($eq($1.checktype, "ncrmod11")) { /*9282*/
				$k[$j++] = $1.barcode; /*9282*/
				$1.ncrmod11(); /*9282*/
			} /*9282*/
			if ($eq($1.checktype, "mod1110")) { /*9283*/
				$k[$j++] = $1.barcode; /*9283*/
				$1.mod11(); /*9283*/
				$1.mod10(); /*9283*/
			} /*9283*/
			if ($eq($1.checktype, "ncrmod1110")) { /*9284*/
				$k[$j++] = $1.barcode; /*9284*/
				$1.ncrmod11(); /*9284*/
				$1.mod10(); /*9284*/
			} /*9284*/
			$1.barcode = $k[--$j]; /*9285*/
			$1.barlen = $1.barcode.length; /*9286*/
			if ($1.includecheckintext) { /*9287*/
				$1.txtlen = $1.barlen; /*9287*/
			} /*9287*/
		} /*9287*/
		$1.sbs = $s(($1.barlen * 8) + 5); /*9290*/
		$1.txt = $a($1.barlen); /*9291*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*9294*/
		for (var _1i = 0, _1h = $1.barlen - 1; _1i <= _1h; _1i += 1) { /*9306*/
			$1.i = _1i; /*9297*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*9299*/
			$j--; /*9300*/
			$1.indx = $k[--$j].length; /*9301*/
			$j -= 2; /*9302*/
			$1.enc = $get($1.encs, $1.indx); /*9303*/
			$puti($1.sbs, ($1.i * 8) + 2, $1.enc); /*9304*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 12) + 3, $1.textyoffset, $1.textfont, $1.textsize])); /*9305*/
		} /*9305*/
		$puti($1.sbs, ($1.barlen * 8) + 2, $get($1.encs, 11)); /*9309*/
		$k[$j++] = Infinity; /*9320*/
		$k[$j++] = "ren"; /*9315*/
		$k[$j++] = $0.renlinear; /*9315*/
		$k[$j++] = "sbs"; /*9315*/
		$k[$j++] = Infinity; /*9315*/
		var _28 = $1.sbs; /*9314*/
		for (var _29 = 0, _2A = _28.length; _29 < _2A; _29++) { /*9314*/
			$k[$j++] = $get(_28, _29) - 48; /*9314*/
		} /*9314*/
		var _2C = $a(); /*9315*/
		$k[$j++] = _2C; /*9316*/
		$k[$j++] = "bhs"; /*9316*/
		$k[$j++] = Infinity; /*9316*/
		for (var _2E = 0, _2F = ~~(($1.sbs.length + 1) / 2); _2E < _2F; _2E++) { /*9315*/
			$k[$j++] = $1.height; /*9315*/
		} /*9315*/
		var _2H = $a(); /*9316*/
		$k[$j++] = _2H; /*9317*/
		$k[$j++] = "bbs"; /*9317*/
		$k[$j++] = Infinity; /*9317*/
		for (var _2J = 0, _2K = ~~(($1.sbs.length + 1) / 2); _2J < _2K; _2J++) { /*9316*/
			$k[$j++] = 0; /*9316*/
		} /*9316*/
		var _2L = $a(); /*9317*/
		$k[$j++] = _2L; /*9319*/
		if ($1.includetext) { /*9319*/
			$k[$j++] = "txt"; /*9318*/
			$k[$j++] = $geti($1.txt, 0, $1.txtlen); /*9318*/
		} /*9318*/
		$k[$j++] = "opt"; /*9320*/
		$k[$j++] = $1.options; /*9320*/
		var _2R = $d(); /*9320*/
		$k[$j++] = _2R; /*9323*/
		if (!$1.dontdraw) { /*9323*/
			$0.renlinear(); /*9323*/
		} /*9323*/
	};
	$0.plessey = function() {
		var $1 = {}; /*9350*/
		$1.options = $k[--$j]; /*9352*/
		$1.barcode = $k[--$j]; /*9353*/
		$1.dontdraw = false; /*9355*/
		$1.includetext = false; /*9356*/
		$1.validatecheck = false; /*9357*/
		$1.includecheckintext = false; /*9358*/
		$1.unidirectional = false; /*9359*/
		$1.textfont = "Courier"; /*9360*/
		$1.textsize = 10; /*9361*/
		$1.textyoffset = -8.5; /*9362*/
		$1.height = 1; /*9363*/
		$forall($1.options, function() { /*9374*/
			var _3 = $k[--$j]; /*9374*/
			$1[$k[--$j]] = _3; /*9374*/
		}); /*9374*/
		$1.textfont = "" + $1.textfont; /*9376*/
		$1.textsize = +$1.textsize; /*9377*/
		$1.textyoffset = +$1.textyoffset; /*9378*/
		$1.height = +$1.height; /*9379*/
		$1.barchars = "0123456789ABCDEF"; /*9382*/
		$1.charvals = {}; /*9383*/
		for (var _9 = 0; _9 <= 15; _9 += 1) { /*9384*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*9384*/
		} /*9384*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*9391*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*9388*/
			if (!_J) { /*9390*/
				$k[$j++] = "bwipp.plesseyBadCharacter"; /*9389*/
				$k[$j++] = "Plessey must contain only digits and letters A B C D E F"; /*9389*/
				$0.raiseerror(); /*9389*/
			} /*9389*/
		} /*9389*/
		$k[$j++] = "barlen"; /*9393*/
		$k[$j++] = $1.barcode.length; /*9393*/
		if ($1.validatecheck) { /*9393*/
			var _M = $k[--$j]; /*9393*/
			$k[$j++] = _M - 2; /*9393*/
		} /*9393*/
		var _N = $k[--$j]; /*9393*/
		$1[$k[--$j]] = _N; /*9393*/
		$1.checkbits = $a(($1.barlen * 4) + 8); /*9396*/
		$puti($1.checkbits, $1.barlen * 4, $a([0, 0, 0, 0, 0, 0, 0, 0])); /*9397*/
		for (var _W = 0, _V = $1.barlen - 1; _W <= _V; _W += 1) { /*9407*/
			$1.i = _W; /*9399*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*9400*/
			$puti($1.checkbits, $1.i * 4, $a([$1.indx & 1, ($1.indx >>> 1) & 1, ($1.indx >>> 2) & 1, $1.indx >>> 3])); /*9406*/
		} /*9406*/
		$1.checksalt = $a([1, 1, 1, 1, 0, 1, 0, 0, 1]); /*9408*/
		for (var _m = 0, _l = ($1.barlen * 4) - 1; _m <= _l; _m += 1) { /*9417*/
			$1.i = _m; /*9410*/
			if ($get($1.checkbits, $1.i) == 1) { /*9416*/
				for (var _q = 0; _q <= 8; _q += 1) { /*9415*/
					$1.j = _q; /*9413*/
					$put($1.checkbits, $1.i + $1.j, $xo($get($1.checkbits, $1.i + $1.j), $get($1.checksalt, $1.j))); /*9414*/
				} /*9414*/
			} /*9414*/
		} /*9414*/
		$1.checkval = 0; /*9418*/
		for (var _11 = 0; _11 <= 7; _11 += 1) { /*9422*/
			$1.i = _11; /*9420*/
			$1.checkval = $1.checkval + ((~~Math.pow(2, $1.i)) * $get($1.checkbits, ($1.barlen * 4) + $1.i)); /*9421*/
		} /*9421*/
		$1.checksum1 = $1.checkval & 15; /*9423*/
		$1.checksum2 = $1.checkval >>> 4; /*9424*/
		if ($1.validatecheck) { /*9431*/
			if (($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) || ($get($1.barcode, $1.barlen + 1) != $get($1.barchars, $1.checksum2))) { /*9429*/
				$k[$j++] = "bwipp.plesseyBadCheckDigits"; /*9428*/
				$k[$j++] = "Incorrect Plessey check digits provided"; /*9428*/
				$0.raiseerror(); /*9428*/
			} /*9428*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*9430*/
		} /*9430*/
		$1.encs = $a(["14141414", "32141414", "14321414", "32321414", "14143214", "32143214", "14323214", "32323214", "14141432", "32141432", "14321432", "32321432", "14143232", "32143232", "14323232", "32323232", "32321432", "541412323", "323"]); /*9440*/
		var _1T = $1.unidirectional ? 27 : 33; /*9442*/
		$1.sbs = $s(($1.barlen * 8) + _1T); /*9442*/
		$1.txt = $a($1.barlen + 2); /*9443*/
		$puti($1.sbs, 0, $get($1.encs, 16)); /*9446*/
		for (var _1c = 0, _1b = $1.barlen - 1; _1c <= _1b; _1c += 1) { /*9453*/
			$1.i = _1c; /*9449*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*9450*/
			$puti($1.sbs, ($1.i * 8) + 8, $get($1.encs, $1.indx)); /*9451*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9452*/
		} /*9452*/
		$puti($1.sbs, ($1.barlen * 8) + 8, $get($1.encs, $1.checksum1)); /*9456*/
		$puti($1.sbs, ($1.barlen * 8) + 16, $get($1.encs, $1.checksum2)); /*9457*/
		if ($1.includecheckintext) { /*9463*/
			$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), ($1.barlen * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9459*/
			$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum2, 1), (($1.barlen + 1) * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9460*/
		} else { /*9463*/
			$put($1.txt, $1.barlen, $a([" ", ($1.barlen * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9462*/
			$put($1.txt, $1.barlen + 1, $a([" ", (($1.barlen + 1) * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9463*/
		} /*9463*/
		var _2k = $1.unidirectional ? 18 : 17; /*9467*/
		$puti($1.sbs, ($1.barlen * 8) + 24, $get($1.encs, _2k)); /*9467*/
		$k[$j++] = Infinity; /*9478*/
		$k[$j++] = "ren"; /*9473*/
		$k[$j++] = $0.renlinear; /*9473*/
		$k[$j++] = "sbs"; /*9473*/
		$k[$j++] = Infinity; /*9473*/
		var _2m = $1.sbs; /*9472*/
		for (var _2n = 0, _2o = _2m.length; _2n < _2o; _2n++) { /*9472*/
			$k[$j++] = $get(_2m, _2n) - 48; /*9472*/
		} /*9472*/
		var _2q = $a(); /*9473*/
		$k[$j++] = _2q; /*9474*/
		$k[$j++] = "bhs"; /*9474*/
		$k[$j++] = Infinity; /*9474*/
		for (var _2s = 0, _2t = ~~(($1.sbs.length + 1) / 2); _2s < _2t; _2s++) { /*9473*/
			$k[$j++] = $1.height; /*9473*/
		} /*9473*/
		var _2v = $a(); /*9474*/
		$k[$j++] = _2v; /*9475*/
		$k[$j++] = "bbs"; /*9475*/
		$k[$j++] = Infinity; /*9475*/
		for (var _2x = 0, _2y = ~~(($1.sbs.length + 1) / 2); _2x < _2y; _2x++) { /*9474*/
			$k[$j++] = 0; /*9474*/
		} /*9474*/
		var _2z = $a(); /*9475*/
		$k[$j++] = _2z; /*9477*/
		if ($1.includetext) { /*9477*/
			$k[$j++] = "txt"; /*9476*/
			$k[$j++] = $1.txt; /*9476*/
		} /*9476*/
		$k[$j++] = "opt"; /*9478*/
		$k[$j++] = $1.options; /*9478*/
		var _33 = $d(); /*9478*/
		$k[$j++] = _33; /*9481*/
		if (!$1.dontdraw) { /*9481*/
			$0.renlinear(); /*9481*/
		} /*9481*/
	};
	$0.telepen = function() {
		var $1 = {}; /*9508*/
		$1.options = $k[--$j]; /*9510*/
		$1.barcode = $k[--$j]; /*9511*/
		$1.numeric = false; /*9513*/
		$1.dontdraw = false; /*9514*/
		$1.includetext = false; /*9515*/
		$1.textfont = "Courier"; /*9516*/
		$1.textsize = 10; /*9517*/
		$1.textyoffset = -8.5; /*9518*/
		$1.height = 1; /*9519*/
		$1.parse = false; /*9520*/
		$forall($1.options, function() { /*9531*/
			var _3 = $k[--$j]; /*9531*/
			$1[$k[--$j]] = _3; /*9531*/
		}); /*9531*/
		$1.textfont = "" + $1.textfont; /*9533*/
		$1.textsize = +$1.textsize; /*9534*/
		$1.textyoffset = +$1.textyoffset; /*9535*/
		$1.height = +$1.height; /*9536*/
		$1.encs = $a(["31313131", "1131313111", "33313111", "1111313131", "3111313111", "11333131", "13133131", "111111313111", "31333111", "1131113131", "33113131", "1111333111", "3111113131", "1113133111", "1311133111", "111111113131", "3131113111", "11313331", "333331", "111131113111", "31113331", "1133113111", "1313113111", "1111113331", "31131331", "113111113111", "3311113111", "1111131331", "311111113111", "1113111331", "1311111331", "11111111113111", "31313311", "1131311131", "33311131", "1111313311", "3111311131", "11333311", "13133311", "111111311131", "31331131", "1131113311", "33113311", "1111331131", "3111113311", "1113131131", "1311131131", "111111113311", "3131111131", "1131131311", "33131311", "111131111131", "3111131311", "1133111131", "1313111131", "111111131311", "3113111311", "113111111131", "3311111131", "111113111311", "311111111131", "111311111311", "131111111311", "11111111111131", "3131311111", "11313133", "333133", "111131311111", "31113133", "1133311111", "1313311111", "1111113133", "313333", "113111311111", "3311311111", "11113333", "311111311111", "11131333", "13111333", "11111111311111", "31311133", "1131331111", "33331111", "1111311133", "3111331111", "11331133", "13131133", "111111331111", "3113131111", "1131111133", "33111133", "111113131111", "3111111133", "111311131111", "131111131111", "111111111133", "31311313", "113131111111", "3331111111", "1111311313", "311131111111", "11331313", "13131313", "11111131111111", "3133111111", "1131111313", "33111313", "111133111111", "3111111313", "111313111111", "131113111111", "111111111313", "313111111111", "1131131113", "33131113", "11113111111111", "3111131113", "113311111111", "131311111111", "111111131113", "3113111113", "11311111111111", "331111111111", "111113111113", "31111111111111", "111311111113", "131111111113", "1111111111111111"]); /*9593*/
		$1.barlen = $1.barcode.length; /*9595*/
		$1.sbs = $s(($1.barlen * 16) + 48); /*9596*/
		$1.txt = $a($1.barlen); /*9597*/
		$1.enc = $get($1.encs, 95); /*9600*/
		$puti($1.sbs, 0, $1.enc); /*9601*/
		$1.l = $1.enc.length; /*9602*/
		$1.checksum = 0; /*9604*/
		$1.i = 0; /*9605*/
		$1.j = 0; /*9605*/
		for (;;) { /*9637*/
			if ($1.i == $1.barlen) { /*9607*/
				break; /*9607*/
			} /*9607*/
			if ($1.numeric) { /*9630*/
				if ($get($1.barcode, $1.i) > 16) { /*9621*/
					$1.np = $geti($1.barcode, $1.i, 2); /*9610*/
					if ($eq($geti($1.np, 1, 1), "X")) { /*9614*/
						$1.indx = (~~$z($geti($1.np, 0, 1))) + 17; /*9612*/
					} else { /*9614*/
						$1.indx = (~~$z($1.np)) + 27; /*9614*/
					} /*9614*/
					$put($1.txt, $1.j, $a([$1.np, ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9616*/
					$1.i = $1.i + 2; /*9617*/
				} else { /*9621*/
					$1.indx = $get($1.barcode, $1.i); /*9619*/
					$put($1.txt, $1.j, $a([" ", ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9620*/
					$1.i = $1.i + 1; /*9621*/
				} /*9621*/
			} else { /*9630*/
				$1.indx = $get($1.barcode, $1.i); /*9624*/
				if (($1.indx >= 32) && ($1.indx <= 126)) { /*9628*/
					$put($1.txt, $1.j, $a([$geti($1.barcode, $1.i, 1), ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9626*/
				} else { /*9628*/
					$put($1.txt, $1.j, $a([" ", ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9628*/
				} /*9628*/
				$1.i = $1.i + 1; /*9630*/
			} /*9630*/
			$1.checksum = $1.checksum + $1.indx; /*9632*/
			$1.enc = $get($1.encs, $1.indx); /*9633*/
			$puti($1.sbs, $1.l, $1.enc); /*9634*/
			$1.l = $1.l + $1.enc.length; /*9635*/
			$1.j = $1.j + 1; /*9636*/
		} /*9636*/
		$1.checksum = (127 - ($1.checksum % 127)) % 127; /*9640*/
		$1.enc = $get($1.encs, $1.checksum); /*9641*/
		$puti($1.sbs, $1.l, $1.enc); /*9642*/
		$1.l = $1.l + $1.enc.length; /*9643*/
		$1.enc = $get($1.encs, 122); /*9646*/
		$puti($1.sbs, $1.l, $1.enc); /*9647*/
		$1.l = $1.l + $1.enc.length; /*9648*/
		$1.sbs = $geti($1.sbs, 0, $1.l); /*9651*/
		$1.txt = $geti($1.txt, 0, $1.j); /*9652*/
		$k[$j++] = Infinity; /*9663*/
		$k[$j++] = "ren"; /*9658*/
		$k[$j++] = $0.renlinear; /*9658*/
		$k[$j++] = "sbs"; /*9658*/
		$k[$j++] = Infinity; /*9658*/
		$forall($1.sbs, function() { /*9657*/
			var _1n = $k[--$j]; /*9657*/
			$k[$j++] = _1n - 48; /*9657*/
		}); /*9657*/
		var _1o = $a(); /*9658*/
		$k[$j++] = _1o; /*9659*/
		$k[$j++] = "bhs"; /*9659*/
		$k[$j++] = Infinity; /*9659*/
		for (var _1q = 0, _1r = ~~(($1.sbs.length + 1) / 2); _1q < _1r; _1q++) { /*9658*/
			$k[$j++] = $1.height; /*9658*/
		} /*9658*/
		var _1t = $a(); /*9659*/
		$k[$j++] = _1t; /*9660*/
		$k[$j++] = "bbs"; /*9660*/
		$k[$j++] = Infinity; /*9660*/
		for (var _1v = 0, _1w = ~~(($1.sbs.length + 1) / 2); _1v < _1w; _1v++) { /*9659*/
			$k[$j++] = 0; /*9659*/
		} /*9659*/
		var _1x = $a(); /*9660*/
		$k[$j++] = _1x; /*9662*/
		if ($1.includetext) { /*9662*/
			$k[$j++] = "txt"; /*9661*/
			$k[$j++] = $1.txt; /*9661*/
		} /*9661*/
		$k[$j++] = "opt"; /*9663*/
		$k[$j++] = $1.options; /*9663*/
		var _21 = $d(); /*9663*/
		$k[$j++] = _21; /*9666*/
		if (!$1.dontdraw) { /*9666*/
			$0.renlinear(); /*9666*/
		} /*9666*/
	};
	$0.telepennumeric = function() {
		var $1 = {}; /*9694*/
		$1.options = $k[--$j]; /*9696*/
		$1.barcode = $k[--$j]; /*9697*/
		$1.dontdraw = false; /*9699*/
		$1.includetext = false; /*9700*/
		$1.textfont = "Courier"; /*9701*/
		$1.textsize = 10; /*9702*/
		$1.textxoffset = 0; /*9703*/
		$1.textyoffset = -8.5; /*9704*/
		$1.height = 1; /*9705*/
		$forall($1.options, function() { /*9716*/
			var _3 = $k[--$j]; /*9716*/
			$1[$k[--$j]] = _3; /*9716*/
		}); /*9716*/
		$1.textfont = "" + $1.textfont; /*9718*/
		$1.textsize = +$1.textsize; /*9719*/
		$1.textxoffset = +$1.textxoffset; /*9720*/
		$1.textyoffset = +$1.textyoffset; /*9721*/
		$1.height = +$1.height; /*9722*/
		$1.options.dontdraw = true; /*9725*/
		$1.options.numeric = true; /*9726*/
		$k[$j++] = "args"; /*9728*/
		$k[$j++] = $1.barcode; /*9728*/
		$k[$j++] = $1.options; /*9728*/
		$0.telepen(); /*9728*/
		var _E = $k[--$j]; /*9728*/
		$1[$k[--$j]] = _E; /*9728*/
		$1.args.opt = $1.options; /*9730*/
		$k[$j++] = $1.args; /*9733*/
		if (!$1.dontdraw) { /*9733*/
			$0.renlinear(); /*9733*/
		} /*9733*/
	};
	$0.posicode = function() {
		var $1 = {}; /*9760*/
		$1.options = $k[--$j]; /*9762*/
		$1.barcode = $k[--$j]; /*9763*/
		$1.dontdraw = false; /*9765*/
		$1.includetext = false; /*9766*/
		$1.textfont = "Courier"; /*9767*/
		$1.textsize = 10; /*9768*/
		$1.textxoffset = 0; /*9769*/
		$1.textyoffset = -8.5; /*9770*/
		$1.height = 1; /*9771*/
		$1.encoding = "auto"; /*9772*/
		$1.version = "a"; /*9773*/
		$1.checkoffset = 0; /*9774*/
		$1.raw = false; /*9775*/
		$1.parse = false; /*9776*/
		$1.parsefnc = false; /*9777*/
		$forall($1.options, function() { /*9788*/
			var _3 = $k[--$j]; /*9788*/
			$1[$k[--$j]] = _3; /*9788*/
		}); /*9788*/
		$1.textfont = "" + $1.textfont; /*9790*/
		$1.textsize = +$1.textsize; /*9791*/
		$1.textxoffset = +$1.textxoffset; /*9792*/
		$1.textyoffset = +$1.textyoffset; /*9793*/
		$1.encoding = "" + $1.encoding; /*9794*/
		$1.version = "" + $1.version; /*9795*/
		$1.checkoffset = ~~$1.checkoffset; /*9796*/
		$1.height = +$1.height; /*9797*/
		$1.barlen = $1.barcode.length; /*9820*/
		$1.la0 = -1; /*9823*/
		$1.la1 = -2; /*9823*/
		$1.la2 = -3; /*9823*/
		$1.sf0 = -4; /*9824*/
		$1.sf1 = -5; /*9824*/
		$1.sf2 = -6; /*9824*/
		$1.fn1 = -7; /*9825*/
		$1.fn2 = -8; /*9825*/
		$1.fn3 = -9; /*9825*/
		$1.fn4 = -10; /*9825*/
		var _1m = {
			normal: $a([$a(["0", "^", "'"]), $a(["1", ";", 27]), $a(["2", "<", 28]), $a(["3", "=", 29]), $a(["4", ">", 30]), $a(["5", "?", 31]), $a(["6", "@", "!"]), $a(["7", "[", "\""]), $a(["8", 92, "#"]), $a(["9", "]", "&"]), $a(["A", "a", 1]), $a(["B", "b", 2]), $a(["C", "c", 3]), $a(["D", "d", 4]), $a(["E", "e", 5]), $a(["F", "f", 6]), $a(["G", "g", 7]), $a(["H", "h", 8]), $a(["I", "i", 9]), $a(["J", "j", 10]), $a(["K", "k", 11]), $a(["L", "l", 12]), $a(["M", "m", 13]), $a(["N", "n", 14]), $a(["O", "o", 15]), $a(["P", "p", 16]), $a(["Q", "q", 17]), $a(["R", "r", 18]), $a(["S", "s", 19]), $a(["T", "t", 20]), $a(["U", "u", 21]), $a(["V", "v", 22]), $a(["W", "w", 23]), $a(["X", "x", 24]), $a(["Y", "y", 25]), $a(["Z", "z", 26]), $a(["-", "_", 40]), $a([".", "`", 41]), $a([" ", 127, 0]), $a(["$", "{", "*"]), $a(["/", "|", ","]), $a(["+", "}", ":"]), $a(["%", "~", $1.fn1]), $a([$1.la1, $1.la0, $1.fn2]), $a([$1.sf1, $1.sf0, $1.fn3]), $a([$1.sf2, $1.sf2, $1.fn4])]),
			limited: $a([$a(["0", -98, -98]), $a(["1", -98, -98]), $a(["2", -98, -98]), $a(["3", -98, -98]), $a(["4", -98, -98]), $a(["5", -98, -98]), $a(["6", -98, -98]), $a(["7", -98, -98]), $a(["8", -98, -98]), $a(["9", -98, -98]), $a(["A", -98, -98]), $a(["B", -98, -98]), $a(["C", -98, -98]), $a(["D", -98, -98]), $a(["E", -98, -98]), $a(["F", -98, -98]), $a(["G", -98, -98]), $a(["H", -98, -98]), $a(["I", -98, -98]), $a(["J", -98, -98]), $a(["K", -98, -98]), $a(["L", -98, -98]), $a(["M", -98, -98]), $a(["N", -98, -98]), $a(["O", -98, -98]), $a(["P", -98, -98]), $a(["Q", -98, -98]), $a(["R", -98, -98]), $a(["S", -98, -98]), $a(["T", -98, -98]), $a(["U", -98, -98]), $a(["V", -98, -98]), $a(["W", -98, -98]), $a(["X", -98, -98]), $a(["Y", -98, -98]), $a(["Z", -98, -98]), $a(["-", -98, -98]), $a([".", -98, -98])])
		}; /*9863*/
		$k[$j++] = _1m; /*9866*/
		if ($eq($1.version, "a") || $eq($1.version, "b")) { /*9866*/
			$k[$j++] = "normal"; /*9866*/
		} else { /*9866*/
			$k[$j++] = "limited"; /*9866*/
		} /*9866*/
		var _1p = $k[--$j]; /*9866*/
		$1.charmaps = $get($k[--$j], _1p); /*9867*/
		var _1s = $1.charmaps; /*9871*/
		var _1t = $1.charmaps; /*9871*/
		var _1u = $1.charmaps; /*9871*/
		$1.charvals = $a([{}, {}, {}]); /*9872*/
		for (var _1y = 0, _1x = $1.charmaps.length - 1; _1y <= _1x; _1y += 1) { /*9881*/
			$1.i = _1y; /*9874*/
			$1.encs = $get($1.charmaps, $1.i); /*9875*/
			for (var _22 = 0; _22 <= 2; _22 += 1) { /*9880*/
				$1.j = _22; /*9877*/
				var _25 = $get($1.encs, $1.j); /*9878*/
				$k[$j++] = _25; /*9878*/
				if ($eq($type(_25), "stringtype")) { /*9878*/
					var _28 = $get($k[--$j], 0); /*9878*/
					$k[$j++] = _28; /*9878*/
				} /*9878*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*9879*/
			} /*9879*/
		} /*9879*/
		$1.set0 = $get($1.charvals, 0); /*9882*/
		$1.set1 = $get($1.charvals, 1); /*9883*/
		$1.set2 = $get($1.charvals, 2); /*9884*/
		if ($1.raw) { /*9886*/
			$1.encoding = "raw"; /*9886*/
		} /*9886*/
		if ($eq($1.encoding, "raw")) { /*9900*/
			$1.cws = $a($1.barlen); /*9889*/
			$1.i = 0; /*9890*/
			$1.j = 0; /*9890*/
			for (;;) { /*9897*/
				if ($1.i == $1.barlen) { /*9892*/
					break; /*9892*/
				} /*9892*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*9893*/
				$put($1.cws, $1.j, $1.cw); /*9894*/
				$1.i = $1.i + 4; /*9895*/
				$1.j = $1.j + 1; /*9896*/
			} /*9896*/
			$1.cws = $geti($1.cws, 0, $1.j); /*9898*/
			$1.text = ""; /*9899*/
		} /*9899*/
		if ($eq($1.encoding, "auto")) { /*10028*/
			var _2f = {
				FNC1: $1.fn1,
				FNC2: $1.fn2,
				FNC3: $1.fn3
			}; /*9907*/
			$1.fncvals = _2f; /*9909*/
			$1.msg = $a($1.barlen); /*9912*/
			$1.text = $s($1.barlen); /*9913*/
			$1.i = 0; /*9914*/
			$1.j = 0; /*9914*/
			for (;;) { /*9930*/
				if ($1.i == $1.barlen) { /*9915*/
					break; /*9915*/
				} /*9915*/
				$1.char = $get($1.barcode, $1.i); /*9916*/
				$put($1.text, $1.j, $1.char); /*9917*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*9926*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*9924*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*9920*/
						$puti($1.text, $1.j, " "); /*9921*/
						$1.i = $1.i + 4; /*9922*/
					} else { /*9924*/
						$1.i = $1.i + 1; /*9924*/
					} /*9924*/
				} /*9924*/
				$put($1.msg, $1.j, $1.char); /*9927*/
				$1.i = $1.i + 1; /*9928*/
				$1.j = $1.j + 1; /*9929*/
			} /*9929*/
			$1.msg = $geti($1.msg, 0, $1.j); /*9931*/
			$1.msglen = $1.msg.length; /*9932*/
			$1.text = $geti($1.text, 0, $1.j); /*9933*/
			$k[$j++] = Infinity; /*9936*/
			for (var _3L = 0, _3M = $1.msglen; _3L < _3M; _3L++) { /*9936*/
				$k[$j++] = 0; /*9936*/
			} /*9936*/
			$k[$j++] = 0; /*9936*/
			$1.numSA = $a(); /*9936*/
			$k[$j++] = Infinity; /*9937*/
			for (var _3P = 0, _3Q = $1.msglen; _3P < _3Q; _3P++) { /*9937*/
				$k[$j++] = 0; /*9937*/
			} /*9937*/
			$k[$j++] = 0; /*9937*/
			$1.numEA = $a(); /*9937*/
			for (var _3T = $1.msglen - 1; _3T >= 0; _3T -= 1) { /*9947*/
				$1.i = _3T; /*9939*/
				if ($get($1.msg, $1.i) >= 0) { /*9946*/
					if ($get($1.msg, $1.i) >= 128) { /*9944*/
						$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*9942*/
					} else { /*9944*/
						$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*9944*/
					} /*9944*/
				} /*9944*/
			} /*9944*/
			$1.ea = false; /*9950*/
			$1.msgtmp = $a([]); /*9950*/
			for (var _3n = 0, _3m = $1.msglen - 1; _3n <= _3m; _3n += 1) { /*9965*/
				$1.i = _3n; /*9952*/
				$1.c = $get($1.msg, $1.i); /*9953*/
				if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*9963*/
					if ($1.ea) { /*9955*/
						$k[$j++] = $1.numSA; /*9955*/
					} else { /*9955*/
						$k[$j++] = $1.numEA; /*9955*/
					} /*9955*/
					var _3z = $get($k[--$j], $1.i); /*9955*/
					var _42 = ((_3z + $1.i) == $1.msglen) ? 3 : 5; /*9956*/
					if (_3z < _42) { /*9961*/
						$k[$j++] = Infinity; /*9958*/
						$aload($1.msgtmp); /*9958*/
						$k[$j++] = $1.fn4; /*9958*/
						$1.msgtmp = $a(); /*9958*/
					} else { /*9961*/
						$k[$j++] = Infinity; /*9960*/
						$aload($1.msgtmp); /*9960*/
						$k[$j++] = $1.fn4; /*9960*/
						$k[$j++] = $1.fn4; /*9960*/
						$1.msgtmp = $a(); /*9960*/
						$1.ea = !$1.ea; /*9961*/
					} /*9961*/
				} /*9961*/
				$k[$j++] = Infinity; /*9964*/
				$aload($1.msgtmp); /*9964*/
				if ($1.c >= 0) { /*9964*/
					$k[$j++] = $1.c & 127; /*9964*/
				} else { /*9964*/
					$k[$j++] = $1.c; /*9964*/
				} /*9964*/
				$1.msgtmp = $a(); /*9964*/
			} /*9964*/
			$1.msg = $1.msgtmp; /*9966*/
			$1.msglen = $1.msg.length; /*9967*/
			$1.enc = function() {
				var _4I = $k[--$j]; /*9971*/
				$put($1.cws, $1.j, $get(_4I, $k[--$j])); /*9971*/
				$1.j = $1.j + 1; /*9972*/
			}; /*9973*/
			$1.cws = $a($1.msglen * 2); /*9975*/
			$1.i = 0; /*9976*/
			$1.j = 0; /*9976*/
			$1.cset = "set0"; /*9976*/
			for (;;) { /*10026*/
				if ($1.i == $1.msglen) { /*9978*/
					break; /*9978*/
				} /*9978*/
				for (;;) { /*10024*/
					$1.char1 = $get($1.msg, $1.i); /*9983*/
					$k[$j++] = "char2"; /*9984*/
					if (($1.i + 1) < $1.msglen) { /*9984*/
						$k[$j++] = $get($1.msg, $1.i + 1); /*9984*/
					} else { /*9984*/
						$k[$j++] = -99; /*9984*/
					} /*9984*/
					var _4a = $k[--$j]; /*9984*/
					$1[$k[--$j]] = _4a; /*9984*/
					var _4f = $get($1[$1.cset], $1.char1) !== undefined; /*9987*/
					if (_4f) { /*9991*/
						$k[$j++] = $1.char1; /*9988*/
						$k[$j++] = $1[$1.cset]; /*9988*/
						$1.enc(); /*9988*/
						$1.i = $1.i + 1; /*9989*/
						break; /*9990*/
					} /*9990*/
					var _4m = $get($1.set2, $1.char1) !== undefined; /*9994*/
					if (_4m) { /*9999*/
						$k[$j++] = $1.sf2; /*9995*/
						$k[$j++] = $1[$1.cset]; /*9995*/
						$1.enc(); /*9995*/
						$k[$j++] = $1.char1; /*9996*/
						$k[$j++] = $1.set2; /*9996*/
						$1.enc(); /*9996*/
						$1.i = $1.i + 1; /*9997*/
						break; /*9998*/
					} /*9998*/
					var _4w = $get($1[$1.cset], $1.char2) !== undefined; /*10002*/
					if (!_4w) { /*10020*/
						if ($eq($1.cset, "set0")) { /*10008*/
							$k[$j++] = $1.la1; /*10004*/
							$k[$j++] = $1[$1.cset]; /*10004*/
							$1.enc(); /*10004*/
							$1.cset = "set1"; /*10005*/
						} else { /*10008*/
							$k[$j++] = $1.la0; /*10007*/
							$k[$j++] = $1[$1.cset]; /*10007*/
							$1.enc(); /*10007*/
							$1.cset = "set0"; /*10008*/
						} /*10008*/
						break; /*10010*/
					} else { /*10020*/
						if ($eq($1.cset, "set0")) { /*10017*/
							$k[$j++] = $1.sf1; /*10013*/
							$k[$j++] = $1[$1.cset]; /*10013*/
							$1.enc(); /*10013*/
							$k[$j++] = $1.char1; /*10014*/
							$k[$j++] = $1.set1; /*10014*/
							$1.enc(); /*10014*/
						} else { /*10017*/
							$k[$j++] = $1.sf0; /*10016*/
							$k[$j++] = $1[$1.cset]; /*10016*/
							$1.enc(); /*10016*/
							$k[$j++] = $1.char1; /*10017*/
							$k[$j++] = $1.set0; /*10017*/
							$1.enc(); /*10017*/
						} /*10017*/
						$1.i = $1.i + 1; /*10019*/
						break; /*10020*/
					} /*10020*/
					break; /*10023*/
				} /*10023*/
			} /*10023*/
			$1.cws = $geti($1.cws, 0, $1.j); /*10027*/
		} /*10027*/
		var _5N = {
			a: $a(["141112", "131212", "121312", "111412", "131113", "121213", "111313", "121114", "111214", "111115", "181111", "171211", "161311", "151411", "141511", "131611", "121711", "111811", "171112", "161212", "151312", "141412", "131512", "121612", "111712", "161113", "151213", "141313", "131413", "121513", "111613", "151114", "141214", "131314", "121414", "111514", "141115", "131215", "121315", "111415", "131116", "121216", "111316", "121117", "111217", "111118", "1<111112", "111111111;1"]),
			b: $a(["151213", "141313", "131413", "121513", "141214", "131314", "121414", "131215", "121315", "121216", "191212", "181312", "171412", "161512", "151612", "141712", "131812", "121912", "181213", "171313", "161413", "151513", "141613", "131713", "121813", "171214", "161314", "151414", "141514", "131614", "121714", "161215", "151315", "141415", "131515", "121615", "151216", "141316", "131416", "121516", "141217", "131317", "121417", "131218", "121318", "121219", "1<121312", "121212121<1"]),
			limiteda: $a(["111411", "111312", "111213", "111114", "121311", "121212", "121113", "141111", "131211", "131112", "171111", "161211", "151311", "141411", "131511", "121611", "111711", "161112", "151212", "141312", "131412", "121512", "111612", "151113", "141213", "131313", "121413", "111513", "141114", "131214", "121314", "111414", "131115", "121215", "111315", "121116", "111216", "111117", "151111", "1"]),
			limitedb: $a(["121512", "121413", "121314", "121215", "131412", "131313", "131214", "151212", "141312", "141213", "181212", "171312", "161412", "151512", "141612", "131712", "121812", "171213", "161313", "151413", "141513", "131613", "121713", "161214", "151314", "141414", "131514", "121614", "151215", "141315", "131415", "121515", "141216", "131316", "121416", "131217", "121317", "121218", "141212", "1"])
		}; /*10074*/
		$1.encs = $get(_5N, $1.version); /*10077*/
		$1.c2w = $a([$a([495, 330, 210, 126, 70, 35, 15, 5]), $a([165, 120, 84, 56, 35, 20, 10, 4]), $a([45, 36, 28, 21, 15, 10, 6, 3]), $a([9, 8, 7, 6, 5, 4, 3, 2]), $a([1, 1, 1, 1, 1, 1, 1, 1])]); /*10085*/
		$1.v = 0; /*10086*/
		$forall($1.cws, function() { /*10096*/
			$1.cw = $k[--$j]; /*10088*/
			for (var _5Y = 0, _5Z = 6; _5Y < _5Z; _5Y++) { /*10095*/
				if ((($1.cw ^ $1.v) & 1) != 0) { /*10092*/
					$1.v = $1.v ^ 7682; /*10091*/
				} /*10091*/
				$1.v = $1.v >>> 1; /*10093*/
				$1.cw = $1.cw >>> 1; /*10094*/
			} /*10094*/
		}); /*10094*/
		$1.v = $1.v + $1.checkoffset; /*10097*/
		if ($eq($1.version, "limiteda") || $eq($1.version, "limitedb")) { /*10105*/
			$1.v = $1.v & 1023; /*10100*/
			if (($1.v > 824) && ($1.v < 853)) { /*10103*/
				$1.v = $1.v + 292; /*10102*/
			} /*10102*/
		} else { /*10105*/
			$1.v = ($1.v & 1023) + 45; /*10105*/
		} /*10105*/
		$1.d = $a([2, 2, 2, 2, 2, 2]); /*10108*/
		$1.r = 0; /*10109*/
		$1.c = 0; /*10109*/
		$1.w = 0; /*10109*/
		$1.sum = 0; /*10109*/
		for (;;) { /*10128*/
			if ($1.sum == $1.v) { /*10111*/
				break; /*10111*/
			} /*10111*/
			$1.t = $1.sum + $get($get($1.c2w, $1.r), $1.c); /*10112*/
			if ($1.t == $1.v) { /*10117*/
				$1.w = $1.w + 1; /*10114*/
				$put($1.d, $1.r, $1.w + 2); /*10115*/
				$1.sum = $1.t; /*10116*/
			} /*10116*/
			if ($1.t > $1.v) { /*10122*/
				$put($1.d, $1.r, $1.w + 2); /*10119*/
				$1.r = $1.r + 1; /*10120*/
				$1.w = 0; /*10121*/
			} /*10121*/
			if ($1.t < $1.v) { /*10127*/
				$1.c = $1.c + 1; /*10124*/
				$1.w = $1.w + 1; /*10125*/
				$1.sum = $1.t; /*10126*/
			} /*10126*/
		} /*10126*/
		$k[$j++] = 20; /*10129*/
		for (var _6F = 0; _6F <= 4; _6F += 1) { /*10129*/
			var _6I = $k[--$j]; /*10129*/
			$k[$j++] = _6I - $get($1.d, _6F); /*10129*/
		} /*10129*/
		$put($1.d, 5, $k[--$j]); /*10130*/
		if ($eq($1.version, "b") || $eq($1.version, "limitedb")) { /*10133*/
			$k[$j++] = Infinity; /*10132*/
			var _6N = $1.d; /*10132*/
			for (var _6O = 0, _6P = _6N.length; _6O < _6P; _6O++) { /*10132*/
				$k[$j++] = $get(_6N, _6O) + 1; /*10132*/
			} /*10132*/
			$1.d = $a(); /*10132*/
		} /*10132*/
		$1.cbs = $strcpy($s(12), "111111111111"); /*10134*/
		for (var _6U = 5; _6U >= 0; _6U -= 1) { /*10138*/
			$1.i = _6U; /*10136*/
			$put($1.cbs, ((5 - $1.i) * 2) + 1, $get($1.d, $1.i) + 47); /*10137*/
		} /*10137*/
		$1.sbs = $s(($1.cws.length * 6) + 31); /*10141*/
		var _6e = $get($1.encs, $1.encs.length - 2); /*10142*/
		$puti($1.sbs, 0, _6e); /*10143*/
		$1.j = _6e.length; /*10144*/
		for (var _6i = 0, _6h = $1.cws.length - 1; _6i <= _6h; _6i += 1) { /*10149*/
			$1.i = _6i; /*10146*/
			$puti($1.sbs, $1.j, $get($1.encs, $get($1.cws, $1.i))); /*10147*/
			$1.j = $1.j + 6; /*10148*/
		} /*10148*/
		$puti($1.sbs, $1.j, $1.cbs); /*10150*/
		$1.j = $1.j + 12; /*10151*/
		var _6x = $get($1.encs, $1.encs.length - 1); /*10152*/
		$puti($1.sbs, $1.j, _6x); /*10153*/
		$1.j = _6x.length + $1.j; /*10154*/
		$1.sbs = $geti($1.sbs, 0, $1.j); /*10155*/
		$k[$j++] = Infinity; /*10165*/
		$k[$j++] = "ren"; /*10161*/
		$k[$j++] = $0.renlinear; /*10161*/
		$k[$j++] = "sbs"; /*10161*/
		$k[$j++] = Infinity; /*10161*/
		$forall($1.sbs, function() { /*10160*/
			var _75 = $k[--$j]; /*10160*/
			$k[$j++] = _75 - 48; /*10160*/
		}); /*10160*/
		var _76 = $a(); /*10161*/
		$k[$j++] = _76; /*10162*/
		$k[$j++] = "bhs"; /*10162*/
		$k[$j++] = Infinity; /*10162*/
		for (var _78 = 0, _79 = ~~(($1.sbs.length + 1) / 2); _78 < _79; _78++) { /*10161*/
			$k[$j++] = $1.height; /*10161*/
		} /*10161*/
		var _7B = $a(); /*10162*/
		$k[$j++] = _7B; /*10163*/
		$k[$j++] = "bbs"; /*10163*/
		$k[$j++] = Infinity; /*10163*/
		for (var _7D = 0, _7E = ~~(($1.sbs.length + 1) / 2); _7D < _7E; _7D++) { /*10162*/
			$k[$j++] = 0; /*10162*/
		} /*10162*/
		var _7F = $a(); /*10163*/
		$k[$j++] = _7F; /*10165*/
		$k[$j++] = "txt"; /*10165*/
		$k[$j++] = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*10165*/
		$k[$j++] = "textxalign"; /*10165*/
		$k[$j++] = "center"; /*10165*/
		$k[$j++] = "opt"; /*10165*/
		$k[$j++] = $1.options; /*10165*/
		var _7O = $d(); /*10165*/
		$k[$j++] = _7O; /*10168*/
		if (!$1.dontdraw) { /*10168*/
			$0.renlinear(); /*10168*/
		} /*10168*/
	};
	$0.codablockf = function() {
		var $1 = {}; /*10195*/
		$1.options = $k[--$j]; /*10197*/
		$1.barcode = $k[--$j]; /*10198*/
		$1.dontdraw = false; /*10200*/
		$1.rows = -1; /*10201*/
		$1.columns = 8; /*10202*/
		$1.rowheight = 10; /*10203*/
		$1.sepheight = 1; /*10204*/
		$1.encoding = "auto"; /*10205*/
		$1.parse = false; /*10206*/
		$1.parsefnc = false; /*10207*/
		$forall($1.options, function() { /*10218*/
			var _3 = $k[--$j]; /*10218*/
			$1[$k[--$j]] = _3; /*10218*/
		}); /*10218*/
		$1.rows = ~~$1.rows; /*10220*/
		$1.columns = ~~$1.columns; /*10221*/
		$1.rowheight = ~~$1.rowheight; /*10222*/
		$1.sepheight = ~~$1.sepheight; /*10223*/
		if ((($1.columns >= 4) && ($1.columns <= 62)) && ((($1.rows >= 2) && ($1.rows <= 44)) || ($1.rows == -1))) { /*10226*/
			$1.c = $1.columns; /*10226*/
		} /*10226*/
		$1.barlen = $1.barcode.length; /*10249*/
		$1.swa = -1; /*10252*/
		$1.swb = -2; /*10252*/
		$1.swc = -3; /*10252*/
		$1.sft = -4; /*10252*/
		$1.fn1 = -5; /*10253*/
		$1.fn2 = -6; /*10253*/
		$1.fn3 = -7; /*10253*/
		$1.fn4 = -8; /*10253*/
		$1.sta = -9; /*10254*/
		$1.stp = -10; /*10254*/
		$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sft, $1.sft, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.sta, $1.sta, $1.sta]), $a([$1.stp, $1.stp, $1.stp])]); /*10294*/
		$1.charvals = $a([{}, {}, {}]); /*10297*/
		for (var _2O = 0, _2N = $1.charmaps.length - 1; _2O <= _2N; _2O += 1) { /*10306*/
			$1.i = _2O; /*10299*/
			$1.encs = $get($1.charmaps, $1.i); /*10300*/
			for (var _2S = 0; _2S <= 2; _2S += 1) { /*10305*/
				$1.j = _2S; /*10302*/
				var _2V = $get($1.encs, $1.j); /*10303*/
				$k[$j++] = _2V; /*10303*/
				if ($eq($type(_2V), "stringtype")) { /*10303*/
					var _2Y = $get($k[--$j], 0); /*10303*/
					$k[$j++] = _2Y; /*10303*/
				} /*10303*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*10304*/
			} /*10304*/
		} /*10304*/
		$1.seta = $get($1.charvals, 0); /*10307*/
		$1.setb = $get($1.charvals, 1); /*10308*/
		$1.setc = $get($1.charvals, 2); /*10309*/
		var _2m = {
			FNC1: $1.fn1,
			FNC3: $1.fn3
		}; /*10314*/
		$1.fncvals = _2m; /*10316*/
		$1.msg = $a($1.barlen); /*10317*/
		$1.i = 0; /*10318*/
		$1.j = 0; /*10318*/
		for (;;) { /*10332*/
			if ($1.i == $1.barlen) { /*10319*/
				break; /*10319*/
			} /*10319*/
			$1.char = $get($1.barcode, $1.i); /*10320*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*10328*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*10326*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*10323*/
					$1.i = $1.i + 4; /*10324*/
				} else { /*10326*/
					$1.i = $1.i + 1; /*10326*/
				} /*10326*/
			} /*10326*/
			$put($1.msg, $1.j, $1.char); /*10329*/
			$1.i = $1.i + 1; /*10330*/
			$1.j = $1.j + 1; /*10331*/
		} /*10331*/
		$1.msg = $geti($1.msg, 0, $1.j); /*10333*/
		$1.msglen = $1.msg.length; /*10334*/
		$1.msgtmp = $a([]); /*10337*/
		$forall($1.msg, function() { /*10341*/
			$1.char = $k[--$j]; /*10339*/
			$k[$j++] = Infinity; /*10340*/
			$aload($1.msgtmp); /*10340*/
			if ($1.char < 128) { /*10340*/
				$k[$j++] = $1.char; /*10340*/
			} else { /*10340*/
				$k[$j++] = $1.fn4; /*10340*/
				$k[$j++] = $1.char & 127; /*10340*/
			} /*10340*/
			$1.msgtmp = $a(); /*10340*/
		}); /*10340*/
		$1.msg = $1.msgtmp; /*10342*/
		$1.msglen = $1.msg.length; /*10343*/
		$1.numsscr = function() {
			$1.n = 0; /*10347*/
			$1.s = 0; /*10347*/
			$1.p = $k[--$j]; /*10348*/
			for (;;) { /*10359*/
				if ($1.p >= $1.msglen) { /*10349*/
					break; /*10349*/
				} /*10349*/
				var _3X = $get($1.msg, $1.p); /*10350*/
				var _3Z = $get($1.setc, _3X) !== undefined; /*10351*/
				$k[$j++] = _3X; /*10351*/
				if (!_3Z) { /*10351*/
					$j--; /*10351*/
					break; /*10351*/
				} /*10351*/
				if ($k[--$j] == $1.fn1) { /*10355*/
					if (($1.s % 2) == 0) { /*10354*/
						$1.s = $1.s + 1; /*10354*/
					} else { /*10354*/
						break; /*10354*/
					} /*10354*/
				} /*10354*/
				$1.n = $1.n + 1; /*10356*/
				$1.s = $1.s + 1; /*10357*/
				$1.p = $1.p + 1; /*10358*/
			} /*10358*/
			$k[$j++] = $1.n; /*10360*/
			$k[$j++] = $1.s; /*10360*/
		}; /*10361*/
		$1.enca = function() {
			$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*10365*/
			$1.j = $1.j + 1; /*10366*/
		}; /*10367*/
		$1.encb = function() {
			$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*10369*/
			$1.j = $1.j + 1; /*10370*/
		}; /*10371*/
		$1.encc = function() {
			var _3v = $k[--$j]; /*10373*/
			$k[$j++] = _3v; /*10377*/
			if ($ne($type(_3v), "arraytype")) { /*10376*/
				var _3z = $get($1.setc, $k[--$j]); /*10374*/
				$k[$j++] = _3z; /*10374*/
			} else { /*10376*/
				$aload($k[--$j]); /*10376*/
				var _41 = $k[--$j]; /*10376*/
				var _42 = $k[--$j]; /*10376*/
				$k[$j++] = (_41 - 48) + ((_42 - 48) * 10); /*10376*/
			} /*10376*/
			$put($1.cws, $1.j, $k[--$j]); /*10378*/
			$1.j = $1.j + 1; /*10379*/
		}; /*10380*/
		$1.anotb = function() {
			var _47 = $k[--$j]; /*10383*/
			var _49 = $get($1.seta, _47) !== undefined; /*10383*/
			var _4B = $get($1.setb, _47) !== undefined; /*10383*/
			$k[$j++] = _49 && (!_4B); /*10383*/
		}; /*10383*/
		$1.bnota = function() {
			var _4C = $k[--$j]; /*10384*/
			var _4E = $get($1.setb, _4C) !== undefined; /*10384*/
			var _4G = $get($1.seta, _4C) !== undefined; /*10384*/
			$k[$j++] = _4E && (!_4G); /*10384*/
		}; /*10384*/
		$k[$j++] = Infinity; /*10387*/
		for (var _4I = 0, _4J = $1.msg.length; _4I < _4J; _4I++) { /*10387*/
			$k[$j++] = 0; /*10387*/
		} /*10387*/
		$k[$j++] = 9999; /*10387*/
		$1.nextanotb = $a(); /*10387*/
		$k[$j++] = Infinity; /*10388*/
		for (var _4M = 0, _4N = $1.msg.length; _4M < _4N; _4M++) { /*10388*/
			$k[$j++] = 0; /*10388*/
		} /*10388*/
		$k[$j++] = 9999; /*10388*/
		$1.nextbnota = $a(); /*10388*/
		for (var _4Q = $1.msg.length - 1; _4Q >= 0; _4Q -= 1) { /*10401*/
			$1.i = _4Q; /*10390*/
			$k[$j++] = $get($1.msg, $1.i); /*10391*/
			$1.anotb(); /*10391*/
			if ($k[--$j]) { /*10394*/
				$put($1.nextanotb, $1.i, 0); /*10392*/
			} else { /*10394*/
				$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*10394*/
			} /*10394*/
			$k[$j++] = $get($1.msg, $1.i); /*10396*/
			$1.bnota(); /*10396*/
			if ($k[--$j]) { /*10399*/
				$put($1.nextbnota, $1.i, 0); /*10397*/
			} else { /*10399*/
				$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*10399*/
			} /*10399*/
		} /*10399*/
		$1.abeforeb = function() {
			var _4n = $k[--$j]; /*10404*/
			$k[$j++] = $lt($get($1.nextanotb, _4n), $get($1.nextbnota, _4n)); /*10404*/
		}; /*10404*/
		$1.bbeforea = function() {
			var _4s = $k[--$j]; /*10405*/
			$k[$j++] = $lt($get($1.nextbnota, _4s), $get($1.nextanotb, _4s)); /*10405*/
		}; /*10405*/
		$1.padrow = function() {
			for (var _4y = 0, _4z = $k[--$j]; _4y < _4z; _4y++) { /*10415*/
				for (;;) { /*10414*/
					if ($eq($1.cset, "seta")) { /*10411*/
						$k[$j++] = $1.swc; /*10411*/
						$1.enca(); /*10411*/
						$1.cset = "setc"; /*10411*/
						break; /*10411*/
					} /*10411*/
					if ($eq($1.cset, "setb")) { /*10412*/
						$k[$j++] = $1.swc; /*10412*/
						$1.encb(); /*10412*/
						$1.cset = "setc"; /*10412*/
						break; /*10412*/
					} /*10412*/
					if ($eq($1.cset, "setc")) { /*10413*/
						$k[$j++] = $1.swb; /*10413*/
						$1.encc(); /*10413*/
						$1.cset = "setb"; /*10413*/
						break; /*10413*/
					} /*10413*/
				} /*10413*/
			} /*10413*/
		}; /*10416*/
		$k[$j++] = "cws"; /*10419*/
		$k[$j++] = $1.c + 5; /*10419*/
		if ($1.rows != -1) { /*10419*/
			$k[$j++] = $1.rows; /*10419*/
		} else { /*10419*/
			$k[$j++] = 44; /*10419*/
		} /*10419*/
		var _59 = $k[--$j]; /*10419*/
		var _5B = $a($k[--$j] * _59); /*10419*/
		$1[$k[--$j]] = _5B; /*10419*/
		$1.i = 0; /*10421*/
		$1.j = 0; /*10421*/
		$1.r = 1; /*10421*/
		$1.lastrow = false; /*10422*/
		for (;;) { /*10590*/
			if ($1.lastrow) { /*10424*/
				break; /*10424*/
			} /*10424*/
			$k[$j++] = $1.sta; /*10427*/
			$1.enca(); /*10427*/
			if ($1.i < $1.msglen) { /*10428*/
				$k[$j++] = $1.i; /*10428*/
				$1.numsscr(); /*10428*/
			} else { /*10428*/
				$k[$j++] = -1; /*10428*/
				$k[$j++] = -1; /*10428*/
			} /*10428*/
			$1.nums = $k[--$j]; /*10428*/
			$1.nchars = $k[--$j]; /*10428*/
			for (;;) { /*10448*/
				if ($1.msglen == 0) { /*10434*/
					$k[$j++] = $1.swb; /*10431*/
					$1.enca(); /*10431*/
					$1.cset = "setb"; /*10432*/
					break; /*10433*/
				} /*10433*/
				if ($1.nums >= 2) { /*10439*/
					$k[$j++] = $1.swc; /*10436*/
					$1.enca(); /*10436*/
					$1.cset = "setc"; /*10437*/
					break; /*10438*/
				} /*10438*/
				$k[$j++] = $1.i; /*10440*/
				$1.abeforeb(); /*10440*/
				if ($k[--$j]) { /*10444*/
					$k[$j++] = $1.sft; /*10441*/
					$1.enca(); /*10441*/
					$1.cset = "seta"; /*10442*/
					break; /*10443*/
				} /*10443*/
				$k[$j++] = $1.swb; /*10445*/
				$1.enca(); /*10445*/
				$1.cset = "setb"; /*10446*/
				break; /*10447*/
			} /*10447*/
			$1.j = $1.j + 1; /*10449*/
			$1.endofrow = false; /*10452*/
			for (;;) { /*10575*/
				$1.rem = ($1.c + 3) - ($1.j % ($1.c + 5)); /*10453*/
				if (($1.i == $1.msglen) || $1.endofrow) { /*10455*/
					break; /*10455*/
				} /*10455*/
				$k[$j++] = $1.i; /*10457*/
				$1.numsscr(); /*10457*/
				$1.nums = $k[--$j]; /*10457*/
				$1.nchars = $k[--$j]; /*10457*/
				for (;;) { /*10573*/
					if ((($eq($1.cset, "seta") || $eq($1.cset, "setb")) && ($1.nums >= 4)) && ($get($1.msg, $1.i) != $1.fn1)) { /*10495*/
						if ((($1.nums % 2) == 0) && ($1.rem >= 3)) { /*10477*/
							$k[$j++] = $1.swc; /*10465*/
							if ($eq($1.cset, "seta")) { /*10465*/
								$1.enca(); /*10465*/
							} else { /*10465*/
								$1.encb(); /*10465*/
							} /*10465*/
							$1.cset = "setc"; /*10466*/
							for (var _5n = 0, _5o = 2; _5n < _5o; _5n++) { /*10475*/
								if ($get($1.msg, $1.i) == $1.fn1) { /*10473*/
									$k[$j++] = $1.fn1; /*10469*/
									$1.encc(); /*10469*/
									$1.i = $1.i + 1; /*10470*/
								} else { /*10473*/
									$k[$j++] = $geti($1.msg, $1.i, 2); /*10472*/
									$1.encc(); /*10472*/
									$1.i = $1.i + 2; /*10473*/
								} /*10473*/
							} /*10473*/
							break; /*10476*/
						} /*10476*/
						if ((($1.nums % 2) != 0) && ($1.rem >= 4)) { /*10494*/
							$k[$j++] = $get($1.msg, $1.i); /*10480*/
							if ($eq($1.cset, "seta")) { /*10480*/
								$1.enca(); /*10480*/
							} else { /*10480*/
								$1.encb(); /*10480*/
							} /*10480*/
							$1.i = $1.i + 1; /*10481*/
							$k[$j++] = $1.swc; /*10482*/
							if ($eq($1.cset, "seta")) { /*10482*/
								$1.enca(); /*10482*/
							} else { /*10482*/
								$1.encb(); /*10482*/
							} /*10482*/
							$1.cset = "setc"; /*10483*/
							for (var _68 = 0, _69 = 2; _68 < _69; _68++) { /*10492*/
								if ($get($1.msg, $1.i) == $1.fn1) { /*10490*/
									$k[$j++] = $1.fn1; /*10486*/
									$1.encc(); /*10486*/
									$1.i = $1.i + 1; /*10487*/
								} else { /*10490*/
									$k[$j++] = $geti($1.msg, $1.i, 2); /*10489*/
									$1.encc(); /*10489*/
									$1.i = $1.i + 2; /*10490*/
								} /*10490*/
							} /*10490*/
							break; /*10493*/
						} /*10493*/
					} /*10493*/
					$k[$j++] = $eq($1.cset, "setb"); /*10496*/
					$k[$j++] = $get($1.msg, $1.i); /*10496*/
					$1.anotb(); /*10496*/
					var _6O = $k[--$j]; /*10496*/
					if (($k[--$j] && _6O) && ($1.rem >= 2)) { /*10511*/
						if ($1.i < ($1.msglen - 1)) { /*10505*/
							$k[$j++] = $1.i + 1; /*10499*/
							$1.bbeforea(); /*10499*/
							if ($k[--$j]) { /*10504*/
								$k[$j++] = $1.sft; /*10500*/
								$1.encb(); /*10500*/
								$k[$j++] = $get($1.msg, $1.i); /*10501*/
								$1.enca(); /*10501*/
								$1.i = $1.i + 1; /*10502*/
								break; /*10503*/
							} /*10503*/
						} /*10503*/
						$k[$j++] = $1.swa; /*10506*/
						$1.encb(); /*10506*/
						$1.cset = "seta"; /*10507*/
						$k[$j++] = $get($1.msg, $1.i); /*10508*/
						$1.enca(); /*10508*/
						$1.i = $1.i + 1; /*10509*/
						break; /*10510*/
					} /*10510*/
					$k[$j++] = $eq($1.cset, "seta"); /*10512*/
					$k[$j++] = $get($1.msg, $1.i); /*10512*/
					$1.bnota(); /*10512*/
					var _6j = $k[--$j]; /*10512*/
					if (($k[--$j] && _6j) && ($1.rem >= 2)) { /*10527*/
						if ($1.i < ($1.msglen - 1)) { /*10521*/
							$k[$j++] = $1.i + 1; /*10515*/
							$1.abeforeb(); /*10515*/
							if ($k[--$j]) { /*10520*/
								$k[$j++] = $1.sft; /*10516*/
								$1.enca(); /*10516*/
								$k[$j++] = $get($1.msg, $1.i); /*10517*/
								$1.encb(); /*10517*/
								$1.i = $1.i + 1; /*10518*/
								break; /*10519*/
							} /*10519*/
						} /*10519*/
						$k[$j++] = $1.swb; /*10522*/
						$1.enca(); /*10522*/
						$1.cset = "setb"; /*10523*/
						$k[$j++] = $get($1.msg, $1.i); /*10524*/
						$1.encb(); /*10524*/
						$1.i = $1.i + 1; /*10525*/
						break; /*10526*/
					} /*10526*/
					if (($eq($1.cset, "setc") && ($1.nums < 2)) && ($1.rem >= 2)) { /*10542*/
						$k[$j++] = $1.i; /*10530*/
						$1.abeforeb(); /*10530*/
						if ($k[--$j]) { /*10536*/
							$k[$j++] = $1.swa; /*10531*/
							$1.encc(); /*10531*/
							$1.cset = "seta"; /*10532*/
							$k[$j++] = $get($1.msg, $1.i); /*10533*/
							$1.enca(); /*10533*/
							$1.i = $1.i + 1; /*10534*/
							break; /*10535*/
						} /*10535*/
						$k[$j++] = $1.swb; /*10537*/
						$1.encc(); /*10537*/
						$1.cset = "setb"; /*10538*/
						$k[$j++] = $get($1.msg, $1.i); /*10539*/
						$1.encb(); /*10539*/
						$1.i = $1.i + 1; /*10540*/
						break; /*10541*/
					} /*10541*/
					var _7K = $get($1.seta, $get($1.msg, $1.i)) !== undefined; /*10545*/
					if (($eq($1.cset, "seta") && _7K) && ($1.rem >= 1)) { /*10550*/
						$k[$j++] = $get($1.msg, $1.i); /*10547*/
						$1.enca(); /*10547*/
						$1.i = $1.i + 1; /*10548*/
						break; /*10549*/
					} /*10549*/
					var _7V = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*10551*/
					if (($eq($1.cset, "setb") && _7V) && ($1.rem >= 1)) { /*10556*/
						$k[$j++] = $get($1.msg, $1.i); /*10553*/
						$1.encb(); /*10553*/
						$1.i = $1.i + 1; /*10554*/
						break; /*10555*/
					} /*10555*/
					if (($eq($1.cset, "setc") && ($1.nums >= 2)) && ($1.rem >= 1)) { /*10567*/
						if ($get($1.msg, $1.i) == $1.fn1) { /*10564*/
							$k[$j++] = $1.fn1; /*10560*/
							$1.encc(); /*10560*/
							$1.i = $1.i + 1; /*10561*/
						} else { /*10564*/
							$k[$j++] = $geti($1.msg, $1.i, 2); /*10563*/
							$1.encc(); /*10563*/
							$1.i = $1.i + 2; /*10564*/
						} /*10564*/
						break; /*10566*/
					} /*10566*/
					$1.endofrow = true; /*10570*/
					break; /*10571*/
				} /*10571*/
			} /*10571*/
			if ((((($1.r == $1.rows) || ($1.rows == -1)) && ($1.r > 1)) && ($1.i == $1.msglen)) && ($1.rem >= 2)) { /*10587*/
				$k[$j++] = $1.rem - 2; /*10579*/
				$1.padrow(); /*10579*/
				$1.j = $1.j + 3; /*10580*/
				$k[$j++] = $1.stp; /*10581*/
				$1.enca(); /*10581*/
				$1.lastrow = true; /*10582*/
			} else { /*10587*/
				$k[$j++] = $1.rem; /*10584*/
				$1.padrow(); /*10584*/
				$1.j = $1.j + 1; /*10585*/
				$k[$j++] = $1.stp; /*10586*/
				$1.enca(); /*10586*/
				$1.r = $1.r + 1; /*10587*/
			} /*10587*/
		} /*10587*/
		$1.cws = $geti($1.cws, 0, $1.j); /*10591*/
		$k[$j++] = Infinity; /*10598*/
		for (var _85 = 64; _85 <= 95; _85 += 1) { /*10595*/
			$k[$j++] = _85; /*10595*/
		} /*10595*/
		for (var _86 = 0; _86 <= 15; _86 += 1) { /*10596*/
			$k[$j++] = _86; /*10596*/
		} /*10596*/
		for (var _87 = 26; _87 <= 63; _87 += 1) { /*10597*/
			$k[$j++] = _87; /*10597*/
		} /*10597*/
		$1.abmap = $a(); /*10598*/
		$k[$j++] = Infinity; /*10599*/
		for (var _89 = 0; _89 <= 85; _89 += 1) { /*10599*/
			$k[$j++] = _89; /*10599*/
		} /*10599*/
		$1.cmap = $a(); /*10599*/
		$1.chkmsg = $a($1.msglen); /*10602*/
		$1.j = 0; /*10603*/
		for (var _8F = 0, _8E = $1.msglen - 1; _8F <= _8E; _8F += 1) { /*10609*/
			$1.i = _8F; /*10605*/
			$1.char = $get($1.msg, $1.i); /*10606*/
			if ($1.char >= 0) { /*10607*/
				$put($1.chkmsg, $1.j, $1.char); /*10607*/
				$1.j = $1.j + 1; /*10607*/
			} /*10607*/
			if (($1.char == $1.fn1) && ($1.i != 0)) { /*10608*/
				$put($1.chkmsg, $1.j, 29); /*10608*/
				$1.j = $1.j + 1; /*10608*/
			} /*10608*/
		} /*10608*/
		$1.t1 = 0; /*10610*/
		$1.t2 = 0; /*10610*/
		$1.k1 = 0; /*10610*/
		$1.k2 = 0; /*10610*/
		for (var _8W = 0, _8V = $1.j - 1; _8W <= _8V; _8W += 1) { /*10617*/
			$1.i = _8W; /*10612*/
			$1.t1 = ($get($1.chkmsg, $1.i) * $1.i) % 86; /*10613*/
			$1.t2 = ($1.t1 + $get($1.chkmsg, $1.i)) % 86; /*10614*/
			$1.k1 = ($1.k1 + $1.t2) % 86; /*10615*/
			$1.k2 = ($1.k2 + $1.t1) % 86; /*10616*/
		} /*10616*/
		$k[$j++] = $1.cws; /*10618*/
		$k[$j++] = $1.cws.length - 4; /*10618*/
		if ($ne($1.cset, "setc")) { /*10618*/
			$k[$j++] = $1.abmap; /*10618*/
		} else { /*10618*/
			$k[$j++] = $1.cmap; /*10618*/
		} /*10618*/
		var _8q = $get($k[--$j], $1.k1); /*10618*/
		var _8r = $k[--$j]; /*10618*/
		$put($k[--$j], _8r, _8q); /*10618*/
		$k[$j++] = $1.cws; /*10619*/
		$k[$j++] = $1.cws.length - 3; /*10619*/
		if ($ne($1.cset, "setc")) { /*10619*/
			$k[$j++] = $1.abmap; /*10619*/
		} else { /*10619*/
			$k[$j++] = $1.cmap; /*10619*/
		} /*10619*/
		var _90 = $get($k[--$j], $1.k2); /*10619*/
		var _91 = $k[--$j]; /*10619*/
		$put($k[--$j], _91, _90); /*10619*/
		var _93 = $1.cws; /*10622*/
		$k[$j++] = _93; /*10622*/
		$k[$j++] = 2; /*10622*/
		if ($get(_93, 2 - 1) != 99) { /*10622*/
			$k[$j++] = $1.abmap; /*10622*/
		} else { /*10622*/
			$k[$j++] = $1.cmap; /*10622*/
		} /*10622*/
		var _99 = $get($k[--$j], $1.r - 2); /*10622*/
		var _9A = $k[--$j]; /*10622*/
		$put($k[--$j], _9A, _99); /*10622*/
		for (var _9E = 1, _9D = $1.r - 1; _9E <= _9D; _9E += 1) { /*10626*/
			$1.i = _9E; /*10624*/
			var _9F = $1.cws; /*10625*/
			var _9G = $1.i; /*10625*/
			var _9H = $1.c; /*10625*/
			$k[$j++] = _9F; /*10625*/
			$k[$j++] = (_9G * (_9H + 5)) + 2; /*10625*/
			if ($get(_9F, ((_9G * (_9H + 5)) + 2) - 1) != 99) { /*10625*/
				$k[$j++] = $1.abmap; /*10625*/
			} else { /*10625*/
				$k[$j++] = $1.cmap; /*10625*/
			} /*10625*/
			var _9N = $get($k[--$j], $1.i + 42); /*10625*/
			var _9O = $k[--$j]; /*10625*/
			$put($k[--$j], _9O, _9N); /*10625*/
		} /*10625*/
		for (var _9S = 0, _9R = $1.r - 1; _9S <= _9R; _9S += 1) { /*10637*/
			$1.rcws = $geti($1.cws, _9S * ($1.c + 5), $1.c + 4); /*10630*/
			$1.csum = $get($1.rcws, 0); /*10631*/
			for (var _9b = 1, _9a = $1.rcws.length - 2; _9b <= _9a; _9b += 1) { /*10635*/
				$1.i = _9b; /*10633*/
				$1.csum = $1.csum + ($get($1.rcws, $1.i) * $1.i); /*10634*/
			} /*10634*/
			$put($1.rcws, $1.rcws.length - 1, $1.csum % 103); /*10636*/
		} /*10636*/
		$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "2331112"]); /*10656*/
		$1.rowbits = $a($1.r); /*10659*/
		for (var _9p = 0, _9o = $1.r - 1; _9p <= _9o; _9p += 1) { /*10671*/
			$1.i = _9p; /*10661*/
			$k[$j++] = Infinity; /*10666*/
			$forall($geti($1.cws, $1.i * ($1.c + 5), $1.c + 5), function() { /*10665*/
				$forall($get($1.encs, $k[--$j]), function() { /*10664*/
					var _9y = $k[--$j]; /*10664*/
					$k[$j++] = _9y - 48; /*10664*/
				}); /*10664*/
			}); /*10664*/
			$1.sbs = $a(); /*10666*/
			$k[$j++] = Infinity; /*10667*/
			var _A0 = $1.sbs; /*10668*/
			$k[$j++] = 0; /*10668*/
			for (var _A1 = 0, _A2 = _A0.length; _A1 < _A2; _A1++) { /*10668*/
				var _A4 = $k[--$j]; /*10668*/
				var _A5 = (_A4 == 1) ? 0 : 1; /*10668*/
				$k[$j++] = _A4; /*10668*/
				for (var _A6 = 0, _A7 = $get(_A0, _A1); _A6 < _A7; _A6++) { /*10668*/
					$k[$j++] = _A5 /*10668*/
				} /*10668*/
			} /*10668*/
			$astore($a($counttomark() - 1)); /*10669*/
			var _AA = $k[--$j]; /*10669*/
			var _AB = $k[--$j]; /*10669*/
			var _AC = $k[--$j]; /*10669*/
			$put($1.rowbits, $1.i, _AA); /*10670*/
		} /*10670*/
		$1.symwid = ($1.c * 11) + 57; /*10674*/
		$k[$j++] = Infinity; /*10688*/
		for (var _AI = 0, _AJ = $1.symwid * $1.sepheight; _AI < _AJ; _AI++) { /*10676*/
			$k[$j++] = 1; /*10676*/
		} /*10676*/
		for (var _AM = 0, _AL = $1.r - 2; _AM <= _AL; _AM += 1) { /*10685*/
			$1.i = _AM; /*10678*/
			for (var _AO = 0, _AP = $1.rowheight; _AO < _AP; _AO++) { /*10679*/
				$aload($get($1.rowbits, $1.i)); /*10679*/
			} /*10679*/
			for (var _AU = 0, _AV = $1.sepheight; _AU < _AV; _AU++) { /*10684*/
				$k[$j++] = 1; /*10682*/
				$k[$j++] = 1; /*10682*/
				$k[$j++] = 0; /*10682*/
				$k[$j++] = 1; /*10682*/
				$k[$j++] = 0; /*10682*/
				$k[$j++] = 0; /*10682*/
				$k[$j++] = 0; /*10682*/
				$k[$j++] = 0; /*10682*/
				$k[$j++] = 1; /*10682*/
				$k[$j++] = 0; /*10682*/
				$k[$j++] = 0; /*10682*/
				for (var _AX = 0, _AY = $1.symwid - 24; _AX < _AY; _AX++) { /*10682*/
					$k[$j++] = 1; /*10682*/
				} /*10682*/
				$k[$j++] = 1; /*10683*/
				$k[$j++] = 1; /*10683*/
				$k[$j++] = 0; /*10683*/
				$k[$j++] = 0; /*10683*/
				$k[$j++] = 0; /*10683*/
				$k[$j++] = 1; /*10683*/
				$k[$j++] = 1; /*10683*/
				$k[$j++] = 1; /*10683*/
				$k[$j++] = 0; /*10683*/
				$k[$j++] = 1; /*10683*/
				$k[$j++] = 0; /*10683*/
				$k[$j++] = 1; /*10683*/
				$k[$j++] = 1; /*10683*/
			} /*10683*/
		} /*10683*/
		for (var _Aa = 0, _Ab = $1.rowheight; _Aa < _Ab; _Aa++) { /*10686*/
			$aload($get($1.rowbits, $1.r - 1)); /*10686*/
		} /*10686*/
		for (var _Ah = 0, _Ai = $1.symwid * $1.sepheight; _Ah < _Ai; _Ah++) { /*10687*/
			$k[$j++] = 1; /*10687*/
		} /*10687*/
		$1.pixs = $a(); /*10688*/
		var _As = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.symwid,
			pixy: ~~($1.pixs.length / $1.symwid),
			height: (~~($1.pixs.length / $1.symwid)) / 72,
			width: $1.symwid / 72,
			opt: $1.options
		}; /*10698*/
		$k[$j++] = _As; /*10701*/
		if (!$1.dontdraw) { /*10701*/
			$0.renmatrix(); /*10701*/
		} /*10701*/
	};
	$0.code16k = function() {
		var $1 = {}; /*10728*/
		$1.options = $k[--$j]; /*10730*/
		$1.barcode = $k[--$j]; /*10731*/
		$1.dontdraw = false; /*10733*/
		$1.mode = -1; /*10734*/
		$1.pos = -1; /*10735*/
		$1.rows = 0; /*10736*/
		$1.rowheight = 8; /*10737*/
		$1.sepheight = 1; /*10738*/
		$1.encoding = "auto"; /*10739*/
		$1.raw = false; /*10740*/
		$1.parse = false; /*10741*/
		$1.parsefnc = false; /*10742*/
		$forall($1.options, function() { /*10753*/
			var _3 = $k[--$j]; /*10753*/
			$1[$k[--$j]] = _3; /*10753*/
		}); /*10753*/
		$1.mode = ~~$1.mode; /*10755*/
		$1.pos = ~~$1.pos; /*10756*/
		$1.rows = ~~$1.rows; /*10757*/
		$1.rowheight = ~~$1.rowheight; /*10758*/
		$1.sepheight = ~~$1.sepheight; /*10759*/
		if ($1.pos != -1) { /*10761*/
			$1.rows = 16; /*10761*/
		} /*10761*/
		$1.barlen = $1.barcode.length; /*10784*/
		$1.swa = -1; /*10787*/
		$1.swb = -2; /*10787*/
		$1.swc = -3; /*10787*/
		$1.sa1 = -4; /*10788*/
		$1.sb1 = -5; /*10788*/
		$1.sc1 = -6; /*10788*/
		$1.sa2 = -7; /*10789*/
		$1.sb2 = -8; /*10789*/
		$1.sc2 = -9; /*10789*/
		$1.pad = -10; /*10790*/
		$1.sb3 = -11; /*10790*/
		$1.sc3 = -12; /*10790*/
		$1.fn1 = -13; /*10791*/
		$1.fn2 = -14; /*10791*/
		$1.fn3 = -15; /*10791*/
		$1.fn4 = -16; /*10791*/
		$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sb1, $1.sa1, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.pad, $1.pad, $1.pad]), $a([$1.sb2, $1.sa2, $1.sb1]), $a([$1.sc2, $1.sc2, $1.sb2]), $a([$1.sc3, $1.sc3, $1.sb3])]); /*10832*/
		$1.charvals = $a([{}, {}, {}]); /*10835*/
		for (var _2S = 0, _2R = $1.charmaps.length - 1; _2S <= _2R; _2S += 1) { /*10844*/
			$1.i = _2S; /*10837*/
			$1.encs = $get($1.charmaps, $1.i); /*10838*/
			for (var _2W = 0; _2W <= 2; _2W += 1) { /*10843*/
				$1.j = _2W; /*10840*/
				var _2Z = $get($1.encs, $1.j); /*10841*/
				$k[$j++] = _2Z; /*10841*/
				if ($eq($type(_2Z), "stringtype")) { /*10841*/
					var _2c = $get($k[--$j], 0); /*10841*/
					$k[$j++] = _2c; /*10841*/
				} /*10841*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*10842*/
			} /*10842*/
		} /*10842*/
		$1.seta = $get($1.charvals, 0); /*10845*/
		$1.setb = $get($1.charvals, 1); /*10846*/
		$1.setc = $get($1.charvals, 2); /*10847*/
		if ($1.raw) { /*10849*/
			$1.encoding = "raw"; /*10849*/
		} /*10849*/
		if ($eq($1.encoding, "raw")) { /*10863*/
			$1.cws = $a($1.barlen); /*10852*/
			$1.i = 0; /*10853*/
			$1.j = 0; /*10853*/
			for (;;) { /*10860*/
				if ($1.i == $1.barlen) { /*10855*/
					break; /*10855*/
				} /*10855*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*10856*/
				$put($1.cws, $1.j, $1.cw); /*10857*/
				$1.i = $1.i + 4; /*10858*/
				$1.j = $1.j + 1; /*10859*/
			} /*10859*/
			$1.cws = $geti($1.cws, 0, $1.j); /*10861*/
			$1.text = ""; /*10862*/
		} /*10862*/
		if ($eq($1.encoding, "auto")) { /*11326*/
			var _39 = {
				FNC1: $1.fn1,
				FNC2: $1.fn2,
				FNC3: $1.fn3
			}; /*10870*/
			$1.fncvals = _39; /*10872*/
			$1.msg = $a($1.barlen); /*10873*/
			$1.i = 0; /*10874*/
			$1.j = 0; /*10874*/
			for (;;) { /*10888*/
				if ($1.i == $1.barlen) { /*10875*/
					break; /*10875*/
				} /*10875*/
				$1.char = $get($1.barcode, $1.i); /*10876*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*10884*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*10882*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*10879*/
						$1.i = $1.i + 4; /*10880*/
					} else { /*10882*/
						$1.i = $1.i + 1; /*10882*/
					} /*10882*/
				} /*10882*/
				$put($1.msg, $1.j, $1.char); /*10885*/
				$1.i = $1.i + 1; /*10886*/
				$1.j = $1.j + 1; /*10887*/
			} /*10887*/
			$1.msg = $geti($1.msg, 0, $1.j); /*10889*/
			$1.msglen = $1.msg.length; /*10890*/
			$k[$j++] = Infinity; /*10893*/
			for (var _3f = 0, _3g = $1.msglen; _3f < _3g; _3f++) { /*10893*/
				$k[$j++] = 0; /*10893*/
			} /*10893*/
			$k[$j++] = 0; /*10893*/
			$1.numSA = $a(); /*10893*/
			$k[$j++] = Infinity; /*10894*/
			for (var _3j = 0, _3k = $1.msglen; _3j < _3k; _3j++) { /*10894*/
				$k[$j++] = 0; /*10894*/
			} /*10894*/
			$k[$j++] = 0; /*10894*/
			$1.numEA = $a(); /*10894*/
			for (var _3n = $1.msglen - 1; _3n >= 0; _3n -= 1) { /*10904*/
				$1.i = _3n; /*10896*/
				if ($get($1.msg, $1.i) >= 0) { /*10903*/
					if ($get($1.msg, $1.i) >= 128) { /*10901*/
						$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*10899*/
					} else { /*10901*/
						$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*10901*/
					} /*10901*/
				} /*10901*/
			} /*10901*/
			$1.ea = false; /*10907*/
			$1.msgtmp = $a([]); /*10907*/
			for (var _47 = 0, _46 = $1.msglen - 1; _47 <= _46; _47 += 1) { /*10922*/
				$1.i = _47; /*10909*/
				$1.c = $get($1.msg, $1.i); /*10910*/
				if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*10920*/
					if ($1.ea) { /*10912*/
						$k[$j++] = $1.numSA; /*10912*/
					} else { /*10912*/
						$k[$j++] = $1.numEA; /*10912*/
					} /*10912*/
					var _4J = $get($k[--$j], $1.i); /*10912*/
					var _4M = ((_4J + $1.i) == $1.msglen) ? 3 : 5; /*10913*/
					if (_4J < _4M) { /*10918*/
						$k[$j++] = Infinity; /*10915*/
						$aload($1.msgtmp); /*10915*/
						$k[$j++] = $1.fn4; /*10915*/
						$1.msgtmp = $a(); /*10915*/
					} else { /*10918*/
						$k[$j++] = Infinity; /*10917*/
						$aload($1.msgtmp); /*10917*/
						$k[$j++] = $1.fn4; /*10917*/
						$k[$j++] = $1.fn4; /*10917*/
						$1.msgtmp = $a(); /*10917*/
						$1.ea = !$1.ea; /*10918*/
					} /*10918*/
				} /*10918*/
				$k[$j++] = Infinity; /*10921*/
				$aload($1.msgtmp); /*10921*/
				if ($1.c >= 0) { /*10921*/
					$k[$j++] = $1.c & 127; /*10921*/
				} else { /*10921*/
					$k[$j++] = $1.c; /*10921*/
				} /*10921*/
				$1.msgtmp = $a(); /*10921*/
			} /*10921*/
			$1.msg = $1.msgtmp; /*10923*/
			$1.msglen = $1.msg.length; /*10924*/
			$1.numsscr = function() {
				$1.n = 0; /*10928*/
				$1.s = 0; /*10928*/
				$1.p = $k[--$j]; /*10929*/
				for (;;) { /*10940*/
					if ($1.p >= $1.msglen) { /*10930*/
						break; /*10930*/
					} /*10930*/
					var _4h = $get($1.msg, $1.p); /*10931*/
					var _4j = $get($1.setc, _4h) !== undefined; /*10932*/
					$k[$j++] = _4h; /*10932*/
					if (!_4j) { /*10932*/
						$j--; /*10932*/
						break; /*10932*/
					} /*10932*/
					if ($k[--$j] == $1.fn1) { /*10936*/
						if (($1.s % 2) == 0) { /*10935*/
							$1.s = $1.s + 1; /*10935*/
						} else { /*10935*/
							break; /*10935*/
						} /*10935*/
					} /*10935*/
					$1.n = $1.n + 1; /*10937*/
					$1.s = $1.s + 1; /*10938*/
					$1.p = $1.p + 1; /*10939*/
				} /*10939*/
				$k[$j++] = $1.n; /*10941*/
				$k[$j++] = $1.s; /*10941*/
			}; /*10942*/
			$1.enca = function() {
				$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*10946*/
				$1.j = $1.j + 1; /*10947*/
			}; /*10948*/
			$1.encb = function() {
				$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*10950*/
				$1.j = $1.j + 1; /*10951*/
			}; /*10952*/
			$1.encc = function() {
				var _55 = $k[--$j]; /*10954*/
				$k[$j++] = _55; /*10958*/
				if ($ne($type(_55), "arraytype")) { /*10957*/
					var _59 = $get($1.setc, $k[--$j]); /*10955*/
					$k[$j++] = _59; /*10955*/
				} else { /*10957*/
					$aload($k[--$j]); /*10957*/
					var _5B = $k[--$j]; /*10957*/
					var _5C = $k[--$j]; /*10957*/
					$k[$j++] = (_5B - 48) + ((_5C - 48) * 10); /*10957*/
				} /*10957*/
				$put($1.cws, $1.j, $k[--$j]); /*10959*/
				$1.j = $1.j + 1; /*10960*/
			}; /*10961*/
			$1.anotb = function() {
				var _5H = $k[--$j]; /*10964*/
				var _5J = $get($1.seta, _5H) !== undefined; /*10964*/
				var _5L = $get($1.setb, _5H) !== undefined; /*10964*/
				$k[$j++] = _5J && (!_5L); /*10964*/
			}; /*10964*/
			$1.bnota = function() {
				var _5M = $k[--$j]; /*10965*/
				var _5O = $get($1.setb, _5M) !== undefined; /*10965*/
				var _5Q = $get($1.seta, _5M) !== undefined; /*10965*/
				$k[$j++] = _5O && (!_5Q); /*10965*/
			}; /*10965*/
			$k[$j++] = Infinity; /*10968*/
			for (var _5S = 0, _5T = $1.msg.length; _5S < _5T; _5S++) { /*10968*/
				$k[$j++] = 0; /*10968*/
			} /*10968*/
			$k[$j++] = 9999; /*10968*/
			$1.nextanotb = $a(); /*10968*/
			$k[$j++] = Infinity; /*10969*/
			for (var _5W = 0, _5X = $1.msg.length; _5W < _5X; _5W++) { /*10969*/
				$k[$j++] = 0; /*10969*/
			} /*10969*/
			$k[$j++] = 9999; /*10969*/
			$1.nextbnota = $a(); /*10969*/
			for (var _5a = $1.msg.length - 1; _5a >= 0; _5a -= 1) { /*10982*/
				$1.i = _5a; /*10971*/
				$k[$j++] = $get($1.msg, $1.i); /*10972*/
				$1.anotb(); /*10972*/
				if ($k[--$j]) { /*10975*/
					$put($1.nextanotb, $1.i, 0); /*10973*/
				} else { /*10975*/
					$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*10975*/
				} /*10975*/
				$k[$j++] = $get($1.msg, $1.i); /*10977*/
				$1.bnota(); /*10977*/
				if ($k[--$j]) { /*10980*/
					$put($1.nextbnota, $1.i, 0); /*10978*/
				} else { /*10980*/
					$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*10980*/
				} /*10980*/
			} /*10980*/
			$1.abeforeb = function() {
				var _5x = $k[--$j]; /*10985*/
				$k[$j++] = $lt($get($1.nextanotb, _5x), $get($1.nextbnota, _5x)); /*10985*/
			}; /*10985*/
			$1.bbeforea = function() {
				var _62 = $k[--$j]; /*10986*/
				$k[$j++] = $lt($get($1.nextbnota, _62), $get($1.nextanotb, _62)); /*10986*/
			}; /*10986*/
			$1.cws = $a(($1.barcode.length * 2) + 3); /*10988*/
			$1.i = 0; /*10991*/
			$1.j = 0; /*10991*/
			for (;;) { /*11081*/
				if ($1.pos != -1) { /*11002*/
					$put($1.cws, 0, (~~($1.pos / 10)) - 1); /*10996*/
					$put($1.cws, 1, ($1.pos % 10) - 1); /*10997*/
					$1.j = 2; /*10998*/
					$1.cset = "setb"; /*10999*/
					$1.mode = 7; /*11000*/
					break; /*11001*/
				} /*11001*/
				if ($1.msglen == 0) { /*11008*/
					$1.cset = "setb"; /*11005*/
					$1.mode = 1; /*11006*/
					break; /*11007*/
				} /*11007*/
				if ($1.msglen >= 2) { /*11017*/
					$k[$j++] = $get($1.msg, 0) == $1.fn1; /*11011*/
					$k[$j++] = 1; /*11011*/
					$1.numsscr(); /*11011*/
					var _6J = $k[--$j]; /*11011*/
					var _6K = $k[--$j]; /*11011*/
					if ($k[--$j] && (_6J >= 2)) { /*11016*/
						$1.cset = "setc"; /*11012*/
						$1.mode = 4; /*11013*/
						$1.i = 1; /*11014*/
						break; /*11015*/
					} /*11015*/
				} /*11015*/
				if ($get($1.msg, 0) == $1.fn1) { /*11024*/
					$1.cset = "setb"; /*11020*/
					$1.mode = 3; /*11021*/
					$1.i = 1; /*11022*/
					break; /*11023*/
				} /*11023*/
				if ($1.msglen >= 2) { /*11070*/
					$k[$j++] = 0; /*11027*/
					$1.numsscr(); /*11027*/
					var _6Q = $k[--$j]; /*11027*/
					var _6R = $k[--$j]; /*11027*/
					if ((_6Q >= 2) && ((_6Q % 2) == 0)) { /*11031*/
						$1.cset = "setc"; /*11028*/
						$1.mode = 2; /*11029*/
						break; /*11030*/
					} /*11030*/
					$k[$j++] = 0; /*11033*/
					$1.numsscr(); /*11033*/
					var _6S = $k[--$j]; /*11033*/
					var _6T = $k[--$j]; /*11033*/
					if ((_6S >= 3) && ((_6S % 2) == 1)) { /*11039*/
						$k[$j++] = $get($1.msg, 0); /*11034*/
						$1.encb(); /*11034*/
						$1.cset = "setc"; /*11035*/
						$1.mode = 5; /*11036*/
						$1.i = 1; /*11037*/
						break; /*11038*/
					} /*11038*/
					var _6Z = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11041*/
					$k[$j++] = _6Z; /*11042*/
					$k[$j++] = 1; /*11042*/
					$1.numsscr(); /*11042*/
					var _6a = $k[--$j]; /*11042*/
					var _6b = $k[--$j]; /*11042*/
					if ($k[--$j] && ((_6a >= 2) && ((_6a % 2) == 0))) { /*11048*/
						$k[$j++] = $get($1.msg, 0); /*11043*/
						$1.encb(); /*11043*/
						$1.cset = "setc"; /*11044*/
						$1.mode = 5; /*11045*/
						$1.i = 1; /*11046*/
						break; /*11047*/
					} /*11047*/
					var _6i = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11050*/
					$k[$j++] = _6i; /*11051*/
					$k[$j++] = 1; /*11051*/
					$1.numsscr(); /*11051*/
					var _6j = $k[--$j]; /*11051*/
					var _6k = $k[--$j]; /*11051*/
					if ($k[--$j] && ((_6j >= 3) && ((_6j % 2) == 1))) { /*11058*/
						$k[$j++] = $get($1.msg, 0); /*11052*/
						$1.encb(); /*11052*/
						$k[$j++] = $get($1.msg, 1); /*11053*/
						$1.encb(); /*11053*/
						$1.cset = "setc"; /*11054*/
						$1.mode = 6; /*11055*/
						$1.i = 2; /*11056*/
						break; /*11057*/
					} /*11057*/
					var _6t = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11060*/
					var _6x = $get($1.setb, $get($1.msg, 1)) !== undefined; /*11061*/
					$k[$j++] = _6t && _6x; /*11062*/
					$k[$j++] = 2; /*11062*/
					$1.numsscr(); /*11062*/
					var _6y = $k[--$j]; /*11062*/
					var _6z = $k[--$j]; /*11062*/
					if ($k[--$j] && ((_6y >= 2) && ((_6y % 2) == 0))) { /*11069*/
						$k[$j++] = $get($1.msg, 0); /*11063*/
						$1.encb(); /*11063*/
						$k[$j++] = $get($1.msg, 1); /*11064*/
						$1.encb(); /*11064*/
						$1.cset = "setc"; /*11065*/
						$1.mode = 6; /*11066*/
						$1.i = 2; /*11067*/
						break; /*11068*/
					} /*11068*/
				} /*11068*/
				$k[$j++] = 0; /*11072*/
				$1.abeforeb(); /*11072*/
				if ($k[--$j]) { /*11076*/
					$1.cset = "seta"; /*11073*/
					$1.mode = 0; /*11074*/
					break; /*11075*/
				} /*11075*/
				$1.cset = "setb"; /*11078*/
				$1.mode = 1; /*11079*/
				break; /*11080*/
			} /*11080*/
			for (;;) { /*11324*/
				if ($1.i == $1.msglen) { /*11084*/
					break; /*11084*/
				} /*11084*/
				$k[$j++] = $1.i; /*11086*/
				$1.numsscr(); /*11086*/
				$1.nums = $k[--$j]; /*11086*/
				$1.nchars = $k[--$j]; /*11086*/
				for (;;) { /*11322*/
					if ($eq($1.cset, "seta")) { /*11163*/
						if ($1.i < ($1.msglen - 1)) { /*11100*/
							$k[$j++] = $get($1.msg, $1.i); /*11093*/
							$1.bnota(); /*11093*/
							$k[$j++] = $1.i + 1; /*11094*/
							$1.abeforeb(); /*11094*/
							var _7I = $k[--$j]; /*11094*/
							if (($k[--$j] && _7I)) { /*11099*/
								$k[$j++] = $1.sb1; /*11095*/
								$1.enca(); /*11095*/
								$k[$j++] = $get($1.msg, $1.i); /*11096*/
								$1.encb(); /*11096*/
								$1.i = $1.i + 1; /*11097*/
								break; /*11098*/
							} /*11098*/
						} /*11098*/
						if ($1.i < ($1.msglen - 2)) { /*11112*/
							$k[$j++] = $get($1.msg, $1.i); /*11103*/
							$1.bnota(); /*11103*/
							$k[$j++] = $get($1.msg, $1.i + 1); /*11104*/
							$1.bnota(); /*11104*/
							var _7X = $k[--$j]; /*11104*/
							var _7Y = $k[--$j]; /*11104*/
							$k[$j++] = $an(_7Y, _7X); /*11105*/
							$k[$j++] = $1.i + 2; /*11105*/
							$1.abeforeb(); /*11105*/
							var _7a = $k[--$j]; /*11105*/
							if (($k[--$j] && _7a)) { /*11111*/
								$k[$j++] = $1.sb2; /*11106*/
								$1.enca(); /*11106*/
								$k[$j++] = $get($1.msg, $1.i); /*11107*/
								$1.encb(); /*11107*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11108*/
								$1.encb(); /*11108*/
								$1.i = $1.i + 2; /*11109*/
								break; /*11110*/
							} /*11110*/
						} /*11110*/
						$k[$j++] = $get($1.msg, $1.i); /*11114*/
						$1.bnota(); /*11114*/
						if ($k[--$j]) { /*11118*/
							$k[$j++] = $1.swb; /*11115*/
							$1.enca(); /*11115*/
							$1.cset = "setb"; /*11116*/
							break; /*11117*/
						} /*11117*/
						if ($1.i < ($1.msglen - 4)) { /*11135*/
							var _7w = $get($1.seta, $get($1.msg, $1.i + 4)) !== undefined; /*11122*/
							if (($1.nums == 4) && _7w) { /*11134*/
								$k[$j++] = $1.sc2; /*11123*/
								$1.enca(); /*11123*/
								for (var _7y = 0, _7z = 2; _7y < _7z; _7y++) { /*11132*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*11130*/
										$k[$j++] = $1.fn1; /*11126*/
										$1.encc(); /*11126*/
										$1.i = $1.i + 1; /*11127*/
									} else { /*11130*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*11129*/
										$1.encc(); /*11129*/
										$1.i = $1.i + 2; /*11130*/
									} /*11130*/
								} /*11130*/
								break; /*11133*/
							} /*11133*/
						} /*11133*/
						if ($1.i < ($1.msglen - 6)) { /*11152*/
							var _8H = $get($1.seta, $get($1.msg, $1.i + 6)) !== undefined; /*11139*/
							if (($1.nums == 6) && _8H) { /*11151*/
								$k[$j++] = $1.sc3; /*11140*/
								$1.enca(); /*11140*/
								for (var _8J = 0, _8K = 3; _8J < _8K; _8J++) { /*11149*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*11147*/
										$k[$j++] = $1.fn1; /*11143*/
										$1.encc(); /*11143*/
										$1.i = $1.i + 1; /*11144*/
									} else { /*11147*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*11146*/
										$1.encc(); /*11146*/
										$1.i = $1.i + 2; /*11147*/
									} /*11147*/
								} /*11147*/
								break; /*11150*/
							} /*11150*/
						} /*11150*/
						if (($1.nums >= 4) && (($1.nums % 2) == 0)) { /*11158*/
							$k[$j++] = $1.swc; /*11155*/
							$1.enca(); /*11155*/
							$1.cset = "setc"; /*11156*/
							break; /*11157*/
						} /*11157*/
						$k[$j++] = $get($1.msg, $1.i); /*11160*/
						$1.enca(); /*11160*/
						$1.i = $1.i + 1; /*11161*/
						break; /*11162*/
					} /*11162*/
					if ($eq($1.cset, "setb")) { /*11237*/
						if ($1.i < ($1.msglen - 1)) { /*11174*/
							$k[$j++] = $get($1.msg, $1.i); /*11167*/
							$1.anotb(); /*11167*/
							$k[$j++] = $1.i + 1; /*11168*/
							$1.bbeforea(); /*11168*/
							var _8j = $k[--$j]; /*11168*/
							if (($k[--$j] && _8j)) { /*11173*/
								$k[$j++] = $1.sa1; /*11169*/
								$1.encb(); /*11169*/
								$k[$j++] = $get($1.msg, $1.i); /*11170*/
								$1.enca(); /*11170*/
								$1.i = $1.i + 1; /*11171*/
								break; /*11172*/
							} /*11172*/
						} /*11172*/
						if ($1.i < ($1.msglen - 2)) { /*11186*/
							$k[$j++] = $get($1.msg, $1.i); /*11177*/
							$1.anotb(); /*11177*/
							$k[$j++] = $get($1.msg, $1.i + 1); /*11178*/
							$1.anotb(); /*11178*/
							var _8y = $k[--$j]; /*11178*/
							var _8z = $k[--$j]; /*11178*/
							$k[$j++] = $an(_8z, _8y); /*11179*/
							$k[$j++] = $1.i + 2; /*11179*/
							$1.bbeforea(); /*11179*/
							var _91 = $k[--$j]; /*11179*/
							if (($k[--$j] && _91)) { /*11185*/
								$k[$j++] = $1.sa2; /*11180*/
								$1.encb(); /*11180*/
								$k[$j++] = $get($1.msg, $1.i); /*11181*/
								$1.enca(); /*11181*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11182*/
								$1.enca(); /*11182*/
								$1.i = $1.i + 2; /*11183*/
								break; /*11184*/
							} /*11184*/
						} /*11184*/
						$k[$j++] = $get($1.msg, $1.i); /*11188*/
						$1.anotb(); /*11188*/
						if ($k[--$j]) { /*11192*/
							$k[$j++] = $1.swa; /*11189*/
							$1.encb(); /*11189*/
							$1.cset = "seta"; /*11190*/
							break; /*11191*/
						} /*11191*/
						if ($1.i < ($1.msglen - 4)) { /*11209*/
							var _9N = $get($1.setb, $get($1.msg, $1.i + 4)) !== undefined; /*11196*/
							if (($1.nums == 4) && _9N) { /*11208*/
								$k[$j++] = $1.sc2; /*11197*/
								$1.encb(); /*11197*/
								for (var _9P = 0, _9Q = 2; _9P < _9Q; _9P++) { /*11206*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*11204*/
										$k[$j++] = $1.fn1; /*11200*/
										$1.encc(); /*11200*/
										$1.i = $1.i + 1; /*11201*/
									} else { /*11204*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*11203*/
										$1.encc(); /*11203*/
										$1.i = $1.i + 2; /*11204*/
									} /*11204*/
								} /*11204*/
								break; /*11207*/
							} /*11207*/
						} /*11207*/
						if ($1.i < ($1.msglen - 6)) { /*11226*/
							var _9i = $get($1.setb, $get($1.msg, $1.i + 6)) !== undefined; /*11213*/
							if (($1.nums == 6) && _9i) { /*11225*/
								$k[$j++] = $1.sc3; /*11214*/
								$1.encb(); /*11214*/
								for (var _9k = 0, _9l = 3; _9k < _9l; _9k++) { /*11223*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*11221*/
										$k[$j++] = $1.fn1; /*11217*/
										$1.encc(); /*11217*/
										$1.i = $1.i + 1; /*11218*/
									} else { /*11221*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*11220*/
										$1.encc(); /*11220*/
										$1.i = $1.i + 2; /*11221*/
									} /*11221*/
								} /*11221*/
								break; /*11224*/
							} /*11224*/
						} /*11224*/
						if (($1.nums >= 4) && (($1.nums % 2) == 0)) { /*11232*/
							$k[$j++] = $1.swc; /*11229*/
							$1.encb(); /*11229*/
							$1.cset = "setc"; /*11230*/
							break; /*11231*/
						} /*11231*/
						$k[$j++] = $get($1.msg, $1.i); /*11234*/
						$1.encb(); /*11234*/
						$1.i = $1.i + 1; /*11235*/
						break; /*11236*/
					} /*11236*/
					if ($eq($1.cset, "setc")) { /*11320*/
						if ($1.nums >= 2) { /*11249*/
							if ($get($1.msg, $1.i) == $1.fn1) { /*11246*/
								$k[$j++] = $1.fn1; /*11242*/
								$1.encc(); /*11242*/
								$1.i = $1.i + 1; /*11243*/
							} else { /*11246*/
								$k[$j++] = $geti($1.msg, $1.i, 2); /*11245*/
								$1.encc(); /*11245*/
								$1.i = $1.i + 2; /*11246*/
							} /*11246*/
							break; /*11248*/
						} /*11248*/
						if ($1.i < ($1.msglen - 1)) { /*11259*/
							var _AL = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11252*/
							$k[$j++] = _AL; /*11253*/
							$k[$j++] = $1.i + 1; /*11253*/
							$1.numsscr(); /*11253*/
							var _AN = $k[--$j]; /*11253*/
							var _AO = $k[--$j]; /*11253*/
							if ($k[--$j] && ((_AN >= 2) && ((_AN % 2) == 0))) { /*11258*/
								$k[$j++] = $1.sb1; /*11254*/
								$1.encc(); /*11254*/
								$k[$j++] = $get($1.msg, $1.i); /*11255*/
								$1.encb(); /*11255*/
								$1.i = $1.i + 1; /*11256*/
								break; /*11257*/
							} /*11257*/
						} /*11257*/
						if ($1.i < ($1.msglen - 1)) { /*11270*/
							var _Ab = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11262*/
							$k[$j++] = _Ab; /*11263*/
							$k[$j++] = $1.i + 1; /*11263*/
							$1.numsscr(); /*11263*/
							var _Ad = $k[--$j]; /*11263*/
							var _Ae = $k[--$j]; /*11263*/
							if ($k[--$j] && ((_Ad >= 3) && ((_Ad % 2) == 1))) { /*11269*/
								$k[$j++] = $1.sb2; /*11264*/
								$1.encc(); /*11264*/
								$k[$j++] = $get($1.msg, $1.i); /*11265*/
								$1.encb(); /*11265*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11266*/
								$1.encb(); /*11266*/
								$1.i = $1.i + 2; /*11267*/
								break; /*11268*/
							} /*11268*/
						} /*11268*/
						if ($1.i < ($1.msglen - 2)) { /*11282*/
							var _Au = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11273*/
							var _Az = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11274*/
							$k[$j++] = _Au && _Az; /*11275*/
							$k[$j++] = $1.i + 2; /*11275*/
							$1.numsscr(); /*11275*/
							var _B1 = $k[--$j]; /*11275*/
							var _B2 = $k[--$j]; /*11275*/
							if ($k[--$j] && ((_B1 >= 2) && ((_B1 % 2) == 0))) { /*11281*/
								$k[$j++] = $1.sb2; /*11276*/
								$1.encc(); /*11276*/
								$k[$j++] = $get($1.msg, $1.i); /*11277*/
								$1.encb(); /*11277*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11278*/
								$1.encb(); /*11278*/
								$1.i = $1.i + 2; /*11279*/
								break; /*11280*/
							} /*11280*/
						} /*11280*/
						if ($1.i < ($1.msglen - 3)) { /*11295*/
							var _BI = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11285*/
							var _BN = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11286*/
							$k[$j++] = _BI && _BN; /*11287*/
							$k[$j++] = $1.i + 2; /*11287*/
							$1.numsscr(); /*11287*/
							var _BP = $k[--$j]; /*11287*/
							var _BQ = $k[--$j]; /*11287*/
							if ($k[--$j] && ((_BP >= 3) && ((_BP % 2) == 1))) { /*11294*/
								$k[$j++] = $1.sb3; /*11288*/
								$1.encc(); /*11288*/
								$k[$j++] = $get($1.msg, $1.i); /*11289*/
								$1.encb(); /*11289*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11290*/
								$1.encb(); /*11290*/
								$k[$j++] = $get($1.msg, $1.i + 2); /*11291*/
								$1.encb(); /*11291*/
								$1.i = $1.i + 3; /*11292*/
								break; /*11293*/
							} /*11293*/
						} /*11293*/
						if ($1.i < ($1.msglen - 3)) { /*11309*/
							var _Bj = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11298*/
							var _Bo = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11299*/
							var _Bt = $get($1.setb, $get($1.msg, $1.i + 2)) !== undefined; /*11300*/
							$k[$j++] = (_Bj && _Bo) && _Bt; /*11301*/
							$k[$j++] = $1.i + 3; /*11301*/
							$1.numsscr(); /*11301*/
							var _Bv = $k[--$j]; /*11301*/
							var _Bw = $k[--$j]; /*11301*/
							if ($k[--$j] && ((_Bv >= 2) && ((_Bv % 2) == 0))) { /*11308*/
								$k[$j++] = $1.sb3; /*11302*/
								$1.encc(); /*11302*/
								$k[$j++] = $get($1.msg, $1.i); /*11303*/
								$1.encb(); /*11303*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11304*/
								$1.encb(); /*11304*/
								$k[$j++] = $get($1.msg, $1.i + 2); /*11305*/
								$1.encb(); /*11305*/
								$1.i = $1.i + 3; /*11306*/
								break; /*11307*/
							} /*11307*/
						} /*11307*/
						$k[$j++] = $1.i; /*11311*/
						$1.abeforeb(); /*11311*/
						if ($k[--$j]) { /*11315*/
							$k[$j++] = $1.swa; /*11312*/
							$1.encc(); /*11312*/
							$1.cset = "seta"; /*11313*/
							break; /*11314*/
						} /*11314*/
						$k[$j++] = $1.swb; /*11317*/
						$1.encc(); /*11317*/
						$1.cset = "setb"; /*11318*/
						break; /*11319*/
					} /*11319*/
					break; /*11321*/
				} /*11321*/
			} /*11321*/
			$1.cws = $geti($1.cws, 0, $1.j); /*11325*/
		} /*11325*/
		$1.metrics = $a([$a([2, 7]), $a([3, 12]), $a([4, 17]), $a([5, 22]), $a([6, 27]), $a([7, 32]), $a([8, 37]), $a([9, 42]), $a([10, 47]), $a([11, 52]), $a([12, 57]), $a([13, 62]), $a([14, 67]), $a([15, 72]), $a([16, 77])]); /*11346*/
		$1.urows = $1.rows; /*11349*/
		$1.i = 0; /*11350*/
		for (;;) { /*11360*/
			$1.m = $get($1.metrics, $1.i); /*11352*/
			$1.r = $get($1.m, 0); /*11353*/
			$1.dcws = $get($1.m, 1); /*11354*/
			$1.okay = true; /*11355*/
			if (($1.urows != 0) && ($1.urows != $1.r)) { /*11356*/
				$1.okay = false; /*11356*/
			} /*11356*/
			if ($1.cws.length > $1.dcws) { /*11357*/
				$1.okay = false; /*11357*/
			} /*11357*/
			if ($1.okay) { /*11358*/
				break; /*11358*/
			} /*11358*/
			$1.i = $1.i + 1; /*11359*/
		} /*11359*/
		$k[$j++] = Infinity; /*11363*/
		$aload($1.cws); /*11363*/
		for (var _Co = 0, _Cp = $1.dcws - $1.cws.length; _Co < _Cp; _Co++) { /*11363*/
			$k[$j++] = 103; /*11363*/
		} /*11363*/
		$1.cws = $a(); /*11363*/
		$k[$j++] = Infinity; /*11366*/
		$k[$j++] = (($1.r - 2) * 7) + $1.mode; /*11366*/
		$aload($1.cws); /*11366*/
		$1.cws = $a(); /*11366*/
		$k[$j++] = 0; /*11369*/
		for (var _Cx = 0, _Cw = $1.dcws; _Cx <= _Cw; _Cx += 1) { /*11369*/
			var _D0 = $k[--$j]; /*11369*/
			$k[$j++] = _D0 + ((_Cx + 2) * $get($1.cws, _Cx)); /*11369*/
		} /*11369*/
		$1.c1 = $k[--$j] % 107; /*11370*/
		$k[$j++] = 0; /*11371*/
		for (var _D4 = 0, _D3 = $1.dcws; _D4 <= _D3; _D4 += 1) { /*11371*/
			var _D7 = $k[--$j]; /*11371*/
			$k[$j++] = _D7 + ((_D4 + 1) * $get($1.cws, _D4)); /*11371*/
		} /*11371*/
		$1.c2 = ($k[--$j] + ($1.c1 * ($1.dcws + 2))) % 107; /*11372*/
		$k[$j++] = Infinity; /*11373*/
		$aload($1.cws); /*11373*/
		$k[$j++] = $1.c1; /*11373*/
		$k[$j++] = $1.c2; /*11373*/
		$1.cws = $a(); /*11373*/
		$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "211214", "211232", "211133"]); /*11393*/
		$1.startencs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112"]); /*11399*/
		$1.stopencsodd = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411"]); /*11403*/
		$1.stopencseven = $a(["2122", "1411", "1132", "1231", "1114", "3112", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411", "3211", "2221"]); /*11407*/
		if (($1.pos == -1) || (((~~($1.pos / 10)) % 2) == 1)) { /*11411*/
			$1.stopencs = $1.stopencsodd; /*11409*/
		} else { /*11411*/
			$1.stopencs = $1.stopencseven; /*11411*/
		} /*11411*/
		$1.rowbits = $a($1.r); /*11415*/
		for (var _DR = 0, _DQ = $1.r - 1; _DR <= _DQ; _DR += 1) { /*11432*/
			$1.i = _DR; /*11417*/
			$k[$j++] = Infinity; /*11427*/
			$k[$j++] = 10; /*11420*/
			$forall($get($1.startencs, $1.i), function() { /*11420*/
				var _DV = $k[--$j]; /*11420*/
				$k[$j++] = _DV - 48; /*11420*/
			}); /*11420*/
			$k[$j++] = 1; /*11424*/
			$forall($geti($1.cws, $1.i * 5, 5), function() { /*11424*/
				$forall($get($1.encs, $k[--$j]), function() { /*11423*/
					var _Dc = $k[--$j]; /*11423*/
					$k[$j++] = _Dc - 48; /*11423*/
				}); /*11423*/
			}); /*11423*/
			$forall($get($1.stopencs, $1.i), function() { /*11425*/
				var _Dg = $k[--$j]; /*11425*/
				$k[$j++] = _Dg - 48; /*11425*/
			}); /*11425*/
			$k[$j++] = 1; /*11426*/
			$1.sbs = $a(); /*11427*/
			$k[$j++] = Infinity; /*11428*/
			var _Di = $1.sbs; /*11429*/
			$k[$j++] = 1; /*11429*/
			for (var _Dj = 0, _Dk = _Di.length; _Dj < _Dk; _Dj++) { /*11429*/
				var _Dm = $k[--$j]; /*11429*/
				var _Dn = (_Dm == 0) ? 1 : 0; /*11429*/
				$k[$j++] = _Dm; /*11429*/
				for (var _Do = 0, _Dp = $get(_Di, _Dj); _Do < _Dp; _Do++) { /*11429*/
					$k[$j++] = _Dn /*11429*/
				} /*11429*/
			} /*11429*/
			$astore($a($counttomark() - 1)); /*11430*/
			var _Ds = $k[--$j]; /*11430*/
			var _Dt = $k[--$j]; /*11430*/
			var _Du = $k[--$j]; /*11430*/
			$put($1.rowbits, $1.i, _Ds); /*11431*/
		} /*11431*/
		$k[$j++] = Infinity; /*11444*/
		for (var _Dy = 0, _Dz = 81 * $1.sepheight; _Dy < _Dz; _Dy++) { /*11436*/
			$k[$j++] = 1; /*11436*/
		} /*11436*/
		for (var _E2 = 0, _E1 = $1.r - 2; _E2 <= _E1; _E2 += 1) { /*11441*/
			$1.i = _E2; /*11438*/
			for (var _E4 = 0, _E5 = $1.rowheight; _E4 < _E5; _E4++) { /*11439*/
				$aload($get($1.rowbits, $1.i)); /*11439*/
			} /*11439*/
			for (var _EA = 0, _EB = $1.sepheight; _EA < _EB; _EA++) { /*11440*/
				for (var _EC = 0, _ED = 10; _EC < _ED; _EC++) { /*11440*/
					$k[$j++] = 0; /*11440*/
				} /*11440*/
				for (var _EE = 0, _EF = 70; _EE < _EF; _EE++) { /*11440*/
					$k[$j++] = 1; /*11440*/
				} /*11440*/
				$k[$j++] = 0; /*11440*/
			} /*11440*/
		} /*11440*/
		for (var _EH = 0, _EI = $1.rowheight; _EH < _EI; _EH++) { /*11442*/
			$aload($get($1.rowbits, $1.r - 1)); /*11442*/
		} /*11442*/
		for (var _EN = 0, _EO = 81 * $1.sepheight; _EN < _EO; _EN++) { /*11443*/
			$k[$j++] = 1; /*11443*/
		} /*11443*/
		$1.pixs = $a(); /*11444*/
		var _EU = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: 81,
			pixy: ~~($1.pixs.length / 81),
			height: (~~($1.pixs.length / 81)) / 72,
			width: 81 / 72,
			opt: $1.options
		}; /*11454*/
		$k[$j++] = _EU; /*11457*/
		if (!$1.dontdraw) { /*11457*/
			$0.renmatrix(); /*11457*/
		} /*11457*/
	};
	$0.code49 = function() {
		var $1 = {}; /*11484*/
		$1.options = $k[--$j]; /*11486*/
		$1.barcode = $k[--$j]; /*11487*/
		$1.dontdraw = false; /*11489*/
		$1.mode = -1; /*11490*/
		$1.pos = -1; /*11491*/
		$1.rows = 0; /*11492*/
		$1.rowheight = 8; /*11493*/
		$1.sepheight = 1; /*11494*/
		$1.parse = false; /*11495*/
		$1.parsefnc = false; /*11496*/
		$forall($1.options, function() { /*11507*/
			var _3 = $k[--$j]; /*11507*/
			$1[$k[--$j]] = _3; /*11507*/
		}); /*11507*/
		$1.mode = ~~$1.mode; /*11509*/
		$1.pos = ~~$1.pos; /*11510*/
		$1.rows = ~~$1.rows; /*11511*/
		$1.rowheight = ~~$1.rowheight; /*11512*/
		$1.sepheight = ~~$1.sepheight; /*11513*/
		$1.barlen = $1.barcode.length; /*11536*/
		$1.s1 = -1; /*11539*/
		$1.s2 = -2; /*11539*/
		$1.fn1 = -3; /*11539*/
		$1.fn2 = -4; /*11539*/
		$1.fn3 = -5; /*11539*/
		$1.ns = -6; /*11539*/
		var _E = {
			FNC1: $1.fn1,
			FNC2: $1.fn2,
			FNC3: $1.fn3
		}; /*11543*/
		$1.fncvals = _E; /*11544*/
		$1.msg = $a($1.barlen); /*11545*/
		$1.i = 0; /*11546*/
		$1.j = 0; /*11546*/
		for (;;) { /*11560*/
			if ($1.i == $1.barlen) { /*11547*/
				break; /*11547*/
			} /*11547*/
			$1.char = $get($1.barcode, $1.i); /*11548*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*11556*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*11554*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*11551*/
					$1.i = $1.i + 4; /*11552*/
				} else { /*11554*/
					$1.i = $1.i + 1; /*11554*/
				} /*11554*/
			} /*11554*/
			$put($1.msg, $1.j, $1.char); /*11557*/
			$1.i = $1.i + 1; /*11558*/
			$1.j = $1.j + 1; /*11559*/
		} /*11559*/
		$1.msg = $geti($1.msg, 0, $1.j); /*11561*/
		$1.msglen = $1.msg.length; /*11562*/
		$1.charmap = $a(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", $1.s1, $1.s2, $1.fn1, $1.fn2, $1.fn3, $1.ns]); /*11571*/
		$1.charvals = {}; /*11574*/
		for (var _q = 0; _q <= 48; _q += 1) { /*11580*/
			$1.i = _q; /*11576*/
			var _t = $get($1.charmap, $1.i); /*11577*/
			$k[$j++] = _t; /*11578*/
			if ($eq($type(_t), "stringtype")) { /*11578*/
				var _w = $get($k[--$j], 0); /*11578*/
				$k[$j++] = _w; /*11578*/
			} /*11578*/
			$put($1.charvals, $k[--$j], $1.i); /*11579*/
		} /*11579*/
		$1.combos = $a(["1 ", "1A", "1B", "1C", "1D", "1E", "1F", "1G", "1H", "1I", "1J", "1K", "1L", "1M", "1N", "1O", "1P", "1Q", "1R", "1S", "1T", "1U", "1V", "1W", "1X", "1Y", "1Z", "11", "12", "13", "14", "15", "  ", "16", "17", "18", " $", " %", "19", "10", "1-", "1.", "1$", " +", "1/", " -", " .", " /", " 0", " 1", " 2", " 3", " 4", " 5", " 6", " 7", " 8", " 9", "1+", "21", "22", "23", "24", "25", "26", " A", " B", " C", " D", " E", " F", " G", " H", " I", " J", " K", " L", " M", " N", " O", " P", " Q", " R", " S", " T", " U", " V", " W", " X", " Y", " Z", "27", "28", "29", "20", "2-", "2.", "2A", "2B", "2C", "2D", "2E", "2F", "2G", "2H", "2I", "2J", "2K", "2L", "2M", "2N", "2O", "2P", "2Q", "2R", "2S", "2T", "2U", "2V", "2W", "2X", "2Y", "2Z", "2$", "2/", "2+", "2%", "2 "]); /*11592*/
		for (var _11 = 0; _11 <= 127; _11 += 1) { /*11602*/
			$1.i = _11; /*11594*/
			var _14 = $get($1.combos, $1.i); /*11595*/
			$1.c1 = $get(_14, 0); /*11595*/
			$1.c2 = $get(_14, 1); /*11595*/
			if ($1.c1 == 49) { /*11598*/
				$put($1.charvals, $1.i, $a([$get($1.charvals, $1.s1), $get($1.charvals, $1.c2)])); /*11597*/
			} /*11597*/
			if ($1.c1 == 50) { /*11601*/
				$put($1.charvals, $1.i, $a([$get($1.charvals, $1.s2), $get($1.charvals, $1.c2)])); /*11600*/
			} /*11600*/
		} /*11600*/
		$1.encodealpha = function() {
			var _1T = $get($1.charvals, $k[--$j]); /*11605*/
			$k[$j++] = _1T; /*11606*/
			if ($ne($type(_1T), "arraytype")) { /*11606*/
				$astore($a(1)); /*11606*/
			} /*11606*/
			var _1W = $k[--$j]; /*11607*/
			$puti($1.cws, $1.j, _1W); /*11607*/
			$1.j = _1W.length + $1.j; /*11608*/
		}; /*11609*/
		$1.base48 = function() {
			var _1a = $k[--$j]; /*11612*/
			$k[$j++] = 0; /*11612*/
			$forall(_1a, function() { /*11612*/
				var _1b = $k[--$j]; /*11612*/
				var _1c = $k[--$j]; /*11612*/
				$k[$j++] = (_1b - 48) + (_1c * 10); /*11612*/
			}); /*11612*/
			$k[$j++] = Infinity; /*11613*/
			var _1d = $k[--$j]; /*11613*/
			var _1e = $k[--$j]; /*11613*/
			var _1f = $k[--$j]; /*11613*/
			$k[$j++] = _1d; /*11613*/
			$k[$j++] = _1e; /*11613*/
			for (var _1g = 0, _1h = _1f - 1; _1g < _1h; _1g++) { /*11613*/
				var _1i = $k[--$j]; /*11613*/
				$k[$j++] = _1i % 48; /*11613*/
				$k[$j++] = ~~(_1i / 48); /*11613*/
			} /*11613*/
			var _1j = $a(); /*11613*/
			$k[$j++] = _1j; /*11614*/
			$k[$j++] = Infinity; /*11614*/
			var _1k = $k[--$j]; /*11614*/
			var _1l = $k[--$j]; /*11614*/
			$k[$j++] = _1k; /*11614*/
			$k[$j++] = _1l; /*11614*/
			for (var _1m = _1l.length - 1; _1m >= 0; _1m -= 1) { /*11614*/
				var _1n = $k[--$j]; /*11614*/
				$k[$j++] = $get(_1n, _1m); /*11614*/
				$k[$j++] = _1n; /*11614*/
			} /*11614*/
			$j--; /*11614*/
			var _1p = $a(); /*11614*/
			$puti($1.cws, $1.j, _1p); /*11615*/
			$1.j = _1p.length + $1.j; /*11616*/
		}; /*11617*/
		$1.encodenumeric = function() {
			$1.nums = $k[--$j]; /*11620*/
			var _1v = $1.nums.length; /*11621*/
			var _1w = _1v % 5; /*11621*/
			$k[$j++] = "pre"; /*11621*/
			$k[$j++] = _1v; /*11621*/
			$k[$j++] = _1w; /*11621*/
			if (_1w != 2) { /*11621*/
				var _1x = $k[--$j]; /*11621*/
				var _1y = $k[--$j]; /*11621*/
				$k[$j++] = _1y - _1x; /*11621*/
			} else { /*11621*/
				var _1z = $k[--$j]; /*11621*/
				var _20 = $k[--$j]; /*11621*/
				$k[$j++] = (_20 - _1z) - 5; /*11621*/
			} /*11621*/
			var _21 = $k[--$j]; /*11621*/
			$1[$k[--$j]] = _21; /*11621*/
			for (var _25 = 0, _24 = $1.pre - 1; _25 <= _24; _25 += 5) { /*11622*/
				$k[$j++] = 3; /*11622*/
				$k[$j++] = $geti($1.nums, _25, 5); /*11622*/
				$1.base48(); /*11622*/
			} /*11622*/
			$1.nums = $geti($1.nums, $1.pre, $1.nums.length - $1.pre); /*11623*/
			var _2E = $1.nums.length; /*11625*/
			$k[$j++] = _2E; /*11625*/
			if (_2E == 1) { /*11625*/
				$k[$j++] = $get($1.nums, $1.i); /*11625*/
				$1.encodealpha(); /*11625*/
			} /*11625*/
			var _2I = $k[--$j]; /*11626*/
			$k[$j++] = _2I; /*11626*/
			if (_2I == 3) { /*11626*/
				$k[$j++] = 2; /*11626*/
				$k[$j++] = $1.nums; /*11626*/
				$1.base48(); /*11626*/
			} /*11626*/
			var _2K = $k[--$j]; /*11627*/
			$k[$j++] = _2K; /*11627*/
			if (_2K == 4) { /*11627*/
				$k[$j++] = 3; /*11627*/
				$k[$j++] = Infinity; /*11627*/
				$k[$j++] = 49; /*11627*/
				$k[$j++] = 48; /*11627*/
				$aload($1.nums); /*11627*/
				var _2M = $a(); /*11627*/
				$k[$j++] = _2M; /*11627*/
				$1.base48(); /*11627*/
			} /*11627*/
			if ($k[--$j] == 7) { /*11631*/
				$k[$j++] = 3; /*11629*/
				$k[$j++] = Infinity; /*11629*/
				$k[$j++] = 49; /*11629*/
				$k[$j++] = 48; /*11629*/
				$aload($geti($1.nums, 0, 4)); /*11629*/
				var _2Q = $a(); /*11629*/
				$k[$j++] = _2Q; /*11629*/
				$1.base48(); /*11629*/
				$k[$j++] = 2; /*11630*/
				$k[$j++] = $geti($1.nums, 4, 3); /*11630*/
				$1.base48(); /*11630*/
			} /*11630*/
		}; /*11632*/
		$k[$j++] = Infinity; /*11635*/
		for (var _2U = 0, _2V = $1.msglen; _2U < _2V; _2U++) { /*11635*/
			$k[$j++] = 0; /*11635*/
		} /*11635*/
		$k[$j++] = 0; /*11635*/
		$1.numericruns = $a(); /*11635*/
		for (var _2Y = $1.msglen - 1; _2Y >= 0; _2Y -= 1) { /*11644*/
			$1.i = _2Y; /*11637*/
			var _2b = $get($1.msg, $1.i); /*11638*/
			if ((_2b >= 48) && (_2b <= 57)) { /*11642*/
				$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 1) + 1); /*11640*/
			} else { /*11642*/
				$put($1.numericruns, $1.i, 0); /*11642*/
			} /*11642*/
		} /*11642*/
		if ($1.mode == -1) { /*11656*/
			for (;;) { /*11655*/
				if ($1.pos != -1) { /*11649*/
					$1.mode = 3; /*11649*/
					break; /*11649*/
				} /*11649*/
				if ($get($1.numericruns, 0) >= 5) { /*11650*/
					$1.mode = 2; /*11650*/
					break; /*11650*/
				} /*11650*/
				var _2q = $get($1.charvals, $get($1.msg, 0)); /*11651*/
				$k[$j++] = _2q; /*11652*/
				if ($ne($type(_2q), "arraytype")) { /*11652*/
					$j--; /*11652*/
					$1.mode = 0; /*11652*/
					break; /*11652*/
				} /*11652*/
				var _2u = ($get($k[--$j], 0) == 43) ? 4 : 5; /*11653*/
				$1.mode = _2u; /*11653*/
				break; /*11654*/
			} /*11654*/
		} /*11654*/
		$1.cws = $a(($1.msglen * 2) + 1); /*11658*/
		$1.method = "alpha"; /*11659*/
		$1.i = -1; /*11659*/
		$1.j = -1; /*11659*/
		if (($1.mode == 0) || ($1.mode == 1)) { /*11662*/
			$1.method = "alpha"; /*11662*/
			$1.i = 0; /*11662*/
			$1.j = 0; /*11662*/
		} /*11662*/
		if ($1.mode == 2) { /*11663*/
			$1.method = "numeric"; /*11663*/
			$1.i = 0; /*11663*/
			$1.j = 0; /*11663*/
		} /*11663*/
		if ($1.mode == 3) { /*11677*/
			$1.posval = $a([12, 22, 13, 23, 33, 14, 24, 34, 44, 15, 25, 35, 45, 55, 16, 26, 36, 46, 56, 66, 17, 27, 37, 47, 57, 67, 77, 18, 28, 38, 48, 58, 68, 78, 88, 19, 29, 39, 49, 59, 69, 79, 89, 99]); /*11674*/
			$k[$j++] = $1.cws; /*11675*/
			$k[$j++] = 0; /*11675*/
			for (var _33 = 0; _33 <= 43; _33 += 1) { /*11675*/
				$k[$j++] = _33; /*11675*/
				if ($get($1.posval, _33) != $1.pos) { /*11675*/
					$j--; /*11675*/
				} /*11675*/
			} /*11675*/
			var _37 = $k[--$j]; /*11675*/
			var _38 = $k[--$j]; /*11675*/
			$put($k[--$j], _38, _37 + 1); /*11675*/
			$1.method = "alpha"; /*11676*/
			$1.i = 0; /*11676*/
			$1.j = 1; /*11676*/
		} /*11676*/
		if (($1.mode == 4) || ($1.mode == 5)) { /*11681*/
			$put($1.cws, 0, $get($get($1.charvals, $get($1.msg, 0)), 1)); /*11679*/
			$1.method = "alpha"; /*11680*/
			$1.i = 1; /*11680*/
			$1.j = 1; /*11680*/
		} /*11680*/
		for (;;) { /*11708*/
			if ($1.i == $1.msglen) { /*11685*/
				break; /*11685*/
			} /*11685*/
			for (;;) { /*11707*/
				if ($eq($1.method, "alpha")) { /*11696*/
					if ($get($1.numericruns, $1.i) >= 5) { /*11692*/
						$k[$j++] = $1.ns; /*11689*/
						$1.encodealpha(); /*11689*/
						$1.method = "numeric"; /*11690*/
						break; /*11691*/
					} /*11691*/
					$k[$j++] = $get($1.msg, $1.i); /*11693*/
					$1.encodealpha(); /*11693*/
					$1.i = $1.i + 1; /*11694*/
					break; /*11695*/
				} /*11695*/
				if ($eq($1.method, "numeric")) { /*11706*/
					if ($get($1.numericruns, $1.i) < 5) { /*11702*/
						$k[$j++] = $1.ns; /*11699*/
						$1.encodealpha(); /*11699*/
						$1.method = "alpha"; /*11700*/
						break; /*11701*/
					} /*11701*/
					$k[$j++] = $geti($1.msg, $1.i, $get($1.numericruns, $1.i)); /*11703*/
					$1.encodenumeric(); /*11703*/
					$1.i = $1.i + $get($1.numericruns, $1.i); /*11704*/
					break; /*11705*/
				} /*11705*/
			} /*11705*/
		} /*11705*/
		$1.cws = $geti($1.cws, 0, $1.j); /*11709*/
		$1.metrics = $a([$a([2, 9]), $a([3, 16]), $a([4, 23]), $a([5, 30]), $a([6, 37]), $a([7, 42]), $a([8, 49])]); /*11721*/
		$1.urows = $1.rows; /*11724*/
		$1.i = 0; /*11725*/
		for (;;) { /*11735*/
			$1.m = $get($1.metrics, $1.i); /*11727*/
			$1.r = $get($1.m, 0); /*11728*/
			$1.dcws = $get($1.m, 1); /*11729*/
			$1.okay = true; /*11730*/
			if (($1.urows != 0) && ($1.urows != $1.r)) { /*11731*/
				$1.okay = false; /*11731*/
			} /*11731*/
			if ($1.cws.length > $1.dcws) { /*11732*/
				$1.okay = false; /*11732*/
			} /*11732*/
			if ($1.okay) { /*11733*/
				break; /*11733*/
			} /*11733*/
			$1.i = $1.i + 1; /*11734*/
		} /*11734*/
		$k[$j++] = Infinity; /*11738*/
		$aload($1.cws); /*11738*/
		for (var _4B = 0, _4C = $1.dcws - $1.cws.length; _4B < _4C; _4B++) { /*11738*/
			$k[$j++] = 48; /*11738*/
		} /*11738*/
		$1.cws = $a(); /*11738*/
		$1.ccs = $a($1.r * 8); /*11741*/
		$1.j = 0; /*11742*/
		for (var _4I = 0, _4H = $1.r - 2; _4I <= _4H; _4I += 1) { /*11749*/
			$1.i = _4I; /*11744*/
			$1.cc = $geti($1.cws, $1.j, 7); /*11745*/
			$puti($1.ccs, $1.i * 8, $1.cc); /*11746*/
			$k[$j++] = $1.ccs; /*11747*/
			$k[$j++] = ($1.i * 8) + 7; /*11747*/
			$k[$j++] = 0; /*11747*/
			$forall($1.cc, function() { /*11747*/
				var _4S = $k[--$j]; /*11747*/
				var _4T = $k[--$j]; /*11747*/
				$k[$j++] = _4T + _4S; /*11747*/
			}); /*11747*/
			var _4U = $k[--$j]; /*11747*/
			var _4V = $k[--$j]; /*11747*/
			$put($k[--$j], _4V, _4U % 49); /*11747*/
			$1.j = $1.j + 7; /*11748*/
		} /*11748*/
		if ($1.j < $1.dcws) { /*11752*/
			$puti($1.ccs, $1.ccs.length - 8, $geti($1.cws, $1.j, $1.dcws - $1.j)); /*11751*/
		} /*11751*/
		$1.cr7 = (($1.r - 2) * 7) + $1.mode; /*11755*/
		$put($1.ccs, $1.ccs.length - 2, $1.cr7); /*11756*/
		var _4m = $a([1, 9, 31, 26, 2, 12, 17, 23, 37, 18, 22, 6, 27, 44, 15, 43, 39, 11, 13, 5, 41, 33, 36, 8, 4, 32, 3, 19, 40, 25, 29, 10, 24, 30]); /*11760*/
		$k[$j++] = _4m; /*11761*/
		$k[$j++] = _4m; /*11761*/
		$k[$j++] = Infinity; /*11761*/
		var _4n = $k[--$j]; /*11761*/
		var _4p = $geti($k[--$j], 0, 32); /*11761*/
		$k[$j++] = _4n; /*11761*/
		$k[$j++] = 20; /*11761*/
		$aload(_4p); /*11761*/
		$1.weightx = $a(); /*11761*/
		var _4r = $k[--$j]; /*11762*/
		$k[$j++] = _4r; /*11762*/
		$k[$j++] = _4r; /*11762*/
		$k[$j++] = Infinity; /*11762*/
		var _4s = $k[--$j]; /*11762*/
		var _4u = $geti($k[--$j], 1, 32); /*11762*/
		$k[$j++] = _4s; /*11762*/
		$k[$j++] = 16; /*11762*/
		$aload(_4u); /*11762*/
		$1.weighty = $a(); /*11762*/
		$k[$j++] = Infinity; /*11763*/
		var _4w = $k[--$j]; /*11763*/
		var _4y = $geti($k[--$j], 2, 32); /*11763*/
		$k[$j++] = _4w; /*11763*/
		$k[$j++] = 38; /*11763*/
		$aload(_4y); /*11763*/
		$1.weightz = $a(); /*11763*/
		$1.calccheck = function() {
			$1.weights = $k[--$j]; /*11765*/
			$1.score = 0; /*11766*/
			for (var _53 = 0, _52 = (~~((($1.r - 1) * 8) / 2)) - 1; _53 <= _52; _53 += 1) { /*11771*/
				$1.i = _53; /*11768*/
				$1.score = ((($get($1.ccs, $1.i * 2) * 49) + $get($1.ccs, ($1.i * 2) + 1)) * $get($1.weights, $1.i + 1)) + $1.score; /*11770*/
			} /*11770*/
			$k[$j++] = $1.score; /*11772*/
		}; /*11773*/
		$1.lastrow = $geti($1.ccs, $1.ccs.length - 8, 8); /*11774*/
		if ($1.r >= 7) { /*11781*/
			$k[$j++] = $1.cr7 * $get($1.weightz, 0); /*11778*/
			$k[$j++] = $1.weightz; /*11778*/
			$1.calccheck(); /*11778*/
			var _5N = $k[--$j]; /*11778*/
			var _5P = ($k[--$j] + _5N) % 2401; /*11779*/
			$k[$j++] = ~~(_5P / 49); /*11779*/
			$k[$j++] = _5P % 49; /*11779*/
			$astore($a(2)); /*11779*/
			$puti($1.lastrow, 0, $k[--$j]); /*11780*/
		} /*11780*/
		$1.wr1 = ($get($1.lastrow, 0) * 49) + $get($1.lastrow, 1); /*11782*/
		$k[$j++] = $1.cr7 * $get($1.weighty, 0); /*11785*/
		$k[$j++] = $1.weighty; /*11785*/
		$1.calccheck(); /*11785*/
		var _5b = $k[--$j]; /*11785*/
		var _5h = (($k[--$j] + _5b) + ($1.wr1 * $get($1.weighty, ($1.r * 4) - 3))) % 2401; /*11787*/
		$1.wr2 = _5h; /*11787*/
		$k[$j++] = ~~(_5h / 49); /*11788*/
		$k[$j++] = _5h % 49; /*11788*/
		$astore($a(2)); /*11788*/
		$puti($1.lastrow, 2, $k[--$j]); /*11789*/
		$k[$j++] = $1.cr7 * $get($1.weightx, 0); /*11792*/
		$k[$j++] = $1.weightx; /*11792*/
		$1.calccheck(); /*11792*/
		var _5p = $k[--$j]; /*11792*/
		var _5z = ((($k[--$j] + _5p) + ($1.wr1 * $get($1.weightx, ($1.r * 4) - 3))) + ($1.wr2 * $get($1.weightx, ($1.r * 4) - 2))) % 2401; /*11796*/
		$k[$j++] = ~~(_5z / 49); /*11796*/
		$k[$j++] = _5z % 49; /*11796*/
		$astore($a(2)); /*11796*/
		$puti($1.lastrow, 4, $k[--$j]); /*11797*/
		$k[$j++] = 0; /*11800*/
		$forall($geti($1.ccs, $1.ccs.length - 8, 7), function() { /*11800*/
			var _66 = $k[--$j]; /*11800*/
			var _67 = $k[--$j]; /*11800*/
			$k[$j++] = _67 + _66; /*11800*/
		}); /*11800*/
		$put($1.ccs, $1.ccs.length - 1, $k[--$j] % 49); /*11801*/
		$1.patterns = $a([$a(["11521132", "25112131", "14212132", "25121221", "14221222", "12412132", "23321221", "12421222", "21521221", "15112222", "15121312", "13312222", "24221311", "13321312", "11512222", "22421311", "11521312", "25112311", "14212312", "23312311", "12412312", "21512311", "16121131", "14321131", "12521131", "15212131", "15221221", "13412131", "13421221", "11612131", "16112221", "16121311", "14312221", "14321311", "12512221", "12521311", "15212311", "13412311", "11612311", "11131135", "31131133", "51131131", "21122134", "41122132", "21131224", "41131222", "11113135", "31113133", "51113131", "11122225", "31122223", "51122221", "11131315", "31131313", "51131311", "21113224", "41113222", "21122314", "41122312", "11113315", "31113313", "51113311", "12131134", "32131132", "21231133", "41231131", "22122133", "42122131", "11222134", "22131223", "42131221", "11231224", "31231222", "12113134", "32113132", "12122224", "32122222", "12131314", "32131312", "21231313", "41231311", "22113223", "42113221", "11213224", "22122313", "42122311", "11222314", "31222312", "12113314", "32113312", "21213313", "41213311", "13131133", "33131131", "22231132", "11331133", "31331131", "23122132", "12222133", "23131222", "12231223", "32231221", "21331222", "13113133", "33113131", "13122223", "33122221", "11313133", "13131313", "33131311", "11322223", "22231312", "11331313", "31331311", "23113222", "12213223", "23122312", "12222313", "32222311", "21322312", "13113313", "33113311", "22213312", "11313313", "31313311", "14131132", "23231131", "12331132", "21431131", "24122131", "13222132", "24131221", "13231222", "11422132", "22331221", "11431222", "14113132", "14122222", "12313132", "14131312", "12322222", "23231311", "12331312", "21431311", "24113221", "13213222", "24122311", "13222312", "11413222", "22322311", "11422312", "14113312", "23213311", "12313312", "21413311", "15131131", "13331131", "14222131", "14231221", "12422131", "12431221", "15113131", "15122221", "13313131", "15131311", "13322221", "11513131", "13331311", "11522221", "14213221", "14222311", "12413221", "12422311", "15113311", "13313311", "11513311", "11141134", "31141132", "21132133", "41132131", "21141223", "41141221", "11123134", "31123132", "11132224", "31132222", "11141314", "31141312", "21114133", "41114131", "21123223", "41123221", "21132313", "41132311", "11114224", "31114222", "11123314", "31123312", "21114313", "41114311", "12141133", "32141131", "21241132", "22132132", "11232133", "22141222", "11241223", "31241221", "12123133", "32123131", "12132223", "32132221", "12141313", "32141311", "21241312", "22114132", "11214133", "22123222", "11223223", "22132312", "11232313", "31232311", "12114223", "32114221", "12123313", "32123311", "21223312", "22114312", "11214313", "31214311", "13141132", "22241131", "11341132", "23132131", "12232132", "23141221", "12241222", "21341221", "13123132", "13132222", "11323132", "13141312", "11332222", "22241311", "11341312", "23114131", "12214132", "23123221", "12223222", "23132311", "12232312", "21332311", "13114222", "13123312", "11314222", "22223311", "11323312", "23114311", "12214312", "21314311", "14141131", "12341131", "13232131", "13241221", "11432131", "14123131", "14132221", "12323131", "14141311", "12332221", "12341311", "13214131", "13223221", "11414131", "13232311", "11423221", "11432311", "14114221", "14123311", "12314221", "12323311", "13214311", "11414311", "11151133", "31151131", "21142132", "21151222", "11133133", "31133131", "11142223", "31142221", "11151313", "31151311", "21124132", "21133222", "21142312", "11115133", "31115131", "11124223", "31124221", "11133313", "31133311", "21115222", "21124312", "12151132", "21251131", "22142131", "11242132", "22151221", "11251222", "12133132", "12142222", "12151312", "21251311", "22124131", "11224132", "22133221", "11233222", "22142311", "11242312", "12115132", "12124222", "12133312", "21233311", "22115221", "11215222", "22124311", "11224312", "13151131", "12242131", "12251221", "13133131", "13142221", "11333131", "13151311", "11342221", "12224131", "12233221", "12242311", "13115131", "13124221", "11315131", "13133311", "11324221", "11333311", "12215221", "12224311", "11161132", "21152131", "21161221", "11143132", "11152222", "11161312", "21134131", "21143221", "21152311", "11125132", "11134222", "11143312", "21116131", "21125221", "21134311", "12161131", "11252131", "12143131", "12152221", "12161311", "11234131", "11243221", "11252311", "12125131", "12134221", "12143311", "11216131", "11225221", "11234311", "11111236", "31111234", "51111232", "21111325", "41111323", "61111321", "11111416", "31111414", "51111412", "31211143", "51211141", "12111235", "32111233", "52111231", "21211234", "41211232", "22111324", "42111322", "11211325", "31211323", "51211321", "12111415", "32111413", "52111411", "21211414", "41211412", "12211144", "32211142", "21311143", "41311141", "13111234", "33111232", "22211233", "42211231", "11311234", "31311232", "23111323", "43111321", "12211324", "32211322", "21311323", "41311321", "13111414", "33111412", "22211413", "42211411", "11311414", "31311412", "13211143", "33211141", "22311142", "11411143", "31411141", "14111233", "34111231", "23211232", "12311233", "32311231", "21411232", "24111322", "13211323", "33211321", "22311322", "11411323", "31411321", "14111413", "34111411", "23211412", "12311413", "32311411", "21411412", "14211142", "23311141", "12411142", "21511141", "15111232", "24211231", "13311232", "22411231", "11511232", "25111321", "14211322", "23311321", "12411322", "21511321", "15111412", "24211411", "13311412", "22411411", "11511412", "15211141", "13411141", "11611141", "16111231", "14311231", "12511231", "15211321", "13411321", "11611321", "16111411", "14311411", "12511411", "21121144", "41121142", "11112145", "31112143", "51112141", "11121235", "31121233", "51121231", "21112234", "41112232", "21121324", "41121322", "11112325", "31112323", "51112321", "11121415", "31121413", "51121411", "21112414", "41112412", "22121143", "42121141", "11221144", "31221142", "12112144", "32112142", "12121234", "32121232", "21221233", "41221231", "22112233", "42112231", "11212234", "22121323", "42121321", "11221324", "31221322", "12112324", "32112322", "12121414", "32121412", "21221413", "41221411", "22112413", "42112411", "11212414", "31212412", "23121142", "12221143", "32221141", "21321142", "13112143", "33112141", "13121233", "33121231", "11312143", "22221232", "11321233", "31321231", "23112232", "12212233", "23121322", "12221323", "32221321", "21321322", "13112323", "33112321", "13121413", "33121411", "11312323", "22221412", "11321413", "31321411", "23112412", "12212413", "32212411", "21312412", "24121141", "13221142", "22321141", "11421142", "14112142", "14121232", "12312142", "23221231", "12321232", "21421231", "24112231", "13212232", "24121321", "13221322", "11412232", "22321321", "11421322", "14112322", "14121412", "12312322", "23221411", "12321412", "21421411", "24112411", "13212412", "22312411", "11412412", "14221141", "12421141", "15112141", "15121231", "13312141", "13321231", "11512141", "11521231", "14212231", "14221321", "12412231", "12421321", "15112321", "15121411", "13312321", "13321411", "11512321", "11521411", "14212411", "12412411", "21131143", "41131141", "11122144", "31122142", "11131234", "31131232", "21113143", "41113141", "21122233", "41122231", "21131323", "41131321", "11113234", "31113232", "11122324", "31122322", "11131414", "31131412", "21113323", "41113321", "21122413", "41122411", "11113414", "31113412", "22131142", "11231143", "31231141", "12122143", "32122141", "12131233", "32131231", "21231232", "22113142", "11213143", "22122232", "11222233", "22131322", "11231323", "31231321", "12113233", "32113231", "12122323", "32122321", "12131413", "32131411", "21231412", "22113322", "11213323", "22122412", "11222413", "31222411", "12113413", "32113411", "21213412", "23131141", "12231142", "21331141", "13122142", "13131232", "11322142", "22231231", "11331232", "23113141", "12213142", "23122231", "12222232", "23131321", "12231322", "21331321", "13113232", "13122322", "11313232", "13131412", "11322322", "22231411", "11331412", "23113321", "12213322", "23122411", "12222412", "21322411", "13113412", "22213411", "11313412", "13231141", "11431141", "14122141", "14131231", "12322141", "12331231", "13213141", "13222231", "11413141", "13231321", "11422231", "11431321", "14113231", "14122321", "12313231", "14131411", "12322321", "12331411", "13213321", "13222411", "11413321", "11422411", "14113411", "12313411", "21141142", "11132143", "31132141", "11141233", "31141231", "21123142", "21132232", "21141322", "11114143", "31114141", "11123233", "31123231", "11132323", "31132321", "11141413", "31141411", "21114232", "21123322", "21132412", "11114323", "31114321", "11123413", "31123411", "22141141", "11241142", "12132142", "12141232", "21241231", "22123141", "11223142", "22132231", "11232232", "22141321", "11241322", "12114142", "12123232", "12132322", "12141412", "21241411", "22114231", "11214232", "22123321", "11223322", "22132411", "11232412", "12114322", "12123412", "21223411", "12241141", "13132141", "13141231", "11332141", "11341231", "12223141", "12232231", "12241321", "13114141", "13123231", "11314141", "13132321", "11323231", "13141411", "11332321", "11341411", "12214231", "12223321", "12232411", "13114321", "13123411", "11314321", "11323411", "21151141", "11142142", "11151232", "21133141", "21142231", "21151321", "11124142", "11133232", "11142322", "11151412", "21115141", "21124231", "21133321", "21142411", "11115232", "11124322", "11133412", "11251141", "12142141", "12151231", "11233141", "11242231", "11251321", "12124141", "12133231", "12142321", "12151411", "11215141", "11224231", "11233321", "11242411", "12115231", "12124321", "12133411", "11152141", "11161231", "11134141", "11143231", "11152321", "11161411", "11116141", "11125231", "11134321", "11143411", "21111244", "41111242", "11111335", "31111333", "51111331", "21111424", "41111422", "11111515", "31111513", "51111511", "21211153", "41211151", "22111243", "42111241", "11211244", "31211242", "12111334", "32111332", "21211333", "41211331", "22111423", "42111421", "11211424", "31211422", "12111514", "32111512", "21211513", "41211511", "22211152", "11311153", "31311151", "23111242", "12211243", "32211241", "21311242", "13111333", "33111331", "22211332", "11311333", "31311331", "23111422", "12211423", "32211421", "21311422", "13111513", "33111511", "22211512", "11311513", "31311511", "23211151", "12311152", "21411151", "24111241", "13211242", "22311241", "11411242", "14111332", "23211331", "12311332", "21411331", "24111421", "13211422", "22311421", "11411422", "14111512", "23211511", "12311512", "21411511", "13311151", "11511151", "14211241", "12411241", "15111331", "13311331", "11511331", "14211421", "12411421", "15111511", "13311511", "11511511", "31121152", "21112153", "41112151", "21121243", "41121241", "11112244", "31112242", "11121334", "31121332", "21112333", "41112331", "21121423", "41121421", "11112424", "31112422", "11121514", "31121512", "21112513", "41112511", "12121153", "32121151", "21221152", "22112152", "11212153", "22121242", "11221243", "31221241", "12112243", "32112241", "12121333", "32121331", "21221332", "22112332", "11212333", "22121422", "11221423", "31221421", "12112423", "32112421", "12121513", "32121511", "21221512", "22112512", "11212513", "31212511", "13121152", "22221151", "11321152", "23112151", "12212152", "23121241", "12221242", "21321241", "13112242", "13121332", "11312242", "22221331", "11321332", "23112331", "12212332", "23121421", "12221422", "21321421", "13112422", "13121512", "11312422", "22221511", "11321512", "23112511", "12212512", "21312511", "14121151", "12321151", "13212151", "13221241", "11412151", "11421241", "14112241", "14121331", "12312241", "12321331", "13212331", "13221421", "11412331", "11421421", "14112421", "14121511", "12312421", "12321511", "13212511", "11412511", "11131153", "31131151", "21122152", "21131242", "11113153", "31113151", "11122243", "31122241", "11131333", "31131331", "21113242", "21122332", "21131422", "11113333", "31113331", "11122423", "31122421", "11131513", "31131511", "21113422", "21122512", "12131152", "21231151", "22122151", "11222152", "22131241", "11231242", "12113152", "12122242", "12131332", "21231331", "22113241", "11213242", "22122331", "11222332", "22131421", "11231422", "12113332", "12122422", "12131512", "21231511", "22113421", "11213422", "22122511", "11222512", "13131151", "11331151", "12222151", "12231241", "13113151", "13122241", "11313151", "13131331", "11322241", "11331331", "12213241", "12222331", "12231421", "13113331", "13122421", "11313331", "13131511", "11322421", "11331511", "12213421", "12222511", "11141152", "21132151", "21141241", "11123152", "11132242", "11141332", "21114151", "21123241", "21132331", "21141421", "11114242", "11123332", "11132422", "11141512", "21114331", "21123421", "21132511", "12141151", "11232151", "11241241", "12123151", "12132241", "12141331", "11214151", "11223241", "11232331", "11241421", "12114241", "12123331", "12132421", "12141511", "11214331", "11223421", "11232511", "11151151", "11133151", "11142241", "11151331", "11115151", "11124241", "11133331", "11142421", "11151511", "11111254", "31111252", "21111343", "41111341", "11111434", "31111432", "21111523", "41111521", "11111614", "31111612", "31211161", "12111253", "32111251", "21211252", "22111342", "11211343", "31211341", "12111433", "32111431", "21211432", "22111522", "11211523", "31211521", "12111613", "32111611", "21211612", "12211162", "21311161", "13111252", "22211251", "11311252", "23111341", "12211342", "21311341", "13111432", "22211431", "11311432", "23111521", "12211522", "21311521", "13111612", "22211611", "11311612", "13211161", "11411161", "14111251", "12311251", "13211341", "11411341", "14111431", "12311431", "13211521", "11411521", "14111611", "12311611", "21121162", "11112163", "31112161", "11121253", "31121251", "21112252", "21121342", "11112343", "31112341", "11121433", "31121431", "21112432", "21121522", "11112523", "31112521", "11121613", "31121611", "22121161", "11221162", "12112162", "12121252", "21221251", "22112251", "11212252", "22121341", "11221342", "12112342", "12121432", "21221431", "22112431", "11212432", "22121521", "11221522", "12112522", "12121612", "21221611", "12221161", "13112161", "13121251", "11312161", "11321251", "32121115", "52121113", "21221116", "41221114", "61221112", "22112116", "42112114", "31212115", "51212113", "13121116", "33121114", "22221115", "42221113", "11321116", "31321114", "51321112", "23112115", "43112113", "12212116", "32212114", "52212112", "21312115", "41312113", "61312111", "14121115", "34121113", "23221114", "43221112", "12321115", "32321113", "52321111", "21421114", "41421112", "24112114", "13212115", "33212113", "22312114", "42312112", "11412115", "31412113", "51412111", "15121114", "24221113", "13321114", "33321112", "22421113", "42421111", "11521114", "31521112", "25112113", "14212114", "34212112", "23312113", "43312111", "12412114", "32412112", "21512113", "41512111", "16121113", "25221112", "14321113", "34321111", "23421112", "12521113", "32521111", "15212113", "24312112", "13412113", "33412111", "22512112", "11612113", "31612111", "31131115", "51131113", "21122116", "41122114", "61122112", "31113115", "51113113", "12131116", "32131114", "52131112", "21231115", "41231113", "61231111", "22122115", "42122113", "11222116", "31222114", "51222112", "12113116", "32113114", "52113112", "21213115", "41213113", "61213111", "13131115", "33131113", "22231114", "42231112", "11331115", "31331113", "51331111", "23122114", "43122112", "12222115", "32222113", "52222111", "21322114", "41322112", "13113115", "33113113", "22213114", "42213112", "11313115", "31313113", "51313111", "14131114", "34131112", "23231113", "43231111", "12331114", "32331112", "21431113", "41431111", "24122113", "13222114", "33222112", "22322113", "42322111", "11422114", "31422112", "14113114", "34113112", "23213113", "43213111", "12313114", "32313112", "21413113", "41413111", "15131113", "24231112", "13331113", "33331111", "22431112", "25122112", "14222113", "34222111", "23322112", "12422113", "32422111", "21522112", "15113113", "24213112", "13313113", "33313111", "22413112", "11513113", "31513111", "16131112", "25231111", "14331112", "23431111", "15222112", "24322111", "13422112", "22522111", "16113112", "25213111", "14313112", "23413111", "12513112", "21613111", "11141116", "31141114", "51141112", "21132115", "41132113", "61132111", "11123116", "31123114", "51123112", "21114115", "41114113", "61114111", "12141115", "32141113", "52141111", "21241114", "41241112", "22132114", "42132112", "11232115", "31232113", "51232111", "12123115", "32123113", "52123111", "21223114", "41223112", "22114114", "42114112", "11214115", "31214113", "51214111", "13141114", "33141112", "22241113", "42241111", "11341114", "31341112", "23132113", "43132111", "12232114", "32232112", "21332113", "41332111", "13123114", "33123112", "22223113", "42223111", "11323114", "31323112", "23114113", "43114111", "12214114", "32214112", "21314113", "41314111", "14141113", "34141111", "23241112", "12341113", "32341111", "24132112", "13232113", "33232111", "22332112", "11432113", "31432111", "14123113", "34123111", "23223112", "12323113", "32323111", "21423112", "24114112", "13214113", "33214111", "22314112", "11414113", "31414111", "15141112", "24241111", "13341112", "25132111", "14232112", "23332111", "12432112", "15123112", "24223111", "13323112", "22423111", "11523112", "25114111", "14214112", "23314111", "12414112", "21514111", "16141111", "14341111", "15232111", "13432111", "16123111", "14323111", "12523111", "15214111", "13414111", "11614111", "11151115", "31151113", "51151111", "21142114", "41142112", "11133115", "31133113", "51133111", "21124114", "41124112", "11115115", "31115113", "51115111", "12151114", "32151112", "21251113", "41251111", "22142113", "42142111", "11242114", "31242112", "12133114", "32133112", "21233113", "41233111", "22124113", "42124111", "11224114", "31224112", "12115114", "32115112", "21215113", "41215111", "13151113", "33151111", "22251112", "23142112", "12242113", "32242111", "21342112", "13133113", "33133111", "22233112", "11333113", "31333111", "23124112", "12224113", "32224111", "21324112", "13115113", "33115111", "22215112", "11315113", "31315111", "14151112", "23251111", "24142111", "13242112", "22342111", "14133112", "23233111", "12333112", "21433111", "24124111", "13224112", "22324111", "11424112", "14115112", "23215111", "12315112", "21415111", "15151111", "14242111", "15133111", "13333111", "14224111", "12424111", "15115111", "13315111", "11515111", "11161114", "31161112", "21152113", "41152111", "11143114", "31143112", "21134113", "41134111", "11125114", "31125112", "21116113", "41116111", "12161113", "32161111", "22152112", "11252113", "31252111", "12143113", "32143111", "21243112", "22134112", "11234113", "31234111", "12125113", "32125111", "21225112", "22116112", "11216113", "31216111", "13161112", "23152111", "12252112", "13143112", "22243111", "11343112", "23134111", "12234112", "21334111", "13125112", "22225111", "11325112", "23116111", "12216112", "21316111", "14161111", "13252111", "14143111", "12343111", "13234111", "11434111", "14125111", "12325111", "13216111", "11416111", "31111216", "51111214", "31211125", "51211123", "32111215", "52111213", "21211216", "41211214", "61211212", "12211126", "32211124", "52211122", "21311125", "41311123", "61311121", "13111216", "33111214", "22211215", "42211213", "11311216", "31311214", "51311212", "13211125", "33211123", "22311124", "42311122", "11411125", "31411123", "51411121", "14111215", "34111213", "23211214", "43211212", "12311215", "32311213", "52311211", "21411214", "41411212", "14211124", "34211122", "23311123", "43311121", "12411124", "32411122", "21511123", "41511121", "15111214", "24211213", "13311214", "33311212", "22411213", "42411211", "11511214", "31511212", "15211123", "24311122", "13411123", "33411121", "22511122", "11611123", "31611121", "16111213", "25211212", "14311213", "34311211", "23411212", "12511213", "32511211", "21611212", "21121126", "41121124", "61121122", "31112125", "51112123", "31121215", "51121213", "21112216", "41112214", "61112212", "22121125", "42121123", "11221126", "31221124", "51221122", "12112126", "32112124", "52112122", "12121216", "32121214", "52121212", "21221215", "41221213", "61221211", "22112215", "42112213", "11212216", "31212214", "51212212", "23121124", "43121122", "12221125", "32221123", "52221121", "21321124", "41321122", "13112125", "33112123", "13121215", "33121213", "11312125", "22221214", "42221212", "11321215", "31321213", "51321211", "23112214", "43112212", "12212215", "32212213", "52212211", "21312214", "41312212", "24121123", "13221124", "33221122", "22321123", "42321121", "11421124", "31421122", "14112124", "34112122", "14121214", "34121212", "12312124", "23221213", "43221211", "12321214", "32321212", "21421213", "41421211", "24112213", "13212214", "33212212", "22312213", "42312211", "11412214", "31412212", "25121122", "14221123", "34221121", "23321122", "12421123", "32421121", "21521122", "15112123", "15121213", "13312123", "24221212", "13321213", "33321211", "11512123", "22421212", "11521213", "31521211", "25112212", "14212213", "34212211", "23312212", "12412213", "32412211", "21512212", "15221122", "24321121", "13421122", "22521121", "16112122", "16121212", "14312122", "25221211", "14321212", "12512122", "23421211", "12521212", "15212212", "24312211", "13412212", "22512211", "11612212", "21131125", "41131123", "61131121", "11122126", "31122124", "51122122", "11131216", "31131214", "51131212", "21113125", "41113123", "61113121", "21122215", "41122213", "61122211", "11113216", "31113214", "51113212", "22131124", "42131122", "11231125", "31231123", "51231121", "12122125", "32122123", "52122121", "12131215", "32131213", "52131211", "21231214", "41231212", "22113124", "42113122", "11213125", "22122214", "42122212", "11222215", "31222213", "51222211", "12113215", "32113213", "52113211", "21213214", "41213212", "23131123", "43131121", "12231124", "32231122", "21331123", "41331121", "13122124", "33122122", "13131214", "33131212", "11322124", "22231213", "42231211", "11331214", "31331212", "23113123", "43113121", "12213124", "23122213", "43122211", "12222214", "32222212", "21322213", "41322211", "13113214", "33113212", "22213213", "42213211", "11313214", "31313212", "24131122", "13231123", "33231121", "22331122", "11431123", "31431121", "14122123", "34122121", "14131213", "34131211", "12322123", "23231212", "12331213", "32331211", "21431212", "24113122", "13213123", "24122212", "13222213", "33222211", "11413123", "22322212", "11422213", "31422211", "14113213", "34113211", "23213212", "12313213", "32313211", "21413212", "25131121", "14231122", "23331121", "12431122", "15122122", "15131212", "13322122", "24231211", "13331212", "11522122", "22431211", "25113121", "14213122", "25122211", "14222212", "12413122", "23322211", "12422212", "21522211", "15113212", "24213211", "13313212", "22413211", "11513212", "15231121", "13431121", "16122121", "16131211", "14322121", "14331211", "12522121", "15213121", "15222211", "13413121", "13422211", "11613121", "16113211", "14313211", "12513211", "21141124", "41141122", "11132125", "31132123", "51132121", "11141215", "31141213", "51141211", "21123124", "41123122", "21132214", "41132212", "11114125", "31114123", "51114121", "11123215", "31123213", "51123211", "21114214", "41114212", "22141123", "42141121", "11241124", "31241122", "12132124", "32132122", "12141214", "32141212", "21241213", "41241211", "22123123", "42123121", "11223124", "22132213", "42132211", "11232214", "31232212", "12114124", "32114122", "12123214", "32123212", "21223213", "41223211", "22114213", "42114211", "11214214", "31214212", "23141122", "12241123", "32241121", "21341122", "13132123", "33132121", "13141213", "33141211", "11332123", "22241212", "11341213", "31341211", "23123122", "12223123", "23132212", "12232213", "32232211", "21332212", "13114123", "33114121", "13123213", "33123211", "11314123", "22223212", "11323213", "31323211", "23114212", "12214213", "32214211", "21314212", "24141121", "13241122", "22341121", "14132122", "14141212", "12332122", "23241211", "12341212", "24123121", "13223122", "24132211", "13232212", "11423122", "22332211", "11432212", "14114122", "14123212", "12314122", "23223211", "12323212", "21423211", "24114211", "13214212", "22314211", "11414212", "14241121", "15132121", "15141211", "13332121", "13341211", "14223121", "14232211", "12423121", "12432211", "15114121", "15123211", "13314121", "13323211", "11514121", "11523211", "14214211", "12414211", "21151123", "41151121", "11142124", "31142122", "11151214", "31151212", "21133123", "41133121", "21142213", "41142211", "11124124", "31124122", "11133214", "31133212", "21115123", "41115121", "21124213", "41124211", "11115214", "31115212", "22151122", "11251123", "31251121", "12142123", "32142121", "12151213", "32151211", "21251212", "22133122", "11233123", "22142212", "11242213", "31242211", "12124123", "32124121", "12133213", "32133211", "21233212", "22115122", "11215123", "22124212", "11224213", "31224211", "12115213", "32115211", "21215212", "23151121", "12251122", "13142122", "13151212", "11342122", "22251211", "23133121", "12233122", "23142211", "12242212", "21342211", "13124122", "13133212", "11324122", "22233211", "11333212", "23115121", "12215122", "23124211", "12224212", "21324211", "13115212", "22215211", "11315212", "13251121", "14142121", "14151211", "12342121", "13233121", "13242211", "11433121", "14124121", "14133211", "12324121", "12333211", "13215121", "13224211", "11415121", "11424211", "14115211", "12315211", "21161122", "11152123", "31152121", "11161213", "31161211", "21143122", "21152212", "11134123", "31134121", "11143213", "31143211", "21125122", "21134212", "11116123", "31116121", "11125213", "31125211", "22161121", "12152122", "12161212", "22143121", "11243122", "22152211", "11252212", "12134122", "12143212", "21243211", "22125121", "11225122", "22134211", "11234212", "12116122", "12125212", "21225211", "13152121", "13161211", "12243121", "12252211", "13134121", "13143211", "11334121", "11343211", "12225121", "12234211", "13116121", "13125211", "11316121", "11325211", "21111226", "41111224", "61111222", "31111315", "51111313", "21211135", "41211133", "61211131", "22111225", "42111223", "11211226", "31211224", "51211222", "12111316", "32111314", "52111312", "21211315", "41211313", "61211311", "22211134", "42211132", "11311135", "31311133", "51311131", "23111224", "43111222", "12211225", "32211223", "52211221", "21311224", "41311222", "13111315", "33111313", "22211314", "42211312", "11311315", "31311313", "51311311", "23211133", "43211131", "12311134", "32311132", "21411133", "41411131", "24111223", "13211224", "33211222", "22311223", "42311221", "11411224", "31411222", "14111314", "34111312", "23211313", "43211311", "12311314", "32311312", "21411313", "41411311", "24211132", "13311133", "33311131", "22411132", "11511133", "31511131", "25111222", "14211223", "34211221", "23311222", "12411223", "32411221", "21511222", "15111313", "24211312", "13311313", "33311311", "22411312", "11511313", "31511311", "25211131", "14311132", "23411131", "12511132", "21611131", "15211222", "24311221", "13411222", "22511221", "11611222", "16111312", "25211311", "14311312", "23411311", "12511312", "21611311", "31121134", "51121132", "21112135", "41112133", "61112131", "21121225", "41121223", "61121221", "11112226", "31112224", "51112222", "11121316", "31121314", "51121312", "21112315", "41112313", "61112311", "12121135", "32121133", "52121131", "21221134", "41221132", "22112134", "42112132", "11212135", "22121224", "42121222", "11221225", "31221223", "51221221", "12112225", "32112223", "52112221", "12121315", "32121313", "52121311", "21221314", "41221312", "22112314", "42112312", "11212315", "31212313", "51212311", "13121134", "33121132", "22221133", "42221131", "11321134", "31321132", "23112133", "43112131", "12212134", "23121223", "43121221", "12221224", "32221222", "21321223", "41321221", "13112224", "33112222", "13121314", "33121312", "11312224", "22221313", "42221311", "11321314", "31321312", "23112313", "43112311", "12212314", "32212312", "21312313", "41312311", "14121133", "34121131", "23221132", "12321133", "32321131", "21421132", "24112132", "13212133", "24121222", "13221223", "33221221", "11412133", "22321222", "11421223", "31421221", "14112223", "34112221", "14121313", "34121311", "12312223", "23221312", "12321313", "32321311", "21421312", "24112312", "13212313", "33212311", "22312312", "11412313", "31412311", "15121132", "24221131", "13321132", "22421131"]), $a(["22121116", "42121114", "31221115", "51221113", "32112115", "52112113", "21212116", "41212114", "61212112", "23121115", "43121113", "12221116", "32221114", "52221112", "21321115", "41321113", "61321111", "13112116", "33112114", "22212115", "42212113", "11312116", "31312114", "51312112", "24121114", "13221115", "33221113", "22321114", "42321112", "11421115", "31421113", "51421111", "14112115", "34112113", "23212114", "43212112", "12312115", "32312113", "52312111", "21412114", "41412112", "25121113", "14221114", "34221112", "23321113", "43321111", "12421114", "32421112", "21521113", "41521111", "15112114", "24212113", "13312114", "33312112", "22412113", "42412111", "11512114", "31512112", "15221113", "24321112", "13421113", "33421111", "22521112", "16112113", "25212112", "14312113", "34312111", "23412112", "12512113", "32512111", "21612112", "21131116", "41131114", "61131112", "31122115", "51122113", "21113116", "41113114", "61113112", "22131115", "42131113", "11231116", "31231114", "51231112", "12122116", "32122114", "52122112", "21222115", "41222113", "61222111", "22113115", "42113113", "11213116", "31213114", "51213112", "23131114", "43131112", "12231115", "32231113", "52231111", "21331114", "41331112", "13122115", "33122113", "22222114", "42222112", "11322115", "31322113", "51322111", "23113114", "43113112", "12213115", "32213113", "52213111", "21313114", "41313112", "24131113", "13231114", "33231112", "22331113", "42331111", "11431114", "31431112", "14122114", "34122112", "23222113", "43222111", "12322114", "32322112", "21422113", "41422111", "24113113", "13213114", "33213112", "22313113", "42313111", "11413114", "31413112", "25131112", "14231113", "34231111", "23331112", "12431113", "32431111", "15122113", "24222112", "13322113", "33322111", "22422112", "11522113", "31522111", "25113112", "14213113", "34213111", "23313112", "12413113", "32413111", "21513112", "15231112", "24331111", "13431112", "16122112", "25222111", "14322112", "23422111", "12522112", "15213112", "24313111", "13413112", "22513111", "11613112", "21141115", "41141113", "61141111", "11132116", "31132114", "51132112", "21123115", "41123113", "61123111", "11114116", "31114114", "51114112", "22141114", "42141112", "11241115", "31241113", "51241111", "12132115", "32132113", "52132111", "21232114", "41232112", "22123114", "42123112", "11223115", "31223113", "51223111", "12114115", "32114113", "52114111", "21214114", "41214112", "23141113", "43141111", "12241114", "32241112", "21341113", "41341111", "13132114", "33132112", "22232113", "42232111", "11332114", "31332112", "23123113", "43123111", "12223114", "32223112", "21323113", "41323111", "13114114", "33114112", "22214113", "42214111", "11314114", "31314112", "24141112", "13241113", "33241111", "22341112", "14132113", "34132111", "23232112", "12332113", "32332111", "21432112", "24123112", "13223113", "33223111", "22323112", "11423113", "31423111", "14114113", "34114111", "23214112", "12314113", "32314111", "21414112", "25141111", "14241112", "23341111", "15132112", "24232111", "13332112", "22432111", "25123111", "14223112", "23323111", "12423112", "21523111", "15114112", "24214111", "13314112", "22414111", "11514112", "15241111", "16132111", "14332111", "15223111", "13423111", "16114111", "14314111", "12514111", "21151114", "41151112", "11142115", "31142113", "51142111", "21133114", "41133112", "11124115", "31124113", "51124111", "21115114", "41115112", "22151113", "42151111", "11251114", "31251112", "12142114", "32142112", "21242113", "41242111", "22133113", "42133111", "11233114", "31233112", "12124114", "32124112", "21224113", "41224111", "22115113", "42115111", "11215114", "31215112", "23151112", "12251113", "32251111", "13142113", "33142111", "22242112", "11342113", "31342111", "23133112", "12233113", "32233111", "21333112", "13124113", "33124111", "22224112", "11324113", "31324111", "23115112", "12215113", "32215111", "21315112", "24151111", "13251112", "14142112", "23242111", "12342112", "24133111", "13233112", "22333111", "11433112", "14124112", "23224111", "12324112", "21424111", "24115111", "13215112", "22315111", "11415112", "14251111", "15142111", "13342111", "14233111", "12433111", "15124111", "13324111", "11524111", "14215111", "12415111", "21161113", "41161111", "11152114", "31152112", "21143113", "41143111", "11134114", "31134112", "21125113", "41125111", "11116114", "31116112", "22161112", "12152113", "32152111", "21252112", "22143112", "11243113", "31243111", "12134113", "32134111", "21234112", "22125112", "11225113", "31225111", "12116113", "32116111", "21216112", "23161111", "13152112", "22252111", "23143111", "12243112", "21343111", "13134112", "22234111", "11334112", "23125111", "12225112", "21325111", "13116112", "22216111", "11316112", "14152111", "13243111", "14134111", "12334111", "13225111", "11425111", "14116111", "12316111", "41111215", "61111213", "21211126", "41211124", "61211122", "22111216", "42111214", "31211215", "51211213", "22211125", "42211123", "11311126", "31311124", "51311122", "23111215", "43111213", "12211216", "32211214", "52211212", "21311215", "41311213", "61311211", "23211124", "43211122", "12311125", "32311123", "52311121", "21411124", "41411122", "24111214", "13211215", "33211213", "22311214", "42311212", "11411215", "31411213", "51411211", "24211123", "13311124", "33311122", "22411123", "42411121", "11511124", "31511122", "25111213", "14211214", "34211212", "23311213", "43311211", "12411214", "32411212", "21511213", "41511211", "25211122", "14311123", "34311121", "23411122", "12511123", "32511121", "21611122", "15211213", "24311212", "13411213", "33411211", "22511212", "11611213", "31611211", "31121125", "51121123", "21112126", "41112124", "61112122", "21121216", "41121214", "61121212", "31112215", "51112213", "12121126", "32121124", "52121122", "21221125", "41221123", "61221121", "22112125", "42112123", "11212126", "22121215", "42121213", "11221216", "31221214", "51221212", "12112216", "32112214", "52112212", "21212215", "41212213", "61212211", "13121125", "33121123", "22221124", "42221122", "11321125", "31321123", "51321121", "23112124", "43112122", "12212125", "23121214", "43121212", "12221215", "32221213", "52221211", "21321214", "41321212", "13112215", "33112213", "22212214", "42212212", "11312215", "31312213", "51312211", "14121124", "34121122", "23221123", "43221121", "12321124", "32321122", "21421123", "41421121", "24112123", "13212124", "24121213", "13221214", "33221212", "11412124", "22321213", "42321211", "11421214", "31421212", "14112214", "34112212", "23212213", "43212211", "12312214", "32312212", "21412213", "41412211", "15121123", "24221122", "13321123", "33321121", "22421122", "11521123", "31521121", "25112122", "14212123", "25121212", "14221213", "34221211", "12412123", "23321212", "12421213", "32421211", "21521212", "15112213", "24212212", "13312213", "33312211", "22412212", "11512213", "31512211", "16121122", "25221121", "14321122", "23421121", "12521122", "15212122", "15221212", "13412122", "24321211", "13421212", "11612122", "22521211", "16112212", "25212211", "14312212", "23412211", "12512212", "21612211", "11131126", "31131124", "51131122", "21122125", "41122123", "61122121", "21131215", "41131213", "61131211", "11113126", "31113124", "51113122", "11122216", "31122214", "51122212", "21113215", "41113213", "61113211", "12131125", "32131123", "52131121", "21231124", "41231122", "22122124", "42122122", "11222125", "22131214", "42131212", "11231215", "31231213", "51231211", "12113125", "32113123", "52113121", "12122215", "32122213", "52122211", "21222214", "41222212", "22113214", "42113212", "11213215", "31213213", "51213211", "13131124", "33131122", "22231123", "42231121", "11331124", "31331122", "23122123", "43122121", "12222124", "23131213", "43131211", "12231214", "32231212", "21331213", "41331211", "13113124", "33113122", "13122214", "33122212", "11313124", "22222213", "42222211", "11322214", "31322212", "23113213", "43113211", "12213214", "32213212", "21313213", "41313211", "14131123", "34131121", "23231122", "12331123", "32331121", "21431122", "24122122", "13222123", "24131212", "13231213", "33231211", "11422123", "22331212", "11431213", "31431211", "14113123", "34113121", "14122213", "34122211", "12313123", "23222212", "12322213", "32322211", "21422212", "24113212", "13213213", "33213211", "22313212", "11413213", "31413211", "15131122", "24231121", "13331122", "22431121", "25122121", "14222122", "25131211", "14231212", "12422122", "23331211", "12431212", "15113122", "15122212", "13313122", "24222211", "13322212", "11513122", "22422211", "11522212", "25113211", "14213212", "23313211", "12413212", "21513211", "16131121", "14331121", "15222121", "15231211", "13422121", "13431211", "16113121", "16122211", "14313121", "14322211", "12513121", "12522211", "15213211", "13413211", "11613211", "11141125", "31141123", "51141121", "21132124", "41132122", "21141214", "41141212", "11123125", "31123123", "51123121", "11132215", "31132213", "51132211", "21114124", "41114122", "21123214", "41123212", "11114215", "31114213", "51114211", "12141124", "32141122", "21241123", "41241121", "22132123", "42132121", "11232124", "22141213", "42141211", "11241214", "31241212", "12123124", "32123122", "12132214", "32132212", "21232213", "41232211", "22114123", "42114121", "11214124", "22123213", "42123211", "11223214", "31223212", "12114214", "32114212", "21214213", "41214211", "13141123", "33141121", "22241122", "11341123", "31341121", "23132122", "12232123", "23141212", "12241213", "32241211", "21341212", "13123123", "33123121", "13132213", "33132211", "11323123", "22232212", "11332213", "31332211", "23114122", "12214123", "23123212", "12223213", "32223211", "21323212", "13114213", "33114211", "22214212", "11314213", "31314211", "14141122", "23241121", "12341122", "24132121", "13232122", "24141211", "13241212", "11432122", "22341211", "14123122", "14132212", "12323122", "23232211", "12332212", "21432211", "24114121", "13214122", "24123211", "13223212", "11414122", "22323211", "11423212", "14114212", "23214211", "12314212", "21414211", "15141121", "13341121", "14232121", "14241211", "12432121", "15123121", "15132211", "13323121", "13332211", "11523121", "14214121", "14223211", "12414121", "12423211", "15114211", "13314211", "11514211", "11151124", "31151122", "21142123", "41142121", "21151213", "41151211", "11133124", "31133122", "11142214", "31142212", "21124123", "41124121", "21133213", "41133211", "11115124", "31115122", "11124214", "31124212", "21115213", "41115211", "12151123", "32151121", "21251122", "22142122", "11242123", "22151212", "11251213", "31251211", "12133123", "32133121", "12142213", "32142211", "21242212", "22124122", "11224123", "22133212", "11233213", "31233211", "12115123", "32115121", "12124213", "32124211", "21224212", "22115212", "11215213", "31215211", "13151122", "22251121", "23142121", "12242122", "23151211", "12251212", "13133122", "13142212", "11333122", "22242211", "11342212", "23124121", "12224122", "23133211", "12233212", "21333211", "13115122", "13124212", "11315122", "22224211", "11324212", "23115211", "12215212", "21315211", "14151121", "13242121", "13251211", "14133121", "14142211", "12333121", "12342211", "13224121", "13233211", "11424121", "11433211", "14115121", "14124211", "12315121", "12324211", "13215211", "11415211", "11161123", "31161121", "21152122", "21161212", "11143123", "31143121", "11152213", "31152211", "21134122", "21143212", "11125123", "31125121", "11134213", "31134211", "21116122", "21125212", "12161122", "22152121", "11252122", "22161211", "12143122", "12152212", "21252211", "22134121", "11234122", "22143211", "11243212", "12125122", "12134212", "21234211", "22116121", "11216122", "22125211", "11225212", "13161121", "12252121", "13143121", "13152211", "11343121", "12234121", "12243211", "13125121", "13134211", "11325121", "11334211", "12216121", "12225211", "31111225", "51111223", "21111316", "41111314", "61111312", "31211134", "51211132", "12111226", "32111224", "52111222", "21211225", "41211223", "61211221", "22111315", "42111313", "11211316", "31211314", "51211312", "12211135", "32211133", "52211131", "21311134", "41311132", "13111225", "33111223", "22211224", "42211222", "11311225", "31311223", "51311221", "23111314", "43111312", "12211315", "32211313", "52211311", "21311314", "41311312", "13211134", "33211132", "22311133", "42311131", "11411134", "31411132", "14111224", "34111222", "23211223", "43211221", "12311224", "32311222", "21411223", "41411221", "24111313", "13211314", "33211312", "22311313", "42311311", "11411314", "31411312", "14211133", "34211131", "23311132", "12411133", "32411131", "21511132", "15111223", "24211222", "13311223", "33311221", "22411222", "11511223", "31511221", "25111312", "14211313", "34211311", "23311312", "12411313", "32411311", "21511312", "15211132", "24311131", "13411132", "22511131", "11611132", "16111222", "25211221", "14311222", "23411221", "12511222", "21611221", "15211312", "24311311", "13411312", "22511311", "11611312", "21121135", "41121133", "61121131", "11112136", "31112134", "51112132", "11121226", "31121224", "51121222", "21112225", "41112223", "61112221", "21121315", "41121313", "61121311", "11112316", "31112314", "51112312", "22121134", "42121132", "11221135", "31221133", "51221131", "12112135", "32112133", "52112131", "12121225", "32121223", "52121221", "21221224", "41221222", "22112224", "42112222", "11212225", "22121314", "42121312", "11221315", "31221313", "51221311", "12112315", "32112313", "52112311", "21212314", "41212312", "23121133", "43121131", "12221134", "32221132", "21321133", "41321131", "13112134", "33112132", "13121224", "33121222", "11312134", "22221223", "42221221", "11321224", "31321222", "23112223", "43112221", "12212224", "23121313", "43121311", "12221314", "32221312", "21321313", "41321311", "13112314", "33112312", "22212313", "42212311", "11312314", "31312312", "24121132", "13221133", "33221131", "22321132", "11421133", "31421131", "14112133", "34112131", "14121223", "34121221", "12312133", "23221222", "12321223", "32321221", "21421222", "24112222", "13212223", "24121312", "13221313", "33221311", "11412223", "22321312", "11421313", "31421311", "14112313", "34112311", "23212312", "12312313", "32312311", "21412312", "25121131", "14221132", "23321131", "12421132", "21521131", "15112132", "15121222", "13312132", "24221221", "13321222", "11512132", "22421221", "11521222", "25112221", "14212222", "25121311", "14221312", "12412222", "23321311", "12421312", "21521311", "15112312", "24212311", "13312312", "22412311", "11512312", "15221131", "13421131", "16112131", "16121221", "14312131", "14321221", "12512131", "12521221", "15212221", "15221311", "13412221", "13421311", "11612221", "16112311", "14312311", "12512311", "21131134", "41131132", "11122135", "31122133", "51122131", "11131225", "31131223", "51131221", "21113134", "41113132", "21122224", "41122222", "21131314", "41131312", "11113225", "31113223", "51113221", "11122315", "31122313", "51122311", "21113314", "41113312", "22131133", "42131131", "11231134", "31231132", "12122134", "32122132", "12131224", "32131222", "21231223", "41231221", "22113133", "42113131", "11213134", "22122223", "42122221", "11222224", "22131313", "42131311", "11231314", "31231312", "12113224", "32113222", "12122314", "32122312", "21222313", "41222311", "22113313", "42113311", "11213314", "31213312", "23131132", "12231133", "32231131", "21331132", "13122133", "33122131", "13131223", "33131221", "11322133", "22231222", "11331223", "31331221", "23113132", "12213133", "23122222", "12222223", "23131312", "12231313", "32231311", "21331312", "13113223", "33113221", "13122313", "33122311", "11313223", "22222312", "11322313", "31322311", "23113312", "12213313", "32213311", "21313312", "24131131", "13231132", "22331131", "11431132", "14122132", "14131222", "12322132", "23231221", "12331222", "21431221", "24113131", "13213132", "24122221", "13222222", "24131311", "11413132", "13231312", "11422222", "22331311", "11431312", "14113222", "14122312", "12313222", "23222311", "12322312", "21422311", "24113311", "13213312", "22313311", "11413312", "14231131", "12431131", "15122131", "15131221", "13322131", "13331221", "11522131", "14213131", "14222221", "12413131", "14231311", "12422221", "12431311", "15113221", "15122311", "13313221", "13322311", "11513221", "11522311", "14213311", "12413311", "21141133", "41141131", "11132134", "31132132", "11141224", "31141222", "21123133", "41123131", "21132223", "41132221", "21141313", "41141311", "11114134", "31114132", "11123224", "31123222", "11132314", "31132312", "21114223", "41114221", "21123313", "41123311", "11114314", "31114312", "22141132", "11241133", "31241131", "12132133", "32132131", "12141223", "32141221", "21241222", "22123132", "11223133", "22132222", "11232223", "22141312", "11241313", "31241311", "12114133", "32114131", "12123223", "32123221", "12132313", "32132311", "21232312", "22114222", "11214223", "22123312", "11223313", "31223311", "12114313", "32114311", "21214312", "23141131", "12241132", "21341131", "13132132", "13141222", "11332132", "22241221", "11341222", "23123131", "12223132", "23132221", "12232222", "23141311", "12241312", "21341311", "13114132", "13123222", "11314132", "13132312", "11323222", "22232311", "11332312", "23114221", "12214222", "23123311", "12223312", "21323311", "13114312", "22214311", "11314312", "13241131", "14132131", "14141221", "12332131", "12341221", "13223131", "13232221", "11423131", "13241311", "11432221", "14114131", "14123221", "12314131", "14132311", "12323221", "12332311", "13214221", "13223311", "11414221", "11423311", "14114311", "12314311", "21151132", "11142133", "31142131", "11151223", "31151221", "21133132", "21142222", "21151312", "11124133", "31124131", "11133223", "31133221", "11142313", "31142311", "21115132", "21124222", "21133312", "11115223", "31115221", "11124313", "31124311", "22151131", "11251132", "12142132", "12151222", "21251221", "22133131", "11233132", "22142221", "11242222", "22151311", "11251312", "12124132", "12133222", "12142312", "21242311", "22115131", "11215132", "22124221", "11224222", "22133311", "11233312", "12115222", "12124312", "21224311", "12251131", "13142131", "13151221", "11342131", "12233131", "12242221", "12251311", "13124131", "13133221", "11324131", "13142311", "11333221", "11342311", "12215131", "12224221", "12233311", "13115221", "13124311", "11315221", "11324311", "21161131", "11152132", "11161222", "21143131", "21152221", "21161311", "11134132", "11143222", "11152312", "21125131", "21134221", "21143311", "11116132", "11125222", "11134312", "12152131", "12161221", "11243131", "11252221", "12134131", "12143221", "12152311", "11225131", "11234221", "11243311", "12116131", "12125221", "12134311", "21111235", "41111233", "61111231", "11111326", "31111324", "51111322", "21111415", "41111413", "61111411", "21211144", "41211142", "22111234", "42111232", "11211235", "31211233", "51211231", "12111325", "32111323", "52111321", "21211324", "41211322", "22111414", "42111412", "11211415", "31211413", "51211411", "22211143", "42211141", "11311144", "31311142", "23111233", "43111231", "12211234", "32211232", "21311233", "41311231", "13111324", "33111322", "22211323", "42211321", "11311324", "31311322", "23111413", "43111411", "12211414", "32211412", "21311413", "41311411", "23211142", "12311143", "32311141", "21411142", "24111232", "13211233", "33211231", "22311232", "11411233", "31411231", "14111323", "34111321", "23211322", "12311323", "32311321", "21411322", "24111412", "13211413", "33211411", "22311412", "11411413", "31411411", "24211141", "13311142", "22411141", "11511142", "25111231", "14211232", "23311231", "12411232", "21511231", "15111322", "24211321", "13311322", "22411321", "11511322", "25111411", "14211412", "23311411", "12411412", "21511411", "14311141", "12511141", "15211231", "13411231", "11611231", "16111321", "14311321", "12511321", "15211411", "13411411", "11611411", "31121143", "51121141", "21112144", "41112142", "21121234", "41121232", "11112235", "31112233", "51112231", "11121325", "31121323", "51121321", "21112324", "41112322", "21121414", "41121412", "11112415", "31112413", "51112411", "12121144", "32121142", "21221143", "41221141", "22112143", "42112141", "11212144", "22121233", "42121231", "11221234", "31221232", "12112234", "32112232", "12121324", "32121322", "21221323", "41221321", "22112323", "42112321", "11212324", "22121413", "42121411", "11221414", "31221412", "12112414", "32112412", "21212413", "41212411", "13121143", "33121141", "22221142", "11321143", "31321141", "23112142", "12212143", "23121232", "12221233", "32221231", "21321232", "13112233", "33112231", "13121323", "33121321", "11312233", "22221322", "11321323", "31321321", "23112322", "12212323", "23121412", "12221413", "32221411", "21321412", "13112413", "33112411", "22212412", "11312413", "31312411", "14121142", "23221141", "12321142", "21421141", "24112141", "13212142", "24121231", "13221232", "11412142", "22321231", "11421232", "14112232", "14121322", "12312232", "23221321", "12321322", "21421321", "24112321", "13212322", "24121411", "13221412", "11412322", "22321411", "11421412", "14112412", "23212411", "12312412", "21412411", "15121141", "13321141", "11521141", "14212141", "14221231", "12412141", "12421231", "15112231", "15121321", "13312231", "13321321", "11512231", "11521321", "14212321", "14221411", "12412321", "12421411", "15112411", "13312411", "11512411", "11131144", "31131142", "21122143", "41122141", "21131233", "41131231", "11113144", "31113142", "11122234", "31122232", "11131324", "31131322", "21113233", "41113231", "21122323", "41122321", "21131413", "41131411", "11113324", "31113322", "11122414", "31122412", "21113413", "41113411", "12131143", "32131141", "21231142", "22122142", "11222143", "22131232", "11231233", "31231231", "12113143", "32113141", "12122233", "32122231", "12131323", "32131321", "21231322", "22113232", "11213233", "22122322", "11222323", "22131412", "11231413", "31231411", "12113323", "32113321", "12122413", "32122411", "21222412", "22113412", "11213413", "31213411", "13131142", "22231141", "11331142", "23122141", "12222142", "23131231", "12231232", "21331231", "13113142", "13122232", "11313142", "13131322", "11322232", "22231321", "11331322", "23113231", "12213232", "23122321", "12222322", "23131411", "12231412", "21331411", "13113322", "13122412", "11313322", "22222411", "11322412", "23113411", "12213412", "21313411", "14131141", "12331141", "13222141", "13231231", "11422141", "11431231", "14113141", "14122231", "12313141", "14131321", "12322231", "12331321", "13213231", "13222321", "11413231", "13231411", "11422321", "11431411", "14113321", "14122411", "12313321", "12322411", "13213411", "11413411", "11141143", "31141141", "21132142", "21141232", "11123143", "31123141", "11132233", "31132231", "11141323", "31141321", "21114142", "21123232", "21132322", "21141412", "11114233", "31114231", "11123323", "31123321", "11132413", "31132411", "21114322", "21123412", "12141142", "21241141", "22132141", "11232142", "22141231", "11241232", "12123142", "12132232", "12141322", "21241321", "22114141", "11214142", "22123231", "11223232", "22132321", "11232322", "22141411", "11241412", "12114232", "12123322", "12132412", "21232411", "22114321", "11214322", "22123411", "11223412", "13141141", "11341141", "12232141", "12241231", "13123141", "13132231", "11323141", "13141321", "11332231", "11341321", "12214141", "12223231", "12232321", "12241411", "13114231", "13123321", "11314231", "13132411", "11323321", "11332411", "12214321", "12223411", "11151142", "21142141", "21151231", "11133142", "11142232", "11151322", "21124141", "21133231", "21142321", "21151411", "11115142", "11124232", "11133322", "11142412", "21115231", "21124321", "21133411", "12151141", "11242141", "11251231", "12133141", "12142231", "12151321", "11224141", "11233231", "11242321", "11251411", "12115141", "12124231", "12133321", "12142411", "11215231", "11224321", "11233411", "11161141", "11143141", "11152231", "11161321", "11125141", "11134231", "11143321", "11152411", "11111245", "31111243", "51111241", "21111334", "41111332", "11111425", "31111423", "51111421", "21111514", "41111512", "31211152", "12111244", "32111242", "21211243", "41211241", "22111333", "42111331", "11211334", "31211332", "12111424", "32111422", "21211423", "41211421", "22111513", "42111511", "11211514", "31211512", "12211153", "32211151", "21311152", "13111243", "33111241", "22211242", "11311243", "31311241", "23111332", "12211333", "32211331", "21311332", "13111423", "33111421", "22211422", "11311423", "31311421", "23111512", "12211513", "32211511", "21311512", "13211152", "22311151", "11411152", "14111242", "23211241", "12311242", "21411241", "24111331", "13211332", "22311331", "11411332", "14111422", "23211421", "12311422", "21411421", "24111511", "13211512", "22311511", "11411512", "14211151", "12411151", "15111241", "13311241", "11511241", "14211331", "12411331", "15111421", "13311421", "11511421", "14211511", "12411511", "21121153", "41121151", "11112154", "31112152", "11121244", "31121242", "21112243", "41112241", "21121333", "41121331", "11112334", "31112332", "11121424", "31121422", "21112423", "41112421", "21121513", "41121511", "11112514", "31112512", "22121152", "11221153", "31221151", "12112153", "32112151", "12121243", "32121241", "21221242", "22112242", "11212243", "22121332", "11221333", "31221331", "12112333", "32112331", "12121423", "32121421", "21221422", "22112422", "11212423", "22121512", "11221513", "31221511", "12112513", "32112511", "21212512", "23121151", "12221152", "21321151", "13112152", "13121242", "11312152", "22221241", "11321242", "23112241", "12212242", "23121331", "12221332", "21321331", "13112332", "13121422", "11312332", "22221421", "11321422", "23112421", "12212422", "23121511", "12221512", "21321511", "13112512", "22212511", "11312512", "13221151", "11421151", "14112151", "14121241", "12312151", "12321241", "13212241", "13221331", "11412241", "11421331", "14112331", "14121421", "12312331", "12321421", "13212421", "13221511", "11412421", "11421511", "14112511", "12312511", "21131152", "11122153", "31122151", "11131243", "31131241", "21113152", "21122242", "21131332", "11113243", "31113241", "11122333", "31122331", "11131423", "31131421", "21113332", "21122422", "21131512", "11113423", "31113421", "11122513", "31122511", "22131151", "11231152", "12122152", "12131242", "21231241", "22113151", "11213152", "22122241", "11222242", "22131331", "11231332", "12113242", "12122332", "12131422", "21231421", "22113331", "11213332", "22122421", "11222422", "22131511", "11231512", "12113422", "12122512", "21222511", "12231151", "13122151", "13131241", "11322151", "11331241", "12213151", "12222241", "12231331", "13113241", "13122331", "11313241", "13131421", "11322331", "11331421", "12213331", "12222421", "12231511", "13113421", "13122511", "11313421", "11322511", "21141151", "11132152", "11141242", "21123151", "21132241", "21141331", "11114152", "11123242", "11132332", "11141422", "21114241", "21123331", "21132421", "21141511", "11114332", "11123422", "11132512", "11241151", "12132151", "12141241", "11223151", "11232241", "11241331", "12114151", "12123241", "12132331", "12141421", "11214241", "11223331", "11232421", "11241511", "12114331", "12123421", "12132511", "11142151", "11151241", "11124151", "11133241", "11142331", "11151421", "11115241", "11124331", "11133421", "11142511", "21111253", "41111251", "11111344", "31111342", "21111433", "41111431", "11111524", "31111522", "21111613", "41111611", "21211162", "22111252", "11211253", "31211251", "12111343", "32111341", "21211342", "22111432", "11211433", "31211431", "12111523", "32111521", "21211522", "22111612", "11211613", "31211611", "22211161", "11311162", "23111251", "12211252", "21311251", "13111342", "22211341", "11311342", "23111431", "12211432", "21311431", "13111522", "22211521", "11311522", "23111611", "12211612", "21311611", "12311161", "13211251", "11411251", "14111341", "12311341", "13211431", "11411431", "14111521", "12311521", "13211611", "11411611", "31121161", "21112162", "21121252", "11112253", "31112251", "11121343", "31121341", "21112342", "21121432", "11112433", "31112431", "11121523", "31121521", "21112522", "21121612", "12121162", "21221161", "22112161", "11212162", "22121251", "11221252", "12112252", "12121342", "21221341", "22112341", "11212342", "22121431", "11221432", "12112432", "12121522", "21221521", "22112521", "11212522", "22121611", "11221612", "13121161", "11321161", "12212161", "12221251", "13112251", "13121341", "11312251", "11321341", "12212341", "12221431", "13112431", "13121521", "11312431", "11321521", "12212521", "12221611", "11131162", "21122161", "21131251", "11113162"])]); /*12493*/
		$1.parity = $a(["1001", "0101", "1100", "0011", "1010", "0110", "1111", "0000"]); /*12497*/
		$1.rowbits = $a($1.r); /*12500*/
		for (var _6J = 0, _6I = $1.r - 1; _6J <= _6I; _6J += 1) { /*12520*/
			$1.i = _6J; /*12502*/
			$k[$j++] = "p"; /*12503*/
			if ($1.i != ($1.r - 1)) { /*12503*/
				$k[$j++] = $get($1.parity, $1.i); /*12503*/
			} else { /*12503*/
				$k[$j++] = "0000"; /*12503*/
			} /*12503*/
			var _6P = $k[--$j]; /*12503*/
			$1[$k[--$j]] = _6P; /*12503*/
			$1.ccrow = $geti($1.ccs, $1.i * 8, 8); /*12504*/
			$k[$j++] = Infinity; /*12507*/
			for (var _6U = 0; _6U <= 7; _6U += 2) { /*12506*/
				$aload($geti($1.ccrow, _6U, 2)); /*12506*/
				var _6X = $k[--$j]; /*12506*/
				var _6Y = $k[--$j]; /*12506*/
				$k[$j++] = _6X + (_6Y * 49); /*12506*/
			} /*12506*/
			$1.scrow = $a(); /*12507*/
			$k[$j++] = Infinity; /*12515*/
			$k[$j++] = 10; /*12513*/
			$k[$j++] = 1; /*12513*/
			$k[$j++] = 1; /*12513*/
			for (var _6a = 0; _6a <= 3; _6a += 1) { /*12513*/
				$1.j = _6a; /*12511*/
				$forall($get($get($1.patterns, $get($1.p, $1.j) - 48), $get($1.scrow, $1.j)), function() { /*12512*/
					var _6k = $k[--$j]; /*12512*/
					$k[$j++] = _6k - 48; /*12512*/
				}); /*12512*/
			} /*12512*/
			$k[$j++] = 4; /*12514*/
			$k[$j++] = 1; /*12514*/
			$1.sbs = $a(); /*12515*/
			$k[$j++] = Infinity; /*12516*/
			var _6m = $1.sbs; /*12517*/
			$k[$j++] = 1; /*12517*/
			for (var _6n = 0, _6o = _6m.length; _6n < _6o; _6n++) { /*12517*/
				var _6q = $k[--$j]; /*12517*/
				var _6r = (_6q == 0) ? 1 : 0; /*12517*/
				$k[$j++] = _6q; /*12517*/
				for (var _6s = 0, _6t = $get(_6m, _6n); _6s < _6t; _6s++) { /*12517*/
					$k[$j++] = _6r /*12517*/
				} /*12517*/
			} /*12517*/
			$astore($a($counttomark() - 1)); /*12518*/
			var _6w = $k[--$j]; /*12518*/
			var _6x = $k[--$j]; /*12518*/
			var _6y = $k[--$j]; /*12518*/
			$put($1.rowbits, $1.i, _6w); /*12519*/
		} /*12519*/
		$k[$j++] = Infinity; /*12532*/
		for (var _72 = 0, _73 = 81 * $1.sepheight; _72 < _73; _72++) { /*12524*/
			$k[$j++] = 1; /*12524*/
		} /*12524*/
		for (var _76 = 0, _75 = $1.r - 2; _76 <= _75; _76 += 1) { /*12529*/
			$1.i = _76; /*12526*/
			for (var _78 = 0, _79 = $1.rowheight; _78 < _79; _78++) { /*12527*/
				$aload($get($1.rowbits, $1.i)); /*12527*/
			} /*12527*/
			for (var _7E = 0, _7F = $1.sepheight; _7E < _7F; _7E++) { /*12528*/
				for (var _7G = 0, _7H = 10; _7G < _7H; _7G++) { /*12528*/
					$k[$j++] = 0; /*12528*/
				} /*12528*/
				for (var _7I = 0, _7J = 70; _7I < _7J; _7I++) { /*12528*/
					$k[$j++] = 1; /*12528*/
				} /*12528*/
				$k[$j++] = 0; /*12528*/
			} /*12528*/
		} /*12528*/
		for (var _7L = 0, _7M = $1.rowheight; _7L < _7M; _7L++) { /*12530*/
			$aload($get($1.rowbits, $1.r - 1)); /*12530*/
		} /*12530*/
		for (var _7R = 0, _7S = 81 * $1.sepheight; _7R < _7S; _7R++) { /*12531*/
			$k[$j++] = 1; /*12531*/
		} /*12531*/
		$1.pixs = $a(); /*12532*/
		var _7Y = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: 81,
			pixy: ~~($1.pixs.length / 81),
			height: (~~($1.pixs.length / 81)) / 72,
			width: 81 / 72,
			opt: $1.options
		}; /*12542*/
		$k[$j++] = _7Y; /*12545*/
		if (!$1.dontdraw) { /*12545*/
			$0.renmatrix(); /*12545*/
		} /*12545*/
	};
	$0.channelcode = function() {
		var $1 = {}; /*12572*/
		$1.options = $k[--$j]; /*12574*/
		$1.barcode = $k[--$j]; /*12575*/
		$1.dontdraw = false; /*12577*/
		$1.shortfinder = false; /*12578*/
		$1.includetext = false; /*12579*/
		$1.includecheck = false; /*12580*/
		$1.height = 1; /*12581*/
		$forall($1.options, function() { /*12592*/
			var _3 = $k[--$j]; /*12592*/
			$1[$k[--$j]] = _3; /*12592*/
		}); /*12592*/
		$1.height = +$1.height; /*12594*/
		if (($1.barcode.length < 2) || ($1.barcode.length > 7)) { /*12599*/
			$k[$j++] = "bwipp.channelcodeBadLength"; /*12598*/
			$k[$j++] = "Channel Code must be 2 to 7 digits"; /*12598*/
			$0.raiseerror(); /*12598*/
		} /*12598*/
		$forall($1.barcode, function() { /*12604*/
			var _9 = $k[--$j]; /*12601*/
			if ((_9 < 48) || (_9 > 57)) { /*12603*/
				$k[$j++] = "bwipp.channelcodeBadCharacter"; /*12602*/
				$k[$j++] = "Channel Code must contain only digits"; /*12602*/
				$0.raiseerror(); /*12602*/
			} /*12602*/
		}); /*12602*/
		if ((~~$z($1.barcode)) > $get($a([26, 292, 3493, 44072, 576688, 7742862]), $1.barcode.length - 2)) { /*12607*/
			$k[$j++] = "bwipp.channelcodeTooBig"; /*12606*/
			$k[$j++] = "The Channel Code value is too big for the number of channels"; /*12606*/
			$0.raiseerror(); /*12606*/
		} /*12606*/
		$1.nextb = function() {
			var _E = $k[--$j]; /*12610*/
			var _N = (($get($1.s, _E) + ($get($1.b, _E - 1) + ($get($1.b, _E - 2) + $get($1.s, _E - 1)))) > 4) ? 1 : 2; /*12615*/
			$k[$j++] = _E; /*12631*/
			$k[$j++] = _N; /*12631*/
			if (_E < ($1.chan + 2)) { /*12629*/
				var _P = $k[--$j]; /*12617*/
				var _Q = $k[--$j]; /*12617*/
				var _R = $k[--$j]; /*12617*/
				$k[$j++] = _R; /*12620*/
				$k[$j++] = _Q; /*12620*/
				$k[$j++] = _P; /*12620*/
				for (var _T = _P, _S = _R; _T <= _S; _T += 1) { /*12620*/
					var _V = $k[--$j]; /*12618*/
					var _W = $k[--$j]; /*12618*/
					$put($1.b, _W, _T); /*12618*/
					var _X = $k[--$j]; /*12619*/
					var _Y = $k[--$j]; /*12619*/
					$k[$j++] = _Y; /*12619*/
					$k[$j++] = _X; /*12619*/
					$k[$j++] = _W; /*12619*/
					$k[$j++] = _V; /*12619*/
					$k[$j++] = (_X - _T) + 1; /*12619*/
					$k[$j++] = _Y; /*12619*/
					$k[$j++] = _W + 1; /*12619*/
					$1.nexts(); /*12619*/
				} /*12619*/
			} else { /*12629*/
				var _Z = $k[--$j]; /*12622*/
				var _a = $k[--$j]; /*12622*/
				var _b = $k[--$j]; /*12622*/
				$k[$j++] = _b; /*12630*/
				$k[$j++] = _a; /*12630*/
				$k[$j++] = _Z; /*12630*/
				if ($le(_Z, _b)) { /*12630*/
					var _d = $k[--$j]; /*12623*/
					var _e = $k[--$j]; /*12623*/
					var _f = $k[--$j]; /*12623*/
					$put($1.b, _e, _f); /*12623*/
					$k[$j++] = _f; /*12628*/
					$k[$j++] = _e; /*12628*/
					$k[$j++] = _d; /*12628*/
					if ($1.value == $1.target) { /*12628*/
						$k[$j++] = "out"; /*12627*/
						$k[$j++] = Infinity; /*12627*/
						for (var _i = 3; _i <= 10; _i += 1) { /*12626*/
							$k[$j++] = $get($1.s, _i); /*12626*/
							$k[$j++] = $get($1.b, _i); /*12626*/
						} /*12626*/
						var _p = $geti($a(), 0, $1.chan * 2); /*12627*/
						$1[$k[--$j]] = _p; /*12627*/
					} /*12627*/
					$1.value = $1.value + 1; /*12629*/
				} /*12629*/
			} /*12629*/
			$j -= 4; /*12632*/
		}; /*12633*/
		$1.nexts = function() {
			var _s = $k[--$j]; /*12636*/
			$k[$j++] = _s; /*12636*/
			if (_s < ($1.chan + 2)) { /*12636*/
				$k[$j++] = 1; /*12636*/
			} else { /*12636*/
				var _u = $k[--$j]; /*12636*/
				var _v = $k[--$j]; /*12636*/
				$k[$j++] = _v; /*12636*/
				$k[$j++] = _u; /*12636*/
				$k[$j++] = _v; /*12636*/
			} /*12636*/
			var _w = $k[--$j]; /*12636*/
			var _x = $k[--$j]; /*12636*/
			var _y = $k[--$j]; /*12636*/
			$k[$j++] = _y; /*12639*/
			$k[$j++] = _x; /*12639*/
			for (var _10 = _w, _z = _y; _10 <= _z; _10 += 1) { /*12639*/
				var _12 = $k[--$j]; /*12637*/
				$put($1.s, _12, _10); /*12637*/
				var _13 = $k[--$j]; /*12638*/
				var _14 = $k[--$j]; /*12638*/
				$k[$j++] = _14; /*12638*/
				$k[$j++] = _13; /*12638*/
				$k[$j++] = _12; /*12638*/
				$k[$j++] = (_13 - _10) + 1; /*12638*/
				$k[$j++] = _14; /*12638*/
				$k[$j++] = _12; /*12638*/
				$1.nextb(); /*12638*/
			} /*12638*/
			$j -= 3; /*12640*/
		}; /*12641*/
		$1.encode = function() {
			$1.chan = $k[--$j]; /*12644*/
			$1.target = $k[--$j]; /*12645*/
			$1.value = 0; /*12646*/
			$1.out = -1; /*12647*/
			$1.b = $a([1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0]); /*12648*/
			$1.s = $a([0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0]); /*12649*/
			var _19 = $1.chan; /*12650*/
			$k[$j++] = _19; /*12650*/
			$k[$j++] = _19; /*12650*/
			$k[$j++] = 3; /*12650*/
			$1.nexts(); /*12650*/
			$k[$j++] = $1.out; /*12651*/
		}; /*12652*/
		$1.barlen = $1.barcode.length; /*12654*/
		$k[$j++] = "finder"; /*12657*/
		if ($1.shortfinder) { /*12657*/
			$k[$j++] = $a([1, 1, 1, 1, 1]); /*12657*/
		} else { /*12657*/
			$k[$j++] = $a([1, 1, 1, 1, 1, 1, 1, 1, 1]); /*12657*/
		} /*12657*/
		var _1F = $k[--$j]; /*12657*/
		$1[$k[--$j]] = _1F; /*12657*/
		$k[$j++] = "data"; /*12660*/
		$k[$j++] = ~~$z($1.barcode); /*12660*/
		$k[$j++] = $1.barlen + 1; /*12660*/
		$1.encode(); /*12660*/
		var _1J = $k[--$j]; /*12660*/
		$1[$k[--$j]] = _1J; /*12660*/
		$1.check = $a([]); /*12663*/
		if ($1.includecheck) { /*12679*/
			$1.mod23 = $get($a([$a([]), $a([]), $a([13, 12, 4, 9, 3, 1]), $a([13, 2, 12, 3, 18, 16, 4, 1]), $a([11, 16, 17, 8, 20, 4, 10, 2, 5, 1]), $a([1, 4, 16, 18, 3, 12, 2, 8, 9, 13, 6, 1]), $a([20, 16, 22, 13, 15, 12, 5, 4, 8, 9, 21, 3, 7, 1]), $a([2, 6, 18, 8, 1, 3, 9, 4, 12, 13, 16, 2, 6, 18, 8, 1])]), $1.barlen); /*12673*/
			$k[$j++] = 0; /*12677*/
			for (var _1a = 0, _1Z = $1.data.length - 1; _1a <= _1Z; _1a += 1) { /*12677*/
				var _1f = $k[--$j]; /*12676*/
				$k[$j++] = _1f + (($get($1.data, _1a) - 1) * $get($1.mod23, _1a)); /*12676*/
			} /*12676*/
			var _1g = $k[--$j]; /*12678*/
			$k[$j++] = _1g % 23; /*12678*/
			$k[$j++] = 3; /*12678*/
			$1.encode(); /*12678*/
			$1.check = $k[--$j]; /*12678*/
		} /*12678*/
		$k[$j++] = Infinity; /*12686*/
		$aload($1.finder); /*12683*/
		$aload($1.data); /*12684*/
		$aload($1.check); /*12685*/
		$1.sbs = $a(); /*12686*/
		$1.txt = $a($1.barlen); /*12689*/
		for (var _1q = 0, _1p = $1.barlen - 1; _1q <= _1p; _1q += 1) { /*12693*/
			$1.i = _1q; /*12691*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*12692*/
		} /*12692*/
		$k[$j++] = Infinity; /*12703*/
		$k[$j++] = "ren"; /*12700*/
		$k[$j++] = $0.renlinear; /*12700*/
		$k[$j++] = "sbs"; /*12700*/
		$k[$j++] = $1.sbs; /*12700*/
		$k[$j++] = "bhs"; /*12700*/
		$k[$j++] = Infinity; /*12700*/
		for (var _1z = 0, _20 = ~~(($1.sbs.length + 1) / 2); _1z < _20; _1z++) { /*12699*/
			$k[$j++] = $1.height; /*12699*/
		} /*12699*/
		var _22 = $a(); /*12700*/
		$k[$j++] = _22; /*12701*/
		$k[$j++] = "bbs"; /*12701*/
		$k[$j++] = Infinity; /*12701*/
		for (var _24 = 0, _25 = ~~(($1.sbs.length + 1) / 2); _24 < _25; _24++) { /*12700*/
			$k[$j++] = 0; /*12700*/
		} /*12700*/
		var _26 = $a(); /*12701*/
		$k[$j++] = _26; /*12703*/
		$k[$j++] = "txt"; /*12703*/
		$k[$j++] = $1.txt; /*12703*/
		$k[$j++] = "textxalign"; /*12703*/
		$k[$j++] = "center"; /*12703*/
		$k[$j++] = "opt"; /*12703*/
		$k[$j++] = $1.options; /*12703*/
		var _29 = $d(); /*12703*/
		$k[$j++] = _29; /*12706*/
		if (!$1.dontdraw) { /*12706*/
			$0.renlinear(); /*12706*/
		} /*12706*/
	};
	$0.flattermarken = function() {
		var $1 = {}; /*12733*/
		$1.options = $k[--$j]; /*12735*/
		$1.barcode = $k[--$j]; /*12736*/
		$1.dontdraw = false; /*12738*/
		$1.includetext = false; /*12739*/
		$1.textfont = "Courier"; /*12740*/
		$1.textsize = 10; /*12741*/
		$1.textyoffset = -8.5; /*12742*/
		$1.height = 0.3; /*12743*/
		$forall($1.barcode, function() { /*12750*/
			var _3 = $k[--$j]; /*12747*/
			if ((_3 < 48) || (_3 > 57)) { /*12749*/
				$k[$j++] = "bwipp.flattermarkenBadCharacter"; /*12748*/
				$k[$j++] = "Flattermarken must contain only digits"; /*12748*/
				$0.raiseerror(); /*12748*/
			} /*12748*/
		}); /*12748*/
		$forall($1.options, function() { /*12761*/
			var _5 = $k[--$j]; /*12761*/
			$1[$k[--$j]] = _5; /*12761*/
		}); /*12761*/
		$1.textfont = "" + $1.textfont; /*12763*/
		$1.textsize = +$1.textsize; /*12764*/
		$1.textyoffset = +$1.textyoffset; /*12765*/
		$1.height = +$1.height; /*12766*/
		$forall($1.barcode, function() { /*12773*/
			var _C = $k[--$j]; /*12770*/
			if ((_C < 48) || (_C > 57)) { /*12772*/
				$k[$j++] = "bwipp.flattermarkenBadCharacter"; /*12771*/
				$k[$j++] = "Flattermarken must contain only digits"; /*12771*/
				$0.raiseerror(); /*12771*/
			} /*12771*/
		}); /*12771*/
		$1.encs = $a(["0018", "0117", "0216", "0315", "0414", "0513", "0612", "0711", "0810", "0900"]); /*12779*/
		$1.barchars = "1234567890"; /*12782*/
		$1.barlen = $1.barcode.length; /*12784*/
		$1.sbs = $s($1.barlen * 4); /*12786*/
		$1.txt = $a($1.barlen); /*12787*/
		for (var _L = 0, _K = $1.barlen - 1; _L <= _K; _L += 1) { /*12799*/
			$1.i = _L; /*12790*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*12792*/
			$j--; /*12793*/
			$1.indx = $k[--$j].length; /*12794*/
			$j -= 2; /*12795*/
			$1.enc = $get($1.encs, $1.indx); /*12796*/
			$puti($1.sbs, $1.i * 4, $1.enc); /*12797*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.i * 9, $1.textyoffset, $1.textfont, $1.textsize])); /*12798*/
		} /*12798*/
		$k[$j++] = Infinity; /*12808*/
		$k[$j++] = "ren"; /*12805*/
		$k[$j++] = $0.renlinear; /*12805*/
		$k[$j++] = "sbs"; /*12805*/
		$k[$j++] = Infinity; /*12805*/
		var _h = $1.sbs; /*12804*/
		for (var _i = 0, _j = _h.length; _i < _j; _i++) { /*12804*/
			$k[$j++] = $get(_h, _i) - 48; /*12804*/
		} /*12804*/
		var _l = $a(); /*12805*/
		$k[$j++] = _l; /*12806*/
		$k[$j++] = "bhs"; /*12806*/
		$k[$j++] = Infinity; /*12806*/
		for (var _n = 0, _o = ~~(($1.sbs.length + 1) / 2); _n < _o; _n++) { /*12805*/
			$k[$j++] = $1.height; /*12805*/
		} /*12805*/
		var _q = $a(); /*12806*/
		$k[$j++] = _q; /*12807*/
		$k[$j++] = "bbs"; /*12807*/
		$k[$j++] = Infinity; /*12807*/
		for (var _s = 0, _t = ~~(($1.sbs.length + 1) / 2); _s < _t; _s++) { /*12806*/
			$k[$j++] = 0; /*12806*/
		} /*12806*/
		var _u = $a(); /*12807*/
		$k[$j++] = _u; /*12808*/
		$k[$j++] = "txt"; /*12808*/
		$k[$j++] = $1.txt; /*12808*/
		$k[$j++] = "opt"; /*12808*/
		$k[$j++] = $1.options; /*12808*/
		var _x = $d(); /*12808*/
		$k[$j++] = _x; /*12811*/
		if (!$1.dontdraw) { /*12811*/
			$0.renlinear(); /*12811*/
		} /*12811*/
	};
	$0.raw = function() {
		var $1 = {}; /*12838*/
		$1.options = $k[--$j]; /*12840*/
		$1.barcode = $k[--$j]; /*12841*/
		$1.dontdraw = false; /*12843*/
		$1.height = 1; /*12844*/
		$forall($1.options, function() { /*12855*/
			var _3 = $k[--$j]; /*12855*/
			$1[$k[--$j]] = _3; /*12855*/
		}); /*12855*/
		$1.height = +$1.height; /*12857*/
		$forall($1.barcode, function() { /*12864*/
			var _7 = $k[--$j]; /*12861*/
			if ((_7 < 49) || (_7 > 57)) { /*12863*/
				$k[$j++] = "bwipp.rawBadCharacter"; /*12862*/
				$k[$j++] = "Raw must contain only digits 1 to 9"; /*12862*/
				$0.raiseerror(); /*12862*/
			} /*12862*/
		}); /*12862*/
		$k[$j++] = Infinity; /*12872*/
		$k[$j++] = "ren"; /*12870*/
		$k[$j++] = $0.renlinear; /*12870*/
		$k[$j++] = "sbs"; /*12870*/
		$k[$j++] = Infinity; /*12870*/
		$forall($1.barcode, function() { /*12869*/
			var _9 = $k[--$j]; /*12869*/
			$k[$j++] = _9 - 48; /*12869*/
		}); /*12869*/
		var _A = $a(); /*12870*/
		$k[$j++] = _A; /*12871*/
		$k[$j++] = "bhs"; /*12871*/
		$k[$j++] = Infinity; /*12871*/
		for (var _C = 0, _D = ~~(($1.barcode.length + 1) / 2); _C < _D; _C++) { /*12870*/
			$k[$j++] = $1.height; /*12870*/
		} /*12870*/
		var _F = $a(); /*12871*/
		$k[$j++] = _F; /*12872*/
		$k[$j++] = "bbs"; /*12872*/
		$k[$j++] = Infinity; /*12872*/
		for (var _H = 0, _I = ~~(($1.barcode.length + 1) / 2); _H < _I; _H++) { /*12871*/
			$k[$j++] = 0; /*12871*/
		} /*12871*/
		var _J = $a(); /*12872*/
		$k[$j++] = _J; /*12872*/
		$k[$j++] = "opt"; /*12872*/
		$k[$j++] = $1.options; /*12872*/
		var _L = $d(); /*12872*/
		$k[$j++] = _L; /*12875*/
		if (!$1.dontdraw) { /*12875*/
			$0.renlinear(); /*12875*/
		} /*12875*/
	};
	$0.daft = function() {
		var $1 = {}; /*12902*/
		$1.options = $k[--$j]; /*12904*/
		$1.barcode = $k[--$j]; /*12905*/
		$1.dontdraw = false; /*12907*/
		$1.height = 0.175; /*12908*/
		$forall($1.options, function() { /*12919*/
			var _3 = $k[--$j]; /*12919*/
			$1[$k[--$j]] = _3; /*12919*/
		}); /*12919*/
		$1.height = +$1.height; /*12921*/
		$forall($1.barcode, function() { /*12927*/
			var _7 = $k[--$j]; /*12924*/
			if ((_7 != 68) && ((_7 != 65) && ((_7 != 70) && (_7 != 84)))) { /*12926*/
				$k[$j++] = "bwipp.daftBadCharacter"; /*12925*/
				$k[$j++] = "DAFT must contain only characters D, A, F and T"; /*12925*/
				$0.raiseerror(); /*12925*/
			} /*12925*/
		}); /*12925*/
		$1.barlen = $1.barcode.length; /*12929*/
		$1.bbs = $a($1.barlen); /*12931*/
		$1.bhs = $a($1.barlen); /*12932*/
		for (var _F = 0, _E = $1.barlen - 1; _F <= _E; _F += 1) { /*12952*/
			$1.i = _F; /*12934*/
			$1.enc = $geti($1.barcode, $1.i, 1); /*12935*/
			if ($eq($1.enc, "D")) { /*12939*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*12937*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*12938*/
			} /*12938*/
			if ($eq($1.enc, "A")) { /*12943*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*12941*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*12942*/
			} /*12942*/
			if ($eq($1.enc, "F")) { /*12947*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*12945*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*12946*/
			} /*12946*/
			if ($eq($1.enc, "T")) { /*12951*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*12949*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*12950*/
			} /*12950*/
		} /*12950*/
		$k[$j++] = Infinity; /*12960*/
		$k[$j++] = "ren"; /*12960*/
		$k[$j++] = $0.renlinear; /*12960*/
		$k[$j++] = "bbs"; /*12960*/
		$k[$j++] = $1.bbs; /*12960*/
		$k[$j++] = "bhs"; /*12960*/
		$k[$j++] = $1.bhs; /*12960*/
		$k[$j++] = "sbs"; /*12960*/
		$k[$j++] = Infinity; /*12960*/
		for (var _o = 0, _p = $1.bhs.length - 1; _o < _p; _o++) { /*12959*/
			$k[$j++] = 1.44; /*12959*/
			$k[$j++] = 1.872; /*12959*/
		} /*12959*/
		$k[$j++] = 1.44; /*12959*/
		var _q = $a(); /*12960*/
		$k[$j++] = _q; /*12960*/
		$k[$j++] = "opt"; /*12960*/
		$k[$j++] = $1.options; /*12960*/
		var _s = $d(); /*12960*/
		$k[$j++] = _s; /*12963*/
		if (!$1.dontdraw) { /*12963*/
			$0.renlinear(); /*12963*/
		} /*12963*/
	};
	$0.symbol = function() {
		var $1 = {}; /*12990*/
		$1.options = $k[--$j]; /*12992*/
		$1.barcode = $k[--$j]; /*12993*/
		$1.dontdraw = false; /*12995*/
		$forall($1.options, function() { /*13006*/
			var _3 = $k[--$j]; /*13006*/
			$1[$k[--$j]] = _3; /*13006*/
		}); /*13006*/
		var _H = {
			fima: function() {
				$1.sbs = $a([2.25, 2.25, 2.25, 11.25, 2.25, 11.25, 2.25, 2.25, 2.25]); /*13010*/
				$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625]); /*13011*/
				$1.bbs = $a([0, 0, 0, 0, 0]); /*13012*/
			},
			fimb: function() {
				$1.sbs = $a([2.25, 6.75, 2.25, 2.25, 2.25, 6.25, 2.25, 2.25, 2.25, 6.75, 2.25]); /*13015*/
				$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13016*/
				$1.bbs = $a([0, 0, 0, 0, 0, 0]); /*13017*/
			},
			fimc: function() {
				$1.sbs = $a([2.25, 2.25, 2.25, 6.75, 2.25, 6.75, 2.25, 6.75, 2.25, 2.25, 2.25]); /*13020*/
				$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13021*/
				$1.bbs = $a([0, 0, 0, 0, 0, 0]); /*13022*/
			},
			fimd: function() {
				$1.sbs = $a([2.25, 2.25, 2.25, 2.25, 2.25, 6.75, 2.25, 6.75, 2.25, 2.25, 2.25, 2.25, 2.25]); /*13025*/
				$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13026*/
				$1.bbs = $a([0, 0, 0, 0, 0, 0, 0]); /*13027*/
			}
		}; /*13027*/
		$1.symbols = _H; /*13029*/
		var _K = $get($1.symbols, $1.barcode) !== undefined; /*13032*/
		if (!_K) { /*13034*/
			$k[$j++] = "bwipp.symbolUnknownSymbol"; /*13033*/
			$k[$j++] = "Unknown symbol name provided"; /*13033*/
			$0.raiseerror(); /*13033*/
		} /*13033*/
		$get($1.symbols, $1.barcode)(); /*13036*/
		var _S = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			opt: $1.options
		}; /*13044*/
		$k[$j++] = _S; /*13047*/
		if (!$1.dontdraw) { /*13047*/
			$0.renlinear(); /*13047*/
		} /*13047*/
	};
	$0.pdf417 = function() {
		var $1 = {}; /*13074*/
		$1.options = $k[--$j]; /*13076*/
		$1.barcode = $k[--$j]; /*13077*/
		$1.dontdraw = false; /*13079*/
		$1.compact = false; /*13080*/
		$1.eclevel = -1; /*13081*/
		$1.columns = 0; /*13082*/
		$1.rows = 0; /*13083*/
		$1.rowmult = 3; /*13084*/
		$1.encoding = "auto"; /*13085*/
		$1.ccc = false; /*13086*/
		$1.raw = false; /*13087*/
		$1.parse = false; /*13088*/
		$forall($1.options, function() { /*13099*/
			var _3 = $k[--$j]; /*13099*/
			$1[$k[--$j]] = _3; /*13099*/
		}); /*13099*/
		$1.eclevel = ~~$1.eclevel; /*13101*/
		$1.columns = ~~$1.columns; /*13102*/
		$1.rows = ~~$1.rows; /*13103*/
		$1.rowmult = +$1.rowmult; /*13104*/
		if ($1.raw) { /*13127*/
			$1.encoding = "raw"; /*13127*/
		} /*13127*/
		if ($eq($1.encoding, "raw")) { /*13141*/
			$1.datcws = $a($1.barcode.length); /*13131*/
			$1.i = 0; /*13132*/
			$1.j = 0; /*13132*/
			for (;;) { /*13139*/
				if ($1.i == $1.barcode.length) { /*13134*/
					break; /*13134*/
				} /*13134*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*13135*/
				$put($1.datcws, $1.j, $1.cw); /*13136*/
				$1.i = $1.i + 4; /*13137*/
				$1.j = $1.j + 1; /*13138*/
			} /*13138*/
			$1.datcws = $geti($1.datcws, 0, $1.j); /*13140*/
		} /*13140*/
		$k[$j++] = Infinity; /*13143*/
		$forall($1.barcode); /*13143*/
		$1.barcode = $a(); /*13143*/
		$1.barlen = $1.barcode.length; /*13144*/
		if ($1.ccc) { /*13146*/
			$1.encoding = "ccc"; /*13146*/
		} /*13146*/
		$1.encb = function() {
			$1.in = $k[--$j]; /*13149*/
			$1.inlen = $1.in.length; /*13150*/
			$1.out = $a(((~~($1.inlen / 6)) * 5) + ($1.inlen % 6)); /*13151*/
			for (var _b = 0, _a = (~~($1.inlen / 6)) - 1; _b <= _a; _b += 1) { /*13174*/
				$1.k = _b; /*13153*/
				$k[$j++] = Infinity; /*13154*/
				$aload($geti($1.in, $1.k * 6, 3)); /*13154*/
				$1.msbs = $a(); /*13154*/
				$k[$j++] = Infinity; /*13158*/
				$aload($1.msbs); /*13156*/
				var _h = $k[--$j]; /*13156*/
				var _i = $k[--$j]; /*13156*/
				var _j = $k[--$j]; /*13156*/
				$k[$j++] = (_h + (_i * 256)) + (_j * 65536); /*13157*/
				for (var _k = 0, _l = 3; _k < _l; _k++) { /*13157*/
					var _m = $k[--$j]; /*13157*/
					$k[$j++] = _m % 900; /*13157*/
					$k[$j++] = ~~(_m / 900); /*13157*/
				} /*13157*/
				$1.mscs = $a(); /*13158*/
				$k[$j++] = Infinity; /*13159*/
				$aload($geti($1.in, ($1.k * 6) + 3, 3)); /*13159*/
				$1.lsbs = $a(); /*13159*/
				$k[$j++] = Infinity; /*13163*/
				$aload($1.lsbs); /*13161*/
				var _t = $k[--$j]; /*13161*/
				var _u = $k[--$j]; /*13161*/
				var _v = $k[--$j]; /*13161*/
				$k[$j++] = (_t + (_u * 256)) + (_v * 65536); /*13162*/
				for (var _w = 0, _x = 3; _w < _x; _w++) { /*13162*/
					var _y = $k[--$j]; /*13162*/
					$k[$j++] = _y % 900; /*13162*/
					$k[$j++] = ~~(_y / 900); /*13162*/
				} /*13162*/
				$1.lscs = $a(); /*13163*/
				var _11 = $get($1.lscs, 0); /*13164*/
				var _13 = $get($1.mscs, 0); /*13164*/
				$put($1.out, ($1.k * 5) + 4, (_11 + (_13 * 316)) % 900); /*13165*/
				var _17 = $get($1.lscs, 1); /*13166*/
				var _19 = $get($1.mscs, 0); /*13166*/
				var _1B = $get($1.mscs, 1); /*13166*/
				$put($1.out, ($1.k * 5) + 3, ((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) % 900); /*13167*/
				var _1F = $get($1.lscs, 2); /*13168*/
				var _1H = $get($1.mscs, 0); /*13168*/
				var _1J = $get($1.mscs, 1); /*13168*/
				var _1L = $get($1.mscs, 2); /*13168*/
				$put($1.out, ($1.k * 5) + 2, (((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) % 900); /*13169*/
				var _1P = $get($1.lscs, 3); /*13170*/
				var _1R = $get($1.mscs, 1); /*13170*/
				var _1T = $get($1.mscs, 2); /*13170*/
				$put($1.out, ($1.k * 5) + 1, ((((~~((((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) / 900)) + _1P) + (_1R * 20)) + (_1T * 641)) % 900); /*13171*/
				$put($1.out, $1.k * 5, ((~~(((((~~((((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) / 900)) + _1P) + (_1R * 20)) + (_1T * 641)) / 900)) + ($get($1.mscs, 2) * 20)) % 900); /*13173*/
			} /*13173*/
			$1.rem = $1.inlen % 6; /*13175*/
			if ($1.rem != 0) { /*13180*/
				$k[$j++] = $1.out; /*13178*/
				$k[$j++] = $1.out.length - $1.rem; /*13178*/
				$k[$j++] = Infinity; /*13178*/
				$aload($geti($1.in, $1.inlen - $1.rem, $1.rem)); /*13178*/
				var _1k = $a(); /*13178*/
				var _1l = $k[--$j]; /*13179*/
				$puti($k[--$j], _1l, _1k); /*13179*/
			} /*13179*/
			$k[$j++] = $1.out; /*13181*/
		}; /*13182*/
		if ($eq($1.encoding, "byte") || $eq($1.encoding, "ccc")) { /*13189*/
			$1.datcws = $a((((~~($1.barlen / 6)) * 5) + ($1.barlen % 6)) + 1); /*13185*/
			var _1v = (($1.barlen % 6) == 0) ? 924 : 901; /*13186*/
			$put($1.datcws, 0, _1v); /*13186*/
			$k[$j++] = $1.datcws; /*13187*/
			$k[$j++] = 1; /*13187*/
			$k[$j++] = $1.barcode; /*13187*/
			$1.encb(); /*13187*/
			var _1y = $k[--$j]; /*13187*/
			var _1z = $k[--$j]; /*13187*/
			$puti($k[--$j], _1z, _1y); /*13187*/
			if ($eq($1.encoding, "ccc")) { /*13188*/
				$k[$j++] = Infinity; /*13188*/
				$k[$j++] = 920; /*13188*/
				$aload($1.datcws); /*13188*/
				$1.datcws = $a(); /*13188*/
			} /*13188*/
		} /*13188*/
		if ($eq($1.encoding, "auto")) { /*13553*/
			$1.T = 0; /*13194*/
			$1.N = 1; /*13194*/
			$1.B = 2; /*13194*/
			$1.A = 0; /*13195*/
			$1.L = 1; /*13195*/
			$1.M = 2; /*13195*/
			$1.P = 3; /*13195*/
			$1.tl = -1; /*13198*/
			$1.nl = -2; /*13198*/
			$1.bl = -3; /*13198*/
			$1.bl6 = -4; /*13198*/
			$1.bs = -5; /*13198*/
			$1.al = -6; /*13201*/
			$1.ll = -7; /*13201*/
			$1.ml = -8; /*13201*/
			$1.pl = -9; /*13201*/
			$1.as = -10; /*13201*/
			$1.ps = -11; /*13201*/
			$1.charmaps = $a([$a(["A", "a", "0", ";"]), $a(["B", "b", "1", "<"]), $a(["C", "c", "2", ">"]), $a(["D", "d", "3", "@"]), $a(["E", "e", "4", "["]), $a(["F", "f", "5", 92]), $a(["G", "g", "6", "]"]), $a(["H", "h", "7", "_"]), $a(["I", "i", "8", "`"]), $a(["J", "j", "9", "~"]), $a(["K", "k", "&", "!"]), $a(["L", "l", 13, 13]), $a(["M", "m", 9, 9]), $a(["N", "n", ",", ","]), $a(["O", "o", ":", ":"]), $a(["P", "p", "#", 10]), $a(["Q", "q", "-", "-"]), $a(["R", "r", ".", "."]), $a(["S", "s", "$", "$"]), $a(["T", "t", "/", "/"]), $a(["U", "u", "+", "\""]), $a(["V", "v", "%", "|"]), $a(["W", "w", "*", "*"]), $a(["X", "x", "=", 40]), $a(["Y", "y", "^", 41]), $a(["Z", "z", $1.pl, "?"]), $a([" ", " ", " ", "{"]), $a([$1.ll, $1.as, $1.ll, "}"]), $a([$1.ml, $1.ml, $1.al, "'"]), $a([$1.ps, $1.ps, $1.ps, $1.al])]); /*13236*/
			$1.charvals = $a([{}, {}, {}, {}]); /*13239*/
			$1.alltext = {}; /*13240*/
			for (var _2o = 0, _2n = $1.charmaps.length - 1; _2o <= _2n; _2o += 1) { /*13250*/
				$1.i = _2o; /*13242*/
				$1.encs = $get($1.charmaps, $1.i); /*13243*/
				for (var _2s = 0; _2s <= 3; _2s += 1) { /*13249*/
					$1.j = _2s; /*13245*/
					var _2v = $get($1.encs, $1.j); /*13246*/
					$k[$j++] = _2v; /*13246*/
					if ($eq($type(_2v), "stringtype")) { /*13246*/
						var _2y = $get($k[--$j], 0); /*13246*/
						$k[$j++] = _2y; /*13246*/
					} /*13246*/
					var _2z = $k[--$j]; /*13247*/
					$put($get($1.charvals, $1.j), _2z, $1.i); /*13247*/
					$put($1.alltext, _2z, -1); /*13248*/
				} /*13248*/
			} /*13248*/
			$1.e = 10000; /*13252*/
			$1.latlen = $a([$a([0, 1, 1, 2]), $a([2, 0, 1, 2]), $a([1, 1, 0, 1]), $a([1, 2, 2, 0])]); /*13260*/
			$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.ml, $1.al]), $a([]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.al]), $a([$1.ll]), $a([]), $a([$1.pl])]), $a([$a([$1.al]), $a([$1.al, $1.ll]), $a([$1.al, $1.ml]), $a([])])]); /*13268*/
			$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 1]), $a([1, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, $1.e])]); /*13276*/
			$k[$j++] = Infinity; /*13279*/
			for (var _44 = 0, _45 = $1.barlen; _44 < _45; _44++) { /*13279*/
				$k[$j++] = 0; /*13279*/
			} /*13279*/
			$k[$j++] = 0; /*13279*/
			$1.numdigits = $a(); /*13279*/
			$k[$j++] = Infinity; /*13280*/
			for (var _48 = 0, _49 = $1.barlen; _48 < _49; _48++) { /*13280*/
				$k[$j++] = 0; /*13280*/
			} /*13280*/
			$k[$j++] = 0; /*13280*/
			$1.numtext = $a(); /*13280*/
			$k[$j++] = Infinity; /*13281*/
			for (var _4C = 0, _4D = $1.barlen; _4C < _4D; _4C++) { /*13281*/
				$k[$j++] = 0; /*13281*/
			} /*13281*/
			$k[$j++] = 0; /*13281*/
			$1.numbytes = $a(); /*13281*/
			for (var _4G = $1.barlen - 1; _4G >= 0; _4G -= 1) { /*13293*/
				$1.i = _4G; /*13283*/
				var _4J = $get($1.barcode, $1.i); /*13284*/
				if ((_4J >= 48) && (_4J <= 57)) { /*13286*/
					$put($1.numdigits, $1.i, $get($1.numdigits, $1.i + 1) + 1); /*13285*/
				} /*13285*/
				var _4T = $get($1.alltext, $get($1.barcode, $1.i)) !== undefined; /*13287*/
				if (_4T && ($get($1.numdigits, $1.i) < 13)) { /*13289*/
					$put($1.numtext, $1.i, $get($1.numtext, $1.i + 1) + 1); /*13288*/
				} /*13288*/
				if (($get($1.numtext, $1.i) < 5) && ($get($1.numdigits, $1.i) < 13)) { /*13292*/
					$put($1.numbytes, $1.i, $get($1.numbytes, $1.i + 1) + 1); /*13291*/
				} /*13291*/
			} /*13291*/
			$1.numdigits = $geti($1.numdigits, 0, $1.barlen); /*13294*/
			$1.numtext = $geti($1.numtext, 0, $1.barlen); /*13295*/
			$1.numbytes = $geti($1.numbytes, 0, $1.barlen); /*13296*/
			$1.seq = $a([]); /*13298*/
			$1.seqlen = 0; /*13298*/
			$1.state = $1.T; /*13298*/
			$1.p = 0; /*13298*/
			for (;;) { /*13341*/
				if ($1.p == $1.barlen) { /*13299*/
					break; /*13299*/
				} /*13299*/
				$1.n = $get($1.numdigits, $1.p); /*13300*/
				if ($1.n >= 13) { /*13339*/
					$k[$j++] = Infinity; /*13306*/
					$aload($1.seq); /*13303*/
					$k[$j++] = $1.nl; /*13305*/
					$k[$j++] = Infinity; /*13305*/
					$aload($geti($1.barcode, $1.p, $1.n)); /*13305*/
					var _5A = $a(); /*13305*/
					$k[$j++] = _5A; /*13305*/
					$1.seq = $a(); /*13306*/
					$1.state = $1.N; /*13307*/
					$1.p = $1.p + $1.n; /*13308*/
					$1.seqlen = ($1.seqlen + 1) + $1.n; /*13309*/
				} else { /*13339*/
					$1.t = $get($1.numtext, $1.p); /*13311*/
					if ($1.t >= 5) { /*13339*/
						$k[$j++] = Infinity; /*13317*/
						$aload($1.seq); /*13314*/
						if ($1.state != $1.T) { /*13315*/
							$k[$j++] = $1.tl; /*13315*/
						} /*13315*/
						$k[$j++] = Infinity; /*13316*/
						$aload($geti($1.barcode, $1.p, $1.t)); /*13316*/
						var _5T = $a(); /*13316*/
						$k[$j++] = _5T; /*13316*/
						$1.seq = $a(); /*13317*/
						$1.state = $1.T; /*13318*/
						$1.p = $1.p + $1.t; /*13319*/
						$1.seqlen = ($1.seqlen + 1) + $1.t; /*13320*/
					} else { /*13339*/
						$1.b = $get($1.numbytes, $1.p); /*13322*/
						if (($1.b == 1) && ($1.state == $1.T)) { /*13339*/
							$k[$j++] = Infinity; /*13328*/
							$aload($1.seq); /*13325*/
							$k[$j++] = $1.bs; /*13327*/
							$k[$j++] = $a([$get($1.barcode, $1.p)]); /*13327*/
							$1.seq = $a(); /*13328*/
							$1.p = $1.p + $1.b; /*13329*/
							$1.seqlen = $1.seqlen + 2; /*13330*/
						} else { /*13339*/
							$k[$j++] = Infinity; /*13336*/
							$aload($1.seq); /*13333*/
							if (($1.b % 6) != 0) { /*13334*/
								$k[$j++] = $1.bl; /*13334*/
							} else { /*13334*/
								$k[$j++] = $1.bl6; /*13334*/
							} /*13334*/
							$k[$j++] = Infinity; /*13335*/
							$aload($geti($1.barcode, $1.p, $1.b)); /*13335*/
							var _5y = $a(); /*13335*/
							$k[$j++] = _5y; /*13335*/
							$1.seq = $a(); /*13336*/
							$1.state = $1.B; /*13337*/
							$1.p = $1.p + $1.b; /*13338*/
							$1.seqlen = ($1.seqlen + 1) + $1.b; /*13339*/
						} /*13339*/
					} /*13339*/
				} /*13339*/
			} /*13339*/
			$k[$j++] = "latchcws"; /*13344*/
			$k[$j++] = Infinity; /*13344*/
			$k[$j++] = $1.tl; /*13344*/
			$k[$j++] = 900; /*13344*/
			$k[$j++] = $1.bl; /*13344*/
			$k[$j++] = 901; /*13344*/
			$k[$j++] = $1.bl6; /*13344*/
			$k[$j++] = 924; /*13344*/
			$k[$j++] = $1.nl; /*13344*/
			$k[$j++] = 902; /*13344*/
			$k[$j++] = $1.bs; /*13344*/
			$k[$j++] = 913; /*13344*/
			var _6A = $d(); /*13344*/
			$1[$k[--$j]] = _6A; /*13345*/
			$1.enca = function() {
				var _6G = $get($get($1.charvals, $1.A), $k[--$j]); /*13348*/
				$k[$j++] = _6G; /*13348*/
			}; /*13348*/
			$1.encl = function() {
				var _6L = $get($get($1.charvals, $1.L), $k[--$j]); /*13349*/
				$k[$j++] = _6L; /*13349*/
			}; /*13349*/
			$1.encm = function() {
				var _6Q = $get($get($1.charvals, $1.M), $k[--$j]); /*13350*/
				$k[$j++] = _6Q; /*13350*/
			}; /*13350*/
			$1.encp = function() {
				var _6V = $get($get($1.charvals, $1.P), $k[--$j]); /*13351*/
				$k[$j++] = _6V; /*13351*/
			}; /*13351*/
			$1.textencfuncs = $a(["enca", "encl", "encm", "encp"]); /*13352*/
			$1.addtotext = function() {
				$put($1.text, $1.l, $k[--$j]); /*13355*/
				$1.l = $1.l + 1; /*13356*/
			}; /*13357*/
			$1.enct = function() {
				$1.in = $k[--$j]; /*13361*/
				$1.curlen = $a([$1.e, $1.e, $1.e, $1.e]); /*13363*/
				$put($1.curlen, $1.submode, 0); /*13364*/
				$1.curseq = $a([$a([]), $a([]), $a([]), $a([])]); /*13365*/
				$forall($1.in, function() { /*13435*/
					$1.char = $k[--$j]; /*13370*/
					for (;;) { /*13391*/
						$1.imp = false; /*13374*/
						var _6u = $a([$1.A, $1.L, $1.M, $1.P]); /*13375*/
						for (var _6v = 0, _6w = _6u.length; _6v < _6w; _6v++) { /*13389*/
							$1.x = $get(_6u, _6v); /*13376*/
							var _72 = $a([$1.A, $1.L, $1.M, $1.P]); /*13377*/
							for (var _73 = 0, _74 = _72.length; _73 < _74; _73++) { /*13388*/
								$1.y = $get(_72, _73); /*13378*/
								$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*13379*/
								if ($1.cost < $get($1.curlen, $1.y)) { /*13387*/
									$put($1.curlen, $1.y, $1.cost); /*13381*/
									$k[$j++] = $1.curseq; /*13384*/
									$k[$j++] = $1.y; /*13384*/
									$k[$j++] = Infinity; /*13384*/
									$aload($get($1.curseq, $1.x)); /*13383*/
									$aload($get($get($1.latseq, $1.x), $1.y)); /*13384*/
									var _7V = $a(); /*13384*/
									var _7W = $k[--$j]; /*13385*/
									$put($k[--$j], _7W, _7V); /*13385*/
									$1.imp = true; /*13386*/
								} /*13386*/
							} /*13386*/
						} /*13386*/
						if (!$1.imp) { /*13390*/
							break; /*13390*/
						} /*13390*/
					} /*13390*/
					$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e]); /*13394*/
					$1.nxtseq = $a(4); /*13395*/
					var _7j = $a([$1.A, $1.L, $1.M, $1.P]); /*13397*/
					for (var _7k = 0, _7l = _7j.length; _7k < _7l; _7k++) { /*13430*/
						$1.x = $get(_7j, _7k); /*13398*/
						for (;;) { /*13428*/
							var _7r = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*13402*/
							if (!_7r) { /*13402*/
								break; /*13402*/
							} /*13402*/
							$1.cost = $get($1.curlen, $1.x) + 1; /*13405*/
							if ($1.cost < $get($1.nxtlen, $1.x)) { /*13409*/
								$put($1.nxtlen, $1.x, $1.cost); /*13407*/
								$k[$j++] = $1.nxtseq; /*13408*/
								$k[$j++] = $1.x; /*13408*/
								$k[$j++] = Infinity; /*13408*/
								$aload($get($1.curseq, $1.x)); /*13408*/
								$k[$j++] = $1.char; /*13408*/
								var _88 = $a(); /*13408*/
								var _89 = $k[--$j]; /*13408*/
								$put($k[--$j], _89, _88); /*13408*/
							} /*13408*/
							var _8F = $a([$1.A, $1.L, $1.M, $1.P]); /*13412*/
							for (var _8G = 0, _8H = _8F.length; _8G < _8H; _8G++) { /*13425*/
								$1.y = $get(_8F, _8G); /*13413*/
								if ($ne($1.x, $1.y)) { /*13424*/
									$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + 1; /*13415*/
									if ($1.cost < $get($1.nxtlen, $1.y)) { /*13423*/
										$put($1.nxtlen, $1.y, $1.cost); /*13417*/
										$k[$j++] = $1.nxtseq; /*13421*/
										$k[$j++] = $1.y; /*13421*/
										$k[$j++] = Infinity; /*13421*/
										$aload($get($1.curseq, $1.y)); /*13419*/
										if ($1.x == $1.A) { /*13420*/
											$k[$j++] = $1.as; /*13420*/
										} else { /*13420*/
											$k[$j++] = $1.ps; /*13420*/
										} /*13420*/
										$k[$j++] = $1.char; /*13421*/
										var _8k = $a(); /*13421*/
										var _8l = $k[--$j]; /*13422*/
										$put($k[--$j], _8l, _8k); /*13422*/
									} /*13422*/
								} /*13422*/
							} /*13422*/
							break; /*13427*/
						} /*13427*/
					} /*13427*/
					$1.curlen = $1.nxtlen; /*13432*/
					$1.curseq = $1.nxtseq; /*13433*/
				}); /*13433*/
				$1.minseq = $1.e; /*13438*/
				var _8u = $a([$1.A, $1.L, $1.M, $1.P]); /*13439*/
				for (var _8v = 0, _8w = _8u.length; _8v < _8w; _8v++) { /*13445*/
					$1.k = $get(_8u, _8v); /*13440*/
					if ($get($1.curlen, $1.k) < $1.minseq) { /*13444*/
						$1.minseq = $get($1.curlen, $1.k); /*13442*/
						$1.txtseq = $get($1.curseq, $1.k); /*13443*/
					} /*13443*/
				} /*13443*/
				$1.text = $a($1.minseq); /*13448*/
				$1.k = 0; /*13449*/
				$1.l = 0; /*13449*/
				for (;;) { /*13469*/
					if ($1.k >= $1.txtseq.length) { /*13450*/
						break; /*13450*/
					} /*13450*/
					$1.char = $get($1.txtseq, $1.k); /*13452*/
					$k[$j++] = $1.char; /*13455*/
					$1[$get($1.textencfuncs, $1.submode)](); /*13455*/
					$1.addtotext(); /*13455*/
					$1.k = $1.k + 1; /*13456*/
					if (($1.char == $1.as) || ($1.char == $1.ps)) { /*13462*/
						$k[$j++] = $get($1.txtseq, $1.k); /*13460*/
						if ($1.char == $1.as) { /*13460*/
							$1.enca(); /*13460*/
						} else { /*13460*/
							$1.encp(); /*13460*/
						} /*13460*/
						$1.addtotext(); /*13460*/
						$1.k = $1.k + 1; /*13461*/
					} /*13461*/
					if ($1.char == $1.al) { /*13465*/
						$1.submode = $1.A; /*13465*/
					} /*13465*/
					if ($1.char == $1.ll) { /*13466*/
						$1.submode = $1.L; /*13466*/
					} /*13466*/
					if ($1.char == $1.ml) { /*13467*/
						$1.submode = $1.M; /*13467*/
					} /*13467*/
					if ($1.char == $1.pl) { /*13468*/
						$1.submode = $1.P; /*13468*/
					} /*13468*/
				} /*13468*/
				if (($1.text.length % 2) == 1) { /*13479*/
					if ($1.submode == $1.P) { /*13476*/
						$k[$j++] = "pad"; /*13473*/
						$k[$j++] = $1.al; /*13473*/
						$1.encp(); /*13473*/
						var _9l = $k[--$j]; /*13473*/
						$1[$k[--$j]] = _9l; /*13473*/
						$1.submode = $1.A; /*13474*/
					} else { /*13476*/
						$k[$j++] = "pad"; /*13476*/
						$k[$j++] = $1.ps; /*13476*/
						$1[$get($1.textencfuncs, $1.submode)](); /*13476*/
						var _9t = $k[--$j]; /*13476*/
						$1[$k[--$j]] = _9t; /*13476*/
					} /*13476*/
					$k[$j++] = Infinity; /*13478*/
					$aload($1.text); /*13478*/
					$k[$j++] = $1.pad; /*13478*/
					$1.text = $a(); /*13478*/
				} /*13478*/
				$1.out = $a(~~($1.text.length / 2)); /*13481*/
				for (var _A2 = 0, _A1 = $1.out.length - 1; _A2 <= _A1; _A2 += 1) { /*13485*/
					$1.k = _A2; /*13483*/
					$put($1.out, $1.k, ($get($1.text, $1.k * 2) * 30) + $get($1.text, ($1.k * 2) + 1)); /*13484*/
				} /*13484*/
				$k[$j++] = $1.out; /*13487*/
			}; /*13489*/
			$1.encn = function() {
				$1.in = $k[--$j]; /*13492*/
				$1.out = $a([]); /*13493*/
				for (var _AG = 0, _AF = $1.in.length - 1; _AG <= _AF; _AG += 44) { /*13521*/
					$1.k = _AG; /*13495*/
					$k[$j++] = Infinity; /*13499*/
					var _AL = $1.in.length - $1.k; /*13497*/
					$k[$j++] = 1; /*13497*/
					$k[$j++] = $1.in; /*13497*/
					$k[$j++] = $1.k; /*13497*/
					$k[$j++] = _AL; /*13497*/
					if (_AL > 44) { /*13497*/
						$j--; /*13497*/
						$k[$j++] = 44; /*13497*/
					} /*13497*/
					var _AM = $k[--$j]; /*13497*/
					var _AN = $k[--$j]; /*13497*/
					$forall($geti($k[--$j], _AN, _AM), function() { /*13498*/
						var _AQ = $k[--$j]; /*13498*/
						$k[$j++] = _AQ - 48; /*13498*/
					}); /*13498*/
					$1.gmod = $a(); /*13499*/
					$1.cwn = $a([]); /*13500*/
					for (;;) { /*13519*/
						$1.dv = 900; /*13501*/
						$1.gmul = $a([]); /*13502*/
						$1.val = 0; /*13502*/
						for (;;) { /*13514*/
							if ($1.gmod.length == 0) { /*13503*/
								break; /*13503*/
							} /*13503*/
							$1.val = ($1.val * 10) + $get($1.gmod, 0); /*13504*/
							$1.gmod = $geti($1.gmod, 1, $1.gmod.length - 1); /*13505*/
							if ($1.val < $1.dv) { /*13511*/
								if ($1.gmul.length != 0) { /*13509*/
									$k[$j++] = Infinity; /*13508*/
									$aload($1.gmul); /*13508*/
									$k[$j++] = 0; /*13508*/
									$1.gmul = $a(); /*13508*/
								} /*13508*/
							} else { /*13511*/
								$k[$j++] = Infinity; /*13511*/
								$aload($1.gmul); /*13511*/
								$k[$j++] = ~~($1.val / $1.dv); /*13511*/
								$1.gmul = $a(); /*13511*/
							} /*13511*/
							$1.val = $1.val % $1.dv; /*13513*/
						} /*13513*/
						$1.dv = $1.val; /*13515*/
						$k[$j++] = Infinity; /*13516*/
						$k[$j++] = $1.dv; /*13516*/
						$aload($1.cwn); /*13516*/
						$1.cwn = $a(); /*13516*/
						$1.gmod = $1.gmul; /*13517*/
						if ($1.gmul.length == 0) { /*13518*/
							break; /*13518*/
						} /*13518*/
					} /*13518*/
					$k[$j++] = Infinity; /*13520*/
					$aload($1.out); /*13520*/
					$aload($1.cwn); /*13520*/
					$1.out = $a(); /*13520*/
				} /*13520*/
				$k[$j++] = $1.out; /*13522*/
			}; /*13523*/
			$1.encfuncs = $a(["enct", "encn", "encb"]); /*13525*/
			$1.addtocws = function() {
				var _Ax = $k[--$j]; /*13528*/
				$puti($1.datcws, $1.j, _Ax); /*13528*/
				$1.j = _Ax.length + $1.j; /*13529*/
			}; /*13530*/
			$1.state = $1.T; /*13533*/
			$1.submode = $1.A; /*13533*/
			$1.datcws = $a($1.seqlen); /*13534*/
			$1.i = 0; /*13535*/
			$1.j = 0; /*13535*/
			for (;;) { /*13551*/
				if ($1.i >= $1.seq.length) { /*13536*/
					break; /*13536*/
				} /*13536*/
				$1.chars = $get($1.seq, $1.i); /*13537*/
				if ($eq($type($1.chars), "arraytype")) { /*13547*/
					$k[$j++] = $1.chars; /*13539*/
					$1[$get($1.encfuncs, $1.state)](); /*13539*/
					$1.addtocws(); /*13539*/
				} else { /*13547*/
					$k[$j++] = $a([$get($1.latchcws, $1.chars)]); /*13541*/
					$1.addtocws(); /*13541*/
					if ($1.chars == $1.tl) { /*13542*/
						$1.state = $1.T; /*13542*/
						$1.submode = $1.A; /*13542*/
					} /*13542*/
					if ($1.chars == $1.nl) { /*13543*/
						$1.state = $1.N; /*13543*/
					} /*13543*/
					if (($1.chars == $1.bl) || ($1.chars == $1.bl6)) { /*13544*/
						$1.state = $1.B; /*13544*/
					} /*13544*/
					if ($1.chars == $1.bs) { /*13548*/
						$1.i = $1.i + 1; /*13546*/
						$k[$j++] = $get($1.seq, $1.i); /*13547*/
						$1.encb(); /*13547*/
						$1.addtocws(); /*13547*/
					} /*13547*/
				} /*13547*/
				$1.i = $1.i + 1; /*13550*/
			} /*13550*/
			$1.datcws = $geti($1.datcws, 0, $1.j); /*13552*/
		} /*13552*/
		$1.m = $1.datcws.length; /*13556*/
		if ($1.eclevel == -1) { /*13562*/
			if ($1.m <= 40) { /*13558*/
				$1.eclevel = 2; /*13558*/
			} /*13558*/
			if (($1.m >= 41) && ($1.m <= 160)) { /*13559*/
				$1.eclevel = 3; /*13559*/
			} /*13559*/
			if (($1.m >= 161) && ($1.m <= 320)) { /*13560*/
				$1.eclevel = 4; /*13560*/
			} /*13560*/
			if ($1.m >= 321) { /*13561*/
				$1.eclevel = 5; /*13561*/
			} /*13561*/
		} /*13561*/
		$1.maxeclevel = (~~((Math.log((928 - 1) - $1.m)) / Math.log(2))) - 1; /*13565*/
		if ($1.eclevel > $1.maxeclevel) { /*13566*/
			$1.eclevel = $1.maxeclevel; /*13566*/
		} /*13566*/
		$1.k = ~~Math.pow(2, $1.eclevel + 1); /*13567*/
		if ($1.columns == 0) { /*13570*/
			$1.columns = ~~(Math.round(Math.sqrt(($1.m + $1.k) / 3))); /*13570*/
		} /*13570*/
		if (($1.columns >= 1) && ($1.columns <= 30)) { /*13571*/
			$1.c = $1.columns; /*13571*/
		} /*13571*/
		$1.r = ~~(Math.ceil((($1.m + $1.k) + 1) / $1.columns)); /*13574*/
		if (($1.r < $1.rows) && ($1.rows <= 90)) { /*13575*/
			$1.r = $1.rows; /*13575*/
		} /*13575*/
		if ($1.r < 3) { /*13576*/
			$1.r = 3; /*13576*/
		} /*13576*/
		var _C8 = $1.c; /*13579*/
		var _C9 = $1.r; /*13579*/
		var _CA = $1.m; /*13579*/
		var _CB = 8; /*13579*/
		var _CC = (~~((Math.log(((_C8 * _C9) - 1) - _CA)) / Math.log(2))) - 1; /*13579*/
		if (((~~((Math.log(((_C8 * _C9) - 1) - _CA)) / Math.log(2))) - 1) > 8) { /*13579*/
			var _ = _CB; /*13579*/
			_CB = _CC; /*13579*/
			_CC = _; /*13579*/
		} /*13579*/
		$1.maxeclevel = _CC; /*13579*/
		if ($1.maxeclevel > $1.eclevel) { /*13583*/
			$1.eclevel = $1.maxeclevel; /*13581*/
			$1.k = ~~Math.pow(2, $1.eclevel + 1); /*13582*/
		} /*13582*/
		$1.n = ($1.c * $1.r) - $1.k; /*13586*/
		$1.cws = $a(($1.c * $1.r) + 1); /*13587*/
		$put($1.cws, 0, $1.n); /*13588*/
		$puti($1.cws, 1, $1.datcws); /*13589*/
		$k[$j++] = $1.cws; /*13590*/
		$k[$j++] = $1.m + 1; /*13590*/
		$k[$j++] = Infinity; /*13590*/
		for (var _CV = 0, _CW = ($1.n - $1.m) - 1; _CV < _CW; _CV++) { /*13590*/
			$k[$j++] = 900; /*13590*/
		} /*13590*/
		var _CX = $a(); /*13590*/
		var _CY = $k[--$j]; /*13590*/
		$puti($k[--$j], _CY, _CX); /*13590*/
		$k[$j++] = $1.cws; /*13591*/
		$k[$j++] = $1.n; /*13591*/
		$k[$j++] = Infinity; /*13591*/
		for (var _Cd = 0, _Ce = $1.k; _Cd < _Ce; _Cd++) { /*13591*/
			$k[$j++] = 0; /*13591*/
		} /*13591*/
		$k[$j++] = 0; /*13591*/
		var _Cf = $a(); /*13591*/
		var _Cg = $k[--$j]; /*13591*/
		$puti($k[--$j], _Cg, _Cf); /*13591*/
		$k[$j++] = Infinity; /*13594*/
		$k[$j++] = 1; /*13594*/
		for (var _Ci = 0, _Cj = 928; _Ci < _Cj; _Ci++) { /*13594*/
			var _Ck = $k[--$j]; /*13594*/
			$k[$j++] = _Ck; /*13594*/
			$k[$j++] = (_Ck * 3) % 929; /*13594*/
		} /*13594*/
		$1.rsalog = $a(); /*13594*/
		$1.rslog = $a(929); /*13595*/
		for (var _Cn = 1; _Cn <= 928; _Cn += 1) { /*13596*/
			$put($1.rslog, $get($1.rsalog, _Cn), _Cn); /*13596*/
		} /*13596*/
		$1.rsprod = function() {
			var _Cr = $k[--$j]; /*13600*/
			var _Cs = $k[--$j]; /*13600*/
			$k[$j++] = _Cs; /*13604*/
			$k[$j++] = _Cr; /*13604*/
			if ((_Cr != 0) && (_Cs != 0)) { /*13603*/
				var _Cv = $get($1.rslog, $k[--$j]); /*13601*/
				var _D0 = $get($1.rsalog, (_Cv + $get($1.rslog, $k[--$j])) % 928); /*13601*/
				$k[$j++] = _D0; /*13601*/
			} else { /*13603*/
				$j -= 2; /*13603*/
				$k[$j++] = 0; /*13603*/
			} /*13603*/
		}; /*13605*/
		$k[$j++] = Infinity; /*13608*/
		$k[$j++] = 1; /*13608*/
		for (var _D2 = 0, _D3 = $1.k; _D2 < _D3; _D2++) { /*13608*/
			$k[$j++] = 0; /*13608*/
		} /*13608*/
		$1.coeffs = $a(); /*13608*/
		for (var _D7 = 1, _D6 = $1.k; _D7 <= _D6; _D7 += 1) { /*13617*/
			$1.i = _D7; /*13610*/
			$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*13611*/
			for (var _DE = $1.i - 1; _DE >= 1; _DE -= 1) { /*13615*/
				$1.j = _DE; /*13613*/
				$k[$j++] = $1.coeffs; /*13614*/
				$k[$j++] = $1.j; /*13614*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*13614*/
				$k[$j++] = $get($1.coeffs, $1.j); /*13614*/
				$k[$j++] = $get($1.rsalog, $1.i); /*13614*/
				$1.rsprod(); /*13614*/
				var _DQ = $k[--$j]; /*13614*/
				var _DR = $k[--$j]; /*13614*/
				var _DS = $k[--$j]; /*13614*/
				$put($k[--$j], _DS, (_DR + _DQ) % 929); /*13614*/
			} /*13614*/
			$k[$j++] = $1.coeffs; /*13616*/
			$k[$j++] = 0; /*13616*/
			$k[$j++] = $get($1.coeffs, 0); /*13616*/
			$k[$j++] = $get($1.rsalog, $1.i); /*13616*/
			$1.rsprod(); /*13616*/
			var _Da = $k[--$j]; /*13616*/
			var _Db = $k[--$j]; /*13616*/
			$put($k[--$j], _Db, _Da); /*13616*/
		} /*13616*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*13618*/
		for (var _Dh = $1.coeffs.length - 1; _Dh >= 0; _Dh -= 2) { /*13619*/
			var _Di = $1.coeffs; /*13619*/
			$put(_Di, _Dh, 929 - $get(_Di, _Dh)); /*13619*/
		} /*13619*/
		for (var _Dm = 0, _Dl = $1.n - 1; _Dm <= _Dl; _Dm += 1) { /*13628*/
			$1.t = ($get($1.cws, _Dm) + $get($1.cws, $1.n)) % 929; /*13623*/
			for (var _Du = 0, _Dt = $1.k - 1; _Du <= _Dt; _Du += 1) { /*13627*/
				$1.j = _Du; /*13625*/
				$put($1.cws, $1.n + $1.j, ($get($1.cws, ($1.n + $1.j) + 1) + (929 - (($1.t * $get($1.coeffs, ($1.k - $1.j) - 1)) % 929))) % 929); /*13626*/
			} /*13626*/
		} /*13626*/
		for (var _EB = $1.n, _EA = $1.n + $1.k; _EB <= _EA; _EB += 1) { /*13629*/
			$put($1.cws, _EB, (929 - $get($1.cws, _EB)) % 929); /*13629*/
		} /*13629*/
		$1.cws = $geti($1.cws, 0, $1.cws.length - 1); /*13632*/
		$1.clusters = $a([$a([120256, 125680, 128380, 120032, 125560, 128318, 108736, 119920, 108640, 86080, 108592, 86048, 110016, 120560, 125820, 109792, 120440, 125758, 88256, 109680, 88160, 89536, 110320, 120700, 89312, 110200, 120638, 89200, 110140, 89840, 110460, 89720, 110398, 89980, 128506, 119520, 125304, 128190, 107712, 119408, 125244, 107616, 119352, 84032, 107568, 119324, 84000, 107544, 83984, 108256, 119672, 125374, 85184, 108144, 119612, 85088, 108088, 119582, 85040, 108060, 85728, 108408, 119742, 85616, 108348, 85560, 108318, 85880, 108478, 85820, 85790, 107200, 119152, 125116, 107104, 119096, 125086, 83008, 107056, 119068, 82976, 107032, 82960, 82952, 83648, 107376, 119228, 83552, 107320, 119198, 83504, 107292, 83480, 83468, 83824, 107452, 83768, 107422, 83740, 83900, 106848, 118968, 125022, 82496, 106800, 118940, 82464, 106776, 118926, 82448, 106764, 82440, 106758, 82784, 106936, 119006, 82736, 106908, 82712, 106894, 82700, 82694, 106974, 82830, 82240, 106672, 118876, 82208, 106648, 118862, 82192, 106636, 82184, 106630, 82180, 82352, 82328, 82316, 82080, 118830, 106572, 106566, 82050, 117472, 124280, 127678, 103616, 117360, 124220, 103520, 117304, 124190, 75840, 103472, 75808, 104160, 117624, 124350, 76992, 104048, 117564, 76896, 103992, 76848, 76824, 77536, 104312, 117694, 77424, 104252, 77368, 77340, 77688, 104382, 77628, 77758, 121536, 126320, 128700, 121440, 126264, 128670, 111680, 121392, 126236, 111648, 121368, 126222, 111632, 121356, 103104, 117104, 124092, 112320, 103008, 117048, 124062, 112224, 121656, 126366, 93248, 74784, 102936, 117006, 93216, 112152, 93200, 75456, 103280, 117180, 93888, 75360, 103224, 117150, 93792, 112440, 121758, 93744, 75288, 93720, 75632, 103356, 94064, 75576, 103326, 94008, 112542, 93980, 75708, 94140, 75678, 94110, 121184, 126136, 128606, 111168, 121136, 126108, 111136, 121112, 126094, 111120, 121100, 111112, 111108, 102752, 116920, 123998, 111456, 102704, 116892, 91712, 74272, 121244, 116878, 91680, 74256, 102668, 91664, 111372, 102662, 74244, 74592, 102840, 116958, 92000, 74544, 102812, 91952, 111516, 102798, 91928, 74508, 74502, 74680, 102878, 92088, 74652, 92060, 74638, 92046, 92126, 110912, 121008, 126044, 110880, 120984, 126030, 110864, 120972, 110856, 120966, 110852, 110850, 74048, 102576, 116828, 90944, 74016, 102552, 116814, 90912, 111000, 121038, 90896, 73992, 102534, 90888, 110982, 90884, 74160, 102620, 91056, 74136, 102606, 91032, 111054, 91020, 74118, 91014, 91100, 91086, 110752, 120920, 125998, 110736, 120908, 110728, 120902, 110724, 110722, 73888, 102488, 116782, 90528, 73872, 102476, 90512, 110796, 102470, 90504, 73860, 90500, 73858, 73944, 90584, 90572, 90566, 120876, 120870, 110658, 102444, 73800, 90312, 90308, 90306, 101056, 116080, 123580, 100960, 116024, 70720, 100912, 115996, 70688, 100888, 70672, 70664, 71360, 101232, 116156, 71264, 101176, 116126, 71216, 101148, 71192, 71180, 71536, 101308, 71480, 101278, 71452, 71612, 71582, 118112, 124600, 127838, 105024, 118064, 124572, 104992, 118040, 124558, 104976, 118028, 104968, 118022, 100704, 115896, 123486, 105312, 100656, 115868, 79424, 70176, 118172, 115854, 79392, 105240, 100620, 79376, 70152, 79368, 70496, 100792, 115934, 79712, 70448, 118238, 79664, 105372, 100750, 79640, 70412, 79628, 70584, 100830, 79800, 70556, 79772, 70542, 70622, 79838, 122176, 126640, 128860, 122144, 126616, 128846, 122128, 126604, 122120, 126598, 122116, 104768, 117936, 124508, 113472, 104736, 126684, 124494, 113440, 122264, 126670, 113424, 104712, 117894, 113416, 122246, 104706, 69952, 100528, 115804, 78656, 69920, 100504, 115790, 96064, 78624, 104856, 117966, 96032, 113560, 122318, 100486, 96016, 78600, 104838, 96008, 69890, 70064, 100572, 78768, 70040, 100558, 96176, 78744, 104910, 96152, 113614, 70022, 78726, 70108, 78812, 70094, 96220, 78798, 122016, 126552, 128814, 122000, 126540, 121992, 126534, 121988, 121986, 104608, 117848, 124462, 113056, 104592, 126574, 113040, 122060, 117830, 113032, 104580, 113028, 104578, 113026, 69792, 100440, 115758, 78240, 69776, 100428, 95136, 78224, 104652, 100422, 95120, 113100, 69764, 95112, 78212, 69762, 78210, 69848, 100462, 78296, 69836, 95192, 78284, 69830, 95180, 78278, 69870, 95214, 121936, 126508, 121928, 126502, 121924, 121922, 104528, 117804, 112848, 104520, 117798, 112840, 121958, 112836, 104514, 112834, 69712, 100396, 78032, 69704, 100390, 94672, 78024, 104550, 94664, 112870, 69698, 94660, 78018, 94658, 78060, 94700, 94694, 126486, 121890, 117782, 104484, 104482, 69672, 77928, 94440, 69666, 77922, 99680, 68160, 99632, 68128, 99608, 115342, 68112, 99596, 68104, 99590, 68448, 99768, 115422, 68400, 99740, 68376, 99726, 68364, 68358, 68536, 99806, 68508, 68494, 68574, 101696, 116400, 123740, 101664, 116376, 101648, 116364, 101640, 116358, 101636, 67904, 99504, 115292, 72512, 67872, 116444, 115278, 72480, 101784, 116430, 72464, 67848, 99462, 72456, 101766, 67842, 68016, 99548, 72624, 67992, 99534, 72600, 101838, 72588, 67974, 68060, 72668, 68046, 72654, 118432, 124760, 127918, 118416, 124748, 118408, 124742, 118404, 118402, 101536, 116312, 105888, 101520, 116300, 105872, 118476, 116294, 105864, 101508, 105860, 101506, 105858, 67744, 99416, 72096, 67728, 116334, 80800, 72080, 101580, 99398, 80784, 105932, 67716, 80776, 72068, 67714, 72066, 67800, 99438, 72152, 67788, 80856, 72140, 67782, 80844, 72134, 67822, 72174, 80878, 126800, 128940, 126792, 128934, 126788, 126786, 118352, 124716, 122576, 126828, 124710, 122568, 126822, 122564, 118338, 122562, 101456, 116268, 105680, 101448, 116262, 114128, 105672, 118374, 114120, 122598, 101442, 114116, 105666, 114114, 67664, 99372, 71888, 67656, 99366, 80336, 71880, 101478, 97232, 80328, 105702, 67650, 97224, 114150, 71874, 97220, 67692, 71916, 67686, 80364, 71910, 97260, 80358, 97254, 126760, 128918, 126756, 126754, 118312, 124694, 122472, 126774, 122468, 118306, 122466, 101416, 116246, 105576, 101412, 113896, 105572, 101410, 113892, 105570, 113890, 67624, 99350, 71784, 101430, 80104, 71780, 67618, 96744, 80100, 71778, 96740, 80098, 96738, 71798, 96758, 126738, 122420, 122418, 105524, 113780, 113778, 71732, 79988, 96500, 96498, 66880, 66848, 98968, 66832, 66824, 66820, 66992, 66968, 66956, 66950, 67036, 67022, 100000, 99984, 115532, 99976, 115526, 99972, 99970, 66720, 98904, 69024, 100056, 98892, 69008, 100044, 69000, 100038, 68996, 66690, 68994, 66776, 98926, 69080, 100078, 69068, 66758, 69062, 66798, 69102, 116560, 116552, 116548, 116546, 99920, 102096, 116588, 115494, 102088, 116582, 102084, 99906, 102082, 66640, 68816, 66632, 98854, 73168, 68808, 66628, 73160, 68804, 66626, 73156, 68802, 66668, 68844, 66662, 73196, 68838, 73190, 124840, 124836, 124834, 116520, 118632, 124854, 118628, 116514, 118626, 99880, 115478, 101992, 116534, 106216, 101988, 99874, 106212, 101986, 106210, 66600, 98838, 68712, 99894, 72936, 68708, 66594, 81384, 72932, 68706, 81380, 72930, 66614, 68726, 72950, 81398, 128980, 128978, 124820, 126900, 124818, 126898, 116500, 118580, 116498, 122740, 118578, 122738, 99860, 101940, 99858, 106100, 101938, 114420]), $a([128352, 129720, 125504, 128304, 129692, 125472, 128280, 129678, 125456, 128268, 125448, 128262, 125444, 125792, 128440, 129758, 120384, 125744, 128412, 120352, 125720, 128398, 120336, 125708, 120328, 125702, 120324, 120672, 125880, 128478, 110144, 120624, 125852, 110112, 120600, 125838, 110096, 120588, 110088, 120582, 110084, 110432, 120760, 125918, 89664, 110384, 120732, 89632, 110360, 120718, 89616, 110348, 89608, 110342, 89952, 110520, 120798, 89904, 110492, 89880, 110478, 89868, 90040, 110558, 90012, 89998, 125248, 128176, 129628, 125216, 128152, 129614, 125200, 128140, 125192, 128134, 125188, 125186, 119616, 125360, 128220, 119584, 125336, 128206, 119568, 125324, 119560, 125318, 119556, 119554, 108352, 119728, 125404, 108320, 119704, 125390, 108304, 119692, 108296, 119686, 108292, 108290, 85824, 108464, 119772, 85792, 108440, 119758, 85776, 108428, 85768, 108422, 85764, 85936, 108508, 85912, 108494, 85900, 85894, 85980, 85966, 125088, 128088, 129582, 125072, 128076, 125064, 128070, 125060, 125058, 119200, 125144, 128110, 119184, 125132, 119176, 125126, 119172, 119170, 107424, 119256, 125166, 107408, 119244, 107400, 119238, 107396, 107394, 83872, 107480, 119278, 83856, 107468, 83848, 107462, 83844, 83842, 83928, 107502, 83916, 83910, 83950, 125008, 128044, 125000, 128038, 124996, 124994, 118992, 125036, 118984, 125030, 118980, 118978, 106960, 119020, 106952, 119014, 106948, 106946, 82896, 106988, 82888, 106982, 82884, 82882, 82924, 82918, 124968, 128022, 124964, 124962, 118888, 124982, 118884, 118882, 106728, 118902, 106724, 106722, 82408, 106742, 82404, 82402, 124948, 124946, 118836, 118834, 106612, 106610, 124224, 127664, 129372, 124192, 127640, 129358, 124176, 127628, 124168, 127622, 124164, 124162, 117568, 124336, 127708, 117536, 124312, 127694, 117520, 124300, 117512, 124294, 117508, 117506, 104256, 117680, 124380, 104224, 117656, 124366, 104208, 117644, 104200, 117638, 104196, 104194, 77632, 104368, 117724, 77600, 104344, 117710, 77584, 104332, 77576, 104326, 77572, 77744, 104412, 77720, 104398, 77708, 77702, 77788, 77774, 128672, 129880, 93168, 128656, 129868, 92664, 128648, 129862, 92412, 128644, 128642, 124064, 127576, 129326, 126368, 124048, 129902, 126352, 128716, 127558, 126344, 124036, 126340, 124034, 126338, 117152, 124120, 127598, 121760, 117136, 124108, 121744, 126412, 124102, 121736, 117124, 121732, 117122, 121730, 103328, 117208, 124142, 112544, 103312, 117196, 112528, 121804, 117190, 112520, 103300, 112516, 103298, 112514, 75680, 103384, 117230, 94112, 75664, 103372, 94096, 112588, 103366, 94088, 75652, 94084, 75650, 75736, 103406, 94168, 75724, 94156, 75718, 94150, 75758, 128592, 129836, 91640, 128584, 129830, 91388, 128580, 91262, 128578, 123984, 127532, 126160, 123976, 127526, 126152, 128614, 126148, 123970, 126146, 116944, 124012, 121296, 116936, 124006, 121288, 126182, 121284, 116930, 121282, 102864, 116972, 111568, 102856, 116966, 111560, 121318, 111556, 102850, 111554, 74704, 102892, 92112, 74696, 102886, 92104, 111590, 92100, 74690, 92098, 74732, 92140, 74726, 92134, 128552, 129814, 90876, 128548, 90750, 128546, 123944, 127510, 126056, 128566, 126052, 123938, 126050, 116840, 123958, 121064, 116836, 121060, 116834, 121058, 102632, 116854, 111080, 121078, 111076, 102626, 111074, 74216, 102646, 91112, 74212, 91108, 74210, 91106, 74230, 91126, 128532, 90494, 128530, 123924, 126004, 123922, 126002, 116788, 120948, 116786, 120946, 102516, 110836, 102514, 110834, 73972, 90612, 73970, 90610, 128522, 123914, 125978, 116762, 120890, 102458, 110714, 123552, 127320, 129198, 123536, 127308, 123528, 127302, 123524, 123522, 116128, 123608, 127342, 116112, 123596, 116104, 123590, 116100, 116098, 101280, 116184, 123630, 101264, 116172, 101256, 116166, 101252, 101250, 71584, 101336, 116206, 71568, 101324, 71560, 101318, 71556, 71554, 71640, 101358, 71628, 71622, 71662, 127824, 129452, 79352, 127816, 129446, 79100, 127812, 78974, 127810, 123472, 127276, 124624, 123464, 127270, 124616, 127846, 124612, 123458, 124610, 115920, 123500, 118224, 115912, 123494, 118216, 124646, 118212, 115906, 118210, 100816, 115948, 105424, 100808, 115942, 105416, 118246, 105412, 100802, 105410, 70608, 100844, 79824, 70600, 100838, 79816, 105446, 79812, 70594, 79810, 70636, 79852, 70630, 79846, 129960, 95728, 113404, 129956, 95480, 113278, 129954, 95356, 95294, 127784, 129430, 78588, 128872, 129974, 95996, 78462, 128868, 127778, 95870, 128866, 123432, 127254, 124520, 123428, 126696, 128886, 123426, 126692, 124514, 126690, 115816, 123446, 117992, 115812, 122344, 117988, 115810, 122340, 117986, 122338, 100584, 115830, 104936, 100580, 113640, 104932, 100578, 113636, 104930, 113634, 70120, 100598, 78824, 70116, 96232, 78820, 70114, 96228, 78818, 96226, 70134, 78838, 129940, 94968, 113022, 129938, 94844, 94782, 127764, 78206, 128820, 127762, 95102, 128818, 123412, 124468, 123410, 126580, 124466, 126578, 115764, 117876, 115762, 122100, 117874, 122098, 100468, 104692, 100466, 113140, 104690, 113138, 69876, 78324, 69874, 95220, 78322, 95218, 129930, 94588, 94526, 127754, 128794, 123402, 124442, 126522, 115738, 117818, 121978, 100410, 104570, 112890, 69754, 78074, 94714, 94398, 123216, 127148, 123208, 127142, 123204, 123202, 115408, 123244, 115400, 123238, 115396, 115394, 99792, 115436, 99784, 115430, 99780, 99778, 68560, 99820, 68552, 99814, 68548, 68546, 68588, 68582, 127400, 129238, 72444, 127396, 72318, 127394, 123176, 127126, 123752, 123172, 123748, 123170, 123746, 115304, 123190, 116456, 115300, 116452, 115298, 116450, 99560, 115318, 101864, 99556, 101860, 99554, 101858, 68072, 99574, 72680, 68068, 72676, 68066, 72674, 68086, 72694, 129492, 80632, 105854, 129490, 80508, 80446, 127380, 72062, 127924, 127378, 80766, 127922, 123156, 123700, 123154, 124788, 123698, 124786, 115252, 116340, 115250, 118516, 116338, 118514, 99444, 101620, 99442, 105972, 101618, 105970, 67828, 72180, 67826, 80884, 72178, 80882, 97008, 114044, 96888, 113982, 96828, 96798, 129482, 80252, 130010, 97148, 80190, 97086, 127370, 127898, 128954, 123146, 123674, 124730, 126842, 115226, 116282, 118394, 122618, 99386, 101498, 105722, 114170, 67706, 71930, 80378, 96632, 113854, 96572, 96542, 80062, 96702, 96444, 96414, 96350, 123048, 123044, 123042, 115048, 123062, 115044, 115042, 99048, 115062, 99044, 99042, 67048, 99062, 67044, 67042, 67062, 127188, 68990, 127186, 123028, 123316, 123026, 123314, 114996, 115572, 114994, 115570, 98932, 100084, 98930, 100082, 66804, 69108, 66802, 69106, 129258, 73084, 73022, 127178, 127450, 123018, 123290, 123834, 114970, 115514, 116602, 98874, 99962, 102138, 66682, 68858, 73210, 81272, 106174, 81212, 81182, 72894, 81342, 97648, 114364, 97592, 114334, 97564, 97550, 81084, 97724, 81054, 97694, 97464, 114270, 97436, 97422, 80990, 97502, 97372, 97358, 97326, 114868, 114866, 98676, 98674, 66292, 66290, 123098, 114842, 115130, 98618, 99194, 66170, 67322, 69310, 73404, 73374, 81592, 106334, 81564, 81550, 73310, 81630, 97968, 114524, 97944, 114510, 97932, 97926, 81500, 98012, 81486, 97998, 97880, 114478, 97868, 97862, 81454, 97902, 97836, 97830, 69470, 73564, 73550, 81752, 106414, 81740, 81734, 73518, 81774, 81708, 81702]), $a([109536, 120312, 86976, 109040, 120060, 86496, 108792, 119934, 86256, 108668, 86136, 129744, 89056, 110072, 129736, 88560, 109820, 129732, 88312, 109694, 129730, 88188, 128464, 129772, 89592, 128456, 129766, 89340, 128452, 89214, 128450, 125904, 128492, 125896, 128486, 125892, 125890, 120784, 125932, 120776, 125926, 120772, 120770, 110544, 120812, 110536, 120806, 110532, 84928, 108016, 119548, 84448, 107768, 119422, 84208, 107644, 84088, 107582, 84028, 129640, 85488, 108284, 129636, 85240, 108158, 129634, 85116, 85054, 128232, 129654, 85756, 128228, 85630, 128226, 125416, 128246, 125412, 125410, 119784, 125430, 119780, 119778, 108520, 119798, 108516, 108514, 83424, 107256, 119166, 83184, 107132, 83064, 107070, 83004, 82974, 129588, 83704, 107390, 129586, 83580, 83518, 128116, 83838, 128114, 125172, 125170, 119284, 119282, 107508, 107506, 82672, 106876, 82552, 106814, 82492, 82462, 129562, 82812, 82750, 128058, 125050, 119034, 82296, 106686, 82236, 82206, 82366, 82108, 82078, 76736, 103920, 117500, 76256, 103672, 117374, 76016, 103548, 75896, 103486, 75836, 129384, 77296, 104188, 129380, 77048, 104062, 129378, 76924, 76862, 127720, 129398, 77564, 127716, 77438, 127714, 124392, 127734, 124388, 124386, 117736, 124406, 117732, 117730, 104424, 117750, 104420, 104418, 112096, 121592, 126334, 92608, 111856, 121468, 92384, 111736, 121406, 92272, 111676, 92216, 111646, 92188, 75232, 103160, 117118, 93664, 74992, 103036, 93424, 112252, 102974, 93304, 74812, 93244, 74782, 93214, 129332, 75512, 103294, 129908, 129330, 93944, 75388, 129906, 93820, 75326, 93758, 127604, 75646, 128756, 127602, 94078, 128754, 124148, 126452, 124146, 126450, 117236, 121844, 117234, 121842, 103412, 103410, 91584, 111344, 121212, 91360, 111224, 121150, 91248, 111164, 91192, 111134, 91164, 91150, 74480, 102780, 91888, 74360, 102718, 91768, 111422, 91708, 74270, 91678, 129306, 74620, 129850, 92028, 74558, 91966, 127546, 128634, 124026, 126202, 116986, 121338, 102906, 90848, 110968, 121022, 90736, 110908, 90680, 110878, 90652, 90638, 74104, 102590, 91000, 74044, 90940, 74014, 90910, 74174, 91070, 90480, 110780, 90424, 110750, 90396, 90382, 73916, 90556, 73886, 90526, 90296, 110686, 90268, 90254, 73822, 90334, 90204, 90190, 71136, 101112, 116094, 70896, 100988, 70776, 100926, 70716, 70686, 129204, 71416, 101246, 129202, 71292, 71230, 127348, 71550, 127346, 123636, 123634, 116212, 116210, 101364, 101362, 79296, 105200, 118140, 79072, 105080, 118078, 78960, 105020, 78904, 104990, 78876, 78862, 70384, 100732, 79600, 70264, 100670, 79480, 105278, 79420, 70174, 79390, 129178, 70524, 129466, 79740, 70462, 79678, 127290, 127866, 123514, 124666, 115962, 118266, 100858, 113376, 122232, 126654, 95424, 113264, 122172, 95328, 113208, 122142, 95280, 113180, 95256, 113166, 95244, 78560, 104824, 117950, 95968, 78448, 104764, 95856, 113468, 104734, 95800, 78364, 95772, 78350, 95758, 70008, 100542, 78712, 69948, 96120, 78652, 69918, 96060, 78622, 96030, 70078, 78782, 96190, 94912, 113008, 122044, 94816, 112952, 122014, 94768, 112924, 94744, 112910, 94732, 94726, 78192, 104636, 95088, 78136, 104606, 95032, 113054, 95004, 78094, 94990, 69820, 78268, 69790, 95164, 78238, 95134, 94560, 112824, 121950, 94512, 112796, 94488, 112782, 94476, 94470, 78008, 104542, 94648, 77980, 94620, 77966, 94606, 69726, 78046, 94686, 94384, 112732, 94360, 112718, 94348, 94342, 77916, 94428, 77902, 94414, 94296, 112686, 94284, 94278, 77870, 94318, 94252, 94246, 68336, 99708, 68216, 99646, 68156, 68126, 68476, 68414, 127162, 123258, 115450, 99834, 72416, 101752, 116414, 72304, 101692, 72248, 101662, 72220, 72206, 67960, 99518, 72568, 67900, 72508, 67870, 72478, 68030, 72638, 80576, 105840, 118460, 80480, 105784, 118430, 80432, 105756, 80408, 105742, 80396, 80390, 72048, 101564, 80752, 71992, 101534, 80696, 71964, 80668, 71950, 80654, 67772, 72124, 67742, 80828, 72094, 80798, 114016, 122552, 126814, 96832, 113968, 122524, 96800, 113944, 122510, 96784, 113932, 96776, 113926, 96772, 80224, 105656, 118366, 97120, 80176, 105628, 97072, 114076, 105614, 97048, 80140, 97036, 80134, 97030, 71864, 101470, 80312, 71836, 97208, 80284, 71822, 97180, 80270, 97166, 67678, 71902, 80350, 97246, 96576, 113840, 122460, 96544, 113816, 122446, 96528, 113804, 96520, 113798, 96516, 96514, 80048, 105564, 96688, 80024, 105550, 96664, 113870, 96652, 80006, 96646, 71772, 80092, 71758, 96732, 80078, 96718, 96416, 113752, 122414, 96400, 113740, 96392, 113734, 96388, 96386, 79960, 105518, 96472, 79948, 96460, 79942, 96454, 71726, 79982, 96494, 96336, 113708, 96328, 113702, 96324, 96322, 79916, 96364, 79910, 96358, 96296, 113686, 96292, 96290, 79894, 96310, 66936, 99006, 66876, 66846, 67006, 68976, 100028, 68920, 99998, 68892, 68878, 66748, 69052, 66718, 69022, 73056, 102072, 116574, 73008, 102044, 72984, 102030, 72972, 72966, 68792, 99934, 73144, 68764, 73116, 68750, 73102, 66654, 68830, 73182, 81216, 106160, 118620, 81184, 106136, 118606, 81168, 106124, 81160, 106118, 81156, 81154, 72880, 101980, 81328, 72856, 101966, 81304, 106190, 81292, 72838, 81286, 68700, 72924, 68686, 81372, 72910, 81358, 114336, 122712, 126894, 114320, 122700, 114312, 122694, 114308, 114306, 81056, 106072, 118574, 97696, 81040, 106060, 97680, 114380, 106054, 97672, 81028, 97668, 81026, 97666, 72792, 101934, 81112, 72780, 97752, 81100, 72774, 97740, 81094, 97734, 68654, 72814, 81134, 97774, 114256, 122668, 114248, 122662, 114244, 114242, 80976, 106028, 97488, 80968, 106022, 97480, 114278, 97476, 80962, 97474, 72748, 81004, 72742, 97516, 80998, 97510, 114216, 122646, 114212, 114210, 80936, 106006, 97384, 80932, 97380, 80930, 97378, 72726, 80950, 97398, 114196, 114194, 80916, 97332, 80914, 97330, 66236, 66206, 67256, 99166, 67228, 67214, 66142, 67294, 69296, 100188, 69272, 100174, 69260, 69254, 67164, 69340, 67150, 69326, 73376, 102232, 116654, 73360, 102220, 73352, 102214, 73348, 73346, 69208, 100142, 73432, 102254, 73420, 69190, 73414, 67118, 69230, 73454, 106320, 118700, 106312, 118694, 106308, 106306, 73296, 102188, 81616, 106348, 102182, 81608, 73284, 81604, 73282, 81602, 69164, 73324, 69158, 81644, 73318, 81638, 122792, 126934, 122788, 122786, 106280, 118678, 114536, 106276, 114532, 106274, 114530, 73256, 102166, 81512, 73252, 98024, 81508, 73250, 98020, 81506, 98018, 69142, 73270, 81526, 98038, 122772, 122770, 106260, 114484, 106258, 114482, 73236, 81460, 73234, 97908, 81458, 97906, 122762, 106250, 114458, 73226, 81434, 97850, 66396, 66382, 67416, 99246, 67404, 67398, 66350, 67438, 69456, 100268, 69448, 100262, 69444, 69442, 67372, 69484, 67366, 69478, 102312, 116694, 102308, 102306, 69416, 100246, 73576, 102326, 73572, 69410, 73570, 67350, 69430, 73590, 118740, 118738, 102292, 106420, 102290, 106418, 69396, 73524, 69394, 81780, 73522, 81778, 118730, 102282, 106394, 69386, 73498, 81722, 66476, 66470, 67496, 99286, 67492, 67490, 66454, 67510, 100308, 100306, 67476, 69556, 67474, 69554, 116714])]); /*13874*/
		$1.cwtobits = function() {
			var _EO = $get($1.clusters, $k[--$j]); /*13878*/
			$1.v = $get(_EO, $k[--$j]); /*13878*/
			$k[$j++] = Infinity; /*13879*/
			for (var _ER = 0, _ES = 17; _ER < _ES; _ER++) { /*13879*/
				$k[$j++] = 0; /*13879*/
			} /*13879*/
			var _EV = $cvrs($s(17), $1.v, 2); /*13879*/
			for (var _EW = 0, _EX = _EV.length; _EW < _EX; _EW++) { /*13879*/
				$k[$j++] = $get(_EV, _EW) - 48; /*13879*/
			} /*13879*/
			var _EZ = $a(); /*13879*/
			$k[$j++] = $geti(_EZ, _EZ.length - 17, 17); /*13880*/
		}; /*13881*/
		if ($1.compact) { /*13887*/
			$1.rwid = (((17 * $1.c) + 17) + 17) + 1; /*13885*/
		} else { /*13887*/
			$1.rwid = ((((17 * $1.c) + 17) + 17) + 17) + 18; /*13887*/
		} /*13887*/
		$1.pixs = $a($1.rwid * $1.r); /*13889*/
		for (var _Ej = 0, _Ei = $1.r - 1; _Ej <= _Ei; _Ej += 1) { /*13919*/
			$1.i = _Ej; /*13892*/
			if (($1.i % 3) == 0) { /*13897*/
				$1.lcw = ((~~($1.i / 3)) * 30) + (~~(($1.r - 1) / 3)); /*13895*/
				$1.rcw = (((~~($1.i / 3)) * 30) + $1.c) - 1; /*13896*/
			} /*13896*/
			if (($1.i % 3) == 1) { /*13901*/
				$1.lcw = (((~~($1.i / 3)) * 30) + ($1.eclevel * 3)) + (($1.r - 1) % 3); /*13899*/
				$1.rcw = ((~~($1.i / 3)) * 30) + (~~(($1.r - 1) / 3)); /*13900*/
			} /*13900*/
			if (($1.i % 3) == 2) { /*13905*/
				$1.lcw = (((~~($1.i / 3)) * 30) + $1.c) - 1; /*13903*/
				$1.rcw = (((~~($1.i / 3)) * 30) + ($1.eclevel * 3)) + (($1.r - 1) % 3); /*13904*/
			} /*13904*/
			$k[$j++] = $1.pixs; /*13915*/
			$k[$j++] = $1.rwid * $1.i; /*13915*/
			$k[$j++] = Infinity; /*13915*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 0; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 0; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 0; /*13909*/
			$k[$j++] = 1; /*13909*/
			$k[$j++] = 0; /*13909*/
			$k[$j++] = 0; /*13909*/
			$k[$j++] = 0; /*13909*/
			$k[$j++] = $1.lcw; /*13909*/
			$k[$j++] = $1.i % 3; /*13909*/
			$1.cwtobits(); /*13909*/
			$forall($k[--$j]); /*13909*/
			$forall($geti($1.cws, $1.c * $1.i, $1.c), function() { /*13910*/
				$k[$j++] = $1.i % 3; /*13910*/
				$1.cwtobits(); /*13910*/
				$forall($k[--$j]); /*13910*/
			}); /*13910*/
			if ($1.compact) { /*13915*/
				$k[$j++] = 1; /*13912*/
			} else { /*13915*/
				$k[$j++] = $1.rcw; /*13914*/
				$k[$j++] = $1.i % 3; /*13914*/
				$1.cwtobits(); /*13914*/
				$forall($k[--$j]); /*13914*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 0; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 0; /*13915*/
				$k[$j++] = 0; /*13915*/
				$k[$j++] = 0; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 0; /*13915*/
				$k[$j++] = 1; /*13915*/
				$k[$j++] = 0; /*13915*/
				$k[$j++] = 0; /*13915*/
				$k[$j++] = 1; /*13915*/
			} /*13915*/
			var _FI = $a(); /*13915*/
			var _FJ = $k[--$j]; /*13917*/
			$puti($k[--$j], _FJ, _FI); /*13917*/
		} /*13917*/
		var _FS = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.rwid,
			pixy: $1.r,
			height: ($1.r / 72) * $1.rowmult,
			width: $1.rwid / 72,
			opt: $1.options
		}; /*13929*/
		$k[$j++] = _FS; /*13932*/
		if (!$1.dontdraw) { /*13932*/
			$0.renmatrix(); /*13932*/
		} /*13932*/
	};
	$0.pdf417compact = function() {
		var $1 = {}; /*13960*/
		$1.options = $k[--$j]; /*13962*/
		$1.barcode = $k[--$j]; /*13963*/
		$1.dontdraw = false; /*13965*/
		$forall($1.options, function() { /*13976*/
			var _3 = $k[--$j]; /*13976*/
			$1[$k[--$j]] = _3; /*13976*/
		}); /*13976*/
		$1.options.dontdraw = true; /*13979*/
		$1.options.compact = true; /*13980*/
		$k[$j++] = "args"; /*13982*/
		$k[$j++] = $1.barcode; /*13982*/
		$k[$j++] = $1.options; /*13982*/
		$0.pdf417(); /*13982*/
		var _9 = $k[--$j]; /*13982*/
		$1[$k[--$j]] = _9; /*13982*/
		$1.args.opt = $1.options; /*13984*/
		$k[$j++] = $1.args; /*13987*/
		if (!$1.dontdraw) { /*13987*/
			$0.renmatrix(); /*13987*/
		} /*13987*/
	};
	$0.micropdf417 = function() {
		var $1 = {}; /*14014*/
		$1.options = $k[--$j]; /*14016*/
		$1.barcode = $k[--$j]; /*14017*/
		$1.dontdraw = false; /*14019*/
		$1.version = "unset"; /*14020*/
		$1.columns = 0; /*14021*/
		$1.rows = 0; /*14022*/
		$1.rowmult = 2; /*14023*/
		$1.encoding = "auto"; /*14024*/
		$1.cca = false; /*14025*/
		$1.ccb = false; /*14026*/
		$1.raw = false; /*14027*/
		$1.parse = false; /*14028*/
		$forall($1.options, function() { /*14039*/
			var _3 = $k[--$j]; /*14039*/
			$1[$k[--$j]] = _3; /*14039*/
		}); /*14039*/
		if ($ne($1.version, "unset")) { /*14045*/
			$search($1.version, "x"); /*14042*/
			$j--; /*14043*/
			$1.columns = $k[--$j]; /*14043*/
			$j--; /*14044*/
			$1.rows = $k[--$j]; /*14044*/
		} /*14044*/
		$1.columns = ~~$z($1.columns); /*14047*/
		$1.rows = ~~$z($1.rows); /*14048*/
		$1.rowmult = +$1.rowmult; /*14049*/
		if ($1.raw) { /*14072*/
			$1.encoding = "raw"; /*14072*/
		} /*14072*/
		if ($1.cca) { /*14073*/
			$1.encoding = "cca"; /*14073*/
		} /*14073*/
		if ($eq($1.encoding, "raw") || $eq($1.encoding, "cca")) { /*14087*/
			$1.datcws = $a($1.barcode.length); /*14077*/
			$1.i = 0; /*14078*/
			$1.j = 0; /*14078*/
			for (;;) { /*14085*/
				if ($1.i == $1.barcode.length) { /*14080*/
					break; /*14080*/
				} /*14080*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*14081*/
				$put($1.datcws, $1.j, $1.cw); /*14082*/
				$1.i = $1.i + 4; /*14083*/
				$1.j = $1.j + 1; /*14084*/
			} /*14084*/
			$1.datcws = $geti($1.datcws, 0, $1.j); /*14086*/
		} /*14086*/
		$k[$j++] = Infinity; /*14089*/
		$forall($1.barcode); /*14089*/
		$1.barcode = $a(); /*14089*/
		$1.barlen = $1.barcode.length; /*14090*/
		if ($1.ccb) { /*14092*/
			$1.encoding = "ccb"; /*14092*/
		} /*14092*/
		$1.encb = function() {
			$1.in = $k[--$j]; /*14095*/
			$1.inlen = $1.in.length; /*14096*/
			$1.out = $a(((~~($1.inlen / 6)) * 5) + ($1.inlen % 6)); /*14097*/
			for (var _g = 0, _f = (~~($1.inlen / 6)) - 1; _g <= _f; _g += 1) { /*14120*/
				$1.k = _g; /*14099*/
				$k[$j++] = Infinity; /*14100*/
				$aload($geti($1.in, $1.k * 6, 3)); /*14100*/
				$1.msbs = $a(); /*14100*/
				$k[$j++] = Infinity; /*14104*/
				$aload($1.msbs); /*14102*/
				var _m = $k[--$j]; /*14102*/
				var _n = $k[--$j]; /*14102*/
				var _o = $k[--$j]; /*14102*/
				$k[$j++] = (_m + (_n * 256)) + (_o * 65536); /*14103*/
				for (var _p = 0, _q = 3; _p < _q; _p++) { /*14103*/
					var _r = $k[--$j]; /*14103*/
					$k[$j++] = _r % 900; /*14103*/
					$k[$j++] = ~~(_r / 900); /*14103*/
				} /*14103*/
				$1.mscs = $a(); /*14104*/
				$k[$j++] = Infinity; /*14105*/
				$aload($geti($1.in, ($1.k * 6) + 3, 3)); /*14105*/
				$1.lsbs = $a(); /*14105*/
				$k[$j++] = Infinity; /*14109*/
				$aload($1.lsbs); /*14107*/
				var _y = $k[--$j]; /*14107*/
				var _z = $k[--$j]; /*14107*/
				var _10 = $k[--$j]; /*14107*/
				$k[$j++] = (_y + (_z * 256)) + (_10 * 65536); /*14108*/
				for (var _11 = 0, _12 = 3; _11 < _12; _11++) { /*14108*/
					var _13 = $k[--$j]; /*14108*/
					$k[$j++] = _13 % 900; /*14108*/
					$k[$j++] = ~~(_13 / 900); /*14108*/
				} /*14108*/
				$1.lscs = $a(); /*14109*/
				var _16 = $get($1.lscs, 0); /*14110*/
				var _18 = $get($1.mscs, 0); /*14110*/
				$put($1.out, ($1.k * 5) + 4, (_16 + (_18 * 316)) % 900); /*14111*/
				var _1C = $get($1.lscs, 1); /*14112*/
				var _1E = $get($1.mscs, 0); /*14112*/
				var _1G = $get($1.mscs, 1); /*14112*/
				$put($1.out, ($1.k * 5) + 3, ((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) % 900); /*14113*/
				var _1K = $get($1.lscs, 2); /*14114*/
				var _1M = $get($1.mscs, 0); /*14114*/
				var _1O = $get($1.mscs, 1); /*14114*/
				var _1Q = $get($1.mscs, 2); /*14114*/
				$put($1.out, ($1.k * 5) + 2, (((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) % 900); /*14115*/
				var _1U = $get($1.lscs, 3); /*14116*/
				var _1W = $get($1.mscs, 1); /*14116*/
				var _1Y = $get($1.mscs, 2); /*14116*/
				$put($1.out, ($1.k * 5) + 1, ((((~~((((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) / 900)) + _1U) + (_1W * 20)) + (_1Y * 641)) % 900); /*14117*/
				$put($1.out, $1.k * 5, ((~~(((((~~((((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) / 900)) + _1U) + (_1W * 20)) + (_1Y * 641)) / 900)) + ($get($1.mscs, 2) * 20)) % 900); /*14119*/
			} /*14119*/
			$1.rem = $1.inlen % 6; /*14121*/
			if ($1.rem != 0) { /*14126*/
				$k[$j++] = $1.out; /*14124*/
				$k[$j++] = $1.out.length - $1.rem; /*14124*/
				$k[$j++] = Infinity; /*14124*/
				$aload($geti($1.in, $1.inlen - $1.rem, $1.rem)); /*14124*/
				var _1p = $a(); /*14124*/
				var _1q = $k[--$j]; /*14125*/
				$puti($k[--$j], _1q, _1p); /*14125*/
			} /*14125*/
			$k[$j++] = $1.out; /*14127*/
		}; /*14128*/
		if ($eq($1.encoding, "byte") || $eq($1.encoding, "ccb")) { /*14135*/
			$1.datcws = $a((((~~($1.barlen / 6)) * 5) + ($1.barlen % 6)) + 1); /*14131*/
			var _20 = (($1.barlen % 6) == 0) ? 924 : 901; /*14132*/
			$put($1.datcws, 0, _20); /*14132*/
			$k[$j++] = $1.datcws; /*14133*/
			$k[$j++] = 1; /*14133*/
			$k[$j++] = $1.barcode; /*14133*/
			$1.encb(); /*14133*/
			var _23 = $k[--$j]; /*14133*/
			var _24 = $k[--$j]; /*14133*/
			$puti($k[--$j], _24, _23); /*14133*/
			if ($eq($1.encoding, "ccb")) { /*14134*/
				$k[$j++] = Infinity; /*14134*/
				$k[$j++] = 920; /*14134*/
				$aload($1.datcws); /*14134*/
				$1.datcws = $a(); /*14134*/
			} /*14134*/
		} /*14134*/
		if ($eq($1.encoding, "auto")) { /*14499*/
			$1.T = 0; /*14140*/
			$1.N = 1; /*14140*/
			$1.B = 2; /*14140*/
			$1.A = 0; /*14141*/
			$1.L = 1; /*14141*/
			$1.M = 2; /*14141*/
			$1.P = 3; /*14141*/
			$1.tl = -1; /*14144*/
			$1.nl = -2; /*14144*/
			$1.bl = -3; /*14144*/
			$1.bl6 = -4; /*14144*/
			$1.bs = -5; /*14144*/
			$1.al = -6; /*14147*/
			$1.ll = -7; /*14147*/
			$1.ml = -8; /*14147*/
			$1.pl = -9; /*14147*/
			$1.as = -10; /*14147*/
			$1.ps = -11; /*14147*/
			$1.charmaps = $a([$a(["A", "a", "0", ";"]), $a(["B", "b", "1", "<"]), $a(["C", "c", "2", ">"]), $a(["D", "d", "3", "@"]), $a(["E", "e", "4", "["]), $a(["F", "f", "5", 92]), $a(["G", "g", "6", "]"]), $a(["H", "h", "7", "_"]), $a(["I", "i", "8", "`"]), $a(["J", "j", "9", "~"]), $a(["K", "k", "&", "!"]), $a(["L", "l", 13, 13]), $a(["M", "m", 9, 9]), $a(["N", "n", ",", ","]), $a(["O", "o", ":", ":"]), $a(["P", "p", "#", 10]), $a(["Q", "q", "-", "-"]), $a(["R", "r", ".", "."]), $a(["S", "s", "$", "$"]), $a(["T", "t", "/", "/"]), $a(["U", "u", "+", "\""]), $a(["V", "v", "%", "|"]), $a(["W", "w", "*", "*"]), $a(["X", "x", "=", 40]), $a(["Y", "y", "^", 41]), $a(["Z", "z", $1.pl, "?"]), $a([" ", " ", " ", "{"]), $a([$1.ll, $1.as, $1.ll, "}"]), $a([$1.ml, $1.ml, $1.al, "'"]), $a([$1.ps, $1.ps, $1.ps, $1.al])]); /*14182*/
			$1.charvals = $a([{}, {}, {}, {}]); /*14185*/
			$1.alltext = {}; /*14186*/
			for (var _2t = 0, _2s = $1.charmaps.length - 1; _2t <= _2s; _2t += 1) { /*14196*/
				$1.i = _2t; /*14188*/
				$1.encs = $get($1.charmaps, $1.i); /*14189*/
				for (var _2x = 0; _2x <= 3; _2x += 1) { /*14195*/
					$1.j = _2x; /*14191*/
					var _30 = $get($1.encs, $1.j); /*14192*/
					$k[$j++] = _30; /*14192*/
					if ($eq($type(_30), "stringtype")) { /*14192*/
						var _33 = $get($k[--$j], 0); /*14192*/
						$k[$j++] = _33; /*14192*/
					} /*14192*/
					var _34 = $k[--$j]; /*14193*/
					$put($get($1.charvals, $1.j), _34, $1.i); /*14193*/
					$put($1.alltext, _34, -1); /*14194*/
				} /*14194*/
			} /*14194*/
			$1.e = 10000; /*14198*/
			$1.latlen = $a([$a([0, 1, 1, 2]), $a([2, 0, 1, 2]), $a([1, 1, 0, 1]), $a([1, 2, 2, 0])]); /*14206*/
			$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.ml, $1.al]), $a([]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.al]), $a([$1.ll]), $a([]), $a([$1.pl])]), $a([$a([$1.al]), $a([$1.al, $1.ll]), $a([$1.al, $1.ml]), $a([])])]); /*14214*/
			$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 1]), $a([1, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, $1.e])]); /*14222*/
			$k[$j++] = Infinity; /*14225*/
			for (var _49 = 0, _4A = $1.barlen; _49 < _4A; _49++) { /*14225*/
				$k[$j++] = 0; /*14225*/
			} /*14225*/
			$k[$j++] = 0; /*14225*/
			$1.numdigits = $a(); /*14225*/
			$k[$j++] = Infinity; /*14226*/
			for (var _4D = 0, _4E = $1.barlen; _4D < _4E; _4D++) { /*14226*/
				$k[$j++] = 0; /*14226*/
			} /*14226*/
			$k[$j++] = 0; /*14226*/
			$1.numtext = $a(); /*14226*/
			$k[$j++] = Infinity; /*14227*/
			for (var _4H = 0, _4I = $1.barlen; _4H < _4I; _4H++) { /*14227*/
				$k[$j++] = 0; /*14227*/
			} /*14227*/
			$k[$j++] = 0; /*14227*/
			$1.numbytes = $a(); /*14227*/
			for (var _4L = $1.barlen - 1; _4L >= 0; _4L -= 1) { /*14239*/
				$1.i = _4L; /*14229*/
				var _4O = $get($1.barcode, $1.i); /*14230*/
				if ((_4O >= 48) && (_4O <= 57)) { /*14232*/
					$put($1.numdigits, $1.i, $get($1.numdigits, $1.i + 1) + 1); /*14231*/
				} /*14231*/
				var _4Y = $get($1.alltext, $get($1.barcode, $1.i)) !== undefined; /*14233*/
				if (_4Y && ($get($1.numdigits, $1.i) < 13)) { /*14235*/
					$put($1.numtext, $1.i, $get($1.numtext, $1.i + 1) + 1); /*14234*/
				} /*14234*/
				if (($get($1.numtext, $1.i) < 5) && ($get($1.numdigits, $1.i) < 13)) { /*14238*/
					$put($1.numbytes, $1.i, $get($1.numbytes, $1.i + 1) + 1); /*14237*/
				} /*14237*/
			} /*14237*/
			$1.numdigits = $geti($1.numdigits, 0, $1.barlen); /*14240*/
			$1.numtext = $geti($1.numtext, 0, $1.barlen); /*14241*/
			$1.numbytes = $geti($1.numbytes, 0, $1.barlen); /*14242*/
			$1.seq = $a([]); /*14244*/
			$1.seqlen = 0; /*14244*/
			$1.state = $1.B; /*14244*/
			$1.p = 0; /*14244*/
			for (;;) { /*14287*/
				if ($1.p == $1.barlen) { /*14245*/
					break; /*14245*/
				} /*14245*/
				$1.n = $get($1.numdigits, $1.p); /*14246*/
				if ($1.n >= 13) { /*14285*/
					$k[$j++] = Infinity; /*14252*/
					$aload($1.seq); /*14249*/
					$k[$j++] = $1.nl; /*14251*/
					$k[$j++] = Infinity; /*14251*/
					$aload($geti($1.barcode, $1.p, $1.n)); /*14251*/
					var _5F = $a(); /*14251*/
					$k[$j++] = _5F; /*14251*/
					$1.seq = $a(); /*14252*/
					$1.state = $1.N; /*14253*/
					$1.p = $1.p + $1.n; /*14254*/
					$1.seqlen = ($1.seqlen + 1) + $1.n; /*14255*/
				} else { /*14285*/
					$1.t = $get($1.numtext, $1.p); /*14257*/
					if ($1.t >= 5) { /*14285*/
						$k[$j++] = Infinity; /*14263*/
						$aload($1.seq); /*14260*/
						if ($1.state != $1.T) { /*14261*/
							$k[$j++] = $1.tl; /*14261*/
						} /*14261*/
						$k[$j++] = Infinity; /*14262*/
						$aload($geti($1.barcode, $1.p, $1.t)); /*14262*/
						var _5Y = $a(); /*14262*/
						$k[$j++] = _5Y; /*14262*/
						$1.seq = $a(); /*14263*/
						$1.state = $1.T; /*14264*/
						$1.p = $1.p + $1.t; /*14265*/
						$1.seqlen = ($1.seqlen + 1) + $1.t; /*14266*/
					} else { /*14285*/
						$1.b = $get($1.numbytes, $1.p); /*14268*/
						if (($1.b == 1) && ($1.state == $1.T)) { /*14285*/
							$k[$j++] = Infinity; /*14274*/
							$aload($1.seq); /*14271*/
							$k[$j++] = $1.bs; /*14273*/
							$k[$j++] = $a([$get($1.barcode, $1.p)]); /*14273*/
							$1.seq = $a(); /*14274*/
							$1.p = $1.p + $1.b; /*14275*/
							$1.seqlen = $1.seqlen + 2; /*14276*/
						} else { /*14285*/
							$k[$j++] = Infinity; /*14282*/
							$aload($1.seq); /*14279*/
							if (($1.b % 6) != 0) { /*14280*/
								$k[$j++] = $1.bl; /*14280*/
							} else { /*14280*/
								$k[$j++] = $1.bl6; /*14280*/
							} /*14280*/
							$k[$j++] = Infinity; /*14281*/
							$aload($geti($1.barcode, $1.p, $1.b)); /*14281*/
							var _63 = $a(); /*14281*/
							$k[$j++] = _63; /*14281*/
							$1.seq = $a(); /*14282*/
							$1.state = $1.B; /*14283*/
							$1.p = $1.p + $1.b; /*14284*/
							$1.seqlen = ($1.seqlen + 1) + $1.b; /*14285*/
						} /*14285*/
					} /*14285*/
				} /*14285*/
			} /*14285*/
			$k[$j++] = "latchcws"; /*14290*/
			$k[$j++] = Infinity; /*14290*/
			$k[$j++] = $1.tl; /*14290*/
			$k[$j++] = 900; /*14290*/
			$k[$j++] = $1.bl; /*14290*/
			$k[$j++] = 901; /*14290*/
			$k[$j++] = $1.bl6; /*14290*/
			$k[$j++] = 924; /*14290*/
			$k[$j++] = $1.nl; /*14290*/
			$k[$j++] = 902; /*14290*/
			$k[$j++] = $1.bs; /*14290*/
			$k[$j++] = 913; /*14290*/
			var _6F = $d(); /*14290*/
			$1[$k[--$j]] = _6F; /*14291*/
			$1.enca = function() {
				var _6L = $get($get($1.charvals, $1.A), $k[--$j]); /*14294*/
				$k[$j++] = _6L; /*14294*/
			}; /*14294*/
			$1.encl = function() {
				var _6Q = $get($get($1.charvals, $1.L), $k[--$j]); /*14295*/
				$k[$j++] = _6Q; /*14295*/
			}; /*14295*/
			$1.encm = function() {
				var _6V = $get($get($1.charvals, $1.M), $k[--$j]); /*14296*/
				$k[$j++] = _6V; /*14296*/
			}; /*14296*/
			$1.encp = function() {
				var _6a = $get($get($1.charvals, $1.P), $k[--$j]); /*14297*/
				$k[$j++] = _6a; /*14297*/
			}; /*14297*/
			$1.textencfuncs = $a(["enca", "encl", "encm", "encp"]); /*14298*/
			$1.addtotext = function() {
				$put($1.text, $1.l, $k[--$j]); /*14301*/
				$1.l = $1.l + 1; /*14302*/
			}; /*14303*/
			$1.enct = function() {
				$1.in = $k[--$j]; /*14307*/
				$1.curlen = $a([$1.e, $1.e, $1.e, $1.e]); /*14309*/
				$put($1.curlen, $1.submode, 0); /*14310*/
				$1.curseq = $a([$a([]), $a([]), $a([]), $a([])]); /*14311*/
				$forall($1.in, function() { /*14381*/
					$1.char = $k[--$j]; /*14316*/
					for (;;) { /*14337*/
						$1.imp = false; /*14320*/
						var _6z = $a([$1.A, $1.L, $1.M, $1.P]); /*14321*/
						for (var _70 = 0, _71 = _6z.length; _70 < _71; _70++) { /*14335*/
							$1.x = $get(_6z, _70); /*14322*/
							var _77 = $a([$1.A, $1.L, $1.M, $1.P]); /*14323*/
							for (var _78 = 0, _79 = _77.length; _78 < _79; _78++) { /*14334*/
								$1.y = $get(_77, _78); /*14324*/
								$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*14325*/
								if ($1.cost < $get($1.curlen, $1.y)) { /*14333*/
									$put($1.curlen, $1.y, $1.cost); /*14327*/
									$k[$j++] = $1.curseq; /*14330*/
									$k[$j++] = $1.y; /*14330*/
									$k[$j++] = Infinity; /*14330*/
									$aload($get($1.curseq, $1.x)); /*14329*/
									$aload($get($get($1.latseq, $1.x), $1.y)); /*14330*/
									var _7a = $a(); /*14330*/
									var _7b = $k[--$j]; /*14331*/
									$put($k[--$j], _7b, _7a); /*14331*/
									$1.imp = true; /*14332*/
								} /*14332*/
							} /*14332*/
						} /*14332*/
						if (!$1.imp) { /*14336*/
							break; /*14336*/
						} /*14336*/
					} /*14336*/
					$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e]); /*14340*/
					$1.nxtseq = $a(4); /*14341*/
					var _7o = $a([$1.A, $1.L, $1.M, $1.P]); /*14343*/
					for (var _7p = 0, _7q = _7o.length; _7p < _7q; _7p++) { /*14376*/
						$1.x = $get(_7o, _7p); /*14344*/
						for (;;) { /*14374*/
							var _7w = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*14348*/
							if (!_7w) { /*14348*/
								break; /*14348*/
							} /*14348*/
							$1.cost = $get($1.curlen, $1.x) + 1; /*14351*/
							if ($1.cost < $get($1.nxtlen, $1.x)) { /*14355*/
								$put($1.nxtlen, $1.x, $1.cost); /*14353*/
								$k[$j++] = $1.nxtseq; /*14354*/
								$k[$j++] = $1.x; /*14354*/
								$k[$j++] = Infinity; /*14354*/
								$aload($get($1.curseq, $1.x)); /*14354*/
								$k[$j++] = $1.char; /*14354*/
								var _8D = $a(); /*14354*/
								var _8E = $k[--$j]; /*14354*/
								$put($k[--$j], _8E, _8D); /*14354*/
							} /*14354*/
							var _8K = $a([$1.A, $1.L, $1.M, $1.P]); /*14358*/
							for (var _8L = 0, _8M = _8K.length; _8L < _8M; _8L++) { /*14371*/
								$1.y = $get(_8K, _8L); /*14359*/
								if ($ne($1.x, $1.y)) { /*14370*/
									$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + 1; /*14361*/
									if ($1.cost < $get($1.nxtlen, $1.y)) { /*14369*/
										$put($1.nxtlen, $1.y, $1.cost); /*14363*/
										$k[$j++] = $1.nxtseq; /*14367*/
										$k[$j++] = $1.y; /*14367*/
										$k[$j++] = Infinity; /*14367*/
										$aload($get($1.curseq, $1.y)); /*14365*/
										if ($1.x == $1.A) { /*14366*/
											$k[$j++] = $1.as; /*14366*/
										} else { /*14366*/
											$k[$j++] = $1.ps; /*14366*/
										} /*14366*/
										$k[$j++] = $1.char; /*14367*/
										var _8p = $a(); /*14367*/
										var _8q = $k[--$j]; /*14368*/
										$put($k[--$j], _8q, _8p); /*14368*/
									} /*14368*/
								} /*14368*/
							} /*14368*/
							break; /*14373*/
						} /*14373*/
					} /*14373*/
					$1.curlen = $1.nxtlen; /*14378*/
					$1.curseq = $1.nxtseq; /*14379*/
				}); /*14379*/
				$1.minseq = $1.e; /*14384*/
				var _8z = $a([$1.A, $1.L, $1.M, $1.P]); /*14385*/
				for (var _90 = 0, _91 = _8z.length; _90 < _91; _90++) { /*14391*/
					$1.k = $get(_8z, _90); /*14386*/
					if ($get($1.curlen, $1.k) < $1.minseq) { /*14390*/
						$1.minseq = $get($1.curlen, $1.k); /*14388*/
						$1.txtseq = $get($1.curseq, $1.k); /*14389*/
					} /*14389*/
				} /*14389*/
				$1.text = $a($1.minseq); /*14394*/
				$1.k = 0; /*14395*/
				$1.l = 0; /*14395*/
				for (;;) { /*14415*/
					if ($1.k >= $1.txtseq.length) { /*14396*/
						break; /*14396*/
					} /*14396*/
					$1.char = $get($1.txtseq, $1.k); /*14398*/
					$k[$j++] = $1.char; /*14401*/
					$1[$get($1.textencfuncs, $1.submode)](); /*14401*/
					$1.addtotext(); /*14401*/
					$1.k = $1.k + 1; /*14402*/
					if (($1.char == $1.as) || ($1.char == $1.ps)) { /*14408*/
						$k[$j++] = $get($1.txtseq, $1.k); /*14406*/
						if ($1.char == $1.as) { /*14406*/
							$1.enca(); /*14406*/
						} else { /*14406*/
							$1.encp(); /*14406*/
						} /*14406*/
						$1.addtotext(); /*14406*/
						$1.k = $1.k + 1; /*14407*/
					} /*14407*/
					if ($1.char == $1.al) { /*14411*/
						$1.submode = $1.A; /*14411*/
					} /*14411*/
					if ($1.char == $1.ll) { /*14412*/
						$1.submode = $1.L; /*14412*/
					} /*14412*/
					if ($1.char == $1.ml) { /*14413*/
						$1.submode = $1.M; /*14413*/
					} /*14413*/
					if ($1.char == $1.pl) { /*14414*/
						$1.submode = $1.P; /*14414*/
					} /*14414*/
				} /*14414*/
				if (($1.text.length % 2) == 1) { /*14425*/
					if ($1.submode == $1.P) { /*14422*/
						$k[$j++] = "pad"; /*14419*/
						$k[$j++] = $1.al; /*14419*/
						$1.encp(); /*14419*/
						var _9q = $k[--$j]; /*14419*/
						$1[$k[--$j]] = _9q; /*14419*/
						$1.submode = $1.A; /*14420*/
					} else { /*14422*/
						$k[$j++] = "pad"; /*14422*/
						$k[$j++] = $1.ps; /*14422*/
						$1[$get($1.textencfuncs, $1.submode)](); /*14422*/
						var _9y = $k[--$j]; /*14422*/
						$1[$k[--$j]] = _9y; /*14422*/
					} /*14422*/
					$k[$j++] = Infinity; /*14424*/
					$aload($1.text); /*14424*/
					$k[$j++] = $1.pad; /*14424*/
					$1.text = $a(); /*14424*/
				} /*14424*/
				$1.out = $a(~~($1.text.length / 2)); /*14427*/
				for (var _A7 = 0, _A6 = $1.out.length - 1; _A7 <= _A6; _A7 += 1) { /*14431*/
					$1.k = _A7; /*14429*/
					$put($1.out, $1.k, ($get($1.text, $1.k * 2) * 30) + $get($1.text, ($1.k * 2) + 1)); /*14430*/
				} /*14430*/
				$k[$j++] = $1.out; /*14433*/
			}; /*14435*/
			$1.encn = function() {
				$1.in = $k[--$j]; /*14438*/
				$1.out = $a([]); /*14439*/
				for (var _AL = 0, _AK = $1.in.length - 1; _AL <= _AK; _AL += 44) { /*14467*/
					$1.k = _AL; /*14441*/
					$k[$j++] = Infinity; /*14445*/
					var _AQ = $1.in.length - $1.k; /*14443*/
					$k[$j++] = 1; /*14443*/
					$k[$j++] = $1.in; /*14443*/
					$k[$j++] = $1.k; /*14443*/
					$k[$j++] = _AQ; /*14443*/
					if (_AQ > 44) { /*14443*/
						$j--; /*14443*/
						$k[$j++] = 44; /*14443*/
					} /*14443*/
					var _AR = $k[--$j]; /*14443*/
					var _AS = $k[--$j]; /*14443*/
					$forall($geti($k[--$j], _AS, _AR), function() { /*14444*/
						var _AV = $k[--$j]; /*14444*/
						$k[$j++] = _AV - 48; /*14444*/
					}); /*14444*/
					$1.gmod = $a(); /*14445*/
					$1.cwn = $a([]); /*14446*/
					for (;;) { /*14465*/
						$1.dv = 900; /*14447*/
						$1.gmul = $a([]); /*14448*/
						$1.val = 0; /*14448*/
						for (;;) { /*14460*/
							if ($1.gmod.length == 0) { /*14449*/
								break; /*14449*/
							} /*14449*/
							$1.val = ($1.val * 10) + $get($1.gmod, 0); /*14450*/
							$1.gmod = $geti($1.gmod, 1, $1.gmod.length - 1); /*14451*/
							if ($1.val < $1.dv) { /*14457*/
								if ($1.gmul.length != 0) { /*14455*/
									$k[$j++] = Infinity; /*14454*/
									$aload($1.gmul); /*14454*/
									$k[$j++] = 0; /*14454*/
									$1.gmul = $a(); /*14454*/
								} /*14454*/
							} else { /*14457*/
								$k[$j++] = Infinity; /*14457*/
								$aload($1.gmul); /*14457*/
								$k[$j++] = ~~($1.val / $1.dv); /*14457*/
								$1.gmul = $a(); /*14457*/
							} /*14457*/
							$1.val = $1.val % $1.dv; /*14459*/
						} /*14459*/
						$1.dv = $1.val; /*14461*/
						$k[$j++] = Infinity; /*14462*/
						$k[$j++] = $1.dv; /*14462*/
						$aload($1.cwn); /*14462*/
						$1.cwn = $a(); /*14462*/
						$1.gmod = $1.gmul; /*14463*/
						if ($1.gmul.length == 0) { /*14464*/
							break; /*14464*/
						} /*14464*/
					} /*14464*/
					$k[$j++] = Infinity; /*14466*/
					$aload($1.out); /*14466*/
					$aload($1.cwn); /*14466*/
					$1.out = $a(); /*14466*/
				} /*14466*/
				$k[$j++] = $1.out; /*14468*/
			}; /*14469*/
			$1.encfuncs = $a(["enct", "encn", "encb"]); /*14471*/
			$1.addtocws = function() {
				var _B2 = $k[--$j]; /*14474*/
				$puti($1.datcws, $1.j, _B2); /*14474*/
				$1.j = _B2.length + $1.j; /*14475*/
			}; /*14476*/
			$1.state = $1.T; /*14479*/
			$1.submode = $1.A; /*14479*/
			$1.datcws = $a($1.seqlen); /*14480*/
			$1.i = 0; /*14481*/
			$1.j = 0; /*14481*/
			for (;;) { /*14497*/
				if ($1.i >= $1.seq.length) { /*14482*/
					break; /*14482*/
				} /*14482*/
				$1.chars = $get($1.seq, $1.i); /*14483*/
				if ($eq($type($1.chars), "arraytype")) { /*14493*/
					$k[$j++] = $1.chars; /*14485*/
					$1[$get($1.encfuncs, $1.state)](); /*14485*/
					$1.addtocws(); /*14485*/
				} else { /*14493*/
					$k[$j++] = $a([$get($1.latchcws, $1.chars)]); /*14487*/
					$1.addtocws(); /*14487*/
					if ($1.chars == $1.tl) { /*14488*/
						$1.state = $1.T; /*14488*/
						$1.submode = $1.A; /*14488*/
					} /*14488*/
					if ($1.chars == $1.nl) { /*14489*/
						$1.state = $1.N; /*14489*/
					} /*14489*/
					if (($1.chars == $1.bl) || ($1.chars == $1.bl6)) { /*14490*/
						$1.state = $1.B; /*14490*/
					} /*14490*/
					if ($1.chars == $1.bs) { /*14494*/
						$1.i = $1.i + 1; /*14492*/
						$k[$j++] = $get($1.seq, $1.i); /*14493*/
						$1.encb(); /*14493*/
						$1.addtocws(); /*14493*/
					} /*14493*/
				} /*14493*/
				$1.i = $1.i + 1; /*14496*/
			} /*14496*/
			$1.datcws = $geti($1.datcws, 0, $1.j); /*14498*/
		} /*14498*/
		$1.metrics = $a([$a([1, 11, 7, 1, 0, 9]), $a([1, 14, 7, 8, 0, 8]), $a([1, 17, 7, 36, 0, 36]), $a([1, 20, 8, 19, 0, 19]), $a([1, 24, 8, 9, 0, 17]), $a([1, 28, 8, 25, 0, 33]), $a([2, 8, 8, 1, 0, 1]), $a([2, 11, 9, 1, 0, 9]), $a([2, 14, 9, 8, 0, 8]), $a([2, 17, 10, 36, 0, 36]), $a([2, 20, 11, 19, 0, 19]), $a([2, 23, 13, 9, 0, 17]), $a([2, 26, 15, 27, 0, 35]), $a([3, 6, 12, 1, 1, 1]), $a([3, 8, 14, 7, 7, 7]), $a([3, 10, 16, 15, 15, 15]), $a([3, 12, 18, 25, 25, 25]), $a([3, 15, 21, 37, 37, 37]), $a([3, 20, 26, 1, 17, 33]), $a([3, 26, 32, 1, 9, 17]), $a([3, 32, 38, 21, 29, 37]), $a([3, 38, 44, 15, 31, 47]), $a([3, 44, 50, 1, 25, 49]), $a([4, 4, 8, 47, 19, 43]), $a([4, 6, 12, 1, 1, 1]), $a([4, 8, 14, 7, 7, 7]), $a([4, 10, 16, 15, 15, 15]), $a([4, 12, 18, 25, 25, 25]), $a([4, 15, 21, 37, 37, 37]), $a([4, 20, 26, 1, 17, 33]), $a([4, 26, 32, 1, 9, 17]), $a([4, 32, 38, 21, 29, 37]), $a([4, 38, 44, 15, 31, 47]), $a([4, 44, 50, 1, 25, 49])]); /*14538*/
		$1.ccametrics = $a([$a([2, 5, 4, 39, 0, 19]), $a([2, 6, 4, 1, 0, 33]), $a([2, 7, 5, 32, 0, 12]), $a([2, 8, 5, 8, 0, 40]), $a([2, 9, 6, 14, 0, 46]), $a([2, 10, 6, 43, 0, 23]), $a([2, 12, 7, 20, 0, 52]), $a([3, 4, 4, 11, 43, 23]), $a([3, 5, 5, 1, 33, 13]), $a([3, 6, 6, 5, 37, 17]), $a([3, 7, 7, 15, 47, 27]), $a([3, 8, 7, 21, 1, 33]), $a([4, 3, 4, 40, 20, 52]), $a([4, 4, 5, 43, 23, 3]), $a([4, 5, 6, 46, 26, 6]), $a([4, 6, 7, 34, 14, 46]), $a([4, 7, 8, 29, 9, 41])]); /*14560*/
		if ($1.cca) { /*14561*/
			$1.metrics = $1.ccametrics; /*14561*/
		} /*14561*/
		$1.urows = $1.rows; /*14564*/
		$1.ucols = $1.columns; /*14565*/
		$1.i = 0; /*14566*/
		for (;;) { /*14582*/
			$1.m = $get($1.metrics, $1.i); /*14568*/
			$1.c = $get($1.m, 0); /*14569*/
			$1.r = $get($1.m, 1); /*14570*/
			$1.k = $get($1.m, 2); /*14571*/
			$1.rapl = $get($1.m, 3); /*14572*/
			$1.rapc = $get($1.m, 4); /*14573*/
			$1.rapr = $get($1.m, 5); /*14574*/
			$1.ncws = ($1.r * $1.c) - $1.k; /*14575*/
			$1.okay = true; /*14576*/
			if ($1.datcws.length > $1.ncws) { /*14577*/
				$1.okay = false; /*14577*/
			} /*14577*/
			if (($1.urows != 0) && ($1.urows != $1.r)) { /*14578*/
				$1.okay = false; /*14578*/
			} /*14578*/
			if (($1.ucols != 0) && ($1.ucols != $1.c)) { /*14579*/
				$1.okay = false; /*14579*/
			} /*14579*/
			if ($1.okay) { /*14580*/
				break; /*14580*/
			} /*14580*/
			$1.i = $1.i + 1; /*14581*/
		} /*14581*/
		$1.m = $1.datcws.length; /*14583*/
		$1.n = ($1.c * $1.r) - $1.k; /*14586*/
		$1.cws = $a(($1.c * $1.r) + 1); /*14587*/
		$puti($1.cws, 0, $1.datcws); /*14588*/
		$k[$j++] = $1.cws; /*14589*/
		$k[$j++] = $1.m; /*14589*/
		$k[$j++] = Infinity; /*14589*/
		for (var _DM = 0, _DN = $1.n - $1.m; _DM < _DN; _DM++) { /*14589*/
			$k[$j++] = 900; /*14589*/
		} /*14589*/
		var _DO = $a(); /*14589*/
		var _DP = $k[--$j]; /*14589*/
		$puti($k[--$j], _DP, _DO); /*14589*/
		$k[$j++] = $1.cws; /*14590*/
		$k[$j++] = $1.n; /*14590*/
		$k[$j++] = Infinity; /*14590*/
		for (var _DU = 0, _DV = $1.k; _DU < _DV; _DU++) { /*14590*/
			$k[$j++] = 0; /*14590*/
		} /*14590*/
		$k[$j++] = 0; /*14590*/
		var _DW = $a(); /*14590*/
		var _DX = $k[--$j]; /*14590*/
		$puti($k[--$j], _DX, _DW); /*14590*/
		$k[$j++] = Infinity; /*14593*/
		$k[$j++] = 1; /*14593*/
		for (var _DZ = 0, _Da = 928; _DZ < _Da; _DZ++) { /*14593*/
			var _Db = $k[--$j]; /*14593*/
			$k[$j++] = _Db; /*14593*/
			$k[$j++] = (_Db * 3) % 929; /*14593*/
		} /*14593*/
		$1.rsalog = $a(); /*14593*/
		$1.rslog = $a(929); /*14594*/
		for (var _De = 1; _De <= 928; _De += 1) { /*14595*/
			$put($1.rslog, $get($1.rsalog, _De), _De); /*14595*/
		} /*14595*/
		$1.rsprod = function() {
			var _Di = $k[--$j]; /*14599*/
			var _Dj = $k[--$j]; /*14599*/
			$k[$j++] = _Dj; /*14603*/
			$k[$j++] = _Di; /*14603*/
			if ((_Di != 0) && (_Dj != 0)) { /*14602*/
				var _Dm = $get($1.rslog, $k[--$j]); /*14600*/
				var _Dr = $get($1.rsalog, (_Dm + $get($1.rslog, $k[--$j])) % 928); /*14600*/
				$k[$j++] = _Dr; /*14600*/
			} else { /*14602*/
				$j -= 2; /*14602*/
				$k[$j++] = 0; /*14602*/
			} /*14602*/
		}; /*14604*/
		$k[$j++] = Infinity; /*14607*/
		$k[$j++] = 1; /*14607*/
		for (var _Dt = 0, _Du = $1.k; _Dt < _Du; _Dt++) { /*14607*/
			$k[$j++] = 0; /*14607*/
		} /*14607*/
		$1.coeffs = $a(); /*14607*/
		for (var _Dy = 1, _Dx = $1.k; _Dy <= _Dx; _Dy += 1) { /*14616*/
			$1.i = _Dy; /*14609*/
			$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*14610*/
			for (var _E5 = $1.i - 1; _E5 >= 1; _E5 -= 1) { /*14614*/
				$1.j = _E5; /*14612*/
				$k[$j++] = $1.coeffs; /*14613*/
				$k[$j++] = $1.j; /*14613*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*14613*/
				$k[$j++] = $get($1.coeffs, $1.j); /*14613*/
				$k[$j++] = $get($1.rsalog, $1.i); /*14613*/
				$1.rsprod(); /*14613*/
				var _EH = $k[--$j]; /*14613*/
				var _EI = $k[--$j]; /*14613*/
				var _EJ = $k[--$j]; /*14613*/
				$put($k[--$j], _EJ, (_EI + _EH) % 929); /*14613*/
			} /*14613*/
			$k[$j++] = $1.coeffs; /*14615*/
			$k[$j++] = 0; /*14615*/
			$k[$j++] = $get($1.coeffs, 0); /*14615*/
			$k[$j++] = $get($1.rsalog, $1.i); /*14615*/
			$1.rsprod(); /*14615*/
			var _ER = $k[--$j]; /*14615*/
			var _ES = $k[--$j]; /*14615*/
			$put($k[--$j], _ES, _ER); /*14615*/
		} /*14615*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*14617*/
		for (var _EY = $1.coeffs.length - 1; _EY >= 0; _EY -= 2) { /*14618*/
			var _EZ = $1.coeffs; /*14618*/
			$put(_EZ, _EY, 929 - $get(_EZ, _EY)); /*14618*/
		} /*14618*/
		for (var _Ed = 0, _Ec = $1.n - 1; _Ed <= _Ec; _Ed += 1) { /*14627*/
			$1.t = ($get($1.cws, _Ed) + $get($1.cws, $1.n)) % 929; /*14622*/
			for (var _El = 0, _Ek = $1.k - 1; _El <= _Ek; _El += 1) { /*14626*/
				$1.j = _El; /*14624*/
				$put($1.cws, $1.n + $1.j, ($get($1.cws, ($1.n + $1.j) + 1) + (929 - (($1.t * $get($1.coeffs, ($1.k - $1.j) - 1)) % 929))) % 929); /*14625*/
			} /*14625*/
		} /*14625*/
		for (var _F2 = $1.n, _F1 = $1.n + $1.k; _F2 <= _F1; _F2 += 1) { /*14628*/
			$put($1.cws, _F2, (929 - $get($1.cws, _F2)) % 929); /*14628*/
		} /*14628*/
		$1.cws = $geti($1.cws, 0, $1.cws.length - 1); /*14631*/
		$1.clusters = $a([$a([120256, 125680, 128380, 120032, 125560, 128318, 108736, 119920, 108640, 86080, 108592, 86048, 110016, 120560, 125820, 109792, 120440, 125758, 88256, 109680, 88160, 89536, 110320, 120700, 89312, 110200, 120638, 89200, 110140, 89840, 110460, 89720, 110398, 89980, 128506, 119520, 125304, 128190, 107712, 119408, 125244, 107616, 119352, 84032, 107568, 119324, 84000, 107544, 83984, 108256, 119672, 125374, 85184, 108144, 119612, 85088, 108088, 119582, 85040, 108060, 85728, 108408, 119742, 85616, 108348, 85560, 108318, 85880, 108478, 85820, 85790, 107200, 119152, 125116, 107104, 119096, 125086, 83008, 107056, 119068, 82976, 107032, 82960, 82952, 83648, 107376, 119228, 83552, 107320, 119198, 83504, 107292, 83480, 83468, 83824, 107452, 83768, 107422, 83740, 83900, 106848, 118968, 125022, 82496, 106800, 118940, 82464, 106776, 118926, 82448, 106764, 82440, 106758, 82784, 106936, 119006, 82736, 106908, 82712, 106894, 82700, 82694, 106974, 82830, 82240, 106672, 118876, 82208, 106648, 118862, 82192, 106636, 82184, 106630, 82180, 82352, 82328, 82316, 82080, 118830, 106572, 106566, 82050, 117472, 124280, 127678, 103616, 117360, 124220, 103520, 117304, 124190, 75840, 103472, 75808, 104160, 117624, 124350, 76992, 104048, 117564, 76896, 103992, 76848, 76824, 77536, 104312, 117694, 77424, 104252, 77368, 77340, 77688, 104382, 77628, 77758, 121536, 126320, 128700, 121440, 126264, 128670, 111680, 121392, 126236, 111648, 121368, 126222, 111632, 121356, 103104, 117104, 124092, 112320, 103008, 117048, 124062, 112224, 121656, 126366, 93248, 74784, 102936, 117006, 93216, 112152, 93200, 75456, 103280, 117180, 93888, 75360, 103224, 117150, 93792, 112440, 121758, 93744, 75288, 93720, 75632, 103356, 94064, 75576, 103326, 94008, 112542, 93980, 75708, 94140, 75678, 94110, 121184, 126136, 128606, 111168, 121136, 126108, 111136, 121112, 126094, 111120, 121100, 111112, 111108, 102752, 116920, 123998, 111456, 102704, 116892, 91712, 74272, 121244, 116878, 91680, 74256, 102668, 91664, 111372, 102662, 74244, 74592, 102840, 116958, 92000, 74544, 102812, 91952, 111516, 102798, 91928, 74508, 74502, 74680, 102878, 92088, 74652, 92060, 74638, 92046, 92126, 110912, 121008, 126044, 110880, 120984, 126030, 110864, 120972, 110856, 120966, 110852, 110850, 74048, 102576, 116828, 90944, 74016, 102552, 116814, 90912, 111000, 121038, 90896, 73992, 102534, 90888, 110982, 90884, 74160, 102620, 91056, 74136, 102606, 91032, 111054, 91020, 74118, 91014, 91100, 91086, 110752, 120920, 125998, 110736, 120908, 110728, 120902, 110724, 110722, 73888, 102488, 116782, 90528, 73872, 102476, 90512, 110796, 102470, 90504, 73860, 90500, 73858, 73944, 90584, 90572, 90566, 120876, 120870, 110658, 102444, 73800, 90312, 90308, 90306, 101056, 116080, 123580, 100960, 116024, 70720, 100912, 115996, 70688, 100888, 70672, 70664, 71360, 101232, 116156, 71264, 101176, 116126, 71216, 101148, 71192, 71180, 71536, 101308, 71480, 101278, 71452, 71612, 71582, 118112, 124600, 127838, 105024, 118064, 124572, 104992, 118040, 124558, 104976, 118028, 104968, 118022, 100704, 115896, 123486, 105312, 100656, 115868, 79424, 70176, 118172, 115854, 79392, 105240, 100620, 79376, 70152, 79368, 70496, 100792, 115934, 79712, 70448, 118238, 79664, 105372, 100750, 79640, 70412, 79628, 70584, 100830, 79800, 70556, 79772, 70542, 70622, 79838, 122176, 126640, 128860, 122144, 126616, 128846, 122128, 126604, 122120, 126598, 122116, 104768, 117936, 124508, 113472, 104736, 126684, 124494, 113440, 122264, 126670, 113424, 104712, 117894, 113416, 122246, 104706, 69952, 100528, 115804, 78656, 69920, 100504, 115790, 96064, 78624, 104856, 117966, 96032, 113560, 122318, 100486, 96016, 78600, 104838, 96008, 69890, 70064, 100572, 78768, 70040, 100558, 96176, 78744, 104910, 96152, 113614, 70022, 78726, 70108, 78812, 70094, 96220, 78798, 122016, 126552, 128814, 122000, 126540, 121992, 126534, 121988, 121986, 104608, 117848, 124462, 113056, 104592, 126574, 113040, 122060, 117830, 113032, 104580, 113028, 104578, 113026, 69792, 100440, 115758, 78240, 69776, 100428, 95136, 78224, 104652, 100422, 95120, 113100, 69764, 95112, 78212, 69762, 78210, 69848, 100462, 78296, 69836, 95192, 78284, 69830, 95180, 78278, 69870, 95214, 121936, 126508, 121928, 126502, 121924, 121922, 104528, 117804, 112848, 104520, 117798, 112840, 121958, 112836, 104514, 112834, 69712, 100396, 78032, 69704, 100390, 94672, 78024, 104550, 94664, 112870, 69698, 94660, 78018, 94658, 78060, 94700, 94694, 126486, 121890, 117782, 104484, 104482, 69672, 77928, 94440, 69666, 77922, 99680, 68160, 99632, 68128, 99608, 115342, 68112, 99596, 68104, 99590, 68448, 99768, 115422, 68400, 99740, 68376, 99726, 68364, 68358, 68536, 99806, 68508, 68494, 68574, 101696, 116400, 123740, 101664, 116376, 101648, 116364, 101640, 116358, 101636, 67904, 99504, 115292, 72512, 67872, 116444, 115278, 72480, 101784, 116430, 72464, 67848, 99462, 72456, 101766, 67842, 68016, 99548, 72624, 67992, 99534, 72600, 101838, 72588, 67974, 68060, 72668, 68046, 72654, 118432, 124760, 127918, 118416, 124748, 118408, 124742, 118404, 118402, 101536, 116312, 105888, 101520, 116300, 105872, 118476, 116294, 105864, 101508, 105860, 101506, 105858, 67744, 99416, 72096, 67728, 116334, 80800, 72080, 101580, 99398, 80784, 105932, 67716, 80776, 72068, 67714, 72066, 67800, 99438, 72152, 67788, 80856, 72140, 67782, 80844, 72134, 67822, 72174, 80878, 126800, 128940, 126792, 128934, 126788, 126786, 118352, 124716, 122576, 126828, 124710, 122568, 126822, 122564, 118338, 122562, 101456, 116268, 105680, 101448, 116262, 114128, 105672, 118374, 114120, 122598, 101442, 114116, 105666, 114114, 67664, 99372, 71888, 67656, 99366, 80336, 71880, 101478, 97232, 80328, 105702, 67650, 97224, 114150, 71874, 97220, 67692, 71916, 67686, 80364, 71910, 97260, 80358, 97254, 126760, 128918, 126756, 126754, 118312, 124694, 122472, 126774, 122468, 118306, 122466, 101416, 116246, 105576, 101412, 113896, 105572, 101410, 113892, 105570, 113890, 67624, 99350, 71784, 101430, 80104, 71780, 67618, 96744, 80100, 71778, 96740, 80098, 96738, 71798, 96758, 126738, 122420, 122418, 105524, 113780, 113778, 71732, 79988, 96500, 96498, 66880, 66848, 98968, 66832, 66824, 66820, 66992, 66968, 66956, 66950, 67036, 67022, 100000, 99984, 115532, 99976, 115526, 99972, 99970, 66720, 98904, 69024, 100056, 98892, 69008, 100044, 69000, 100038, 68996, 66690, 68994, 66776, 98926, 69080, 100078, 69068, 66758, 69062, 66798, 69102, 116560, 116552, 116548, 116546, 99920, 102096, 116588, 115494, 102088, 116582, 102084, 99906, 102082, 66640, 68816, 66632, 98854, 73168, 68808, 66628, 73160, 68804, 66626, 73156, 68802, 66668, 68844, 66662, 73196, 68838, 73190, 124840, 124836, 124834, 116520, 118632, 124854, 118628, 116514, 118626, 99880, 115478, 101992, 116534, 106216, 101988, 99874, 106212, 101986, 106210, 66600, 98838, 68712, 99894, 72936, 68708, 66594, 81384, 72932, 68706, 81380, 72930, 66614, 68726, 72950, 81398, 128980, 128978, 124820, 126900, 124818, 126898, 116500, 118580, 116498, 122740, 118578, 122738, 99860, 101940, 99858, 106100, 101938, 114420]), $a([128352, 129720, 125504, 128304, 129692, 125472, 128280, 129678, 125456, 128268, 125448, 128262, 125444, 125792, 128440, 129758, 120384, 125744, 128412, 120352, 125720, 128398, 120336, 125708, 120328, 125702, 120324, 120672, 125880, 128478, 110144, 120624, 125852, 110112, 120600, 125838, 110096, 120588, 110088, 120582, 110084, 110432, 120760, 125918, 89664, 110384, 120732, 89632, 110360, 120718, 89616, 110348, 89608, 110342, 89952, 110520, 120798, 89904, 110492, 89880, 110478, 89868, 90040, 110558, 90012, 89998, 125248, 128176, 129628, 125216, 128152, 129614, 125200, 128140, 125192, 128134, 125188, 125186, 119616, 125360, 128220, 119584, 125336, 128206, 119568, 125324, 119560, 125318, 119556, 119554, 108352, 119728, 125404, 108320, 119704, 125390, 108304, 119692, 108296, 119686, 108292, 108290, 85824, 108464, 119772, 85792, 108440, 119758, 85776, 108428, 85768, 108422, 85764, 85936, 108508, 85912, 108494, 85900, 85894, 85980, 85966, 125088, 128088, 129582, 125072, 128076, 125064, 128070, 125060, 125058, 119200, 125144, 128110, 119184, 125132, 119176, 125126, 119172, 119170, 107424, 119256, 125166, 107408, 119244, 107400, 119238, 107396, 107394, 83872, 107480, 119278, 83856, 107468, 83848, 107462, 83844, 83842, 83928, 107502, 83916, 83910, 83950, 125008, 128044, 125000, 128038, 124996, 124994, 118992, 125036, 118984, 125030, 118980, 118978, 106960, 119020, 106952, 119014, 106948, 106946, 82896, 106988, 82888, 106982, 82884, 82882, 82924, 82918, 124968, 128022, 124964, 124962, 118888, 124982, 118884, 118882, 106728, 118902, 106724, 106722, 82408, 106742, 82404, 82402, 124948, 124946, 118836, 118834, 106612, 106610, 124224, 127664, 129372, 124192, 127640, 129358, 124176, 127628, 124168, 127622, 124164, 124162, 117568, 124336, 127708, 117536, 124312, 127694, 117520, 124300, 117512, 124294, 117508, 117506, 104256, 117680, 124380, 104224, 117656, 124366, 104208, 117644, 104200, 117638, 104196, 104194, 77632, 104368, 117724, 77600, 104344, 117710, 77584, 104332, 77576, 104326, 77572, 77744, 104412, 77720, 104398, 77708, 77702, 77788, 77774, 128672, 129880, 93168, 128656, 129868, 92664, 128648, 129862, 92412, 128644, 128642, 124064, 127576, 129326, 126368, 124048, 129902, 126352, 128716, 127558, 126344, 124036, 126340, 124034, 126338, 117152, 124120, 127598, 121760, 117136, 124108, 121744, 126412, 124102, 121736, 117124, 121732, 117122, 121730, 103328, 117208, 124142, 112544, 103312, 117196, 112528, 121804, 117190, 112520, 103300, 112516, 103298, 112514, 75680, 103384, 117230, 94112, 75664, 103372, 94096, 112588, 103366, 94088, 75652, 94084, 75650, 75736, 103406, 94168, 75724, 94156, 75718, 94150, 75758, 128592, 129836, 91640, 128584, 129830, 91388, 128580, 91262, 128578, 123984, 127532, 126160, 123976, 127526, 126152, 128614, 126148, 123970, 126146, 116944, 124012, 121296, 116936, 124006, 121288, 126182, 121284, 116930, 121282, 102864, 116972, 111568, 102856, 116966, 111560, 121318, 111556, 102850, 111554, 74704, 102892, 92112, 74696, 102886, 92104, 111590, 92100, 74690, 92098, 74732, 92140, 74726, 92134, 128552, 129814, 90876, 128548, 90750, 128546, 123944, 127510, 126056, 128566, 126052, 123938, 126050, 116840, 123958, 121064, 116836, 121060, 116834, 121058, 102632, 116854, 111080, 121078, 111076, 102626, 111074, 74216, 102646, 91112, 74212, 91108, 74210, 91106, 74230, 91126, 128532, 90494, 128530, 123924, 126004, 123922, 126002, 116788, 120948, 116786, 120946, 102516, 110836, 102514, 110834, 73972, 90612, 73970, 90610, 128522, 123914, 125978, 116762, 120890, 102458, 110714, 123552, 127320, 129198, 123536, 127308, 123528, 127302, 123524, 123522, 116128, 123608, 127342, 116112, 123596, 116104, 123590, 116100, 116098, 101280, 116184, 123630, 101264, 116172, 101256, 116166, 101252, 101250, 71584, 101336, 116206, 71568, 101324, 71560, 101318, 71556, 71554, 71640, 101358, 71628, 71622, 71662, 127824, 129452, 79352, 127816, 129446, 79100, 127812, 78974, 127810, 123472, 127276, 124624, 123464, 127270, 124616, 127846, 124612, 123458, 124610, 115920, 123500, 118224, 115912, 123494, 118216, 124646, 118212, 115906, 118210, 100816, 115948, 105424, 100808, 115942, 105416, 118246, 105412, 100802, 105410, 70608, 100844, 79824, 70600, 100838, 79816, 105446, 79812, 70594, 79810, 70636, 79852, 70630, 79846, 129960, 95728, 113404, 129956, 95480, 113278, 129954, 95356, 95294, 127784, 129430, 78588, 128872, 129974, 95996, 78462, 128868, 127778, 95870, 128866, 123432, 127254, 124520, 123428, 126696, 128886, 123426, 126692, 124514, 126690, 115816, 123446, 117992, 115812, 122344, 117988, 115810, 122340, 117986, 122338, 100584, 115830, 104936, 100580, 113640, 104932, 100578, 113636, 104930, 113634, 70120, 100598, 78824, 70116, 96232, 78820, 70114, 96228, 78818, 96226, 70134, 78838, 129940, 94968, 113022, 129938, 94844, 94782, 127764, 78206, 128820, 127762, 95102, 128818, 123412, 124468, 123410, 126580, 124466, 126578, 115764, 117876, 115762, 122100, 117874, 122098, 100468, 104692, 100466, 113140, 104690, 113138, 69876, 78324, 69874, 95220, 78322, 95218, 129930, 94588, 94526, 127754, 128794, 123402, 124442, 126522, 115738, 117818, 121978, 100410, 104570, 112890, 69754, 78074, 94714, 94398, 123216, 127148, 123208, 127142, 123204, 123202, 115408, 123244, 115400, 123238, 115396, 115394, 99792, 115436, 99784, 115430, 99780, 99778, 68560, 99820, 68552, 99814, 68548, 68546, 68588, 68582, 127400, 129238, 72444, 127396, 72318, 127394, 123176, 127126, 123752, 123172, 123748, 123170, 123746, 115304, 123190, 116456, 115300, 116452, 115298, 116450, 99560, 115318, 101864, 99556, 101860, 99554, 101858, 68072, 99574, 72680, 68068, 72676, 68066, 72674, 68086, 72694, 129492, 80632, 105854, 129490, 80508, 80446, 127380, 72062, 127924, 127378, 80766, 127922, 123156, 123700, 123154, 124788, 123698, 124786, 115252, 116340, 115250, 118516, 116338, 118514, 99444, 101620, 99442, 105972, 101618, 105970, 67828, 72180, 67826, 80884, 72178, 80882, 97008, 114044, 96888, 113982, 96828, 96798, 129482, 80252, 130010, 97148, 80190, 97086, 127370, 127898, 128954, 123146, 123674, 124730, 126842, 115226, 116282, 118394, 122618, 99386, 101498, 105722, 114170, 67706, 71930, 80378, 96632, 113854, 96572, 96542, 80062, 96702, 96444, 96414, 96350, 123048, 123044, 123042, 115048, 123062, 115044, 115042, 99048, 115062, 99044, 99042, 67048, 99062, 67044, 67042, 67062, 127188, 68990, 127186, 123028, 123316, 123026, 123314, 114996, 115572, 114994, 115570, 98932, 100084, 98930, 100082, 66804, 69108, 66802, 69106, 129258, 73084, 73022, 127178, 127450, 123018, 123290, 123834, 114970, 115514, 116602, 98874, 99962, 102138, 66682, 68858, 73210, 81272, 106174, 81212, 81182, 72894, 81342, 97648, 114364, 97592, 114334, 97564, 97550, 81084, 97724, 81054, 97694, 97464, 114270, 97436, 97422, 80990, 97502, 97372, 97358, 97326, 114868, 114866, 98676, 98674, 66292, 66290, 123098, 114842, 115130, 98618, 99194, 66170, 67322, 69310, 73404, 73374, 81592, 106334, 81564, 81550, 73310, 81630, 97968, 114524, 97944, 114510, 97932, 97926, 81500, 98012, 81486, 97998, 97880, 114478, 97868, 97862, 81454, 97902, 97836, 97830, 69470, 73564, 73550, 81752, 106414, 81740, 81734, 73518, 81774, 81708, 81702]), $a([109536, 120312, 86976, 109040, 120060, 86496, 108792, 119934, 86256, 108668, 86136, 129744, 89056, 110072, 129736, 88560, 109820, 129732, 88312, 109694, 129730, 88188, 128464, 129772, 89592, 128456, 129766, 89340, 128452, 89214, 128450, 125904, 128492, 125896, 128486, 125892, 125890, 120784, 125932, 120776, 125926, 120772, 120770, 110544, 120812, 110536, 120806, 110532, 84928, 108016, 119548, 84448, 107768, 119422, 84208, 107644, 84088, 107582, 84028, 129640, 85488, 108284, 129636, 85240, 108158, 129634, 85116, 85054, 128232, 129654, 85756, 128228, 85630, 128226, 125416, 128246, 125412, 125410, 119784, 125430, 119780, 119778, 108520, 119798, 108516, 108514, 83424, 107256, 119166, 83184, 107132, 83064, 107070, 83004, 82974, 129588, 83704, 107390, 129586, 83580, 83518, 128116, 83838, 128114, 125172, 125170, 119284, 119282, 107508, 107506, 82672, 106876, 82552, 106814, 82492, 82462, 129562, 82812, 82750, 128058, 125050, 119034, 82296, 106686, 82236, 82206, 82366, 82108, 82078, 76736, 103920, 117500, 76256, 103672, 117374, 76016, 103548, 75896, 103486, 75836, 129384, 77296, 104188, 129380, 77048, 104062, 129378, 76924, 76862, 127720, 129398, 77564, 127716, 77438, 127714, 124392, 127734, 124388, 124386, 117736, 124406, 117732, 117730, 104424, 117750, 104420, 104418, 112096, 121592, 126334, 92608, 111856, 121468, 92384, 111736, 121406, 92272, 111676, 92216, 111646, 92188, 75232, 103160, 117118, 93664, 74992, 103036, 93424, 112252, 102974, 93304, 74812, 93244, 74782, 93214, 129332, 75512, 103294, 129908, 129330, 93944, 75388, 129906, 93820, 75326, 93758, 127604, 75646, 128756, 127602, 94078, 128754, 124148, 126452, 124146, 126450, 117236, 121844, 117234, 121842, 103412, 103410, 91584, 111344, 121212, 91360, 111224, 121150, 91248, 111164, 91192, 111134, 91164, 91150, 74480, 102780, 91888, 74360, 102718, 91768, 111422, 91708, 74270, 91678, 129306, 74620, 129850, 92028, 74558, 91966, 127546, 128634, 124026, 126202, 116986, 121338, 102906, 90848, 110968, 121022, 90736, 110908, 90680, 110878, 90652, 90638, 74104, 102590, 91000, 74044, 90940, 74014, 90910, 74174, 91070, 90480, 110780, 90424, 110750, 90396, 90382, 73916, 90556, 73886, 90526, 90296, 110686, 90268, 90254, 73822, 90334, 90204, 90190, 71136, 101112, 116094, 70896, 100988, 70776, 100926, 70716, 70686, 129204, 71416, 101246, 129202, 71292, 71230, 127348, 71550, 127346, 123636, 123634, 116212, 116210, 101364, 101362, 79296, 105200, 118140, 79072, 105080, 118078, 78960, 105020, 78904, 104990, 78876, 78862, 70384, 100732, 79600, 70264, 100670, 79480, 105278, 79420, 70174, 79390, 129178, 70524, 129466, 79740, 70462, 79678, 127290, 127866, 123514, 124666, 115962, 118266, 100858, 113376, 122232, 126654, 95424, 113264, 122172, 95328, 113208, 122142, 95280, 113180, 95256, 113166, 95244, 78560, 104824, 117950, 95968, 78448, 104764, 95856, 113468, 104734, 95800, 78364, 95772, 78350, 95758, 70008, 100542, 78712, 69948, 96120, 78652, 69918, 96060, 78622, 96030, 70078, 78782, 96190, 94912, 113008, 122044, 94816, 112952, 122014, 94768, 112924, 94744, 112910, 94732, 94726, 78192, 104636, 95088, 78136, 104606, 95032, 113054, 95004, 78094, 94990, 69820, 78268, 69790, 95164, 78238, 95134, 94560, 112824, 121950, 94512, 112796, 94488, 112782, 94476, 94470, 78008, 104542, 94648, 77980, 94620, 77966, 94606, 69726, 78046, 94686, 94384, 112732, 94360, 112718, 94348, 94342, 77916, 94428, 77902, 94414, 94296, 112686, 94284, 94278, 77870, 94318, 94252, 94246, 68336, 99708, 68216, 99646, 68156, 68126, 68476, 68414, 127162, 123258, 115450, 99834, 72416, 101752, 116414, 72304, 101692, 72248, 101662, 72220, 72206, 67960, 99518, 72568, 67900, 72508, 67870, 72478, 68030, 72638, 80576, 105840, 118460, 80480, 105784, 118430, 80432, 105756, 80408, 105742, 80396, 80390, 72048, 101564, 80752, 71992, 101534, 80696, 71964, 80668, 71950, 80654, 67772, 72124, 67742, 80828, 72094, 80798, 114016, 122552, 126814, 96832, 113968, 122524, 96800, 113944, 122510, 96784, 113932, 96776, 113926, 96772, 80224, 105656, 118366, 97120, 80176, 105628, 97072, 114076, 105614, 97048, 80140, 97036, 80134, 97030, 71864, 101470, 80312, 71836, 97208, 80284, 71822, 97180, 80270, 97166, 67678, 71902, 80350, 97246, 96576, 113840, 122460, 96544, 113816, 122446, 96528, 113804, 96520, 113798, 96516, 96514, 80048, 105564, 96688, 80024, 105550, 96664, 113870, 96652, 80006, 96646, 71772, 80092, 71758, 96732, 80078, 96718, 96416, 113752, 122414, 96400, 113740, 96392, 113734, 96388, 96386, 79960, 105518, 96472, 79948, 96460, 79942, 96454, 71726, 79982, 96494, 96336, 113708, 96328, 113702, 96324, 96322, 79916, 96364, 79910, 96358, 96296, 113686, 96292, 96290, 79894, 96310, 66936, 99006, 66876, 66846, 67006, 68976, 100028, 68920, 99998, 68892, 68878, 66748, 69052, 66718, 69022, 73056, 102072, 116574, 73008, 102044, 72984, 102030, 72972, 72966, 68792, 99934, 73144, 68764, 73116, 68750, 73102, 66654, 68830, 73182, 81216, 106160, 118620, 81184, 106136, 118606, 81168, 106124, 81160, 106118, 81156, 81154, 72880, 101980, 81328, 72856, 101966, 81304, 106190, 81292, 72838, 81286, 68700, 72924, 68686, 81372, 72910, 81358, 114336, 122712, 126894, 114320, 122700, 114312, 122694, 114308, 114306, 81056, 106072, 118574, 97696, 81040, 106060, 97680, 114380, 106054, 97672, 81028, 97668, 81026, 97666, 72792, 101934, 81112, 72780, 97752, 81100, 72774, 97740, 81094, 97734, 68654, 72814, 81134, 97774, 114256, 122668, 114248, 122662, 114244, 114242, 80976, 106028, 97488, 80968, 106022, 97480, 114278, 97476, 80962, 97474, 72748, 81004, 72742, 97516, 80998, 97510, 114216, 122646, 114212, 114210, 80936, 106006, 97384, 80932, 97380, 80930, 97378, 72726, 80950, 97398, 114196, 114194, 80916, 97332, 80914, 97330, 66236, 66206, 67256, 99166, 67228, 67214, 66142, 67294, 69296, 100188, 69272, 100174, 69260, 69254, 67164, 69340, 67150, 69326, 73376, 102232, 116654, 73360, 102220, 73352, 102214, 73348, 73346, 69208, 100142, 73432, 102254, 73420, 69190, 73414, 67118, 69230, 73454, 106320, 118700, 106312, 118694, 106308, 106306, 73296, 102188, 81616, 106348, 102182, 81608, 73284, 81604, 73282, 81602, 69164, 73324, 69158, 81644, 73318, 81638, 122792, 126934, 122788, 122786, 106280, 118678, 114536, 106276, 114532, 106274, 114530, 73256, 102166, 81512, 73252, 98024, 81508, 73250, 98020, 81506, 98018, 69142, 73270, 81526, 98038, 122772, 122770, 106260, 114484, 106258, 114482, 73236, 81460, 73234, 97908, 81458, 97906, 122762, 106250, 114458, 73226, 81434, 97850, 66396, 66382, 67416, 99246, 67404, 67398, 66350, 67438, 69456, 100268, 69448, 100262, 69444, 69442, 67372, 69484, 67366, 69478, 102312, 116694, 102308, 102306, 69416, 100246, 73576, 102326, 73572, 69410, 73570, 67350, 69430, 73590, 118740, 118738, 102292, 106420, 102290, 106418, 69396, 73524, 69394, 81780, 73522, 81778, 118730, 102282, 106394, 69386, 73498, 81722, 66476, 66470, 67496, 99286, 67492, 67490, 66454, 67510, 100308, 100306, 67476, 69556, 67474, 69554, 116714])]); /*14873*/
		$1.raps = $a([$a([802, 930, 946, 818, 882, 890, 826, 954, 922, 986, 970, 906, 778, 794, 786, 914, 978, 982, 980, 916, 948, 932, 934, 942, 940, 936, 808, 812, 814, 806, 822, 950, 918, 790, 788, 820, 884, 868, 870, 878, 876, 872, 840, 856, 860, 862, 846, 844, 836, 838, 834, 866]), $a([718, 590, 622, 558, 550, 566, 534, 530, 538, 570, 562, 546, 610, 626, 634, 762, 754, 758, 630, 628, 612, 614, 582, 578, 706, 738, 742, 740, 748, 620, 556, 552, 616, 744, 712, 716, 708, 710, 646, 654, 652, 668, 664, 696, 688, 656, 720, 592, 600, 604, 732, 734])]); /*14888*/
		$1.cwtobits = function() {
			var _FI = $get($1.clusters, $k[--$j]); /*14892*/
			$1.v = $get(_FI, $k[--$j]); /*14892*/
			$k[$j++] = Infinity; /*14893*/
			for (var _FL = 0, _FM = 17; _FL < _FM; _FL++) { /*14893*/
				$k[$j++] = 0; /*14893*/
			} /*14893*/
			var _FP = $cvrs($s(17), $1.v, 2); /*14893*/
			for (var _FQ = 0, _FR = _FP.length; _FQ < _FR; _FQ++) { /*14893*/
				$k[$j++] = $get(_FP, _FQ) - 48; /*14893*/
			} /*14893*/
			var _FT = $a(); /*14893*/
			$k[$j++] = $geti(_FT, _FT.length - 17, 17); /*14894*/
		}; /*14895*/
		$1.raptobits = function() {
			var _FX = $get($1.raps, $k[--$j]); /*14899*/
			$1.v = $get(_FX, $k[--$j]); /*14899*/
			$k[$j++] = Infinity; /*14900*/
			for (var _Fa = 0, _Fb = 10; _Fa < _Fb; _Fa++) { /*14900*/
				$k[$j++] = 0; /*14900*/
			} /*14900*/
			var _Fe = $cvrs($s(10), $1.v, 2); /*14900*/
			for (var _Ff = 0, _Fg = _Fe.length; _Ff < _Fg; _Ff++) { /*14900*/
				$k[$j++] = $get(_Fe, _Ff) - 48; /*14900*/
			} /*14900*/
			var _Fi = $a(); /*14900*/
			$k[$j++] = $geti(_Fi, _Fi.length - 10, 10); /*14901*/
		}; /*14902*/
		$1.rwid = $get($a([38, 55, 82, 99]), $1.c - 1); /*14905*/
		if (($1.c == 3) && $1.cca) { /*14906*/
			$1.rwid = 72; /*14906*/
		} /*14906*/
		$1.pixs = $a($1.rwid * $1.r); /*14907*/
		for (var _Fu = 0, _Ft = $1.r - 1; _Fu <= _Ft; _Fu += 1) { /*14945*/
			$1.i = _Fu; /*14910*/
			$1.clst = (($1.i + $1.rapl) - 1) % 3; /*14911*/
			$k[$j++] = $1.pixs; /*14943*/
			$k[$j++] = $1.rwid * $1.i; /*14943*/
			$k[$j++] = Infinity; /*14943*/
			if ($1.c == 1) { /*14917*/
				$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*14914*/
				$k[$j++] = 0; /*14914*/
				$1.raptobits(); /*14914*/
				$aload($k[--$j]); /*14914*/
				$k[$j++] = $get($1.cws, $1.i); /*14915*/
				$k[$j++] = $1.clst; /*14915*/
				$1.cwtobits(); /*14915*/
				$aload($k[--$j]); /*14915*/
				$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*14916*/
				$k[$j++] = 0; /*14916*/
				$1.raptobits(); /*14916*/
				$aload($k[--$j]); /*14916*/
			} /*14916*/
			if ($1.c == 2) { /*14923*/
				$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*14919*/
				$k[$j++] = 0; /*14919*/
				$1.raptobits(); /*14919*/
				$aload($k[--$j]); /*14919*/
				$k[$j++] = $get($1.cws, $1.i * 2); /*14920*/
				$k[$j++] = $1.clst; /*14920*/
				$1.cwtobits(); /*14920*/
				$aload($k[--$j]); /*14920*/
				$k[$j++] = $get($1.cws, ($1.i * 2) + 1); /*14921*/
				$k[$j++] = $1.clst; /*14921*/
				$1.cwtobits(); /*14921*/
				$aload($k[--$j]); /*14921*/
				$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*14922*/
				$k[$j++] = 0; /*14922*/
				$1.raptobits(); /*14922*/
				$aload($k[--$j]); /*14922*/
			} /*14922*/
			if ($1.c == 3) { /*14933*/
				if (!$1.cca) { /*14927*/
					$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*14926*/
					$k[$j++] = 0; /*14926*/
					$1.raptobits(); /*14926*/
					$aload($k[--$j]); /*14926*/
				} /*14926*/
				$k[$j++] = $get($1.cws, $1.i * 3); /*14928*/
				$k[$j++] = $1.clst; /*14928*/
				$1.cwtobits(); /*14928*/
				$aload($k[--$j]); /*14928*/
				$k[$j++] = (($1.i + $1.rapc) - 1) % 52; /*14929*/
				$k[$j++] = 1; /*14929*/
				$1.raptobits(); /*14929*/
				$aload($k[--$j]); /*14929*/
				$k[$j++] = $get($1.cws, ($1.i * 3) + 1); /*14930*/
				$k[$j++] = $1.clst; /*14930*/
				$1.cwtobits(); /*14930*/
				$aload($k[--$j]); /*14930*/
				$k[$j++] = $get($1.cws, ($1.i * 3) + 2); /*14931*/
				$k[$j++] = $1.clst; /*14931*/
				$1.cwtobits(); /*14931*/
				$aload($k[--$j]); /*14931*/
				$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*14932*/
				$k[$j++] = 0; /*14932*/
				$1.raptobits(); /*14932*/
				$aload($k[--$j]); /*14932*/
			} /*14932*/
			if ($1.c == 4) { /*14942*/
				$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*14935*/
				$k[$j++] = 0; /*14935*/
				$1.raptobits(); /*14935*/
				$aload($k[--$j]); /*14935*/
				$k[$j++] = $get($1.cws, $1.i * 4); /*14936*/
				$k[$j++] = $1.clst; /*14936*/
				$1.cwtobits(); /*14936*/
				$aload($k[--$j]); /*14936*/
				$k[$j++] = $get($1.cws, ($1.i * 4) + 1); /*14937*/
				$k[$j++] = $1.clst; /*14937*/
				$1.cwtobits(); /*14937*/
				$aload($k[--$j]); /*14937*/
				$k[$j++] = (($1.i + $1.rapc) - 1) % 52; /*14938*/
				$k[$j++] = 1; /*14938*/
				$1.raptobits(); /*14938*/
				$aload($k[--$j]); /*14938*/
				$k[$j++] = $get($1.cws, ($1.i * 4) + 2); /*14939*/
				$k[$j++] = $1.clst; /*14939*/
				$1.cwtobits(); /*14939*/
				$aload($k[--$j]); /*14939*/
				$k[$j++] = $get($1.cws, ($1.i * 4) + 3); /*14940*/
				$k[$j++] = $1.clst; /*14940*/
				$1.cwtobits(); /*14940*/
				$aload($k[--$j]); /*14940*/
				$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*14941*/
				$k[$j++] = 0; /*14941*/
				$1.raptobits(); /*14941*/
				$aload($k[--$j]); /*14941*/
			} /*14941*/
			$k[$j++] = 1; /*14943*/
			var _HN = $a(); /*14943*/
			var _HO = $k[--$j]; /*14944*/
			$puti($k[--$j], _HO, _HN); /*14944*/
		} /*14944*/
		var _HX = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.rwid,
			pixy: $1.r,
			height: ($1.r / 72) * $1.rowmult,
			width: $1.rwid / 72,
			opt: $1.options
		}; /*14955*/
		$k[$j++] = _HX; /*14958*/
		if (!$1.dontdraw) { /*14958*/
			$0.renmatrix(); /*14958*/
		} /*14958*/
	};
	$0.datamatrix = function() {
		var $1 = {}; /*14985*/
		$1.options = $k[--$j]; /*14987*/
		$1.barcode = $k[--$j]; /*14988*/
		$1.dontdraw = false; /*14990*/
		$1.columns = 0; /*14991*/
		$1.rows = 0; /*14992*/
		$1.format = "square"; /*14993*/
		$1.version = "unset"; /*14994*/
		$1.parse = false; /*14995*/
		$1.parsefnc = false; /*14996*/
		$1.dmre = false; /*14997*/
		$forall($1.options, function() { /*15008*/
			var _3 = $k[--$j]; /*15008*/
			$1[$k[--$j]] = _3; /*15008*/
		}); /*15008*/
		if ($ne($1.version, "unset")) { /*15014*/
			$search($1.version, "x"); /*15011*/
			$j--; /*15012*/
			$1.rows = $k[--$j]; /*15012*/
			$j--; /*15013*/
			$1.columns = $k[--$j]; /*15013*/
		} /*15013*/
		$1.columns = ~~$z($1.columns); /*15016*/
		$1.rows = ~~$z($1.rows); /*15017*/
		$1.mac05comp = false; /*15041*/
		$1.mac06comp = false; /*15042*/
		if ($1.barcode.length >= 9) { /*15051*/
			var _D = $geti($1.barcode, 0, 7); /*15044*/
			if ((($eq(_D, "[)>03605035")) || ($eq(_D, "[)>03606035"))) && $eq($geti($1.barcode, $1.barcode.length - 2, 2), "036004")) { /*15050*/
				if ($get($1.barcode, 5) == 53) { /*15048*/
					$k[$j++] = "mac05comp"; /*15048*/
				} else { /*15048*/
					$k[$j++] = "mac06comp"; /*15048*/
				} /*15048*/
				$1[$k[--$j]] = true; /*15048*/
				$1.barcode = $geti($1.barcode, 7, $1.barcode.length - 9); /*15049*/
			} /*15049*/
		} /*15049*/
		$1.barlen = $1.barcode.length; /*15053*/
		$1.fnc1 = -1; /*15056*/
		$1.prog = -2; /*15056*/
		$1.m05 = -3; /*15056*/
		$1.m06 = -4; /*15056*/
		var _S = {
			FNC1: $1.fnc1,
			PROG: $1.prog,
			MAC5: $1.m05,
			MAC6: $1.m06
		}; /*15061*/
		$1.fncvals = _S; /*15062*/
		$1.msg = $a($1.barlen); /*15063*/
		$1.i = 0; /*15064*/
		$1.j = 0; /*15064*/
		for (;;) { /*15078*/
			if ($1.i == $1.barlen) { /*15065*/
				break; /*15065*/
			} /*15065*/
			$1.char = $get($1.barcode, $1.i); /*15066*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*15074*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*15072*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*15069*/
					$1.i = $1.i + 4; /*15070*/
				} else { /*15072*/
					$1.i = $1.i + 1; /*15072*/
				} /*15072*/
			} /*15072*/
			$put($1.msg, $1.j, $1.char); /*15075*/
			$1.i = $1.i + 1; /*15076*/
			$1.j = $1.j + 1; /*15077*/
		} /*15077*/
		$1.msg = $geti($1.msg, 0, $1.j); /*15079*/
		if ($1.mac05comp) { /*15082*/
			$k[$j++] = Infinity; /*15082*/
			$k[$j++] = $1.m05; /*15082*/
			$aload($1.msg); /*15082*/
			$1.msg = $a(); /*15082*/
		} /*15082*/
		if ($1.mac06comp) { /*15083*/
			$k[$j++] = Infinity; /*15083*/
			$k[$j++] = $1.m06; /*15083*/
			$aload($1.msg); /*15083*/
			$1.msg = $a(); /*15083*/
		} /*15083*/
		$1.msglen = $1.msg.length; /*15085*/
		$k[$j++] = Infinity; /*15134*/
		$k[$j++] = $a([10, 10, 1, 1, 5, 1]); /*15118*/
		$k[$j++] = $a([12, 12, 1, 1, 7, 1]); /*15118*/
		$k[$j++] = $a([14, 14, 1, 1, 10, 1]); /*15118*/
		$k[$j++] = $a([16, 16, 1, 1, 12, 1]); /*15118*/
		$k[$j++] = $a([18, 18, 1, 1, 14, 1]); /*15118*/
		$k[$j++] = $a([20, 20, 1, 1, 18, 1]); /*15118*/
		$k[$j++] = $a([22, 22, 1, 1, 20, 1]); /*15118*/
		$k[$j++] = $a([24, 24, 1, 1, 24, 1]); /*15118*/
		$k[$j++] = $a([26, 26, 1, 1, 28, 1]); /*15118*/
		$k[$j++] = $a([32, 32, 2, 2, 36, 1]); /*15118*/
		$k[$j++] = $a([36, 36, 2, 2, 42, 1]); /*15118*/
		$k[$j++] = $a([40, 40, 2, 2, 48, 1]); /*15118*/
		$k[$j++] = $a([44, 44, 2, 2, 56, 1]); /*15118*/
		$k[$j++] = $a([48, 48, 2, 2, 68, 1]); /*15118*/
		$k[$j++] = $a([52, 52, 2, 2, 84, 2]); /*15118*/
		$k[$j++] = $a([64, 64, 4, 4, 112, 2]); /*15118*/
		$k[$j++] = $a([72, 72, 4, 4, 144, 4]); /*15118*/
		$k[$j++] = $a([80, 80, 4, 4, 192, 4]); /*15118*/
		$k[$j++] = $a([88, 88, 4, 4, 224, 4]); /*15118*/
		$k[$j++] = $a([96, 96, 4, 4, 272, 4]); /*15118*/
		$k[$j++] = $a([104, 104, 4, 4, 336, 6]); /*15118*/
		$k[$j++] = $a([120, 120, 6, 6, 408, 6]); /*15118*/
		$k[$j++] = $a([132, 132, 6, 6, 496, 8]); /*15118*/
		$k[$j++] = $a([144, 144, 6, 6, 620, 10]); /*15118*/
		$k[$j++] = $a([8, 18, 1, 1, 7, 1]); /*15118*/
		$k[$j++] = $a([8, 32, 1, 2, 11, 1]); /*15118*/
		if ($1.dmre) { /*15118*/
			$k[$j++] = $a([8, 48, 1, 2, 15, 1]); /*15118*/
		} /*15118*/
		if ($1.dmre) { /*15119*/
			$k[$j++] = $a([8, 64, 1, 4, 18, 1]); /*15119*/
		} /*15119*/
		$k[$j++] = $a([12, 26, 1, 1, 14, 1]); /*15122*/
		$k[$j++] = $a([12, 36, 1, 2, 18, 1]); /*15122*/
		if ($1.dmre) { /*15122*/
			$k[$j++] = $a([12, 64, 1, 4, 27, 1]); /*15122*/
		} /*15122*/
		$k[$j++] = $a([16, 36, 1, 2, 24, 1]); /*15125*/
		$k[$j++] = $a([16, 48, 1, 2, 28, 1]); /*15125*/
		if ($1.dmre) { /*15125*/
			$k[$j++] = $a([16, 64, 1, 4, 36, 1]); /*15125*/
		} /*15125*/
		if ($1.dmre) { /*15126*/
			$k[$j++] = $a([24, 32, 1, 2, 28, 1]); /*15126*/
		} /*15126*/
		if ($1.dmre) { /*15127*/
			$k[$j++] = $a([24, 36, 1, 2, 33, 1]); /*15127*/
		} /*15127*/
		if ($1.dmre) { /*15128*/
			$k[$j++] = $a([24, 48, 1, 2, 41, 1]); /*15128*/
		} /*15128*/
		if ($1.dmre) { /*15129*/
			$k[$j++] = $a([24, 64, 1, 4, 46, 1]); /*15129*/
		} /*15129*/
		if ($1.dmre) { /*15130*/
			$k[$j++] = $a([26, 32, 1, 2, 32, 1]); /*15130*/
		} /*15130*/
		if ($1.dmre) { /*15131*/
			$k[$j++] = $a([26, 40, 1, 2, 38, 1]); /*15131*/
		} /*15131*/
		if ($1.dmre) { /*15132*/
			$k[$j++] = $a([26, 48, 1, 2, 42, 1]); /*15132*/
		} /*15132*/
		if ($1.dmre) { /*15133*/
			$k[$j++] = $a([26, 64, 1, 4, 50, 1]); /*15133*/
		} /*15133*/
		$1.metrics = $a(); /*15134*/
		$1.urows = $1.rows; /*15137*/
		$1.ucols = $1.columns; /*15138*/
		$1.fullcws = $a([]); /*15139*/
		var _21 = $1.metrics; /*15140*/
		for (var _22 = 0, _23 = _21.length; _22 < _23; _22++) { /*15157*/
			$1.m = $get(_21, _22); /*15141*/
			$1.rows = $get($1.m, 0); /*15142*/
			$1.cols = $get($1.m, 1); /*15143*/
			$1.regh = $get($1.m, 2); /*15144*/
			$1.regv = $get($1.m, 3); /*15145*/
			$1.rscw = $get($1.m, 4); /*15146*/
			$1.rsbl = $get($1.m, 5); /*15147*/
			$1.mrows = $1.rows - (2 * $1.regh); /*15148*/
			$1.mcols = $1.cols - (2 * $1.regv); /*15149*/
			$1.ncws = (~~(($1.mrows * $1.mcols) / 8)) - $1.rscw; /*15150*/
			$1.okay = true; /*15151*/
			if (($1.urows != 0) && ($1.urows != $1.rows)) { /*15152*/
				$1.okay = false; /*15152*/
			} /*15152*/
			if (($1.ucols != 0) && ($1.ucols != $1.cols)) { /*15153*/
				$1.okay = false; /*15153*/
			} /*15153*/
			if ($eq($1.format, "square") && $ne($1.rows, $1.cols)) { /*15154*/
				$1.okay = false; /*15154*/
			} /*15154*/
			if ($eq($1.format, "rectangle") && $eq($1.rows, $1.cols)) { /*15155*/
				$1.okay = false; /*15155*/
			} /*15155*/
			if ($1.okay) { /*15156*/
				$k[$j++] = Infinity; /*15156*/
				$aload($1.fullcws); /*15156*/
				$k[$j++] = $1.ncws; /*15156*/
				$1.fullcws = $a(); /*15156*/
			} /*15156*/
		} /*15156*/
		$k[$j++] = Infinity; /*15158*/
		for (var _2e = 0, _2f = 1558; _2e < _2f; _2e++) { /*15158*/
			$k[$j++] = 10000; /*15158*/
		} /*15158*/
		$1.numremcws = $a(); /*15158*/
		var _2h = $1.fullcws; /*15159*/
		for (var _2i = 0, _2j = _2h.length; _2i < _2j; _2i++) { /*15159*/
			$put($1.numremcws, $get(_2h, _2i) - 1, 1); /*15159*/
		} /*15159*/
		for (var _2m = 1556; _2m >= 0; _2m -= 1) { /*15165*/
			$1.i = _2m; /*15161*/
			if ($get($1.numremcws, $1.i) != 1) { /*15164*/
				$put($1.numremcws, $1.i, $get($1.numremcws, $1.i + 1) + 1); /*15163*/
			} /*15163*/
		} /*15163*/
		$1.lC = -5; /*15168*/
		$1.lB = -6; /*15168*/
		$1.lX = -7; /*15168*/
		$1.lT = -8; /*15168*/
		$1.lE = -9; /*15168*/
		$1.unl = -10; /*15168*/
		$1.sapp = -11; /*15169*/
		$1.usft = -12; /*15169*/
		$1.sft1 = -13; /*15169*/
		$1.sft2 = -14; /*15169*/
		$1.sft3 = -15; /*15169*/
		$1.eci = -16; /*15169*/
		$1.pad = -17; /*15169*/
		$1.unlcw = 254; /*15170*/
		$k[$j++] = "Avals"; /*15179*/
		$k[$j++] = Infinity; /*15179*/
		for (var _2v = 0; _2v <= 128; _2v += 1) { /*15173*/
			$k[$j++] = _2v; /*15173*/
			$k[$j++] = _2v + 1; /*15173*/
		} /*15173*/
		$k[$j++] = $1.pad; /*15178*/
		$k[$j++] = 129; /*15178*/
		for (var _2x = 0; _2x <= 99; _2x += 1) { /*15178*/
			var _2z = $cvrs($s(2), _2x, 10); /*15176*/
			var _31 = $strcpy($s(2), "00"); /*15176*/
			$puti(_31, 2 - _2z.length, _2z); /*15176*/
			$k[$j++] = _31; /*15177*/
			$k[$j++] = _2x + 130; /*15177*/
		} /*15177*/
		var _3E = $a([$1.lC, $1.lB, $1.fnc1, $1.sapp, $1.prog, $1.usft, $1.m05, $1.m06, $1.lX, $1.lT, $1.lE, $1.eci]); /*15179*/
		$k[$j++] = 229; /*15179*/
		for (var _3F = 0, _3G = _3E.length; _3F < _3G; _3F++) { /*15179*/
			var _3J = $k[--$j] + 1; /*15179*/
			$k[$j++] = $get(_3E, _3F); /*15179*/
			$k[$j++] = _3J; /*15179*/
			$k[$j++] = _3J; /*15179*/
		} /*15179*/
		$j--; /*15179*/
		var _3K = $d(); /*15179*/
		$1[$k[--$j]] = _3K; /*15180*/
		$k[$j++] = "Avals"; /*15182*/
		$k[$j++] = Infinity; /*15182*/
		$forall($1.Avals, function() { /*15182*/
			$k[$j++] = Infinity; /*15182*/
			var _3N = $k[--$j]; /*15182*/
			var _3O = $k[--$j]; /*15182*/
			$k[$j++] = _3N; /*15182*/
			$k[$j++] = _3O; /*15182*/
			var _3P = $a(); /*15182*/
			$k[$j++] = _3P; /*15182*/
		}); /*15182*/
		var _3Q = $d(); /*15182*/
		$1[$k[--$j]] = _3Q; /*15183*/
		$k[$j++] = "CNvals"; /*15191*/
		$k[$j++] = Infinity; /*15191*/
		$k[$j++] = $1.sft1; /*15190*/
		$k[$j++] = 0; /*15190*/
		$k[$j++] = $1.sft2; /*15190*/
		$k[$j++] = 1; /*15190*/
		$k[$j++] = $1.sft3; /*15190*/
		$k[$j++] = 2; /*15190*/
		$k[$j++] = 32; /*15190*/
		$k[$j++] = 3; /*15190*/
		for (var _3V = 48; _3V <= 57; _3V += 1) { /*15190*/
			$k[$j++] = _3V; /*15190*/
			$k[$j++] = _3V - 44; /*15190*/
		} /*15190*/
		for (var _3W = 65; _3W <= 90; _3W += 1) { /*15191*/
			$k[$j++] = _3W; /*15191*/
			$k[$j++] = _3W - 51; /*15191*/
		} /*15191*/
		var _3X = $d(); /*15191*/
		$1[$k[--$j]] = _3X; /*15192*/
		$k[$j++] = "C1vals"; /*15193*/
		$k[$j++] = Infinity; /*15193*/
		for (var _3Z = 0; _3Z <= 31; _3Z += 1) { /*15193*/
			$k[$j++] = _3Z; /*15193*/
			$k[$j++] = _3Z; /*15193*/
		} /*15193*/
		var _3a = $d(); /*15193*/
		$1[$k[--$j]] = _3a; /*15193*/
		$k[$j++] = "C2vals"; /*15199*/
		$k[$j++] = Infinity; /*15199*/
		for (var _3c = 33; _3c <= 47; _3c += 1) { /*15195*/
			$k[$j++] = _3c; /*15195*/
			$k[$j++] = _3c - 33; /*15195*/
		} /*15195*/
		for (var _3d = 58; _3d <= 64; _3d += 1) { /*15196*/
			$k[$j++] = _3d; /*15196*/
			$k[$j++] = _3d - 43; /*15196*/
		} /*15196*/
		for (var _3e = 91; _3e <= 95; _3e += 1) { /*15197*/
			$k[$j++] = _3e; /*15197*/
			$k[$j++] = _3e - 69; /*15197*/
		} /*15197*/
		$k[$j++] = $1.fnc1; /*15199*/
		$k[$j++] = 27; /*15199*/
		$k[$j++] = $1.usft; /*15199*/
		$k[$j++] = 30; /*15199*/
		var _3h = $d(); /*15199*/
		$1[$k[--$j]] = _3h; /*15200*/
		$k[$j++] = "C3vals"; /*15201*/
		$k[$j++] = Infinity; /*15201*/
		for (var _3j = 96; _3j <= 127; _3j += 1) { /*15201*/
			$k[$j++] = _3j; /*15201*/
			$k[$j++] = _3j - 96; /*15201*/
		} /*15201*/
		var _3k = $d(); /*15201*/
		$1[$k[--$j]] = _3k; /*15201*/
		$k[$j++] = "Cvals"; /*15206*/
		$k[$j++] = Infinity; /*15206*/
		$forall($1.CNvals, function() { /*15203*/
			$k[$j++] = Infinity; /*15203*/
			var _3n = $k[--$j]; /*15203*/
			var _3o = $k[--$j]; /*15203*/
			$k[$j++] = _3n; /*15203*/
			$k[$j++] = _3o; /*15203*/
			var _3p = $a(); /*15203*/
			$k[$j++] = _3p; /*15203*/
		}); /*15203*/
		$forall($1.C1vals, function() { /*15204*/
			$k[$j++] = Infinity; /*15204*/
			var _3r = $k[--$j]; /*15204*/
			var _3s = $k[--$j]; /*15204*/
			$k[$j++] = _3r; /*15204*/
			$k[$j++] = $get($1.CNvals, $1.sft1); /*15204*/
			$k[$j++] = _3s; /*15204*/
			var _3w = $a(); /*15204*/
			$k[$j++] = _3w; /*15204*/
		}); /*15204*/
		$forall($1.C2vals, function() { /*15205*/
			$k[$j++] = Infinity; /*15205*/
			var _3y = $k[--$j]; /*15205*/
			var _3z = $k[--$j]; /*15205*/
			$k[$j++] = _3y; /*15205*/
			$k[$j++] = $get($1.CNvals, $1.sft2); /*15205*/
			$k[$j++] = _3z; /*15205*/
			var _43 = $a(); /*15205*/
			$k[$j++] = _43; /*15205*/
		}); /*15205*/
		$forall($1.C3vals, function() { /*15206*/
			$k[$j++] = Infinity; /*15206*/
			var _45 = $k[--$j]; /*15206*/
			var _46 = $k[--$j]; /*15206*/
			$k[$j++] = _45; /*15206*/
			$k[$j++] = $get($1.CNvals, $1.sft3); /*15206*/
			$k[$j++] = _46; /*15206*/
			var _4A = $a(); /*15206*/
			$k[$j++] = _4A; /*15206*/
		}); /*15206*/
		var _4B = $d(); /*15206*/
		$1[$k[--$j]] = _4B; /*15207*/
		$k[$j++] = "TNvals"; /*15215*/
		$k[$j++] = Infinity; /*15215*/
		$k[$j++] = $1.sft1; /*15214*/
		$k[$j++] = 0; /*15214*/
		$k[$j++] = $1.sft2; /*15214*/
		$k[$j++] = 1; /*15214*/
		$k[$j++] = $1.sft3; /*15214*/
		$k[$j++] = 2; /*15214*/
		$k[$j++] = 32; /*15214*/
		$k[$j++] = 3; /*15214*/
		for (var _4G = 48; _4G <= 57; _4G += 1) { /*15214*/
			$k[$j++] = _4G; /*15214*/
			$k[$j++] = _4G - 44; /*15214*/
		} /*15214*/
		for (var _4H = 97; _4H <= 122; _4H += 1) { /*15215*/
			$k[$j++] = _4H; /*15215*/
			$k[$j++] = _4H - 83; /*15215*/
		} /*15215*/
		var _4I = $d(); /*15215*/
		$1[$k[--$j]] = _4I; /*15216*/
		$k[$j++] = "T1vals"; /*15217*/
		$k[$j++] = Infinity; /*15217*/
		for (var _4K = 0; _4K <= 31; _4K += 1) { /*15217*/
			$k[$j++] = _4K; /*15217*/
			$k[$j++] = _4K; /*15217*/
		} /*15217*/
		var _4L = $d(); /*15217*/
		$1[$k[--$j]] = _4L; /*15217*/
		$k[$j++] = "T2vals"; /*15223*/
		$k[$j++] = Infinity; /*15223*/
		for (var _4N = 33; _4N <= 47; _4N += 1) { /*15219*/
			$k[$j++] = _4N; /*15219*/
			$k[$j++] = _4N - 33; /*15219*/
		} /*15219*/
		for (var _4O = 58; _4O <= 64; _4O += 1) { /*15220*/
			$k[$j++] = _4O; /*15220*/
			$k[$j++] = _4O - 43; /*15220*/
		} /*15220*/
		for (var _4P = 91; _4P <= 95; _4P += 1) { /*15221*/
			$k[$j++] = _4P; /*15221*/
			$k[$j++] = _4P - 69; /*15221*/
		} /*15221*/
		$k[$j++] = $1.fnc1; /*15223*/
		$k[$j++] = 27; /*15223*/
		$k[$j++] = $1.usft; /*15223*/
		$k[$j++] = 30; /*15223*/
		var _4S = $d(); /*15223*/
		$1[$k[--$j]] = _4S; /*15224*/
		$k[$j++] = "T3vals"; /*15228*/
		$k[$j++] = Infinity; /*15228*/
		$k[$j++] = 96; /*15227*/
		$k[$j++] = 0; /*15227*/
		for (var _4U = 65; _4U <= 90; _4U += 1) { /*15227*/
			$k[$j++] = _4U; /*15227*/
			$k[$j++] = _4U - 64; /*15227*/
		} /*15227*/
		for (var _4V = 123; _4V <= 127; _4V += 1) { /*15228*/
			$k[$j++] = _4V; /*15228*/
			$k[$j++] = _4V - 96; /*15228*/
		} /*15228*/
		var _4W = $d(); /*15228*/
		$1[$k[--$j]] = _4W; /*15229*/
		$k[$j++] = "Tvals"; /*15234*/
		$k[$j++] = Infinity; /*15234*/
		$forall($1.TNvals, function() { /*15231*/
			$k[$j++] = Infinity; /*15231*/
			var _4Z = $k[--$j]; /*15231*/
			var _4a = $k[--$j]; /*15231*/
			$k[$j++] = _4Z; /*15231*/
			$k[$j++] = _4a; /*15231*/
			var _4b = $a(); /*15231*/
			$k[$j++] = _4b; /*15231*/
		}); /*15231*/
		$forall($1.T1vals, function() { /*15232*/
			$k[$j++] = Infinity; /*15232*/
			var _4d = $k[--$j]; /*15232*/
			var _4e = $k[--$j]; /*15232*/
			$k[$j++] = _4d; /*15232*/
			$k[$j++] = $get($1.TNvals, $1.sft1); /*15232*/
			$k[$j++] = _4e; /*15232*/
			var _4i = $a(); /*15232*/
			$k[$j++] = _4i; /*15232*/
		}); /*15232*/
		$forall($1.T2vals, function() { /*15233*/
			$k[$j++] = Infinity; /*15233*/
			var _4k = $k[--$j]; /*15233*/
			var _4l = $k[--$j]; /*15233*/
			$k[$j++] = _4k; /*15233*/
			$k[$j++] = $get($1.TNvals, $1.sft2); /*15233*/
			$k[$j++] = _4l; /*15233*/
			var _4p = $a(); /*15233*/
			$k[$j++] = _4p; /*15233*/
		}); /*15233*/
		$forall($1.T3vals, function() { /*15234*/
			$k[$j++] = Infinity; /*15234*/
			var _4r = $k[--$j]; /*15234*/
			var _4s = $k[--$j]; /*15234*/
			$k[$j++] = _4r; /*15234*/
			$k[$j++] = $get($1.TNvals, $1.sft3); /*15234*/
			$k[$j++] = _4s; /*15234*/
			var _4w = $a(); /*15234*/
			$k[$j++] = _4w; /*15234*/
		}); /*15234*/
		var _4x = $d(); /*15234*/
		$1[$k[--$j]] = _4x; /*15235*/
		for (var _4z = 128; _4z <= 255; _4z += 1) { /*15243*/
			$1.i = _4z; /*15239*/
			$k[$j++] = $1.Avals; /*15240*/
			$k[$j++] = $1.i; /*15240*/
			$k[$j++] = Infinity; /*15240*/
			$aload($get($1.Avals, $1.usft)); /*15240*/
			$aload($get($1.Avals, $1.i - 128)); /*15240*/
			var _58 = $a(); /*15240*/
			var _59 = $k[--$j]; /*15240*/
			$put($k[--$j], _59, _58); /*15240*/
			$k[$j++] = $1.Cvals; /*15241*/
			$k[$j++] = $1.i; /*15241*/
			$k[$j++] = Infinity; /*15241*/
			$aload($get($1.Cvals, $1.usft)); /*15241*/
			$aload($get($1.Cvals, $1.i - 128)); /*15241*/
			var _5J = $a(); /*15241*/
			var _5K = $k[--$j]; /*15241*/
			$put($k[--$j], _5K, _5J); /*15241*/
			$k[$j++] = $1.Tvals; /*15242*/
			$k[$j++] = $1.i; /*15242*/
			$k[$j++] = Infinity; /*15242*/
			$aload($get($1.Tvals, $1.usft)); /*15242*/
			$aload($get($1.Tvals, $1.i - 128)); /*15242*/
			var _5U = $a(); /*15242*/
			var _5V = $k[--$j]; /*15242*/
			$put($k[--$j], _5V, _5U); /*15242*/
		} /*15242*/
		$k[$j++] = "Xvals"; /*15251*/
		$k[$j++] = Infinity; /*15251*/
		$k[$j++] = 13; /*15250*/
		$k[$j++] = 0; /*15250*/
		$k[$j++] = 42; /*15250*/
		$k[$j++] = 1; /*15250*/
		$k[$j++] = 62; /*15250*/
		$k[$j++] = 2; /*15250*/
		$k[$j++] = 32; /*15250*/
		$k[$j++] = 3; /*15250*/
		for (var _5X = 48; _5X <= 57; _5X += 1) { /*15250*/
			$k[$j++] = _5X; /*15250*/
			$k[$j++] = _5X - 44; /*15250*/
		} /*15250*/
		for (var _5Y = 65; _5Y <= 90; _5Y += 1) { /*15251*/
			$k[$j++] = _5Y; /*15251*/
			$k[$j++] = _5Y - 51; /*15251*/
		} /*15251*/
		var _5Z = $d(); /*15251*/
		$1[$k[--$j]] = _5Z; /*15252*/
		$k[$j++] = "Xvals"; /*15254*/
		$k[$j++] = Infinity; /*15254*/
		$forall($1.Xvals, function() { /*15254*/
			$k[$j++] = Infinity; /*15254*/
			var _5c = $k[--$j]; /*15254*/
			var _5d = $k[--$j]; /*15254*/
			$k[$j++] = _5c; /*15254*/
			$k[$j++] = _5d; /*15254*/
			var _5e = $a(); /*15254*/
			$k[$j++] = _5e; /*15254*/
		}); /*15254*/
		var _5f = $d(); /*15254*/
		$1[$k[--$j]] = _5f; /*15255*/
		$k[$j++] = "Evals"; /*15260*/
		$k[$j++] = Infinity; /*15260*/
		for (var _5h = 64; _5h <= 94; _5h += 1) { /*15258*/
			$k[$j++] = _5h; /*15258*/
			$k[$j++] = _5h - 64; /*15258*/
		} /*15258*/
		$k[$j++] = $1.unl; /*15260*/
		$k[$j++] = 31; /*15260*/
		for (var _5j = 32; _5j <= 63; _5j += 1) { /*15260*/
			$k[$j++] = _5j; /*15260*/
			$k[$j++] = _5j; /*15260*/
		} /*15260*/
		var _5k = $d(); /*15260*/
		$1[$k[--$j]] = _5k; /*15261*/
		$k[$j++] = "Evals"; /*15263*/
		$k[$j++] = Infinity; /*15263*/
		$forall($1.Evals, function() { /*15263*/
			$k[$j++] = Infinity; /*15263*/
			var _5n = $k[--$j]; /*15263*/
			var _5o = $k[--$j]; /*15263*/
			$k[$j++] = _5n; /*15263*/
			$k[$j++] = _5o; /*15263*/
			var _5p = $a(); /*15263*/
			$k[$j++] = _5p; /*15263*/
		}); /*15263*/
		var _5q = $d(); /*15263*/
		$1[$k[--$j]] = _5q; /*15264*/
		$k[$j++] = "Bvals"; /*15267*/
		$k[$j++] = Infinity; /*15267*/
		for (var _5s = 0; _5s <= 255; _5s += 1) { /*15267*/
			$k[$j++] = _5s; /*15267*/
			$k[$j++] = _5s; /*15267*/
		} /*15267*/
		var _5t = $d(); /*15267*/
		$1[$k[--$j]] = _5t; /*15268*/
		$k[$j++] = "Bvals"; /*15270*/
		$k[$j++] = Infinity; /*15270*/
		$forall($1.Bvals, function() { /*15270*/
			$k[$j++] = Infinity; /*15270*/
			var _5w = $k[--$j]; /*15270*/
			var _5x = $k[--$j]; /*15270*/
			$k[$j++] = _5w; /*15270*/
			$k[$j++] = _5x; /*15270*/
			var _5y = $a(); /*15270*/
			$k[$j++] = _5y; /*15270*/
		}); /*15270*/
		var _5z = $d(); /*15270*/
		$1[$k[--$j]] = _5z; /*15271*/
		$1.encvals = $a([$1.Avals, $1.Cvals, $1.Tvals, $1.Xvals, $1.Evals, $1.Bvals]); /*15273*/
		$k[$j++] = Infinity; /*15275*/
		for (var _69 = 0, _6A = $1.msglen; _69 < _6A; _69++) { /*15275*/
			$k[$j++] = 0; /*15275*/
		} /*15275*/
		$k[$j++] = 0; /*15275*/
		$1.numD = $a(); /*15275*/
		$k[$j++] = Infinity; /*15276*/
		for (var _6D = 0, _6E = $1.msglen; _6D < _6E; _6D++) { /*15276*/
			$k[$j++] = 0; /*15276*/
		} /*15276*/
		$k[$j++] = 9999; /*15276*/
		$1.nextXterm = $a(); /*15276*/
		$k[$j++] = Infinity; /*15277*/
		for (var _6H = 0, _6I = $1.msglen; _6H < _6I; _6H++) { /*15277*/
			$k[$j++] = 0; /*15277*/
		} /*15277*/
		$k[$j++] = 9999; /*15277*/
		$1.nextNonX = $a(); /*15277*/
		for (var _6L = $1.msglen - 1; _6L >= 0; _6L -= 1) { /*15294*/
			$1.i = _6L; /*15279*/
			$1.barchar = $get($1.msg, $1.i); /*15280*/
			if (($1.barchar >= 48) && ($1.barchar <= 57)) { /*15283*/
				$put($1.numD, $1.i, $get($1.numD, $1.i + 1) + 1); /*15282*/
			} /*15282*/
			if ((($1.barchar == 13) || ($1.barchar == 42)) || ($1.barchar == 62)) { /*15287*/
				$put($1.nextXterm, $1.i, 0); /*15285*/
			} else { /*15287*/
				$put($1.nextXterm, $1.i, $get($1.nextXterm, $1.i + 1) + 1); /*15287*/
			} /*15287*/
			var _6i = $get($1.Xvals, $1.barchar) !== undefined; /*15289*/
			if (!_6i) { /*15292*/
				$put($1.nextNonX, $1.i, 0); /*15290*/
			} else { /*15292*/
				$put($1.nextNonX, $1.i, $get($1.nextNonX, $1.i + 1) + 1); /*15292*/
			} /*15292*/
		} /*15292*/
		$k[$j++] = Infinity; /*15295*/
		var _6q = $1.nextXterm; /*15295*/
		for (var _6r = 0, _6s = _6q.length; _6r < _6s; _6r++) { /*15295*/
			var _6t = $get(_6q, _6r); /*15295*/
			$k[$j++] = _6t; /*15295*/
			if (_6t > 10000) { /*15295*/
				$j--; /*15295*/
				$k[$j++] = 10000; /*15295*/
			} /*15295*/
		} /*15295*/
		$1.nextXterm = $a(); /*15295*/
		$k[$j++] = Infinity; /*15296*/
		var _6v = $1.nextNonX; /*15296*/
		for (var _6w = 0, _6x = _6v.length; _6w < _6x; _6w++) { /*15296*/
			var _6y = $get(_6v, _6w); /*15296*/
			$k[$j++] = _6y; /*15296*/
			if (_6y > 10000) { /*15296*/
				$j--; /*15296*/
				$k[$j++] = 10000; /*15296*/
			} /*15296*/
		} /*15296*/
		$1.nextNonX = $a(); /*15296*/
		$1.isD = function() {
			$k[$j++] = ($1.char >= 48) && ($1.char <= 57); /*15298*/
		}; /*15298*/
		$1.isC = function() {
			var _74 = $get($1.CNvals, $1.char) !== undefined; /*15299*/
			$k[$j++] = _74; /*15299*/
		}; /*15299*/
		$1.isT = function() {
			var _77 = $get($1.TNvals, $1.char) !== undefined; /*15300*/
			$k[$j++] = _77; /*15300*/
		}; /*15300*/
		$1.isX = function() {
			var _7A = $get($1.Xvals, $1.char) !== undefined; /*15301*/
			$k[$j++] = _7A; /*15301*/
		}; /*15301*/
		$1.isE = function() {
			var _7D = $get($1.Evals, $1.char) !== undefined; /*15302*/
			$k[$j++] = _7D; /*15302*/
		}; /*15302*/
		$1.isEA = function() {
			$k[$j++] = $1.char > 127; /*15303*/
		}; /*15303*/
		$1.isFN = function() {
			$k[$j++] = $1.char < 0; /*15304*/
		}; /*15304*/
		$1.XtermFirst = function() {
			var _7G = $k[--$j]; /*15305*/
			$k[$j++] = $lt($get($1.nextXterm, _7G), $get($1.nextNonX, _7G)); /*15305*/
		}; /*15305*/
		$1.A = 0; /*15307*/
		$1.C = 1; /*15307*/
		$1.T = 2; /*15307*/
		$1.X = 3; /*15307*/
		$1.E = 4; /*15307*/
		$1.B = 5; /*15307*/
		$1.lookup = function() {
			$1.ac = 1; /*15310*/
			$1.cc = 2; /*15310*/
			$1.tc = 2; /*15310*/
			$1.xc = 2; /*15310*/
			$1.ec = 2; /*15310*/
			$1.bc = 2.25; /*15310*/
			if ($1.mode == $1.A) { /*15311*/
				$1.ac = 0; /*15311*/
				$1.cc = 1; /*15311*/
				$1.tc = 1; /*15311*/
				$1.xc = 1; /*15311*/
				$1.ec = 1; /*15311*/
				$1.bc = 1.25; /*15311*/
			} /*15311*/
			if ($1.mode == $1.C) { /*15312*/
				$1.cc = 0; /*15312*/
			} /*15312*/
			if ($1.mode == $1.T) { /*15313*/
				$1.tc = 0; /*15313*/
			} /*15313*/
			if ($1.mode == $1.X) { /*15314*/
				$1.xc = 0; /*15314*/
			} /*15314*/
			if ($1.mode == $1.E) { /*15315*/
				$1.ec = 0; /*15315*/
			} /*15315*/
			if ($1.mode == $1.B) { /*15316*/
				$1.bc = 0; /*15316*/
			} /*15316*/
			for (var _7X = 0, _7Y = 1; _7X < _7Y; _7X++) { /*15349*/
				$1.k = 0; /*15318*/
				for (;;) { /*15348*/
					if (($1.i + $1.k) == $1.msglen) { /*15327*/
						var _7c = $a(["ac", "cc", "tc", "xc", "ec", "bc"]); /*15320*/
						for (var _7d = 0, _7e = _7c.length; _7d < _7e; _7d++) { /*15320*/
							var _7f = $get(_7c, _7d); /*15320*/
							$1[_7f] = Math.ceil($1[_7f]); /*15320*/
						} /*15320*/
						var _7m = $a([$1.cc, $1.tc, $1.xc, $1.ec, $1.bc]); /*15321*/
						$k[$j++] = true; /*15321*/
						for (var _7n = 0, _7o = _7m.length; _7n < _7o; _7n++) { /*15321*/
							var _7r = $k[--$j]; /*15321*/
							$k[$j++] = _7r && ($1.ac <= $get(_7m, _7n)); /*15321*/
						} /*15321*/
						if ($k[--$j]) { /*15321*/
							$k[$j++] = $1.A; /*15321*/
							break; /*15321*/
						} /*15321*/
						var _7z = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.ec]); /*15322*/
						$k[$j++] = true; /*15322*/
						for (var _80 = 0, _81 = _7z.length; _80 < _81; _80++) { /*15322*/
							var _84 = $k[--$j]; /*15322*/
							$k[$j++] = _84 && ($1.bc < $get(_7z, _80)); /*15322*/
						} /*15322*/
						if ($k[--$j]) { /*15322*/
							$k[$j++] = $1.B; /*15322*/
							break; /*15322*/
						} /*15322*/
						var _8C = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.bc]); /*15323*/
						$k[$j++] = true; /*15323*/
						for (var _8D = 0, _8E = _8C.length; _8D < _8E; _8D++) { /*15323*/
							var _8H = $k[--$j]; /*15323*/
							$k[$j++] = _8H && ($1.ec < $get(_8C, _8D)); /*15323*/
						} /*15323*/
						if ($k[--$j]) { /*15323*/
							$k[$j++] = $1.E; /*15323*/
							break; /*15323*/
						} /*15323*/
						var _8P = $a([$1.ac, $1.cc, $1.xc, $1.ec, $1.bc]); /*15324*/
						$k[$j++] = true; /*15324*/
						for (var _8Q = 0, _8R = _8P.length; _8Q < _8R; _8Q++) { /*15324*/
							var _8U = $k[--$j]; /*15324*/
							$k[$j++] = _8U && ($1.tc < $get(_8P, _8Q)); /*15324*/
						} /*15324*/
						if ($k[--$j]) { /*15324*/
							$k[$j++] = $1.T; /*15324*/
							break; /*15324*/
						} /*15324*/
						var _8c = $a([$1.ac, $1.cc, $1.tc, $1.ec, $1.bc]); /*15325*/
						$k[$j++] = true; /*15325*/
						for (var _8d = 0, _8e = _8c.length; _8d < _8e; _8d++) { /*15325*/
							var _8h = $k[--$j]; /*15325*/
							$k[$j++] = _8h && ($1.xc < $get(_8c, _8d)); /*15325*/
						} /*15325*/
						if ($k[--$j]) { /*15325*/
							$k[$j++] = $1.X; /*15325*/
							break; /*15325*/
						} /*15325*/
						$k[$j++] = $1.C; /*15326*/
						break; /*15326*/
					} /*15326*/
					$1.char = $get($1.msg, $1.i + $1.k); /*15328*/
					$k[$j++] = "ac"; /*15329*/
					$k[$j++] = $1.ac; /*15329*/
					$1.isD(); /*15329*/
					if ($k[--$j]) { /*15329*/
						var _8r = $k[--$j]; /*15329*/
						$k[$j++] = _8r + (1 / 2); /*15329*/
					} else { /*15329*/
						$1.isEA(); /*15329*/
						if ($k[--$j]) { /*15329*/
							var _8t = $k[--$j]; /*15329*/
							$k[$j++] = Math.ceil(_8t) + 2; /*15329*/
						} else { /*15329*/
							var _8u = $k[--$j]; /*15329*/
							$k[$j++] = Math.ceil(_8u) + 1; /*15329*/
						} /*15329*/
					} /*15329*/
					var _8v = $k[--$j]; /*15329*/
					$1[$k[--$j]] = _8v; /*15329*/
					$k[$j++] = "cc"; /*15330*/
					$k[$j++] = $1.cc; /*15330*/
					$1.isC(); /*15330*/
					if ($k[--$j]) { /*15330*/
						var _8z = $k[--$j]; /*15330*/
						$k[$j++] = _8z + (2 / 3); /*15330*/
					} else { /*15330*/
						$1.isEA(); /*15330*/
						if ($k[--$j]) { /*15330*/
							var _91 = $k[--$j]; /*15330*/
							$k[$j++] = _91 + (8 / 3); /*15330*/
						} else { /*15330*/
							var _92 = $k[--$j]; /*15330*/
							$k[$j++] = _92 + (4 / 3); /*15330*/
						} /*15330*/
					} /*15330*/
					var _93 = $k[--$j]; /*15330*/
					$1[$k[--$j]] = _93; /*15330*/
					$k[$j++] = "tc"; /*15331*/
					$k[$j++] = $1.tc; /*15331*/
					$1.isT(); /*15331*/
					if ($k[--$j]) { /*15331*/
						var _97 = $k[--$j]; /*15331*/
						$k[$j++] = _97 + (2 / 3); /*15331*/
					} else { /*15331*/
						$1.isEA(); /*15331*/
						if ($k[--$j]) { /*15331*/
							var _99 = $k[--$j]; /*15331*/
							$k[$j++] = _99 + (8 / 3); /*15331*/
						} else { /*15331*/
							var _9A = $k[--$j]; /*15331*/
							$k[$j++] = _9A + (4 / 3); /*15331*/
						} /*15331*/
					} /*15331*/
					var _9B = $k[--$j]; /*15331*/
					$1[$k[--$j]] = _9B; /*15331*/
					$k[$j++] = "xc"; /*15332*/
					$k[$j++] = $1.xc; /*15332*/
					$1.isX(); /*15332*/
					if ($k[--$j]) { /*15332*/
						var _9F = $k[--$j]; /*15332*/
						$k[$j++] = _9F + (2 / 3); /*15332*/
					} else { /*15332*/
						$1.isEA(); /*15332*/
						if ($k[--$j]) { /*15332*/
							var _9H = $k[--$j]; /*15332*/
							$k[$j++] = _9H + (13 / 3); /*15332*/
						} else { /*15332*/
							var _9I = $k[--$j]; /*15332*/
							$k[$j++] = _9I + (10 / 3); /*15332*/
						} /*15332*/
					} /*15332*/
					var _9J = $k[--$j]; /*15332*/
					$1[$k[--$j]] = _9J; /*15332*/
					$k[$j++] = "ec"; /*15333*/
					$k[$j++] = $1.ec; /*15333*/
					$1.isE(); /*15333*/
					if ($k[--$j]) { /*15333*/
						var _9N = $k[--$j]; /*15333*/
						$k[$j++] = _9N + (3 / 4); /*15333*/
					} else { /*15333*/
						$1.isEA(); /*15333*/
						if ($k[--$j]) { /*15333*/
							var _9P = $k[--$j]; /*15333*/
							$k[$j++] = _9P + (17 / 4); /*15333*/
						} else { /*15333*/
							var _9Q = $k[--$j]; /*15333*/
							$k[$j++] = _9Q + (13 / 4); /*15333*/
						} /*15333*/
					} /*15333*/
					var _9R = $k[--$j]; /*15333*/
					$1[$k[--$j]] = _9R; /*15333*/
					$k[$j++] = "bc"; /*15334*/
					$k[$j++] = $1.bc; /*15334*/
					$1.isFN(); /*15334*/
					if ($k[--$j]) { /*15334*/
						var _9V = $k[--$j]; /*15334*/
						$k[$j++] = _9V + 4; /*15334*/
					} else { /*15334*/
						var _9W = $k[--$j]; /*15334*/
						$k[$j++] = _9W + 1; /*15334*/
					} /*15334*/
					var _9X = $k[--$j]; /*15334*/
					$1[$k[--$j]] = _9X; /*15334*/
					if ($1.k >= 4) { /*15346*/
						var _9f = $a([$1.cc, $1.tc, $1.xc, $1.ec, $1.bc]); /*15336*/
						$k[$j++] = true; /*15336*/
						for (var _9g = 0, _9h = _9f.length; _9g < _9h; _9g++) { /*15336*/
							var _9k = $k[--$j]; /*15336*/
							$k[$j++] = _9k && (($1.ac + 1) <= $get(_9f, _9g)); /*15336*/
						} /*15336*/
						if ($k[--$j]) { /*15336*/
							$k[$j++] = $1.A; /*15336*/
							break; /*15336*/
						} /*15336*/
						if (($1.bc + 1) <= $1.ac) { /*15337*/
							$k[$j++] = $1.B; /*15337*/
							break; /*15337*/
						} /*15337*/
						var _9u = $a([$1.cc, $1.tc, $1.xc, $1.ec]); /*15338*/
						$k[$j++] = true; /*15338*/
						for (var _9v = 0, _9w = _9u.length; _9v < _9w; _9v++) { /*15338*/
							var _9z = $k[--$j]; /*15338*/
							$k[$j++] = _9z && (($1.bc + 1) < $get(_9u, _9v)); /*15338*/
						} /*15338*/
						if ($k[--$j]) { /*15338*/
							$k[$j++] = $1.B; /*15338*/
							break; /*15338*/
						} /*15338*/
						var _A7 = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.bc]); /*15339*/
						$k[$j++] = true; /*15339*/
						for (var _A8 = 0, _A9 = _A7.length; _A8 < _A9; _A8++) { /*15339*/
							var _AC = $k[--$j]; /*15339*/
							$k[$j++] = _AC && (($1.ec + 1) < $get(_A7, _A8)); /*15339*/
						} /*15339*/
						if ($k[--$j]) { /*15339*/
							$k[$j++] = $1.E; /*15339*/
							break; /*15339*/
						} /*15339*/
						var _AK = $a([$1.ac, $1.cc, $1.xc, $1.ec, $1.bc]); /*15340*/
						$k[$j++] = true; /*15340*/
						for (var _AL = 0, _AM = _AK.length; _AL < _AM; _AL++) { /*15340*/
							var _AP = $k[--$j]; /*15340*/
							$k[$j++] = _AP && (($1.tc + 1) < $get(_AK, _AL)); /*15340*/
						} /*15340*/
						if ($k[--$j]) { /*15340*/
							$k[$j++] = $1.T; /*15340*/
							break; /*15340*/
						} /*15340*/
						var _AX = $a([$1.ac, $1.cc, $1.tc, $1.ec, $1.bc]); /*15341*/
						$k[$j++] = true; /*15341*/
						for (var _AY = 0, _AZ = _AX.length; _AY < _AZ; _AY++) { /*15341*/
							var _Ac = $k[--$j]; /*15341*/
							$k[$j++] = _Ac && (($1.xc + 1) < $get(_AX, _AY)); /*15341*/
						} /*15341*/
						if ($k[--$j]) { /*15341*/
							$k[$j++] = $1.X; /*15341*/
							break; /*15341*/
						} /*15341*/
						var _Aj = $a([$1.ac, $1.tc, $1.ec, $1.bc]); /*15342*/
						$k[$j++] = true; /*15342*/
						for (var _Ak = 0, _Al = _Aj.length; _Ak < _Al; _Ak++) { /*15342*/
							var _Ao = $k[--$j]; /*15342*/
							$k[$j++] = _Ao && (($1.cc + 1) < $get(_Aj, _Ak)); /*15342*/
						} /*15342*/
						if ($k[--$j]) { /*15345*/
							if ($1.cc < $1.xc) { /*15343*/
								$k[$j++] = $1.C; /*15343*/
								break; /*15343*/
							} /*15343*/
							if ($1.cc == $1.xc) { /*15344*/
								$k[$j++] = ($1.i + $1.k) + 1; /*15344*/
								$1.XtermFirst(); /*15344*/
								if ($k[--$j]) { /*15344*/
									$k[$j++] = $1.X; /*15344*/
									break; /*15344*/
								} else { /*15344*/
									$k[$j++] = $1.C; /*15344*/
									break; /*15344*/
								} /*15344*/
							} /*15344*/
						} /*15344*/
					} /*15344*/
					$1.k = $1.k + 1; /*15347*/
				} /*15347*/
			} /*15347*/
		}; /*15350*/
		$1.addtocws = function() {
			var _B1 = $k[--$j]; /*15353*/
			$puti($1.cws, $1.j, _B1); /*15353*/
			$1.j = _B1.length + $1.j; /*15354*/
		}; /*15355*/
		$1.encA = function() {
			for (var _B5 = 0, _B6 = 1; _B5 < _B6; _B5++) { /*15373*/
				if ($get($1.numD, $1.i) >= 2) { /*15363*/
					var _BA = $s(2); /*15360*/
					$put(_BA, 0, $get($1.msg, $1.i)); /*15360*/
					$put(_BA, 1, $get($1.msg, $1.i + 1)); /*15360*/
					$k[$j++] = $get($1.Avals, _BA); /*15360*/
					$1.addtocws(); /*15360*/
					$1.i = $1.i + 2; /*15361*/
					break; /*15362*/
				} /*15362*/
				$k[$j++] = "newmode"; /*15364*/
				$1.lookup(); /*15364*/
				var _BK = $k[--$j]; /*15364*/
				$1[$k[--$j]] = _BK; /*15364*/
				if ($1.newmode != $1.mode) { /*15369*/
					$k[$j++] = $get($1.Avals, $get($a([-1, $1.lC, $1.lT, $1.lX, $1.lE, $1.lB]), $1.newmode)); /*15366*/
					$1.addtocws(); /*15366*/
					$1.mode = $1.newmode; /*15367*/
					break; /*15368*/
				} /*15368*/
				$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15370*/
				$1.addtocws(); /*15370*/
				$1.i = $1.i + 1; /*15371*/
				break; /*15372*/
			} /*15372*/
		}; /*15374*/
		$1.CTXvalstocws = function() {
			$1.in = $k[--$j]; /*15377*/
			$k[$j++] = Infinity; /*15378*/
			for (var _Bi = 0, _Bh = $1.in.length - 1; _Bi <= _Bh; _Bi += 3) { /*15382*/
				$k[$j++] = 0; /*15380*/
				$forall($geti($1.in, _Bi, 3), function() { /*15380*/
					var _Bl = $k[--$j]; /*15380*/
					var _Bm = $k[--$j]; /*15380*/
					$k[$j++] = (_Bm + _Bl) * 40; /*15380*/
				}); /*15380*/
				var _Bo = (~~($k[--$j] / 40)) + 1; /*15381*/
				$k[$j++] = ~~(_Bo / 256); /*15381*/
				$k[$j++] = _Bo % 256; /*15381*/
			} /*15381*/
			$astore($a($counttomark())); /*15383*/
			var _Br = $k[--$j]; /*15383*/
			var _Bs = $k[--$j]; /*15383*/
			$k[$j++] = _Br; /*15383*/
		}; /*15384*/
		$1.encCTX = function() {
			$1.p = 0; /*15387*/
			$1.ctxvals = $a(2500); /*15388*/
			for (;;) { /*15456*/
				if ($1.i == $1.msglen) { /*15392*/
					break; /*15392*/
				} /*15392*/
				var _C2 = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)) !== undefined; /*15393*/
				if (!_C2) { /*15393*/
					break; /*15393*/
				} /*15393*/
				if (($1.p % 3) == 0) { /*15451*/
					$1.lookup(); /*15395*/
					if ($ne($k[--$j], $1.mode)) { /*15400*/
						$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15396*/
						$1.CTXvalstocws(); /*15396*/
						$1.addtocws(); /*15396*/
						$k[$j++] = $a([$1.unlcw]); /*15397*/
						$1.addtocws(); /*15397*/
						$1.mode = $1.A; /*15398*/
						break; /*15399*/
					} /*15399*/
					if (($1.msglen - $1.i) <= 3) { /*15450*/
						$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 3)) * 2)); /*15402*/
						$k[$j++] = Infinity; /*15411*/
						$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*15410*/
							var _CN = $k[--$j]; /*15405*/
							var _CR = $get($get($1.encvals, $1.mode), _CN) !== undefined; /*15405*/
							$k[$j++] = _CN; /*15409*/
							if (_CR) { /*15408*/
								$aload($get($get($1.encvals, $1.mode), $k[--$j])); /*15406*/
							} else { /*15408*/
								$j--; /*15408*/
								$k[$j++] = -1; /*15408*/
								$k[$j++] = -1; /*15408*/
								$k[$j++] = -1; /*15408*/
								$k[$j++] = -1; /*15408*/
							} /*15408*/
						}); /*15408*/
						$1.remvals = $a(); /*15411*/
						if (($1.remcws == 2) && ($1.remvals.length == 3)) { /*15421*/
							$k[$j++] = Infinity; /*15416*/
							$aload($geti($1.ctxvals, 0, $1.p)); /*15415*/
							$aload($1.remvals); /*15416*/
							var _Ce = $a(); /*15416*/
							$k[$j++] = _Ce; /*15417*/
							$1.CTXvalstocws(); /*15417*/
							$1.addtocws(); /*15417*/
							$1.mode = $1.A; /*15418*/
							$1.i = $1.msglen; /*15419*/
							break; /*15420*/
						} /*15420*/
						if ((($1.remcws == 2) && ($1.remvals.length == 2)) && ($1.mode != $1.X)) { /*15432*/
							$k[$j++] = Infinity; /*15427*/
							$aload($geti($1.ctxvals, 0, $1.p)); /*15425*/
							$aload($1.remvals); /*15426*/
							$aload($get($get($1.encvals, $1.mode), $1.sft1)); /*15427*/
							var _Cu = $a(); /*15427*/
							$k[$j++] = _Cu; /*15428*/
							$1.CTXvalstocws(); /*15428*/
							$1.addtocws(); /*15428*/
							$1.mode = $1.A; /*15429*/
							$1.i = $1.msglen; /*15430*/
							break; /*15431*/
						} /*15431*/
						if (($1.remcws == 2) && ($1.remvals.length == 1)) { /*15441*/
							$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15435*/
							$1.CTXvalstocws(); /*15435*/
							$1.addtocws(); /*15435*/
							$k[$j++] = $a([$1.unlcw]); /*15436*/
							$1.addtocws(); /*15436*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15437*/
							$1.addtocws(); /*15437*/
							$1.mode = $1.A; /*15438*/
							$1.i = $1.msglen; /*15439*/
							break; /*15440*/
						} /*15440*/
						if (($1.remcws == 1) && ($1.remvals.length == 1)) { /*15449*/
							$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15444*/
							$1.CTXvalstocws(); /*15444*/
							$1.addtocws(); /*15444*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15445*/
							$1.addtocws(); /*15445*/
							$1.mode = $1.A; /*15446*/
							$1.i = $1.msglen; /*15447*/
							break; /*15448*/
						} /*15448*/
					} /*15448*/
				} /*15448*/
				var _DT = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)); /*15452*/
				$puti($1.ctxvals, $1.p, _DT); /*15453*/
				$1.p = _DT.length + $1.p; /*15454*/
				$1.i = $1.i + 1; /*15455*/
			} /*15455*/
			if ($1.mode != $1.A) { /*15480*/
				for (;;) { /*15464*/
					if (($1.p % 3) == 0) { /*15461*/
						break; /*15461*/
					} /*15461*/
					$1.i = $1.i - 1; /*15462*/
					$1.p = $1.p - $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)).length; /*15463*/
				} /*15463*/
				$k[$j++] = Infinity; /*15466*/
				$aload($geti($1.ctxvals, 0, $1.p)); /*15466*/
				var _Dn = $a(); /*15466*/
				$k[$j++] = _Dn; /*15467*/
				$1.CTXvalstocws(); /*15467*/
				$1.addtocws(); /*15467*/
				$k[$j++] = $a([$1.unlcw]); /*15468*/
				$1.addtocws(); /*15468*/
				$1.mode = $1.A; /*15469*/
				if ($1.i != $1.msglen) { /*15479*/
					if ($get($1.numD, $1.i) >= 2) { /*15477*/
						var _Dw = $s(2); /*15473*/
						$put(_Dw, 0, $get($1.msg, $1.i)); /*15473*/
						$put(_Dw, 1, $get($1.msg, $1.i + 1)); /*15473*/
						$k[$j++] = $get($1.Avals, _Dw); /*15473*/
						$1.addtocws(); /*15473*/
						$1.i = $1.i + 2; /*15474*/
					} else { /*15477*/
						$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15476*/
						$1.addtocws(); /*15476*/
						$1.i = $1.i + 1; /*15477*/
					} /*15477*/
				} /*15477*/
			} /*15477*/
		}; /*15482*/
		$1.Evalstocws = function() {
			$1.in = $k[--$j]; /*15485*/
			$1.inlen = $1.in.length; /*15486*/
			$1.outlen = ~~(Math.ceil(($1.in.length / 4) * 3)); /*15487*/
			$k[$j++] = Infinity; /*15488*/
			$aload($1.in); /*15488*/
			$k[$j++] = 0; /*15488*/
			$k[$j++] = 0; /*15488*/
			$k[$j++] = 0; /*15488*/
			$1.in = $a(); /*15488*/
			$k[$j++] = Infinity; /*15489*/
			for (var _EJ = 0, _EI = $1.inlen - 1; _EJ <= _EI; _EJ += 4) { /*15495*/
				$k[$j++] = 0; /*15491*/
				$forall($geti($1.in, _EJ, 4), function() { /*15491*/
					var _EM = $k[--$j]; /*15491*/
					var _EN = $k[--$j]; /*15491*/
					$k[$j++] = $or(_EN, _EM) << 6; /*15491*/
				}); /*15491*/
				var _EP = $k[--$j] >>> 6; /*15492*/
				$k[$j++] = (_EP >>> 16) & 255; /*15494*/
				$k[$j++] = (_EP >>> 8) & 255; /*15494*/
				$k[$j++] = _EP & 255; /*15494*/
			} /*15494*/
			$astore($a($counttomark())); /*15496*/
			var _ES = $k[--$j]; /*15496*/
			var _ET = $k[--$j]; /*15496*/
			$k[$j++] = $geti(_ES, 0, $1.outlen); /*15497*/
		}; /*15498*/
		$1.encE = function() {
			$1.p = 0; /*15501*/
			$1.edifactvals = $a(2100); /*15502*/
			for (;;) { /*15544*/
				if ($1.i == $1.msglen) { /*15506*/
					break; /*15506*/
				} /*15506*/
				var _Ed = $get($1.Evals, $get($1.msg, $1.i)) !== undefined; /*15507*/
				if (!_Ed) { /*15507*/
					break; /*15507*/
				} /*15507*/
				if (($1.p % 4) == 0) { /*15539*/
					$1.lookup(); /*15509*/
					if ($k[--$j] != $1.mode) { /*15509*/
						break; /*15509*/
					} /*15509*/
					if (($1.msglen - $1.i) <= 2) { /*15538*/
						$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 4)) * 3)); /*15511*/
						$k[$j++] = Infinity; /*15520*/
						$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*15519*/
							var _Es = $k[--$j]; /*15514*/
							var _Eu = $get($1.Evals, _Es) !== undefined; /*15514*/
							$k[$j++] = _Es; /*15518*/
							if (_Eu) { /*15517*/
								$aload($get($1.Evals, $k[--$j])); /*15515*/
							} else { /*15517*/
								$j--; /*15517*/
								$k[$j++] = -1; /*15517*/
								$k[$j++] = -1; /*15517*/
								$k[$j++] = -1; /*15517*/
								$k[$j++] = -1; /*15517*/
								$k[$j++] = -1; /*15517*/
							} /*15517*/
						}); /*15517*/
						$1.remvals = $a(); /*15520*/
						if (($1.remcws == 2) && ($1.remvals.length == 2)) { /*15529*/
							$k[$j++] = $geti($1.edifactvals, 0, $1.p); /*15523*/
							$1.Evalstocws(); /*15523*/
							$1.addtocws(); /*15523*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15524*/
							$1.addtocws(); /*15524*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i + 1)); /*15525*/
							$1.addtocws(); /*15525*/
							$1.mode = $1.A; /*15526*/
							$1.i = $1.msglen; /*15527*/
							break; /*15528*/
						} /*15528*/
						if ((($1.remcws == 2) || ($1.remcws == 1)) && ($1.remvals.length == 1)) { /*15537*/
							$k[$j++] = $geti($1.edifactvals, 0, $1.p); /*15532*/
							$1.Evalstocws(); /*15532*/
							$1.addtocws(); /*15532*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15533*/
							$1.addtocws(); /*15533*/
							$1.mode = $1.A; /*15534*/
							$1.i = $1.msglen; /*15535*/
							break; /*15536*/
						} /*15536*/
					} /*15536*/
				} /*15536*/
				var _FX = $get($1.Evals, $get($1.msg, $1.i)); /*15540*/
				$puti($1.edifactvals, $1.p, _FX); /*15541*/
				$1.p = _FX.length + $1.p; /*15542*/
				$1.i = $1.i + 1; /*15543*/
			} /*15543*/
			if ($1.mode != $1.A) { /*15566*/
				$1.remcws = $get($1.numremcws, ($1.j + ((~~($1.p / 4)) * 3)) - 1) - 1; /*15548*/
				if ($1.remcws != 0) { /*15553*/
					var _Fl = $get($1.Evals, $1.unl); /*15550*/
					$puti($1.edifactvals, $1.p, _Fl); /*15551*/
					$1.p = _Fl.length + $1.p; /*15552*/
				} /*15552*/
				$k[$j++] = $geti($1.edifactvals, 0, $1.p); /*15554*/
				$1.Evalstocws(); /*15554*/
				$1.addtocws(); /*15554*/
				$1.mode = $1.A; /*15555*/
				if ($1.i != $1.msglen) { /*15565*/
					if ($get($1.numD, $1.i) >= 2) { /*15563*/
						var _Fy = $s(2); /*15559*/
						$put(_Fy, 0, $get($1.msg, $1.i)); /*15559*/
						$put(_Fy, 1, $get($1.msg, $1.i + 1)); /*15559*/
						$k[$j++] = $get($1.Avals, _Fy); /*15559*/
						$1.addtocws(); /*15559*/
						$1.i = $1.i + 2; /*15560*/
					} else { /*15563*/
						$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15562*/
						$1.addtocws(); /*15562*/
						$1.i = $1.i + 1; /*15563*/
					} /*15563*/
				} /*15563*/
			} /*15563*/
		}; /*15568*/
		$1.encB = function() {
			$1.p = 0; /*15571*/
			$1.bvals = $a(1558); /*15571*/
			for (;;) { /*15577*/
				if ($1.i == $1.msglen) { /*15572*/
					break; /*15572*/
				} /*15572*/
				$1.lookup(); /*15573*/
				if ($k[--$j] != $1.mode) { /*15573*/
					break; /*15573*/
				} /*15573*/
				$put($1.bvals, $1.p, $get($1.msg, $1.i)); /*15574*/
				$1.p = $1.p + 1; /*15575*/
				$1.i = $1.i + 1; /*15576*/
			} /*15576*/
			$1.remcws = $get($1.numremcws, $1.j + $1.p) - 1; /*15578*/
			$k[$j++] = Infinity; /*15586*/
			if (($1.remcws == 0) && ($1.i == $1.msglen)) { /*15583*/
				$k[$j++] = 0; /*15581*/
			} else { /*15583*/
				if ($1.p < 250) { /*15583*/
					$k[$j++] = $1.p; /*15583*/
				} else { /*15583*/
					$k[$j++] = (~~($1.p / 250)) + 249; /*15583*/
					$k[$j++] = $1.p % 250; /*15583*/
				} /*15583*/
			} /*15583*/
			$aload($geti($1.bvals, 0, $1.p)); /*15585*/
			$1.bvals = $a(); /*15586*/
			for (var _Gh = 0, _Gg = $1.bvals.length - 1; _Gh <= _Gg; _Gh += 1) { /*15592*/
				$1.p = _Gh; /*15588*/
				var _Gn = ((((($1.j + $1.p) + 1) * 149) % 255) + 1) + $get($1.bvals, $1.p); /*15590*/
				$k[$j++] = _Gn; /*15590*/
				if (_Gn >= 256) { /*15590*/
					var _Go = $k[--$j]; /*15590*/
					$k[$j++] = _Go - 256; /*15590*/
				} /*15590*/
				$put($1.bvals, $1.p, $k[--$j]); /*15591*/
			} /*15591*/
			$k[$j++] = $1.bvals; /*15593*/
			$1.addtocws(); /*15593*/
			$1.mode = $1.A; /*15594*/
		}; /*15595*/
		$1.cws = $a(1558); /*15598*/
		$1.mode = $1.A; /*15599*/
		$1.i = 0; /*15599*/
		$1.j = 0; /*15599*/
		for (;;) { /*15602*/
			if ($1.i >= $1.msglen) { /*15600*/
				break; /*15600*/
			} /*15600*/
			$1[$get($a(["encA", "encCTX", "encCTX", "encCTX", "encE", "encB"]), $1.mode)](); /*15601*/
		} /*15601*/
		$1.cws = $geti($1.cws, 0, $1.j); /*15603*/
		$1.datlen = $1.cws.length; /*15606*/
		$1.remcws = $get($1.numremcws, $1.j - 1) - 1; /*15607*/
		if ($1.remcws > 0) { /*15616*/
			$k[$j++] = Infinity; /*15609*/
			$aload($1.cws); /*15609*/
			for (var _HC = 0, _HD = $1.remcws; _HC < _HD; _HC++) { /*15609*/
				$k[$j++] = 129; /*15609*/
			} /*15609*/
			$1.cws = $a(); /*15609*/
			for (var _HJ = $1.datlen + 1, _HI = ($1.datlen + $1.remcws) - 1; _HJ <= _HI; _HJ += 1) { /*15615*/
				$1.i = _HJ; /*15611*/
				var _HL = (((($1.i + 1) * 149) % 253) + 1) + 129; /*15613*/
				$k[$j++] = _HL; /*15613*/
				if (_HL > 254) { /*15613*/
					var _HM = $k[--$j]; /*15613*/
					$k[$j++] = _HM - 254; /*15613*/
				} /*15613*/
				$put($1.cws, $1.i, $k[--$j]); /*15614*/
			} /*15614*/
		} /*15614*/
		$1.i = 0; /*15619*/
		for (;;) { /*15640*/
			$1.m = $get($1.metrics, $1.i); /*15620*/
			$1.rows = $get($1.m, 0); /*15621*/
			$1.cols = $get($1.m, 1); /*15622*/
			$1.regh = $get($1.m, 2); /*15623*/
			$1.regv = $get($1.m, 3); /*15624*/
			$1.rscw = $get($1.m, 4); /*15625*/
			$1.rsbl = $get($1.m, 5); /*15626*/
			$1.mrows = $1.rows - (2 * $1.regh); /*15627*/
			$1.mcols = $1.cols - (2 * $1.regv); /*15628*/
			$1.rrows = ~~($1.mrows / $1.regh); /*15629*/
			$1.rcols = ~~($1.mcols / $1.regv); /*15630*/
			$1.ncws = (~~(($1.mrows * $1.mcols) / 8)) - $1.rscw; /*15631*/
			$1.okay = true; /*15632*/
			if ($1.cws.length != $1.ncws) { /*15633*/
				$1.okay = false; /*15633*/
			} /*15633*/
			if (($1.urows != 0) && ($1.urows != $1.rows)) { /*15634*/
				$1.okay = false; /*15634*/
			} /*15634*/
			if (($1.ucols != 0) && ($1.ucols != $1.cols)) { /*15635*/
				$1.okay = false; /*15635*/
			} /*15635*/
			if ($eq($1.format, "square") && $ne($1.rows, $1.cols)) { /*15636*/
				$1.okay = false; /*15636*/
			} /*15636*/
			if ($eq($1.format, "rectangle") && $eq($1.rows, $1.cols)) { /*15637*/
				$1.okay = false; /*15637*/
			} /*15637*/
			if ($1.okay) { /*15638*/
				break; /*15638*/
			} /*15638*/
			$1.i = $1.i + 1; /*15639*/
		} /*15639*/
		$1.cwbs = $a($1.rsbl); /*15643*/
		$1.ecbs = $a($1.rsbl); /*15644*/
		for (var _IC = 0, _IB = $1.rsbl - 1; _IC <= _IB; _IC += 1) { /*15659*/
			$1.i = _IC; /*15646*/
			if ($1.cws.length != 1558) { /*15650*/
				$1.cwbsize = ~~($1.cws.length / $1.rsbl); /*15648*/
			} else { /*15650*/
				if ($1.i <= 7) { /*15650*/
					$1.cwbsize = 156; /*15650*/
				} else { /*15650*/
					$1.cwbsize = 155; /*15650*/
				} /*15650*/
			} /*15650*/
			$1.cwb = $a($1.cwbsize); /*15652*/
			for (var _IL = 0, _IK = $1.cwbsize - 1; _IL <= _IK; _IL += 1) { /*15656*/
				$1.j = _IL; /*15654*/
				$put($1.cwb, $1.j, $get($1.cws, ($1.j * $1.rsbl) + $1.i)); /*15655*/
			} /*15655*/
			$put($1.cwbs, $1.i, $1.cwb); /*15657*/
			$k[$j++] = $1.ecbs; /*15658*/
			$k[$j++] = $1.i; /*15658*/
			$k[$j++] = Infinity; /*15658*/
			for (var _Ia = 0, _Ib = ~~($1.rscw / $1.rsbl); _Ia < _Ib; _Ia++) { /*15658*/
				$k[$j++] = 0; /*15658*/
			} /*15658*/
			var _Ic = $a(); /*15658*/
			var _Id = $k[--$j]; /*15658*/
			$put($k[--$j], _Id, _Ic); /*15658*/
		} /*15658*/
		$k[$j++] = Infinity; /*15662*/
		$k[$j++] = 1; /*15662*/
		for (var _If = 0, _Ig = 255; _If < _Ig; _If++) { /*15662*/
			var _Ih = $k[--$j]; /*15662*/
			var _Ii = _Ih * 2; /*15662*/
			$k[$j++] = _Ih; /*15662*/
			$k[$j++] = _Ii; /*15662*/
			if (_Ii >= 256) { /*15662*/
				var _Ij = $k[--$j]; /*15662*/
				$k[$j++] = _Ij ^ 301; /*15662*/
			} /*15662*/
		} /*15662*/
		$1.rsalog = $a(); /*15662*/
		$1.rslog = $a(256); /*15663*/
		for (var _Im = 1; _Im <= 255; _Im += 1) { /*15664*/
			$put($1.rslog, $get($1.rsalog, _Im), _Im); /*15664*/
		} /*15664*/
		$1.rsprod = function() {
			var _Iq = $k[--$j]; /*15668*/
			var _Ir = $k[--$j]; /*15668*/
			$k[$j++] = _Ir; /*15672*/
			$k[$j++] = _Iq; /*15672*/
			if ((_Iq != 0) && (_Ir != 0)) { /*15671*/
				var _Iu = $get($1.rslog, $k[--$j]); /*15669*/
				var _Iz = $get($1.rsalog, (_Iu + $get($1.rslog, $k[--$j])) % 255); /*15669*/
				$k[$j++] = _Iz; /*15669*/
			} else { /*15671*/
				$j -= 2; /*15671*/
				$k[$j++] = 0; /*15671*/
			} /*15671*/
		}; /*15673*/
		$k[$j++] = Infinity; /*15676*/
		$k[$j++] = 1; /*15676*/
		for (var _J2 = 0, _J3 = ~~($1.rscw / $1.rsbl); _J2 < _J3; _J2++) { /*15676*/
			$k[$j++] = 0; /*15676*/
		} /*15676*/
		$1.coeffs = $a(); /*15676*/
		for (var _J8 = 1, _J7 = ~~($1.rscw / $1.rsbl); _J8 <= _J7; _J8 += 1) { /*15685*/
			$1.i = _J8; /*15678*/
			$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*15679*/
			for (var _JF = $1.i - 1; _JF >= 1; _JF -= 1) { /*15683*/
				$1.j = _JF; /*15681*/
				$k[$j++] = $1.coeffs; /*15682*/
				$k[$j++] = $1.j; /*15682*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*15682*/
				$k[$j++] = $get($1.coeffs, $1.j); /*15682*/
				$k[$j++] = $get($1.rsalog, $1.i); /*15682*/
				$1.rsprod(); /*15682*/
				var _JR = $k[--$j]; /*15682*/
				var _JS = $k[--$j]; /*15682*/
				var _JT = $k[--$j]; /*15682*/
				$put($k[--$j], _JT, $xo(_JS, _JR)); /*15682*/
			} /*15682*/
			$k[$j++] = $1.coeffs; /*15684*/
			$k[$j++] = 0; /*15684*/
			$k[$j++] = $get($1.coeffs, 0); /*15684*/
			$k[$j++] = $get($1.rsalog, $1.i); /*15684*/
			$1.rsprod(); /*15684*/
			var _Jb = $k[--$j]; /*15684*/
			var _Jc = $k[--$j]; /*15684*/
			$put($k[--$j], _Jc, _Jb); /*15684*/
		} /*15684*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*15686*/
		for (var _Jj = 0, _Ji = $1.cwbs.length - 1; _Jj <= _Ji; _Jj += 1) { /*15702*/
			$1.i = _Jj; /*15690*/
			$1.cwb = $get($1.cwbs, $1.i); /*15691*/
			$1.ecb = $get($1.ecbs, $1.i); /*15692*/
			for (var _Js = 0, _Jr = $1.cwb.length - 1; _Js <= _Jr; _Js += 1) { /*15701*/
				$1.t = $xo($get($1.cwb, _Js), $get($1.ecb, 0)); /*15694*/
				for (var _Jy = $1.ecb.length - 1; _Jy >= 0; _Jy -= 1) { /*15700*/
					$1.j = _Jy; /*15696*/
					$1.p = ($1.ecb.length - $1.j) - 1; /*15697*/
					$k[$j++] = $1.ecb; /*15698*/
					$k[$j++] = $1.p; /*15698*/
					$k[$j++] = $1.t; /*15698*/
					$k[$j++] = $get($1.coeffs, $1.j); /*15698*/
					$1.rsprod(); /*15698*/
					var _K7 = $k[--$j]; /*15698*/
					var _K8 = $k[--$j]; /*15698*/
					$put($k[--$j], _K8, _K7); /*15698*/
					if ($1.j > 0) { /*15699*/
						$put($1.ecb, $1.p, $xo($get($1.ecb, $1.p + 1), $get($1.ecb, $1.p))); /*15699*/
					} /*15699*/
				} /*15699*/
			} /*15699*/
		} /*15699*/
		if ($1.ncws == 1558) { /*15707*/
			$k[$j++] = Infinity; /*15706*/
			$forall($geti($1.ecbs, 8, 2)); /*15706*/
			$forall($geti($1.ecbs, 0, 8)); /*15706*/
			$1.ecbs = $a(); /*15706*/
		} /*15706*/
		$k[$j++] = Infinity; /*15710*/
		var _KP = $1.cws; /*15710*/
		for (var _KQ = 0, _KR = _KP.length; _KQ < _KR; _KQ++) { /*15710*/
			$k[$j++] = $get(_KP, _KQ); /*15710*/
		} /*15710*/
		for (var _KU = 0, _KV = $1.rscw; _KU < _KV; _KU++) { /*15710*/
			$k[$j++] = 0; /*15710*/
		} /*15710*/
		$1.cws = $a(); /*15710*/
		for (var _KZ = 0, _KY = $1.rscw - 1; _KZ <= _KY; _KZ += 1) { /*15714*/
			$1.i = _KZ; /*15712*/
			$put($1.cws, $1.ncws + $1.i, $get($get($1.ecbs, $1.i % $1.rsbl), ~~($1.i / $1.rsbl))); /*15713*/
		} /*15713*/
		$1.module = function() {
			var _Kk = $k[--$j]; /*15719*/
			var _Kl = $k[--$j]; /*15719*/
			var _Km = $k[--$j]; /*15719*/
			var _Kp = $strcpy($s(8), "00000000"); /*15720*/
			var _Kr = $cvrs($s(8), $k[--$j], 2); /*15720*/
			$puti(_Kp, 8 - _Kr.length, _Kr); /*15721*/
			$k[$j++] = _Km; /*15722*/
			$k[$j++] = _Kl; /*15722*/
			$k[$j++] = _Kk; /*15722*/
			$k[$j++] = _Kp; /*15722*/
			for (var _Ks = 7; _Ks >= 0; _Ks -= 1) { /*15722*/
				var _Kt = $k[--$j]; /*15722*/
				$k[$j++] = $get(_Kt, _Ks) - 48; /*15722*/
				$k[$j++] = _Kt; /*15722*/
			} /*15722*/
			$j--; /*15722*/
			var _Kv = $k[--$j]; /*15723*/
			var _Kw = $k[--$j]; /*15723*/
			var _Kx = $k[--$j]; /*15723*/
			var _Ky = $k[--$j]; /*15723*/
			var _Kz = $k[--$j]; /*15723*/
			var _L0 = $k[--$j]; /*15723*/
			var _L1 = $k[--$j]; /*15723*/
			var _L2 = $k[--$j]; /*15723*/
			var _L3 = $k[--$j]; /*15723*/
			var _L4 = $k[--$j]; /*15723*/
			var _L5 = $k[--$j]; /*15723*/
			$k[$j++] = _L2; /*15740*/
			$k[$j++] = _L1; /*15740*/
			$k[$j++] = _L0; /*15740*/
			$k[$j++] = _Kz; /*15740*/
			$k[$j++] = _Ky; /*15740*/
			$k[$j++] = _Kx; /*15740*/
			$k[$j++] = _Kw; /*15740*/
			$k[$j++] = _Kv; /*15740*/
			$k[$j++] = _L5; /*15740*/
			$k[$j++] = _L4; /*15740*/
			$forall(_L3, function() { /*15740*/
				$k[--$j](); /*15726*/
				var _L7 = $k[--$j]; /*15727*/
				var _L8 = $k[--$j]; /*15727*/
				$k[$j++] = _L8; /*15730*/
				$k[$j++] = _L7; /*15730*/
				if (_L8 < 0) { /*15730*/
					var _L9 = $k[--$j]; /*15728*/
					var _LA = $k[--$j]; /*15728*/
					$k[$j++] = _LA + $1.mrows; /*15729*/
					$k[$j++] = _L9 + (4 - (($1.mrows + 4) % 8)); /*15729*/
				} /*15729*/
				var _LD = $k[--$j]; /*15731*/
				$k[$j++] = _LD; /*15734*/
				if (_LD < 0) { /*15734*/
					var _LF = $k[--$j]; /*15732*/
					var _LG = $k[--$j]; /*15732*/
					$k[$j++] = _LG + (4 - (($1.mcols + 4) % 8)); /*15733*/
					$k[$j++] = _LF + $1.mcols; /*15733*/
				} /*15733*/
				var _LI = $k[--$j]; /*15735*/
				var _LJ = $k[--$j]; /*15735*/
				$k[$j++] = _LJ; /*15737*/
				$k[$j++] = _LI; /*15737*/
				if (_LJ >= $1.mrows) { /*15737*/
					var _LL = $k[--$j]; /*15736*/
					var _LM = $k[--$j]; /*15736*/
					$k[$j++] = _LM - $1.mrows; /*15736*/
					$k[$j++] = _LL; /*15736*/
				} /*15736*/
				var _LO = $k[--$j]; /*15738*/
				var _LP = $k[--$j]; /*15738*/
				var _LS = $k[--$j]; /*15739*/
				var _LT = $k[--$j]; /*15739*/
				$put($1.mmat, _LO + (_LP * $1.mcols), $k[--$j]); /*15739*/
				$k[$j++] = _LT; /*15739*/
				$k[$j++] = _LS; /*15739*/
			}); /*15739*/
		}; /*15741*/
		var _Ll = $a([function() {
			var _LV = $k[--$j]; /*15745*/
			var _LW = $k[--$j]; /*15745*/
			$k[$j++] = _LW; /*15745*/
			$k[$j++] = _LV; /*15745*/
			$k[$j++] = _LW - 2; /*15745*/
			$k[$j++] = _LV - 2; /*15745*/
		}, function() {
			var _LX = $k[--$j]; /*15745*/
			var _LY = $k[--$j]; /*15745*/
			$k[$j++] = _LY; /*15745*/
			$k[$j++] = _LX; /*15745*/
			$k[$j++] = _LY - 2; /*15745*/
			$k[$j++] = _LX - 1; /*15745*/
		}, function() {
			var _LZ = $k[--$j]; /*15746*/
			var _La = $k[--$j]; /*15746*/
			$k[$j++] = _La; /*15746*/
			$k[$j++] = _LZ; /*15746*/
			$k[$j++] = _La - 1; /*15746*/
			$k[$j++] = _LZ - 2; /*15746*/
		}, function() {
			var _Lb = $k[--$j]; /*15746*/
			var _Lc = $k[--$j]; /*15746*/
			$k[$j++] = _Lc; /*15746*/
			$k[$j++] = _Lb; /*15746*/
			$k[$j++] = _Lc - 1; /*15746*/
			$k[$j++] = _Lb - 1; /*15746*/
		}, function() {
			var _Ld = $k[--$j]; /*15747*/
			var _Le = $k[--$j]; /*15747*/
			$k[$j++] = _Le; /*15747*/
			$k[$j++] = _Ld; /*15747*/
			$k[$j++] = _Le - 1; /*15747*/
			$k[$j++] = _Ld; /*15747*/
		}, function() {
			var _Lf = $k[--$j]; /*15747*/
			var _Lg = $k[--$j]; /*15747*/
			$k[$j++] = _Lg; /*15747*/
			$k[$j++] = _Lf; /*15747*/
			$k[$j++] = _Lg; /*15747*/
			$k[$j++] = _Lf - 2; /*15747*/
		}, function() {
			var _Lh = $k[--$j]; /*15748*/
			var _Li = $k[--$j]; /*15748*/
			$k[$j++] = _Li; /*15748*/
			$k[$j++] = _Lh; /*15748*/
			$k[$j++] = _Li; /*15748*/
			$k[$j++] = _Lh - 1; /*15748*/
		}, function() {
			var _Lj = $k[--$j]; /*15748*/
			var _Lk = $k[--$j]; /*15748*/
			$k[$j++] = _Lk; /*15748*/
			$k[$j++] = _Lj; /*15748*/
			$k[$j++] = _Lk; /*15748*/
			$k[$j++] = _Lj; /*15748*/
		}]); /*15748*/
		$1.dmn = _Ll; /*15749*/
		var _Lu = $a([function() {
			$k[$j++] = $1.mrows - 1; /*15752*/
			$k[$j++] = 0; /*15752*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*15752*/
			$k[$j++] = 1; /*15752*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*15753*/
			$k[$j++] = 2; /*15753*/
		}, function() {
			$k[$j++] = 0; /*15753*/
			$k[$j++] = $1.mcols - 2; /*15753*/
		}, function() {
			$k[$j++] = 0; /*15754*/
			$k[$j++] = $1.mcols - 1; /*15754*/
		}, function() {
			$k[$j++] = 1; /*15754*/
			$k[$j++] = $1.mcols - 1; /*15754*/
		}, function() {
			$k[$j++] = 2; /*15755*/
			$k[$j++] = $1.mcols - 1; /*15755*/
		}, function() {
			$k[$j++] = 3; /*15755*/
			$k[$j++] = $1.mcols - 1; /*15755*/
		}]); /*15755*/
		$1.dmc1 = _Lu; /*15756*/
		var _M3 = $a([function() {
			$k[$j++] = $1.mrows - 3; /*15759*/
			$k[$j++] = 0; /*15759*/
		}, function() {
			$k[$j++] = $1.mrows - 2; /*15759*/
			$k[$j++] = 0; /*15759*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*15760*/
			$k[$j++] = 0; /*15760*/
		}, function() {
			$k[$j++] = 0; /*15760*/
			$k[$j++] = $1.mcols - 4; /*15760*/
		}, function() {
			$k[$j++] = 0; /*15761*/
			$k[$j++] = $1.mcols - 3; /*15761*/
		}, function() {
			$k[$j++] = 0; /*15761*/
			$k[$j++] = $1.mcols - 2; /*15761*/
		}, function() {
			$k[$j++] = 0; /*15762*/
			$k[$j++] = $1.mcols - 1; /*15762*/
		}, function() {
			$k[$j++] = 1; /*15762*/
			$k[$j++] = $1.mcols - 1; /*15762*/
		}]); /*15762*/
		$1.dmc2 = _M3; /*15763*/
		var _MC = $a([function() {
			$k[$j++] = $1.mrows - 3; /*15766*/
			$k[$j++] = 0; /*15766*/
		}, function() {
			$k[$j++] = $1.mrows - 2; /*15766*/
			$k[$j++] = 0; /*15766*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*15767*/
			$k[$j++] = 0; /*15767*/
		}, function() {
			$k[$j++] = 0; /*15767*/
			$k[$j++] = $1.mcols - 2; /*15767*/
		}, function() {
			$k[$j++] = 0; /*15768*/
			$k[$j++] = $1.mcols - 1; /*15768*/
		}, function() {
			$k[$j++] = 1; /*15768*/
			$k[$j++] = $1.mcols - 1; /*15768*/
		}, function() {
			$k[$j++] = 2; /*15769*/
			$k[$j++] = $1.mcols - 1; /*15769*/
		}, function() {
			$k[$j++] = 3; /*15769*/
			$k[$j++] = $1.mcols - 1; /*15769*/
		}]); /*15769*/
		$1.dmc3 = _MC; /*15770*/
		var _MM = $a([function() {
			$k[$j++] = $1.mrows - 1; /*15773*/
			$k[$j++] = 0; /*15773*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*15773*/
			$k[$j++] = $1.mcols - 1; /*15773*/
		}, function() {
			$k[$j++] = 0; /*15774*/
			$k[$j++] = $1.mcols - 3; /*15774*/
		}, function() {
			$k[$j++] = 0; /*15774*/
			$k[$j++] = $1.mcols - 2; /*15774*/
		}, function() {
			$k[$j++] = 0; /*15775*/
			$k[$j++] = $1.mcols - 1; /*15775*/
		}, function() {
			$k[$j++] = 1; /*15775*/
			$k[$j++] = $1.mcols - 3; /*15775*/
		}, function() {
			$k[$j++] = 1; /*15776*/
			$k[$j++] = $1.mcols - 2; /*15776*/
		}, function() {
			$k[$j++] = 1; /*15776*/
			$k[$j++] = $1.mcols - 1; /*15776*/
		}]); /*15776*/
		$1.dmc4 = _MM; /*15777*/
		$k[$j++] = Infinity; /*15779*/
		for (var _MP = 0, _MQ = $1.mrows * $1.mcols; _MP < _MQ; _MP++) { /*15779*/
			$k[$j++] = -1; /*15779*/
		} /*15779*/
		$1.mmat = $a(); /*15779*/
		for (var _MT = $1.cws.length - 1; _MT >= 0; _MT -= 1) { /*15780*/
			$k[$j++] = $get($1.cws, _MT); /*15780*/
		} /*15780*/
		$k[$j++] = 4; /*15820*/
		$k[$j++] = 0; /*15820*/
		for (;;) { /*15820*/
			var _MW = $k[--$j]; /*15783*/
			var _MX = $k[--$j]; /*15783*/
			$k[$j++] = _MX; /*15785*/
			$k[$j++] = _MW; /*15785*/
			if ((_MW == 0) && (_MX == $1.mrows)) { /*15785*/
				$k[$j++] = $1.dmc1; /*15784*/
				$1.module(); /*15784*/
			} /*15784*/
			var _Ma = $k[--$j]; /*15786*/
			var _Mb = $k[--$j]; /*15786*/
			$k[$j++] = _Mb; /*15788*/
			$k[$j++] = _Ma; /*15788*/
			if (((_Ma == 0) && (_Mb == ($1.mrows - 2))) && (($1.mcols % 4) != 0)) { /*15788*/
				$k[$j++] = $1.dmc2; /*15787*/
				$1.module(); /*15787*/
			} /*15787*/
			var _Mf = $k[--$j]; /*15789*/
			var _Mg = $k[--$j]; /*15789*/
			$k[$j++] = _Mg; /*15791*/
			$k[$j++] = _Mf; /*15791*/
			if (((_Mf == 0) && (_Mg == ($1.mrows - 2))) && (($1.mcols % 8) == 4)) { /*15791*/
				$k[$j++] = $1.dmc3; /*15790*/
				$1.module(); /*15790*/
			} /*15790*/
			var _Mk = $k[--$j]; /*15792*/
			var _Ml = $k[--$j]; /*15792*/
			$k[$j++] = _Ml; /*15794*/
			$k[$j++] = _Mk; /*15794*/
			if (((_Mk == 2) && (_Ml == ($1.mrows + 4))) && (($1.mcols % 8) == 0)) { /*15794*/
				$k[$j++] = $1.dmc4; /*15793*/
				$1.module(); /*15793*/
			} /*15793*/
			for (;;) { /*15804*/
				var _Mp = $k[--$j]; /*15797*/
				var _Mq = $k[--$j]; /*15797*/
				$k[$j++] = _Mq; /*15801*/
				$k[$j++] = _Mp; /*15801*/
				if ((_Mp >= 0) && (_Mq < $1.mrows)) { /*15801*/
					var _Ms = $k[--$j]; /*15798*/
					var _Mt = $k[--$j]; /*15798*/
					$k[$j++] = _Mt; /*15800*/
					$k[$j++] = _Ms; /*15800*/
					if ($get($1.mmat, _Ms + (_Mt * $1.mcols)) == -1) { /*15800*/
						$k[$j++] = $1.dmn; /*15799*/
						$1.module(); /*15799*/
					} /*15799*/
				} /*15799*/
				var _My = $k[--$j]; /*15802*/
				var _Mz = $k[--$j]; /*15802*/
				$k[$j++] = _Mz - 2; /*15803*/
				$k[$j++] = _My + 2; /*15803*/
				if (!(((_My + 2) < $1.mcols) && ((_Mz - 2) >= 0))) { /*15803*/
					break; /*15803*/
				} /*15803*/
			} /*15803*/
			var _N1 = $k[--$j]; /*15805*/
			var _N2 = $k[--$j]; /*15805*/
			$k[$j++] = _N2 + 1; /*15815*/
			$k[$j++] = _N1 + 3; /*15815*/
			for (;;) { /*15815*/
				var _N3 = $k[--$j]; /*15808*/
				var _N4 = $k[--$j]; /*15808*/
				$k[$j++] = _N4; /*15812*/
				$k[$j++] = _N3; /*15812*/
				if ((_N3 < $1.mcols) && (_N4 >= 0)) { /*15812*/
					var _N6 = $k[--$j]; /*15809*/
					var _N7 = $k[--$j]; /*15809*/
					$k[$j++] = _N7; /*15811*/
					$k[$j++] = _N6; /*15811*/
					if ($get($1.mmat, _N6 + (_N7 * $1.mcols)) == -1) { /*15811*/
						$k[$j++] = $1.dmn; /*15810*/
						$1.module(); /*15810*/
					} /*15810*/
				} /*15810*/
				var _NC = $k[--$j]; /*15813*/
				var _ND = $k[--$j]; /*15813*/
				$k[$j++] = _ND + 2; /*15814*/
				$k[$j++] = _NC - 2; /*15814*/
				if (!(((_NC - 2) >= 0) && ((_ND + 2) < $1.mrows))) { /*15814*/
					break; /*15814*/
				} /*15814*/
			} /*15814*/
			var _NF = $k[--$j]; /*15816*/
			var _NG = $k[--$j]; /*15816*/
			$k[$j++] = _NG + 3; /*15818*/
			$k[$j++] = _NF + 1; /*15818*/
			if (!(((_NF + 1) < $1.mcols) || ((_NG + 3) < $1.mrows))) { /*15818*/
				$j -= 2; /*15818*/
				break; /*15818*/
			} /*15818*/
		} /*15818*/
		if ($get($1.mmat, ($1.mrows * $1.mcols) - 1) == -1) { /*15826*/
			$puti($1.mmat, ($1.mrows * ($1.mcols - 1)) - 2, $a([1, 0])); /*15824*/
			$puti($1.mmat, ($1.mrows * $1.mcols) - 2, $a([0, 1])); /*15825*/
		} /*15825*/
		$1.pixs = $a($1.rows * $1.cols); /*15829*/
		$1.cwpos = 0; /*15830*/
		for (var _Na = 0, _NZ = $1.rows - 1; _Na <= _NZ; _Na += 1) { /*15846*/
			$1.i = _Na; /*15832*/
			if (($1.i % ($1.rrows + 2)) == 0) { /*15833*/
				$k[$j++] = $1.pixs; /*15833*/
				$k[$j++] = $1.i * $1.cols; /*15833*/
				$k[$j++] = Infinity; /*15833*/
				for (var _Nh = 0, _Ni = ~~($1.cols / 2); _Nh < _Ni; _Nh++) { /*15833*/
					$k[$j++] = 1; /*15833*/
					$k[$j++] = 0; /*15833*/
				} /*15833*/
				var _Nj = $a(); /*15833*/
				var _Nk = $k[--$j]; /*15833*/
				$puti($k[--$j], _Nk, _Nj); /*15833*/
			} /*15833*/
			if (($1.i % ($1.rrows + 2)) == ($1.rrows + 1)) { /*15834*/
				$k[$j++] = $1.pixs; /*15834*/
				$k[$j++] = $1.i * $1.cols; /*15834*/
				$k[$j++] = Infinity; /*15834*/
				for (var _Nt = 0, _Nu = $1.cols; _Nt < _Nu; _Nt++) { /*15834*/
					$k[$j++] = 1; /*15834*/
				} /*15834*/
				var _Nv = $a(); /*15834*/
				var _Nw = $k[--$j]; /*15834*/
				$puti($k[--$j], _Nw, _Nv); /*15834*/
			} /*15834*/
			if ((($1.i % ($1.rrows + 2)) != 0) && (($1.i % ($1.rrows + 2)) != ($1.rrows + 1))) { /*15845*/
				for (var _O5 = 0, _O4 = $1.cols - 1; _O5 <= _O4; _O5 += 1) { /*15844*/
					$1.j = _O5; /*15837*/
					if (($1.j % ($1.rcols + 2)) == 0) { /*15838*/
						$put($1.pixs, ($1.i * $1.cols) + $1.j, 1); /*15838*/
					} /*15838*/
					if (($1.j % ($1.rcols + 2)) == ($1.rcols + 1)) { /*15839*/
						$put($1.pixs, ($1.i * $1.cols) + $1.j, $1.i % 2); /*15839*/
					} /*15839*/
					if ((($1.j % ($1.rcols + 2)) != 0) && (($1.j % ($1.rcols + 2)) != ($1.rcols + 1))) { /*15843*/
						$put($1.pixs, ($1.i * $1.cols) + $1.j, $get($1.mmat, $1.cwpos)); /*15841*/
						$1.cwpos = $1.cwpos + 1; /*15842*/
					} /*15842*/
				} /*15842*/
			} /*15842*/
		} /*15842*/
		var _Od = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.cols,
			pixy: $1.rows,
			height: ($1.rows * 2) / 72,
			width: ($1.cols * 2) / 72,
			opt: $1.options
		}; /*15856*/
		$k[$j++] = _Od; /*15859*/
		if (!$1.dontdraw) { /*15859*/
			$0.renmatrix(); /*15859*/
		} /*15859*/
	};
	$0.datamatrixrectangular = function() {
		var $1 = {}; /*15887*/
		$1.options = $k[--$j]; /*15889*/
		$1.barcode = $k[--$j]; /*15890*/
		$1.dontdraw = false; /*15892*/
		$forall($1.options, function() { /*15903*/
			var _3 = $k[--$j]; /*15903*/
			$1[$k[--$j]] = _3; /*15903*/
		}); /*15903*/
		$1.options.dontdraw = true; /*15906*/
		$1.options.format = "rectangle"; /*15907*/
		$k[$j++] = "args"; /*15909*/
		$k[$j++] = $1.barcode; /*15909*/
		$k[$j++] = $1.options; /*15909*/
		$0.datamatrix(); /*15909*/
		var _9 = $k[--$j]; /*15909*/
		$1[$k[--$j]] = _9; /*15909*/
		$1.args.opt = $1.options; /*15911*/
		$k[$j++] = $1.args; /*15914*/
		if (!$1.dontdraw) { /*15914*/
			$0.renmatrix(); /*15914*/
		} /*15914*/
	};
	$0.qrcode = function() {
		var $1 = {}; /*15941*/
		$1.options = $k[--$j]; /*15943*/
		$1.barcode = $k[--$j]; /*15944*/
		$1.dontdraw = false; /*15946*/
		$1.format = "full"; /*15947*/
		$1.version = "unset"; /*15948*/
		$1.eclevel = "unset"; /*15949*/
		$1.parse = false; /*15950*/
		$1.parsefnc = false; /*15951*/
		$1.mask = -1; /*15952*/
		$forall($1.options, function() { /*15963*/
			var _3 = $k[--$j]; /*15963*/
			$1[$k[--$j]] = _3; /*15963*/
		}); /*15963*/
		$1.mask = ~~$1.mask; /*15965*/
		$1.barlen = $1.barcode.length; /*15988*/
		$1.fn1 = -1; /*15991*/
		var _8 = {
			FNC1: $1.fn1
		}; /*15993*/
		$1.fncvals = _8; /*15994*/
		$1.msg = $a($1.barlen); /*15995*/
		$1.i = 0; /*15996*/
		$1.j = 0; /*15996*/
		for (;;) { /*16010*/
			if ($1.i == $1.barlen) { /*15997*/
				break; /*15997*/
			} /*15997*/
			$1.char = $get($1.barcode, $1.i); /*15998*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*16006*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*16004*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*16001*/
					$1.i = $1.i + 4; /*16002*/
				} else { /*16004*/
					$1.i = $1.i + 1; /*16004*/
				} /*16004*/
			} /*16004*/
			$put($1.msg, $1.j, $1.char); /*16007*/
			$1.i = $1.i + 1; /*16008*/
			$1.j = $1.j + 1; /*16009*/
		} /*16009*/
		$1.msg = $geti($1.msg, 0, $1.j); /*16011*/
		$1.msglen = $1.msg.length; /*16012*/
		$1.fnc1first = false; /*16015*/
		if ($1.msglen > 0) { /*16022*/
			if ($get($1.msg, 0) == $1.fn1) { /*16021*/
				$1.fnc1first = true; /*16018*/
				$k[$j++] = Infinity; /*16019*/
				$forall($geti($1.msg, 1, $1.msglen - 1), function() { /*16019*/
					var _k = $k[--$j]; /*16019*/
					$k[$j++] = _k; /*16019*/
					if (_k == 37) { /*16019*/
						var _l = $k[--$j]; /*16019*/
						$k[$j++] = _l; /*16019*/
						$k[$j++] = _l; /*16019*/
					} /*16019*/
				}); /*16019*/
				$1.msg = $a(); /*16019*/
				$1.msglen = $1.msg.length; /*16020*/
			} /*16020*/
		} /*16020*/
		if ($eq($1.eclevel, "unset")) { /*16025*/
			$k[$j++] = "eclevel"; /*16025*/
			if ($eq($1.format, "full")) { /*16025*/
				$k[$j++] = "M"; /*16025*/
			} else { /*16025*/
				$k[$j++] = "L"; /*16025*/
			} /*16025*/
			var _q = $k[--$j]; /*16025*/
			$1[$k[--$j]] = _q; /*16025*/
		} /*16025*/
		$1.N = 0; /*16028*/
		$1.A = 1; /*16028*/
		$1.B = 2; /*16028*/
		$1.K = 3; /*16028*/
		$k[$j++] = "Nexcl"; /*16033*/
		$k[$j++] = Infinity; /*16033*/
		$k[$j++] = Infinity; /*16032*/
		for (var _s = 48; _s <= 57; _s += 1) { /*16032*/
			$k[$j++] = _s; /*16032*/
		} /*16032*/
		var _t = $a(); /*16032*/
		for (var _u = 0, _v = _t.length; _u < _v; _u++) { /*16033*/
			$k[$j++] = $get(_t, _u); /*16033*/
			$k[$j++] = -1; /*16033*/
		} /*16033*/
		var _x = $d(); /*16033*/
		$1[$k[--$j]] = _x; /*16034*/
		$k[$j++] = "Aexcl"; /*16040*/
		$k[$j++] = Infinity; /*16040*/
		$k[$j++] = Infinity; /*16039*/
		$k[$j++] = 32; /*16039*/
		$k[$j++] = 36; /*16039*/
		$k[$j++] = 37; /*16039*/
		$k[$j++] = 42; /*16039*/
		$k[$j++] = 43; /*16039*/
		$k[$j++] = 45; /*16039*/
		$k[$j++] = 46; /*16039*/
		$k[$j++] = 47; /*16039*/
		$k[$j++] = 58; /*16039*/
		for (var _z = 65; _z <= 90; _z += 1) { /*16039*/
			$k[$j++] = _z; /*16039*/
		} /*16039*/
		var _10 = $a(); /*16039*/
		for (var _11 = 0, _12 = _10.length; _11 < _12; _11++) { /*16040*/
			$k[$j++] = $get(_10, _11); /*16040*/
			$k[$j++] = -1; /*16040*/
		} /*16040*/
		var _14 = $d(); /*16040*/
		$1[$k[--$j]] = _14; /*16041*/
		$k[$j++] = "Bexcl"; /*16050*/
		$k[$j++] = Infinity; /*16050*/
		$k[$j++] = Infinity; /*16049*/
		for (var _16 = 0; _16 <= 31; _16 += 1) { /*16045*/
			$k[$j++] = _16; /*16045*/
		} /*16045*/
		$k[$j++] = 33; /*16047*/
		$k[$j++] = 34; /*16047*/
		$k[$j++] = 35; /*16047*/
		$k[$j++] = 38; /*16047*/
		$k[$j++] = 39; /*16047*/
		$k[$j++] = 40; /*16047*/
		$k[$j++] = 41; /*16047*/
		$k[$j++] = 44; /*16047*/
		for (var _17 = 59; _17 <= 64; _17 += 1) { /*16047*/
			$k[$j++] = _17; /*16047*/
		} /*16047*/
		for (var _18 = 91; _18 <= 127; _18 += 1) { /*16048*/
			$k[$j++] = _18; /*16048*/
		} /*16048*/
		for (var _19 = 160; _19 <= 223; _19 += 1) { /*16049*/
			$k[$j++] = _19; /*16049*/
		} /*16049*/
		var _1A = $a(); /*16049*/
		for (var _1B = 0, _1C = _1A.length; _1B < _1C; _1B++) { /*16050*/
			$k[$j++] = $get(_1A, _1B); /*16050*/
			$k[$j++] = -1; /*16050*/
		} /*16050*/
		var _1E = $d(); /*16050*/
		$1[$k[--$j]] = _1E; /*16051*/
		$k[$j++] = "Kexcl"; /*16057*/
		$k[$j++] = Infinity; /*16057*/
		$k[$j++] = Infinity; /*16056*/
		for (var _1G = 129; _1G <= 159; _1G += 1) { /*16055*/
			$k[$j++] = _1G; /*16055*/
		} /*16055*/
		for (var _1H = 224; _1H <= 235; _1H += 1) { /*16056*/
			$k[$j++] = _1H; /*16056*/
		} /*16056*/
		var _1I = $a(); /*16056*/
		for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*16057*/
			$k[$j++] = $get(_1I, _1J); /*16057*/
			$k[$j++] = -1; /*16057*/
		} /*16057*/
		var _1M = $d(); /*16057*/
		$1[$k[--$j]] = _1M; /*16058*/
		$1.mids = $a([$a(["0001", "0010", "0100", "1000"]), $a(["0001", "0010", "0100", "1000"]), $a(["0001", "0010", "0100", "1000"]), $a(["", -1, -1, -1]), $a(["0", "1", -1, -1]), $a(["00", "01", "10", "11"]), $a(["000", "001", "010", "011"])]); /*16068*/
		$1.cclens = $a([$a([10, 9, 8, 8]), $a([12, 11, 16, 10]), $a([14, 13, 16, 12]), $a([3, -1, -1, -1]), $a([4, 3, -1, -1]), $a([5, 4, 4, 3]), $a([6, 5, 5, 4])]); /*16078*/
		$1.termlens = $a([4, 4, 4, 3, 5, 7, 9]); /*16080*/
		$1.tobin = function() {
			var _1g = $s($k[--$j]); /*16084*/
			$k[$j++] = _1g; /*16084*/
			for (var _1i = 0, _1h = _1g.length - 1; _1i <= _1h; _1i += 1) { /*16084*/
				var _1j = $k[--$j]; /*16084*/
				$put(_1j, _1i, 48); /*16084*/
				$k[$j++] = _1j; /*16084*/
			} /*16084*/
			var _1k = $k[--$j]; /*16085*/
			var _1n = $cvrs($s(_1k.length), $k[--$j], 2); /*16085*/
			$puti(_1k, _1k.length - _1n.length, _1n); /*16085*/
			$k[$j++] = _1k; /*16085*/
		}; /*16086*/
		$1.charmap = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:"; /*16089*/
		$1.charvals = {}; /*16090*/
		for (var _1o = 0; _1o <= 44; _1o += 1) { /*16091*/
			$put($1.charvals, $get($1.charmap, _1o), _1o); /*16091*/
		} /*16091*/
		$1.encA = function() {
			$1.in = $k[--$j]; /*16094*/
			if ($1.fnc1first) { /*16097*/
				$k[$j++] = Infinity; /*16096*/
				$forall($1.in, function() { /*16096*/
					var _1v = $k[--$j]; /*16096*/
					$k[$j++] = _1v; /*16096*/
					if (_1v == -1) { /*16096*/
						$j--; /*16096*/
						$k[$j++] = 37; /*16096*/
					} /*16096*/
				}); /*16096*/
				$1.in = $a(); /*16096*/
			} /*16096*/
			$1.out = $s((~~(($1.in.length * 11) / 2)) + 1); /*16098*/
			$1.k = 0; /*16099*/
			$1.m = 0; /*16099*/
			for (;;) { /*16110*/
				if ($1.k == $1.in.length) { /*16100*/
					break; /*16100*/
				} /*16100*/
				if ($1.k < ($1.in.length - 1)) { /*16106*/
					$k[$j++] = ($get($1.charvals, $get($1.in, $1.k)) * 45) + $get($1.charvals, $get($1.in, $1.k + 1)); /*16102*/
					$k[$j++] = 11; /*16102*/
					$1.tobin(); /*16102*/
					$1.k = $1.k + 2; /*16103*/
				} else { /*16106*/
					$k[$j++] = $get($1.charvals, $get($1.in, $1.k)); /*16105*/
					$k[$j++] = 6; /*16105*/
					$1.tobin(); /*16105*/
					$1.k = $1.k + 1; /*16106*/
				} /*16106*/
				var _2K = $k[--$j]; /*16108*/
				$puti($1.out, $1.m, _2K); /*16108*/
				$1.m = _2K.length + $1.m; /*16109*/
			} /*16109*/
			$k[$j++] = $geti($1.out, 0, $1.m); /*16111*/
		}; /*16112*/
		$1.encN = function() {
			$1.in = $k[--$j]; /*16115*/
			$1.out = $s((~~(($1.in.length * 10) / 3)) + 1); /*16116*/
			$1.k = 0; /*16117*/
			$1.m = 0; /*16117*/
			for (;;) { /*16133*/
				if ($1.k == $1.in.length) { /*16118*/
					break; /*16118*/
				} /*16118*/
				if ($1.k < ($1.in.length - 2)) { /*16128*/
					$k[$j++] = 0; /*16120*/
					$forall($geti($1.in, $1.k, 3), function() { /*16120*/
						var _2b = $k[--$j]; /*16120*/
						var _2c = $k[--$j]; /*16120*/
						$k[$j++] = _2b + ((_2c * 10) - 48); /*16120*/
					}); /*16120*/
					$k[$j++] = 10; /*16120*/
					$1.tobin(); /*16120*/
					$1.k = $1.k + 3; /*16121*/
				} else { /*16128*/
					if ($1.k == ($1.in.length - 2)) { /*16128*/
						$k[$j++] = 0; /*16124*/
						$forall($geti($1.in, $1.k, 2), function() { /*16124*/
							var _2j = $k[--$j]; /*16124*/
							var _2k = $k[--$j]; /*16124*/
							$k[$j++] = _2j + ((_2k * 10) - 48); /*16124*/
						}); /*16124*/
						$k[$j++] = 7; /*16124*/
						$1.tobin(); /*16124*/
						$1.k = $1.k + 2; /*16125*/
					} else { /*16128*/
						$k[$j++] = 0; /*16127*/
						$forall($geti($1.in, $1.k, 1), function() { /*16127*/
							var _2p = $k[--$j]; /*16127*/
							var _2q = $k[--$j]; /*16127*/
							$k[$j++] = _2p + ((_2q * 10) - 48); /*16127*/
						}); /*16127*/
						$k[$j++] = 4; /*16127*/
						$1.tobin(); /*16127*/
						$1.k = $1.k + 1; /*16128*/
					} /*16128*/
				} /*16128*/
				var _2s = $k[--$j]; /*16131*/
				$puti($1.out, $1.m, _2s); /*16131*/
				$1.m = _2s.length + $1.m; /*16132*/
			} /*16132*/
			$k[$j++] = $geti($1.out, 0, $1.m); /*16134*/
		}; /*16135*/
		$1.encB = function() {
			$1.in = $k[--$j]; /*16138*/
			if ($1.fnc1first) { /*16141*/
				$k[$j++] = Infinity; /*16140*/
				$forall($1.in, function() { /*16140*/
					var _32 = $k[--$j]; /*16140*/
					$k[$j++] = _32; /*16140*/
					if (_32 == -1) { /*16140*/
						$j--; /*16140*/
						$k[$j++] = 29; /*16140*/
					} /*16140*/
				}); /*16140*/
				$1.in = $a(); /*16140*/
			} /*16140*/
			$1.out = $s($1.in.length * 8); /*16142*/
			for (var _38 = 0, _37 = $1.in.length - 1; _38 <= _37; _38 += 1) { /*16147*/
				$1.k = _38; /*16144*/
				$k[$j++] = ~~$z($get($1.in, $1.k)); /*16145*/
				$k[$j++] = 8; /*16145*/
				$1.tobin(); /*16145*/
				$puti($1.out, $1.k * 8, $k[--$j]); /*16146*/
			} /*16146*/
			$k[$j++] = $1.out; /*16148*/
		}; /*16149*/
		$1.encK = function() {
			$1.in = $k[--$j]; /*16152*/
			$1.out = $s((~~($1.in.length / 2)) * 13); /*16153*/
			$1.k = 0; /*16154*/
			$1.m = 0; /*16154*/
			for (;;) { /*16162*/
				if ($1.k == $1.in.length) { /*16155*/
					break; /*16155*/
				} /*16155*/
				var _3R = ($get($1.in, $1.k) * 256) + $get($1.in, $1.k + 1); /*16157*/
				$k[$j++] = _3R; /*16157*/
				if (_3R < 57408) { /*16157*/
					$k[$j++] = 33088; /*16157*/
				} else { /*16157*/
					$k[$j++] = 49472; /*16157*/
				} /*16157*/
				var _3S = $k[--$j]; /*16157*/
				var _3U = $k[--$j] - _3S; /*16158*/
				$k[$j++] = ((_3U >>> 8) * 192) + (_3U & 255); /*16159*/
				$k[$j++] = 13; /*16159*/
				$1.tobin(); /*16159*/
				var _3V = $k[--$j]; /*16159*/
				$puti($1.out, $1.m, _3V); /*16159*/
				$1.m = _3V.length + $1.m; /*16160*/
				$1.k = $1.k + 2; /*16161*/
			} /*16161*/
			$k[$j++] = $1.out; /*16163*/
		}; /*16164*/
		$1.encfuncs = $a(["encN", "encA", "encB", "encK"]); /*16166*/
		$1.addtobits = function() {
			var _3c = $k[--$j]; /*16169*/
			$puti($1.bits, $1.j, _3c); /*16169*/
			$1.j = _3c.length + $1.j; /*16170*/
		}; /*16171*/
		$k[$j++] = Infinity; /*16173*/
		for (var _3h = 0, _3i = $1.msglen; _3h < _3i; _3h++) { /*16173*/
			$k[$j++] = 0; /*16173*/
		} /*16173*/
		$k[$j++] = 0; /*16173*/
		$1.numNs = $a(); /*16173*/
		$k[$j++] = Infinity; /*16174*/
		for (var _3l = 0, _3m = $1.msglen; _3l < _3m; _3l++) { /*16174*/
			$k[$j++] = 0; /*16174*/
		} /*16174*/
		$k[$j++] = 0; /*16174*/
		$1.numAs = $a(); /*16174*/
		$k[$j++] = Infinity; /*16175*/
		for (var _3p = 0, _3q = $1.msglen; _3p < _3q; _3p++) { /*16175*/
			$k[$j++] = 0; /*16175*/
		} /*16175*/
		$k[$j++] = 0; /*16175*/
		$1.numBs = $a(); /*16175*/
		$k[$j++] = Infinity; /*16176*/
		for (var _3t = 0, _3u = $1.msglen; _3t < _3u; _3t++) { /*16176*/
			$k[$j++] = 0; /*16176*/
		} /*16176*/
		$k[$j++] = -1; /*16176*/
		$1.numKs = $a(); /*16176*/
		$k[$j++] = Infinity; /*16177*/
		for (var _3x = 0, _3y = $1.msglen; _3x < _3y; _3x++) { /*16177*/
			$k[$j++] = 0; /*16177*/
		} /*16177*/
		$k[$j++] = 9999; /*16177*/
		$1.nextNs = $a(); /*16177*/
		$k[$j++] = Infinity; /*16178*/
		for (var _41 = 0, _42 = $1.msglen; _41 < _42; _41++) { /*16178*/
			$k[$j++] = 0; /*16178*/
		} /*16178*/
		$k[$j++] = 9999; /*16178*/
		$1.nextBs = $a(); /*16178*/
		$k[$j++] = Infinity; /*16179*/
		for (var _45 = 0, _46 = $1.msglen; _45 < _46; _45++) { /*16179*/
			$k[$j++] = 0; /*16179*/
		} /*16179*/
		$k[$j++] = 9999; /*16179*/
		$1.nextAs = $a(); /*16179*/
		$k[$j++] = Infinity; /*16180*/
		for (var _49 = 0, _4A = $1.msglen; _49 < _4A; _49++) { /*16180*/
			$k[$j++] = 0; /*16180*/
		} /*16180*/
		$k[$j++] = 9999; /*16180*/
		$1.nextKs = $a(); /*16180*/
		for (var _4D = $1.msglen - 1; _4D >= 0; _4D -= 1) { /*16208*/
			$1.i = _4D; /*16182*/
			$1.barchar = $get($1.msg, $1.i); /*16183*/
			var _4J = $get($1.Kexcl, $1.barchar) !== undefined; /*16184*/
			if (_4J) { /*16188*/
				$put($1.nextKs, $1.i, 0); /*16185*/
				$put($1.numKs, $1.i, $get($1.numKs, $1.i + 1) + 1); /*16186*/
			} else { /*16188*/
				$put($1.nextKs, $1.i, $get($1.nextKs, $1.i + 1) + 1); /*16188*/
			} /*16188*/
			var _4Y = $get($1.Nexcl, $1.barchar) !== undefined; /*16190*/
			if (_4Y) { /*16194*/
				$put($1.nextNs, $1.i, 0); /*16191*/
				$put($1.numNs, $1.i, $get($1.numNs, $1.i + 1) + 1); /*16192*/
			} else { /*16194*/
				$put($1.nextNs, $1.i, $get($1.nextNs, $1.i + 1) + 1); /*16194*/
			} /*16194*/
			var _4n = $get($1.Bexcl, $1.barchar) !== undefined; /*16196*/
			if (_4n) { /*16200*/
				$put($1.nextBs, $1.i, 0); /*16197*/
				$put($1.numBs, $1.i, $get($1.numBs, $1.i + 1) + 1); /*16198*/
			} else { /*16200*/
				$put($1.nextBs, $1.i, $get($1.nextBs, $1.i + 1) + 1); /*16200*/
			} /*16200*/
			var _52 = $get($1.Aexcl, $1.barchar) !== undefined; /*16202*/
			if (_52) { /*16206*/
				$put($1.nextAs, $1.i, 0); /*16203*/
				$put($1.numAs, $1.i, $get($1.numAs, $1.i + 1) + 1); /*16204*/
			} else { /*16206*/
				$put($1.nextAs, $1.i, $get($1.nextAs, $1.i + 1) + 1); /*16206*/
			} /*16206*/
		} /*16206*/
		$k[$j++] = Infinity; /*16209*/
		var _5F = $1.numKs; /*16209*/
		for (var _5G = 0, _5H = _5F.length; _5G < _5H; _5G++) { /*16209*/
			$k[$j++] = ~~(($get(_5F, _5G) + 1) / 2); /*16209*/
		} /*16209*/
		$1.numKs = $a(); /*16209*/
		$1.KbeforeB = function() {
			var _5N = $get($k[--$j], $1.ver); /*16211*/
			$k[$j++] = $ge($1.numK, _5N) && ($get($1.nextBs, ($1.numK * 2) + $1.i) == 0); /*16211*/
		}; /*16211*/
		$1.KbeforeA = function() {
			var _5V = $get($k[--$j], $1.ver); /*16212*/
			$k[$j++] = $ge($1.numK, _5V) && ($get($1.nextAs, ($1.numK * 2) + $1.i) == 0); /*16212*/
		}; /*16212*/
		$1.KbeforeN = function() {
			var _5d = $get($k[--$j], $1.ver); /*16213*/
			$k[$j++] = $ge($1.numK, _5d) && ($get($1.nextNs, ($1.numK * 2) + $1.i) == 0); /*16213*/
		}; /*16213*/
		$1.KbeforeE = function() {
			var _5l = $get($k[--$j], $1.ver); /*16214*/
			$k[$j++] = $ge($1.numK, _5l) && ((($1.numK * 2) + $1.i) == $1.msglen); /*16214*/
		}; /*16214*/
		$1.AbeforeK = function() {
			var _5s = $get($k[--$j], $1.ver); /*16215*/
			$k[$j++] = $ge($1.numA, _5s) && ($get($1.nextKs, $1.numA + $1.i) == 0); /*16215*/
		}; /*16215*/
		$1.AbeforeB = function() {
			var _60 = $get($k[--$j], $1.ver); /*16216*/
			$k[$j++] = $ge($1.numA, _60) && ($get($1.nextBs, $1.numA + $1.i) == 0); /*16216*/
		}; /*16216*/
		$1.AbeforeN = function() {
			var _68 = $get($k[--$j], $1.ver); /*16217*/
			$k[$j++] = $ge($1.numA, _68) && ($get($1.nextNs, $1.numA + $1.i) == 0); /*16217*/
		}; /*16217*/
		$1.AbeforeE = function() {
			var _6G = $get($k[--$j], $1.ver); /*16218*/
			$k[$j++] = $ge($1.numA, _6G) && (($1.numA + $1.i) == $1.msglen); /*16218*/
		}; /*16218*/
		$1.NbeforeK = function() {
			var _6N = $get($k[--$j], $1.ver); /*16219*/
			$k[$j++] = $ge($1.numN, _6N) && ($get($1.nextKs, $1.numN + $1.i) == 0); /*16219*/
		}; /*16219*/
		$1.NbeforeB = function() {
			var _6V = $get($k[--$j], $1.ver); /*16220*/
			$k[$j++] = $ge($1.numN, _6V) && ($get($1.nextBs, $1.numN + $1.i) == 0); /*16220*/
		}; /*16220*/
		$1.NbeforeA = function() {
			var _6d = $get($k[--$j], $1.ver); /*16221*/
			$k[$j++] = $ge($1.numN, _6d) && ($get($1.nextAs, $1.numN + $1.i) == 0); /*16221*/
		}; /*16221*/
		$1.NbeforeE = function() {
			var _6l = $get($k[--$j], $1.ver); /*16222*/
			$k[$j++] = $ge($1.numN, _6l) && (($1.numN + $1.i) == $1.msglen); /*16222*/
		}; /*16222*/
		$1.msgbits = $a([-1, -1, -1, -1, -1, -1, -1]); /*16225*/
		$1.v1to9 = 0; /*16226*/
		$1.v10to26 = 1; /*16226*/
		$1.v27to40 = 2; /*16226*/
		$1.vM1 = 3; /*16226*/
		$1.vM2 = 4; /*16226*/
		$1.vM3 = 5; /*16226*/
		$1.vM4 = 6; /*16226*/
		$1.e = 10000; /*16227*/
		var _6x = $a([$1.v1to9, $1.v10to26, $1.v27to40, $1.vM1, $1.vM2, $1.vM3, $1.vM4]); /*16228*/
		for (var _6y = 0, _6z = _6x.length; _6y < _6z; _6y++) { /*16345*/
			$1.ver = $get(_6x, _6y); /*16229*/
			$1.mode = -1; /*16232*/
			$1.seq = $a([]); /*16232*/
			$1.i = 0; /*16232*/
			for (;;) { /*16319*/
				if ($1.i >= $1.msglen) { /*16233*/
					break; /*16233*/
				} /*16233*/
				$1.numK = $get($1.numKs, $1.i); /*16234*/
				$1.numB = $get($1.numBs, $1.i); /*16235*/
				$1.numA = $get($1.numAs, $1.i); /*16236*/
				$1.numN = $get($1.numNs, $1.i); /*16237*/
				if (($1.ver == $1.vM1) && ($1.numA >= 1)) { /*16238*/
					$1.seq = -1; /*16238*/
					break; /*16238*/
				} /*16238*/
				if (($1.ver == $1.vM1) && ($1.numB >= 1)) { /*16239*/
					$1.seq = -1; /*16239*/
					break; /*16239*/
				} /*16239*/
				if (($1.ver == $1.vM1) && ($1.numK >= 1)) { /*16240*/
					$1.seq = -1; /*16240*/
					break; /*16240*/
				} /*16240*/
				if (($1.ver == $1.vM2) && ($1.numB >= 1)) { /*16241*/
					$1.seq = -1; /*16241*/
					break; /*16241*/
				} /*16241*/
				if (($1.ver == $1.vM2) && ($1.numK >= 1)) { /*16242*/
					$1.seq = -1; /*16242*/
					break; /*16242*/
				} /*16242*/
				for (;;) { /*16300*/
					if ($1.mode == -1) { /*16261*/
						$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16245*/
						$1.KbeforeA(); /*16245*/
						if ($k[--$j]) { /*16245*/
							$k[$j++] = $1.K; /*16245*/
							break; /*16245*/
						} /*16245*/
						$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16246*/
						$1.KbeforeN(); /*16246*/
						if ($k[--$j]) { /*16246*/
							$k[$j++] = $1.K; /*16246*/
							break; /*16246*/
						} /*16246*/
						$k[$j++] = $a([5, 5, 6, $1.e, $1.e, 2, 3]); /*16247*/
						$1.KbeforeB(); /*16247*/
						if ($k[--$j]) { /*16247*/
							$k[$j++] = $1.K; /*16247*/
							break; /*16247*/
						} /*16247*/
						$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16248*/
						$1.KbeforeE(); /*16248*/
						if ($k[--$j]) { /*16248*/
							$k[$j++] = $1.K; /*16248*/
							break; /*16248*/
						} /*16248*/
						if ($1.numK >= 1) { /*16249*/
							$k[$j++] = $1.B; /*16249*/
							break; /*16249*/
						} /*16249*/
						$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16250*/
						$1.AbeforeB(); /*16250*/
						if ($k[--$j]) { /*16250*/
							$k[$j++] = $1.A; /*16250*/
							break; /*16250*/
						} /*16250*/
						$k[$j++] = $a([1, 1, 1, $1.e, 1, 1, 1]); /*16251*/
						$1.AbeforeE(); /*16251*/
						if ($k[--$j]) { /*16251*/
							$k[$j++] = $1.A; /*16251*/
							break; /*16251*/
						} /*16251*/
						if ($1.numA >= 1) { /*16254*/
							if (($1.ver != $1.vM1) && ($1.ver != $1.vM2)) { /*16253*/
								$k[$j++] = $1.B; /*16253*/
							} else { /*16253*/
								$k[$j++] = $1.A; /*16253*/
							} /*16253*/
							break; /*16253*/
						} /*16253*/
						$k[$j++] = $a([4, 4, 5, $1.e, $1.e, 2, 3]); /*16255*/
						$1.NbeforeB(); /*16255*/
						if ($k[--$j]) { /*16255*/
							$k[$j++] = $1.N; /*16255*/
							break; /*16255*/
						} /*16255*/
						$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16256*/
						$1.NbeforeB(); /*16256*/
						if ($k[--$j]) { /*16256*/
							$k[$j++] = $1.B; /*16256*/
							break; /*16256*/
						} /*16256*/
						$k[$j++] = $a([7, 8, 9, $1.e, 3, 4, 5]); /*16257*/
						$1.NbeforeA(); /*16257*/
						if ($k[--$j]) { /*16257*/
							$k[$j++] = $1.N; /*16257*/
							break; /*16257*/
						} /*16257*/
						$k[$j++] = $a([1, 1, 1, $1.e, 1, 1, 1]); /*16258*/
						$1.NbeforeA(); /*16258*/
						if ($k[--$j]) { /*16258*/
							$k[$j++] = $1.A; /*16258*/
							break; /*16258*/
						} /*16258*/
						if ($1.numN >= 1) { /*16259*/
							$k[$j++] = $1.N; /*16259*/
							break; /*16259*/
						} /*16259*/
						$k[$j++] = $1.B; /*16260*/
						break; /*16260*/
					} /*16260*/
					if ($1.mode == $1.B) { /*16276*/
						$k[$j++] = $a([9, 12, 13, $1.e, $1.e, 4, 5]); /*16263*/
						$1.KbeforeB(); /*16263*/
						if ($k[--$j]) { /*16263*/
							$k[$j++] = $1.K; /*16263*/
							break; /*16263*/
						} /*16263*/
						$k[$j++] = $a([9, 10, 12, $1.e, $1.e, 4, 5]); /*16264*/
						$1.KbeforeA(); /*16264*/
						if ($k[--$j]) { /*16264*/
							$k[$j++] = $1.K; /*16264*/
							break; /*16264*/
						} /*16264*/
						$k[$j++] = $a([9, 10, 11, $1.e, $1.e, 5, 6]); /*16265*/
						$1.KbeforeN(); /*16265*/
						if ($k[--$j]) { /*16265*/
							$k[$j++] = $1.K; /*16265*/
							break; /*16265*/
						} /*16265*/
						$k[$j++] = $a([4, 5, 6, $1.e, $1.e, 2, 3]); /*16266*/
						$1.KbeforeE(); /*16266*/
						if ($k[--$j]) { /*16266*/
							$k[$j++] = $1.K; /*16266*/
							break; /*16266*/
						} /*16266*/
						$k[$j++] = $a([11, 12, 14, $1.e, $1.e, 5, 7]); /*16267*/
						$1.AbeforeK(); /*16267*/
						if ($k[--$j]) { /*16267*/
							$k[$j++] = $1.A; /*16267*/
							break; /*16267*/
						} /*16267*/
						$k[$j++] = $a([11, 15, 16, $1.e, $1.e, 6, 7]); /*16268*/
						$1.AbeforeB(); /*16268*/
						if ($k[--$j]) { /*16268*/
							$k[$j++] = $1.A; /*16268*/
							break; /*16268*/
						} /*16268*/
						$k[$j++] = $a([12, 13, 15, $1.e, $1.e, 6, 8]); /*16269*/
						$1.AbeforeN(); /*16269*/
						if ($k[--$j]) { /*16269*/
							$k[$j++] = $1.A; /*16269*/
							break; /*16269*/
						} /*16269*/
						$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16270*/
						$1.AbeforeE(); /*16270*/
						if ($k[--$j]) { /*16270*/
							$k[$j++] = $1.A; /*16270*/
							break; /*16270*/
						} /*16270*/
						$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16271*/
						$1.NbeforeK(); /*16271*/
						if ($k[--$j]) { /*16271*/
							$k[$j++] = $1.N; /*16271*/
							break; /*16271*/
						} /*16271*/
						$k[$j++] = $a([6, 8, 9, $1.e, $1.e, 3, 4]); /*16272*/
						$1.NbeforeB(); /*16272*/
						if ($k[--$j]) { /*16272*/
							$k[$j++] = $1.N; /*16272*/
							break; /*16272*/
						} /*16272*/
						$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16273*/
						$1.NbeforeA(); /*16273*/
						if ($k[--$j]) { /*16273*/
							$k[$j++] = $1.N; /*16273*/
							break; /*16273*/
						} /*16273*/
						$k[$j++] = $a([3, 4, 5, $1.e, $1.e, 2, 3]); /*16274*/
						$1.NbeforeE(); /*16274*/
						if ($k[--$j]) { /*16274*/
							$k[$j++] = $1.N; /*16274*/
							break; /*16274*/
						} /*16274*/
						$k[$j++] = $1.B; /*16275*/
						break; /*16275*/
					} /*16275*/
					if ($1.mode == $1.A) { /*16285*/
						if ($1.numK >= 1) { /*16278*/
							$k[$j++] = $1.K; /*16278*/
							break; /*16278*/
						} /*16278*/
						if ($1.numB >= 1) { /*16279*/
							$k[$j++] = $1.B; /*16279*/
							break; /*16279*/
						} /*16279*/
						$k[$j++] = $a([13, 15, 17, $1.e, 5, 7, 9]); /*16280*/
						$1.NbeforeA(); /*16280*/
						if ($k[--$j]) { /*16280*/
							$k[$j++] = $1.N; /*16280*/
							break; /*16280*/
						} /*16280*/
						$k[$j++] = $a([13, 17, 18, $1.e, $1.e, 7, 9]); /*16281*/
						$1.NbeforeB(); /*16281*/
						if ($k[--$j]) { /*16281*/
							$k[$j++] = $1.N; /*16281*/
							break; /*16281*/
						} /*16281*/
						$k[$j++] = $a([7, 8, 9, $1.e, 3, 4, 5]); /*16282*/
						$1.NbeforeE(); /*16282*/
						if ($k[--$j]) { /*16282*/
							$k[$j++] = $1.N; /*16282*/
							break; /*16282*/
						} /*16282*/
						if (($1.numA >= 1) || ($1.numN >= 1)) { /*16283*/
							$k[$j++] = $1.A; /*16283*/
							break; /*16283*/
						} /*16283*/
						$k[$j++] = $1.B; /*16284*/
						break; /*16284*/
					} /*16284*/
					if ($1.mode == $1.N) { /*16292*/
						if ($1.numK >= 1) { /*16287*/
							$k[$j++] = $1.K; /*16287*/
							break; /*16287*/
						} /*16287*/
						if ($1.numB >= 1) { /*16288*/
							$k[$j++] = $1.B; /*16288*/
							break; /*16288*/
						} /*16288*/
						if ($1.numA >= 1) { /*16289*/
							$k[$j++] = $1.A; /*16289*/
							break; /*16289*/
						} /*16289*/
						if ($1.numN >= 1) { /*16290*/
							$k[$j++] = $1.N; /*16290*/
							break; /*16290*/
						} /*16290*/
						$k[$j++] = $1.B; /*16291*/
						break; /*16291*/
					} /*16291*/
					if ($1.mode == $1.K) { /*16299*/
						if ($1.numB >= 1) { /*16294*/
							$k[$j++] = $1.B; /*16294*/
							break; /*16294*/
						} /*16294*/
						if ($1.numA >= 1) { /*16295*/
							$k[$j++] = $1.A; /*16295*/
							break; /*16295*/
						} /*16295*/
						if ($1.numN >= 1) { /*16296*/
							$k[$j++] = $1.N; /*16296*/
							break; /*16296*/
						} /*16296*/
						if ($1.numK >= 1) { /*16297*/
							$k[$j++] = $1.K; /*16297*/
							break; /*16297*/
						} /*16297*/
						$k[$j++] = $1.B; /*16298*/
						break; /*16298*/
					} /*16298*/
				} /*16298*/
				var _AD = $k[--$j]; /*16301*/
				$k[$j++] = _AD; /*16301*/
				if ((_AD == $1.K) && $1.fnc1first) { /*16301*/
					$j--; /*16301*/
					$k[$j++] = $1.B; /*16301*/
				} /*16301*/
				var _AH = $k[--$j]; /*16302*/
				$k[$j++] = _AH; /*16317*/
				if (_AH == $1.mode) { /*16316*/
					$j--; /*16303*/
					var _AN = ($1.mode == $1.K) ? 2 : 1; /*16304*/
					$1.dat = $geti($1.msg, $1.i, _AN); /*16304*/
					$k[$j++] = Infinity; /*16308*/
					$aload($1.seq); /*16306*/
					$k[$j++] = Infinity; /*16307*/
					var _AQ = $k[--$j]; /*16307*/
					var _AR = $k[--$j]; /*16307*/
					$k[$j++] = _AQ; /*16307*/
					$aload(_AR); /*16307*/
					$aload($1.dat); /*16307*/
					var _AT = $a(); /*16307*/
					$k[$j++] = _AT; /*16307*/
					$1.seq = $a(); /*16308*/
				} else { /*16316*/
					$1.mode = $k[--$j]; /*16310*/
					if ($1.mode == $1.K) { /*16311*/
						$k[$j++] = $1.K; /*16311*/
						$k[$j++] = $geti($1.msg, $1.i, $1.numK * 2); /*16311*/
					} /*16311*/
					if ($1.mode == $1.B) { /*16312*/
						$k[$j++] = $1.B; /*16312*/
						$k[$j++] = $geti($1.msg, $1.i, $1.numB); /*16312*/
					} /*16312*/
					if ($1.mode == $1.A) { /*16313*/
						$k[$j++] = $1.A; /*16313*/
						$k[$j++] = $geti($1.msg, $1.i, $1.numA); /*16313*/
					} /*16313*/
					if ($1.mode == $1.N) { /*16314*/
						$k[$j++] = $1.N; /*16314*/
						$k[$j++] = $geti($1.msg, $1.i, $1.numN); /*16314*/
					} /*16314*/
					$1.dat = $k[--$j]; /*16315*/
					$1.sw = $k[--$j]; /*16315*/
					$k[$j++] = Infinity; /*16316*/
					$aload($1.seq); /*16316*/
					$k[$j++] = $1.sw; /*16316*/
					$k[$j++] = $1.dat; /*16316*/
					$1.seq = $a(); /*16316*/
				} /*16316*/
				$1.i = $1.i + $1.dat.length; /*16318*/
			} /*16318*/
			for (;;) { /*16344*/
				if ($1.seq == -1) { /*16323*/
					break; /*16323*/
				} /*16323*/
				$1.bits = $s(23648); /*16324*/
				$1.j = 0; /*16325*/
				if ($1.fnc1first) { /*16326*/
					$k[$j++] = "0101"; /*16326*/
					$1.addtobits(); /*16326*/
				} /*16326*/
				$1.abort = false; /*16327*/
				for (var _BB = 0, _BA = $1.seq.length - 1; _BB <= _BA; _BB += 2) { /*16339*/
					$1.i = _BB; /*16329*/
					$1.mode = $get($1.seq, $1.i); /*16330*/
					$k[$j++] = $get($get($1.mids, $1.ver), $1.mode); /*16331*/
					$1.addtobits(); /*16331*/
					$1.cclen = $get($get($1.cclens, $1.ver), $1.mode); /*16332*/
					$1.chars = $get($1.seq, $1.i + 1); /*16333*/
					if ($1.chars.length >= (~~Math.pow(2, $1.cclen))) { /*16336*/
						$1.abort = true; /*16335*/
						break; /*16335*/
					} /*16335*/
					$k[$j++] = $1.chars.length; /*16337*/
					if ($1.mode == $1.K) { /*16337*/
						var _BX = $k[--$j]; /*16337*/
						$k[$j++] = ~~(_BX / 2); /*16337*/
					} /*16337*/
					$k[$j++] = $1.cclen; /*16337*/
					$1.tobin(); /*16337*/
					$1.addtobits(); /*16337*/
					$k[$j++] = $1.chars; /*16338*/
					$1[$get($1.encfuncs, $1.mode)](); /*16338*/
					$1.addtobits(); /*16338*/
				} /*16338*/
				if ($1.abort) { /*16340*/
					break; /*16340*/
				} /*16340*/
				$1.bits = $geti($1.bits, 0, $1.j); /*16341*/
				$put($1.msgbits, $1.ver, $1.bits); /*16342*/
				break; /*16343*/
			} /*16343*/
		} /*16343*/
		$1.metrics = $a([$a(["micro", "M1", $1.vM1, 11, 98, 99, 36, $a([2, 99, 99, 99]), $a([1, 0, -1, -1, -1, -1, -1, -1])]), $a(["micro", "M2", $1.vM2, 13, 98, 99, 80, $a([5, 6, 99, 99]), $a([1, 0, 1, 0, -1, -1, -1, -1])]), $a(["micro", "M3", $1.vM3, 15, 98, 99, 132, $a([6, 8, 99, 99]), $a([1, 0, 1, 0, -1, -1, -1, -1])]), $a(["micro", "M4", $1.vM4, 17, 98, 99, 192, $a([8, 10, 14, 99]), $a([1, 0, 1, 0, 1, 0, -1, -1])]), $a(["full", "1", $1.v1to9, 21, 98, 99, 208, $a([7, 10, 13, 17]), $a([1, 0, 1, 0, 1, 0, 1, 0])]), $a(["full", "2", $1.v1to9, 25, 18, 99, 359, $a([10, 16, 22, 28]), $a([1, 0, 1, 0, 1, 0, 1, 0])]), $a(["full", "3", $1.v1to9, 29, 22, 99, 567, $a([15, 26, 36, 44]), $a([1, 0, 1, 0, 2, 0, 2, 0])]), $a(["full", "4", $1.v1to9, 33, 26, 99, 807, $a([20, 36, 52, 64]), $a([1, 0, 2, 0, 2, 0, 4, 0])]), $a(["full", "5", $1.v1to9, 37, 30, 99, 1079, $a([26, 48, 72, 88]), $a([1, 0, 2, 0, 2, 2, 2, 2])]), $a(["full", "6", $1.v1to9, 41, 34, 99, 1383, $a([36, 64, 96, 112]), $a([2, 0, 4, 0, 4, 0, 4, 0])]), $a(["full", "7", $1.v1to9, 45, 22, 38, 1568, $a([40, 72, 108, 130]), $a([2, 0, 4, 0, 2, 4, 4, 1])]), $a(["full", "8", $1.v1to9, 49, 24, 42, 1936, $a([48, 88, 132, 156]), $a([2, 0, 2, 2, 4, 2, 4, 2])]), $a(["full", "9", $1.v1to9, 53, 26, 46, 2336, $a([60, 110, 160, 192]), $a([2, 0, 3, 2, 4, 4, 4, 4])]), $a(["full", "10", $1.v10to26, 57, 28, 50, 2768, $a([72, 130, 192, 224]), $a([2, 2, 4, 1, 6, 2, 6, 2])]), $a(["full", "11", $1.v10to26, 61, 30, 54, 3232, $a([80, 150, 224, 264]), $a([4, 0, 1, 4, 4, 4, 3, 8])]), $a(["full", "12", $1.v10to26, 65, 32, 58, 3728, $a([96, 176, 260, 308]), $a([2, 2, 6, 2, 4, 6, 7, 4])]), $a(["full", "13", $1.v10to26, 69, 34, 62, 4256, $a([104, 198, 288, 352]), $a([4, 0, 8, 1, 8, 4, 12, 4])]), $a(["full", "14", $1.v10to26, 73, 26, 46, 4651, $a([120, 216, 320, 384]), $a([3, 1, 4, 5, 11, 5, 11, 5])]), $a(["full", "15", $1.v10to26, 77, 26, 48, 5243, $a([132, 240, 360, 432]), $a([5, 1, 5, 5, 5, 7, 11, 7])]), $a(["full", "16", $1.v10to26, 81, 26, 50, 5867, $a([144, 280, 408, 480]), $a([5, 1, 7, 3, 15, 2, 3, 13])]), $a(["full", "17", $1.v10to26, 85, 30, 54, 6523, $a([168, 308, 448, 532]), $a([1, 5, 10, 1, 1, 15, 2, 17])]), $a(["full", "18", $1.v10to26, 89, 30, 56, 7211, $a([180, 338, 504, 588]), $a([5, 1, 9, 4, 17, 1, 2, 19])]), $a(["full", "19", $1.v10to26, 93, 30, 58, 7931, $a([196, 364, 546, 650]), $a([3, 4, 3, 11, 17, 4, 9, 16])]), $a(["full", "20", $1.v10to26, 97, 34, 62, 8683, $a([224, 416, 600, 700]), $a([3, 5, 3, 13, 15, 5, 15, 10])]), $a(["full", "21", $1.v10to26, 101, 28, 50, 9252, $a([224, 442, 644, 750]), $a([4, 4, 17, 0, 17, 6, 19, 6])]), $a(["full", "22", $1.v10to26, 105, 26, 50, 10068, $a([252, 476, 690, 816]), $a([2, 7, 17, 0, 7, 16, 34, 0])]), $a(["full", "23", $1.v10to26, 109, 30, 54, 10916, $a([270, 504, 750, 900]), $a([4, 5, 4, 14, 11, 14, 16, 14])]), $a(["full", "24", $1.v10to26, 113, 28, 54, 11796, $a([300, 560, 810, 960]), $a([6, 4, 6, 14, 11, 16, 30, 2])]), $a(["full", "25", $1.v10to26, 117, 32, 58, 12708, $a([312, 588, 870, 1050]), $a([8, 4, 8, 13, 7, 22, 22, 13])]), $a(["full", "26", $1.v10to26, 121, 30, 58, 13652, $a([336, 644, 952, 1110]), $a([10, 2, 19, 4, 28, 6, 33, 4])]), $a(["full", "27", $1.v27to40, 125, 34, 62, 14628, $a([360, 700, 1020, 1200]), $a([8, 4, 22, 3, 8, 26, 12, 28])]), $a(["full", "28", $1.v27to40, 129, 26, 50, 15371, $a([390, 728, 1050, 1260]), $a([3, 10, 3, 23, 4, 31, 11, 31])]), $a(["full", "29", $1.v27to40, 133, 30, 54, 16411, $a([420, 784, 1140, 1350]), $a([7, 7, 21, 7, 1, 37, 19, 26])]), $a(["full", "30", $1.v27to40, 137, 26, 52, 17483, $a([450, 812, 1200, 1440]), $a([5, 10, 19, 10, 15, 25, 23, 25])]), $a(["full", "31", $1.v27to40, 141, 30, 56, 18587, $a([480, 868, 1290, 1530]), $a([13, 3, 2, 29, 42, 1, 23, 28])]), $a(["full", "32", $1.v27to40, 145, 34, 60, 19723, $a([510, 924, 1350, 1620]), $a([17, 0, 10, 23, 10, 35, 19, 35])]), $a(["full", "33", $1.v27to40, 149, 30, 58, 20891, $a([540, 980, 1440, 1710]), $a([17, 1, 14, 21, 29, 19, 11, 46])]), $a(["full", "34", $1.v27to40, 153, 34, 62, 22091, $a([570, 1036, 1530, 1800]), $a([13, 6, 14, 23, 44, 7, 59, 1])]), $a(["full", "35", $1.v27to40, 157, 30, 54, 23008, $a([570, 1064, 1590, 1890]), $a([12, 7, 12, 26, 39, 14, 22, 41])]), $a(["full", "36", $1.v27to40, 161, 24, 50, 24272, $a([600, 1120, 1680, 1980]), $a([6, 14, 6, 34, 46, 10, 2, 64])]), $a(["full", "37", $1.v27to40, 165, 28, 54, 25568, $a([630, 1204, 1770, 2100]), $a([17, 4, 29, 14, 49, 10, 24, 46])]), $a(["full", "38", $1.v27to40, 169, 32, 58, 26896, $a([660, 1260, 1860, 2220]), $a([4, 18, 13, 32, 48, 14, 42, 32])]), $a(["full", "39", $1.v27to40, 173, 26, 54, 28256, $a([720, 1316, 1950, 2310]), $a([20, 4, 40, 7, 43, 22, 10, 67])]), $a(["full", "40", $1.v27to40, 177, 30, 58, 29648, $a([750, 1372, 2040, 2430]), $a([19, 6, 18, 31, 34, 34, 20, 61])])]); /*16395*/
		$k[$j++] = "eclval"; /*16396*/
		$search("LMQH", $1.eclevel); /*16396*/
		$j--; /*16396*/
		var _Ed = $k[--$j]; /*16396*/
		var _Ee = $k[--$j]; /*16396*/
		var _Ef = $k[--$j]; /*16396*/
		$1[$k[--$j]] = _Ed.length; /*16396*/
		for (var _Eh = 0; _Eh <= 43; _Eh += 1) { /*16433*/
			$1.i = _Eh; /*16398*/
			$1.m = $get($1.metrics, $1.i); /*16399*/
			$1.frmt = $get($1.m, 0); /*16400*/
			$1.vers = $get($1.m, 1); /*16401*/
			$1.vergrp = $get($1.m, 2); /*16402*/
			$1.size = $get($1.m, 3); /*16403*/
			$1.asp2 = $get($1.m, 4); /*16404*/
			$1.asp3 = $get($1.m, 5); /*16405*/
			$1.nmod = $get($1.m, 6); /*16406*/
			$1.ncws = ~~($1.nmod / 8); /*16407*/
			$1.rbit = $1.nmod % 8; /*16408*/
			$1.lc4b = false; /*16409*/
			if (($1.size == 11) || ($1.size == 15)) { /*16414*/
				$1.ncws = $1.ncws + 1; /*16411*/
				$1.rbit = 0; /*16412*/
				$1.lc4b = true; /*16413*/
			} /*16413*/
			$1.ecws = $get($get($1.m, 7), $1.eclval); /*16415*/
			$1.dcws = $1.ncws - $1.ecws; /*16416*/
			var _FC = $1.lc4b ? 4 : 0; /*16417*/
			$1.dmod = ($1.dcws * 8) - _FC; /*16417*/
			$1.ecb1 = $get($get($1.m, 8), $1.eclval * 2); /*16418*/
			$1.ecb2 = $get($get($1.m, 8), ($1.eclval * 2) + 1); /*16419*/
			$1.okay = true; /*16420*/
			if ($ne($1.format, "any") && $ne($1.format, $1.frmt)) { /*16421*/
				$1.okay = false; /*16421*/
			} /*16421*/
			if ($eq($1.frmt, "micro") && $1.fnc1first) { /*16422*/
				$1.okay = false; /*16422*/
			} /*16422*/
			if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*16423*/
				$1.okay = false; /*16423*/
			} /*16423*/
			if (($1.ecb1 == -1) || ($1.ecb2 == -1)) { /*16424*/
				$1.okay = false; /*16424*/
			} /*16424*/
			$1.verbits = $get($1.msgbits, $1.vergrp); /*16425*/
			if ($1.verbits == -1) { /*16429*/
				$1.okay = false; /*16427*/
			} else { /*16429*/
				if ($1.verbits.length > $1.dmod) { /*16429*/
					$1.okay = false; /*16429*/
				} /*16429*/
			} /*16429*/
			$1.term = $geti("000000000", 0, $get($1.termlens, $1.vergrp)); /*16431*/
			if ($1.okay) { /*16432*/
				break; /*16432*/
			} /*16432*/
		} /*16432*/
		if (!$1.okay) { /*16437*/
			$k[$j++] = "bwipp.qrcodeNoValidSymbol"; /*16436*/
			$k[$j++] = "No valid symbol available"; /*16436*/
			$0.raiseerror(); /*16436*/
		} /*16436*/
		$1.format = $1.frmt; /*16439*/
		$1.version = $1.vers; /*16440*/
		$1.msgbits = $1.verbits; /*16441*/
		$1.dcpb = ~~($1.dcws / ($1.ecb1 + $1.ecb2)); /*16442*/
		$1.ecpb = (~~($1.ncws / ($1.ecb1 + $1.ecb2))) - $1.dcpb; /*16443*/
		var _Fr = $1.term; /*16446*/
		var _Fs = $1.dmod; /*16446*/
		var _Ft = $1.msgbits; /*16446*/
		var _Fu = $1.term; /*16446*/
		var _Fv = _Fu.length; /*16446*/
		var _Fw = _Fs - _Ft.length; /*16446*/
		if ((_Fs - _Ft.length) > _Fu.length) { /*16446*/
			var _ = _Fv; /*16446*/
			_Fv = _Fw; /*16446*/
			_Fw = _; /*16446*/
		} /*16446*/
		$1.term = $geti(_Fr, 0, _Fw); /*16446*/
		var _G0 = $s($1.msgbits.length + $1.term.length); /*16447*/
		$puti(_G0, 0, $1.msgbits); /*16448*/
		$puti(_G0, $1.msgbits.length, $1.term); /*16449*/
		$1.msgbits = _G0; /*16450*/
		$1.pad = $s($1.dmod); /*16453*/
		for (var _G8 = 0, _G7 = $1.pad.length - 1; _G8 <= _G7; _G8 += 1) { /*16454*/
			$put($1.pad, _G8, 48); /*16454*/
		} /*16454*/
		$puti($1.pad, 0, $1.msgbits); /*16455*/
		$1.padstrs = $a(["11101100", "00010001"]); /*16456*/
		$1.padnum = 0; /*16457*/
		var _GG = $1.lc4b ? 5 : 1; /*16458*/
		for (var _GI = ~~(Math.ceil($1.msgbits.length / 8) * 8), _GH = $1.dmod - _GG; _GI <= _GH; _GI += 8) { /*16461*/
			$puti($1.pad, _GI, $get($1.padstrs, $1.padnum)); /*16459*/
			$1.padnum = ($1.padnum + 1) % 2; /*16460*/
		} /*16460*/
		$1.cws = $a($1.dcws); /*16464*/
		for (var _GS = 0, _GR = $1.cws.length - 1; _GS <= _GR; _GS += 1) { /*16476*/
			$1.c = _GS; /*16466*/
			$1.bpcw = 8; /*16467*/
			if ($1.lc4b && ($1.c == ($1.cws.length - 1))) { /*16468*/
				$1.bpcw = 4; /*16468*/
			} /*16468*/
			$1.cwb = $geti($1.pad, $1.c * 8, $1.bpcw); /*16469*/
			$1.cw = 0; /*16470*/
			for (var _Gc = 0, _Gb = $1.bpcw - 1; _Gc <= _Gb; _Gc += 1) { /*16474*/
				$1.i = _Gc; /*16472*/
				$1.cw = $1.cw + ((~~(Math.pow(2, ($1.bpcw - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*16473*/
			} /*16473*/
			$put($1.cws, $1.c, $1.cw); /*16475*/
		} /*16475*/
		if ($1.lc4b) { /*16479*/
			var _Gn = $1.cws; /*16479*/
			var _Go = $1.cws; /*16479*/
			$put(_Gn, _Go.length - 1, $get(_Gn, _Go.length - 1) << 4); /*16479*/
		} /*16479*/
		$k[$j++] = Infinity; /*16482*/
		$k[$j++] = 1; /*16482*/
		for (var _Gq = 0, _Gr = 255; _Gq < _Gr; _Gq++) { /*16482*/
			var _Gs = $k[--$j]; /*16482*/
			var _Gt = _Gs * 2; /*16482*/
			$k[$j++] = _Gs; /*16482*/
			$k[$j++] = _Gt; /*16482*/
			if (_Gt >= 256) { /*16482*/
				var _Gu = $k[--$j]; /*16482*/
				$k[$j++] = _Gu ^ 285; /*16482*/
			} /*16482*/
		} /*16482*/
		$1.rsalog = $a(); /*16482*/
		$1.rslog = $a(256); /*16483*/
		for (var _Gx = 1; _Gx <= 255; _Gx += 1) { /*16484*/
			$put($1.rslog, $get($1.rsalog, _Gx), _Gx); /*16484*/
		} /*16484*/
		$1.rsprod = function() {
			var _H1 = $k[--$j]; /*16488*/
			var _H2 = $k[--$j]; /*16488*/
			$k[$j++] = _H2; /*16492*/
			$k[$j++] = _H1; /*16492*/
			if ((_H1 != 0) && (_H2 != 0)) { /*16491*/
				var _H5 = $get($1.rslog, $k[--$j]); /*16489*/
				var _HA = $get($1.rsalog, (_H5 + $get($1.rslog, $k[--$j])) % 255); /*16489*/
				$k[$j++] = _HA; /*16489*/
			} else { /*16491*/
				$j -= 2; /*16491*/
				$k[$j++] = 0; /*16491*/
			} /*16491*/
		}; /*16493*/
		$k[$j++] = Infinity; /*16496*/
		$k[$j++] = 1; /*16496*/
		for (var _HC = 0, _HD = $1.ecpb; _HC < _HD; _HC++) { /*16496*/
			$k[$j++] = 0; /*16496*/
		} /*16496*/
		$1.coeffs = $a(); /*16496*/
		for (var _HH = 0, _HG = $1.ecpb - 1; _HH <= _HG; _HH += 1) { /*16505*/
			$1.i = _HH; /*16498*/
			$put($1.coeffs, $1.i + 1, $get($1.coeffs, $1.i)); /*16499*/
			for (var _HO = $1.i; _HO >= 1; _HO -= 1) { /*16503*/
				$1.j = _HO; /*16501*/
				$k[$j++] = $1.coeffs; /*16502*/
				$k[$j++] = $1.j; /*16502*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*16502*/
				$k[$j++] = $get($1.coeffs, $1.j); /*16502*/
				$k[$j++] = $get($1.rsalog, $1.i); /*16502*/
				$1.rsprod(); /*16502*/
				var _Ha = $k[--$j]; /*16502*/
				var _Hb = $k[--$j]; /*16502*/
				var _Hc = $k[--$j]; /*16502*/
				$put($k[--$j], _Hc, $xo(_Hb, _Ha)); /*16502*/
			} /*16502*/
			$k[$j++] = $1.coeffs; /*16504*/
			$k[$j++] = 0; /*16504*/
			$k[$j++] = $get($1.coeffs, 0); /*16504*/
			$k[$j++] = $get($1.rsalog, $1.i); /*16504*/
			$1.rsprod(); /*16504*/
			var _Hk = $k[--$j]; /*16504*/
			var _Hl = $k[--$j]; /*16504*/
			$put($k[--$j], _Hl, _Hk); /*16504*/
		} /*16504*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*16506*/
		$1.rscodes = function() {
			$1.rscws = $k[--$j]; /*16510*/
			$1.rsnd = $1.rscws.length; /*16511*/
			$k[$j++] = Infinity; /*16512*/
			$forall($1.rscws); /*16512*/
			for (var _Hu = 0, _Hv = $1.ecpb; _Hu < _Hv; _Hu++) { /*16512*/
				$k[$j++] = 0; /*16512*/
			} /*16512*/
			$1.rscws = $a(); /*16512*/
			for (var _Hz = 0, _Hy = $1.rsnd - 1; _Hz <= _Hy; _Hz += 1) { /*16520*/
				$1.m = _Hz; /*16514*/
				$1.k = $get($1.rscws, $1.m); /*16515*/
				for (var _I5 = 0, _I4 = $1.ecpb - 1; _I5 <= _I4; _I5 += 1) { /*16519*/
					$1.j = _I5; /*16517*/
					$k[$j++] = $1.rscws; /*16518*/
					$k[$j++] = ($1.m + $1.j) + 1; /*16518*/
					$k[$j++] = $get($1.coeffs, ($1.ecpb - $1.j) - 1); /*16518*/
					$k[$j++] = $1.k; /*16518*/
					$1.rsprod(); /*16518*/
					var _II = $k[--$j]; /*16518*/
					var _IJ = $k[--$j]; /*16518*/
					$put($k[--$j], _IJ, $xo(_II, $get($1.rscws, ($1.m + $1.j) + 1))); /*16518*/
				} /*16518*/
			} /*16518*/
			$k[$j++] = $geti($1.rscws, $1.rsnd, $1.ecpb); /*16521*/
		}; /*16522*/
		$1.dcwsb = $a($1.ecb1 + $1.ecb2); /*16525*/
		$1.ecwsb = $a($1.ecb1 + $1.ecb2); /*16526*/
		for (var _IX = 0, _IW = $1.ecb1 - 1; _IX <= _IW; _IX += 1) { /*16531*/
			$1.i = _IX; /*16528*/
			$put($1.dcwsb, $1.i, $geti($1.cws, $1.i * $1.dcpb, $1.dcpb)); /*16529*/
			$k[$j++] = $1.ecwsb; /*16530*/
			$k[$j++] = $1.i; /*16530*/
			$k[$j++] = $get($1.dcwsb, $1.i); /*16530*/
			$1.rscodes(); /*16530*/
			var _Ik = $k[--$j]; /*16530*/
			var _Il = $k[--$j]; /*16530*/
			$put($k[--$j], _Il, _Ik); /*16530*/
		} /*16530*/
		for (var _Ip = 0, _Io = $1.ecb2 - 1; _Ip <= _Io; _Ip += 1) { /*16536*/
			$1.i = _Ip; /*16533*/
			$put($1.dcwsb, $1.ecb1 + $1.i, $geti($1.cws, ($1.ecb1 * $1.dcpb) + ($1.i * ($1.dcpb + 1)), $1.dcpb + 1)); /*16534*/
			$k[$j++] = $1.ecwsb; /*16535*/
			$k[$j++] = $1.ecb1 + $1.i; /*16535*/
			$k[$j++] = $get($1.dcwsb, $1.ecb1 + $1.i); /*16535*/
			$1.rscodes(); /*16535*/
			var _J7 = $k[--$j]; /*16535*/
			var _J8 = $k[--$j]; /*16535*/
			$put($k[--$j], _J8, _J7); /*16535*/
		} /*16535*/
		$1.cws = $a($1.ncws); /*16539*/
		$1.cw = 0; /*16540*/
		for (var _JE = 0, _JD = $1.dcpb; _JE <= _JD; _JE += 1) { /*16550*/
			$1.i = _JE; /*16542*/
			for (var _JI = 0, _JH = ($1.ecb1 + $1.ecb2) - 1; _JI <= _JH; _JI += 1) { /*16549*/
				$1.j = _JI; /*16544*/
				if ($1.i < $get($1.dcwsb, $1.j).length) { /*16548*/
					$put($1.cws, $1.cw, $get($get($1.dcwsb, $1.j), $1.i)); /*16546*/
					$1.cw = $1.cw + 1; /*16547*/
				} /*16547*/
			} /*16547*/
		} /*16547*/
		for (var _JX = 0, _JW = $1.ecpb - 1; _JX <= _JW; _JX += 1) { /*16558*/
			$1.i = _JX; /*16552*/
			for (var _Jb = 0, _Ja = ($1.ecb1 + $1.ecb2) - 1; _Jb <= _Ja; _Jb += 1) { /*16557*/
				$1.j = _Jb; /*16554*/
				$put($1.cws, $1.cw, $get($get($1.ecwsb, $1.j), $1.i)); /*16555*/
				$1.cw = $1.cw + 1; /*16556*/
			} /*16556*/
		} /*16556*/
		if ($1.rbit > 0) { /*16566*/
			$1.pad = $a($1.cws.length + 1); /*16562*/
			$puti($1.pad, 0, $1.cws); /*16563*/
			$put($1.pad, $1.pad.length - 1, 0); /*16564*/
			$1.cws = $1.pad; /*16565*/
		} /*16565*/
		if ($1.lc4b) { /*16577*/
			var _Jt = $1.cws; /*16570*/
			var _Ju = $1.dcws; /*16570*/
			$put(_Jt, _Ju - 1, $get(_Jt, _Ju - 1) >>> 4); /*16570*/
			for (var _Jz = $1.dcws - 1, _Jy = $1.ncws - 2; _Jz <= _Jy; _Jz += 1) { /*16575*/
				$1.i = _Jz; /*16572*/
				$put($1.cws, $1.i, ($get($1.cws, $1.i) & 15) << 4); /*16573*/
				$put($1.cws, $1.i, (($get($1.cws, $1.i + 1) >>> 4) & 15) | $get($1.cws, $1.i)); /*16574*/
			} /*16574*/
			$put($1.cws, $1.ncws - 1, ($get($1.cws, $1.ncws - 1) & 15) << 4); /*16576*/
		} /*16576*/
		$k[$j++] = Infinity; /*16580*/
		for (var _KK = 0, _KL = $1.size * $1.size; _KK < _KL; _KK++) { /*16580*/
			$k[$j++] = -1; /*16580*/
		} /*16580*/
		$1.pixs = $a(); /*16580*/
		$1.qmv = function() {
			var _KO = $k[--$j]; /*16581*/
			var _KP = $k[--$j]; /*16581*/
			$k[$j++] = _KP + (_KO * $1.size); /*16581*/
		}; /*16581*/
		$1.fpat = $a([$a([1, 1, 1, 1, 1, 1, 1, 0]), $a([1, 0, 0, 0, 0, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 0, 0, 0, 0, 1, 0]), $a([1, 1, 1, 1, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*16593*/
		for (var _Kb = 0, _Ka = $1.fpat.length - 1; _Kb <= _Ka; _Kb += 1) { /*16605*/
			$1.y = _Kb; /*16595*/
			for (var _Kf = 0, _Ke = $get($1.fpat, 0).length - 1; _Kf <= _Ke; _Kf += 1) { /*16604*/
				$1.x = _Kf; /*16597*/
				$1.fpb = $get($get($1.fpat, $1.y), $1.x); /*16598*/
				$k[$j++] = $1.pixs; /*16599*/
				$k[$j++] = $1.x; /*16599*/
				$k[$j++] = $1.y; /*16599*/
				$1.qmv(); /*16599*/
				var _Kp = $k[--$j]; /*16599*/
				$put($k[--$j], _Kp, $1.fpb); /*16599*/
				if ($eq($1.format, "full")) { /*16603*/
					$k[$j++] = $1.pixs; /*16601*/
					$k[$j++] = ($1.size - $1.x) - 1; /*16601*/
					$k[$j++] = $1.y; /*16601*/
					$1.qmv(); /*16601*/
					var _Kx = $k[--$j]; /*16601*/
					$put($k[--$j], _Kx, $1.fpb); /*16601*/
					$k[$j++] = $1.pixs; /*16602*/
					$k[$j++] = $1.x; /*16602*/
					$k[$j++] = ($1.size - $1.y) - 1; /*16602*/
					$1.qmv(); /*16602*/
					var _L4 = $k[--$j]; /*16602*/
					$put($k[--$j], _L4, $1.fpb); /*16602*/
				} /*16602*/
			} /*16602*/
		} /*16602*/
		$1.algnpat = $a([$a([1, 1, 1, 1, 1]), $a([1, 0, 0, 0, 1]), $a([1, 0, 1, 0, 1]), $a([1, 0, 0, 0, 1]), $a([1, 1, 1, 1, 1])]); /*16614*/
		$1.putalgnpat = function() {
			$1.py = $k[--$j]; /*16616*/
			$1.px = $k[--$j]; /*16617*/
			for (var _LE = 0; _LE <= 4; _LE += 1) { /*16624*/
				$1.pb = _LE; /*16619*/
				for (var _LF = 0; _LF <= 4; _LF += 1) { /*16623*/
					$1.pa = _LF; /*16621*/
					$k[$j++] = $1.pixs; /*16622*/
					$k[$j++] = $1.px + $1.pa; /*16622*/
					$k[$j++] = $1.py + $1.pb; /*16622*/
					$1.qmv(); /*16622*/
					var _LQ = $k[--$j]; /*16622*/
					$put($k[--$j], _LQ, $get($get($1.algnpat, $1.pb), $1.pa)); /*16622*/
				} /*16622*/
			} /*16622*/
		}; /*16625*/
		for (var _LX = $1.asp2 - 2, _LY = $1.asp3 - $1.asp2, _LW = $1.size - 13; _LY < 0 ? _LX >= _LW : _LX <= _LW; _LX += _LY) { /*16630*/
			$1.i = _LX; /*16627*/
			$k[$j++] = $1.i; /*16628*/
			$k[$j++] = 4; /*16628*/
			$1.putalgnpat(); /*16628*/
			$k[$j++] = 4; /*16629*/
			$k[$j++] = $1.i; /*16629*/
			$1.putalgnpat(); /*16629*/
		} /*16629*/
		for (var _Lg = $1.asp2 - 2, _Lh = $1.asp3 - $1.asp2, _Lf = $1.size - 9; _Lh < 0 ? _Lg >= _Lf : _Lg <= _Lf; _Lg += _Lh) { /*16637*/
			$1.x = _Lg; /*16632*/
			for (var _Ln = $1.asp2 - 2, _Lo = $1.asp3 - $1.asp2, _Lm = $1.size - 9; _Lo < 0 ? _Ln >= _Lm : _Ln <= _Lm; _Ln += _Lo) { /*16636*/
				$1.y = _Ln; /*16634*/
				$k[$j++] = $1.x; /*16635*/
				$k[$j++] = $1.y; /*16635*/
				$1.putalgnpat(); /*16635*/
			} /*16635*/
		} /*16635*/
		if ($eq($1.format, "full")) { /*16650*/
			for (var _Lu = 8, _Lt = $1.size - 9; _Lu <= _Lt; _Lu += 1) { /*16645*/
				$1.i = _Lu; /*16642*/
				$k[$j++] = $1.pixs; /*16643*/
				$k[$j++] = $1.i; /*16643*/
				$k[$j++] = 6; /*16643*/
				$1.qmv(); /*16643*/
				var _Ly = $k[--$j]; /*16643*/
				$put($k[--$j], _Ly, ($1.i + 1) % 2); /*16643*/
				$k[$j++] = $1.pixs; /*16644*/
				$k[$j++] = 6; /*16644*/
				$k[$j++] = $1.i; /*16644*/
				$1.qmv(); /*16644*/
				var _M3 = $k[--$j]; /*16644*/
				$put($k[--$j], _M3, ($1.i + 1) % 2); /*16644*/
			} /*16644*/
		} else { /*16650*/
			for (var _M7 = 8, _M6 = $1.size - 1; _M7 <= _M6; _M7 += 1) { /*16651*/
				$1.i = _M7; /*16648*/
				$k[$j++] = $1.pixs; /*16649*/
				$k[$j++] = $1.i; /*16649*/
				$k[$j++] = 0; /*16649*/
				$1.qmv(); /*16649*/
				var _MB = $k[--$j]; /*16649*/
				$put($k[--$j], _MB, ($1.i + 1) % 2); /*16649*/
				$k[$j++] = $1.pixs; /*16650*/
				$k[$j++] = 0; /*16650*/
				$k[$j++] = $1.i; /*16650*/
				$1.qmv(); /*16650*/
				var _MG = $k[--$j]; /*16650*/
				$put($k[--$j], _MG, ($1.i + 1) % 2); /*16650*/
			} /*16650*/
		} /*16650*/
		if ($eq($1.format, "full")) { /*16668*/
			$1.formatmap = $a([$a([$a([0, 8]), $a([8, $1.size - 1])]), $a([$a([1, 8]), $a([8, $1.size - 2])]), $a([$a([2, 8]), $a([8, $1.size - 3])]), $a([$a([3, 8]), $a([8, $1.size - 4])]), $a([$a([4, 8]), $a([8, $1.size - 5])]), $a([$a([5, 8]), $a([8, $1.size - 6])]), $a([$a([7, 8]), $a([8, $1.size - 7])]), $a([$a([8, 8]), $a([$1.size - 8, 8])]), $a([$a([8, 7]), $a([$1.size - 7, 8])]), $a([$a([8, 5]), $a([$1.size - 6, 8])]), $a([$a([8, 4]), $a([$1.size - 5, 8])]), $a([$a([8, 3]), $a([$1.size - 4, 8])]), $a([$a([8, 2]), $a([$1.size - 3, 8])]), $a([$a([8, 1]), $a([$1.size - 2, 8])]), $a([$a([8, 0]), $a([$1.size - 1, 8])])]); /*16662*/
		} else { /*16668*/
			$1.formatmap = $a([$a([$a([1, 8])]), $a([$a([2, 8])]), $a([$a([3, 8])]), $a([$a([4, 8])]), $a([$a([5, 8])]), $a([$a([6, 8])]), $a([$a([7, 8])]), $a([$a([8, 8])]), $a([$a([8, 7])]), $a([$a([8, 6])]), $a([$a([8, 5])]), $a([$a([8, 4])]), $a([$a([8, 3])]), $a([$a([8, 2])]), $a([$a([8, 1])])]); /*16668*/
		} /*16668*/
		var _Nn = $1.formatmap; /*16670*/
		for (var _No = 0, _Np = _Nn.length; _No < _Np; _No++) { /*16672*/
			$forall($get(_Nn, _No), function() { /*16671*/
				$forall($k[--$j]); /*16671*/
				$1.qmv(); /*16671*/
				$put($1.pixs, $k[--$j], 0); /*16671*/
			}); /*16671*/
		} /*16671*/
		if ($1.size >= 45) { /*16688*/
			$1.versionmap = $a([$a([$a([$1.size - 9, 5]), $a([5, $1.size - 9])]), $a([$a([$1.size - 10, 5]), $a([5, $1.size - 10])]), $a([$a([$1.size - 11, 5]), $a([5, $1.size - 11])]), $a([$a([$1.size - 9, 4]), $a([4, $1.size - 9])]), $a([$a([$1.size - 10, 4]), $a([4, $1.size - 10])]), $a([$a([$1.size - 11, 4]), $a([4, $1.size - 11])]), $a([$a([$1.size - 9, 3]), $a([3, $1.size - 9])]), $a([$a([$1.size - 10, 3]), $a([3, $1.size - 10])]), $a([$a([$1.size - 11, 3]), $a([3, $1.size - 11])]), $a([$a([$1.size - 9, 2]), $a([2, $1.size - 9])]), $a([$a([$1.size - 10, 2]), $a([2, $1.size - 10])]), $a([$a([$1.size - 11, 2]), $a([2, $1.size - 11])]), $a([$a([$1.size - 9, 1]), $a([1, $1.size - 9])]), $a([$a([$1.size - 10, 1]), $a([1, $1.size - 10])]), $a([$a([$1.size - 11, 1]), $a([1, $1.size - 11])]), $a([$a([$1.size - 9, 0]), $a([0, $1.size - 9])]), $a([$a([$1.size - 10, 0]), $a([0, $1.size - 10])]), $a([$a([$1.size - 11, 0]), $a([0, $1.size - 11])])]); /*16686*/
		} else { /*16688*/
			$1.versionmap = $a([]); /*16688*/
		} /*16688*/
		var _PP = $1.versionmap; /*16690*/
		for (var _PQ = 0, _PR = _PP.length; _PQ < _PR; _PQ++) { /*16692*/
			$forall($get(_PP, _PQ), function() { /*16691*/
				$forall($k[--$j]); /*16691*/
				$1.qmv(); /*16691*/
				$put($1.pixs, $k[--$j], 0); /*16691*/
			}); /*16691*/
		} /*16691*/
		if ($eq($1.format, "full")) { /*16697*/
			$k[$j++] = $1.pixs; /*16696*/
			$k[$j++] = 8; /*16696*/
			$k[$j++] = $1.size - 8; /*16696*/
			$1.qmv(); /*16696*/
			var _PZ = $k[--$j]; /*16696*/
			$put($k[--$j], _PZ, 1); /*16696*/
		} /*16696*/
		if ($eq($1.format, "full")) { /*16717*/
			var _Pt = $a([function() {
				var _Pc = $k[--$j]; /*16702*/
				var _Pd = $k[--$j]; /*16702*/
				$k[$j++] = (_Pd + _Pc) % 2; /*16702*/
			}, function() {
				var _Pe = $k[--$j]; /*16703*/
				var _Pf = $k[--$j]; /*16703*/
				$k[$j++] = _Pe % 2; /*16703*/
			}, function() {
				$j--; /*16704*/
				var _Pg = $k[--$j]; /*16704*/
				$k[$j++] = _Pg % 3; /*16704*/
			}, function() {
				var _Ph = $k[--$j]; /*16705*/
				var _Pi = $k[--$j]; /*16705*/
				$k[$j++] = (_Pi + _Ph) % 3; /*16705*/
			}, function() {
				var _Pj = $k[--$j]; /*16706*/
				var _Pk = $k[--$j]; /*16706*/
				$k[$j++] = ((~~(_Pj / 2)) + (~~(_Pk / 3))) % 2; /*16706*/
			}, function() {
				var _Pl = $k[--$j]; /*16707*/
				var _Pn = $k[--$j] * _Pl; /*16707*/
				$k[$j++] = (_Pn % 2) + (_Pn % 3); /*16707*/
			}, function() {
				var _Po = $k[--$j]; /*16708*/
				var _Pq = $k[--$j] * _Po; /*16708*/
				$k[$j++] = ((_Pq % 2) + (_Pq % 3)) % 2; /*16708*/
			}, function() {
				var _Pr = $k[--$j]; /*16709*/
				var _Ps = $k[--$j]; /*16709*/
				$k[$j++] = (((_Ps * _Pr) % 3) + ((_Ps + _Pr) % 2)) % 2; /*16709*/
			}]); /*16709*/
			$1.maskfuncs = _Pt; /*16710*/
		} else { /*16717*/
			var _Q3 = $a([function() {
				var _Pu = $k[--$j]; /*16713*/
				var _Pv = $k[--$j]; /*16713*/
				$k[$j++] = _Pu % 2; /*16713*/
			}, function() {
				var _Pw = $k[--$j]; /*16714*/
				var _Px = $k[--$j]; /*16714*/
				$k[$j++] = ((~~(_Pw / 2)) + (~~(_Px / 3))) % 2; /*16714*/
			}, function() {
				var _Py = $k[--$j]; /*16715*/
				var _Q0 = $k[--$j] * _Py; /*16715*/
				$k[$j++] = ((_Q0 % 2) + (_Q0 % 3)) % 2; /*16715*/
			}, function() {
				var _Q1 = $k[--$j]; /*16716*/
				var _Q2 = $k[--$j]; /*16716*/
				$k[$j++] = (((_Q2 * _Q1) % 3) + ((_Q2 + _Q1) % 2)) % 2; /*16716*/
			}]); /*16716*/
			$1.maskfuncs = _Q3; /*16717*/
		} /*16717*/
		if ($1.mask != -1) { /*16722*/
			$1.maskfuncs = $a([$get($1.maskfuncs, $1.mask - 1)]); /*16720*/
			$1.bestmaskval = $1.mask - 1; /*16721*/
		} /*16721*/
		$1.masks = $a($1.maskfuncs.length); /*16723*/
		for (var _QE = 0, _QD = $1.masks.length - 1; _QE <= _QD; _QE += 1) { /*16737*/
			$1.m = _QE; /*16725*/
			$1.mask = $a($1.size * $1.size); /*16726*/
			for (var _QK = 0, _QJ = $1.size - 1; _QK <= _QJ; _QK += 1) { /*16735*/
				$1.j = _QK; /*16728*/
				for (var _QN = 0, _QM = $1.size - 1; _QN <= _QM; _QN += 1) { /*16734*/
					$1.i = _QN; /*16730*/
					$k[$j++] = $1.i; /*16731*/
					$k[$j++] = $1.j; /*16731*/
					$get($1.maskfuncs, $1.m)(); /*16731*/
					var _QT = $k[--$j]; /*16731*/
					$k[$j++] = _QT == 0; /*16732*/
					$k[$j++] = $1.pixs; /*16732*/
					$k[$j++] = $1.i; /*16732*/
					$k[$j++] = $1.j; /*16732*/
					$1.qmv(); /*16732*/
					var _QX = $k[--$j]; /*16732*/
					var _QZ = $get($k[--$j], _QX); /*16732*/
					var _Qb = ($k[--$j] && (_QZ == -1)) ? 1 : 0; /*16732*/
					$k[$j++] = _Qb; /*16733*/
					$k[$j++] = $1.mask; /*16733*/
					$k[$j++] = $1.i; /*16733*/
					$k[$j++] = $1.j; /*16733*/
					$1.qmv(); /*16733*/
					var _Qf = $k[--$j]; /*16733*/
					var _Qg = $k[--$j]; /*16733*/
					$put(_Qg, _Qf, $k[--$j]); /*16733*/
				} /*16733*/
			} /*16733*/
			$put($1.masks, $1.m, $1.mask); /*16736*/
		} /*16736*/
		$1.posx = $1.size - 1; /*16740*/
		$1.posy = $1.size - 1; /*16741*/
		$1.dir = -1; /*16742*/
		$1.col = 1; /*16743*/
		$1.num = 0; /*16744*/
		for (;;) { /*16767*/
			if ($1.posx < 0) { /*16746*/
				break; /*16746*/
			} /*16746*/
			$k[$j++] = $1.pixs; /*16747*/
			$k[$j++] = $1.posx; /*16747*/
			$k[$j++] = $1.posy; /*16747*/
			$1.qmv(); /*16747*/
			var _Qr = $k[--$j]; /*16747*/
			if ($get($k[--$j], _Qr) == -1) { /*16751*/
				var _Qw = $get($1.cws, ~~($1.num / 8)); /*16748*/
				var _Qy = -(7 - ($1.num % 8)); /*16748*/
				$k[$j++] = ((_Qy < 0 ? _Qw >>> -_Qy : _Qw << _Qy)) & 1; /*16749*/
				$k[$j++] = $1.pixs; /*16749*/
				$k[$j++] = $1.posx; /*16749*/
				$k[$j++] = $1.posy; /*16749*/
				$1.qmv(); /*16749*/
				var _R2 = $k[--$j]; /*16749*/
				var _R3 = $k[--$j]; /*16749*/
				$put(_R3, _R2, $k[--$j]); /*16749*/
				$1.num = $1.num + 1; /*16750*/
			} /*16750*/
			if ($1.col == 1) { /*16764*/
				$1.col = 0; /*16753*/
				$1.posx = $1.posx - 1; /*16754*/
			} else { /*16764*/
				$1.col = 1; /*16756*/
				$1.posx = $1.posx + 1; /*16757*/
				$1.posy = $1.posy + $1.dir; /*16758*/
				if (($1.posy < 0) || ($1.posy >= $1.size)) { /*16765*/
					$1.dir = $1.dir * -1; /*16760*/
					$1.posy = $1.posy + $1.dir; /*16761*/
					$1.posx = $1.posx - 2; /*16762*/
					if ($eq($1.format, "full") && ($1.posx == 6)) { /*16764*/
						$1.posx = $1.posx - 1; /*16764*/
					} /*16764*/
				} /*16764*/
			} /*16764*/
		} /*16764*/
		$1.evalfulln1n3 = function() {
			$1.scrle = $k[--$j]; /*16771*/
			$k[$j++] = "scr1"; /*16773*/
			$k[$j++] = 0; /*16773*/
			$forall($1.scrle, function() { /*16773*/
				var _RN = $k[--$j]; /*16773*/
				$k[$j++] = _RN; /*16773*/
				if (_RN >= 5) { /*16773*/
					var _RO = $k[--$j]; /*16773*/
					var _RQ = ($k[--$j] + _RO) - 2; /*16773*/
					$k[$j++] = _RQ; /*16773*/
					$k[$j++] = _RQ; /*16773*/
				} /*16773*/
				$j--; /*16773*/
			}); /*16773*/
			var _RR = $k[--$j]; /*16773*/
			$1[$k[--$j]] = _RR; /*16773*/
			$1.scr3 = 0; /*16775*/
			for (var _RV = 3, _RU = $1.scrle.length - 3; _RV <= _RU; _RV += 2) { /*16790*/
				$1.j = _RV; /*16777*/
				if (($get($1.scrle, $1.j) % 3) == 0) { /*16789*/
					$1.fact = ~~($get($1.scrle, $1.j) / 3); /*16779*/
					$forall($geti($1.scrle, $1.j - 2, 5), function() { /*16780*/
						var _Rg = $k[--$j]; /*16780*/
						$k[$j++] = _Rg == $1.fact; /*16780*/
					}); /*16780*/
					var _Rh = $k[--$j]; /*16780*/
					var _Ri = $k[--$j]; /*16780*/
					var _Rj = $k[--$j]; /*16780*/
					var _Rk = $k[--$j]; /*16780*/
					if ($k[--$j] && (_Rk && (_Ri && _Rh))) { /*16788*/
						if (($1.j == 3) || (($1.j + 4) >= $1.scrle.length)) { /*16785*/
							$1.scr3 = $1.scr3 + 40; /*16782*/
						} else { /*16785*/
							if (($get($1.scrle, $1.j - 3) >= 4) || ($get($1.scrle, $1.j + 3) >= 4)) { /*16786*/
								$1.scr3 = $1.scr3 + 40; /*16785*/
							} /*16785*/
						} /*16785*/
					} /*16785*/
				} /*16785*/
			} /*16785*/
			$k[$j++] = $1.scr1; /*16791*/
			$k[$j++] = $1.scr3; /*16791*/
		}; /*16792*/
		$1.evalfull = function() {
			$1.sym = $k[--$j]; /*16796*/
			$1.n1 = 0; /*16798*/
			$1.n2 = 0; /*16798*/
			$1.n3 = 0; /*16798*/
			$1.rle = $a($1.size + 1); /*16799*/
			$1.lastpairs = $a($1.size); /*16800*/
			$1.thispairs = $a($1.size); /*16801*/
			$1.sizeadd1 = $1.size + 1; /*16802*/
			for (var _S9 = 0, _S8 = $1.size - 1; _S9 <= _S8; _S9 += 1) { /*16841*/
				$1.i = _S9; /*16804*/
				$k[$j++] = Infinity; /*16807*/
				var _SB = $1.size; /*16808*/
				$k[$j++] = 0; /*16810*/
				$k[$j++] = 0; /*16810*/
				for (var _SD = $1.i, _SE = _SB, _SC = (_SB * _SB) - 1; _SE < 0 ? _SD >= _SC : _SD <= _SC; _SD += _SE) { /*16810*/
					var _SG = $get($1.sym, _SD); /*16809*/
					var _SH = $k[--$j]; /*16809*/
					$k[$j++] = _SG; /*16809*/
					if ($eq(_SH, _SG)) { /*16809*/
						var _SI = $k[--$j]; /*16809*/
						var _SJ = $k[--$j]; /*16809*/
						$k[$j++] = _SJ + 1; /*16809*/
						$k[$j++] = _SI; /*16809*/
					} else { /*16809*/
						var _SK = $k[--$j]; /*16809*/
						$k[$j++] = 1; /*16809*/
						$k[$j++] = _SK; /*16809*/
					} /*16809*/
				} /*16809*/
				$j--; /*16811*/
				var _SM = $counttomark() + 2; /*16812*/
				$astore($geti($1.rle, 0, _SM - 2)); /*16812*/
				$1.evalfulln1n3(); /*16813*/
				$1.n3 = $k[--$j] + $1.n3; /*16813*/
				$1.n1 = $k[--$j] + $1.n1; /*16813*/
				$j--; /*16814*/
				$1.symrow = $geti($1.sym, $1.i * $1.size, $1.size); /*16817*/
				$k[$j++] = Infinity; /*16818*/
				$k[$j++] = 0; /*16821*/
				$k[$j++] = 0; /*16821*/
				$forall($1.symrow, function() { /*16821*/
					var _SY = $k[--$j]; /*16820*/
					var _SZ = $k[--$j]; /*16820*/
					$k[$j++] = _SY; /*16820*/
					if ($eq(_SZ, _SY)) { /*16820*/
						var _Sa = $k[--$j]; /*16820*/
						var _Sb = $k[--$j]; /*16820*/
						$k[$j++] = _Sb + 1; /*16820*/
						$k[$j++] = _Sa; /*16820*/
					} else { /*16820*/
						var _Sc = $k[--$j]; /*16820*/
						$k[$j++] = 1; /*16820*/
						$k[$j++] = _Sc; /*16820*/
					} /*16820*/
				}); /*16820*/
				$j--; /*16822*/
				var _Se = $counttomark() + 2; /*16823*/
				$astore($geti($1.rle, 0, _Se - 2)); /*16823*/
				$1.evalfulln1n3(); /*16824*/
				$1.n3 = $k[--$j] + $1.n3; /*16824*/
				$1.n1 = $k[--$j] + $1.n1; /*16824*/
				$j--; /*16825*/
				var _Sk = $1.thispairs; /*16828*/
				$1.thispairs = $1.lastpairs; /*16828*/
				$1.lastpairs = _Sk; /*16828*/
				var _So = ($get($1.symrow, 0) == 1) ? 0 : 1; /*16829*/
				$k[$j++] = _So; /*16830*/
				$forall($1.symrow, function() { /*16830*/
					var _Sq = $k[--$j]; /*16830*/
					var _Sr = $k[--$j]; /*16830*/
					$k[$j++] = _Sr + _Sq; /*16830*/
					$k[$j++] = _Sq; /*16830*/
				}); /*16830*/
				$j--; /*16831*/
				$astore($1.thispairs); /*16832*/
				$j--; /*16832*/
				if ($1.i > 0) { /*16839*/
					$k[$j++] = Infinity; /*16834*/
					$aload($1.lastpairs); /*16835*/
					$aload($1.thispairs); /*16835*/
					$k[$j++] = $1.n2; /*16836*/
					for (var _Sy = 0, _Sz = $1.size; _Sy < _Sz; _Sy++) { /*16836*/
						var _T0 = $k[--$j]; /*16836*/
						var _T1 = $k[--$j]; /*16836*/
						$k[$j++] = _T0; /*16836*/
						$k[$j++] = _T1; /*16836*/
						var _T3 = $k[$j - 1 - $1.sizeadd1]; /*16836*/
						if ((($k[--$j] + _T3) & 3) == 0) { /*16836*/
							var _T5 = $k[--$j]; /*16836*/
							$k[$j++] = _T5 + 3; /*16836*/
						} /*16836*/
					} /*16836*/
					$1.n2 = $k[--$j]; /*16837*/
					$cleartomark(); /*16838*/
				} /*16838*/
			} /*16838*/
			$k[$j++] = "dark"; /*16844*/
			$k[$j++] = 0; /*16844*/
			$forall($1.sym, function() { /*16844*/
				var _T8 = $k[--$j]; /*16844*/
				var _T9 = $k[--$j]; /*16844*/
				$k[$j++] = _T9 + _T8; /*16844*/
			}); /*16844*/
			var _TA = $k[--$j]; /*16844*/
			$1[$k[--$j]] = _TA; /*16844*/
			var _TD = $1.size; /*16845*/
			$1.n4 = (~~((Math.abs((($1.dark * 100) / (_TD * _TD)) - 50)) / 5)) * 10; /*16845*/
			$k[$j++] = (($1.n1 + $1.n2) + $1.n3) + $1.n4; /*16847*/
		}; /*16848*/
		$1.evalmicro = function() {
			$1.sym = $k[--$j]; /*16852*/
			$1.dkrhs = 0; /*16853*/
			$1.dkbot = 0; /*16853*/
			for (var _TL = 1, _TK = $1.size - 1; _TL <= _TK; _TL += 1) { /*16858*/
				$1.i = _TL; /*16855*/
				$k[$j++] = "dkrhs"; /*16856*/
				$k[$j++] = $1.dkrhs; /*16856*/
				$k[$j++] = $1.sym; /*16856*/
				$k[$j++] = $1.size - 1; /*16856*/
				$k[$j++] = $1.i; /*16856*/
				$1.qmv(); /*16856*/
				var _TQ = $k[--$j]; /*16856*/
				var _TS = $get($k[--$j], _TQ); /*16856*/
				var _TT = $k[--$j]; /*16856*/
				$1[$k[--$j]] = _TT + _TS; /*16856*/
				$k[$j++] = "dkbot"; /*16857*/
				$k[$j++] = $1.dkbot; /*16857*/
				$k[$j++] = $1.sym; /*16857*/
				$k[$j++] = $1.i; /*16857*/
				$k[$j++] = $1.size - 1; /*16857*/
				$1.qmv(); /*16857*/
				var _TZ = $k[--$j]; /*16857*/
				var _Tb = $get($k[--$j], _TZ); /*16857*/
				var _Tc = $k[--$j]; /*16857*/
				$1[$k[--$j]] = _Tc + _Tb; /*16857*/
			} /*16857*/
			if ($1.dkrhs <= $1.dkbot) { /*16862*/
				$k[$j++] = -(($1.dkrhs * 16) + $1.dkbot); /*16860*/
			} else { /*16862*/
				$k[$j++] = -(($1.dkbot * 16) + $1.dkrhs); /*16862*/
			} /*16862*/
		}; /*16864*/
		$1.bestscore = 999999999; /*16867*/
		for (var _Tm = 0, _Tl = $1.masks.length - 1; _Tm <= _Tl; _Tm += 1) { /*16889*/
			$1.m = _Tm; /*16869*/
			$1.masksym = $a($1.size * $1.size); /*16870*/
			for (var _Tt = 0, _Ts = ($1.size * $1.size) - 1; _Tt <= _Ts; _Tt += 1) { /*16874*/
				$1.i = _Tt; /*16872*/
				$put($1.masksym, $1.i, $xo($get($1.pixs, $1.i), $get($get($1.masks, $1.m), $1.i))); /*16873*/
			} /*16873*/
			if ($1.masks.length != 1) { /*16887*/
				if ($eq($1.format, "full")) { /*16879*/
					$k[$j++] = $1.masksym; /*16877*/
					$1.evalfull(); /*16877*/
					$1.score = $k[--$j]; /*16877*/
				} else { /*16879*/
					$k[$j++] = $1.masksym; /*16879*/
					$1.evalmicro(); /*16879*/
					$1.score = $k[--$j]; /*16879*/
				} /*16879*/
				if ($1.score < $1.bestscore) { /*16885*/
					$1.bestsym = $1.masksym; /*16882*/
					$1.bestmaskval = $1.m; /*16883*/
					$1.bestscore = $1.score; /*16884*/
				} /*16884*/
			} else { /*16887*/
				$1.bestsym = $1.masksym; /*16887*/
			} /*16887*/
		} /*16887*/
		$1.pixs = $1.bestsym; /*16890*/
		if ($eq($1.format, "full")) { /*16910*/
			$1.fmtvals = $a([21522, 20773, 24188, 23371, 17913, 16590, 20375, 19104, 30660, 29427, 32170, 30877, 26159, 25368, 27713, 26998, 5769, 5054, 7399, 6608, 1890, 597, 3340, 2107, 13663, 12392, 16177, 14854, 9396, 8579, 11994, 11245]); /*16899*/
			$k[$j++] = "ecid"; /*16900*/
			$search("MLHQ", $1.eclevel); /*16900*/
			$j--; /*16900*/
			var _UK = $k[--$j]; /*16900*/
			var _UL = $k[--$j]; /*16900*/
			var _UM = $k[--$j]; /*16900*/
			$1[$k[--$j]] = _UK.length; /*16900*/
			$1.fmtval = $get($1.fmtvals, ($1.ecid << 3) + $1.bestmaskval); /*16901*/
		} else { /*16910*/
			$1.fmtvals = $a([17477, 16754, 20011, 19228, 21934, 20633, 24512, 23287, 26515, 25252, 28157, 26826, 30328, 29519, 31766, 31009, 1758, 1001, 3248, 2439, 5941, 4610, 7515, 6252, 9480, 8255, 12134, 10833, 13539, 12756, 16013, 15290]); /*16908*/
			$1.symid = $get($get($a([$a([0]), $a([1, 2]), $a([3, 4]), $a([5, 6, 7])]), ~~(($1.size - 11) / 2)), $1.eclval); /*16909*/
			$1.fmtval = $get($1.fmtvals, ($1.symid << 2) + $1.bestmaskval); /*16910*/
		} /*16910*/
		for (var _Ui = 0, _Uh = $1.formatmap.length - 1; _Ui <= _Uh; _Ui += 1) { /*16917*/
			$1.i = _Ui; /*16913*/
			$forall($get($1.formatmap, $1.i), function() { /*16916*/
				var _Un = $k[--$j]; /*16915*/
				$k[$j++] = $1.pixs; /*16915*/
				$forall(_Un); /*16915*/
				$1.qmv(); /*16915*/
				var _Uo = $1.fmtval; /*16915*/
				var _Uq = -(14 - $1.i); /*16915*/
				var _Ur = $k[--$j]; /*16915*/
				$put($k[--$j], _Ur, ((_Uq < 0 ? _Uo >>> -_Uq : _Uo << _Uq)) & 1); /*16915*/
			}); /*16915*/
		} /*16915*/
		if ($1.size >= 45) { /*16935*/
			$1.vervals = $a([31892, 34236, 39577, 42195, 48118, 51042, 55367, 58893, 63784, 68472, 70749, 76311, 79154, 84390, 87683, 92361, 96236, 102084, 102881, 110507, 110734, 117786, 119615, 126325, 127568, 133589, 136957, 141498, 145311, 150283, 152622, 158308, 161089, 167017]); /*16927*/
			$1.verval = $get($1.vervals, (~~(($1.size - 17) / 4)) - 7); /*16928*/
			for (var _V0 = 0, _Uz = $1.versionmap.length - 1; _V0 <= _Uz; _V0 += 1) { /*16934*/
				$1.i = _V0; /*16930*/
				$forall($get($1.versionmap, $1.i), function() { /*16933*/
					var _V5 = $k[--$j]; /*16932*/
					$k[$j++] = $1.pixs; /*16932*/
					$forall(_V5); /*16932*/
					$1.qmv(); /*16932*/
					var _V6 = $1.verval; /*16932*/
					var _V8 = -(17 - $1.i); /*16932*/
					var _V9 = $k[--$j]; /*16932*/
					$put($k[--$j], _V9, ((_V8 < 0 ? _V6 >>> -_V8 : _V6 << _V8)) & 1); /*16932*/
				}); /*16932*/
			} /*16932*/
		} /*16932*/
		var _VH = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.size,
			pixy: $1.size,
			height: ($1.size * 2) / 72,
			width: ($1.size * 2) / 72,
			opt: $1.options
		}; /*16945*/
		$k[$j++] = _VH; /*16948*/
		if (!$1.dontdraw) { /*16948*/
			$0.renmatrix(); /*16948*/
		} /*16948*/
	};
	$0.microqrcode = function() {
		var $1 = {}; /*16976*/
		$1.options = $k[--$j]; /*16978*/
		$1.barcode = $k[--$j]; /*16979*/
		$1.dontdraw = false; /*16981*/
		$forall($1.options, function() { /*16992*/
			var _3 = $k[--$j]; /*16992*/
			$1[$k[--$j]] = _3; /*16992*/
		}); /*16992*/
		$1.options.dontdraw = true; /*16995*/
		$1.options.format = "micro"; /*16996*/
		$k[$j++] = "args"; /*16998*/
		$k[$j++] = $1.barcode; /*16998*/
		$k[$j++] = $1.options; /*16998*/
		$0.qrcode(); /*16998*/
		var _9 = $k[--$j]; /*16998*/
		$1[$k[--$j]] = _9; /*16998*/
		$1.args.opt = $1.options; /*17000*/
		$k[$j++] = $1.args; /*17003*/
		if (!$1.dontdraw) { /*17003*/
			$0.renmatrix(); /*17003*/
		} /*17003*/
	};
	$0.maxicode = function() {
		var $1 = {}; /*17030*/
		$1.options = $k[--$j]; /*17032*/
		$1.barcode = $k[--$j]; /*17033*/
		$1.dontdraw = false; /*17035*/
		$1.mode = -1; /*17036*/
		$1.sam = -1; /*17037*/
		$1.parse = false; /*17038*/
		$forall($1.options, function() { /*17049*/
			var _3 = $k[--$j]; /*17049*/
			$1[$k[--$j]] = _3; /*17049*/
		}); /*17049*/
		$1.mode = ~~$1.mode; /*17051*/
		$1.sam = ~~$1.sam; /*17052*/
		$1.msg = $1.barcode; /*17075*/
		$1.msglen = $1.msg.length; /*17076*/
		if (($1.mode == 2) || ($1.mode == 3)) { /*17102*/
			if ($eq($geti($1.msg, 0, 7), "\x5b\x29\x3e\x1e\x30\x31\x1d")) { /*17086*/
				$1.fid = $geti($1.msg, 0, 9); /*17083*/
				$1.msg = $geti($1.msg, 9, $1.msglen - 9); /*17084*/
			} else { /*17086*/
				$1.fid = ""; /*17086*/
			} /*17086*/
			$search($1.msg, "\x1d"); /*17090*/
			$j--; /*17090*/
			$1.pcode = $k[--$j]; /*17090*/
			$j--; /*17091*/
			$search($k[--$j], "\x1d"); /*17091*/
			$j--; /*17091*/
			$1.ccode = $k[--$j]; /*17091*/
			$j--; /*17092*/
			$search($k[--$j], "\x1d"); /*17092*/
			$j--; /*17092*/
			$1.scode = $k[--$j]; /*17092*/
			$j--; /*17093*/
			$1.msg = $k[--$j]; /*17093*/
			var _R = $s($1.msg.length + $1.fid.length); /*17096*/
			$puti(_R, 0, $1.fid); /*17097*/
			$puti(_R, $1.fid.length, $1.msg); /*17098*/
			$1.msg = _R; /*17099*/
			$1.msglen = $1.msg.length; /*17100*/
		} /*17100*/
		$1.eci = -1; /*17105*/
		$1.pad = -2; /*17105*/
		$1.ns = -3; /*17105*/
		$1.la = -4; /*17106*/
		$1.lb = -5; /*17106*/
		$1.sa = -6; /*17107*/
		$1.sb = -7; /*17107*/
		$1.sc = -8; /*17107*/
		$1.sd = -9; /*17107*/
		$1.se = -10; /*17107*/
		$1.sa2 = -11; /*17108*/
		$1.sa3 = -12; /*17108*/
		$1.lkc = -13; /*17109*/
		$1.lkd = -14; /*17109*/
		$1.lke = -15; /*17109*/
		$1.pd2 = -16; /*17110*/
		$1.pd3 = -17; /*17110*/
		$1.charmaps = $a([$a([13, "`", 192, 224, 0]), $a(["A", "a", 193, 225, 1]), $a(["B", "b", 194, 226, 2]), $a(["C", "c", 195, 227, 3]), $a(["D", "d", 196, 228, 4]), $a(["E", "e", 197, 229, 5]), $a(["F", "f", 198, 230, 6]), $a(["G", "g", 199, 231, 7]), $a(["H", "h", 200, 232, 8]), $a(["I", "i", 201, 233, 9]), $a(["J", "j", 202, 234, 10]), $a(["K", "k", 203, 235, 11]), $a(["L", "l", 204, 236, 12]), $a(["M", "m", 205, 237, 13]), $a(["N", "n", 206, 238, 14]), $a(["O", "o", 207, 239, 15]), $a(["P", "p", 208, 240, 16]), $a(["Q", "q", 209, 241, 17]), $a(["R", "r", 210, 242, 18]), $a(["S", "s", 211, 243, 19]), $a(["T", "t", 212, 244, 20]), $a(["U", "u", 213, 245, 21]), $a(["V", "v", 214, 246, 22]), $a(["W", "w", 215, 247, 23]), $a(["X", "x", 216, 248, 24]), $a(["Y", "y", 217, 249, 25]), $a(["Z", "z", 218, 250, 26]), $a([$1.eci, $1.eci, $1.eci, $1.eci, $1.eci]), $a([28, 28, 28, 28, $1.pad]), $a([29, 29, 29, 29, $1.pad]), $a([30, 30, 30, 30, 27]), $a([$1.ns, $1.ns, $1.ns, $1.ns, $1.ns]), $a([" ", "{", 219, 251, 28]), $a([$1.pad, $1.pad, 220, 252, 29]), $a(["\"", "}", 221, 253, 30]), $a(["#", "~", 222, 254, 31]), $a(["$", 127, 223, 255, 159]), $a(["%", ";", 170, 161, 160]), $a(["&", "<", 172, 168, 162]), $a(["'", "=", 177, 171, 163]), $a([40, ">", 178, 175, 164]), $a([41, "?", 179, 176, 165]), $a(["*", "[", 181, 180, 166]), $a(["+", 92, 185, 183, 167]), $a([",", "]", 186, 184, 169]), $a(["-", "^", 188, 187, 173]), $a([".", "_", 189, 191, 174]), $a(["/", " ", 190, 138, 182]), $a(["0", ",", 128, 139, 149]), $a(["1", ".", 129, 140, 150]), $a(["2", "/", 130, 141, 151]), $a(["3", ":", 131, 142, 152]), $a(["4", "@", 132, 143, 153]), $a(["5", "!", 133, 144, 154]), $a(["6", "|", 134, 145, 155]), $a(["7", $1.pd2, 135, 146, 156]), $a(["8", $1.sa2, 136, 147, 157]), $a(["9", $1.sa3, 137, 148, 158]), $a([":", $1.pd3, $1.la, $1.la, $1.la]), $a([$1.sb, $1.sa, " ", " ", " "]), $a([$1.sc, $1.sc, $1.lkc, $1.sc, $1.sc]), $a([$1.sd, $1.sd, $1.sd, $1.lkd, $1.sd]), $a([$1.se, $1.se, $1.se, $1.se, $1.lke]), $a([$1.lb, $1.la, $1.lb, $1.lb, $1.lb])]); /*17179*/
		$1.charvals = $a([{}, {}, {}, {}, {}]); /*17182*/
		for (var _2J = 0, _2I = $1.charmaps.length - 1; _2J <= _2I; _2J += 1) { /*17191*/
			$1.i = _2J; /*17184*/
			$1.encs = $get($1.charmaps, $1.i); /*17185*/
			for (var _2N = 0; _2N <= 4; _2N += 1) { /*17190*/
				$1.j = _2N; /*17187*/
				var _2Q = $get($1.encs, $1.j); /*17188*/
				$k[$j++] = _2Q; /*17188*/
				if ($eq($type(_2Q), "stringtype")) { /*17188*/
					var _2T = $get($k[--$j], 0); /*17188*/
					$k[$j++] = _2T; /*17188*/
				} /*17188*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*17189*/
			} /*17189*/
		} /*17189*/
		$1.seta = $get($1.charvals, 0); /*17192*/
		$1.setb = $get($1.charvals, 1); /*17193*/
		$1.setc = $get($1.charvals, 2); /*17194*/
		$1.setd = $get($1.charvals, 3); /*17195*/
		$1.sete = $get($1.charvals, 4); /*17196*/
		$k[$j++] = Infinity; /*17199*/
		for (var _2k = 0, _2l = $1.msglen + 1; _2k < _2l; _2k++) { /*17199*/
			$k[$j++] = 0; /*17199*/
		} /*17199*/
		$1.nseq = $a(); /*17199*/
		for (var _2o = $1.msglen - 1; _2o >= 0; _2o -= 1) { /*17207*/
			$1.i = _2o; /*17201*/
			var _2r = $get($1.msg, $1.i); /*17202*/
			if ((_2r >= 48) && (_2r <= 57)) { /*17205*/
				$put($1.nseq, $1.i, $get($1.nseq, $1.i + 1) + 1); /*17203*/
			} else { /*17205*/
				$put($1.nseq, $1.i, 0); /*17205*/
			} /*17205*/
		} /*17205*/
		$1.nseq = $geti($1.nseq, 0, $1.msglen); /*17208*/
		$1.prefixinset = function() {
			$k[$j++] = 0; /*17215*/
			for (;;) { /*17215*/
				var _32 = $k[--$j]; /*17213*/
				var _33 = $k[--$j]; /*17213*/
				$k[$j++] = _33; /*17213*/
				$k[$j++] = _32; /*17213*/
				if (_32 >= _33.length) { /*17213*/
					break; /*17213*/
				} /*17213*/
				var _34 = $k[--$j]; /*17214*/
				var _35 = $k[--$j]; /*17214*/
				var _37 = $k[--$j]; /*17214*/
				var _38 = $get(_37, $get(_35, _34)) !== undefined; /*17214*/
				$k[$j++] = _37; /*17214*/
				$k[$j++] = _35; /*17214*/
				$k[$j++] = _34; /*17214*/
				if (_38) { /*17214*/
					var _39 = $k[--$j]; /*17214*/
					$k[$j++] = _39 + 1; /*17214*/
				} else { /*17214*/
					break; /*17214*/
				} /*17214*/
			} /*17214*/
			var _3A = $k[--$j]; /*17216*/
			var _3B = $k[--$j]; /*17216*/
			var _3C = $k[--$j]; /*17216*/
			$k[$j++] = _3A; /*17216*/
		}; /*17217*/
		$1.enc = function() {
			var _3D = $k[--$j]; /*17220*/
			$put($1.out, $1.j, $get(_3D, $k[--$j])); /*17220*/
			$1.j = $1.j + 1; /*17221*/
		}; /*17222*/
		$1.out = $a(144); /*17224*/
		$1.i = 0; /*17225*/
		$1.j = 0; /*17225*/
		$1.cset = "seta"; /*17225*/
		for (;;) { /*17348*/
			if ($1.i == $1.msglen) { /*17234*/
				if ($ne($1.cset, "seta") && $ne($1.cset, "setb")) { /*17232*/
					$k[$j++] = $1.la; /*17230*/
					$k[$j++] = $1[$1.cset]; /*17230*/
					$1.enc(); /*17230*/
					$1.cset = "seta"; /*17231*/
				} /*17231*/
				break; /*17233*/
			} /*17233*/
			for (;;) { /*17347*/
				if ($get($1.nseq, $1.i) >= 9) { /*17245*/
					$k[$j++] = ~~$z($geti($1.msg, $1.i, 9)); /*17239*/
					for (var _3X = 0, _3Y = 4; _3X < _3Y; _3X++) { /*17239*/
						var _3Z = $k[--$j]; /*17239*/
						$k[$j++] = _3Z & 63; /*17239*/
						$k[$j++] = _3Z >>> 6; /*17239*/
					} /*17239*/
					$k[$j++] = $get($1[$1.cset], $1.ns); /*17240*/
					for (var _3e = 0; _3e <= 10; _3e += 2) { /*17240*/
						var _3f = $k[$j - 1 - _3e]; /*17240*/
						$k[$j++] = _3f; /*17240*/
					} /*17240*/
					$astore($a(6)); /*17240*/
					var _3h = $k[--$j]; /*17240*/
					var _3i = $k[--$j]; /*17240*/
					var _3j = $k[--$j]; /*17240*/
					var _3k = $k[--$j]; /*17240*/
					var _3l = $k[--$j]; /*17240*/
					var _3m = $k[--$j]; /*17240*/
					var _3n = $k[--$j]; /*17240*/
					$k[$j++] = _3h; /*17240*/
					$k[$j++] = _3n; /*17240*/
					$k[$j++] = _3m; /*17240*/
					$k[$j++] = _3l; /*17240*/
					$k[$j++] = _3k; /*17240*/
					$k[$j++] = _3j; /*17240*/
					$k[$j++] = _3i; /*17240*/
					for (var _3o = 0, _3p = 6; _3o < _3p; _3o++) { /*17240*/
						$j--; /*17240*/
					} /*17240*/
					$puti($1.out, $1.j, $k[--$j]); /*17241*/
					$1.i = $1.i + 9; /*17242*/
					$1.j = $1.j + 6; /*17243*/
					break; /*17244*/
				} /*17244*/
				$1.char1 = $get($1.msg, $1.i); /*17248*/
				$k[$j++] = "char2"; /*17249*/
				if (($1.i + 1) < $1.msglen) { /*17249*/
					$k[$j++] = $get($1.msg, $1.i + 1); /*17249*/
				} else { /*17249*/
					$k[$j++] = -99; /*17249*/
				} /*17249*/
				var _43 = $k[--$j]; /*17249*/
				$1[$k[--$j]] = _43; /*17249*/
				$k[$j++] = "char3"; /*17250*/
				if (($1.i + 2) < $1.msglen) { /*17250*/
					$k[$j++] = $get($1.msg, $1.i + 2); /*17250*/
				} else { /*17250*/
					$k[$j++] = -99; /*17250*/
				} /*17250*/
				var _4A = $k[--$j]; /*17250*/
				$1[$k[--$j]] = _4A; /*17250*/
				var _4F = $get($1[$1.cset], $1.char1) !== undefined; /*17253*/
				if (_4F) { /*17257*/
					$k[$j++] = $1.char1; /*17254*/
					$k[$j++] = $1[$1.cset]; /*17254*/
					$1.enc(); /*17254*/
					$1.i = $1.i + 1; /*17255*/
					break; /*17256*/
				} /*17256*/
				var _4N = $get($1.setb, $1.char1) !== undefined; /*17260*/
				if ($eq($1.cset, "seta") && _4N) { /*17270*/
					var _4Q = $get($1.setb, $1.char2) !== undefined; /*17261*/
					if (_4Q) { /*17267*/
						$k[$j++] = $1.lb; /*17262*/
						$k[$j++] = $1.seta; /*17262*/
						$1.enc(); /*17262*/
						$1.cset = "setb"; /*17263*/
					} else { /*17267*/
						$k[$j++] = $1.sb; /*17265*/
						$k[$j++] = $1.seta; /*17265*/
						$1.enc(); /*17265*/
						$k[$j++] = $1.char1; /*17266*/
						$k[$j++] = $1.setb; /*17266*/
						$1.enc(); /*17266*/
						$1.i = $1.i + 1; /*17267*/
					} /*17267*/
					break; /*17269*/
				} /*17269*/
				var _4b = $get($1.seta, $1.char1) !== undefined; /*17273*/
				if ($eq($1.cset, "setb") && _4b) { /*17298*/
					var _4c = $1.seta; /*17274*/
					var _4d = $1.msg; /*17274*/
					var _4e = $1.i; /*17274*/
					var _4f = $1.msglen; /*17274*/
					var _4g = $1.i; /*17274*/
					var _4h = _4f - _4g; /*17274*/
					var _4i = 4; /*17274*/
					if (4 > (_4f - _4g)) { /*17274*/
						var _ = _4h; /*17274*/
						_4h = _4i; /*17274*/
						_4i = _; /*17274*/
					} /*17274*/
					$k[$j++] = "p"; /*17274*/
					$k[$j++] = _4c; /*17274*/
					$k[$j++] = $geti(_4d, _4e, _4i); /*17274*/
					$1.prefixinset(); /*17274*/
					var _4k = $k[--$j]; /*17274*/
					$1[$k[--$j]] = _4k; /*17274*/
					if ($1.p == 1) { /*17279*/
						$k[$j++] = $1.sa; /*17276*/
						$k[$j++] = $1.setb; /*17276*/
						$1.enc(); /*17276*/
						$k[$j++] = $1.char1; /*17277*/
						$k[$j++] = $1.seta; /*17277*/
						$1.enc(); /*17277*/
						$1.i = $1.i + 1; /*17278*/
					} /*17278*/
					if ($1.p == 2) { /*17285*/
						$k[$j++] = $1.sa2; /*17281*/
						$k[$j++] = $1.setb; /*17281*/
						$1.enc(); /*17281*/
						$k[$j++] = $1.char1; /*17282*/
						$k[$j++] = $1.seta; /*17282*/
						$1.enc(); /*17282*/
						$k[$j++] = $1.char2; /*17283*/
						$k[$j++] = $1.seta; /*17283*/
						$1.enc(); /*17283*/
						$1.i = $1.i + 2; /*17284*/
					} /*17284*/
					if ($1.p == 3) { /*17292*/
						$k[$j++] = $1.sa3; /*17287*/
						$k[$j++] = $1.setb; /*17287*/
						$1.enc(); /*17287*/
						$k[$j++] = $1.char1; /*17288*/
						$k[$j++] = $1.seta; /*17288*/
						$1.enc(); /*17288*/
						$k[$j++] = $1.char2; /*17289*/
						$k[$j++] = $1.seta; /*17289*/
						$1.enc(); /*17289*/
						$k[$j++] = $1.char3; /*17290*/
						$k[$j++] = $1.seta; /*17290*/
						$1.enc(); /*17290*/
						$1.i = $1.i + 3; /*17291*/
					} /*17291*/
					if ($1.p >= 4) { /*17296*/
						$k[$j++] = $1.la; /*17294*/
						$k[$j++] = $1.setb; /*17294*/
						$1.enc(); /*17294*/
						$1.cset = "seta"; /*17295*/
					} /*17295*/
					break; /*17297*/
				} /*17297*/
				var _5F = $get($1.seta, $1.char1) !== undefined; /*17301*/
				if (_5F) { /*17305*/
					$k[$j++] = $1.la; /*17302*/
					$k[$j++] = $1[$1.cset]; /*17302*/
					$1.enc(); /*17302*/
					$1.cset = "seta"; /*17303*/
					break; /*17304*/
				} /*17304*/
				var _5L = $get($1.setb, $1.char1) !== undefined; /*17306*/
				if (_5L) { /*17310*/
					$k[$j++] = $1.lb; /*17307*/
					$k[$j++] = $1[$1.cset]; /*17307*/
					$1.enc(); /*17307*/
					$1.cset = "setb"; /*17308*/
					break; /*17309*/
				} /*17309*/
				var _5R = $get($1.setc, $1.char1) !== undefined; /*17313*/
				if (_5R) { /*17313*/
					$1.setx = "setc"; /*17313*/
					$1.sx = $1.sc; /*17313*/
					$1.lkx = $1.lkc; /*17313*/
				} /*17313*/
				var _5W = $get($1.setd, $1.char1) !== undefined; /*17314*/
				if (_5W) { /*17314*/
					$1.setx = "setd"; /*17314*/
					$1.sx = $1.sd; /*17314*/
					$1.lkx = $1.lkd; /*17314*/
				} /*17314*/
				var _5b = $get($1.sete, $1.char1) !== undefined; /*17315*/
				if (_5b) { /*17315*/
					$1.setx = "sete"; /*17315*/
					$1.sx = $1.se; /*17315*/
					$1.lkx = $1.lke; /*17315*/
				} /*17315*/
				var _5f = $1[$1.setx]; /*17318*/
				var _5g = $1.msg; /*17318*/
				var _5h = $1.i; /*17318*/
				var _5i = $1.msglen; /*17318*/
				var _5j = $1.i; /*17318*/
				var _5k = _5i - _5j; /*17318*/
				var _5l = 4; /*17318*/
				if (4 > (_5i - _5j)) { /*17318*/
					var _ = _5k; /*17318*/
					_5k = _5l; /*17318*/
					_5l = _; /*17318*/
				} /*17318*/
				$k[$j++] = "p"; /*17318*/
				$k[$j++] = _5f; /*17318*/
				$k[$j++] = $geti(_5g, _5h, _5l); /*17318*/
				$1.prefixinset(); /*17318*/
				var _5n = $k[--$j]; /*17318*/
				$1[$k[--$j]] = _5n; /*17318*/
				if ($1.p == 1) { /*17323*/
					$k[$j++] = $1.sx; /*17320*/
					$k[$j++] = $1[$1.cset]; /*17320*/
					$1.enc(); /*17320*/
					$k[$j++] = $1.char1; /*17321*/
					$k[$j++] = $1[$1.setx]; /*17321*/
					$1.enc(); /*17321*/
					$1.i = $1.i + 1; /*17322*/
				} /*17322*/
				if ($1.p == 2) { /*17330*/
					$k[$j++] = $1.sx; /*17325*/
					$k[$j++] = $1[$1.cset]; /*17325*/
					$1.enc(); /*17325*/
					$k[$j++] = $1.char1; /*17326*/
					$k[$j++] = $1[$1.setx]; /*17326*/
					$1.enc(); /*17326*/
					$k[$j++] = $1.sx; /*17327*/
					$k[$j++] = $1[$1.cset]; /*17327*/
					$1.enc(); /*17327*/
					$k[$j++] = $1.char2; /*17328*/
					$k[$j++] = $1[$1.setx]; /*17328*/
					$1.enc(); /*17328*/
					$1.i = $1.i + 2; /*17329*/
				} /*17329*/
				if ($1.p == 3) { /*17339*/
					$k[$j++] = $1.sx; /*17332*/
					$k[$j++] = $1[$1.cset]; /*17332*/
					$1.enc(); /*17332*/
					$k[$j++] = $1.char1; /*17333*/
					$k[$j++] = $1[$1.setx]; /*17333*/
					$1.enc(); /*17333*/
					$k[$j++] = $1.sx; /*17334*/
					$k[$j++] = $1[$1.cset]; /*17334*/
					$1.enc(); /*17334*/
					$k[$j++] = $1.char2; /*17335*/
					$k[$j++] = $1[$1.setx]; /*17335*/
					$1.enc(); /*17335*/
					$k[$j++] = $1.sx; /*17336*/
					$k[$j++] = $1[$1.cset]; /*17336*/
					$1.enc(); /*17336*/
					$k[$j++] = $1.char3; /*17337*/
					$k[$j++] = $1[$1.setx]; /*17337*/
					$1.enc(); /*17337*/
					$1.i = $1.i + 3; /*17338*/
				} /*17338*/
				if ($1.p >= 4) { /*17344*/
					$k[$j++] = $1.sx; /*17341*/
					$k[$j++] = $1[$1.cset]; /*17341*/
					$1.enc(); /*17341*/
					$k[$j++] = $1.lkx; /*17342*/
					$k[$j++] = $1[$1.setx]; /*17342*/
					$1.enc(); /*17342*/
					$1.cset = $1.setx; /*17343*/
				} /*17343*/
				break; /*17346*/
			} /*17346*/
		} /*17346*/
		$1.encmsg = $geti($1.out, 0, $1.j); /*17349*/
		$1.padval = $get($1[$1.cset], $1.pad); /*17350*/
		$1.sami = $a([]); /*17353*/
		if ($1.sam != -1) { /*17358*/
			$1.sami = $a(2); /*17355*/
			$put($1.sami, 0, $get($1.seta, $1.pad)); /*17356*/
			$put($1.sami, 1, (((~~($1.sam / 10)) - 1) * 8) + (($1.sam % 10) - 1)); /*17357*/
		} /*17357*/
		$k[$j++] = Infinity; /*17359*/
		$aload($1.sami); /*17359*/
		$aload($1.encmsg); /*17359*/
		$1.encmsg = $a(); /*17359*/
		if (($1.mode == 2) || ($1.mode == 3)) { /*17414*/
			var _70 = $strcpy($s(4), "0000"); /*17365*/
			var _73 = $cvrs($s(4), ~~$1.mode, 2); /*17365*/
			$puti(_70, 4 - _73.length, _73); /*17365*/
			$1.mdb = _70; /*17365*/
			var _75 = $strcpy($s(10), "0000000000"); /*17366*/
			var _78 = $cvrs($s(10), ~~$z($1.ccode), 2); /*17366*/
			$puti(_75, 10 - _78.length, _78); /*17366*/
			$1.ccb = _75; /*17366*/
			var _7A = $strcpy($s(10), "0000000000"); /*17367*/
			var _7D = $cvrs($s(10), ~~$z($1.scode), 2); /*17367*/
			$puti(_7A, 10 - _7D.length, _7D); /*17367*/
			$1.scb = _7A; /*17367*/
			$1.pcb = $strcpy($s(36), "000000000000000000000000000000000000"); /*17368*/
			if ($1.mode == 2) { /*17381*/
				var _7K = $cvrs($s(6), $1.pcode.length, 2); /*17371*/
				$puti($1.pcb, 6 - _7K.length, _7K); /*17371*/
				var _7O = $cvrs($s(30), ~~$z($1.pcode), 2); /*17372*/
				$puti($1.pcb, 36 - _7O.length, _7O); /*17372*/
			} else { /*17381*/
				$k[$j++] = Infinity; /*17378*/
				var _7Q = $strcpy($s(6), "      "); /*17376*/
				$k[$j++] = _7Q; /*17376*/
				$k[$j++] = _7Q; /*17376*/
				$k[$j++] = 0; /*17376*/
				if ($1.pcode.length > 6) { /*17376*/
					$k[$j++] = $geti($1.pcode, 0, 6); /*17376*/
				} else { /*17376*/
					$k[$j++] = $1.pcode; /*17376*/
				} /*17376*/
				var _7V = $k[--$j]; /*17376*/
				var _7W = $k[--$j]; /*17376*/
				$puti($k[--$j], _7W, _7V); /*17376*/
				$forall($k[--$j], function() { /*17377*/
					var _7b = $get($1.seta, $k[--$j]); /*17377*/
					$k[$j++] = _7b; /*17377*/
				}); /*17377*/
				$1.pccw = $a(); /*17378*/
				for (var _7d = 0; _7d <= 5; _7d += 1) { /*17382*/
					$1.i = _7d; /*17380*/
					var _7j = $cvrs($s(6), $get($1.pccw, $1.i), 2); /*17381*/
					$puti($1.pcb, ((6 * $1.i) + 6) - _7j.length, _7j); /*17381*/
				} /*17381*/
			} /*17381*/
			$1.scm = $s(60); /*17386*/
			$puti($1.scm, 2, $1.mdb); /*17387*/
			$puti($1.scm, 38, $geti($1.pcb, 0, 4)); /*17388*/
			$puti($1.scm, 30, $geti($1.pcb, 4, 6)); /*17389*/
			$puti($1.scm, 24, $geti($1.pcb, 10, 6)); /*17390*/
			$puti($1.scm, 18, $geti($1.pcb, 16, 6)); /*17391*/
			$puti($1.scm, 12, $geti($1.pcb, 22, 6)); /*17392*/
			$puti($1.scm, 6, $geti($1.pcb, 28, 6)); /*17393*/
			$puti($1.scm, 0, $geti($1.pcb, 34, 2)); /*17394*/
			$puti($1.scm, 52, $geti($1.ccb, 0, 2)); /*17395*/
			$puti($1.scm, 42, $geti($1.ccb, 2, 6)); /*17396*/
			$puti($1.scm, 36, $geti($1.ccb, 8, 2)); /*17397*/
			$puti($1.scm, 54, $geti($1.scb, 0, 6)); /*17398*/
			$puti($1.scm, 48, $geti($1.scb, 6, 4)); /*17399*/
			$1.pri = $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]); /*17402*/
			for (var _8P = 0; _8P <= 59; _8P += 1) { /*17408*/
				$1.i = _8P; /*17404*/
				$1.ps = ~~($1.i / 6); /*17405*/
				$1.ep = (~~(Math.pow(2, 5 - ($1.i % 6)))) * ($get($1.scm, $1.i) - 48); /*17406*/
				$put($1.pri, $1.ps, $get($1.pri, $1.ps) + $1.ep); /*17407*/
			} /*17407*/
			$k[$j++] = Infinity; /*17411*/
			for (var _8b = 0, _8c = 84; _8b < _8c; _8b++) { /*17411*/
				$k[$j++] = $1.padval; /*17411*/
			} /*17411*/
			$1.sec = $a(); /*17411*/
			$puti($1.sec, 0, $1.encmsg); /*17412*/
		} /*17412*/
		if (((($1.mode == 4) || ($1.mode == 5)) || ($1.mode == 6)) || ($1.mode == -1)) { /*17433*/
			if ($1.mode == -1) { /*17422*/
				var _8n = ($1.encmsg.length <= 77) ? 5 : 4; /*17421*/
				$1.mode = _8n; /*17421*/
			} /*17421*/
			$k[$j++] = Infinity; /*17425*/
			var _8p = ($1.mode == 5) ? 78 : 94; /*17425*/
			for (var _8q = 0, _8r = _8p; _8q < _8r; _8q++) { /*17425*/
				$k[$j++] = $1.padval; /*17425*/
			} /*17425*/
			$1.cws = $a(); /*17425*/
			$put($1.cws, 0, $1.mode); /*17426*/
			$puti($1.cws, 1, $1.encmsg); /*17427*/
			$1.pri = $geti($1.cws, 0, 10); /*17430*/
			$1.sec = $geti($1.cws, 10, $1.cws.length - 10); /*17431*/
		} /*17431*/
		$k[$j++] = Infinity; /*17436*/
		$k[$j++] = 1; /*17436*/
		for (var _93 = 0, _94 = 63; _93 < _94; _93++) { /*17436*/
			var _95 = $k[--$j]; /*17436*/
			var _96 = _95 * 2; /*17436*/
			$k[$j++] = _95; /*17436*/
			$k[$j++] = _96; /*17436*/
			if (_96 >= 64) { /*17436*/
				var _97 = $k[--$j]; /*17436*/
				$k[$j++] = _97 ^ 67; /*17436*/
			} /*17436*/
		} /*17436*/
		$1.rsalog = $a(); /*17436*/
		$1.rslog = $a(64); /*17437*/
		for (var _9A = 1; _9A <= 63; _9A += 1) { /*17438*/
			$put($1.rslog, $get($1.rsalog, _9A), _9A); /*17438*/
		} /*17438*/
		$1.rsprod = function() {
			var _9E = $k[--$j]; /*17442*/
			var _9F = $k[--$j]; /*17442*/
			$k[$j++] = _9F; /*17446*/
			$k[$j++] = _9E; /*17446*/
			if ((_9E != 0) && (_9F != 0)) { /*17445*/
				var _9I = $get($1.rslog, $k[--$j]); /*17443*/
				var _9N = $get($1.rsalog, (_9I + $get($1.rslog, $k[--$j])) % 63); /*17443*/
				$k[$j++] = _9N; /*17443*/
			} else { /*17445*/
				$j -= 2; /*17445*/
				$k[$j++] = 0; /*17445*/
			} /*17445*/
		}; /*17447*/
		$1.rscodes = function() {
			$1.rsnum = $k[--$j]; /*17452*/
			$1.cwb = $k[--$j]; /*17453*/
			$k[$j++] = Infinity; /*17456*/
			$k[$j++] = 1; /*17456*/
			for (var _9R = 0, _9S = $1.rsnum; _9R < _9S; _9R++) { /*17456*/
				$k[$j++] = 0; /*17456*/
			} /*17456*/
			$1.coeffs = $a(); /*17456*/
			for (var _9W = 1, _9V = $1.rsnum; _9W <= _9V; _9W += 1) { /*17465*/
				$1.i = _9W; /*17458*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*17459*/
				for (var _9d = $1.i - 1; _9d >= 1; _9d -= 1) { /*17463*/
					$1.j = _9d; /*17461*/
					$k[$j++] = $1.coeffs; /*17462*/
					$k[$j++] = $1.j; /*17462*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*17462*/
					$k[$j++] = $get($1.coeffs, $1.j); /*17462*/
					$k[$j++] = $get($1.rsalog, $1.i); /*17462*/
					$1.rsprod(); /*17462*/
					var _9p = $k[--$j]; /*17462*/
					var _9q = $k[--$j]; /*17462*/
					var _9r = $k[--$j]; /*17462*/
					$put($k[--$j], _9r, $xo(_9q, _9p)); /*17462*/
				} /*17462*/
				$k[$j++] = $1.coeffs; /*17464*/
				$k[$j++] = 0; /*17464*/
				$k[$j++] = $get($1.coeffs, 0); /*17464*/
				$k[$j++] = $get($1.rsalog, $1.i); /*17464*/
				$1.rsprod(); /*17464*/
				var _9z = $k[--$j]; /*17464*/
				var _A0 = $k[--$j]; /*17464*/
				$put($k[--$j], _A0, _9z); /*17464*/
			} /*17464*/
			$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*17466*/
			$k[$j++] = Infinity; /*17469*/
			for (var _A6 = 0, _A7 = $1.rsnum; _A6 < _A7; _A6++) { /*17469*/
				$k[$j++] = 0; /*17469*/
			} /*17469*/
			$1.ecb = $a(); /*17469*/
			for (var _AB = 0, _AA = $1.cwb.length - 1; _AB <= _AA; _AB += 1) { /*17478*/
				$1.t = $xo($get($1.cwb, _AB), $get($1.ecb, 0)); /*17471*/
				for (var _AH = $1.ecb.length - 1; _AH >= 0; _AH -= 1) { /*17477*/
					$1.i = _AH; /*17473*/
					$1.p = ($1.ecb.length - $1.i) - 1; /*17474*/
					$k[$j++] = $1.ecb; /*17475*/
					$k[$j++] = $1.p; /*17475*/
					$k[$j++] = $1.t; /*17475*/
					$k[$j++] = $get($1.coeffs, $1.i); /*17475*/
					$1.rsprod(); /*17475*/
					var _AQ = $k[--$j]; /*17475*/
					var _AR = $k[--$j]; /*17475*/
					$put($k[--$j], _AR, _AQ); /*17475*/
					if ($1.i > 0) { /*17476*/
						$put($1.ecb, $1.p, $xo($get($1.ecb, $1.p + 1), $get($1.ecb, $1.p))); /*17476*/
					} /*17476*/
				} /*17476*/
			} /*17476*/
			$k[$j++] = $1.ecb; /*17480*/
		}; /*17482*/
		$k[$j++] = Infinity; /*17485*/
		for (var _Af = 0, _Ae = $1.sec.length - 1; _Af <= _Ae; _Af += 2) { /*17485*/
			$k[$j++] = $get($1.sec, _Af); /*17485*/
		} /*17485*/
		$1.seco = $a(); /*17485*/
		$k[$j++] = Infinity; /*17486*/
		for (var _Al = 1, _Ak = $1.sec.length - 1; _Al <= _Ak; _Al += 2) { /*17486*/
			$k[$j++] = $get($1.sec, _Al); /*17486*/
		} /*17486*/
		$1.sece = $a(); /*17486*/
		var _Aq = ($1.sec.length == 84) ? 20 : 28; /*17489*/
		$1.scodes = _Aq; /*17489*/
		$k[$j++] = "secochk"; /*17490*/
		$k[$j++] = $1.seco; /*17490*/
		$k[$j++] = $1.scodes; /*17490*/
		$1.rscodes(); /*17490*/
		var _At = $k[--$j]; /*17490*/
		$1[$k[--$j]] = _At; /*17490*/
		$k[$j++] = "secechk"; /*17491*/
		$k[$j++] = $1.sece; /*17491*/
		$k[$j++] = $1.scodes; /*17491*/
		$1.rscodes(); /*17491*/
		var _Ax = $k[--$j]; /*17491*/
		$1[$k[--$j]] = _Ax; /*17491*/
		$k[$j++] = Infinity; /*17494*/
		for (var _B1 = 0, _B0 = $1.scodes - 1; _B1 <= _B0; _B1 += 1) { /*17494*/
			$k[$j++] = $get($1.secochk, _B1); /*17494*/
			$k[$j++] = $get($1.secechk, _B1); /*17494*/
		} /*17494*/
		$1.secchk = $a(); /*17494*/
		$k[$j++] = Infinity; /*17502*/
		$aload($1.pri); /*17498*/
		$k[$j++] = $1.pri; /*17499*/
		$k[$j++] = 10; /*17499*/
		$1.rscodes(); /*17499*/
		$aload($k[--$j]); /*17499*/
		$aload($1.sec); /*17500*/
		$aload($1.secchk); /*17501*/
		$1.codewords = $a(); /*17502*/
		$k[$j++] = Infinity; /*17505*/
		for (var _BD = 0, _BE = 864; _BD < _BE; _BD++) { /*17505*/
			$k[$j++] = 0; /*17505*/
		} /*17505*/
		$1.mods = $a(); /*17505*/
		for (var _BG = 0; _BG <= 143; _BG += 1) { /*17510*/
			$1.i = _BG; /*17507*/
			$k[$j++] = Infinity; /*17508*/
			var _BL = $cvrs($s(6), $get($1.codewords, $1.i), 2); /*17508*/
			for (var _BM = 0, _BN = _BL.length; _BM < _BN; _BM++) { /*17508*/
				$k[$j++] = $get(_BL, _BM) - 48; /*17508*/
			} /*17508*/
			$1.cw = $a(); /*17508*/
			$puti($1.mods, (6 * $1.i) + (6 - $1.cw.length), $1.cw); /*17509*/
		} /*17509*/
		$1.modmap = $a([469, 529, 286, 316, 347, 346, 673, 672, 703, 702, 647, 676, 283, 282, 313, 312, 370, 610, 618, 379, 378, 409, 408, 439, 705, 704, 559, 589, 588, 619, 458, 518, 640, 701, 675, 674, 285, 284, 315, 314, 310, 340, 531, 289, 288, 319, 349, 348, 456, 486, 517, 516, 471, 470, 369, 368, 399, 398, 429, 428, 549, 548, 579, 578, 609, 608, 649, 648, 679, 678, 709, 708, 639, 638, 669, 668, 699, 698, 279, 278, 309, 308, 339, 338, 381, 380, 411, 410, 441, 440, 561, 560, 591, 590, 621, 620, 547, 546, 577, 576, 607, 606, 367, 366, 397, 396, 427, 426, 291, 290, 321, 320, 351, 350, 651, 650, 681, 680, 711, 710, 1, 0, 31, 30, 61, 60, 3, 2, 33, 32, 63, 62, 5, 4, 35, 34, 65, 64, 7, 6, 37, 36, 67, 66, 9, 8, 39, 38, 69, 68, 11, 10, 41, 40, 71, 70, 13, 12, 43, 42, 73, 72, 15, 14, 45, 44, 75, 74, 17, 16, 47, 46, 77, 76, 19, 18, 49, 48, 79, 78, 21, 20, 51, 50, 81, 80, 23, 22, 53, 52, 83, 82, 25, 24, 55, 54, 85, 84, 27, 26, 57, 56, 87, 86, 117, 116, 147, 146, 177, 176, 115, 114, 145, 144, 175, 174, 113, 112, 143, 142, 173, 172, 111, 110, 141, 140, 171, 170, 109, 108, 139, 138, 169, 168, 107, 106, 137, 136, 167, 166, 105, 104, 135, 134, 165, 164, 103, 102, 133, 132, 163, 162, 101, 100, 131, 130, 161, 160, 99, 98, 129, 128, 159, 158, 97, 96, 127, 126, 157, 156, 95, 94, 125, 124, 155, 154, 93, 92, 123, 122, 153, 152, 91, 90, 121, 120, 151, 150, 181, 180, 211, 210, 241, 240, 183, 182, 213, 212, 243, 242, 185, 184, 215, 214, 245, 244, 187, 186, 217, 216, 247, 246, 189, 188, 219, 218, 249, 248, 191, 190, 221, 220, 251, 250, 193, 192, 223, 222, 253, 252, 195, 194, 225, 224, 255, 254, 197, 196, 227, 226, 257, 256, 199, 198, 229, 228, 259, 258, 201, 200, 231, 230, 261, 260, 203, 202, 233, 232, 263, 262, 205, 204, 235, 234, 265, 264, 207, 206, 237, 236, 267, 266, 297, 296, 327, 326, 357, 356, 295, 294, 325, 324, 355, 354, 293, 292, 323, 322, 353, 352, 277, 276, 307, 306, 337, 336, 275, 274, 305, 304, 335, 334, 273, 272, 303, 302, 333, 332, 271, 270, 301, 300, 331, 330, 361, 360, 391, 390, 421, 420, 363, 362, 393, 392, 423, 422, 365, 364, 395, 394, 425, 424, 383, 382, 413, 412, 443, 442, 385, 384, 415, 414, 445, 444, 387, 386, 417, 416, 447, 446, 477, 476, 507, 506, 537, 536, 475, 474, 505, 504, 535, 534, 473, 472, 503, 502, 533, 532, 455, 454, 485, 484, 515, 514, 453, 452, 483, 482, 513, 512, 451, 450, 481, 480, 511, 510, 541, 540, 571, 570, 601, 600, 543, 542, 573, 572, 603, 602, 545, 544, 575, 574, 605, 604, 563, 562, 593, 592, 623, 622, 565, 564, 595, 594, 625, 624, 567, 566, 597, 596, 627, 626, 657, 656, 687, 686, 717, 716, 655, 654, 685, 684, 715, 714, 653, 652, 683, 682, 713, 712, 637, 636, 667, 666, 697, 696, 635, 634, 665, 664, 695, 694, 633, 632, 663, 662, 693, 692, 631, 630, 661, 660, 691, 690, 721, 720, 751, 750, 781, 780, 723, 722, 753, 752, 783, 782, 725, 724, 755, 754, 785, 784, 727, 726, 757, 756, 787, 786, 729, 728, 759, 758, 789, 788, 731, 730, 761, 760, 791, 790, 733, 732, 763, 762, 793, 792, 735, 734, 765, 764, 795, 794, 737, 736, 767, 766, 797, 796, 739, 738, 769, 768, 799, 798, 741, 740, 771, 770, 801, 800, 743, 742, 773, 772, 803, 802, 745, 744, 775, 774, 805, 804, 747, 746, 777, 776, 807, 806, 837, 836, 867, 866, 897, 896, 835, 834, 865, 864, 895, 894, 833, 832, 863, 862, 893, 892, 831, 830, 861, 860, 891, 890, 829, 828, 859, 858, 889, 888, 827, 826, 857, 856, 887, 886, 825, 824, 855, 854, 885, 884, 823, 822, 853, 852, 883, 882, 821, 820, 851, 850, 881, 880, 819, 818, 849, 848, 879, 878, 817, 816, 847, 846, 877, 876, 815, 814, 845, 844, 875, 874, 813, 812, 843, 842, 873, 872, 811, 810, 841, 840, 871, 870, 901, 900, 931, 930, 961, 960, 903, 902, 933, 932, 963, 962, 905, 904, 935, 934, 965, 964, 907, 906, 937, 936, 967, 966, 909, 908, 939, 938, 969, 968, 911, 910, 941, 940, 971, 970, 913, 912, 943, 942, 973, 972, 915, 914, 945, 944, 975, 974, 917, 916, 947, 946, 977, 976, 919, 918, 949, 948, 979, 978, 921, 920, 951, 950, 981, 980, 923, 922, 953, 952, 983, 982, 925, 924, 955, 954, 985, 984, 927, 926, 957, 956, 987, 986, 58, 89, 88, 118, 149, 148, 178, 209, 208, 238, 269, 268, 298, 329, 328, 358, 389, 388, 418, 449, 448, 478, 509, 508, 538, 569, 568, 598, 629, 628, 658, 689, 688, 718, 749, 748, 778, 809, 808, 838, 869, 868, 898, 929, 928, 958, 989, 988]); /*17558*/
		$1.pixs = $a(864); /*17561*/
		$1.j = 0; /*17562*/
		for (var _BY = 0, _BX = $1.mods.length - 1; _BY <= _BX; _BY += 1) { /*17569*/
			$1.i = _BY; /*17564*/
			if ($get($1.mods, $1.i) == 1) { /*17568*/
				$put($1.pixs, $1.j, $get($1.modmap, $1.i)); /*17566*/
				$1.j = $1.j + 1; /*17567*/
			} /*17567*/
		} /*17567*/
		$k[$j++] = Infinity; /*17570*/
		$forall($geti($1.pixs, 0, $1.j)); /*17570*/
		$k[$j++] = 28; /*17570*/
		$k[$j++] = 29; /*17570*/
		$k[$j++] = 280; /*17570*/
		$k[$j++] = 281; /*17570*/
		$k[$j++] = 311; /*17570*/
		$k[$j++] = 457; /*17570*/
		$k[$j++] = 488; /*17570*/
		$k[$j++] = 500; /*17570*/
		$k[$j++] = 530; /*17570*/
		$k[$j++] = 670; /*17570*/
		$k[$j++] = 700; /*17570*/
		$k[$j++] = 677; /*17570*/
		$k[$j++] = 707; /*17570*/
		$1.pixs = $a(); /*17570*/
		var _Bo = {
			ren: $0.renmaximatrix,
			pixs: $1.pixs,
			opt: $1.options
		}; /*17576*/
		$k[$j++] = _Bo; /*17579*/
		if (!$1.dontdraw) { /*17579*/
			$0.renmaximatrix(); /*17579*/
		} /*17579*/
	};
	$0.azteccode = function() {
		var $1 = {}; /*17606*/
		$1.options = $k[--$j]; /*17608*/
		$1.barcode = $k[--$j]; /*17609*/
		$1.dontdraw = false; /*17611*/
		$1.format = "unset"; /*17612*/
		$1.readerinit = false; /*17613*/
		$1.layers = -1; /*17614*/
		$1.eclevel = 23; /*17615*/
		$1.ecaddchars = 3; /*17616*/
		$1.raw = false; /*17617*/
		$1.parse = false; /*17618*/
		$forall($1.options, function() { /*17629*/
			var _3 = $k[--$j]; /*17629*/
			$1[$k[--$j]] = _3; /*17629*/
		}); /*17629*/
		$1.layers = ~~$1.layers; /*17631*/
		$1.eclevel = +$1.eclevel; /*17632*/
		$1.ecaddchars = ~~$1.ecaddchars; /*17633*/
		$1.msgbits = ""; /*17657*/
		if ($ne($1.format, "rune") && $1.raw) { /*17658*/
			$1.msgbits = $1.barcode; /*17658*/
		} /*17658*/
		if ($ne($1.format, "rune") && (!$1.raw)) { /*17955*/
			$1.U = 0; /*17662*/
			$1.L = 1; /*17662*/
			$1.M = 2; /*17662*/
			$1.P = 3; /*17662*/
			$1.D = 4; /*17662*/
			$1.B = 5; /*17662*/
			$1.lu = -1; /*17665*/
			$1.ll = -2; /*17665*/
			$1.lm = -3; /*17665*/
			$1.lp = -4; /*17666*/
			$1.ld = -5; /*17666*/
			$1.su = -6; /*17666*/
			$1.sp = -7; /*17667*/
			$1.sb = -8; /*17667*/
			$1.fl = -9; /*17667*/
			$1.p2 = -10; /*17668*/
			$1.p3 = -11; /*17668*/
			$1.p4 = -12; /*17668*/
			$1.p5 = -13; /*17668*/
			$1.charmaps = $a([$a([$1.sp, $1.sp, $1.sp, $1.fl, $1.sp]), $a([32, 32, 32, 13, 32]), $a(["A", "a", 1, $1.p2, "0"]), $a(["B", "b", 2, $1.p3, "1"]), $a(["C", "c", 3, $1.p4, "2"]), $a(["D", "d", 4, $1.p5, "3"]), $a(["E", "e", 5, "!", "4"]), $a(["F", "f", 6, "\"", "5"]), $a(["G", "g", 7, "#", "6"]), $a(["H", "h", 8, "$", "7"]), $a(["I", "i", 9, "%", "8"]), $a(["J", "j", 10, "&", "9"]), $a(["K", "k", 11, "'", ","]), $a(["L", "l", 12, 40, "."]), $a(["M", "m", 13, 41, $1.lu]), $a(["N", "n", 27, "*", $1.su]), $a(["O", "o", 28, "+", -99]), $a(["P", "p", 29, ",", -99]), $a(["Q", "q", 30, "-", -99]), $a(["R", "r", 31, ".", -99]), $a(["S", "s", "@", "/", -99]), $a(["T", "t", 92, ":", -99]), $a(["U", "u", "^", ";", -99]), $a(["V", "v", "_", "<", -99]), $a(["W", "w", "`", "=", -99]), $a(["X", "x", "|", ">", -99]), $a(["Y", "y", "~", "?", -99]), $a(["Z", "z", 127, "[", -99]), $a([$1.ll, $1.su, $1.ll, "]", -99]), $a([$1.lm, $1.lm, $1.lu, "{", -99]), $a([$1.ld, $1.ld, $1.lp, "}", -99]), $a([$1.sb, $1.sb, $1.sb, $1.lu, -99])]); /*17705*/
			$1.charvals = $a([{}, {}, {}, {}, {}]); /*17708*/
			for (var _1B = 0, _1A = $1.charmaps.length - 1; _1B <= _1A; _1B += 1) { /*17717*/
				$1.i = _1B; /*17710*/
				$1.encs = $get($1.charmaps, $1.i); /*17711*/
				for (var _1F = 0; _1F <= 4; _1F += 1) { /*17716*/
					$1.j = _1F; /*17713*/
					var _1I = $get($1.encs, $1.j); /*17714*/
					$k[$j++] = _1I; /*17714*/
					if ($eq($type(_1I), "stringtype")) { /*17714*/
						var _1L = $get($k[--$j], 0); /*17714*/
						$k[$j++] = _1L; /*17714*/
					} /*17714*/
					$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*17715*/
				} /*17715*/
			} /*17715*/
			var _1V = {
				"\x0d\x0a": $1.p2,
				". ": $1.p3,
				", ": $1.p4,
				": ": $1.p5
			}; /*17724*/
			$1.pcomp = _1V; /*17725*/
			$1.e = 10000; /*17727*/
			$1.latlen = $a([$a([0, 5, 5, 10, 5, 10]), $a([9, 0, 5, 10, 5, 10]), $a([5, 5, 0, 5, 10, 10]), $a([5, 10, 10, 0, 10, 15]), $a([4, 9, 9, 14, 0, 14]), $a([0, 0, 0, 0, 0, 0])]); /*17737*/
			$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.lm]), $a([$1.lm, $1.lp]), $a([$1.ld]), $a([$1.sb])]), $a([$a([$1.ld, $1.lu]), $a([]), $a([$1.lm]), $a([$1.lm, $1.lp]), $a([$1.ld]), $a([$1.sb])]), $a([$a([$1.lu]), $a([$1.ll]), $a([]), $a([$1.lp]), $a([$1.lu, $1.ld]), $a([$1.sb])]), $a([$a([$1.lu]), $a([$1.lu, $1.ll]), $a([$1.lu, $1.lm]), $a([]), $a([$1.lu, $1.ld]), $a([$1.lu, $1.sb])]), $a([$a([$1.lu]), $a([$1.lu, $1.ll]), $a([$1.lu, $1.lm]), $a([$1.lu, $1.lm, $1.lp]), $a([]), $a([$1.lu, $1.sb])]), $a([$a([$1.lu]), $a([$1.ll]), $a([$1.lm]), $a([]), $a([]), $a([])])]); /*17747*/
			$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 5, $1.e]), $a([5, $1.e, $1.e, 5, $1.e]), $a([$1.e, $1.e, $1.e, 5, $1.e]), $a([$1.e, $1.e, $1.e, $1.e, $1.e]), $a([4, $1.e, $1.e, 4, $1.e])]); /*17756*/
			$1.charsize = $a([5, 5, 5, 5, 4, 8]); /*17759*/
			$1.curlen = $a([0, $1.e, $1.e, $1.e, $1.e, $1.e]); /*17762*/
			$1.curseq = $a([$a([]), $a([]), $a([]), $a([]), $a([]), $a([])]); /*17763*/
			$1.backto = $1.U; /*17765*/
			$1.lastchar = ""; /*17766*/
			$forall($1.barcode, function() { /*17862*/
				$1.char = $k[--$j]; /*17771*/
				for (;;) { /*17797*/
					$1.imp = false; /*17775*/
					var _3l = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*17776*/
					for (var _3m = 0, _3n = _3l.length; _3m < _3n; _3m++) { /*17795*/
						$1.x = $get(_3l, _3m); /*17777*/
						var _3v = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*17778*/
						for (var _3w = 0, _3x = _3v.length; _3w < _3x; _3w++) { /*17794*/
							$1.y = $get(_3v, _3w); /*17779*/
							if (($1.x != $1.B) || ($1.y == $1.backto)) { /*17793*/
								$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*17781*/
								if ($1.cost < $get($1.curlen, $1.y)) { /*17792*/
									$put($1.curlen, $1.y, $1.cost); /*17783*/
									$k[$j++] = $1.curseq; /*17786*/
									$k[$j++] = $1.y; /*17786*/
									$k[$j++] = Infinity; /*17786*/
									$aload($get($1.curseq, $1.x)); /*17785*/
									$aload($get($get($1.latseq, $1.x), $1.y)); /*17786*/
									var _4S = $a(); /*17786*/
									var _4T = $k[--$j]; /*17787*/
									$put($k[--$j], _4T, _4S); /*17787*/
									if ($1.y == $1.B) { /*17790*/
										$k[$j++] = "backto"; /*17789*/
										if (($1.x == $1.P) || ($1.x == $1.D)) { /*17789*/
											$k[$j++] = $1.U; /*17789*/
										} else { /*17789*/
											$k[$j++] = $1.x; /*17789*/
										} /*17789*/
										var _4d = $k[--$j]; /*17789*/
										$1[$k[--$j]] = _4d; /*17789*/
									} /*17789*/
									$1.imp = true; /*17791*/
								} /*17791*/
							} /*17791*/
						} /*17791*/
					} /*17791*/
					if (!$1.imp) { /*17796*/
						break; /*17796*/
					} /*17796*/
				} /*17796*/
				$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e, $1.e, $1.e]); /*17800*/
				$1.nxtseq = $a(6); /*17801*/
				var _4u = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*17803*/
				for (var _4v = 0, _4w = _4u.length; _4v < _4w; _4v++) { /*17838*/
					$1.x = $get(_4u, _4v); /*17804*/
					for (;;) { /*17836*/
						if ($1.x != $1.B) { /*17809*/
							var _54 = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*17809*/
							if (!_54) { /*17809*/
								break; /*17809*/
							} /*17809*/
						} /*17809*/
						$1.cost = $get($1.curlen, $1.x) + $get($1.charsize, $1.x); /*17812*/
						if ($1.cost < $get($1.nxtlen, $1.x)) { /*17816*/
							$put($1.nxtlen, $1.x, $1.cost); /*17814*/
							$k[$j++] = $1.nxtseq; /*17815*/
							$k[$j++] = $1.x; /*17815*/
							$k[$j++] = Infinity; /*17815*/
							$aload($get($1.curseq, $1.x)); /*17815*/
							$k[$j++] = $1.char; /*17815*/
							var _5O = $a(); /*17815*/
							var _5P = $k[--$j]; /*17815*/
							$put($k[--$j], _5P, _5O); /*17815*/
						} /*17815*/
						if ($1.x == $1.B) { /*17819*/
							break; /*17819*/
						} /*17819*/
						var _5Y = $a([$1.U, $1.L, $1.M, $1.P, $1.D]); /*17820*/
						for (var _5Z = 0, _5a = _5Y.length; _5Z < _5a; _5Z++) { /*17833*/
							$1.y = $get(_5Y, _5Z); /*17821*/
							if ($ne($1.x, $1.y)) { /*17832*/
								$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + $get($1.charsize, $1.x); /*17823*/
								if ($1.cost < $get($1.nxtlen, $1.y)) { /*17831*/
									$put($1.nxtlen, $1.y, $1.cost); /*17825*/
									$k[$j++] = $1.nxtseq; /*17829*/
									$k[$j++] = $1.y; /*17829*/
									$k[$j++] = Infinity; /*17829*/
									$aload($get($1.curseq, $1.y)); /*17827*/
									if ($1.x == $1.U) { /*17828*/
										$k[$j++] = $1.su; /*17828*/
									} else { /*17828*/
										$k[$j++] = $1.sp; /*17828*/
									} /*17828*/
									$k[$j++] = $1.char; /*17829*/
									var _66 = $a(); /*17829*/
									var _67 = $k[--$j]; /*17830*/
									$put($k[--$j], _67, _66); /*17830*/
								} /*17830*/
							} /*17830*/
						} /*17830*/
						break; /*17835*/
					} /*17835*/
				} /*17835*/
				if ($ne($1.lastchar, "")) { /*17849*/
					var _6A = $s(2); /*17842*/
					$put(_6A, 0, $1.lastchar); /*17842*/
					$put(_6A, 1, $1.char); /*17842*/
					$1.pchars = _6A; /*17842*/
					var _6F = $get($1.pcomp, $1.pchars) !== undefined; /*17843*/
					if (_6F) { /*17848*/
						if ($lt($get($1.curlen, $1.P), $get($1.nxtlen, $1.P))) { /*17847*/
							$put($1.nxtlen, $1.P, $get($1.curlen, $1.P)); /*17845*/
							$k[$j++] = $1.nxtseq; /*17846*/
							$k[$j++] = $1.P; /*17846*/
							$k[$j++] = Infinity; /*17846*/
							$aload($get($1.curseq, $1.P)); /*17846*/
							$j--; /*17846*/
							$k[$j++] = $get($1.pcomp, $1.pchars); /*17846*/
							var _6Z = $a(); /*17846*/
							var _6a = $k[--$j]; /*17846*/
							$put($k[--$j], _6a, _6Z); /*17846*/
						} /*17846*/
					} /*17846*/
				} /*17846*/
				$1.numbytes = 0; /*17852*/
				$forall($get($1.nxtseq, $1.B), function() { /*17855*/
					if ($k[--$j] == $1.sb) { /*17854*/
						$k[$j++] = 0; /*17854*/
					} else { /*17854*/
						$k[$j++] = $1.numbytes + 1; /*17854*/
					} /*17854*/
					$1.numbytes = $k[--$j]; /*17854*/
				}); /*17854*/
				if ($1.numbytes == 32) { /*17856*/
					$put($1.nxtlen, $1.B, $get($1.nxtlen, $1.B) + 11); /*17856*/
				} /*17856*/
				$1.curlen = $1.nxtlen; /*17858*/
				$1.curseq = $1.nxtseq; /*17859*/
				$1.lastchar = $1.char; /*17860*/
			}); /*17860*/
			$1.minseq = $1.e; /*17865*/
			var _6z = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*17866*/
			for (var _70 = 0, _71 = _6z.length; _70 < _71; _70++) { /*17872*/
				$1.i = $get(_6z, _70); /*17867*/
				if ($get($1.curlen, $1.i) < $1.minseq) { /*17871*/
					$1.minseq = $get($1.curlen, $1.i); /*17869*/
					$1.seq = $get($1.curseq, $1.i); /*17870*/
				} /*17870*/
			} /*17870*/
			$1.tobin = function() {
				var _7E = $s($k[--$j]); /*17876*/
				$k[$j++] = _7E; /*17876*/
				for (var _7G = 0, _7F = _7E.length - 1; _7G <= _7F; _7G += 1) { /*17876*/
					var _7H = $k[--$j]; /*17876*/
					$put(_7H, _7G, 48); /*17876*/
					$k[$j++] = _7H; /*17876*/
				} /*17876*/
				var _7I = $k[--$j]; /*17877*/
				var _7L = $cvrs($s(_7I.length), $k[--$j], 2); /*17877*/
				$puti(_7I, _7I.length - _7L.length, _7L); /*17877*/
				$k[$j++] = _7I; /*17877*/
			}; /*17878*/
			$1.encu = function() {
				var _7Q = $get($get($1.charvals, $1.U), $k[--$j]); /*17879*/
				$k[$j++] = _7Q; /*17879*/
				$k[$j++] = 5; /*17879*/
				$1.tobin(); /*17879*/
			}; /*17879*/
			$1.encl = function() {
				var _7V = $get($get($1.charvals, $1.L), $k[--$j]); /*17880*/
				$k[$j++] = _7V; /*17880*/
				$k[$j++] = 5; /*17880*/
				$1.tobin(); /*17880*/
			}; /*17880*/
			$1.encm = function() {
				var _7a = $get($get($1.charvals, $1.M), $k[--$j]); /*17881*/
				$k[$j++] = _7a; /*17881*/
				$k[$j++] = 5; /*17881*/
				$1.tobin(); /*17881*/
			}; /*17881*/
			$1.encp = function() {
				var _7f = $get($get($1.charvals, $1.P), $k[--$j]); /*17882*/
				$k[$j++] = _7f; /*17882*/
				$k[$j++] = 5; /*17882*/
				$1.tobin(); /*17882*/
			}; /*17882*/
			$1.encd = function() {
				var _7k = $get($get($1.charvals, $1.D), $k[--$j]); /*17883*/
				$k[$j++] = _7k; /*17883*/
				$k[$j++] = 4; /*17883*/
				$1.tobin(); /*17883*/
			}; /*17883*/
			$1.encfuncs = $a(["encu", "encl", "encm", "encp", "encd"]); /*17884*/
			$1.addtomsgbits = function() {
				$1.v = $k[--$j]; /*17886*/
				$puti($1.msgbits, $1.j, $1.v); /*17887*/
				$1.j = $1.j + $1.v.length; /*17888*/
			}; /*17889*/
			$1.state = $1.U; /*17892*/
			$1.msgbits = $s($1.minseq); /*17893*/
			$1.i = 0; /*17894*/
			$1.j = 0; /*17894*/
			for (;;) { /*17953*/
				if ($1.i >= $1.seq.length) { /*17895*/
					break; /*17895*/
				} /*17895*/
				if ($1.state != $1.B) { /*17948*/
					$1.char = $get($1.seq, $1.i); /*17899*/
					$k[$j++] = $1.char; /*17902*/
					$1[$get($1.encfuncs, $1.state)](); /*17902*/
					$1.addtomsgbits(); /*17902*/
					$1.i = $1.i + 1; /*17903*/
					if (($1.char == $1.su) || ($1.char == $1.sp)) { /*17909*/
						$k[$j++] = $get($1.seq, $1.i); /*17907*/
						if ($1.char == $1.su) { /*17907*/
							$1.encu(); /*17907*/
						} else { /*17907*/
							$1.encp(); /*17907*/
						} /*17907*/
						$1.addtomsgbits(); /*17907*/
						$1.i = $1.i + 1; /*17908*/
					} /*17908*/
					if ($1.char == $1.lu) { /*17912*/
						$1.state = $1.U; /*17912*/
					} /*17912*/
					if ($1.char == $1.ll) { /*17913*/
						$1.state = $1.L; /*17913*/
					} /*17913*/
					if ($1.char == $1.lm) { /*17914*/
						$1.state = $1.M; /*17914*/
					} /*17914*/
					if ($1.char == $1.lp) { /*17915*/
						$1.state = $1.P; /*17915*/
					} /*17915*/
					if ($1.char == $1.ld) { /*17916*/
						$1.state = $1.D; /*17916*/
					} /*17916*/
					if ($1.char == $1.sb) { /*17917*/
						$1.state = $1.B; /*17917*/
					} /*17917*/
				} else { /*17948*/
					$1.numbytes = 0; /*17922*/
					for (;;) { /*17926*/
						if (($1.i + $1.numbytes) >= $1.seq.length) { /*17923*/
							break; /*17923*/
						} /*17923*/
						if ($get($1.seq, $1.i + $1.numbytes) < 0) { /*17924*/
							break; /*17924*/
						} /*17924*/
						$1.numbytes = $1.numbytes + 1; /*17925*/
					} /*17925*/
					if ($1.numbytes <= 31) { /*17933*/
						$k[$j++] = $1.numbytes; /*17930*/
						$k[$j++] = 5; /*17930*/
						$1.tobin(); /*17930*/
						$1.addtomsgbits(); /*17930*/
					} else { /*17933*/
						$k[$j++] = 0; /*17932*/
						$k[$j++] = 5; /*17932*/
						$1.tobin(); /*17932*/
						$1.addtomsgbits(); /*17932*/
						$k[$j++] = $1.numbytes - 31; /*17933*/
						$k[$j++] = 11; /*17933*/
						$1.tobin(); /*17933*/
						$1.addtomsgbits(); /*17933*/
					} /*17933*/
					for (var _8m = 0, _8n = $1.numbytes; _8m < _8n; _8m++) { /*17940*/
						$k[$j++] = $get($1.seq, $1.i); /*17938*/
						$k[$j++] = 8; /*17938*/
						$1.tobin(); /*17938*/
						$1.addtomsgbits(); /*17938*/
						$1.i = $1.i + 1; /*17939*/
					} /*17939*/
					if ($1.i < $1.seq.length) { /*17949*/
						$1.char = $get($1.seq, $1.i); /*17944*/
						$1.i = $1.i + 1; /*17945*/
						if ($1.char == $1.lu) { /*17946*/
							$1.state = $1.U; /*17946*/
						} /*17946*/
						if ($1.char == $1.ll) { /*17947*/
							$1.state = $1.L; /*17947*/
						} /*17947*/
						if ($1.char == $1.lm) { /*17948*/
							$1.state = $1.M; /*17948*/
						} /*17948*/
					} /*17948*/
				} /*17948*/
			} /*17948*/
		} /*17948*/
		$1.metrics = $a([$a(["rune", 0, 0, 0, 6]), $a(["compact", 1, 1, 17, 6]), $a(["full", 1, 1, 21, 6]), $a(["compact", 2, 0, 40, 6]), $a(["full", 2, 1, 48, 6]), $a(["compact", 3, 0, 51, 8]), $a(["full", 3, 1, 60, 8]), $a(["compact", 4, 0, 76, 8]), $a(["full", 4, 1, 88, 8]), $a(["full", 5, 1, 120, 8]), $a(["full", 6, 1, 156, 8]), $a(["full", 7, 1, 196, 8]), $a(["full", 8, 1, 240, 8]), $a(["full", 9, 1, 230, 10]), $a(["full", 10, 1, 272, 10]), $a(["full", 11, 1, 316, 10]), $a(["full", 12, 1, 364, 10]), $a(["full", 13, 1, 416, 10]), $a(["full", 14, 1, 470, 10]), $a(["full", 15, 1, 528, 10]), $a(["full", 16, 1, 588, 10]), $a(["full", 17, 1, 652, 10]), $a(["full", 18, 1, 720, 10]), $a(["full", 19, 1, 790, 10]), $a(["full", 20, 1, 864, 10]), $a(["full", 21, 1, 940, 10]), $a(["full", 22, 1, 1020, 10]), $a(["full", 23, 0, 920, 12]), $a(["full", 24, 0, 992, 12]), $a(["full", 25, 0, 1066, 12]), $a(["full", 26, 0, 1144, 12]), $a(["full", 27, 0, 1224, 12]), $a(["full", 28, 0, 1306, 12]), $a(["full", 29, 0, 1392, 12]), $a(["full", 30, 0, 1480, 12]), $a(["full", 31, 0, 1570, 12]), $a(["full", 32, 0, 1664, 12])]); /*17972*/
		$1.i = 0; /*17974*/
		for (;;) { /*17992*/
			$1.m = $get($1.metrics, $1.i); /*17976*/
			$1.frmt = $get($1.m, 0); /*17977*/
			$1.mlyr = $get($1.m, 1); /*17978*/
			$1.icap = $get($1.m, 2); /*17979*/
			$1.ncws = $get($1.m, 3); /*17980*/
			$1.bpcw = $get($1.m, 4); /*17981*/
			$1.numecw = ~~(Math.ceil((($1.ncws * $1.eclevel) / 100) + $1.ecaddchars)); /*17982*/
			if ($1.msgbits.length == 0) { /*17983*/
				$1.numecw = 0; /*17983*/
			} /*17983*/
			$1.numdcw = $1.ncws - $1.numecw; /*17984*/
			$1.okay = true; /*17985*/
			if ($ne($1.format, "unset") && $ne($1.format, $1.frmt)) { /*17986*/
				$1.okay = false; /*17986*/
			} /*17986*/
			if ($1.readerinit && ($1.icap != 1)) { /*17987*/
				$1.okay = false; /*17987*/
			} /*17987*/
			if (($1.layers != -1) && ($1.layers != $1.mlyr)) { /*17988*/
				$1.okay = false; /*17988*/
			} /*17988*/
			if ((~~Math.ceil($1.msgbits.length / $1.bpcw)) > $1.numdcw) { /*17989*/
				$1.okay = false; /*17989*/
			} /*17989*/
			if ($1.okay) { /*17990*/
				break; /*17990*/
			} /*17990*/
			$1.i = $1.i + 1; /*17991*/
		} /*17991*/
		$1.layers = $1.mlyr; /*17993*/
		$1.format = $1.frmt; /*17994*/
		$1.allzero = function() {
			var _AH = $k[--$j]; /*17997*/
			$k[$j++] = $eq(_AH, $geti("000000000000", 0, _AH.length)); /*17997*/
		}; /*17997*/
		$1.allones = function() {
			var _AJ = $k[--$j]; /*17998*/
			$k[$j++] = $eq(_AJ, $geti("111111111111", 0, _AJ.length)); /*17998*/
		}; /*17998*/
		$1.cws = $a($1.ncws); /*17999*/
		$1.m = 0; /*18000*/
		$1.c = 0; /*18000*/
		for (;;) { /*18027*/
			if ($1.msgbits.length <= $1.m) { /*18002*/
				break; /*18002*/
			} /*18002*/
			if (($1.msgbits.length - $1.m) >= $1.bpcw) { /*18016*/
				$1.cwb = $geti($1.msgbits, $1.m, $1.bpcw - 1); /*18004*/
				$1.cwf = $geti($1.msgbits, ($1.m + $1.bpcw) - 1, 1); /*18005*/
				$k[$j++] = $1.cwb; /*18006*/
				$1.allzero(); /*18006*/
				if ($k[--$j]) { /*18006*/
					$1.cwf = "1"; /*18006*/
					$1.m = $1.m - 1; /*18006*/
				} /*18006*/
				$k[$j++] = $1.cwb; /*18007*/
				$1.allones(); /*18007*/
				if ($k[--$j]) { /*18007*/
					$1.cwf = "0"; /*18007*/
					$1.m = $1.m - 1; /*18007*/
				} /*18007*/
				var _Ag = $s(12); /*18009*/
				$puti(_Ag, 0, $1.cwb); /*18009*/
				$puti(_Ag, $1.bpcw - 1, $1.cwf); /*18010*/
				$1.cwb = $geti(_Ag, 0, $1.bpcw); /*18012*/
			} else { /*18016*/
				$1.cwb = $geti($1.msgbits, $1.m, $1.msgbits.length - $1.m); /*18014*/
				var _As = $strcpy($s(12), "111111111111"); /*18015*/
				$puti(_As, 0, $1.cwb); /*18015*/
				$1.cwb = $geti(_As, 0, $1.bpcw); /*18015*/
				$k[$j++] = $1.cwb; /*18016*/
				$1.allones(); /*18016*/
				if ($k[--$j]) { /*18016*/
					$puti($1.cwb, $1.cwb.length - 1, "0"); /*18016*/
				} /*18016*/
			} /*18016*/
			$1.cw = 0; /*18019*/
			for (var _B2 = 0, _B1 = $1.bpcw - 1; _B2 <= _B1; _B2 += 1) { /*18023*/
				$1.i = _B2; /*18021*/
				$1.cw = $1.cw + ((~~(Math.pow(2, ($1.bpcw - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*18022*/
			} /*18022*/
			$put($1.cws, $1.c, $1.cw); /*18024*/
			$1.m = $1.m + $1.bpcw; /*18025*/
			$1.c = $1.c + 1; /*18026*/
		} /*18026*/
		$1.cws = $geti($1.cws, 0, $1.c); /*18028*/
		$1.rscodes = function() {
			$1.rspm = $k[--$j]; /*18033*/
			$1.rsgf = $k[--$j]; /*18034*/
			$1.rsnc = $k[--$j]; /*18035*/
			$1.rscws = $k[--$j]; /*18036*/
			$k[$j++] = Infinity; /*18039*/
			$k[$j++] = 1; /*18039*/
			for (var _BN = 0, _BO = $1.rsgf - 1; _BN < _BO; _BN++) { /*18039*/
				var _BP = $k[--$j]; /*18039*/
				var _BQ = _BP * 2; /*18039*/
				$k[$j++] = _BP; /*18039*/
				$k[$j++] = _BQ; /*18039*/
				if (_BQ >= $1.rsgf) { /*18039*/
					var _BT = $k[--$j]; /*18039*/
					$k[$j++] = $xo(_BT, $1.rspm); /*18039*/
				} /*18039*/
			} /*18039*/
			$1.rsalog = $a(); /*18039*/
			$1.rslog = $a($1.rsgf); /*18040*/
			for (var _BZ = 1, _BY = $1.rsgf - 1; _BZ <= _BY; _BZ += 1) { /*18041*/
				$put($1.rslog, $get($1.rsalog, _BZ), _BZ); /*18041*/
			} /*18041*/
			$1.rsprod = function() {
				var _Bd = $k[--$j]; /*18045*/
				var _Be = $k[--$j]; /*18045*/
				$k[$j++] = _Be; /*18049*/
				$k[$j++] = _Bd; /*18049*/
				if ((_Bd != 0) && (_Be != 0)) { /*18048*/
					var _Bh = $get($1.rslog, $k[--$j]); /*18046*/
					var _Bn = $get($1.rsalog, (_Bh + $get($1.rslog, $k[--$j])) % ($1.rsgf - 1)); /*18046*/
					$k[$j++] = _Bn; /*18046*/
				} else { /*18048*/
					$j -= 2; /*18048*/
					$k[$j++] = 0; /*18048*/
				} /*18048*/
			}; /*18050*/
			$k[$j++] = Infinity; /*18053*/
			$k[$j++] = 1; /*18053*/
			for (var _Bp = 0, _Bq = $1.rsnc; _Bp < _Bq; _Bp++) { /*18053*/
				$k[$j++] = 0; /*18053*/
			} /*18053*/
			$1.coeffs = $a(); /*18053*/
			for (var _Bu = 1, _Bt = $1.rsnc; _Bu <= _Bt; _Bu += 1) { /*18062*/
				$1.i = _Bu; /*18055*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*18056*/
				for (var _C1 = $1.i - 1; _C1 >= 1; _C1 -= 1) { /*18060*/
					$1.j = _C1; /*18058*/
					$k[$j++] = $1.coeffs; /*18059*/
					$k[$j++] = $1.j; /*18059*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*18059*/
					$k[$j++] = $get($1.coeffs, $1.j); /*18059*/
					$k[$j++] = $get($1.rsalog, $1.i); /*18059*/
					$1.rsprod(); /*18059*/
					var _CD = $k[--$j]; /*18059*/
					var _CE = $k[--$j]; /*18059*/
					var _CF = $k[--$j]; /*18059*/
					$put($k[--$j], _CF, $xo(_CE, _CD)); /*18059*/
				} /*18059*/
				$k[$j++] = $1.coeffs; /*18061*/
				$k[$j++] = 0; /*18061*/
				$k[$j++] = $get($1.coeffs, 0); /*18061*/
				$k[$j++] = $get($1.rsalog, $1.i); /*18061*/
				$1.rsprod(); /*18061*/
				var _CN = $k[--$j]; /*18061*/
				var _CO = $k[--$j]; /*18061*/
				$put($k[--$j], _CO, _CN); /*18061*/
			} /*18061*/
			$1.nd = $1.rscws.length; /*18065*/
			$k[$j++] = Infinity; /*18066*/
			$forall($1.rscws); /*18066*/
			for (var _CT = 0, _CU = $1.rsnc; _CT < _CU; _CT++) { /*18066*/
				$k[$j++] = 0; /*18066*/
			} /*18066*/
			$k[$j++] = 0; /*18066*/
			$1.rscws = $a(); /*18066*/
			for (var _CY = 0, _CX = $1.nd - 1; _CY <= _CX; _CY += 1) { /*18073*/
				$1.k = $xo($get($1.rscws, _CY), $get($1.rscws, $1.nd)); /*18068*/
				for (var _Cg = 0, _Cf = $1.rsnc - 1; _Cg <= _Cf; _Cg += 1) { /*18072*/
					$1.j = _Cg; /*18070*/
					$k[$j++] = $1.rscws; /*18071*/
					$k[$j++] = $1.nd + $1.j; /*18071*/
					$k[$j++] = $get($1.rscws, ($1.nd + $1.j) + 1); /*18071*/
					$k[$j++] = $1.k; /*18071*/
					$k[$j++] = $get($1.coeffs, ($1.rsnc - $1.j) - 1); /*18071*/
					$1.rsprod(); /*18071*/
					var _Ct = $k[--$j]; /*18071*/
					var _Cu = $k[--$j]; /*18071*/
					var _Cv = $k[--$j]; /*18071*/
					$put($k[--$j], _Cv, $xo(_Cu, _Ct)); /*18071*/
				} /*18071*/
			} /*18071*/
			$k[$j++] = $geti($1.rscws, 0, $1.rscws.length - 1); /*18076*/
		}; /*18078*/
		if ($eq($1.format, "full")) { /*18091*/
			$1.mode = (($1.layers - 1) << 11) + ($1.cws.length - 1); /*18082*/
			if ($1.readerinit) { /*18083*/
				$1.mode = $1.mode | 1024; /*18083*/
			} /*18083*/
			$1.mode = $a([($1.mode & 61440) >>> 12, ($1.mode & 3840) >>> 8, ($1.mode & 240) >>> 4, $1.mode & 15]); /*18089*/
			$k[$j++] = "mode"; /*18090*/
			$k[$j++] = $1.mode; /*18090*/
			$k[$j++] = 6; /*18090*/
			$k[$j++] = 16; /*18090*/
			$k[$j++] = 19; /*18090*/
			$1.rscodes(); /*18090*/
			var _DB = $k[--$j]; /*18090*/
			$1[$k[--$j]] = _DB; /*18090*/
		} /*18090*/
		if ($eq($1.format, "compact")) { /*18100*/
			$1.mode = (($1.layers - 1) << 6) + ($1.cws.length - 1); /*18093*/
			if ($1.readerinit) { /*18094*/
				$1.mode = $1.mode | 32; /*18094*/
			} /*18094*/
			$1.mode = $a([($1.mode & 240) >>> 4, $1.mode & 15]); /*18098*/
			$k[$j++] = "mode"; /*18099*/
			$k[$j++] = $1.mode; /*18099*/
			$k[$j++] = 5; /*18099*/
			$k[$j++] = 16; /*18099*/
			$k[$j++] = 19; /*18099*/
			$1.rscodes(); /*18099*/
			var _DM = $k[--$j]; /*18099*/
			$1[$k[--$j]] = _DM; /*18099*/
		} /*18099*/
		if ($eq($1.format, "rune")) { /*18109*/
			$1.mode = ~~$z($1.barcode); /*18102*/
			$1.mode = $a([($1.mode & 240) >>> 4, $1.mode & 15]); /*18106*/
			$k[$j++] = "mode"; /*18107*/
			$k[$j++] = $1.mode; /*18107*/
			$k[$j++] = 5; /*18107*/
			$k[$j++] = 16; /*18107*/
			$k[$j++] = 19; /*18107*/
			$1.rscodes(); /*18107*/
			var _DU = $k[--$j]; /*18107*/
			$1[$k[--$j]] = _DU; /*18107*/
			$k[$j++] = Infinity; /*18108*/
			var _DW = $1.mode; /*18108*/
			for (var _DX = 0, _DY = _DW.length; _DX < _DY; _DX++) { /*18108*/
				$k[$j++] = $get(_DW, _DX) ^ 10; /*18108*/
			} /*18108*/
			$1.mode = $a(); /*18108*/
		} /*18108*/
		$1.modebits = $s($1.mode.length * 4); /*18110*/
		for (var _Df = 0, _De = $1.modebits.length - 1; _Df <= _De; _Df += 1) { /*18111*/
			$puti($1.modebits, _Df, "0"); /*18111*/
		} /*18111*/
		for (var _Dj = 0, _Di = $1.mode.length - 1; _Dj <= _Di; _Dj += 1) { /*18115*/
			$1.i = _Dj; /*18113*/
			var _Dp = $cvrs($s(4), $get($1.mode, $1.i), 2); /*18114*/
			$puti($1.modebits, (4 - _Dp.length) + (4 * $1.i), _Dp); /*18114*/
		} /*18114*/
		$1.rsparams = $a([$a([]), $a([]), $a([]), $a([]), $a([]), $a([]), $a([64, 67]), $a([]), $a([256, 301]), $a([]), $a([1024, 1033]), $a([]), $a([4096, 4201])]); /*18127*/
		$k[$j++] = "cws"; /*18128*/
		$k[$j++] = $1.cws; /*18128*/
		$k[$j++] = $1.ncws - $1.cws.length; /*18128*/
		$forall($get($1.rsparams, $1.bpcw)); /*18128*/
		$1.rscodes(); /*18128*/
		var _EB = $k[--$j]; /*18128*/
		$1[$k[--$j]] = _EB; /*18128*/
		if ($eq($1.format, "full")) { /*18132*/
			$1.databits = $s((($1.layers * $1.layers) * 16) + ($1.layers * 112)); /*18130*/
		} else { /*18132*/
			$1.databits = $s((($1.layers * $1.layers) * 16) + ($1.layers * 88)); /*18132*/
		} /*18132*/
		for (var _EO = 0, _EN = $1.databits.length - 1; _EO <= _EN; _EO += 1) { /*18134*/
			$puti($1.databits, _EO, "0"); /*18134*/
		} /*18134*/
		for (var _ES = 0, _ER = $1.ncws - 1; _ES <= _ER; _ES += 1) { /*18140*/
			$1.i = _ES; /*18136*/
			var _EZ = $cvrs($s($1.bpcw), $get($1.cws, $1.i), 2); /*18137*/
			$puti($1.databits, (($1.bpcw - _EZ.length) + ($1.bpcw * $1.i)) + ($1.databits.length - ($1.ncws * $1.bpcw)), _EZ); /*18139*/
		} /*18139*/
		$1.cmv = function() {
			var _Eh = $k[--$j]; /*18143*/
			var _Ei = $k[--$j]; /*18143*/
			$k[$j++] = (_Ei - (_Eh * $1.size)) + $1.mid; /*18143*/
		}; /*18143*/
		$1.lmv = function() {
			$1.lbit = $k[--$j]; /*18147*/
			$1.llyr = $k[--$j]; /*18148*/
			$1.lwid = $1.fw + ($1.llyr * 4); /*18149*/
			$1.ldir = ~~((~~($1.lbit / 2)) / $1.lwid); /*18150*/
			if ($1.ldir == 0) { /*18155*/
				$k[$j++] = ((-(~~(($1.lwid - 1) / 2))) + 1) + ((~~($1.lbit / 2)) % $1.lwid); /*18154*/
				$k[$j++] = ((~~(($1.fw - 1) / 2)) + ($1.llyr * 2)) + ($1.lbit % 2); /*18154*/
				$1.cmv(); /*18154*/
			} /*18154*/
			if ($1.ldir == 1) { /*18160*/
				$k[$j++] = ((~~($1.fw / 2)) + ($1.llyr * 2)) + ($1.lbit % 2); /*18159*/
				$k[$j++] = ((~~(($1.lwid - 1) / 2)) - 1) - ((~~($1.lbit / 2)) % $1.lwid); /*18159*/
				$1.cmv(); /*18159*/
			} /*18159*/
			if ($1.ldir == 2) { /*18165*/
				$k[$j++] = -(((-(~~($1.lwid / 2))) + 1) + ((~~($1.lbit / 2)) % $1.lwid)); /*18164*/
				$k[$j++] = -(((~~($1.fw / 2)) + ($1.llyr * 2)) + ($1.lbit % 2)); /*18164*/
				$1.cmv(); /*18164*/
			} /*18164*/
			if ($1.ldir == 3) { /*18170*/
				$k[$j++] = -(((~~(($1.fw - 1) / 2)) + ($1.llyr * 2)) + ($1.lbit % 2)); /*18169*/
				$k[$j++] = -(((~~($1.lwid / 2)) - 1) - ((~~($1.lbit / 2)) % $1.lwid)); /*18169*/
				$1.cmv(); /*18169*/
			} /*18169*/
		}; /*18171*/
		if ($eq($1.format, "full")) { /*18175*/
			$1.fw = 12; /*18175*/
		} else { /*18175*/
			$1.fw = 9; /*18175*/
		} /*18175*/
		$1.size = ($1.fw + ($1.layers * 4)) + 2; /*18176*/
		$k[$j++] = Infinity; /*18177*/
		for (var _FN = 0, _FO = $1.size * $1.size; _FN < _FO; _FN++) { /*18177*/
			$k[$j++] = -1; /*18177*/
		} /*18177*/
		$1.pixs = $a(); /*18177*/
		$1.mid = ((~~(($1.size - 1) / 2)) * $1.size) + (~~(($1.size - 1) / 2)); /*18178*/
		$1.i = 0; /*18181*/
		for (var _FV = 1, _FU = $1.layers; _FV <= _FU; _FV += 1) { /*18189*/
			$1.layer = _FV; /*18183*/
			for (var _FZ = 0, _FY = (($1.fw + ($1.layer * 4)) * 8) - 1; _FZ <= _FY; _FZ += 1) { /*18188*/
				$1.pos = _FZ; /*18185*/
				$k[$j++] = $1.pixs; /*18186*/
				$k[$j++] = $1.layer; /*18186*/
				$k[$j++] = $1.pos; /*18186*/
				$1.lmv(); /*18186*/
				var _Fh = $k[--$j]; /*18186*/
				$put($k[--$j], _Fh, $get($1.databits, ($1.databits.length - $1.i) - 1) - 48); /*18186*/
				$1.i = $1.i + 1; /*18187*/
			} /*18187*/
		} /*18187*/
		if ($eq($1.format, "full")) { /*18216*/
			$1.fw = 13; /*18193*/
			$1.size = (($1.fw + ($1.layers * 4)) + 2) + ((~~((($1.layers + 10.5) / 7.5) - 1)) * 2); /*18194*/
			$1.mid = ~~(($1.size * $1.size) / 2); /*18195*/
			$k[$j++] = Infinity; /*18196*/
			for (var _Fs = 0, _Ft = $1.size * $1.size; _Fs < _Ft; _Fs++) { /*18196*/
				$k[$j++] = -2; /*18196*/
			} /*18196*/
			$1.npixs = $a(); /*18196*/
			for (var _Fx = 0, _Fw = ~~($1.size / 2); _Fx <= _Fw; _Fx += 16) { /*18206*/
				$1.i = _Fx; /*18198*/
				for (var _G0 = 0, _Fz = $1.size - 1; _G0 <= _Fz; _G0 += 1) { /*18205*/
					$1.j = _G0; /*18200*/
					$k[$j++] = $1.npixs; /*18201*/
					$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18201*/
					$k[$j++] = $1.i; /*18201*/
					$1.cmv(); /*18201*/
					var _G9 = $k[--$j]; /*18201*/
					$puti($k[--$j], _G9, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18201*/
					$k[$j++] = $1.npixs; /*18202*/
					$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18202*/
					$k[$j++] = -$1.i; /*18202*/
					$1.cmv(); /*18202*/
					var _GJ = $k[--$j]; /*18202*/
					$puti($k[--$j], _GJ, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18202*/
					$k[$j++] = $1.npixs; /*18203*/
					$k[$j++] = $1.i; /*18203*/
					$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18203*/
					$1.cmv(); /*18203*/
					var _GT = $k[--$j]; /*18203*/
					$puti($k[--$j], _GT, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18203*/
					$k[$j++] = $1.npixs; /*18204*/
					$k[$j++] = -$1.i; /*18204*/
					$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18204*/
					$1.cmv(); /*18204*/
					var _Gd = $k[--$j]; /*18204*/
					$puti($k[--$j], _Gd, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18204*/
				} /*18204*/
			} /*18204*/
			$1.j = 0; /*18207*/
			for (var _Gh = 0, _Gg = $1.npixs.length - 1; _Gh <= _Gg; _Gh += 1) { /*18214*/
				$1.i = _Gh; /*18209*/
				if ($get($1.npixs, $1.i) == -2) { /*18213*/
					$put($1.npixs, $1.i, $get($1.pixs, $1.j)); /*18211*/
					$1.j = $1.j + 1; /*18212*/
				} /*18212*/
			} /*18212*/
			$1.pixs = $1.npixs; /*18215*/
		} /*18215*/
		$1.fw = ~~($1.fw / 2); /*18219*/
		for (var _Gw = -$1.fw, _Gv = $1.fw; _Gw <= _Gv; _Gw += 1) { /*18228*/
			$1.i = _Gw; /*18221*/
			for (var _H0 = -$1.fw, _Gz = $1.fw; _H0 <= _Gz; _H0 += 1) { /*18227*/
				$1.j = _H0; /*18223*/
				$k[$j++] = $1.pixs; /*18224*/
				$k[$j++] = $1.i; /*18224*/
				$k[$j++] = $1.j; /*18224*/
				$1.cmv(); /*18224*/
				if (Math.abs($1.i) > Math.abs($1.j)) { /*18225*/
					$k[$j++] = Math.abs($1.i); /*18225*/
				} else { /*18225*/
					$k[$j++] = Math.abs($1.j); /*18225*/
				} /*18225*/
				var _H8 = $k[--$j]; /*18225*/
				var _H9 = $k[--$j]; /*18226*/
				$put($k[--$j], _H9, (_H8 + 1) % 2); /*18226*/
			} /*18226*/
		} /*18226*/
		var _Hl = $a([$a([-($1.fw + 1), $1.fw, 1]), $a([-($1.fw + 1), $1.fw + 1, 1]), $a([-$1.fw, $1.fw + 1, 1]), $a([$1.fw + 1, $1.fw + 1, 1]), $a([$1.fw + 1, $1.fw, 1]), $a([$1.fw + 1, -$1.fw, 1]), $a([$1.fw, $1.fw + 1, 0]), $a([$1.fw + 1, -($1.fw + 1), 0]), $a([$1.fw, -($1.fw + 1), 0]), $a([-$1.fw, -($1.fw + 1), 0]), $a([-($1.fw + 1), -($1.fw + 1), 0]), $a([-($1.fw + 1), -$1.fw, 0])]); /*18236*/
		for (var _Hm = 0, _Hn = _Hl.length; _Hm < _Hn; _Hm++) { /*18237*/
			$k[$j++] = $1.pixs; /*18237*/
			$forall($get(_Hl, _Hm)); /*18237*/
			var _Hq = $k[--$j]; /*18237*/
			var _Hr = $k[--$j]; /*18237*/
			var _Hs = $k[--$j]; /*18237*/
			$k[$j++] = _Hq; /*18237*/
			$k[$j++] = _Hs; /*18237*/
			$k[$j++] = _Hr; /*18237*/
			$1.cmv(); /*18237*/
			var _Ht = $k[--$j]; /*18237*/
			var _Hu = $k[--$j]; /*18237*/
			$put($k[--$j], _Ht, _Hu); /*18237*/
		} /*18237*/
		if ($eq($1.format, "full")) { /*18253*/
			$1.modemap = $a([$a([-5, 7]), $a([-4, 7]), $a([-3, 7]), $a([-2, 7]), $a([-1, 7]), $a([1, 7]), $a([2, 7]), $a([3, 7]), $a([4, 7]), $a([5, 7]), $a([7, 5]), $a([7, 4]), $a([7, 3]), $a([7, 2]), $a([7, 1]), $a([7, -1]), $a([7, -2]), $a([7, -3]), $a([7, -4]), $a([7, -5]), $a([5, -7]), $a([4, -7]), $a([3, -7]), $a([2, -7]), $a([1, -7]), $a([-1, -7]), $a([-2, -7]), $a([-3, -7]), $a([-4, -7]), $a([-5, -7]), $a([-7, -5]), $a([-7, -4]), $a([-7, -3]), $a([-7, -2]), $a([-7, -1]), $a([-7, 1]), $a([-7, 2]), $a([-7, 3]), $a([-7, 4]), $a([-7, 5])]); /*18246*/
		} else { /*18253*/
			$1.modemap = $a([$a([-3, 5]), $a([-2, 5]), $a([-1, 5]), $a([0, 5]), $a([1, 5]), $a([2, 5]), $a([3, 5]), $a([5, 3]), $a([5, 2]), $a([5, 1]), $a([5, 0]), $a([5, -1]), $a([5, -2]), $a([5, -3]), $a([3, -5]), $a([2, -5]), $a([1, -5]), $a([0, -5]), $a([-1, -5]), $a([-2, -5]), $a([-3, -5]), $a([-5, -3]), $a([-5, -2]), $a([-5, -1]), $a([-5, 0]), $a([-5, 1]), $a([-5, 2]), $a([-5, 3])]); /*18253*/
		} /*18253*/
		for (var _J7 = 0, _J6 = $1.modemap.length - 1; _J7 <= _J6; _J7 += 1) { /*18258*/
			$1.i = _J7; /*18256*/
			$k[$j++] = $1.pixs; /*18257*/
			$forall($get($1.modemap, $1.i)); /*18257*/
			$1.cmv(); /*18257*/
			var _JF = $k[--$j]; /*18257*/
			$put($k[--$j], _JF, $get($1.modebits, $1.i) - 48); /*18257*/
		} /*18257*/
		var _JN = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.size,
			pixy: $1.size,
			height: ($1.size * 2) / 72,
			width: ($1.size * 2) / 72,
			opt: $1.options
		}; /*18267*/
		$k[$j++] = _JN; /*18270*/
		if (!$1.dontdraw) { /*18270*/
			$0.renmatrix(); /*18270*/
		} /*18270*/
	};
	$0.azteccodecompact = function() {
		var $1 = {}; /*18298*/
		$1.options = $k[--$j]; /*18300*/
		$1.barcode = $k[--$j]; /*18301*/
		$1.dontdraw = false; /*18303*/
		$forall($1.options, function() { /*18314*/
			var _3 = $k[--$j]; /*18314*/
			$1[$k[--$j]] = _3; /*18314*/
		}); /*18314*/
		$1.options.dontdraw = true; /*18317*/
		$1.options.format = "compact"; /*18318*/
		$k[$j++] = "args"; /*18320*/
		$k[$j++] = $1.barcode; /*18320*/
		$k[$j++] = $1.options; /*18320*/
		$0.azteccode(); /*18320*/
		var _9 = $k[--$j]; /*18320*/
		$1[$k[--$j]] = _9; /*18320*/
		$1.args.opt = $1.options; /*18322*/
		$k[$j++] = $1.args; /*18325*/
		if (!$1.dontdraw) { /*18325*/
			$0.renmatrix(); /*18325*/
		} /*18325*/
	};
	$0.aztecrune = function() {
		var $1 = {}; /*18353*/
		$1.options = $k[--$j]; /*18355*/
		$1.barcode = $k[--$j]; /*18356*/
		$1.dontdraw = false; /*18358*/
		$forall($1.options, function() { /*18369*/
			var _3 = $k[--$j]; /*18369*/
			$1[$k[--$j]] = _3; /*18369*/
		}); /*18369*/
		$1.options.dontdraw = true; /*18372*/
		$1.options.format = "rune"; /*18373*/
		$k[$j++] = "args"; /*18375*/
		$k[$j++] = $1.barcode; /*18375*/
		$k[$j++] = $1.options; /*18375*/
		$0.azteccode(); /*18375*/
		var _9 = $k[--$j]; /*18375*/
		$1[$k[--$j]] = _9; /*18375*/
		$1.args.opt = $1.options; /*18377*/
		$k[$j++] = $1.args; /*18380*/
		if (!$1.dontdraw) { /*18380*/
			$0.renmatrix(); /*18380*/
		} /*18380*/
	};
	$0.codeone = function() {
		var $1 = {}; /*18407*/
		$1.options = $k[--$j]; /*18409*/
		$1.barcode = $k[--$j]; /*18410*/
		$1.dontdraw = false; /*18412*/
		$1.version = "unset"; /*18413*/
		$1.parse = false; /*18414*/
		$1.parsefnc = false; /*18415*/
		$forall($1.options, function() { /*18426*/
			var _3 = $k[--$j]; /*18426*/
			$1[$k[--$j]] = _3; /*18426*/
		}); /*18426*/
		$1.barlen = $1.barcode.length; /*18449*/
		$1.stype = $eq($geti($1.version, 0, 1), "S"); /*18451*/
		if ($1.stype) { /*19036*/
			$1.vals = $a(["1", "1010", "1100100", "1111101000", "10011100010000", "11000011010100000", "11110100001001000000", "100110001001011010000000", "101111101011110000100000000", "111011100110101100101000000000", "1001010100000010111110010000000000", "1011101001000011101101110100000000000", "1110100011010100101001010001000000000000", "10010001100001001110011100101010000000000000", "10110101111001100010000011110100100000000000000", "11100011010111111010100100110001101000000000000000", "100011100001101111001001101111110000010000000000000000", "101100011010001010111100001011101100010100000000000000000"]); /*18473*/
			$1.normalize = function() {
				$1.base = $k[--$j]; /*18476*/
				$1.num = $k[--$j]; /*18477*/
				for (var _D = $1.num.length - 1; _D >= 1; _D -= 1) { /*18482*/
					$1.i = _D; /*18479*/
					var _E = $1.num; /*18480*/
					var _F = $1.i; /*18480*/
					$put(_E, _F - 1, $get(_E, _F - 1) + (~~($get($1.num, $1.i) / $1.base))); /*18480*/
					$put($1.num, $1.i, $get($1.num, $1.i) % $1.base); /*18481*/
				} /*18481*/
				for (;;) { /*18488*/
					if ($lt($get($1.num, 0), $1.base)) { /*18484*/
						break; /*18484*/
					} /*18484*/
					$k[$j++] = Infinity; /*18485*/
					$k[$j++] = 0; /*18485*/
					$forall($1.num); /*18485*/
					$1.num = $a(); /*18485*/
					$put($1.num, 0, $get($1.num, 0) + (~~($get($1.num, 1) / $1.base))); /*18486*/
					$put($1.num, 1, $get($1.num, 1) % $1.base); /*18487*/
				} /*18487*/
				$k[$j++] = Infinity; /*18490*/
				$1.i = true; /*18490*/
				var _g = $1.num; /*18490*/
				for (var _h = 0, _i = _g.length; _h < _i; _h++) { /*18490*/
					var _j = $get(_g, _h); /*18490*/
					$k[$j++] = _j; /*18490*/
					if ((_j == 0) && $1.i) { /*18490*/
						$j--; /*18490*/
					} else { /*18490*/
						$1.i = false; /*18490*/
					} /*18490*/
				} /*18490*/
				$1.num = $a(); /*18490*/
				if ($1.num.length == 0) { /*18491*/
					$1.num = $a([0]); /*18491*/
				} /*18491*/
				$k[$j++] = $1.num; /*18492*/
			}; /*18493*/
			$1.bigadd = function() {
				var _p = $k[--$j]; /*18496*/
				var _q = $k[--$j]; /*18496*/
				$1.offset = Math.abs(_p.length - _q.length); /*18497*/
				if (_p.length < _q.length) { /*18498*/
					var _ = _p; /*18498*/
					_p = _q; /*18498*/
					_q = _; /*18498*/
				} /*18498*/
				$1.a = _p; /*18499*/
				$1.b = _q; /*18499*/
				for (var _t = 0, _s = $1.b.length - 1; _t <= _s; _t += 1) { /*18502*/
					var _u = $1.a; /*18501*/
					var _v = $1.offset; /*18501*/
					$put(_u, _t + _v, $get(_u, _t + _v) + $get($1.b, _t)); /*18501*/
				} /*18501*/
				$k[$j++] = $1.a; /*18503*/
			}; /*18504*/
			$1.v = $a([1]); /*18507*/
			for (var _13 = 0, _12 = $1.barlen - 1; _13 <= _12; _13 += 1) { /*18512*/
				$1.i = _13; /*18509*/
				$k[$j++] = Infinity; /*18510*/
				$forall($get($1.vals, $1.i), function() { /*18510*/
					var _17 = $k[--$j]; /*18510*/
					$k[$j++] = (_17 - 48) * ($get($1.barcode, ($1.barlen - $1.i) - 1) - 48); /*18510*/
				}); /*18510*/
				var _1C = $a(); /*18510*/
				$k[$j++] = _1C; /*18511*/
				$k[$j++] = $1.v; /*18511*/
				$1.bigadd(); /*18511*/
				$1.v = $k[--$j]; /*18511*/
			} /*18511*/
			$k[$j++] = "v"; /*18513*/
			$k[$j++] = $1.v; /*18513*/
			$k[$j++] = 2; /*18513*/
			$1.normalize(); /*18513*/
			var _1G = $k[--$j]; /*18513*/
			$1[$k[--$j]] = _1G; /*18513*/
			$k[$j++] = Infinity; /*18516*/
			for (var _1J = 0, _1K = (5 - ($1.v.length % 5)) % 5; _1J < _1K; _1J++) { /*18516*/
				$k[$j++] = 0; /*18516*/
			} /*18516*/
			$aload($1.v); /*18516*/
			$1.v = $a(); /*18516*/
			$1.cws = $a(~~($1.v.length / 5)); /*18517*/
			for (var _1R = 0, _1Q = $1.cws.length - 1; _1R <= _1Q; _1R += 1) { /*18523*/
				$1.i = _1R; /*18519*/
				$k[$j++] = 0; /*18521*/
				$forall($geti($1.v, $1.i * 5, 5), function() { /*18521*/
					var _1V = $k[--$j]; /*18521*/
					var _1W = $k[--$j]; /*18521*/
					$k[$j++] = (_1W + _1V) * 2; /*18521*/
				}); /*18521*/
				$put($1.cws, $1.i, ~~($k[--$j] / 2)); /*18522*/
			} /*18522*/
		} else { /*19036*/
			$1.fnc1 = -1; /*18528*/
			$1.fnc3 = -2; /*18528*/
			var _1c = {
				FNC1: $1.fnc1,
				FNC3: $1.fnc3
			}; /*18531*/
			$1.fncvals = _1c; /*18532*/
			$1.msg = $a($1.barlen); /*18533*/
			$1.i = 0; /*18534*/
			$1.j = 0; /*18534*/
			for (;;) { /*18548*/
				if ($1.i == $1.barlen) { /*18535*/
					break; /*18535*/
				} /*18535*/
				$1.char = $get($1.barcode, $1.i); /*18536*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*18544*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*18542*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*18539*/
						$1.i = $1.i + 4; /*18540*/
					} else { /*18542*/
						$1.i = $1.i + 1; /*18542*/
					} /*18542*/
				} /*18542*/
				$put($1.msg, $1.j, $1.char); /*18545*/
				$1.i = $1.i + 1; /*18546*/
				$1.j = $1.j + 1; /*18547*/
			} /*18547*/
			$1.msg = $geti($1.msg, 0, $1.j); /*18549*/
			$1.msglen = $1.msg.length; /*18550*/
			$1.metrics = $a([$a(["A", 16, 18, 16, 10, 10, 1, 4, 99, 6]), $a(["B", 22, 22, 20, 19, 16, 1, 4, 99, 8]), $a(["C", 28, 32, 28, 44, 26, 1, 4, 22, 11]), $a(["D", 40, 42, 36, 91, 44, 1, 4, 16, 16]), $a(["E", 52, 54, 48, 182, 70, 1, 4, 22, 22]), $a(["F", 70, 76, 68, 370, 140, 2, 4, 22, 31]), $a(["G", 104, 98, 88, 732, 280, 4, 6, 21, 47]), $a(["H", 148, 134, 120, 1480, 560, 8, 6, 20, 69]), $a(["S-10", 8, 11, 10, 4, 4, 1, 99, 99, 99]), $a(["S-20", 8, 21, 20, 8, 8, 1, 99, 99, 99]), $a(["S-30", 8, 31, 30, 12, 12, 1, 99, 99, 99]), $a(["T-16", 16, 17, 16, 10, 10, 1, 99, 99, 99]), $a(["T-32", 16, 33, 32, 24, 16, 1, 99, 99, 99]), $a(["T-48", 16, 49, 48, 38, 22, 1, 99, 99, 99])]); /*18569*/
			$1.fullcws = $a([]); /*18572*/
			var _2N = $1.metrics; /*18573*/
			for (var _2O = 0, _2P = _2N.length; _2O < _2P; _2O++) { /*18584*/
				$1.m = $get(_2N, _2O); /*18574*/
				$1.vers = $get($1.m, 0); /*18575*/
				$1.dcws = $get($1.m, 4); /*18576*/
				$1.okay = true; /*18577*/
				if ($eq($1.version, "unset")) { /*18581*/
					if ($1.vers.length != 1) { /*18579*/
						$1.okay = false; /*18579*/
					} /*18579*/
				} else { /*18581*/
					if ($ne($1.version, $1.vers)) { /*18581*/
						$1.okay = false; /*18581*/
					} /*18581*/
				} /*18581*/
				if ($1.okay) { /*18583*/
					$k[$j++] = Infinity; /*18583*/
					$aload($1.fullcws); /*18583*/
					$k[$j++] = $1.dcws; /*18583*/
					$1.fullcws = $a(); /*18583*/
				} /*18583*/
			} /*18583*/
			$k[$j++] = Infinity; /*18585*/
			for (var _2d = 0, _2e = 1480; _2d < _2e; _2d++) { /*18585*/
				$k[$j++] = 10000; /*18585*/
			} /*18585*/
			$1.numremcws = $a(); /*18585*/
			var _2g = $1.fullcws; /*18586*/
			for (var _2h = 0, _2i = _2g.length; _2h < _2i; _2h++) { /*18586*/
				$put($1.numremcws, $get(_2g, _2h) - 1, 1); /*18586*/
			} /*18586*/
			for (var _2l = 1478; _2l >= 0; _2l -= 1) { /*18592*/
				$1.i = _2l; /*18588*/
				if ($get($1.numremcws, $1.i) != 1) { /*18591*/
					$put($1.numremcws, $1.i, $get($1.numremcws, $1.i + 1) + 1); /*18590*/
				} /*18590*/
			} /*18590*/
			$1.lC = -5; /*18595*/
			$1.lB = -6; /*18595*/
			$1.lX = -7; /*18595*/
			$1.lT = -8; /*18595*/
			$1.lD = -9; /*18595*/
			$1.unl = -10; /*18595*/
			$1.fnc2 = -11; /*18596*/
			$1.fnc4 = -12; /*18596*/
			$1.sft1 = -13; /*18596*/
			$1.sft2 = -14; /*18596*/
			$1.sft3 = -15; /*18596*/
			$1.eci = -16; /*18596*/
			$1.pad = -17; /*18596*/
			$1.fnc1lD = -18; /*18596*/
			$1.unlcw = 255; /*18597*/
			$k[$j++] = "Avals"; /*18608*/
			$k[$j++] = Infinity; /*18608*/
			for (var _2u = 0; _2u <= 128; _2u += 1) { /*18600*/
				$k[$j++] = _2u; /*18600*/
				$k[$j++] = _2u + 1; /*18600*/
			} /*18600*/
			$k[$j++] = $1.pad; /*18605*/
			$k[$j++] = 129; /*18605*/
			for (var _2w = 0; _2w <= 99; _2w += 1) { /*18605*/
				var _2y = $cvrs($s(2), _2w, 10); /*18603*/
				var _30 = $strcpy($s(2), "00"); /*18603*/
				$puti(_30, 2 - _2y.length, _2y); /*18603*/
				$k[$j++] = _30; /*18604*/
				$k[$j++] = _2w + 130; /*18604*/
			} /*18604*/
			var _38 = $a([$1.lC, $1.lB, $1.fnc1, $1.fnc2, $1.fnc3, $1.fnc4, $1.fnc1lD]); /*18606*/
			$k[$j++] = 229; /*18606*/
			for (var _39 = 0, _3A = _38.length; _39 < _3A; _39++) { /*18606*/
				var _3D = $k[--$j] + 1; /*18606*/
				$k[$j++] = $get(_38, _39); /*18606*/
				$k[$j++] = _3D; /*18606*/
				$k[$j++] = _3D; /*18606*/
			} /*18606*/
			$j--; /*18606*/
			$k[$j++] = $1.lX; /*18608*/
			$k[$j++] = 238; /*18608*/
			$k[$j++] = $1.lT; /*18608*/
			$k[$j++] = 239; /*18608*/
			var _3G = $d(); /*18608*/
			$1[$k[--$j]] = _3G; /*18610*/
			$k[$j++] = "Avals"; /*18612*/
			$k[$j++] = Infinity; /*18612*/
			$forall($1.Avals, function() { /*18612*/
				$k[$j++] = Infinity; /*18612*/
				var _3J = $k[--$j]; /*18612*/
				var _3K = $k[--$j]; /*18612*/
				$k[$j++] = _3J; /*18612*/
				$k[$j++] = _3K; /*18612*/
				var _3L = $a(); /*18612*/
				$k[$j++] = _3L; /*18612*/
			}); /*18612*/
			var _3M = $d(); /*18612*/
			$1[$k[--$j]] = _3M; /*18613*/
			$k[$j++] = "CNvals"; /*18621*/
			$k[$j++] = Infinity; /*18621*/
			$k[$j++] = $1.sft1; /*18620*/
			$k[$j++] = 0; /*18620*/
			$k[$j++] = $1.sft2; /*18620*/
			$k[$j++] = 1; /*18620*/
			$k[$j++] = $1.sft3; /*18620*/
			$k[$j++] = 2; /*18620*/
			$k[$j++] = 32; /*18620*/
			$k[$j++] = 3; /*18620*/
			for (var _3R = 48; _3R <= 57; _3R += 1) { /*18620*/
				$k[$j++] = _3R; /*18620*/
				$k[$j++] = _3R - 44; /*18620*/
			} /*18620*/
			for (var _3S = 65; _3S <= 90; _3S += 1) { /*18621*/
				$k[$j++] = _3S; /*18621*/
				$k[$j++] = _3S - 51; /*18621*/
			} /*18621*/
			var _3T = $d(); /*18621*/
			$1[$k[--$j]] = _3T; /*18622*/
			$k[$j++] = "C1vals"; /*18623*/
			$k[$j++] = Infinity; /*18623*/
			for (var _3V = 0; _3V <= 31; _3V += 1) { /*18623*/
				$k[$j++] = _3V; /*18623*/
				$k[$j++] = _3V; /*18623*/
			} /*18623*/
			var _3W = $d(); /*18623*/
			$1[$k[--$j]] = _3W; /*18623*/
			$k[$j++] = "C2vals"; /*18632*/
			$k[$j++] = Infinity; /*18632*/
			for (var _3Y = 33; _3Y <= 47; _3Y += 1) { /*18625*/
				$k[$j++] = _3Y; /*18625*/
				$k[$j++] = _3Y - 33; /*18625*/
			} /*18625*/
			for (var _3Z = 58; _3Z <= 64; _3Z += 1) { /*18626*/
				$k[$j++] = _3Z; /*18626*/
				$k[$j++] = _3Z - 43; /*18626*/
			} /*18626*/
			for (var _3a = 91; _3a <= 95; _3a += 1) { /*18627*/
				$k[$j++] = _3a; /*18627*/
				$k[$j++] = _3a - 69; /*18627*/
			} /*18627*/
			$k[$j++] = $1.fnc1; /*18632*/
			$k[$j++] = 27; /*18632*/
			$k[$j++] = $1.fnc2; /*18632*/
			$k[$j++] = 28; /*18632*/
			$k[$j++] = $1.fnc3; /*18632*/
			$k[$j++] = 29; /*18632*/
			$k[$j++] = $1.fnc4; /*18632*/
			$k[$j++] = 30; /*18632*/
			$k[$j++] = $1.pad; /*18632*/
			$k[$j++] = 31; /*18632*/
			var _3g = $d(); /*18632*/
			$1[$k[--$j]] = _3g; /*18633*/
			$k[$j++] = "C3vals"; /*18634*/
			$k[$j++] = Infinity; /*18634*/
			for (var _3i = 96; _3i <= 127; _3i += 1) { /*18634*/
				$k[$j++] = _3i; /*18634*/
				$k[$j++] = _3i - 96; /*18634*/
			} /*18634*/
			var _3j = $d(); /*18634*/
			$1[$k[--$j]] = _3j; /*18634*/
			$k[$j++] = "Cvals"; /*18639*/
			$k[$j++] = Infinity; /*18639*/
			$forall($1.CNvals, function() { /*18636*/
				$k[$j++] = Infinity; /*18636*/
				var _3m = $k[--$j]; /*18636*/
				var _3n = $k[--$j]; /*18636*/
				$k[$j++] = _3m; /*18636*/
				$k[$j++] = _3n; /*18636*/
				var _3o = $a(); /*18636*/
				$k[$j++] = _3o; /*18636*/
			}); /*18636*/
			$forall($1.C1vals, function() { /*18637*/
				$k[$j++] = Infinity; /*18637*/
				var _3q = $k[--$j]; /*18637*/
				var _3r = $k[--$j]; /*18637*/
				$k[$j++] = _3q; /*18637*/
				$k[$j++] = $get($1.CNvals, $1.sft1); /*18637*/
				$k[$j++] = _3r; /*18637*/
				var _3v = $a(); /*18637*/
				$k[$j++] = _3v; /*18637*/
			}); /*18637*/
			$forall($1.C2vals, function() { /*18638*/
				$k[$j++] = Infinity; /*18638*/
				var _3x = $k[--$j]; /*18638*/
				var _3y = $k[--$j]; /*18638*/
				$k[$j++] = _3x; /*18638*/
				$k[$j++] = $get($1.CNvals, $1.sft2); /*18638*/
				$k[$j++] = _3y; /*18638*/
				var _42 = $a(); /*18638*/
				$k[$j++] = _42; /*18638*/
			}); /*18638*/
			$forall($1.C3vals, function() { /*18639*/
				$k[$j++] = Infinity; /*18639*/
				var _44 = $k[--$j]; /*18639*/
				var _45 = $k[--$j]; /*18639*/
				$k[$j++] = _44; /*18639*/
				$k[$j++] = $get($1.CNvals, $1.sft3); /*18639*/
				$k[$j++] = _45; /*18639*/
				var _49 = $a(); /*18639*/
				$k[$j++] = _49; /*18639*/
			}); /*18639*/
			var _4A = $d(); /*18639*/
			$1[$k[--$j]] = _4A; /*18640*/
			$k[$j++] = "TNvals"; /*18648*/
			$k[$j++] = Infinity; /*18648*/
			$k[$j++] = $1.sft1; /*18647*/
			$k[$j++] = 0; /*18647*/
			$k[$j++] = $1.sft2; /*18647*/
			$k[$j++] = 1; /*18647*/
			$k[$j++] = $1.sft3; /*18647*/
			$k[$j++] = 2; /*18647*/
			$k[$j++] = 32; /*18647*/
			$k[$j++] = 3; /*18647*/
			for (var _4F = 48; _4F <= 57; _4F += 1) { /*18647*/
				$k[$j++] = _4F; /*18647*/
				$k[$j++] = _4F - 44; /*18647*/
			} /*18647*/
			for (var _4G = 97; _4G <= 122; _4G += 1) { /*18648*/
				$k[$j++] = _4G; /*18648*/
				$k[$j++] = _4G - 83; /*18648*/
			} /*18648*/
			var _4H = $d(); /*18648*/
			$1[$k[--$j]] = _4H; /*18649*/
			$k[$j++] = "T1vals"; /*18650*/
			$k[$j++] = Infinity; /*18650*/
			for (var _4J = 0; _4J <= 31; _4J += 1) { /*18650*/
				$k[$j++] = _4J; /*18650*/
				$k[$j++] = _4J; /*18650*/
			} /*18650*/
			var _4K = $d(); /*18650*/
			$1[$k[--$j]] = _4K; /*18650*/
			$k[$j++] = "T2vals"; /*18659*/
			$k[$j++] = Infinity; /*18659*/
			for (var _4M = 33; _4M <= 47; _4M += 1) { /*18652*/
				$k[$j++] = _4M; /*18652*/
				$k[$j++] = _4M - 33; /*18652*/
			} /*18652*/
			for (var _4N = 58; _4N <= 64; _4N += 1) { /*18653*/
				$k[$j++] = _4N; /*18653*/
				$k[$j++] = _4N - 43; /*18653*/
			} /*18653*/
			for (var _4O = 91; _4O <= 95; _4O += 1) { /*18654*/
				$k[$j++] = _4O; /*18654*/
				$k[$j++] = _4O - 69; /*18654*/
			} /*18654*/
			$k[$j++] = $1.fnc1; /*18659*/
			$k[$j++] = 27; /*18659*/
			$k[$j++] = $1.fnc2; /*18659*/
			$k[$j++] = 28; /*18659*/
			$k[$j++] = $1.fnc3; /*18659*/
			$k[$j++] = 29; /*18659*/
			$k[$j++] = $1.fnc4; /*18659*/
			$k[$j++] = 30; /*18659*/
			$k[$j++] = $1.pad; /*18659*/
			$k[$j++] = 31; /*18659*/
			var _4U = $d(); /*18659*/
			$1[$k[--$j]] = _4U; /*18660*/
			$k[$j++] = "T3vals"; /*18664*/
			$k[$j++] = Infinity; /*18664*/
			$k[$j++] = 96; /*18663*/
			$k[$j++] = 0; /*18663*/
			for (var _4W = 65; _4W <= 90; _4W += 1) { /*18663*/
				$k[$j++] = _4W; /*18663*/
				$k[$j++] = _4W - 64; /*18663*/
			} /*18663*/
			for (var _4X = 123; _4X <= 127; _4X += 1) { /*18664*/
				$k[$j++] = _4X; /*18664*/
				$k[$j++] = _4X - 96; /*18664*/
			} /*18664*/
			var _4Y = $d(); /*18664*/
			$1[$k[--$j]] = _4Y; /*18665*/
			$k[$j++] = "Tvals"; /*18670*/
			$k[$j++] = Infinity; /*18670*/
			$forall($1.TNvals, function() { /*18667*/
				$k[$j++] = Infinity; /*18667*/
				var _4b = $k[--$j]; /*18667*/
				var _4c = $k[--$j]; /*18667*/
				$k[$j++] = _4b; /*18667*/
				$k[$j++] = _4c; /*18667*/
				var _4d = $a(); /*18667*/
				$k[$j++] = _4d; /*18667*/
			}); /*18667*/
			$forall($1.T1vals, function() { /*18668*/
				$k[$j++] = Infinity; /*18668*/
				var _4f = $k[--$j]; /*18668*/
				var _4g = $k[--$j]; /*18668*/
				$k[$j++] = _4f; /*18668*/
				$k[$j++] = $get($1.TNvals, $1.sft1); /*18668*/
				$k[$j++] = _4g; /*18668*/
				var _4k = $a(); /*18668*/
				$k[$j++] = _4k; /*18668*/
			}); /*18668*/
			$forall($1.T2vals, function() { /*18669*/
				$k[$j++] = Infinity; /*18669*/
				var _4m = $k[--$j]; /*18669*/
				var _4n = $k[--$j]; /*18669*/
				$k[$j++] = _4m; /*18669*/
				$k[$j++] = $get($1.TNvals, $1.sft2); /*18669*/
				$k[$j++] = _4n; /*18669*/
				var _4r = $a(); /*18669*/
				$k[$j++] = _4r; /*18669*/
			}); /*18669*/
			$forall($1.T3vals, function() { /*18670*/
				$k[$j++] = Infinity; /*18670*/
				var _4t = $k[--$j]; /*18670*/
				var _4u = $k[--$j]; /*18670*/
				$k[$j++] = _4t; /*18670*/
				$k[$j++] = $get($1.TNvals, $1.sft3); /*18670*/
				$k[$j++] = _4u; /*18670*/
				var _4y = $a(); /*18670*/
				$k[$j++] = _4y; /*18670*/
			}); /*18670*/
			var _4z = $d(); /*18670*/
			$1[$k[--$j]] = _4z; /*18671*/
			for (var _51 = 128; _51 <= 255; _51 += 1) { /*18679*/
				$1.i = _51; /*18675*/
				$k[$j++] = $1.Avals; /*18676*/
				$k[$j++] = $1.i; /*18676*/
				$k[$j++] = Infinity; /*18676*/
				$aload($get($1.Avals, $1.fnc4)); /*18676*/
				$aload($get($1.Avals, $1.i - 128)); /*18676*/
				var _5A = $a(); /*18676*/
				var _5B = $k[--$j]; /*18676*/
				$put($k[--$j], _5B, _5A); /*18676*/
				$k[$j++] = $1.Cvals; /*18677*/
				$k[$j++] = $1.i; /*18677*/
				$k[$j++] = Infinity; /*18677*/
				$aload($get($1.Cvals, $1.fnc4)); /*18677*/
				$aload($get($1.Cvals, $1.i - 128)); /*18677*/
				var _5L = $a(); /*18677*/
				var _5M = $k[--$j]; /*18677*/
				$put($k[--$j], _5M, _5L); /*18677*/
				$k[$j++] = $1.Tvals; /*18678*/
				$k[$j++] = $1.i; /*18678*/
				$k[$j++] = Infinity; /*18678*/
				$aload($get($1.Tvals, $1.fnc4)); /*18678*/
				$aload($get($1.Tvals, $1.i - 128)); /*18678*/
				var _5W = $a(); /*18678*/
				var _5X = $k[--$j]; /*18678*/
				$put($k[--$j], _5X, _5W); /*18678*/
			} /*18678*/
			$k[$j++] = "Xvals"; /*18687*/
			$k[$j++] = Infinity; /*18687*/
			$k[$j++] = 13; /*18686*/
			$k[$j++] = 0; /*18686*/
			$k[$j++] = 42; /*18686*/
			$k[$j++] = 1; /*18686*/
			$k[$j++] = 62; /*18686*/
			$k[$j++] = 2; /*18686*/
			$k[$j++] = 32; /*18686*/
			$k[$j++] = 3; /*18686*/
			for (var _5Z = 48; _5Z <= 57; _5Z += 1) { /*18686*/
				$k[$j++] = _5Z; /*18686*/
				$k[$j++] = _5Z - 44; /*18686*/
			} /*18686*/
			for (var _5a = 65; _5a <= 90; _5a += 1) { /*18687*/
				$k[$j++] = _5a; /*18687*/
				$k[$j++] = _5a - 51; /*18687*/
			} /*18687*/
			var _5b = $d(); /*18687*/
			$1[$k[--$j]] = _5b; /*18688*/
			$k[$j++] = "Xvals"; /*18690*/
			$k[$j++] = Infinity; /*18690*/
			$forall($1.Xvals, function() { /*18690*/
				$k[$j++] = Infinity; /*18690*/
				var _5e = $k[--$j]; /*18690*/
				var _5f = $k[--$j]; /*18690*/
				$k[$j++] = _5e; /*18690*/
				$k[$j++] = _5f; /*18690*/
				var _5g = $a(); /*18690*/
				$k[$j++] = _5g; /*18690*/
			}); /*18690*/
			var _5h = $d(); /*18690*/
			$1[$k[--$j]] = _5h; /*18691*/
			$k[$j++] = "Bvals"; /*18694*/
			$k[$j++] = Infinity; /*18694*/
			for (var _5j = 0; _5j <= 255; _5j += 1) { /*18694*/
				$k[$j++] = _5j; /*18694*/
				$k[$j++] = _5j; /*18694*/
			} /*18694*/
			var _5k = $d(); /*18694*/
			$1[$k[--$j]] = _5k; /*18695*/
			$k[$j++] = "Bvals"; /*18697*/
			$k[$j++] = Infinity; /*18697*/
			$forall($1.Bvals, function() { /*18697*/
				$k[$j++] = Infinity; /*18697*/
				var _5n = $k[--$j]; /*18697*/
				var _5o = $k[--$j]; /*18697*/
				$k[$j++] = _5n; /*18697*/
				$k[$j++] = _5o; /*18697*/
				var _5p = $a(); /*18697*/
				$k[$j++] = _5p; /*18697*/
			}); /*18697*/
			var _5q = $d(); /*18697*/
			$1[$k[--$j]] = _5q; /*18698*/
			$1.encvals = $a([$1.Avals, $1.Cvals, $1.Tvals, $1.Xvals, -1, $1.Bvals]); /*18700*/
			$k[$j++] = Infinity; /*18702*/
			for (var _5z = 0, _60 = $1.msglen; _5z < _60; _5z++) { /*18702*/
				$k[$j++] = 0; /*18702*/
			} /*18702*/
			$k[$j++] = 0; /*18702*/
			$1.numD = $a(); /*18702*/
			$k[$j++] = Infinity; /*18703*/
			for (var _63 = 0, _64 = $1.msglen; _63 < _64; _63++) { /*18703*/
				$k[$j++] = 0; /*18703*/
			} /*18703*/
			$k[$j++] = 9999; /*18703*/
			$1.nextXterm = $a(); /*18703*/
			$k[$j++] = Infinity; /*18704*/
			for (var _67 = 0, _68 = $1.msglen; _67 < _68; _67++) { /*18704*/
				$k[$j++] = 0; /*18704*/
			} /*18704*/
			$k[$j++] = 9999; /*18704*/
			$1.nextNonX = $a(); /*18704*/
			for (var _6B = $1.msglen - 1; _6B >= 0; _6B -= 1) { /*18721*/
				$1.i = _6B; /*18706*/
				$1.barchar = $get($1.msg, $1.i); /*18707*/
				if (($1.barchar >= 48) && ($1.barchar <= 57)) { /*18710*/
					$put($1.numD, $1.i, $get($1.numD, $1.i + 1) + 1); /*18709*/
				} /*18709*/
				if ((($1.barchar == 13) || ($1.barchar == 42)) || ($1.barchar == 62)) { /*18714*/
					$put($1.nextXterm, $1.i, 0); /*18712*/
				} else { /*18714*/
					$put($1.nextXterm, $1.i, $get($1.nextXterm, $1.i + 1) + 1); /*18714*/
				} /*18714*/
				var _6Y = $get($1.Xvals, $1.barchar) !== undefined; /*18716*/
				if (!_6Y) { /*18719*/
					$put($1.nextNonX, $1.i, 0); /*18717*/
				} else { /*18719*/
					$put($1.nextNonX, $1.i, $get($1.nextNonX, $1.i + 1) + 1); /*18719*/
				} /*18719*/
			} /*18719*/
			$k[$j++] = Infinity; /*18722*/
			var _6g = $1.nextXterm; /*18722*/
			for (var _6h = 0, _6i = _6g.length; _6h < _6i; _6h++) { /*18722*/
				var _6j = $get(_6g, _6h); /*18722*/
				$k[$j++] = _6j; /*18722*/
				if (_6j > 10000) { /*18722*/
					$j--; /*18722*/
					$k[$j++] = 10000; /*18722*/
				} /*18722*/
			} /*18722*/
			$1.nextXterm = $a(); /*18722*/
			$k[$j++] = Infinity; /*18723*/
			var _6l = $1.nextNonX; /*18723*/
			for (var _6m = 0, _6n = _6l.length; _6m < _6n; _6m++) { /*18723*/
				var _6o = $get(_6l, _6m); /*18723*/
				$k[$j++] = _6o; /*18723*/
				if (_6o > 10000) { /*18723*/
					$j--; /*18723*/
					$k[$j++] = 10000; /*18723*/
				} /*18723*/
			} /*18723*/
			$1.nextNonX = $a(); /*18723*/
			$1.isD = function() {
				$k[$j++] = ($1.char >= 48) && ($1.char <= 57); /*18725*/
			}; /*18725*/
			$1.isC = function() {
				var _6u = $get($1.CNvals, $1.char) !== undefined; /*18726*/
				$k[$j++] = _6u; /*18726*/
			}; /*18726*/
			$1.isT = function() {
				var _6x = $get($1.TNvals, $1.char) !== undefined; /*18727*/
				$k[$j++] = _6x; /*18727*/
			}; /*18727*/
			$1.isX = function() {
				var _70 = $get($1.Xvals, $1.char) !== undefined; /*18728*/
				$k[$j++] = _70; /*18728*/
			}; /*18728*/
			$1.isEA = function() {
				$k[$j++] = $1.char > 127; /*18729*/
			}; /*18729*/
			$1.isFN = function() {
				$k[$j++] = $1.char < 0; /*18730*/
			}; /*18730*/
			$1.XtermFirst = function() {
				var _73 = $k[--$j]; /*18731*/
				$k[$j++] = $lt($get($1.nextXterm, _73), $get($1.nextNonX, _73)); /*18731*/
			}; /*18731*/
			$1.A = 0; /*18733*/
			$1.C = 1; /*18733*/
			$1.T = 2; /*18733*/
			$1.X = 3; /*18733*/
			$1.D = 4; /*18733*/
			$1.B = 5; /*18733*/
			$1.lookup = function() {
				$1.ac = 1; /*18736*/
				$1.cc = 2; /*18736*/
				$1.tc = 2; /*18736*/
				$1.xc = 2; /*18736*/
				$1.bc = 3; /*18736*/
				if ($1.mode == $1.A) { /*18737*/
					$1.ac = 0; /*18737*/
					$1.cc = 1; /*18737*/
					$1.tc = 1; /*18737*/
					$1.xc = 1; /*18737*/
					$1.bc = 2; /*18737*/
				} /*18737*/
				if ($1.mode == $1.C) { /*18738*/
					$1.cc = 0; /*18738*/
				} /*18738*/
				if ($1.mode == $1.T) { /*18739*/
					$1.tc = 0; /*18739*/
				} /*18739*/
				if ($1.mode == $1.X) { /*18740*/
					$1.xc = 0; /*18740*/
				} /*18740*/
				if ($1.mode == $1.B) { /*18741*/
					$1.bc = 0; /*18741*/
				} /*18741*/
				for (var _7I = 0, _7J = 1; _7I < _7J; _7I++) { /*18769*/
					$1.k = 0; /*18743*/
					for (;;) { /*18768*/
						if (($1.i + $1.k) == $1.msglen) { /*18750*/
							var _7R = $a([$1.ac, $1.cc, $1.tc, $1.xc]); /*18745*/
							$k[$j++] = true; /*18745*/
							for (var _7S = 0, _7T = _7R.length; _7S < _7T; _7S++) { /*18745*/
								var _7W = $k[--$j]; /*18745*/
								$k[$j++] = _7W && ($1.bc <= Math.ceil($get(_7R, _7S))); /*18745*/
							} /*18745*/
							if ($k[--$j]) { /*18745*/
								$k[$j++] = $1.B; /*18745*/
								break; /*18745*/
							} /*18745*/
							var _7d = $a([$1.cc, $1.tc, $1.xc, $1.bc]); /*18746*/
							$k[$j++] = true; /*18746*/
							for (var _7e = 0, _7f = _7d.length; _7e < _7f; _7e++) { /*18746*/
								var _7i = $k[--$j]; /*18746*/
								$k[$j++] = _7i && ($1.ac <= Math.ceil($get(_7d, _7e))); /*18746*/
							} /*18746*/
							if ($k[--$j]) { /*18746*/
								$k[$j++] = $1.A; /*18746*/
								break; /*18746*/
							} /*18746*/
							var _7n = $a([$1.tc, $1.xc]); /*18747*/
							$k[$j++] = true; /*18747*/
							for (var _7o = 0, _7p = _7n.length; _7o < _7p; _7o++) { /*18747*/
								var _7s = $k[--$j]; /*18747*/
								$k[$j++] = _7s && (Math.ceil($1.cc) <= Math.ceil($get(_7n, _7o))); /*18747*/
							} /*18747*/
							if ($k[--$j]) { /*18747*/
								$k[$j++] = $1.C; /*18747*/
								break; /*18747*/
							} /*18747*/
							var _7w = $a([$1.xc]); /*18748*/
							$k[$j++] = true; /*18748*/
							for (var _7x = 0, _7y = _7w.length; _7x < _7y; _7x++) { /*18748*/
								var _81 = $k[--$j]; /*18748*/
								$k[$j++] = _81 && (Math.ceil($1.tc) <= Math.ceil($get(_7w, _7x))); /*18748*/
							} /*18748*/
							if ($k[--$j]) { /*18748*/
								$k[$j++] = $1.T; /*18748*/
								break; /*18748*/
							} /*18748*/
							$k[$j++] = $1.X; /*18749*/
							break; /*18749*/
						} /*18749*/
						$1.char = $get($1.msg, $1.i + $1.k); /*18751*/
						$k[$j++] = "ac"; /*18752*/
						$k[$j++] = $1.ac; /*18752*/
						$1.isD(); /*18752*/
						if ($k[--$j]) { /*18752*/
							var _8B = $k[--$j]; /*18752*/
							$k[$j++] = _8B + (1 / 2); /*18752*/
						} else { /*18752*/
							$1.isEA(); /*18752*/
							if ($k[--$j]) { /*18752*/
								var _8D = $k[--$j]; /*18752*/
								$k[$j++] = Math.ceil(_8D) + 2; /*18752*/
							} else { /*18752*/
								var _8E = $k[--$j]; /*18752*/
								$k[$j++] = Math.ceil(_8E) + 1; /*18752*/
							} /*18752*/
						} /*18752*/
						var _8F = $k[--$j]; /*18752*/
						$1[$k[--$j]] = _8F; /*18752*/
						$k[$j++] = "cc"; /*18753*/
						$k[$j++] = $1.cc; /*18753*/
						$1.isC(); /*18753*/
						if ($k[--$j]) { /*18753*/
							var _8J = $k[--$j]; /*18753*/
							$k[$j++] = _8J + (2 / 3); /*18753*/
						} else { /*18753*/
							$1.isEA(); /*18753*/
							if ($k[--$j]) { /*18753*/
								var _8L = $k[--$j]; /*18753*/
								$k[$j++] = _8L + (8 / 3); /*18753*/
							} else { /*18753*/
								var _8M = $k[--$j]; /*18753*/
								$k[$j++] = _8M + (4 / 3); /*18753*/
							} /*18753*/
						} /*18753*/
						var _8N = $k[--$j]; /*18753*/
						$1[$k[--$j]] = _8N; /*18753*/
						$k[$j++] = "tc"; /*18754*/
						$k[$j++] = $1.tc; /*18754*/
						$1.isT(); /*18754*/
						if ($k[--$j]) { /*18754*/
							var _8R = $k[--$j]; /*18754*/
							$k[$j++] = _8R + (2 / 3); /*18754*/
						} else { /*18754*/
							$1.isEA(); /*18754*/
							if ($k[--$j]) { /*18754*/
								var _8T = $k[--$j]; /*18754*/
								$k[$j++] = _8T + (8 / 3); /*18754*/
							} else { /*18754*/
								var _8U = $k[--$j]; /*18754*/
								$k[$j++] = _8U + (4 / 3); /*18754*/
							} /*18754*/
						} /*18754*/
						var _8V = $k[--$j]; /*18754*/
						$1[$k[--$j]] = _8V; /*18754*/
						$k[$j++] = "xc"; /*18755*/
						$k[$j++] = $1.xc; /*18755*/
						$1.isX(); /*18755*/
						if ($k[--$j]) { /*18755*/
							var _8Z = $k[--$j]; /*18755*/
							$k[$j++] = _8Z + (2 / 3); /*18755*/
						} else { /*18755*/
							$1.isEA(); /*18755*/
							if ($k[--$j]) { /*18755*/
								var _8b = $k[--$j]; /*18755*/
								$k[$j++] = _8b + (13 / 3); /*18755*/
							} else { /*18755*/
								var _8c = $k[--$j]; /*18755*/
								$k[$j++] = _8c + (10 / 3); /*18755*/
							} /*18755*/
						} /*18755*/
						var _8d = $k[--$j]; /*18755*/
						$1[$k[--$j]] = _8d; /*18755*/
						$k[$j++] = "bc"; /*18756*/
						$k[$j++] = $1.bc; /*18756*/
						$1.isFN(); /*18756*/
						if ($k[--$j]) { /*18756*/
							var _8h = $k[--$j]; /*18756*/
							$k[$j++] = _8h + 3; /*18756*/
						} else { /*18756*/
							var _8i = $k[--$j]; /*18756*/
							$k[$j++] = _8i + 1; /*18756*/
						} /*18756*/
						var _8j = $k[--$j]; /*18756*/
						$1[$k[--$j]] = _8j; /*18756*/
						if ($1.k >= 3) { /*18766*/
							var _8q = $a([$1.ac, $1.cc, $1.tc, $1.xc]); /*18758*/
							$k[$j++] = true; /*18758*/
							for (var _8r = 0, _8s = _8q.length; _8r < _8s; _8r++) { /*18758*/
								var _8v = $k[--$j]; /*18758*/
								$k[$j++] = _8v && (($1.bc + 1) <= Math.ceil($get(_8q, _8r))); /*18758*/
							} /*18758*/
							if ($k[--$j]) { /*18758*/
								$k[$j++] = $1.B; /*18758*/
								break; /*18758*/
							} /*18758*/
							var _92 = $a([$1.cc, $1.tc, $1.xc, $1.bc]); /*18759*/
							$k[$j++] = true; /*18759*/
							for (var _93 = 0, _94 = _92.length; _93 < _94; _93++) { /*18759*/
								var _97 = $k[--$j]; /*18759*/
								$k[$j++] = _97 && (($1.ac + 1) <= Math.ceil($get(_92, _93))); /*18759*/
							} /*18759*/
							if ($k[--$j]) { /*18759*/
								$k[$j++] = $1.A; /*18759*/
								break; /*18759*/
							} /*18759*/
							var _9E = $a([$1.ac, $1.cc, $1.xc, $1.bc]); /*18760*/
							$k[$j++] = true; /*18760*/
							for (var _9F = 0, _9G = _9E.length; _9F < _9G; _9F++) { /*18760*/
								var _9J = $k[--$j]; /*18760*/
								$k[$j++] = _9J && (($1.tc + 1) <= Math.ceil($get(_9E, _9F))); /*18760*/
							} /*18760*/
							if ($k[--$j]) { /*18760*/
								$k[$j++] = $1.T; /*18760*/
								break; /*18760*/
							} /*18760*/
							var _9O = $a([$1.ac, $1.tc]); /*18761*/
							$k[$j++] = true; /*18761*/
							for (var _9P = 0, _9Q = _9O.length; _9P < _9Q; _9P++) { /*18761*/
								var _9T = $k[--$j]; /*18761*/
								$k[$j++] = _9T && (($1.cc + 1) <= Math.ceil($get(_9O, _9P))); /*18761*/
							} /*18761*/
							if ($k[--$j]) { /*18764*/
								if (Math.ceil($1.cc) < Math.ceil($1.xc)) { /*18762*/
									$k[$j++] = $1.C; /*18762*/
									break; /*18762*/
								} /*18762*/
								if ($1.cc == $1.xc) { /*18763*/
									$k[$j++] = ($1.i + $1.k) + 1; /*18763*/
									$1.XtermFirst(); /*18763*/
									if ($k[--$j]) { /*18763*/
										$k[$j++] = $1.X; /*18763*/
										break; /*18763*/
									} else { /*18763*/
										$k[$j++] = $1.C; /*18763*/
										break; /*18763*/
									} /*18763*/
								} /*18763*/
							} /*18763*/
							var _9j = $a([$1.ac, $1.cc, $1.tc, $1.bc]); /*18765*/
							$k[$j++] = true; /*18765*/
							for (var _9k = 0, _9l = _9j.length; _9k < _9l; _9k++) { /*18765*/
								var _9o = $k[--$j]; /*18765*/
								$k[$j++] = _9o && (($1.xc + 1) < $get(_9j, _9k)); /*18765*/
							} /*18765*/
							if ($k[--$j]) { /*18765*/
								$k[$j++] = $1.X; /*18765*/
								break; /*18765*/
							} /*18765*/
						} /*18765*/
						$1.k = $1.k + 1; /*18767*/
					} /*18767*/
				} /*18767*/
			}; /*18770*/
			$1.addtocws = function() {
				var _9s = $k[--$j]; /*18773*/
				$puti($1.cws, $1.j, _9s); /*18773*/
				$1.j = _9s.length + $1.j; /*18774*/
			}; /*18775*/
			$1.tobin = function() {
				var _9x = $s($k[--$j]); /*18778*/
				$k[$j++] = _9x; /*18778*/
				for (var _9z = 0, _9y = _9x.length - 1; _9z <= _9y; _9z += 1) { /*18778*/
					var _A0 = $k[--$j]; /*18778*/
					$put(_A0, _9z, 48); /*18778*/
					$k[$j++] = _A0; /*18778*/
				} /*18778*/
				var _A1 = $k[--$j]; /*18779*/
				var _A4 = $cvrs($s(_A1.length), $k[--$j], 2); /*18779*/
				$puti(_A1, _A1.length - _A4.length, _A4); /*18779*/
				$k[$j++] = _A1; /*18780*/
				$k[$j++] = Infinity; /*18780*/
				var _A5 = $k[--$j]; /*18780*/
				var _A6 = $k[--$j]; /*18780*/
				$k[$j++] = _A5; /*18780*/
				$forall(_A6, function() { /*18780*/
					var _A7 = $k[--$j]; /*18780*/
					$k[$j++] = _A7 - 48; /*18780*/
				}); /*18780*/
				var _A8 = $a(); /*18780*/
				$k[$j++] = _A8; /*18780*/
			}; /*18781*/
			$1.encA = function() {
				for (var _A9 = 0, _AA = 1; _A9 < _AA; _A9++) { /*18825*/
					if ($get($1.numD, $1.i) >= 21) { /*18789*/
						$1.Dbits = $a([1, 1, 1, 1]); /*18786*/
						$1.mode = $1.D; /*18787*/
						break; /*18788*/
					} /*18788*/
					var _AI = $get($1.numD, $1.i); /*18790*/
					if ((_AI >= 13) && ((_AI + $1.i) == $1.msglen)) { /*18794*/
						$1.Dbits = $a([1, 1, 1, 1]); /*18791*/
						$1.mode = $1.D; /*18792*/
						break; /*18793*/
					} /*18793*/
					if ($get($1.numD, $1.i) >= 2) { /*18799*/
						var _AQ = $s(2); /*18796*/
						$put(_AQ, 0, $get($1.msg, $1.i)); /*18796*/
						$put(_AQ, 1, $get($1.msg, $1.i + 1)); /*18796*/
						$k[$j++] = $get($1.Avals, _AQ); /*18796*/
						$1.addtocws(); /*18796*/
						$1.i = $1.i + 2; /*18797*/
						break; /*18798*/
					} /*18798*/
					if ($get($1.msg, $1.i) == $1.fnc1) { /*18815*/
						if ($get($1.numD, $1.i + 1) >= 15) { /*18807*/
							$k[$j++] = $get($1.Avals, $1.fnc1lD); /*18802*/
							$1.addtocws(); /*18802*/
							$1.i = $1.i + 1; /*18803*/
							$1.Dbits = $a([]); /*18804*/
							$1.mode = $1.D; /*18805*/
							break; /*18806*/
						} /*18806*/
						var _Ap = $get($1.numD, $1.i + 1); /*18808*/
						if ((_Ap >= 7) && (((_Ap + $1.i) + 1) == $1.msglen)) { /*18814*/
							$k[$j++] = $get($1.Avals, $1.fnc1lD); /*18809*/
							$1.addtocws(); /*18809*/
							$1.i = $1.i + 1; /*18810*/
							$1.Dbits = $a([]); /*18811*/
							$1.mode = $1.D; /*18812*/
							break; /*18813*/
						} /*18813*/
					} /*18813*/
					$k[$j++] = "newmode"; /*18816*/
					$1.lookup(); /*18816*/
					var _Ay = $k[--$j]; /*18816*/
					$1[$k[--$j]] = _Ay; /*18816*/
					if ($1.newmode != $1.mode) { /*18821*/
						$k[$j++] = $get($1.Avals, $get($a([-1, $1.lC, $1.lT, $1.lX, $1.lD, $1.lB]), $1.newmode)); /*18818*/
						$1.addtocws(); /*18818*/
						$1.mode = $1.newmode; /*18819*/
						break; /*18820*/
					} /*18820*/
					$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*18822*/
					$1.addtocws(); /*18822*/
					$1.i = $1.i + 1; /*18823*/
					break; /*18824*/
				} /*18824*/
			}; /*18826*/
			$1.CTXvalstocws = function() {
				$1.in = $k[--$j]; /*18829*/
				$k[$j++] = Infinity; /*18830*/
				for (var _BM = 0, _BL = $1.in.length - 1; _BM <= _BL; _BM += 3) { /*18834*/
					$k[$j++] = 0; /*18832*/
					$forall($geti($1.in, _BM, 3), function() { /*18832*/
						var _BP = $k[--$j]; /*18832*/
						var _BQ = $k[--$j]; /*18832*/
						$k[$j++] = (_BQ + _BP) * 40; /*18832*/
					}); /*18832*/
					var _BS = (~~($k[--$j] / 40)) + 1; /*18833*/
					$k[$j++] = ~~(_BS / 256); /*18833*/
					$k[$j++] = _BS % 256; /*18833*/
				} /*18833*/
				$astore($a($counttomark())); /*18835*/
				var _BV = $k[--$j]; /*18835*/
				var _BW = $k[--$j]; /*18835*/
				$k[$j++] = _BV; /*18835*/
			}; /*18836*/
			$1.encCTX = function() {
				$1.p = 0; /*18839*/
				$1.ctxvals = $a(2220); /*18840*/
				for (;;) { /*18918*/
					if ($1.i == $1.msglen) { /*18844*/
						break; /*18844*/
					} /*18844*/
					var _Bg = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)) !== undefined; /*18845*/
					if (!_Bg) { /*18845*/
						break; /*18845*/
					} /*18845*/
					if (($1.p % 3) == 0) { /*18913*/
						if ($get($1.numD, $1.i) >= 12) { /*18851*/
							$k[$j++] = $a([$1.unlcw]); /*18848*/
							$1.addtocws(); /*18848*/
							$1.mode = $1.A; /*18849*/
							break; /*18850*/
						} /*18850*/
						var _Bq = $get($1.numD, $1.i); /*18852*/
						if ((_Bq >= 8) && ((_Bq + $1.i) == $1.msglen)) { /*18856*/
							$k[$j++] = $a([$1.unlcw]); /*18853*/
							$1.addtocws(); /*18853*/
							$1.mode = $1.A; /*18854*/
							break; /*18855*/
						} /*18855*/
						$1.lookup(); /*18857*/
						if ($k[--$j] != $1.mode) { /*18862*/
							$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*18858*/
							$1.CTXvalstocws(); /*18858*/
							$1.addtocws(); /*18858*/
							$k[$j++] = $a([$1.unlcw]); /*18859*/
							$1.addtocws(); /*18859*/
							$1.mode = $1.A; /*18860*/
							break; /*18861*/
						} /*18861*/
						if (($1.msglen - $1.i) <= 3) { /*18912*/
							$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 3)) * 2)); /*18864*/
							$k[$j++] = Infinity; /*18873*/
							$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*18872*/
								var _CF = $k[--$j]; /*18867*/
								var _CJ = $get($get($1.encvals, $1.mode), _CF) !== undefined; /*18867*/
								$k[$j++] = _CF; /*18871*/
								if (_CJ) { /*18870*/
									$aload($get($get($1.encvals, $1.mode), $k[--$j])); /*18868*/
								} else { /*18870*/
									$j--; /*18870*/
									$k[$j++] = -1; /*18870*/
									$k[$j++] = -1; /*18870*/
									$k[$j++] = -1; /*18870*/
									$k[$j++] = -1; /*18870*/
								} /*18870*/
							}); /*18870*/
							$1.remvals = $a(); /*18873*/
							if (($1.remcws == 2) && ($1.remvals.length == 3)) { /*18883*/
								$k[$j++] = Infinity; /*18878*/
								$aload($geti($1.ctxvals, 0, $1.p)); /*18877*/
								$aload($1.remvals); /*18878*/
								var _CW = $a(); /*18878*/
								$k[$j++] = _CW; /*18879*/
								$1.CTXvalstocws(); /*18879*/
								$1.addtocws(); /*18879*/
								$1.mode = $1.A; /*18880*/
								$1.i = $1.msglen; /*18881*/
								break; /*18882*/
							} /*18882*/
							if ((($1.remcws == 2) && ($1.remvals.length == 2)) && ($1.mode != $1.X)) { /*18894*/
								$k[$j++] = Infinity; /*18889*/
								$aload($geti($1.ctxvals, 0, $1.p)); /*18887*/
								$aload($1.remvals); /*18888*/
								$aload($get($get($1.encvals, $1.mode), $1.sft1)); /*18889*/
								var _Cm = $a(); /*18889*/
								$k[$j++] = _Cm; /*18890*/
								$1.CTXvalstocws(); /*18890*/
								$1.addtocws(); /*18890*/
								$1.mode = $1.A; /*18891*/
								$1.i = $1.msglen; /*18892*/
								break; /*18893*/
							} /*18893*/
							if (($1.remcws == 2) && ($1.remvals.length == 1)) { /*18903*/
								$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*18897*/
								$1.CTXvalstocws(); /*18897*/
								$1.addtocws(); /*18897*/
								$k[$j++] = $a([$1.unlcw]); /*18898*/
								$1.addtocws(); /*18898*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*18899*/
								$1.addtocws(); /*18899*/
								$1.mode = $1.A; /*18900*/
								$1.i = $1.msglen; /*18901*/
								break; /*18902*/
							} /*18902*/
							if (($1.remcws == 1) && ($1.remvals.length == 1)) { /*18911*/
								$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*18906*/
								$1.CTXvalstocws(); /*18906*/
								$1.addtocws(); /*18906*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*18907*/
								$1.addtocws(); /*18907*/
								$1.mode = $1.A; /*18908*/
								$1.i = $1.msglen; /*18909*/
								break; /*18910*/
							} /*18910*/
						} /*18910*/
					} /*18910*/
					var _DL = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)); /*18914*/
					$puti($1.ctxvals, $1.p, _DL); /*18915*/
					$1.p = _DL.length + $1.p; /*18916*/
					$1.i = $1.i + 1; /*18917*/
				} /*18917*/
				if ($1.mode != $1.A) { /*18942*/
					for (;;) { /*18926*/
						if (($1.p % 3) == 0) { /*18923*/
							break; /*18923*/
						} /*18923*/
						$1.i = $1.i - 1; /*18924*/
						$1.p = $1.p - $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)).length; /*18925*/
					} /*18925*/
					$k[$j++] = Infinity; /*18928*/
					$aload($geti($1.ctxvals, 0, $1.p)); /*18928*/
					var _Df = $a(); /*18928*/
					$k[$j++] = _Df; /*18929*/
					$1.CTXvalstocws(); /*18929*/
					$1.addtocws(); /*18929*/
					$k[$j++] = $a([$1.unlcw]); /*18930*/
					$1.addtocws(); /*18930*/
					$1.mode = $1.A; /*18931*/
					if ($1.i != $1.msglen) { /*18941*/
						if ($get($1.numD, $1.i) >= 2) { /*18939*/
							var _Do = $s(2); /*18935*/
							$put(_Do, 0, $get($1.msg, $1.i)); /*18935*/
							$put(_Do, 1, $get($1.msg, $1.i + 1)); /*18935*/
							$k[$j++] = $get($1.Avals, _Do); /*18935*/
							$1.addtocws(); /*18935*/
							$1.i = $1.i + 2; /*18936*/
						} else { /*18939*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*18938*/
							$1.addtocws(); /*18938*/
							$1.i = $1.i + 1; /*18939*/
						} /*18939*/
					} /*18939*/
				} /*18939*/
			}; /*18944*/
			$1.encD = function() {
				for (;;) { /*18997*/
					if ($get($1.numD, $1.i) < 3) { /*18987*/
						$1.Drem = (8 - ($1.Dbits.length % 8)) % 8; /*18952*/
						$1.remcws = $get($1.numremcws, $1.j + (~~($1.Dbits.length / 8))); /*18953*/
						if ((($get($1.numremcws, ($1.j + (~~($1.Dbits.length / 8))) - 1) - 1) == 0) && ($1.i == $1.msglen)) { /*18957*/
							break; /*18957*/
						} /*18957*/
						if (((($1.i == ($1.msglen - 1)) && ($get($1.numD, $1.i) == 1)) && ($1.remcws == 1)) && ($1.Drem == 0)) { /*18961*/
							break; /*18961*/
						} /*18961*/
						if (!(((($1.i == ($1.msglen - 1)) && ($get($1.numD, $1.i) == 1)) && ($1.remcws == 1)) && (($1.Drem == 4) || ($1.Drem == 6)))) { /*18968*/
							$k[$j++] = Infinity; /*18966*/
							$aload($1.Dbits); /*18966*/
							$k[$j++] = 1; /*18966*/
							$k[$j++] = 1; /*18966*/
							$k[$j++] = 1; /*18966*/
							$k[$j++] = 1; /*18966*/
							$k[$j++] = 1; /*18966*/
							$k[$j++] = 1; /*18966*/
							$1.Dbits = $a(); /*18966*/
							$1.Drem = (8 - ($1.Dbits.length % 8)) % 8; /*18967*/
						} /*18967*/
						if (($1.Drem == 4) || ($1.Drem == 6)) { /*18979*/
							if ($get($1.numD, $1.i) >= 1) { /*18976*/
								$k[$j++] = Infinity; /*18973*/
								$aload($1.Dbits); /*18973*/
								$k[$j++] = ($get($1.msg, $1.i) - 48) + 1; /*18973*/
								$k[$j++] = 4; /*18973*/
								$1.tobin(); /*18973*/
								$aload($k[--$j]); /*18973*/
								$1.Dbits = $a(); /*18973*/
								$1.i = $1.i + 1; /*18974*/
							} else { /*18976*/
								$k[$j++] = Infinity; /*18976*/
								$aload($1.Dbits); /*18976*/
								$k[$j++] = 1; /*18976*/
								$k[$j++] = 1; /*18976*/
								$k[$j++] = 1; /*18976*/
								$k[$j++] = 1; /*18976*/
								$1.Dbits = $a(); /*18976*/
							} /*18976*/
							$1.Drem = $1.Drem - 4; /*18978*/
						} /*18978*/
						if ($1.Drem == 2) { /*18983*/
							$k[$j++] = Infinity; /*18981*/
							$aload($1.Dbits); /*18981*/
							$k[$j++] = 0; /*18981*/
							$k[$j++] = 1; /*18981*/
							$1.Dbits = $a(); /*18981*/
							$1.Drem = 0; /*18982*/
						} /*18982*/
						break; /*18985*/
					} /*18985*/
					$k[$j++] = Infinity; /*18994*/
					$aload($1.Dbits); /*18991*/
					$k[$j++] = 0; /*18992*/
					$forall($geti($1.msg, $1.i, 3), function() { /*18992*/
						var _Ew = $k[--$j]; /*18992*/
						var _Ex = $k[--$j]; /*18992*/
						$k[$j++] = (_Ex + (_Ew - 48)) * 10; /*18992*/
					}); /*18992*/
					var _Ey = $k[--$j]; /*18992*/
					$k[$j++] = (~~(_Ey / 10)) + 1; /*18993*/
					$k[$j++] = 10; /*18993*/
					$1.tobin(); /*18993*/
					$aload($k[--$j]); /*18993*/
					$1.Dbits = $a(); /*18994*/
					$1.i = $1.i + 3; /*18995*/
				} /*18995*/
				$k[$j++] = Infinity; /*18999*/
				for (var _F4 = 0, _F3 = $1.Dbits.length - 1; _F4 <= _F3; _F4 += 8) { /*19002*/
					$k[$j++] = 0; /*19001*/
					$forall($geti($1.Dbits, _F4, 8), function() { /*19001*/
						var _F7 = $k[--$j]; /*19001*/
						var _F8 = $k[--$j]; /*19001*/
						$k[$j++] = (_F8 + _F7) * 2; /*19001*/
					}); /*19001*/
					var _F9 = $k[--$j]; /*19001*/
					$k[$j++] = ~~(_F9 / 2); /*19001*/
				} /*19001*/
				$astore($a($counttomark())); /*19003*/
				var _FC = $k[--$j]; /*19003*/
				var _FD = $k[--$j]; /*19003*/
				$k[$j++] = _FC; /*19003*/
				$1.addtocws(); /*19003*/
				$1.mode = $1.A; /*19004*/
			}; /*19006*/
			$1.encB = function() {
				$1.p = 0; /*19009*/
				$1.bvals = $a(1480); /*19009*/
				for (;;) { /*19016*/
					if ($1.i == $1.msglen) { /*19010*/
						break; /*19010*/
					} /*19010*/
					if ($get($1.msg, $1.i) < 0) { /*19011*/
						break; /*19011*/
					} /*19011*/
					$1.lookup(); /*19012*/
					if ($k[--$j] != $1.mode) { /*19012*/
						break; /*19012*/
					} /*19012*/
					$put($1.bvals, $1.p, $get($1.msg, $1.i)); /*19013*/
					$1.p = $1.p + 1; /*19014*/
					$1.i = $1.i + 1; /*19015*/
				} /*19015*/
				$1.remcws = $get($1.numremcws, $1.j + $1.p) - 1; /*19017*/
				$k[$j++] = Infinity; /*19025*/
				if (($1.remcws == 0) && ($1.i == $1.msglen)) { /*19022*/
					$k[$j++] = 0; /*19020*/
				} else { /*19022*/
					if ($1.p < 250) { /*19022*/
						$k[$j++] = $1.p; /*19022*/
					} else { /*19022*/
						$k[$j++] = (~~($1.p / 250)) + 249; /*19022*/
						$k[$j++] = $1.p % 250; /*19022*/
					} /*19022*/
				} /*19022*/
				$aload($geti($1.bvals, 0, $1.p)); /*19024*/
				$1.bvals = $a(); /*19025*/
				$k[$j++] = $1.bvals; /*19026*/
				$1.addtocws(); /*19026*/
				$1.mode = $1.A; /*19027*/
			}; /*19028*/
			$1.cws = $a(1480); /*19031*/
			$1.mode = $1.A; /*19032*/
			$1.i = 0; /*19032*/
			$1.j = 0; /*19032*/
			for (;;) { /*19035*/
				if ($1.i >= $1.msglen) { /*19033*/
					break; /*19033*/
				} /*19033*/
				$1[$get($a(["encA", "encCTX", "encCTX", "encCTX", "encD", "encB"]), $1.mode)](); /*19034*/
			} /*19034*/
			$1.cws = $geti($1.cws, 0, $1.j); /*19036*/
		} /*19036*/
		$1.i = 0; /*19041*/
		for (;;) { /*19061*/
			$1.m = $get($1.metrics, $1.i); /*19043*/
			$1.vers = $get($1.m, 0); /*19044*/
			$1.rows = $get($1.m, 1); /*19045*/
			$1.cols = $get($1.m, 2); /*19046*/
			$1.dcol = $get($1.m, 3); /*19047*/
			$1.dcws = $get($1.m, 4); /*19048*/
			$1.rscw = $get($1.m, 5); /*19049*/
			$1.rsbl = $get($1.m, 6); /*19050*/
			$1.riso = $get($1.m, 7); /*19051*/
			$1.risi = $get($1.m, 8); /*19052*/
			$1.risl = $get($1.m, 9); /*19053*/
			$1.dcpb = ~~($1.dcws / $1.rsbl); /*19054*/
			$1.ecpb = ~~($1.rscw / $1.rsbl); /*19055*/
			$1.okay = true; /*19056*/
			if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*19057*/
				$1.okay = false; /*19057*/
			} /*19057*/
			if ($1.cws.length > $1.dcws) { /*19058*/
				$1.okay = false; /*19058*/
			} /*19058*/
			if ($1.okay) { /*19059*/
				break; /*19059*/
			} /*19059*/
			$1.i = $1.i + 1; /*19060*/
		} /*19060*/
		if (!$1.stype) { /*19067*/
			$k[$j++] = Infinity; /*19065*/
			$aload($1.cws); /*19065*/
			for (var _GY = 0, _GZ = $1.dcws - $1.cws.length; _GY < _GZ; _GY++) { /*19065*/
				$k[$j++] = 129; /*19065*/
			} /*19065*/
			$1.cws = $a(); /*19065*/
		} else { /*19067*/
			$k[$j++] = Infinity; /*19067*/
			for (var _Gd = 0, _Ge = $1.dcws - $1.cws.length; _Gd < _Ge; _Gd++) { /*19067*/
				$k[$j++] = 0; /*19067*/
			} /*19067*/
			$aload($1.cws); /*19067*/
			$1.cws = $a(); /*19067*/
		} /*19067*/
		$1.cwbs = $a($1.rsbl); /*19071*/
		$1.ecbs = $a($1.rsbl); /*19072*/
		for (var _Gn = 0, _Gm = $1.rsbl - 1; _Gn <= _Gm; _Gn += 1) { /*19081*/
			$1.i = _Gn; /*19074*/
			$1.cwb = $a($1.dcpb); /*19075*/
			for (var _Gs = 0, _Gr = $1.dcpb - 1; _Gs <= _Gr; _Gs += 1) { /*19079*/
				$1.j = _Gs; /*19077*/
				$put($1.cwb, $1.j, $get($1.cws, ($1.j * $1.rsbl) + $1.i)); /*19078*/
			} /*19078*/
			$put($1.cwbs, $1.i, $1.cwb); /*19080*/
		} /*19080*/
		var _H4 = $1.stype ? 32 : 256; /*19084*/
		$1.gf = _H4; /*19084*/
		$1["gf-1"] = $1.gf - 1; /*19085*/
		var _H7 = $1.stype ? 37 : 301; /*19086*/
		$1.pm = _H7; /*19086*/
		$k[$j++] = Infinity; /*19087*/
		$k[$j++] = 1; /*19087*/
		for (var _H9 = 0, _HA = $1["gf-1"]; _H9 < _HA; _H9++) { /*19087*/
			var _HB = $k[--$j]; /*19087*/
			var _HC = _HB * 2; /*19087*/
			$k[$j++] = _HB; /*19087*/
			$k[$j++] = _HC; /*19087*/
			if (_HC >= $1.gf) { /*19087*/
				var _HF = $k[--$j]; /*19087*/
				$k[$j++] = _HF ^ $1.pm; /*19087*/
			} /*19087*/
		} /*19087*/
		$1.rsalog = $a(); /*19087*/
		$1.rslog = $a($1.gf); /*19088*/
		for (var _HL = 1, _HK = $1["gf-1"]; _HL <= _HK; _HL += 1) { /*19089*/
			$put($1.rslog, $get($1.rsalog, _HL), _HL); /*19089*/
		} /*19089*/
		$1.rsprod = function() {
			var _HP = $k[--$j]; /*19091*/
			var _HQ = $k[--$j]; /*19091*/
			$k[$j++] = _HQ; /*19095*/
			$k[$j++] = _HP; /*19095*/
			if ((_HP != 0) && (_HQ != 0)) { /*19094*/
				var _HT = $get($1.rslog, $k[--$j]); /*19092*/
				var _HZ = $get($1.rsalog, (_HT + $get($1.rslog, $k[--$j])) % $1["gf-1"]); /*19092*/
				$k[$j++] = _HZ; /*19092*/
			} else { /*19094*/
				$j -= 2; /*19094*/
				$k[$j++] = 0; /*19094*/
			} /*19094*/
		}; /*19096*/
		$k[$j++] = Infinity; /*19099*/
		$k[$j++] = 1; /*19099*/
		for (var _Hb = 0, _Hc = $1.ecpb; _Hb < _Hc; _Hb++) { /*19099*/
			$k[$j++] = 0; /*19099*/
		} /*19099*/
		$1.coeffs = $a(); /*19099*/
		for (var _Hg = 0, _Hf = $1.ecpb - 1; _Hg <= _Hf; _Hg += 1) { /*19108*/
			$1.i = _Hg; /*19101*/
			$put($1.coeffs, $1.i + 1, $get($1.coeffs, $1.i)); /*19102*/
			for (var _Hn = $1.i; _Hn >= 1; _Hn -= 1) { /*19106*/
				$1.j = _Hn; /*19104*/
				$k[$j++] = $1.coeffs; /*19105*/
				$k[$j++] = $1.j; /*19105*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*19105*/
				$k[$j++] = $get($1.coeffs, $1.j); /*19105*/
				$k[$j++] = $get($1.rsalog, $1.i); /*19105*/
				$1.rsprod(); /*19105*/
				var _Hz = $k[--$j]; /*19105*/
				var _I0 = $k[--$j]; /*19105*/
				var _I1 = $k[--$j]; /*19105*/
				$put($k[--$j], _I1, $xo(_I0, _Hz)); /*19105*/
			} /*19105*/
			$k[$j++] = $1.coeffs; /*19107*/
			$k[$j++] = 0; /*19107*/
			$k[$j++] = $get($1.coeffs, 0); /*19107*/
			$k[$j++] = $get($1.rsalog, $1.i); /*19107*/
			$1.rsprod(); /*19107*/
			var _I9 = $k[--$j]; /*19107*/
			var _IA = $k[--$j]; /*19107*/
			$put($k[--$j], _IA, _I9); /*19107*/
		} /*19107*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*19109*/
		for (var _IH = 0, _IG = $1.cwbs.length - 1; _IH <= _IG; _IH += 1) { /*19124*/
			$1.i = _IH; /*19113*/
			$k[$j++] = Infinity; /*19114*/
			$aload($get($1.cwbs, $1.i)); /*19114*/
			for (var _IM = 0, _IN = $1.ecpb; _IM < _IN; _IM++) { /*19114*/
				$k[$j++] = 0; /*19114*/
			} /*19114*/
			$1.rscws = $a(); /*19114*/
			for (var _IR = 0, _IQ = $1.dcpb - 1; _IR <= _IQ; _IR += 1) { /*19122*/
				$1.m = _IR; /*19116*/
				$1.k = $get($1.rscws, $1.m); /*19117*/
				for (var _IX = 0, _IW = $1.ecpb - 1; _IX <= _IW; _IX += 1) { /*19121*/
					$1.j = _IX; /*19119*/
					$k[$j++] = $1.rscws; /*19120*/
					$k[$j++] = ($1.m + $1.j) + 1; /*19120*/
					$k[$j++] = $get($1.coeffs, ($1.ecpb - $1.j) - 1); /*19120*/
					$k[$j++] = $1.k; /*19120*/
					$1.rsprod(); /*19120*/
					var _Ik = $k[--$j]; /*19120*/
					var _Il = $k[--$j]; /*19120*/
					$put($k[--$j], _Il, $xo(_Ik, $get($1.rscws, ($1.m + $1.j) + 1))); /*19120*/
				} /*19120*/
			} /*19120*/
			$put($1.ecbs, $1.i, $geti($1.rscws, $1.dcpb, $1.ecpb)); /*19123*/
		} /*19123*/
		$k[$j++] = Infinity; /*19127*/
		$aload($1.cws); /*19127*/
		for (var _Iv = 0, _Iw = $1.rscw; _Iv < _Iw; _Iv++) { /*19127*/
			$k[$j++] = 0; /*19127*/
		} /*19127*/
		$1.cws = $a(); /*19127*/
		for (var _J0 = 0, _Iz = $1.rscw - 1; _J0 <= _Iz; _J0 += 1) { /*19131*/
			$1.i = _J0; /*19129*/
			$put($1.cws, $1.dcws + $1.i, $get($get($1.ecbs, $1.i % $1.rsbl), ~~($1.i / $1.rsbl))); /*19130*/
		} /*19130*/
		var _JE = $1.stype ? 5 : 8; /*19134*/
		$1.mmat = $a(($1.dcws + $1.rscw) * _JE); /*19134*/
		$1.r = 0; /*19135*/
		$1.c = 0; /*19135*/
		var _JH = $1.stype ? 2 : 1; /*19136*/
		for (var _JK = 0, _JL = _JH, _JJ = $1.cws.length - 1; _JL < 0 ? _JK >= _JJ : _JK <= _JJ; _JK += _JL) { /*19157*/
			$1.i = _JK; /*19137*/
			if (!$1.stype) { /*19151*/
				var _JO = $strcpy($s(8), "00000000"); /*19139*/
				var _JT = $cvrs($s(8), $get($1.cws, $1.i), 2); /*19139*/
				$puti(_JO, 8 - _JT.length, _JT); /*19140*/
				$k[$j++] = _JO; /*19140*/
				$k[$j++] = Infinity; /*19140*/
				var _JU = $k[--$j]; /*19140*/
				var _JV = $k[--$j]; /*19140*/
				$k[$j++] = _JU; /*19140*/
				$forall(_JV, function() { /*19140*/
					var _JW = $k[--$j]; /*19140*/
					$k[$j++] = _JW - 48; /*19140*/
				}); /*19140*/
				var _JX = $a(); /*19140*/
				$1.top = $geti(_JX, 0, 4); /*19141*/
				$1.bot = $geti(_JX, 4, 4); /*19142*/
			} else { /*19151*/
				var _Jb = $strcpy($s(5), "00000"); /*19144*/
				var _Jg = $cvrs($s(5), $get($1.cws, $1.i), 2); /*19144*/
				$puti(_Jb, 5 - _Jg.length, _Jg); /*19145*/
				$k[$j++] = _Jb; /*19145*/
				$k[$j++] = Infinity; /*19145*/
				var _Jh = $k[--$j]; /*19145*/
				var _Ji = $k[--$j]; /*19145*/
				$k[$j++] = _Jh; /*19145*/
				$forall(_Ji, function() { /*19145*/
					var _Jj = $k[--$j]; /*19145*/
					$k[$j++] = _Jj - 48; /*19145*/
				}); /*19145*/
				$1.c1 = $a(); /*19146*/
				var _Jm = $strcpy($s(5), "00000"); /*19147*/
				var _Jr = $cvrs($s(5), $get($1.cws, $1.i + 1), 2); /*19147*/
				$puti(_Jm, 5 - _Jr.length, _Jr); /*19148*/
				$k[$j++] = _Jm; /*19148*/
				$k[$j++] = Infinity; /*19148*/
				var _Js = $k[--$j]; /*19148*/
				var _Jt = $k[--$j]; /*19148*/
				$k[$j++] = _Js; /*19148*/
				$forall(_Jt, function() { /*19148*/
					var _Ju = $k[--$j]; /*19148*/
					$k[$j++] = _Ju - 48; /*19148*/
				}); /*19148*/
				$1.c2 = $a(); /*19149*/
				$k[$j++] = Infinity; /*19150*/
				$aload($geti($1.c1, 0, 3)); /*19150*/
				$aload($geti($1.c2, 0, 2)); /*19150*/
				$1.top = $a(); /*19150*/
				$k[$j++] = Infinity; /*19151*/
				$aload($geti($1.c1, 3, 2)); /*19151*/
				$aload($geti($1.c2, 2, 3)); /*19151*/
				$1.bot = $a(); /*19151*/
			} /*19151*/
			$puti($1.mmat, ($1.r * $1.dcol) + $1.c, $1.top); /*19153*/
			$puti($1.mmat, (($1.r + 1) * $1.dcol) + $1.c, $1.bot); /*19154*/
			$1.c = $1.c + $1.top.length; /*19155*/
			if ($1.c == $1.dcol) { /*19156*/
				$1.c = 0; /*19156*/
				$1.r = $1.r + 2; /*19156*/
			} /*19156*/
		} /*19156*/
		$1.mmv = function() {
			var _KM = $k[--$j]; /*19160*/
			var _KN = $k[--$j]; /*19160*/
			$k[$j++] = _KN + (_KM * $1.cols); /*19160*/
		}; /*19160*/
		$k[$j++] = Infinity; /*19161*/
		for (var _KQ = 0, _KR = $1.rows * $1.cols; _KQ < _KR; _KQ++) { /*19161*/
			$k[$j++] = -1; /*19161*/
		} /*19161*/
		$1.pixs = $a(); /*19161*/
		var _Kx = $a([function() {
			for (var _KU = 0, _KV = $1.cols; _KU < _KV; _KU++) { /*19165*/
				$k[$j++] = 0; /*19165*/
			} /*19165*/
		}, function() {
			for (var _KX = 0, _KY = $1.cols; _KX < _KY; _KX++) { /*19166*/
				$k[$j++] = 1; /*19166*/
			} /*19166*/
		}, function() {
			$k[$j++] = 0; /*19167*/
			for (var _Ka = 0, _Kb = $1.cols - 2; _Ka < _Kb; _Ka++) { /*19167*/
				$k[$j++] = 1; /*19167*/
			} /*19167*/
			$k[$j++] = 0; /*19167*/
		}, function() {
			$k[$j++] = 0; /*19168*/
			$k[$j++] = 1; /*19168*/
			for (var _Kd = 0, _Ke = $1.cols - 4; _Kd < _Ke; _Kd++) { /*19168*/
				$k[$j++] = 0; /*19168*/
			} /*19168*/
			$k[$j++] = 1; /*19168*/
			$k[$j++] = 0; /*19168*/
		}, function() {
			for (var _Kg = 0, _Kh = ~~(($1.cols - 1) / 2); _Kg < _Kh; _Kg++) { /*19169*/
				$k[$j++] = -1; /*19169*/
			} /*19169*/
			$k[$j++] = 1; /*19169*/
			for (var _Kj = 0, _Kk = ~~(($1.cols - 1) / 2); _Kj < _Kk; _Kj++) { /*19169*/
				$k[$j++] = -1; /*19169*/
			} /*19169*/
		}, function() {
			for (var _Km = 0, _Kn = ~~(($1.cols - 1) / 2); _Km < _Kn; _Km++) { /*19170*/
				$k[$j++] = -1; /*19170*/
			} /*19170*/
			$k[$j++] = 0; /*19170*/
			for (var _Kp = 0, _Kq = ~~(($1.cols - 1) / 2); _Kp < _Kq; _Kp++) { /*19170*/
				$k[$j++] = -1; /*19170*/
			} /*19170*/
		}, function() {
			$k[$j++] = 1; /*19171*/
			for (var _Ks = 0, _Kt = $1.cols - 2; _Ks < _Kt; _Ks++) { /*19171*/
				$k[$j++] = 0; /*19171*/
			} /*19171*/
			$k[$j++] = 1; /*19171*/
		}, function() {
			$k[$j++] = 1; /*19172*/
			$k[$j++] = 0; /*19172*/
			for (var _Kv = 0, _Kw = $1.cols - 4; _Kv < _Kw; _Kv++) { /*19172*/
				$k[$j++] = 1; /*19172*/
			} /*19172*/
			$k[$j++] = 0; /*19172*/
			$k[$j++] = 1; /*19172*/
		}]); /*19172*/
		$1.artifact = _Kx; /*19173*/
		var _Ky = {
			A: "121343",
			B: "12134343",
			C: "12121343",
			D: "1213434343",
			E: "1212134343",
			F: "1212121343",
			G: "121213434343",
			H: "121212134343",
			S: "56661278",
			T: "5666666666127878"
		}; /*19184*/
		$1.cpat = $get(_Ky, $geti($1.vers, 0, 1)); /*19185*/
		$k[$j++] = $1.pixs; /*19186*/
		$k[$j++] = 0; /*19186*/
		$k[$j++] = ~~(($1.rows - $1.cpat.length) / 2); /*19186*/
		$1.mmv(); /*19186*/
		$k[$j++] = Infinity; /*19187*/
		$forall($1.cpat, function() { /*19187*/
			$get($1.artifact, $k[--$j] - 49)(); /*19187*/
		}); /*19187*/
		var _L9 = $a(); /*19187*/
		var _LA = $k[--$j]; /*19187*/
		$puti($k[--$j], _LA, _L9); /*19187*/
		for (var _LE = 0, _LD = $1.risl - 1; _LE <= _LD; _LE += 1) { /*19202*/
			$1.i = _LE; /*19191*/
			for (var _LJ = $1.riso, _LK = $1.risi, _LI = $1.cols - 1; _LK < 0 ? _LJ >= _LI : _LJ <= _LI; _LJ += _LK) { /*19201*/
				$1.j = _LJ; /*19193*/
				var _LM = (($1.i % 12) == 0) ? 1 : 0; /*19194*/
				var _LN = $a([1, _LM]); /*19194*/
				$k[$j++] = _LN; /*19195*/
				$k[$j++] = _LN; /*19195*/
				$k[$j++] = $1.pixs; /*19195*/
				$k[$j++] = $1.j; /*19195*/
				$k[$j++] = $1.i; /*19195*/
				$1.mmv(); /*19195*/
				var _LR = $k[--$j]; /*19196*/
				var _LS = $k[--$j]; /*19196*/
				$puti(_LS, _LR, $k[--$j]); /*19196*/
				if ($1.i != ($1.risl - 1)) { /*19200*/
					$k[$j++] = $1.pixs; /*19198*/
					$k[$j++] = ($1.cols - $1.j) - 2; /*19198*/
					$k[$j++] = ($1.rows - $1.i) - 1; /*19198*/
					$1.mmv(); /*19198*/
					var _Lb = $k[--$j]; /*19199*/
					var _Lc = $k[--$j]; /*19199*/
					$puti(_Lc, _Lb, $k[--$j]); /*19199*/
				} else { /*19200*/
					$j--; /*19200*/
				} /*19200*/
			} /*19200*/
		} /*19200*/
		var _MH = {
			A: $a([$a([12, 5])]),
			B: $a([$a([16, 7])]),
			C: $a([$a([26, 12])]),
			D: $a([]),
			E: $a([$a([26, 23])]),
			F: $a([$a([26, 32]), $a([70, 32]), $a([26, 34]), $a([70, 34])]),
			G: $a([$a([27, 48]), $a([69, 48])]),
			H: $a([$a([26, 70]), $a([66, 70]), $a([106, 70]), $a([26, 72]), $a([66, 72]), $a([106, 72])]),
			"S-10": $a([]),
			"S-20": $a([$a([10, 4])]),
			"S-30": $a([$a([15, 4]), $a([15, 6])]),
			"T-16": $a([$a([8, 10])]),
			"T-32": $a([$a([16, 10]), $a([16, 12])]),
			"T-48": $a([$a([24, 10]), $a([24, 12]), $a([24, 14])])
		}; /*19219*/
		$forall($get(_MH, $1.vers), function() { /*19220*/
			var _ML = $k[--$j]; /*19220*/
			$k[$j++] = $1.pixs; /*19220*/
			$aload(_ML); /*19220*/
			$1.mmv(); /*19220*/
			var _MM = $k[--$j]; /*19220*/
			$put($k[--$j], _MM, 1); /*19220*/
		}); /*19220*/
		$1.j = 0; /*19223*/
		for (var _MQ = 0, _MP = $1.pixs.length - 1; _MQ <= _MP; _MQ += 1) { /*19230*/
			$1.i = _MQ; /*19225*/
			if ($get($1.pixs, $1.i) == -1) { /*19229*/
				$put($1.pixs, $1.i, $get($1.mmat, $1.j)); /*19227*/
				$1.j = $1.j + 1; /*19228*/
			} /*19228*/
		} /*19228*/
		var _Mg = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.cols,
			pixy: $1.rows,
			height: ($1.rows / 72) * 2,
			width: ($1.cols / 72) * 2,
			opt: $1.options
		}; /*19240*/
		$k[$j++] = _Mg; /*19243*/
		if (!$1.dontdraw) { /*19243*/
			$0.renmatrix(); /*19243*/
		} /*19243*/
	};
	$0.hanxin = function() {
		var $1 = {}; /*19270*/
		$1.options = $k[--$j]; /*19272*/
		$1.barcode = $k[--$j]; /*19273*/
		$1.dontdraw = false; /*19275*/
		$1.version = "unset"; /*19276*/
		$1.eclevel = "unset"; /*19277*/
		$1.parse = false; /*19278*/
		$1.parsefnc = false; /*19279*/
		$1.mask = -1; /*19280*/
		$forall($1.options, function() { /*19291*/
			var _3 = $k[--$j]; /*19291*/
			$1[$k[--$j]] = _3; /*19291*/
		}); /*19291*/
		$1.mask = ~~$1.mask; /*19293*/
		$1.barlen = $1.barcode.length; /*19316*/
		var _7 = {

		}; /*19321*/
		$1.fncvals = _7; /*19321*/
		$1.msg = $a($1.barlen); /*19322*/
		$1.i = 0; /*19323*/
		$1.j = 0; /*19323*/
		for (;;) { /*19337*/
			if ($1.i == $1.barlen) { /*19324*/
				break; /*19324*/
			} /*19324*/
			$1.char = $get($1.barcode, $1.i); /*19325*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*19333*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*19331*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*19328*/
					$1.i = $1.i + 4; /*19329*/
				} else { /*19331*/
					$1.i = $1.i + 1; /*19331*/
				} /*19331*/
			} /*19331*/
			$put($1.msg, $1.j, $1.char); /*19334*/
			$1.i = $1.i + 1; /*19335*/
			$1.j = $1.j + 1; /*19336*/
		} /*19336*/
		$1.msg = $geti($1.msg, 0, $1.j); /*19338*/
		$1.msglen = $1.msg.length; /*19339*/
		if ($eq($1.eclevel, "unset")) { /*19342*/
			$1.eclevel = "L2"; /*19342*/
		} /*19342*/
		$1.tobin = function() {
			var _e = $s($k[--$j]); /*19345*/
			$k[$j++] = _e; /*19345*/
			for (var _g = 0, _f = _e.length - 1; _g <= _f; _g += 1) { /*19345*/
				var _h = $k[--$j]; /*19345*/
				$put(_h, _g, 48); /*19345*/
				$k[$j++] = _h; /*19345*/
			} /*19345*/
			var _i = $k[--$j]; /*19346*/
			var _l = $cvrs($s(_i.length), $k[--$j], 2); /*19346*/
			$puti(_i, _i.length - _l.length, _l); /*19347*/
			$k[$j++] = _i; /*19347*/
		}; /*19348*/
		$1.bits = $s((4 + 13) + ($1.msglen * 8)); /*19351*/
		$puti($1.bits, 0, "0011"); /*19352*/
		$k[$j++] = $1.bits; /*19353*/
		$k[$j++] = 4; /*19353*/
		$k[$j++] = $1.msglen; /*19353*/
		$k[$j++] = 13; /*19353*/
		$1.tobin(); /*19353*/
		var _r = $k[--$j]; /*19353*/
		var _s = $k[--$j]; /*19353*/
		$puti($k[--$j], _s, _r); /*19353*/
		for (var _w = 0, _v = $1.msglen - 1; _w <= _v; _w += 1) { /*19357*/
			$1.i = _w; /*19355*/
			$k[$j++] = $1.bits; /*19356*/
			$k[$j++] = 17 + ($1.i * 8); /*19356*/
			$k[$j++] = $get($1.msg, $1.i); /*19356*/
			$k[$j++] = 8; /*19356*/
			$1.tobin(); /*19356*/
			var _12 = $k[--$j]; /*19356*/
			var _13 = $k[--$j]; /*19356*/
			$puti($k[--$j], _13, _12); /*19356*/
		} /*19356*/
		$1.metrics = $a([$a(["1", 23, -1, 0, 205, $a([1, 21, 4]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 17, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 13, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 9, 16]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["2", 25, -1, 0, 301, $a([1, 31, 6]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 25, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 19, 18]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 15, 22]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["3", 27, -1, 0, 405, $a([1, 42, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 34, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 26, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["4", 29, 14, 1, 439, $a([1, 46, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 38, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 30, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 22, 32]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["5", 31, 16, 1, 555, $a([1, 57, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 49, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 37, 32]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 14, 20]), $a([1, 13, 22]), $a([0, -1, -1])]), $a(["6", 33, 16, 1, 675, $a([1, 70, 14]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 58, 26]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 24, 20]), $a([1, 22, 18]), $a([0, -1, -1]), $a([1, 16, 24]), $a([1, 18, 26]), $a([0, -1, -1])]), $a(["7", 35, 17, 1, 805, $a([1, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 26, 22]), $a([1, 28, 24]), $a([0, -1, -1]), $a([2, 14, 20]), $a([1, 12, 20]), $a([0, -1, -1])]), $a(["8", 37, 18, 1, 943, $a([1, 99, 18]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 40, 18]), $a([1, 41, 18]), $a([0, -1, -1]), $a([1, 31, 26]), $a([1, 32, 28]), $a([0, -1, -1]), $a([2, 16, 24]), $a([1, 15, 22]), $a([0, -1, -1])]), $a(["9", 39, 19, 1, 1089, $a([1, 114, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([2, 48, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([2, 24, 20]), $a([1, 26, 22]), $a([0, -1, -1]), $a([2, 18, 28]), $a([1, 18, 26]), $a([0, -1, -1])]), $a(["10", 41, 20, 1, 1243, $a([1, 131, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 52, 22]), $a([1, 57, 24]), $a([0, -1, -1]), $a([2, 27, 24]), $a([1, 29, 24]), $a([0, -1, -1]), $a([2, 21, 32]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["11", 43, 14, 2, 1289, $a([1, 135, 26]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 56, 24]), $a([1, 57, 24]), $a([0, -1, -1]), $a([2, 28, 24]), $a([1, 31, 26]), $a([0, -1, -1]), $a([2, 22, 32]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["12", 45, 15, 2, 1455, $a([1, 153, 28]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 62, 26]), $a([1, 65, 28]), $a([0, -1, -1]), $a([2, 32, 28]), $a([1, 33, 28]), $a([0, -1, -1]), $a([3, 17, 26]), $a([1, 22, 30]), $a([0, -1, -1])]), $a(["13", 47, 16, 2, 1629, $a([1, 86, 16]), $a([1, 85, 16]), $a([0, -1, -1]), $a([1, 71, 30]), $a([1, 72, 30]), $a([0, -1, -1]), $a([2, 37, 32]), $a([1, 35, 30]), $a([0, -1, -1]), $a([3, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["14", 49, 16, 2, 1805, $a([1, 94, 18]), $a([1, 95, 18]), $a([0, -1, -1]), $a([2, 51, 22]), $a([1, 55, 24]), $a([0, -1, -1]), $a([3, 30, 26]), $a([1, 31, 26]), $a([0, -1, -1]), $a([4, 18, 28]), $a([1, 17, 24]), $a([0, -1, -1])]), $a(["15", 51, 17, 2, 1995, $a([1, 104, 20]), $a([1, 105, 20]), $a([0, -1, -1]), $a([2, 57, 24]), $a([1, 61, 26]), $a([0, -1, -1]), $a([3, 33, 28]), $a([1, 36, 30]), $a([0, -1, -1]), $a([4, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["16", 53, 17, 2, 2187, $a([1, 115, 22]), $a([1, 114, 22]), $a([0, -1, -1]), $a([2, 65, 28]), $a([1, 61, 26]), $a([0, -1, -1]), $a([3, 38, 32]), $a([1, 33, 30]), $a([0, -1, -1]), $a([5, 19, 28]), $a([1, 14, 24]), $a([0, -1, -1])]), $a(["17", 55, 18, 2, 2393, $a([1, 126, 24]), $a([1, 125, 24]), $a([0, -1, -1]), $a([2, 70, 30]), $a([1, 69, 30]), $a([0, -1, -1]), $a([4, 33, 28]), $a([1, 29, 26]), $a([0, -1, -1]), $a([5, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["18", 57, 19, 2, 2607, $a([1, 136, 26]), $a([1, 137, 26]), $a([0, -1, -1]), $a([3, 56, 24]), $a([1, 59, 26]), $a([0, -1, -1]), $a([5, 35, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([6, 18, 28]), $a([1, 21, 28]), $a([0, -1, -1])]), $a(["19", 59, 20, 2, 2829, $a([1, 148, 28]), $a([1, 149, 28]), $a([0, -1, -1]), $a([3, 61, 26]), $a([1, 64, 28]), $a([0, -1, -1]), $a([7, 24, 20]), $a([1, 23, 22]), $a([0, -1, -1]), $a([6, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["20", 61, 20, 2, 3053, $a([3, 107, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([3, 65, 28]), $a([1, 72, 30]), $a([0, -1, -1]), $a([7, 26, 22]), $a([1, 23, 22]), $a([0, -1, -1]), $a([7, 19, 28]), $a([1, 20, 32]), $a([0, -1, -1])]), $a(["21", 63, 21, 2, 3291, $a([3, 115, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([4, 56, 24]), $a([1, 63, 28]), $a([0, -1, -1]), $a([7, 28, 24]), $a([1, 25, 22]), $a([0, -1, -1]), $a([8, 18, 28]), $a([1, 21, 22]), $a([0, -1, -1])]), $a(["22", 65, 16, 3, 3383, $a([2, 116, 22]), $a([1, 122, 24]), $a([0, -1, -1]), $a([4, 56, 24]), $a([1, 72, 30]), $a([0, -1, -1]), $a([7, 28, 24]), $a([1, 32, 26]), $a([0, -1, -1]), $a([8, 18, 28]), $a([1, 24, 30]), $a([0, -1, -1])]), $a(["23", 67, 17, 3, 3631, $a([3, 127, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([5, 51, 22]), $a([1, 62, 26]), $a([0, -1, -1]), $a([7, 30, 26]), $a([1, 35, 26]), $a([0, -1, -1]), $a([8, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["24", 69, 17, 3, 3887, $a([2, 135, 26]), $a([1, 137, 26]), $a([0, -1, -1]), $a([5, 56, 24]), $a([1, 59, 26]), $a([0, -1, -1]), $a([7, 33, 28]), $a([1, 30, 28]), $a([0, -1, -1]), $a([11, 16, 24]), $a([1, 19, 26]), $a([0, -1, -1])]), $a(["25", 71, 18, 3, 4151, $a([3, 105, 20]), $a([1, 121, 22]), $a([0, -1, -1]), $a([5, 61, 26]), $a([1, 57, 26]), $a([0, -1, -1]), $a([9, 28, 24]), $a([1, 28, 22]), $a([0, -1, -1]), $a([10, 19, 28]), $a([1, 18, 30]), $a([0, -1, -1])]), $a(["26", 73, 18, 3, 4423, $a([2, 157, 30]), $a([1, 150, 28]), $a([0, -1, -1]), $a([5, 65, 28]), $a([1, 61, 26]), $a([0, -1, -1]), $a([8, 33, 28]), $a([1, 34, 30]), $a([0, -1, -1]), $a([10, 19, 28]), $a([2, 15, 26]), $a([0, -1, -1])]), $a(["27", 75, 19, 3, 4703, $a([3, 126, 24]), $a([1, 115, 22]), $a([0, -1, -1]), $a([7, 51, 22]), $a([1, 54, 22]), $a([0, -1, -1]), $a([8, 35, 30]), $a([1, 37, 30]), $a([0, -1, -1]), $a([15, 15, 22]), $a([1, 10, 22]), $a([0, -1, -1])]), $a(["28", 77, 19, 3, 4991, $a([4, 105, 20]), $a([1, 103, 20]), $a([0, -1, -1]), $a([7, 56, 24]), $a([1, 45, 18]), $a([0, -1, -1]), $a([10, 31, 26]), $a([1, 27, 26]), $a([0, -1, -1]), $a([10, 17, 26]), $a([3, 20, 28]), $a([1, 21, 28])]), $a(["29", 79, 20, 3, 5287, $a([3, 139, 26]), $a([1, 137, 28]), $a([0, -1, -1]), $a([6, 66, 28]), $a([1, 66, 30]), $a([0, -1, -1]), $a([9, 36, 30]), $a([1, 34, 32]), $a([0, -1, -1]), $a([13, 19, 28]), $a([1, 17, 32]), $a([0, -1, -1])]), $a(["30", 81, 20, 3, 5591, $a([6, 84, 16]), $a([1, 82, 16]), $a([0, -1, -1]), $a([6, 70, 30]), $a([1, 68, 30]), $a([0, -1, -1]), $a([7, 35, 30]), $a([3, 33, 28]), $a([1, 32, 28]), $a([13, 20, 30]), $a([1, 20, 28]), $a([0, -1, -1])]), $a(["31", 83, 21, 3, 5903, $a([5, 105, 20]), $a([1, 94, 18]), $a([0, -1, -1]), $a([6, 74, 32]), $a([1, 71, 30]), $a([0, -1, -1]), $a([11, 33, 28]), $a([1, 34, 32]), $a([0, -1, -1]), $a([13, 19, 28]), $a([3, 16, 26]), $a([0, -1, -1])]), $a(["32", 85, 17, 4, 6033, $a([4, 127, 24]), $a([1, 126, 24]), $a([0, -1, -1]), $a([7, 66, 28]), $a([1, 66, 30]), $a([0, -1, -1]), $a([12, 30, 24]), $a([1, 24, 28]), $a([1, 24, 30]), $a([15, 19, 28]), $a([1, 17, 32]), $a([0, -1, -1])]), $a(["33", 87, 17, 4, 6353, $a([7, 84, 16]), $a([1, 78, 16]), $a([0, -1, -1]), $a([7, 70, 30]), $a([1, 66, 28]), $a([0, -1, -1]), $a([12, 33, 28]), $a([1, 32, 30]), $a([0, -1, -1]), $a([14, 21, 32]), $a([1, 24, 28]), $a([0, -1, -1])]), $a(["34", 89, 18, 4, 6689, $a([5, 117, 22]), $a([1, 117, 24]), $a([0, -1, -1]), $a([8, 66, 28]), $a([1, 58, 26]), $a([0, -1, -1]), $a([11, 38, 32]), $a([1, 34, 32]), $a([0, -1, -1]), $a([15, 20, 30]), $a([2, 17, 26]), $a([0, -1, -1])]), $a(["35", 91, 18, 4, 7025, $a([4, 148, 28]), $a([1, 146, 28]), $a([0, -1, -1]), $a([8, 68, 30]), $a([1, 70, 24]), $a([0, -1, -1]), $a([10, 36, 32]), $a([3, 38, 28]), $a([0, -1, -1]), $a([16, 19, 28]), $a([3, 16, 26]), $a([0, -1, -1])]), $a(["36", 93, 19, 4, 7377, $a([4, 126, 24]), $a([2, 135, 26]), $a([0, -1, -1]), $a([8, 70, 28]), $a([2, 43, 26]), $a([0, -1, -1]), $a([13, 32, 28]), $a([2, 41, 30]), $a([0, -1, -1]), $a([17, 19, 28]), $a([3, 15, 26]), $a([0, -1, -1])]), $a(["37", 95, 19, 4, 7729, $a([5, 136, 26]), $a([1, 132, 24]), $a([0, -1, -1]), $a([5, 67, 30]), $a([4, 68, 28]), $a([1, 69, 28]), $a([14, 35, 30]), $a([1, 32, 24]), $a([0, -1, -1]), $a([18, 18, 26]), $a([3, 16, 28]), $a([1, 14, 28])]), $a(["38", 97, 19, 4, 8089, $a([3, 142, 26]), $a([3, 141, 28]), $a([0, -1, -1]), $a([8, 70, 30]), $a([1, 73, 32]), $a([1, 74, 32]), $a([12, 34, 30]), $a([3, 34, 26]), $a([1, 35, 28]), $a([18, 21, 32]), $a([1, 27, 30]), $a([0, -1, -1])]), $a(["39", 99, 20, 4, 8465, $a([5, 116, 22]), $a([2, 103, 20]), $a([1, 102, 20]), $a([9, 74, 32]), $a([1, 74, 30]), $a([0, -1, -1]), $a([14, 34, 28]), $a([2, 32, 32]), $a([1, 32, 30]), $a([19, 21, 32]), $a([1, 25, 26]), $a([0, -1, -1])]), $a(["40", 101, 20, 4, 8841, $a([7, 116, 22]), $a([1, 117, 22]), $a([0, -1, -1]), $a([11, 65, 28]), $a([1, 58, 24]), $a([0, -1, -1]), $a([15, 38, 32]), $a([1, 27, 28]), $a([0, -1, -1]), $a([20, 20, 30]), $a([1, 20, 32]), $a([1, 21, 32])]), $a(["41", 103, 17, 5, 9009, $a([6, 136, 26]), $a([1, 130, 24]), $a([0, -1, -1]), $a([11, 66, 28]), $a([1, 62, 30]), $a([0, -1, -1]), $a([14, 34, 28]), $a([3, 34, 32]), $a([1, 30, 30]), $a([18, 20, 30]), $a([3, 20, 28]), $a([2, 15, 26])]), $a(["42", 105, 17, 5, 9401, $a([5, 105, 20]), $a([2, 115, 22]), $a([2, 116, 22]), $a([10, 75, 32]), $a([1, 73, 32]), $a([0, -1, -1]), $a([16, 38, 32]), $a([1, 27, 28]), $a([0, -1, -1]), $a([22, 19, 28]), $a([2, 16, 30]), $a([1, 19, 30])]), $a(["43", 107, 18, 5, 9799, $a([6, 147, 28]), $a([1, 146, 28]), $a([0, -1, -1]), $a([11, 66, 28]), $a([2, 65, 30]), $a([0, -1, -1]), $a([18, 33, 28]), $a([2, 33, 30]), $a([0, -1, -1]), $a([22, 21, 32]), $a([1, 28, 30]), $a([0, -1, -1])]), $a(["44", 109, 18, 5, 10207, $a([6, 116, 22]), $a([3, 125, 24]), $a([0, -1, -1]), $a([11, 75, 32]), $a([1, 68, 30]), $a([0, -1, -1]), $a([13, 35, 28]), $a([6, 34, 32]), $a([1, 30, 30]), $a([23, 21, 32]), $a([1, 26, 30]), $a([0, -1, -1])]), $a(["45", 111, 18, 5, 10623, $a([7, 105, 20]), $a([4, 95, 18]), $a([0, -1, -1]), $a([12, 67, 28]), $a([1, 63, 30]), $a([1, 62, 32]), $a([21, 31, 26]), $a([2, 33, 32]), $a([0, -1, -1]), $a([23, 21, 32]), $a([2, 24, 30]), $a([0, -1, -1])]), $a(["46", 113, 19, 5, 11045, $a([10, 116, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([12, 74, 32]), $a([1, 78, 30]), $a([0, -1, -1]), $a([18, 37, 32]), $a([1, 39, 30]), $a([1, 41, 28]), $a([25, 21, 32]), $a([1, 27, 28]), $a([0, -1, -1])]), $a(["47", 115, 19, 5, 11477, $a([5, 126, 24]), $a([4, 115, 22]), $a([1, 114, 22]), $a([12, 67, 28]), $a([2, 66, 32]), $a([1, 68, 30]), $a([21, 35, 30]), $a([1, 39, 30]), $a([0, -1, -1]), $a([26, 21, 32]), $a([1, 28, 28]), $a([0, -1, -1])]), $a(["48", 117, 19, 5, 11917, $a([9, 126, 24]), $a([1, 117, 22]), $a([0, -1, -1]), $a([13, 75, 32]), $a([1, 68, 30]), $a([0, -1, -1]), $a([20, 35, 30]), $a([3, 35, 28]), $a([0, -1, -1]), $a([27, 21, 32]), $a([1, 28, 30]), $a([0, -1, -1])]), $a(["49", 119, 17, 6, 12111, $a([9, 126, 24]), $a([1, 137, 26]), $a([0, -1, -1]), $a([13, 71, 30]), $a([2, 68, 32]), $a([0, -1, -1]), $a([20, 37, 32]), $a([1, 39, 28]), $a([1, 38, 28]), $a([24, 20, 32]), $a([5, 25, 28]), $a([0, -1, -1])]), $a(["50", 121, 17, 6, 12559, $a([8, 147, 28]), $a([1, 141, 28]), $a([0, -1, -1]), $a([10, 73, 32]), $a([4, 74, 30]), $a([1, 73, 30]), $a([16, 36, 32]), $a([6, 39, 30]), $a([1, 37, 30]), $a([27, 21, 32]), $a([3, 20, 26]), $a([0, -1, -1])]), $a(["51", 123, 18, 6, 13025, $a([9, 137, 26]), $a([1, 135, 26]), $a([0, -1, -1]), $a([12, 70, 30]), $a([4, 75, 32]), $a([0, -1, -1]), $a([24, 35, 30]), $a([1, 40, 28]), $a([0, -1, -1]), $a([23, 20, 32]), $a([8, 24, 30]), $a([0, -1, -1])]), $a(["52", 125, 18, 6, 13489, $a([14, 95, 18]), $a([1, 86, 18]), $a([0, -1, -1]), $a([13, 73, 32]), $a([3, 77, 30]), $a([0, -1, -1]), $a([24, 35, 30]), $a([2, 35, 28]), $a([0, -1, -1]), $a([26, 21, 32]), $a([5, 21, 30]), $a([1, 23, 30])]), $a(["53", 127, 18, 6, 13961, $a([9, 147, 28]), $a([1, 142, 28]), $a([0, -1, -1]), $a([10, 73, 30]), $a([6, 70, 32]), $a([1, 71, 32]), $a([25, 35, 30]), $a([2, 34, 26]), $a([0, -1, -1]), $a([29, 21, 32]), $a([4, 22, 30]), $a([0, -1, -1])]), $a(["54", 129, 18, 6, 14441, $a([11, 126, 24]), $a([1, 131, 24]), $a([0, -1, -1]), $a([16, 74, 32]), $a([1, 79, 30]), $a([0, -1, -1]), $a([25, 38, 32]), $a([1, 25, 30]), $a([0, -1, -1]), $a([33, 21, 32]), $a([1, 28, 28]), $a([0, -1, -1])]), $a(["55", 131, 19, 6, 14939, $a([14, 105, 20]), $a([1, 99, 18]), $a([0, -1, -1]), $a([19, 65, 28]), $a([1, 72, 28]), $a([0, -1, -1]), $a([24, 37, 32]), $a([2, 40, 30]), $a([1, 41, 30]), $a([31, 21, 32]), $a([4, 24, 32]), $a([0, -1, -1])]), $a(["56", 133, 19, 6, 15435, $a([10, 147, 28]), $a([1, 151, 28]), $a([0, -1, -1]), $a([15, 71, 30]), $a([3, 71, 32]), $a([1, 73, 32]), $a([24, 37, 32]), $a([3, 38, 30]), $a([1, 39, 30]), $a([36, 19, 30]), $a([3, 29, 26]), $a([0, -1, -1])]), $a(["57", 135, 19, 6, 15939, $a([15, 105, 20]), $a([1, 99, 18]), $a([0, -1, -1]), $a([19, 70, 30]), $a([1, 64, 28]), $a([0, -1, -1]), $a([27, 38, 32]), $a([2, 25, 26]), $a([0, -1, -1]), $a([38, 20, 30]), $a([2, 18, 28]), $a([0, -1, -1])]), $a(["58", 137, 17, 7, 16171, $a([14, 105, 20]), $a([1, 113, 22]), $a([1, 114, 22]), $a([17, 67, 30]), $a([3, 92, 32]), $a([0, -1, -1]), $a([30, 35, 30]), $a([1, 41, 30]), $a([0, -1, -1]), $a([36, 21, 32]), $a([1, 26, 30]), $a([1, 27, 30])]), $a(["59", 139, 17, 7, 16691, $a([11, 146, 28]), $a([1, 146, 26]), $a([0, -1, -1]), $a([20, 70, 30]), $a([1, 60, 26]), $a([0, -1, -1]), $a([29, 38, 32]), $a([1, 24, 32]), $a([0, -1, -1]), $a([40, 20, 30]), $a([2, 17, 26]), $a([0, -1, -1])]), $a(["60", 141, 18, 7, 17215, $a([3, 137, 26]), $a([1, 136, 26]), $a([10, 126, 24]), $a([22, 65, 28]), $a([1, 75, 30]), $a([0, -1, -1]), $a([30, 37, 32]), $a([1, 51, 30]), $a([0, -1, -1]), $a([42, 20, 30]), $a([1, 21, 30]), $a([0, -1, -1])]), $a(["61", 143, 18, 7, 17751, $a([12, 126, 24]), $a([2, 118, 22]), $a([1, 116, 22]), $a([19, 74, 32]), $a([1, 74, 30]), $a([1, 72, 28]), $a([30, 38, 32]), $a([2, 29, 30]), $a([0, -1, -1]), $a([39, 20, 32]), $a([2, 37, 26]), $a([1, 38, 26])]), $a(["62", 145, 18, 7, 18295, $a([12, 126, 24]), $a([3, 136, 26]), $a([0, -1, -1]), $a([21, 70, 30]), $a([2, 65, 28]), $a([0, -1, -1]), $a([34, 35, 30]), $a([1, 44, 32]), $a([0, -1, -1]), $a([42, 20, 30]), $a([2, 19, 28]), $a([2, 18, 28])]), $a(["63", 147, 18, 7, 18847, $a([12, 126, 24]), $a([3, 117, 22]), $a([1, 116, 22]), $a([25, 61, 26]), $a([2, 62, 28]), $a([0, -1, -1]), $a([34, 35, 30]), $a([1, 40, 32]), $a([1, 41, 32]), $a([45, 20, 30]), $a([1, 20, 32]), $a([1, 21, 32])]), $a(["64", 149, 19, 7, 19403, $a([15, 105, 20]), $a([2, 115, 22]), $a([2, 116, 22]), $a([25, 65, 28]), $a([1, 72, 28]), $a([0, -1, -1]), $a([18, 35, 30]), $a([17, 37, 32]), $a([1, 50, 32]), $a([42, 20, 30]), $a([6, 19, 28]), $a([1, 15, 28])]), $a(["65", 151, 19, 7, 19971, $a([19, 105, 20]), $a([1, 101, 20]), $a([0, -1, -1]), $a([33, 51, 22]), $a([1, 65, 22]), $a([0, -1, -1]), $a([40, 33, 28]), $a([1, 28, 28]), $a([0, -1, -1]), $a([49, 20, 30]), $a([1, 18, 28]), $a([0, -1, -1])]), $a(["66", 153, 17, 8, 20229, $a([18, 105, 20]), $a([2, 117, 22]), $a([0, -1, -1]), $a([26, 65, 28]), $a([1, 80, 30]), $a([0, -1, -1]), $a([35, 35, 30]), $a([3, 35, 28]), $a([1, 36, 28]), $a([52, 18, 28]), $a([2, 38, 30]), $a([0, -1, -1])]), $a(["67", 155, 17, 8, 20805, $a([26, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([26, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([45, 31, 26]), $a([1, 9, 26]), $a([0, -1, -1]), $a([52, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["68", 157, 17, 8, 21389, $a([16, 126, 24]), $a([1, 114, 22]), $a([1, 115, 22]), $a([23, 70, 30]), $a([3, 65, 28]), $a([1, 66, 28]), $a([40, 35, 30]), $a([1, 43, 30]), $a([0, -1, -1]), $a([46, 20, 30]), $a([7, 19, 28]), $a([1, 16, 28])]), $a(["69", 159, 18, 8, 21993, $a([19, 116, 22]), $a([1, 105, 22]), $a([0, -1, -1]), $a([20, 70, 30]), $a([7, 66, 28]), $a([1, 63, 28]), $a([40, 35, 30]), $a([1, 42, 32]), $a([1, 43, 32]), $a([54, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["70", 161, 18, 8, 22593, $a([17, 126, 24]), $a([2, 115, 22]), $a([0, -1, -1]), $a([24, 70, 30]), $a([4, 74, 32]), $a([0, -1, -1]), $a([48, 31, 26]), $a([2, 18, 26]), $a([0, -1, -1]), $a([54, 19, 28]), $a([6, 15, 26]), $a([1, 14, 26])]), $a(["71", 163, 18, 8, 23201, $a([29, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([29, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([6, 34, 30]), $a([3, 36, 30]), $a([38, 33, 28]), $a([58, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["72", 165, 18, 8, 23817, $a([16, 147, 28]), $a([1, 149, 28]), $a([0, -1, -1]), $a([31, 66, 28]), $a([1, 37, 26]), $a([0, -1, -1]), $a([48, 33, 28]), $a([1, 23, 26]), $a([0, -1, -1]), $a([53, 20, 30]), $a([6, 19, 28]), $a([1, 17, 28])]), $a(["73", 167, 19, 8, 24453, $a([20, 115, 22]), $a([2, 134, 24]), $a([0, -1, -1]), $a([29, 66, 28]), $a([2, 56, 26]), $a([2, 57, 26]), $a([45, 36, 30]), $a([2, 15, 28]), $a([0, -1, -1]), $a([59, 20, 30]), $a([2, 21, 32]), $a([0, -1, -1])]), $a(["74", 169, 19, 8, 25085, $a([17, 147, 28]), $a([1, 134, 26]), $a([0, -1, -1]), $a([26, 70, 30]), $a([5, 75, 32]), $a([0, -1, -1]), $a([47, 35, 30]), $a([1, 48, 32]), $a([0, -1, -1]), $a([64, 18, 28]), $a([2, 33, 30]), $a([1, 35, 30])]), $a(["75", 171, 17, 9, 25373, $a([22, 115, 22]), $a([1, 133, 24]), $a([0, -1, -1]), $a([33, 65, 28]), $a([1, 74, 28]), $a([0, -1, -1]), $a([43, 36, 30]), $a([5, 27, 28]), $a([1, 30, 28]), $a([57, 20, 30]), $a([5, 21, 32]), $a([1, 24, 32])]), $a(["76", 173, 17, 9, 26021, $a([18, 136, 26]), $a([2, 142, 26]), $a([0, -1, -1]), $a([33, 66, 28]), $a([2, 49, 26]), $a([0, -1, -1]), $a([48, 35, 30]), $a([2, 38, 28]), $a([0, -1, -1]), $a([64, 20, 30]), $a([1, 20, 32]), $a([0, -1, -1])]), $a(["77", 175, 17, 9, 26677, $a([19, 126, 24]), $a([2, 135, 26]), $a([1, 136, 26]), $a([32, 66, 28]), $a([2, 55, 26]), $a([2, 56, 26]), $a([49, 36, 30]), $a([2, 18, 32]), $a([0, -1, -1]), $a([65, 18, 28]), $a([5, 27, 30]), $a([1, 29, 30])]), $a(["78", 177, 18, 9, 27335, $a([20, 137, 26]), $a([1, 130, 26]), $a([0, -1, -1]), $a([30, 75, 32]), $a([2, 71, 32]), $a([0, -1, -1]), $a([46, 35, 30]), $a([6, 39, 32]), $a([0, -1, -1]), $a([3, 12, 30]), $a([70, 19, 28]), $a([0, -1, -1])]), $a(["79", 179, 18, 9, 28007, $a([20, 147, 28]), $a([0, -1, -1]), $a([0, -1, -1]), $a([35, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([49, 35, 30]), $a([5, 35, 28]), $a([0, -1, -1]), $a([70, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["80", 181, 18, 9, 28687, $a([21, 136, 26]), $a([1, 155, 28]), $a([0, -1, -1]), $a([34, 70, 30]), $a([1, 64, 28]), $a([1, 65, 28]), $a([54, 35, 30]), $a([1, 45, 30]), $a([0, -1, -1]), $a([68, 20, 30]), $a([3, 18, 28]), $a([1, 19, 28])]), $a(["81", 183, 18, 9, 29375, $a([19, 126, 24]), $a([5, 115, 22]), $a([1, 114, 22]), $a([33, 70, 30]), $a([3, 65, 28]), $a([1, 64, 28]), $a([52, 35, 30]), $a([3, 41, 32]), $a([1, 40, 32]), $a([67, 20, 30]), $a([5, 21, 32]), $a([1, 24, 32])]), $a(["82", 185, 18, 9, 30071, $a([2, 150, 28]), $a([21, 136, 26]), $a([0, -1, -1]), $a([32, 70, 30]), $a([6, 65, 28]), $a([0, -1, -1]), $a([52, 38, 32]), $a([2, 27, 32]), $a([0, -1, -1]), $a([73, 20, 30]), $a([2, 22, 32]), $a([0, -1, -1])]), $a(["83", 187, 17, 10, 30387, $a([21, 126, 24]), $a([4, 136, 26]), $a([0, -1, -1]), $a([30, 74, 32]), $a([6, 73, 30]), $a([0, -1, -1]), $a([54, 35, 30]), $a([4, 40, 32]), $a([0, -1, -1]), $a([75, 20, 30]), $a([1, 20, 28]), $a([0, -1, -1])]), $a(["84", 189, 17, 10, 31091, $a([30, 105, 20]), $a([1, 114, 22]), $a([0, -1, -1]), $a([3, 45, 22]), $a([55, 47, 20]), $a([0, -1, -1]), $a([2, 26, 26]), $a([62, 33, 28]), $a([0, -1, -1]), $a([79, 18, 28]), $a([4, 33, 30]), $a([0, -1, -1])])]); /*19698*/
		$1.eclval = $get($1.eclevel, 1) - 49; /*19700*/
		for (var _Ik = 0; _Ik <= 83; _Ik += 1) { /*19720*/
			$1.i = _Ik; /*19702*/
			$1.m = $get($1.metrics, $1.i); /*19703*/
			$1.vers = $get($1.m, 0); /*19704*/
			$1.size = $get($1.m, 1); /*19705*/
			$1.alnk = $get($1.m, 2); /*19706*/
			$1.alnn = $get($1.m, 3); /*19707*/
			$1.alnr = $1.size - ($1.alnk * $1.alnn); /*19708*/
			$1.nmod = $get($1.m, 4); /*19709*/
			$1.ncws = ~~($1.nmod / 8); /*19710*/
			$1.rbit = $1.nmod % 8; /*19711*/
			$1.ecbs = $geti($1.m, 5 + ($1.eclval * 3), 3); /*19712*/
			$k[$j++] = "ecws"; /*19713*/
			$k[$j++] = 0; /*19713*/
			$forall($1.ecbs, function() { /*19713*/
				var _J7 = $k[--$j]; /*19713*/
				var _JA = $k[--$j]; /*19713*/
				$k[$j++] = _JA + ($get(_J7, 0) * $get(_J7, 2)); /*19713*/
			}); /*19713*/
			var _JB = $k[--$j]; /*19713*/
			$1[$k[--$j]] = _JB; /*19713*/
			$1.dcws = $1.ncws - $1.ecws; /*19714*/
			$1.dmod = $1.dcws * 8; /*19715*/
			$1.okay = true; /*19716*/
			if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*19717*/
				$1.okay = false; /*19717*/
			} /*19717*/
			if ($1.bits.length > $1.dmod) { /*19718*/
				$1.okay = false; /*19718*/
			} /*19718*/
			if ($1.okay) { /*19719*/
				break; /*19719*/
			} /*19719*/
		} /*19719*/
		if (!$1.okay) { /*19724*/
			$k[$j++] = "bwipp.hanxinNoValidSymbol"; /*19723*/
			$k[$j++] = "No valid symbol available"; /*19723*/
			$0.raiseerror(); /*19723*/
		} /*19723*/
		$1.version = $1.vers; /*19726*/
		$1.msgbits = $1.bits; /*19727*/
		$1.e1nb = $get($get($1.ecbs, 0), 0); /*19728*/
		$1.e2nb = $get($get($1.ecbs, 1), 0); /*19728*/
		$1.e3nb = $get($get($1.ecbs, 2), 0); /*19728*/
		$1.e1dcws = $get($get($1.ecbs, 0), 1); /*19729*/
		$1.e2dcws = $get($get($1.ecbs, 1), 1); /*19729*/
		$1.e3dcws = $get($get($1.ecbs, 2), 1); /*19729*/
		$1.e1ecws = $get($get($1.ecbs, 0), 2); /*19730*/
		$1.e2ecws = $get($get($1.ecbs, 1), 2); /*19730*/
		$1.e3ecws = $get($get($1.ecbs, 2), 2); /*19730*/
		$1.pad = $s($1.dmod); /*19733*/
		for (var _Ju = 0, _Jt = $1.pad.length - 1; _Ju <= _Jt; _Ju += 1) { /*19734*/
			$put($1.pad, _Ju, 48); /*19734*/
		} /*19734*/
		$puti($1.pad, 0, $1.msgbits); /*19735*/
		$1.cws = $a($1.dcws); /*19738*/
		for (var _K2 = 0, _K1 = $1.cws.length - 1; _K2 <= _K1; _K2 += 1) { /*19748*/
			$1.c = _K2; /*19740*/
			$1.cwb = $geti($1.pad, $1.c * 8, 8); /*19741*/
			$1.cw = 0; /*19742*/
			for (var _K6 = 0; _K6 <= 7; _K6 += 1) { /*19746*/
				$1.i = _K6; /*19744*/
				$1.cw = $1.cw + ((~~(Math.pow(2, (8 - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*19745*/
			} /*19745*/
			$put($1.cws, $1.c, $1.cw); /*19747*/
		} /*19747*/
		$1.rscodes = function() {
			$1.rspm = $k[--$j]; /*19752*/
			$1.rsgf = $k[--$j]; /*19753*/
			$1.rsnc = $k[--$j]; /*19754*/
			$1.rscws = $k[--$j]; /*19755*/
			$k[$j++] = Infinity; /*19758*/
			$k[$j++] = 1; /*19758*/
			for (var _KK = 0, _KL = $1.rsgf - 1; _KK < _KL; _KK++) { /*19758*/
				var _KM = $k[--$j]; /*19758*/
				var _KN = _KM * 2; /*19758*/
				$k[$j++] = _KM; /*19758*/
				$k[$j++] = _KN; /*19758*/
				if (_KN >= $1.rsgf) { /*19758*/
					var _KQ = $k[--$j]; /*19758*/
					$k[$j++] = $xo(_KQ, $1.rspm); /*19758*/
				} /*19758*/
			} /*19758*/
			$1.rsalog = $a(); /*19758*/
			$1.rslog = $a($1.rsgf); /*19759*/
			for (var _KW = 1, _KV = $1.rsgf - 1; _KW <= _KV; _KW += 1) { /*19760*/
				$put($1.rslog, $get($1.rsalog, _KW), _KW); /*19760*/
			} /*19760*/
			$1.rsprod = function() {
				var _Ka = $k[--$j]; /*19764*/
				var _Kb = $k[--$j]; /*19764*/
				$k[$j++] = _Kb; /*19768*/
				$k[$j++] = _Ka; /*19768*/
				if ((_Ka != 0) && (_Kb != 0)) { /*19767*/
					var _Ke = $get($1.rslog, $k[--$j]); /*19765*/
					var _Kk = $get($1.rsalog, (_Ke + $get($1.rslog, $k[--$j])) % ($1.rsgf - 1)); /*19765*/
					$k[$j++] = _Kk; /*19765*/
				} else { /*19767*/
					$j -= 2; /*19767*/
					$k[$j++] = 0; /*19767*/
				} /*19767*/
			}; /*19769*/
			$k[$j++] = Infinity; /*19772*/
			$k[$j++] = 1; /*19772*/
			for (var _Km = 0, _Kn = $1.rsnc; _Km < _Kn; _Km++) { /*19772*/
				$k[$j++] = 0; /*19772*/
			} /*19772*/
			$1.coeffs = $a(); /*19772*/
			for (var _Kr = 1, _Kq = $1.rsnc; _Kr <= _Kq; _Kr += 1) { /*19781*/
				$1.i = _Kr; /*19774*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*19775*/
				for (var _Ky = $1.i - 1; _Ky >= 1; _Ky -= 1) { /*19779*/
					$1.j = _Ky; /*19777*/
					$k[$j++] = $1.coeffs; /*19778*/
					$k[$j++] = $1.j; /*19778*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*19778*/
					$k[$j++] = $get($1.coeffs, $1.j); /*19778*/
					$k[$j++] = $get($1.rsalog, $1.i); /*19778*/
					$1.rsprod(); /*19778*/
					var _LA = $k[--$j]; /*19778*/
					var _LB = $k[--$j]; /*19778*/
					var _LC = $k[--$j]; /*19778*/
					$put($k[--$j], _LC, $xo(_LB, _LA)); /*19778*/
				} /*19778*/
				$k[$j++] = $1.coeffs; /*19780*/
				$k[$j++] = 0; /*19780*/
				$k[$j++] = $get($1.coeffs, 0); /*19780*/
				$k[$j++] = $get($1.rsalog, $1.i); /*19780*/
				$1.rsprod(); /*19780*/
				var _LK = $k[--$j]; /*19780*/
				var _LL = $k[--$j]; /*19780*/
				$put($k[--$j], _LL, _LK); /*19780*/
			} /*19780*/
			$1.nd = $1.rscws.length; /*19784*/
			$k[$j++] = Infinity; /*19785*/
			$forall($1.rscws); /*19785*/
			for (var _LQ = 0, _LR = $1.rsnc; _LQ < _LR; _LQ++) { /*19785*/
				$k[$j++] = 0; /*19785*/
			} /*19785*/
			$k[$j++] = 0; /*19785*/
			$1.rscws = $a(); /*19785*/
			for (var _LV = 0, _LU = $1.nd - 1; _LV <= _LU; _LV += 1) { /*19792*/
				$1.k = $xo($get($1.rscws, _LV), $get($1.rscws, $1.nd)); /*19787*/
				for (var _Ld = 0, _Lc = $1.rsnc - 1; _Ld <= _Lc; _Ld += 1) { /*19791*/
					$1.j = _Ld; /*19789*/
					$k[$j++] = $1.rscws; /*19790*/
					$k[$j++] = $1.nd + $1.j; /*19790*/
					$k[$j++] = $get($1.rscws, ($1.nd + $1.j) + 1); /*19790*/
					$k[$j++] = $1.k; /*19790*/
					$k[$j++] = $get($1.coeffs, ($1.rsnc - $1.j) - 1); /*19790*/
					$1.rsprod(); /*19790*/
					var _Lq = $k[--$j]; /*19790*/
					var _Lr = $k[--$j]; /*19790*/
					var _Ls = $k[--$j]; /*19790*/
					$put($k[--$j], _Ls, $xo(_Lr, _Lq)); /*19790*/
				} /*19790*/
			} /*19790*/
			$k[$j++] = $geti($1.rscws, 0, $1.rscws.length - 1); /*19795*/
		}; /*19797*/
		$1.dcwsb = $a(($1.e1nb + $1.e2nb) + $1.e3nb); /*19800*/
		$1.ecwsb = $a($1.dcwsb.length); /*19801*/
		$1.in = 0; /*19802*/
		$1.out = 0; /*19802*/
		for (var _M4 = 0, _M5 = $1.e1nb; _M4 < _M5; _M4++) { /*19808*/
			$k[$j++] = $geti($1.cws, $1.in, $1.e1dcws); /*19804*/
			$k[$j++] = $1.e1ecws; /*19804*/
			$k[$j++] = 256; /*19804*/
			$k[$j++] = 355; /*19804*/
			$1.rscodes(); /*19804*/
			var _MB = $k[--$j]; /*19805*/
			$put($1.dcwsb, $1.out, $geti(_MB, 0, $1.e1dcws)); /*19805*/
			$put($1.ecwsb, $1.out, $geti(_MB, $1.e1dcws, $1.e1ecws)); /*19806*/
			$1.in = $1.in + $1.e1dcws; /*19807*/
			$1.out = $1.out + 1; /*19807*/
		} /*19807*/
		for (var _MP = 0, _MQ = $1.e2nb; _MP < _MQ; _MP++) { /*19814*/
			$k[$j++] = $geti($1.cws, $1.in, $1.e2dcws); /*19810*/
			$k[$j++] = $1.e2ecws; /*19810*/
			$k[$j++] = 256; /*19810*/
			$k[$j++] = 355; /*19810*/
			$1.rscodes(); /*19810*/
			var _MW = $k[--$j]; /*19811*/
			$put($1.dcwsb, $1.out, $geti(_MW, 0, $1.e2dcws)); /*19811*/
			$put($1.ecwsb, $1.out, $geti(_MW, $1.e2dcws, $1.e2ecws)); /*19812*/
			$1.in = $1.in + $1.e2dcws; /*19813*/
			$1.out = $1.out + 1; /*19813*/
		} /*19813*/
		for (var _Mk = 0, _Ml = $1.e3nb; _Mk < _Ml; _Mk++) { /*19820*/
			$k[$j++] = $geti($1.cws, $1.in, $1.e3dcws); /*19816*/
			$k[$j++] = $1.e3ecws; /*19816*/
			$k[$j++] = 256; /*19816*/
			$k[$j++] = 355; /*19816*/
			$1.rscodes(); /*19816*/
			var _Mr = $k[--$j]; /*19817*/
			$put($1.dcwsb, $1.out, $geti(_Mr, 0, $1.e3dcws)); /*19817*/
			$put($1.ecwsb, $1.out, $geti(_Mr, $1.e3dcws, $1.e3ecws)); /*19818*/
			$1.in = $1.in + $1.e3dcws; /*19819*/
			$1.out = $1.out + 1; /*19819*/
		} /*19819*/
		$1.cws = $a($1.ncws); /*19823*/
		$1.cw = 0; /*19824*/
		for (var _N8 = 0, _N7 = $1.dcwsb.length - 1; _N8 <= _N7; _N8 += 1) { /*19829*/
			$1.i = _N8; /*19826*/
			var _NB = $get($1.dcwsb, $1.i); /*19827*/
			$puti($1.cws, $1.cw, _NB); /*19827*/
			$1.cw = _NB.length + $1.cw; /*19827*/
			var _NH = $get($1.ecwsb, $1.i); /*19828*/
			$puti($1.cws, $1.cw, _NH); /*19828*/
			$1.cw = _NH.length + $1.cw; /*19828*/
		} /*19828*/
		$k[$j++] = Infinity; /*19836*/
		var _NL = $1.ncws; /*19833*/
		var _NM = 12; /*19833*/
		var _NN = _NL - 1; /*19833*/
		if ((_NL - 1) > 12) { /*19833*/
			var _ = _NM; /*19833*/
			_NM = _NN; /*19833*/
			_NN = _; /*19833*/
		} /*19833*/
		for (var _NP = 0, _NO = _NN; _NP <= _NO; _NP += 1) { /*19835*/
			for (var _NS = _NP, _NR = $1.ncws - 1; _NS <= _NR; _NS += 13) { /*19834*/
				$k[$j++] = _NS; /*19834*/
				if (_NS < $1.ncws) { /*19834*/
					var _NW = $get($1.cws, $k[--$j]); /*19834*/
					$k[$j++] = _NW; /*19834*/
				} else { /*19834*/
					$j--; /*19834*/
				} /*19834*/
			} /*19834*/
		} /*19834*/
		$1.cws = $a(); /*19836*/
		if ($1.rbit > 0) { /*19844*/
			$1.pad = $a($1.cws.length + 1); /*19840*/
			$puti($1.pad, 0, $1.cws); /*19841*/
			$put($1.pad, $1.pad.length - 1, 0); /*19842*/
			$1.cws = $1.pad; /*19843*/
		} /*19843*/
		$k[$j++] = Infinity; /*19847*/
		for (var _Ni = 0, _Nj = $1.size * $1.size; _Ni < _Nj; _Ni++) { /*19847*/
			$k[$j++] = -1; /*19847*/
		} /*19847*/
		$1.pixs = $a(); /*19847*/
		$1.qmv = function() {
			var _Nm = $k[--$j]; /*19848*/
			var _Nn = $k[--$j]; /*19848*/
			$k[$j++] = _Nn + (_Nm * $1.size); /*19848*/
		}; /*19848*/
		if ($1.alnn != 0) { /*19907*/
			$1.trmv = function() {
				var _Nq = $k[--$j]; /*19852*/
				var _Ns = $k[--$j]; /*19852*/
				$k[$j++] = (((_Nq * $1.size) + $1.size) - 1) - _Ns; /*19852*/
			}; /*19852*/
			$1.aplot = function() {
				var _Nt = $k[--$j]; /*19854*/
				var _Nu = $k[--$j]; /*19854*/
				var _Nv = $k[--$j]; /*19854*/
				$k[$j++] = _Nt; /*19854*/
				$k[$j++] = _Nv; /*19854*/
				$k[$j++] = _Nu; /*19854*/
				$k[$j++] = _Nt; /*19854*/
				$k[$j++] = _Nu; /*19854*/
				$k[$j++] = _Nv; /*19854*/
				$1.trmv(); /*19854*/
				var _Nx = $k[--$j]; /*19854*/
				$put($1.pixs, _Nx, $k[--$j]); /*19854*/
				$1.trmv(); /*19855*/
				var _O0 = $k[--$j]; /*19855*/
				$put($1.pixs, _O0, $k[--$j]); /*19855*/
			}; /*19856*/
			$1.i = 0; /*19857*/
			$1.stag = 0; /*19857*/
			for (;;) { /*19879*/
				if ($1.i >= $1.size) { /*19858*/
					break; /*19858*/
				} /*19858*/
				for (var _O6 = 0, _O5 = $1.size - 1; _O6 <= _O5; _O6 += 1) { /*19872*/
					$1.j = _O6; /*19860*/
					if (($1.j + $1.alnr) < $1.size) { /*19866*/
						$k[$j++] = (((((~~($1.j / $1.alnk)) + $1.stag) % 2) == 0) && (!(($1.i == 0) && ($1.j < $1.alnk)))) || (($1.j % $1.alnk) == 0); /*19864*/
					} else { /*19866*/
						$k[$j++] = (($1.alnn + $1.stag) % 2) == 0; /*19866*/
					} /*19866*/
					if ($k[--$j]) { /*19871*/
						$k[$j++] = $1.j; /*19869*/
						$k[$j++] = $1.i; /*19869*/
						$k[$j++] = 1; /*19869*/
						$1.aplot(); /*19869*/
						var _ON = $1.j; /*19870*/
						var _OO = $1.i; /*19870*/
						$k[$j++] = _ON + 1; /*19870*/
						$k[$j++] = _OO + 1; /*19870*/
						if (((_OO + 1) < $1.size) && ((_ON + 1) < $1.size)) { /*19870*/
							$k[$j++] = 0; /*19870*/
							$1.aplot(); /*19870*/
						} else { /*19870*/
							$j -= 2; /*19870*/
						} /*19870*/
					} /*19870*/
				} /*19870*/
				if (($1.i + $1.alnr) == $1.size) { /*19876*/
					$1.i = ($1.i + $1.alnr) - 1; /*19874*/
				} else { /*19876*/
					$1.i = $1.i + $1.alnk; /*19876*/
				} /*19876*/
				$1.stag = 1 - $1.stag; /*19878*/
			} /*19878*/
			for (var _Od = $1.alnk, _Oe = $1.alnk, _Oc = $1.size - 2; _Oe < 0 ? _Od >= _Oc : _Od <= _Oc; _Od += _Oe) { /*19906*/
				$1.i = _Od; /*19881*/
				if (((~~($1.i / $1.alnk)) % 2) != 0) { /*19893*/
					$k[$j++] = $1.pixs; /*19883*/
					$k[$j++] = 0; /*19883*/
					$k[$j++] = $1.i - 1; /*19883*/
					$1.trmv(); /*19883*/
					var _Oj = $k[--$j]; /*19883*/
					$put($k[--$j], _Oj, 0); /*19883*/
					$k[$j++] = $1.pixs; /*19884*/
					$k[$j++] = 0; /*19884*/
					$k[$j++] = $1.i + 1; /*19884*/
					$1.trmv(); /*19884*/
					var _On = $k[--$j]; /*19884*/
					$put($k[--$j], _On, 0); /*19884*/
					$k[$j++] = $1.pixs; /*19885*/
					$k[$j++] = 1; /*19885*/
					$k[$j++] = $1.i - 1; /*19885*/
					$1.trmv(); /*19885*/
					var _Or = $k[--$j]; /*19885*/
					$put($k[--$j], _Or, 0); /*19885*/
					$k[$j++] = $1.pixs; /*19886*/
					$k[$j++] = 1; /*19886*/
					$k[$j++] = $1.i; /*19886*/
					$1.trmv(); /*19886*/
					var _Ov = $k[--$j]; /*19886*/
					$put($k[--$j], _Ov, 0); /*19886*/
					$k[$j++] = $1.pixs; /*19887*/
					$k[$j++] = 1; /*19887*/
					$k[$j++] = $1.i + 1; /*19887*/
					$1.trmv(); /*19887*/
					var _Oz = $k[--$j]; /*19887*/
					$put($k[--$j], _Oz, 0); /*19887*/
					$k[$j++] = $1.pixs; /*19888*/
					$k[$j++] = $1.i - 1; /*19888*/
					$k[$j++] = 0; /*19888*/
					$1.trmv(); /*19888*/
					var _P3 = $k[--$j]; /*19888*/
					$put($k[--$j], _P3, 0); /*19888*/
					$k[$j++] = $1.pixs; /*19889*/
					$k[$j++] = $1.i + 1; /*19889*/
					$k[$j++] = 0; /*19889*/
					$1.trmv(); /*19889*/
					var _P7 = $k[--$j]; /*19889*/
					$put($k[--$j], _P7, 0); /*19889*/
					$k[$j++] = $1.pixs; /*19890*/
					$k[$j++] = $1.i - 1; /*19890*/
					$k[$j++] = 1; /*19890*/
					$1.trmv(); /*19890*/
					var _PB = $k[--$j]; /*19890*/
					$put($k[--$j], _PB, 0); /*19890*/
					$k[$j++] = $1.pixs; /*19891*/
					$k[$j++] = $1.i; /*19891*/
					$k[$j++] = 1; /*19891*/
					$1.trmv(); /*19891*/
					var _PF = $k[--$j]; /*19891*/
					$put($k[--$j], _PF, 0); /*19891*/
					$k[$j++] = $1.pixs; /*19892*/
					$k[$j++] = $1.i + 1; /*19892*/
					$k[$j++] = 1; /*19892*/
					$1.trmv(); /*19892*/
					var _PJ = $k[--$j]; /*19892*/
					$put($k[--$j], _PJ, 0); /*19892*/
				} /*19892*/
				$k[$j++] = $1.pixs; /*19894*/
				$k[$j++] = $1.size - 1; /*19894*/
				$k[$j++] = $1.i - 1; /*19894*/
				$1.trmv(); /*19894*/
				var _PO = $k[--$j]; /*19894*/
				if ($get($k[--$j], _PO) != 1) { /*19905*/
					$k[$j++] = $1.pixs; /*19895*/
					$k[$j++] = $1.size - 1; /*19895*/
					$k[$j++] = $1.i - 1; /*19895*/
					$1.trmv(); /*19895*/
					var _PU = $k[--$j]; /*19895*/
					$put($k[--$j], _PU, 0); /*19895*/
					$k[$j++] = $1.pixs; /*19896*/
					$k[$j++] = $1.size - 2; /*19896*/
					$k[$j++] = $1.i - 1; /*19896*/
					$1.trmv(); /*19896*/
					var _PZ = $k[--$j]; /*19896*/
					$put($k[--$j], _PZ, 0); /*19896*/
					$k[$j++] = $1.pixs; /*19897*/
					$k[$j++] = $1.size - 2; /*19897*/
					$k[$j++] = $1.i; /*19897*/
					$1.trmv(); /*19897*/
					var _Pe = $k[--$j]; /*19897*/
					$put($k[--$j], _Pe, 0); /*19897*/
					$k[$j++] = $1.pixs; /*19898*/
					$k[$j++] = $1.size - 2; /*19898*/
					$k[$j++] = $1.i + 1; /*19898*/
					$1.trmv(); /*19898*/
					var _Pj = $k[--$j]; /*19898*/
					$put($k[--$j], _Pj, 0); /*19898*/
					$k[$j++] = $1.pixs; /*19899*/
					$k[$j++] = $1.size - 1; /*19899*/
					$k[$j++] = $1.i + 1; /*19899*/
					$1.trmv(); /*19899*/
					var _Po = $k[--$j]; /*19899*/
					$put($k[--$j], _Po, 0); /*19899*/
					$k[$j++] = $1.pixs; /*19900*/
					$k[$j++] = $1.i - 1; /*19900*/
					$k[$j++] = $1.size - 1; /*19900*/
					$1.trmv(); /*19900*/
					var _Pt = $k[--$j]; /*19900*/
					$put($k[--$j], _Pt, 0); /*19900*/
					$k[$j++] = $1.pixs; /*19901*/
					$k[$j++] = $1.i - 1; /*19901*/
					$k[$j++] = $1.size - 2; /*19901*/
					$1.trmv(); /*19901*/
					var _Py = $k[--$j]; /*19901*/
					$put($k[--$j], _Py, 0); /*19901*/
					$k[$j++] = $1.pixs; /*19902*/
					$k[$j++] = $1.i; /*19902*/
					$k[$j++] = $1.size - 2; /*19902*/
					$1.trmv(); /*19902*/
					var _Q3 = $k[--$j]; /*19902*/
					$put($k[--$j], _Q3, 0); /*19902*/
					$k[$j++] = $1.pixs; /*19903*/
					$k[$j++] = $1.i + 1; /*19903*/
					$k[$j++] = $1.size - 2; /*19903*/
					$1.trmv(); /*19903*/
					var _Q8 = $k[--$j]; /*19903*/
					$put($k[--$j], _Q8, 0); /*19903*/
					$k[$j++] = $1.pixs; /*19904*/
					$k[$j++] = $1.i + 1; /*19904*/
					$k[$j++] = $1.size - 1; /*19904*/
					$1.trmv(); /*19904*/
					var _QD = $k[--$j]; /*19904*/
					$put($k[--$j], _QD, 0); /*19904*/
				} /*19904*/
			} /*19904*/
		} /*19904*/
		$1.fpat = $a([$a([1, 1, 1, 1, 1, 1, 1, 0]), $a([1, 0, 0, 0, 0, 0, 0, 0]), $a([1, 0, 1, 1, 1, 1, 1, 0]), $a([1, 0, 1, 0, 0, 0, 0, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*19919*/
		$1.fpat2 = $a([$a([1, 1, 1, 0, 1, 0, 1, 0]), $a([1, 1, 1, 0, 1, 0, 1, 0]), $a([1, 1, 1, 0, 1, 0, 1, 0]), $a([0, 0, 0, 0, 1, 0, 1, 0]), $a([1, 1, 1, 1, 1, 0, 1, 0]), $a([0, 0, 0, 0, 0, 0, 1, 0]), $a([1, 1, 1, 1, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*19929*/
		for (var _QZ = 0, _QY = $1.fpat.length - 1; _QZ <= _QY; _QZ += 1) { /*19941*/
			$1.y = _QZ; /*19931*/
			for (var _Qd = 0, _Qc = $get($1.fpat, 0).length - 1; _Qd <= _Qc; _Qd += 1) { /*19940*/
				$1.x = _Qd; /*19933*/
				$1.fpb = $get($get($1.fpat, $1.y), $1.x); /*19934*/
				$1.fpb2 = $get($get($1.fpat2, $1.y), $1.x); /*19935*/
				$k[$j++] = $1.pixs; /*19936*/
				$k[$j++] = $1.x; /*19936*/
				$k[$j++] = $1.y; /*19936*/
				$1.qmv(); /*19936*/
				var _Qs = $k[--$j]; /*19936*/
				$put($k[--$j], _Qs, $1.fpb); /*19936*/
				$k[$j++] = $1.pixs; /*19937*/
				$k[$j++] = ($1.size - $1.x) - 1; /*19937*/
				$k[$j++] = $1.y; /*19937*/
				$1.qmv(); /*19937*/
				var _Qz = $k[--$j]; /*19937*/
				$put($k[--$j], _Qz, $1.fpb); /*19937*/
				$k[$j++] = $1.pixs; /*19938*/
				$k[$j++] = ($1.size - $1.x) - 1; /*19938*/
				$k[$j++] = ($1.size - $1.y) - 1; /*19938*/
				$1.qmv(); /*19938*/
				var _R7 = $k[--$j]; /*19938*/
				$put($k[--$j], _R7, $1.fpb); /*19938*/
				$k[$j++] = $1.pixs; /*19939*/
				$k[$j++] = $1.x; /*19939*/
				$k[$j++] = ($1.size - $1.y) - 1; /*19939*/
				$1.qmv(); /*19939*/
				var _RE = $k[--$j]; /*19939*/
				$put($k[--$j], _RE, $1.fpb2); /*19939*/
			} /*19939*/
		} /*19939*/
		$1.functionmap = $a([$a([$a([0, 8]), $a([$1.size - 1, $1.size - 9])]), $a([$a([1, 8]), $a([$1.size - 2, $1.size - 9])]), $a([$a([2, 8]), $a([$1.size - 3, $1.size - 9])]), $a([$a([3, 8]), $a([$1.size - 4, $1.size - 9])]), $a([$a([4, 8]), $a([$1.size - 5, $1.size - 9])]), $a([$a([5, 8]), $a([$1.size - 6, $1.size - 9])]), $a([$a([6, 8]), $a([$1.size - 7, $1.size - 9])]), $a([$a([7, 8]), $a([$1.size - 8, $1.size - 9])]), $a([$a([8, 8]), $a([$1.size - 9, $1.size - 9])]), $a([$a([8, 7]), $a([$1.size - 9, $1.size - 8])]), $a([$a([8, 6]), $a([$1.size - 9, $1.size - 7])]), $a([$a([8, 5]), $a([$1.size - 9, $1.size - 6])]), $a([$a([8, 4]), $a([$1.size - 9, $1.size - 5])]), $a([$a([8, 3]), $a([$1.size - 9, $1.size - 4])]), $a([$a([8, 2]), $a([$1.size - 9, $1.size - 3])]), $a([$a([8, 1]), $a([$1.size - 9, $1.size - 2])]), $a([$a([8, 0]), $a([$1.size - 9, $1.size - 1])]), $a([$a([$1.size - 9, 0]), $a([8, $1.size - 1])]), $a([$a([$1.size - 9, 1]), $a([8, $1.size - 2])]), $a([$a([$1.size - 9, 2]), $a([8, $1.size - 3])]), $a([$a([$1.size - 9, 3]), $a([8, $1.size - 4])]), $a([$a([$1.size - 9, 4]), $a([8, $1.size - 5])]), $a([$a([$1.size - 9, 5]), $a([8, $1.size - 6])]), $a([$a([$1.size - 9, 6]), $a([8, $1.size - 7])]), $a([$a([$1.size - 9, 7]), $a([8, $1.size - 8])]), $a([$a([$1.size - 9, 8]), $a([8, $1.size - 9])]), $a([$a([$1.size - 8, 8]), $a([7, $1.size - 9])]), $a([$a([$1.size - 7, 8]), $a([6, $1.size - 9])]), $a([$a([$1.size - 6, 8]), $a([5, $1.size - 9])]), $a([$a([$1.size - 5, 8]), $a([4, $1.size - 9])]), $a([$a([$1.size - 4, 8]), $a([3, $1.size - 9])]), $a([$a([$1.size - 3, 8]), $a([2, $1.size - 9])]), $a([$a([$1.size - 2, 8]), $a([1, $1.size - 9])]), $a([$a([$1.size - 1, 8]), $a([0, $1.size - 9])])]); /*19963*/
		var _U1 = $1.functionmap; /*19964*/
		for (var _U2 = 0, _U3 = _U1.length; _U2 < _U3; _U2++) { /*19966*/
			$forall($get(_U1, _U2), function() { /*19965*/
				$forall($k[--$j]); /*19965*/
				$1.qmv(); /*19965*/
				$put($1.pixs, $k[--$j], 0); /*19965*/
			}); /*19965*/
		} /*19965*/
		var _UE = $a([function() {
			$j -= 2; /*19969*/
			$k[$j++] = 1; /*19969*/
		}, function() {
			var _U8 = $k[--$j]; /*19970*/
			var _U9 = $k[--$j]; /*19970*/
			$k[$j++] = (_U9 + _U8) % 2; /*19970*/
		}, function() {
			var _UA = $k[--$j]; /*19971*/
			var _UB = $k[--$j]; /*19971*/
			$k[$j++] = (((_UA + _UB) % 3) + (_UB % 3)) % 2; /*19971*/
		}, function() {
			var _UC = $k[--$j]; /*19972*/
			var _UD = $k[--$j]; /*19972*/
			$k[$j++] = ((_UD % _UC) + ((_UC % _UD) + ((_UC % 3) + (_UD % 3)))) % 2; /*19973*/
		}]); /*19973*/
		$1.maskfuncs = _UE; /*19974*/
		if ($1.mask != -1) { /*19978*/
			$1.maskfuncs = $a([$get($1.maskfuncs, $1.mask - 1)]); /*19976*/
			$1.bestmaskval = $1.mask - 1; /*19977*/
		} /*19977*/
		$1.masks = $a($1.maskfuncs.length); /*19979*/
		for (var _UP = 0, _UO = $1.masks.length - 1; _UP <= _UO; _UP += 1) { /*19993*/
			$1.m = _UP; /*19981*/
			$1.mask = $a($1.size * $1.size); /*19982*/
			for (var _UV = 0, _UU = $1.size - 1; _UV <= _UU; _UV += 1) { /*19991*/
				$1.j = _UV; /*19984*/
				for (var _UY = 0, _UX = $1.size - 1; _UY <= _UX; _UY += 1) { /*19990*/
					$1.i = _UY; /*19986*/
					$k[$j++] = $1.i + 1; /*19987*/
					$k[$j++] = $1.j + 1; /*19987*/
					$get($1.maskfuncs, $1.m)(); /*19987*/
					var _Ue = $k[--$j]; /*19987*/
					$k[$j++] = _Ue == 0; /*19988*/
					$k[$j++] = $1.pixs; /*19988*/
					$k[$j++] = $1.i; /*19988*/
					$k[$j++] = $1.j; /*19988*/
					$1.qmv(); /*19988*/
					var _Ui = $k[--$j]; /*19988*/
					var _Uk = $get($k[--$j], _Ui); /*19988*/
					var _Um = ($k[--$j] && (_Uk == -1)) ? 1 : 0; /*19988*/
					$k[$j++] = _Um; /*19989*/
					$k[$j++] = $1.mask; /*19989*/
					$k[$j++] = $1.i; /*19989*/
					$k[$j++] = $1.j; /*19989*/
					$1.qmv(); /*19989*/
					var _Uq = $k[--$j]; /*19989*/
					var _Ur = $k[--$j]; /*19989*/
					$put(_Ur, _Uq, $k[--$j]); /*19989*/
				} /*19989*/
			} /*19989*/
			$put($1.masks, $1.m, $1.mask); /*19992*/
		} /*19992*/
		$1.posx = 0; /*19996*/
		$1.posy = 0; /*19997*/
		$1.num = 0; /*19998*/
		for (;;) { /*20008*/
			if ($1.posy == $1.size) { /*20000*/
				break; /*20000*/
			} /*20000*/
			$k[$j++] = $1.pixs; /*20001*/
			$k[$j++] = $1.posx; /*20001*/
			$k[$j++] = $1.posy; /*20001*/
			$1.qmv(); /*20001*/
			var _V1 = $k[--$j]; /*20001*/
			if ($get($k[--$j], _V1) == -1) { /*20005*/
				var _V6 = $get($1.cws, ~~($1.num / 8)); /*20002*/
				var _V8 = -(7 - ($1.num % 8)); /*20002*/
				$k[$j++] = ((_V8 < 0 ? _V6 >>> -_V8 : _V6 << _V8)) & 1; /*20003*/
				$k[$j++] = $1.pixs; /*20003*/
				$k[$j++] = $1.posx; /*20003*/
				$k[$j++] = $1.posy; /*20003*/
				$1.qmv(); /*20003*/
				var _VC = $k[--$j]; /*20003*/
				var _VD = $k[--$j]; /*20003*/
				$put(_VD, _VC, $k[--$j]); /*20003*/
				$1.num = $1.num + 1; /*20004*/
			} /*20004*/
			$1.posx = $1.posx + 1; /*20006*/
			if ($1.posx == $1.size) { /*20007*/
				$1.posx = 0; /*20007*/
				$1.posy = $1.posy + 1; /*20007*/
			} /*20007*/
		} /*20007*/
		$1.evalfulln1n3 = function() {
			$1.scrle = $k[--$j]; /*20012*/
			$k[$j++] = "scr1"; /*20014*/
			$k[$j++] = 0; /*20014*/
			$forall($1.scrle, function() { /*20014*/
				var _VM = $k[--$j]; /*20014*/
				$k[$j++] = _VM; /*20014*/
				if (_VM >= 3) { /*20014*/
					var _VN = $k[--$j]; /*20014*/
					var _VP = $k[--$j] + (_VN * 4); /*20014*/
					$k[$j++] = _VP; /*20014*/
					$k[$j++] = _VP; /*20014*/
				} /*20014*/
				$j--; /*20014*/
			}); /*20014*/
			var _VQ = $k[--$j]; /*20014*/
			$1[$k[--$j]] = _VQ; /*20014*/
			$1.scr3 = 0; /*20015*/
			for (var _VU = 5, _VT = $1.scrle.length - 1; _VU <= _VT; _VU += 2) { /*20031*/
				$1.j = _VU; /*20018*/
				if (($get($1.scrle, $1.j) % 3) == 0) { /*20030*/
					$1.fact = ~~($get($1.scrle, $1.j) / 3); /*20020*/
					$forall($geti($1.scrle, $1.j - 4, 4), function() { /*20021*/
						var _Vf = $k[--$j]; /*20021*/
						$k[$j++] = _Vf == $1.fact; /*20021*/
					}); /*20021*/
					var _Vg = $k[--$j]; /*20021*/
					var _Vh = $k[--$j]; /*20021*/
					var _Vi = $k[--$j]; /*20021*/
					if ($k[--$j] && (_Vi && (_Vh && _Vg))) { /*20029*/
						if (($1.j == 5) || (($1.j + 2) >= $1.scrle.length)) { /*20026*/
							$1.scr3 = $1.scr3 + 50; /*20023*/
						} else { /*20026*/
							if (($get($1.scrle, $1.j - 5) >= 3) || ($get($1.scrle, $1.j + 1) >= 3)) { /*20027*/
								$1.scr3 = $1.scr3 + 50; /*20026*/
							} /*20026*/
						} /*20026*/
					} /*20026*/
				} /*20026*/
			} /*20026*/
			for (var _Vx = 1, _Vw = $1.scrle.length - 5; _Vx <= _Vw; _Vx += 2) { /*20047*/
				$1.j = _Vx; /*20034*/
				if (($get($1.scrle, $1.j) % 3) == 0) { /*20046*/
					$1.fact = ~~($get($1.scrle, $1.j) / 3); /*20036*/
					$forall($geti($1.scrle, $1.j + 1, 4), function() { /*20037*/
						var _W8 = $k[--$j]; /*20037*/
						$k[$j++] = _W8 == $1.fact; /*20037*/
					}); /*20037*/
					var _W9 = $k[--$j]; /*20037*/
					var _WA = $k[--$j]; /*20037*/
					var _WB = $k[--$j]; /*20037*/
					if ($k[--$j] && (_WB && (_WA && _W9))) { /*20045*/
						if (($1.j == 1) || (($1.j + 6) >= $1.scrle.length)) { /*20042*/
							$1.scr3 = $1.scr3 + 50; /*20039*/
						} else { /*20042*/
							if (($get($1.scrle, $1.j - 1) >= 3) || ($get($1.scrle, $1.j + 5) >= 3)) { /*20043*/
								$1.scr3 = $1.scr3 + 50; /*20042*/
							} /*20042*/
						} /*20042*/
					} /*20042*/
				} /*20042*/
			} /*20042*/
			$k[$j++] = $1.scr1; /*20048*/
			$k[$j++] = $1.scr3; /*20048*/
		}; /*20049*/
		$1.evalfull = function() {
			$1.sym = $k[--$j]; /*20053*/
			$1.n1 = 0; /*20055*/
			$1.n3 = 0; /*20055*/
			$1.rle = $a($1.size + 1); /*20056*/
			$1.lastpairs = $a($1.size); /*20057*/
			$1.thispairs = $a($1.size); /*20058*/
			$1.sizeadd1 = $1.size + 1; /*20059*/
			for (var _Wa = 0, _WZ = $1.size - 1; _Wa <= _WZ; _Wa += 1) { /*20084*/
				$1.i = _Wa; /*20061*/
				$k[$j++] = Infinity; /*20064*/
				var _Wc = $1.size; /*20065*/
				$k[$j++] = 0; /*20067*/
				$k[$j++] = 0; /*20067*/
				for (var _We = $1.i, _Wf = _Wc, _Wd = (_Wc * _Wc) - 1; _Wf < 0 ? _We >= _Wd : _We <= _Wd; _We += _Wf) { /*20067*/
					var _Wh = $get($1.sym, _We); /*20066*/
					var _Wi = $k[--$j]; /*20066*/
					$k[$j++] = _Wh; /*20066*/
					if ($eq(_Wi, _Wh)) { /*20066*/
						var _Wj = $k[--$j]; /*20066*/
						var _Wk = $k[--$j]; /*20066*/
						$k[$j++] = _Wk + 1; /*20066*/
						$k[$j++] = _Wj; /*20066*/
					} else { /*20066*/
						var _Wl = $k[--$j]; /*20066*/
						$k[$j++] = 1; /*20066*/
						$k[$j++] = _Wl; /*20066*/
					} /*20066*/
				} /*20066*/
				$j--; /*20068*/
				var _Wn = $counttomark() + 2; /*20069*/
				$astore($geti($1.rle, 0, _Wn - 2)); /*20069*/
				$1.evalfulln1n3(); /*20070*/
				$1.n3 = $k[--$j] + $1.n3; /*20070*/
				$1.n1 = $k[--$j] + $1.n1; /*20070*/
				$j--; /*20071*/
				$1.symrow = $geti($1.sym, $1.i * $1.size, $1.size); /*20074*/
				$k[$j++] = Infinity; /*20075*/
				$k[$j++] = 0; /*20078*/
				$k[$j++] = 0; /*20078*/
				$forall($1.symrow, function() { /*20078*/
					var _Wz = $k[--$j]; /*20077*/
					var _X0 = $k[--$j]; /*20077*/
					$k[$j++] = _Wz; /*20077*/
					if ($eq(_X0, _Wz)) { /*20077*/
						var _X1 = $k[--$j]; /*20077*/
						var _X2 = $k[--$j]; /*20077*/
						$k[$j++] = _X2 + 1; /*20077*/
						$k[$j++] = _X1; /*20077*/
					} else { /*20077*/
						var _X3 = $k[--$j]; /*20077*/
						$k[$j++] = 1; /*20077*/
						$k[$j++] = _X3; /*20077*/
					} /*20077*/
				}); /*20077*/
				$j--; /*20079*/
				var _X5 = $counttomark() + 2; /*20080*/
				$astore($geti($1.rle, 0, _X5 - 2)); /*20080*/
				$1.evalfulln1n3(); /*20081*/
				$1.n3 = $k[--$j] + $1.n3; /*20081*/
				$1.n1 = $k[--$j] + $1.n1; /*20081*/
				$j--; /*20082*/
			} /*20082*/
			$k[$j++] = $1.n1 + $1.n3; /*20086*/
		}; /*20087*/
		$1.bestscore = 999999999; /*20090*/
		for (var _XF = 0, _XE = $1.masks.length - 1; _XF <= _XE; _XF += 1) { /*20108*/
			$1.m = _XF; /*20092*/
			$1.masksym = $a($1.size * $1.size); /*20093*/
			for (var _XM = 0, _XL = ($1.size * $1.size) - 1; _XM <= _XL; _XM += 1) { /*20097*/
				$1.i = _XM; /*20095*/
				$put($1.masksym, $1.i, $xo($get($1.pixs, $1.i), $get($get($1.masks, $1.m), $1.i))); /*20096*/
			} /*20096*/
			if ($1.masks.length != 1) { /*20106*/
				$k[$j++] = $1.masksym; /*20099*/
				$1.evalfull(); /*20099*/
				$1.score = $k[--$j]; /*20099*/
				if ($1.score < $1.bestscore) { /*20104*/
					$1.bestsym = $1.masksym; /*20101*/
					$1.bestmaskval = $1.m; /*20102*/
					$1.bestscore = $1.score; /*20103*/
				} /*20103*/
			} else { /*20106*/
				$1.bestsym = $1.masksym; /*20106*/
			} /*20106*/
		} /*20106*/
		$1.pixs = $1.bestsym; /*20109*/
		$1.funval = (((((~~(($1.size - 21) / 2)) + 20) * 4) + $1.eclval) * 4) + $1.bestmaskval; /*20112*/
		$k[$j++] = $a([($1.funval & 3840) >>> 8, ($1.funval & 240) >>> 4, $1.funval & 15]); /*20116*/
		$k[$j++] = 4; /*20116*/
		$k[$j++] = 16; /*20116*/
		$k[$j++] = 19; /*20116*/
		$1.rscodes(); /*20116*/
		$1.funvals = $k[--$j]; /*20116*/
		$k[$j++] = Infinity; /*20122*/
		$forall($1.funvals, function() { /*20120*/
			$k[$j++] = 4; /*20119*/
			$1.tobin(); /*20119*/
			$forall($k[--$j], function() { /*20119*/
				var _Xr = $k[--$j]; /*20119*/
				$k[$j++] = _Xr - 48; /*20119*/
			}); /*20119*/
		}); /*20119*/
		$k[$j++] = 0; /*20121*/
		$k[$j++] = 1; /*20121*/
		$k[$j++] = 0; /*20121*/
		$k[$j++] = 1; /*20121*/
		$k[$j++] = 0; /*20121*/
		$k[$j++] = 1; /*20121*/
		$1.funbits = $a(); /*20122*/
		for (var _Xv = 0, _Xu = $1.functionmap.length - 1; _Xv <= _Xu; _Xv += 1) { /*20128*/
			$1.i = _Xv; /*20124*/
			$forall($get($1.functionmap, $1.i), function() { /*20127*/
				var _Y0 = $k[--$j]; /*20126*/
				$k[$j++] = $1.pixs; /*20126*/
				$aload(_Y0); /*20126*/
				$1.qmv(); /*20126*/
				var _Y4 = $k[--$j]; /*20126*/
				$put($k[--$j], _Y4, $get($1.funbits, $1.i)); /*20126*/
			}); /*20126*/
		} /*20126*/
		var _YC = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.size,
			pixy: $1.size,
			height: ($1.size * 2) / 72,
			width: ($1.size * 2) / 72,
			opt: $1.options
		}; /*20138*/
		$k[$j++] = _YC; /*20141*/
		if (!$1.dontdraw) { /*20141*/
			$0.renmatrix(); /*20141*/
		} /*20141*/
	};
	$0["gs1-cc"] = function() {
		var $1 = {}; /*20170*/
		$1.options = $k[--$j]; /*20172*/
		$1.barcode = $k[--$j]; /*20173*/
		$1.dontdraw = false; /*20175*/
		$1.ccversion = "a"; /*20176*/
		$1.cccolumns = -1; /*20177*/
		$1.lintype = ""; /*20178*/
		$1.linwidth = -1; /*20179*/
		$forall($1.options, function() { /*20190*/
			var _3 = $k[--$j]; /*20190*/
			$1[$k[--$j]] = _3; /*20190*/
		}); /*20190*/
		$1.cccolumns = ~~$1.cccolumns; /*20192*/
		$1.linwidth = ~~$1.linwidth; /*20193*/
		if ($1.cccolumns == -1) { /*20212*/
			$k[$j++] = Infinity; /*20210*/
			$k[$j++] = "ean13"; /*20203*/
			$k[$j++] = 4; /*20203*/
			$k[$j++] = "upca"; /*20203*/
			$k[$j++] = 4; /*20203*/
			$k[$j++] = "ean8"; /*20203*/
			$k[$j++] = 3; /*20203*/
			$k[$j++] = "upce"; /*20203*/
			$k[$j++] = 2; /*20203*/
			$k[$j++] = "gs1-128"; /*20203*/
			if ($ne($1.ccversion, "c")) { /*20203*/
				$k[$j++] = 4; /*20203*/
			} else { /*20203*/
				$k[$j++] = ~~(($1.linwidth - 52) / 17); /*20203*/
			} /*20203*/
			$k[$j++] = "databaromni"; /*20210*/
			$k[$j++] = 4; /*20210*/
			$k[$j++] = "databarstacked"; /*20210*/
			$k[$j++] = 2; /*20210*/
			$k[$j++] = "databarstackedomni"; /*20210*/
			$k[$j++] = 2; /*20210*/
			$k[$j++] = "databartruncated"; /*20210*/
			$k[$j++] = 4; /*20210*/
			$k[$j++] = "databarlimited"; /*20210*/
			$k[$j++] = 3; /*20210*/
			$k[$j++] = "databarexpanded"; /*20210*/
			$k[$j++] = 4; /*20210*/
			$k[$j++] = "databarexpandedstacked"; /*20210*/
			$k[$j++] = 4; /*20210*/
			$1.cccolumns = $get($d(), $1.lintype); /*20211*/
		} /*20211*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*20216*/
			$1.out = $s($1.in.length); /*20217*/
			$1.j = 0; /*20218*/
			$k[$j++] = $1.in; /*20232*/
			for (;;) { /*20232*/
				$search($k[--$j], "^"); /*20221*/
				if ($k[--$j]) { /*20230*/
					var _J = $k[--$j]; /*20222*/
					$puti($1.out, $1.j, _J); /*20222*/
					$1.j = (_J.length + $1.j) + 1; /*20223*/
					$j--; /*20224*/
					var _N = $k[--$j]; /*20225*/
					$put($1.out, $1.j - 1, ~~$z($geti(_N, 0, 3))); /*20225*/
					$k[$j++] = $geti(_N, 3, _N.length - 3); /*20226*/
				} else { /*20230*/
					var _S = $k[--$j]; /*20228*/
					$puti($1.out, $1.j, _S); /*20228*/
					$1.j = _S.length + $1.j; /*20229*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*20230*/
					break; /*20230*/
				} /*20230*/
			} /*20230*/
		}; /*20233*/
		$1.ais = $a([]); /*20236*/
		$1.aival = {}; /*20237*/
		var _a = $1.barcode; /*20238*/
		$k[$j++] = $geti(_a, 1, _a.length - 1); /*20250*/
		for (;;) { /*20250*/
			var _c = $k[--$j]; /*20240*/
			$k[$j++] = _c; /*20240*/
			if ($eq(_c, "")) { /*20240*/
				break; /*20240*/
			} /*20240*/
			$search($k[--$j], ")"); /*20241*/
			$j--; /*20241*/
			var _e = $k[--$j]; /*20242*/
			var _f = $k[--$j]; /*20242*/
			var _g = $k[--$j]; /*20243*/
			$k[$j++] = _e; /*20243*/
			$search(_g, "("); /*20243*/
			if ($k[--$j]) { /*20246*/
				var _i = $k[--$j]; /*20244*/
				var _j = $k[--$j]; /*20244*/
				var _k = $k[--$j]; /*20244*/
				var _l = $k[--$j]; /*20244*/
				$k[$j++] = _k; /*20244*/
				$k[$j++] = _l; /*20244*/
				$k[$j++] = _i; /*20244*/
			} else { /*20246*/
				var _m = $k[--$j]; /*20246*/
				var _n = $k[--$j]; /*20246*/
				$k[$j++] = ""; /*20246*/
				$k[$j++] = _n; /*20246*/
				$k[$j++] = _m; /*20246*/
			} /*20246*/
			$k[$j++] = Infinity; /*20248*/
			$aload($1.ais); /*20248*/
			var _q = $k[$j - 1 - ($counttomark() + 2)]; /*20248*/
			$k[$j++] = _q; /*20248*/
			$1.ais = $a(); /*20248*/
			var _t = $k[--$j]; /*20249*/
			var _u = $k[--$j]; /*20249*/
			$k[$j++] = $1.aival; /*20249*/
			$k[$j++] = _u; /*20249*/
			$k[$j++] = _t; /*20249*/
			$1.expand(); /*20249*/
			var _v = $k[--$j]; /*20249*/
			var _w = $k[--$j]; /*20249*/
			$put($k[--$j], _w, _v); /*20249*/
		} /*20249*/
		$j--; /*20251*/
		$1.isupper = function() {
			var _y = $k[--$j]; /*20254*/
			$k[$j++] = (_y >= 65) && (_y <= 90); /*20254*/
		}; /*20254*/
		$1.isnum0 = function() {
			var _z = $k[--$j]; /*20255*/
			$k[$j++] = (_z >= 48) && (_z <= 57); /*20255*/
		}; /*20255*/
		$1.isnum1 = function() {
			var _10 = $k[--$j]; /*20256*/
			$k[$j++] = (_10 >= 49) && (_10 <= 57); /*20256*/
		}; /*20256*/
		for (;;) { /*20302*/
			if ($1.ais.length >= 1) { /*20264*/
				if (($eq($get($1.ais, 0), "10") || $eq($get($1.ais, 0), "11")) || $eq($get($1.ais, 0), "17")) { /*20263*/
					$k[$j++] = -1; /*20262*/
					$k[$j++] = "10"; /*20262*/
					break; /*20262*/
				} /*20262*/
			} /*20262*/
			if ($1.ais.length >= 1) { /*20297*/
				if ($eq($get($1.ais, 0), "90")) { /*20296*/
					$1.v = $1.aival["90"]; /*20269*/
					if ($1.v.length >= 1) { /*20274*/
						$k[$j++] = $get($1.v, 0); /*20271*/
						$1.isupper(); /*20271*/
						if ($k[--$j]) { /*20273*/
							$k[$j++] = 0; /*20272*/
							$k[$j++] = "11"; /*20272*/
							break; /*20272*/
						} /*20272*/
					} /*20272*/
					if ($1.v.length >= 2) { /*20280*/
						$k[$j++] = $get($1.v, 0); /*20276*/
						$1.isnum1(); /*20276*/
						$k[$j++] = $get($1.v, 1); /*20277*/
						$1.isupper(); /*20277*/
						var _1M = $k[--$j]; /*20277*/
						if (($k[--$j] && _1M)) { /*20279*/
							$k[$j++] = 1; /*20278*/
							$k[$j++] = "11"; /*20278*/
							break; /*20278*/
						} /*20278*/
					} /*20278*/
					if ($1.v.length >= 3) { /*20287*/
						$k[$j++] = $get($1.v, 0); /*20282*/
						$1.isnum1(); /*20282*/
						$k[$j++] = $get($1.v, 1); /*20283*/
						$1.isnum0(); /*20283*/
						var _1T = $k[--$j]; /*20283*/
						var _1U = $k[--$j]; /*20283*/
						$k[$j++] = $an(_1U, _1T); /*20284*/
						$k[$j++] = $get($1.v, 2); /*20284*/
						$1.isupper(); /*20284*/
						var _1X = $k[--$j]; /*20284*/
						if (($k[--$j] && _1X)) { /*20286*/
							$k[$j++] = 2; /*20285*/
							$k[$j++] = "11"; /*20285*/
							break; /*20285*/
						} /*20285*/
					} /*20285*/
					if ($1.v.length >= 4) { /*20295*/
						$k[$j++] = $get($1.v, 0); /*20289*/
						$1.isnum1(); /*20289*/
						$k[$j++] = $get($1.v, 1); /*20290*/
						$1.isnum0(); /*20290*/
						var _1e = $k[--$j]; /*20290*/
						var _1f = $k[--$j]; /*20290*/
						$k[$j++] = $an(_1f, _1e); /*20291*/
						$k[$j++] = $get($1.v, 2); /*20291*/
						$1.isnum0(); /*20291*/
						var _1i = $k[--$j]; /*20291*/
						var _1j = $k[--$j]; /*20291*/
						$k[$j++] = $an(_1j, _1i); /*20292*/
						$k[$j++] = $get($1.v, 3); /*20292*/
						$1.isupper(); /*20292*/
						var _1m = $k[--$j]; /*20292*/
						if (($k[--$j] && _1m)) { /*20294*/
							$k[$j++] = 3; /*20293*/
							$k[$j++] = "11"; /*20293*/
							break; /*20293*/
						} /*20293*/
					} /*20293*/
				} /*20293*/
			} /*20293*/
			$k[$j++] = -1; /*20300*/
			$k[$j++] = "0"; /*20300*/
			break; /*20300*/
		} /*20300*/
		$1.method = $k[--$j]; /*20303*/
		$1.npre = $k[--$j]; /*20304*/
		$1.fnc1 = -1; /*20306*/
		$1.lnumeric = -2; /*20306*/
		$1.lalphanumeric = -3; /*20306*/
		$1.liso646 = -4; /*20306*/
		$1.tobin = function() {
			var _1r = $s($k[--$j]); /*20309*/
			$k[$j++] = _1r; /*20309*/
			for (var _1t = 0, _1s = _1r.length - 1; _1t <= _1s; _1t += 1) { /*20309*/
				var _1u = $k[--$j]; /*20309*/
				$put(_1u, _1t, 48); /*20309*/
				$k[$j++] = _1u; /*20309*/
			} /*20309*/
			var _1v = $k[--$j]; /*20310*/
			var _1y = $cvrs($s(_1v.length), $k[--$j], 2); /*20310*/
			$puti(_1v, _1v.length - _1y.length, _1y); /*20310*/
			$k[$j++] = _1v; /*20310*/
		}; /*20311*/
		$k[$j++] = "alpha"; /*20316*/
		$k[$j++] = Infinity; /*20316*/
		for (var _1z = 65; _1z <= 90; _1z += 1) { /*20314*/
			$k[$j++] = _1z; /*20314*/
			$k[$j++] = _1z - 65; /*20314*/
			$k[$j++] = 5; /*20314*/
			$1.tobin(); /*20314*/
		} /*20314*/
		for (var _20 = 48; _20 <= 57; _20 += 1) { /*20315*/
			$k[$j++] = _20; /*20315*/
			$k[$j++] = _20 + 4; /*20315*/
			$k[$j++] = 6; /*20315*/
			$1.tobin(); /*20315*/
		} /*20315*/
		$k[$j++] = $1.fnc1; /*20316*/
		$k[$j++] = "11111"; /*20316*/
		var _22 = $d(); /*20316*/
		$1[$k[--$j]] = _22; /*20317*/
		$k[$j++] = "numeric"; /*20329*/
		$k[$j++] = Infinity; /*20329*/
		for (var _24 = 0; _24 <= 119; _24 += 1) { /*20328*/
			var _26 = $strcpy($s(2), "00"); /*20321*/
			var _28 = $cvrs($s(2), _24, 11); /*20321*/
			$puti(_26, 2 - _28.length, _28); /*20322*/
			$k[$j++] = _24; /*20323*/
			$k[$j++] = _26; /*20323*/
			if ($get(_26, 0) == 65) { /*20323*/
				var _2A = $k[--$j]; /*20323*/
				$put(_2A, 0, 94); /*20323*/
				$k[$j++] = _2A; /*20323*/
			} /*20323*/
			var _2B = $k[--$j]; /*20324*/
			$k[$j++] = _2B; /*20324*/
			if ($get(_2B, 1) == 65) { /*20324*/
				var _2D = $k[--$j]; /*20324*/
				$put(_2D, 1, 94); /*20324*/
				$k[$j++] = _2D; /*20324*/
			} /*20324*/
			var _2E = $k[--$j]; /*20325*/
			var _2H = $strcpy($s(7), "0000000"); /*20326*/
			var _2J = $cvrs($s(7), $k[--$j] + 8, 2); /*20326*/
			$puti(_2H, 7 - _2J.length, _2J); /*20327*/
			$k[$j++] = _2E; /*20327*/
			$k[$j++] = _2H; /*20327*/
		} /*20327*/
		$k[$j++] = $1.lalphanumeric; /*20329*/
		$k[$j++] = "0000"; /*20329*/
		var _2L = $d(); /*20329*/
		$1[$k[--$j]] = _2L; /*20330*/
		$k[$j++] = "alphanumeric"; /*20339*/
		$k[$j++] = Infinity; /*20339*/
		for (var _2N = 48; _2N <= 57; _2N += 1) { /*20333*/
			$k[$j++] = _2N; /*20333*/
			$k[$j++] = _2N - 43; /*20333*/
			$k[$j++] = 5; /*20333*/
			$1.tobin(); /*20333*/
		} /*20333*/
		$k[$j++] = $1.fnc1; /*20335*/
		$k[$j++] = "01111"; /*20335*/
		for (var _2P = 65; _2P <= 90; _2P += 1) { /*20335*/
			$k[$j++] = _2P; /*20335*/
			$k[$j++] = _2P - 33; /*20335*/
			$k[$j++] = 6; /*20335*/
			$1.tobin(); /*20335*/
		} /*20335*/
		$k[$j++] = 42; /*20337*/
		$k[$j++] = "111010"; /*20337*/
		for (var _2Q = 44; _2Q <= 47; _2Q += 1) { /*20337*/
			$k[$j++] = _2Q; /*20337*/
			$k[$j++] = _2Q + 15; /*20337*/
			$k[$j++] = 6; /*20337*/
			$1.tobin(); /*20337*/
		} /*20337*/
		$k[$j++] = $1.lnumeric; /*20339*/
		$k[$j++] = "000"; /*20339*/
		$k[$j++] = $1.liso646; /*20339*/
		$k[$j++] = "00100"; /*20339*/
		var _2T = $d(); /*20339*/
		$1[$k[--$j]] = _2T; /*20340*/
		$k[$j++] = "iso646"; /*20354*/
		$k[$j++] = Infinity; /*20354*/
		for (var _2V = 48; _2V <= 57; _2V += 1) { /*20343*/
			$k[$j++] = _2V; /*20343*/
			$k[$j++] = _2V - 43; /*20343*/
			$k[$j++] = 5; /*20343*/
			$1.tobin(); /*20343*/
		} /*20343*/
		$k[$j++] = $1.fnc1; /*20345*/
		$k[$j++] = "01111"; /*20345*/
		for (var _2X = 65; _2X <= 90; _2X += 1) { /*20345*/
			$k[$j++] = _2X; /*20345*/
			$k[$j++] = _2X - 1; /*20345*/
			$k[$j++] = 7; /*20345*/
			$1.tobin(); /*20345*/
		} /*20345*/
		for (var _2Y = 97; _2Y <= 122; _2Y += 1) { /*20346*/
			$k[$j++] = _2Y; /*20346*/
			$k[$j++] = _2Y - 7; /*20346*/
			$k[$j++] = 7; /*20346*/
			$1.tobin(); /*20346*/
		} /*20346*/
		$k[$j++] = 33; /*20349*/
		$k[$j++] = "11101000"; /*20349*/
		$k[$j++] = 34; /*20349*/
		$k[$j++] = "11101001"; /*20349*/
		for (var _2Z = 37; _2Z <= 47; _2Z += 1) { /*20349*/
			$k[$j++] = _2Z; /*20349*/
			$k[$j++] = _2Z + 197; /*20349*/
			$k[$j++] = 8; /*20349*/
			$1.tobin(); /*20349*/
		} /*20349*/
		for (var _2a = 58; _2a <= 63; _2a += 1) { /*20350*/
			$k[$j++] = _2a; /*20350*/
			$k[$j++] = _2a + 187; /*20350*/
			$k[$j++] = 8; /*20350*/
			$1.tobin(); /*20350*/
		} /*20350*/
		$k[$j++] = 95; /*20354*/
		$k[$j++] = "11111011"; /*20354*/
		$k[$j++] = 32; /*20354*/
		$k[$j++] = "11111100"; /*20354*/
		$k[$j++] = $1.lnumeric; /*20354*/
		$k[$j++] = "000"; /*20354*/
		$k[$j++] = $1.lalphanumeric; /*20354*/
		$k[$j++] = "00100"; /*20354*/
		var _2d = $d(); /*20354*/
		$1[$k[--$j]] = _2d; /*20355*/
		if ($eq($1.method, "10")) { /*20386*/
			if ($eq($get($1.ais, 0), "11") || $eq($get($1.ais, 0), "17")) { /*20371*/
				var _2n = $get($1.aival, $get($1.ais, 0)); /*20359*/
				var _2s = $strcpy($s(16), "0000000000000000"); /*20363*/
				var _2u = $cvrs($s(16), ((~~$z($geti(_2n, 0, 2))) * 384) + ((((~~$z($geti(_2n, 2, 2))) - 1) * 32) + (~~$z($geti(_2n, 4, 2)))), 2); /*20363*/
				$puti(_2s, 16 - _2u.length, _2u); /*20364*/
				$k[$j++] = _2s; /*20367*/
				$k[$j++] = Infinity; /*20367*/
				var _2v = $k[--$j]; /*20366*/
				var _2w = $k[--$j]; /*20366*/
				$k[$j++] = _2v; /*20366*/
				$k[$j++] = 1; /*20366*/
				$k[$j++] = 0; /*20366*/
				$forall(_2w, function() { /*20366*/
					var _2x = $k[--$j]; /*20366*/
					$k[$j++] = _2x - 48; /*20366*/
				}); /*20366*/
				var _30 = $eq($get($1.ais, 0), "11") ? 0 : 1; /*20367*/
				$k[$j++] = _30; /*20367*/
				$1.cdf = $a(); /*20368*/
				$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*20369*/
			} else { /*20371*/
				$1.cdf = $a([1, 0, 1, 1]); /*20371*/
			} /*20371*/
			if ($1.ais.length != 0) { /*20383*/
				if ($eq($get($1.ais, 0), "10")) { /*20379*/
					$k[$j++] = Infinity; /*20375*/
					$forall($1.aival["10"]); /*20375*/
					$1.gpf = $a(); /*20375*/
					if ($1.ais.length > 1) { /*20376*/
						$k[$j++] = Infinity; /*20376*/
						$aload($1.gpf); /*20376*/
						$k[$j++] = $1.fnc1; /*20376*/
						$1.gpf = $a(); /*20376*/
					} /*20376*/
					$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*20377*/
				} else { /*20379*/
					$1.gpf = $a([$1.fnc1]); /*20379*/
				} /*20379*/
			} else { /*20383*/
				$k[$j++] = Infinity; /*20382*/
				$aload($1.cdf); /*20382*/
				$k[$j++] = 0; /*20382*/
				$k[$j++] = 0; /*20382*/
				$k[$j++] = 0; /*20382*/
				$k[$j++] = 0; /*20382*/
				$k[$j++] = 0; /*20382*/
				$k[$j++] = 1; /*20382*/
				$k[$j++] = 1; /*20382*/
				$k[$j++] = 1; /*20382*/
				$k[$j++] = 1; /*20382*/
				$1.cdf = $a(); /*20382*/
				$1.gpf = $a([]); /*20383*/
			} /*20383*/
			$1.mode = "numeric"; /*20385*/
		} /*20385*/
		if ($eq($1.method, "11")) { /*20476*/
			$1.cdf = $a([1, 1]); /*20389*/
			$1.ai90 = $1.aival["90"]; /*20390*/
			if (($1.npre + 1) != $1.ai90.length) { /*20394*/
				$k[$j++] = $geti($1.ai90, $1.npre + 1, ($1.ai90.length - $1.npre) - 1); /*20392*/
			} else { /*20394*/
				$k[$j++] = ""; /*20394*/
			} /*20394*/
			$1.ai90rem = $k[--$j]; /*20396*/
			$k[$j++] = "nalpha"; /*20397*/
			$k[$j++] = 0; /*20397*/
			$forall($1.ai90rem, function() { /*20397*/
				var _3b = $k[--$j]; /*20397*/
				if ((_3b >= 65) && (_3b <= 90)) { /*20397*/
					var _3c = $k[--$j]; /*20397*/
					$k[$j++] = _3c + 1; /*20397*/
				} /*20397*/
			}); /*20397*/
			var _3d = $k[--$j]; /*20397*/
			$1[$k[--$j]] = _3d; /*20397*/
			$k[$j++] = "nnums"; /*20398*/
			$k[$j++] = 0; /*20398*/
			$forall($1.ai90rem, function() { /*20398*/
				var _3g = $k[--$j]; /*20398*/
				if ((_3g >= 48) && (_3g <= 57)) { /*20398*/
					var _3h = $k[--$j]; /*20398*/
					$k[$j++] = _3h + 1; /*20398*/
				} /*20398*/
			}); /*20398*/
			var _3i = $k[--$j]; /*20398*/
			$1[$k[--$j]] = _3i; /*20398*/
			$k[$j++] = "mode"; /*20399*/
			if ($gt($1.nalpha, $1.nnums)) { /*20399*/
				$k[$j++] = "alpha"; /*20399*/
			} else { /*20399*/
				$k[$j++] = "numeric"; /*20399*/
			} /*20399*/
			var _3m = $k[--$j]; /*20399*/
			$1[$k[--$j]] = _3m; /*20399*/
			if (($1.nalpha + $1.nnums) != $1.ai90rem.length) { /*20400*/
				$1.mode = "alphanumeric"; /*20400*/
			} /*20400*/
			$k[$j++] = Infinity; /*20406*/
			$aload($1.cdf); /*20402*/
			if ($eq($1.mode, "alphanumeric")) { /*20403*/
				$k[$j++] = 0; /*20403*/
			} /*20403*/
			if ($eq($1.mode, "numeric")) { /*20404*/
				$k[$j++] = 1; /*20404*/
				$k[$j++] = 0; /*20404*/
			} /*20404*/
			if ($eq($1.mode, "alpha")) { /*20405*/
				$k[$j++] = 1; /*20405*/
				$k[$j++] = 1; /*20405*/
			} /*20405*/
			$1.cdf = $a(); /*20406*/
			$k[$j++] = "ais1"; /*20407*/
			if ($1.ais.length > 1) { /*20407*/
				$k[$j++] = $get($1.ais, 1); /*20407*/
			} else { /*20407*/
				$k[$j++] = -1; /*20407*/
			} /*20407*/
			var _3z = $k[--$j]; /*20407*/
			$1[$k[--$j]] = _3z; /*20407*/
			if ($eq($1.ais1, "21") || $eq($1.ais1, "8004")) { /*20411*/
				$k[$j++] = Infinity; /*20409*/
				$aload($1.cdf); /*20409*/
				if ($eq($1.ais1, "21")) { /*20409*/
					$k[$j++] = 1; /*20409*/
					$k[$j++] = 0; /*20409*/
				} else { /*20409*/
					$k[$j++] = 1; /*20409*/
					$k[$j++] = 1; /*20409*/
				} /*20409*/
				$1.cdf = $a(); /*20409*/
			} else { /*20411*/
				$k[$j++] = Infinity; /*20411*/
				$aload($1.cdf); /*20411*/
				$k[$j++] = 0; /*20411*/
				$1.cdf = $a(); /*20411*/
			} /*20411*/
			$k[$j++] = "nval"; /*20413*/
			if ($1.npre != 0) { /*20413*/
				$k[$j++] = ~~$z($geti($1.ai90, 0, $1.npre)); /*20413*/
			} else { /*20413*/
				$k[$j++] = 0; /*20413*/
			} /*20413*/
			var _4C = $k[--$j]; /*20413*/
			$1[$k[--$j]] = _4C; /*20413*/
			$search("BDHIJKLNPQRSTVXZ", $geti($1.ai90, $1.npre, 1)); /*20414*/
			if ($k[--$j]) { /*20418*/
				var _4I = $k[--$j]; /*20415*/
				var _4J = $k[--$j]; /*20415*/
				var _4K = $k[--$j]; /*20415*/
				$1.aval = _4I.length; /*20416*/
			} else { /*20418*/
				$j--; /*20418*/
				$1.aval = -1; /*20418*/
			} /*20418*/
			if (($1.nval < 31) && ($1.aval != -1)) { /*20444*/
				var _4O = $strcpy($s(5), "00000"); /*20421*/
				var _4R = $cvrs($s(5), $1.nval, 2); /*20421*/
				$puti(_4O, 5 - _4R.length, _4R); /*20422*/
				$k[$j++] = _4O; /*20423*/
				$k[$j++] = Infinity; /*20423*/
				var _4S = $k[--$j]; /*20423*/
				var _4T = $k[--$j]; /*20423*/
				$k[$j++] = _4S; /*20423*/
				$forall(_4T, function() { /*20423*/
					var _4U = $k[--$j]; /*20423*/
					$k[$j++] = _4U - 48; /*20423*/
				}); /*20423*/
				$1.nbits = $a(); /*20423*/
				var _4X = $strcpy($s(4), "0000"); /*20424*/
				var _4a = $cvrs($s(4), $1.aval, 2); /*20424*/
				$puti(_4X, 4 - _4a.length, _4a); /*20425*/
				$k[$j++] = _4X; /*20426*/
				$k[$j++] = Infinity; /*20426*/
				var _4b = $k[--$j]; /*20426*/
				var _4c = $k[--$j]; /*20426*/
				$k[$j++] = _4b; /*20426*/
				$forall(_4c, function() { /*20426*/
					var _4d = $k[--$j]; /*20426*/
					$k[$j++] = _4d - 48; /*20426*/
				}); /*20426*/
				$1.abits = $a(); /*20426*/
				$k[$j++] = Infinity; /*20431*/
				$aload($1.cdf); /*20428*/
				$aload($1.nbits); /*20429*/
				$aload($1.abits); /*20430*/
				$1.cdf = $a(); /*20431*/
			} else { /*20444*/
				var _4k = $strcpy($s(10), "0000000000"); /*20433*/
				var _4n = $cvrs($s(10), $1.nval, 2); /*20433*/
				$puti(_4k, 10 - _4n.length, _4n); /*20434*/
				$k[$j++] = _4k; /*20435*/
				$k[$j++] = Infinity; /*20435*/
				var _4o = $k[--$j]; /*20435*/
				var _4p = $k[--$j]; /*20435*/
				$k[$j++] = _4o; /*20435*/
				$forall(_4p, function() { /*20435*/
					var _4q = $k[--$j]; /*20435*/
					$k[$j++] = _4q - 48; /*20435*/
				}); /*20435*/
				$1.nbits = $a(); /*20435*/
				var _4t = $strcpy($s(5), "00000"); /*20436*/
				var _4y = $cvrs($s(5), $get($1.ai90, $1.npre) - 65, 2); /*20436*/
				$puti(_4t, 5 - _4y.length, _4y); /*20437*/
				$k[$j++] = _4t; /*20438*/
				$k[$j++] = Infinity; /*20438*/
				var _4z = $k[--$j]; /*20438*/
				var _50 = $k[--$j]; /*20438*/
				$k[$j++] = _4z; /*20438*/
				$forall(_50, function() { /*20438*/
					var _51 = $k[--$j]; /*20438*/
					$k[$j++] = _51 - 48; /*20438*/
				}); /*20438*/
				$1.abits = $a(); /*20438*/
				$k[$j++] = Infinity; /*20444*/
				$aload($1.cdf); /*20440*/
				$k[$j++] = 1; /*20442*/
				$k[$j++] = 1; /*20442*/
				$k[$j++] = 1; /*20442*/
				$k[$j++] = 1; /*20442*/
				$k[$j++] = 1; /*20442*/
				$aload($1.nbits); /*20442*/
				$aload($1.abits); /*20443*/
				$1.cdf = $a(); /*20444*/
			} /*20444*/
			if ($eq($1.mode, "numeric")) { /*20463*/
				$k[$j++] = Infinity; /*20447*/
				$forall($1.ai90rem); /*20447*/
				if ($1.ais.length > 1) { /*20447*/
					$k[$j++] = $1.fnc1; /*20447*/
				} /*20447*/
				$1.gpf = $a(); /*20447*/
			} else { /*20463*/
				$k[$j++] = "encs"; /*20449*/
				if ($eq($1.mode, "alpha")) { /*20449*/
					$k[$j++] = $1.alpha; /*20449*/
				} else { /*20449*/
					$k[$j++] = $1.alphanumeric; /*20449*/
				} /*20449*/
				var _5F = $k[--$j]; /*20449*/
				$1[$k[--$j]] = _5F; /*20449*/
				$k[$j++] = Infinity; /*20450*/
				$forall($1.ai90rem); /*20450*/
				if ($1.ais.length > 1) { /*20450*/
					$k[$j++] = $1.fnc1; /*20450*/
				} /*20450*/
				$1.in = $a(); /*20450*/
				$1.out = $a($1.in.length * 6); /*20451*/
				$1.j = 0; /*20452*/
				for (var _5P = 0, _5O = $1.in.length - 1; _5P <= _5O; _5P += 1) { /*20457*/
					var _5T = $get($1.encs, $get($1.in, _5P)); /*20454*/
					$k[$j++] = _5T; /*20455*/
					$k[$j++] = _5T; /*20455*/
					$k[$j++] = Infinity; /*20455*/
					var _5U = $k[--$j]; /*20455*/
					var _5V = $k[--$j]; /*20455*/
					$k[$j++] = _5U; /*20455*/
					$forall(_5V, function() { /*20455*/
						var _5W = $k[--$j]; /*20455*/
						$k[$j++] = _5W - 48; /*20455*/
					}); /*20455*/
					$puti($1.out, $1.j, $a()); /*20455*/
					$1.j = $k[--$j].length + $1.j; /*20456*/
				} /*20456*/
				$k[$j++] = Infinity; /*20461*/
				$aload($1.cdf); /*20459*/
				$aload($geti($1.out, 0, $1.j)); /*20460*/
				$1.cdf = $a(); /*20461*/
				$1.gpf = $a([]); /*20462*/
				if (($1.ais.length > 1) || $ne($1.mode, "alpha")) { /*20463*/
					$1.mode = "numeric"; /*20463*/
				} /*20463*/
			} /*20463*/
			$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*20465*/
			if ($1.ais.length != 0) { /*20475*/
				if ($eq($1.ais1, "21") || $eq($1.ais1, "8004")) { /*20474*/
					$k[$j++] = Infinity; /*20471*/
					$aload($1.gpf); /*20469*/
					$forall($get($1.aival, $1.ais1)); /*20470*/
					$1.gpf = $a(); /*20471*/
					$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*20472*/
					if ($1.ais.length != 0) { /*20473*/
						$k[$j++] = Infinity; /*20473*/
						$aload($1.gpf); /*20473*/
						$k[$j++] = $1.fnc1; /*20473*/
						$1.gpf = $a(); /*20473*/
					} /*20473*/
				} /*20473*/
			} /*20473*/
		} /*20473*/
		if ($eq($1.method, "0")) { /*20482*/
			$1.cdf = $a([0]); /*20479*/
			$1.gpf = $a([]); /*20480*/
			$1.mode = "numeric"; /*20481*/
		} /*20481*/
		$1.aifixed = {}; /*20487*/
		$k[$j++] = Infinity; /*20489*/
		for (var _65 = 0; _65 <= 4; _65 += 1) { /*20489*/
			$k[$j++] = _65; /*20489*/
		} /*20489*/
		var _66 = $a(); /*20489*/
		for (var _67 = 0, _68 = _66.length; _67 < _68; _67++) { /*20492*/
			var _6B = $strcpy($s(2), "00"); /*20491*/
			$put(_6B, 1, $get(_66, _67) + 48); /*20491*/
			$put($1.aifixed, _6B, _6B); /*20491*/
		} /*20491*/
		$k[$j++] = Infinity; /*20497*/
		for (var _6D = 11; _6D <= 20; _6D += 1) { /*20494*/
			$k[$j++] = _6D; /*20494*/
		} /*20494*/
		$k[$j++] = 23; /*20496*/
		for (var _6E = 31; _6E <= 36; _6E += 1) { /*20496*/
			$k[$j++] = _6E; /*20496*/
		} /*20496*/
		$k[$j++] = 41; /*20497*/
		var _6F = $a(); /*20497*/
		for (var _6G = 0, _6H = _6F.length; _6G < _6H; _6G++) { /*20500*/
			var _6K = $cvrs($s(2), $get(_6F, _6G), 10); /*20499*/
			$put($1.aifixed, _6K, _6K); /*20499*/
		} /*20499*/
		for (var _6O = 0, _6N = $1.ais.length - 1; _6O <= _6N; _6O += 1) { /*20518*/
			$1.i = _6O; /*20504*/
			$1.ai = $get($1.ais, $1.i); /*20505*/
			$1.val = $get($1.aival, $1.ai); /*20506*/
			var _6Y = $a(($1.gpf.length + $1.ai.length) + $1.val.length); /*20507*/
			$puti(_6Y, 0, $1.gpf); /*20508*/
			$k[$j++] = _6Y; /*20509*/
			$k[$j++] = _6Y; /*20509*/
			$k[$j++] = $1.gpf.length; /*20509*/
			$k[$j++] = $1.ai; /*20509*/
			$k[$j++] = Infinity; /*20509*/
			var _6c = $k[--$j]; /*20509*/
			var _6d = $k[--$j]; /*20509*/
			$k[$j++] = _6c; /*20509*/
			$forall(_6d); /*20509*/
			var _6e = $a(); /*20509*/
			var _6f = $k[--$j]; /*20509*/
			$puti($k[--$j], _6f, _6e); /*20509*/
			var _6h = $k[--$j]; /*20510*/
			$k[$j++] = _6h; /*20510*/
			$k[$j++] = _6h; /*20510*/
			$k[$j++] = $1.gpf.length + $1.ai.length; /*20510*/
			$k[$j++] = $1.val; /*20510*/
			$k[$j++] = Infinity; /*20510*/
			var _6l = $k[--$j]; /*20510*/
			var _6m = $k[--$j]; /*20510*/
			$k[$j++] = _6l; /*20510*/
			$forall(_6m); /*20510*/
			var _6n = $a(); /*20510*/
			var _6o = $k[--$j]; /*20510*/
			$puti($k[--$j], _6o, _6n); /*20510*/
			$1.gpf = $k[--$j]; /*20511*/
			var _6w = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*20512*/
			if (($1.i != ($1.ais.length - 1)) && (!_6w)) { /*20517*/
				var _6y = $a($1.gpf.length + 1); /*20513*/
				$puti(_6y, 0, $1.gpf); /*20514*/
				$put(_6y, $1.gpf.length, $1.fnc1); /*20515*/
				$1.gpf = _6y; /*20516*/
			} /*20516*/
		} /*20516*/
		$1.rembits = function() {
			$1.used = $k[--$j]; /*20522*/
			if ($ne($1.ccversion, "c")) { /*20551*/
				var _7C = {
					a: $a([$a([167, 138, 118, 108, 88, 78, 59]), $a([167, 138, 118, 98, 78]), $a([197, 167, 138, 108, 78])]),
					b: $a([$a([336, 296, 256, 208, 160, 104, 56]), $a([768, 648, 536, 416, 304, 208, 152, 112, 72, 32]), $a([1184, 1016, 840, 672, 496, 352, 264, 208, 152, 96, 56])])
				}; /*20533*/
				$1.bitcaps = $get($get(_7C, $1.ccversion), $1.cccolumns - 2); /*20535*/
				$k[$j++] = -1; /*20536*/
				$forall($1.bitcaps, function() { /*20536*/
					var _7I = $k[--$j]; /*20536*/
					$k[$j++] = _7I; /*20536*/
					if ($ge(_7I, $1.used)) { /*20536*/
						var _7K = $k[--$j]; /*20536*/
						var _7L = $k[--$j]; /*20536*/
						$k[$j++] = _7K; /*20536*/
						$k[$j++] = _7L; /*20536*/
					} /*20536*/
					$j--; /*20536*/
				}); /*20536*/
				var _7M = $k[--$j]; /*20537*/
				$k[$j++] = _7M; /*20537*/
				if (_7M != -1) { /*20537*/
					var _7O = $k[--$j]; /*20537*/
					$k[$j++] = _7O - $1.used; /*20537*/
				} /*20537*/
			} else { /*20551*/
				var _7P = {
					c: -1
				}; /*20539*/
				var _7R = $get(_7P, $1.ccversion); /*20539*/
				var _7T = ~~Math.ceil($1.used / 8); /*20540*/
				$1.m = ((~~(_7T / 6)) * 5) + (_7T % 6); /*20540*/
				if ($1.m <= 40) { /*20541*/
					$k[$j++] = 8; /*20541*/
				} /*20541*/
				if (($1.m >= 41) && ($1.m <= 160)) { /*20542*/
					$k[$j++] = 16; /*20542*/
				} /*20542*/
				if (($1.m >= 161) && ($1.m <= 320)) { /*20543*/
					$k[$j++] = 32; /*20543*/
				} /*20543*/
				if ($1.m >= 321) { /*20544*/
					$k[$j++] = 64; /*20544*/
				} /*20544*/
				$1.eccws = $k[--$j]; /*20545*/
				$1.m = ($1.m + $1.eccws) + 3; /*20546*/
				$1.c = ~~(($1.linwidth - 52) / 17); /*20547*/
				if ((~~($1.m / $1.c)) > 90) { /*20548*/
					$1.c = $1.c + 1; /*20548*/
				} /*20548*/
				$1.r = ~~Math.ceil($1.m / $1.c); /*20549*/
				var _7m = (($1.c * $1.r) - $1.eccws) - 3; /*20550*/
				$1.tgt = (((~~(_7m / 5)) * 6) + (_7m % 5)) * 8; /*20550*/
				if ($1.used <= 8296) { /*20551*/
					$k[$j++] = $1.tgt - $1.used; /*20551*/
				} else { /*20551*/
					$k[$j++] = -1; /*20551*/
				} /*20551*/
			} /*20551*/
			var _7q = $k[--$j]; /*20553*/
			$k[$j++] = _7q; /*20566*/
			if (_7q == -1) { /*20566*/
				$j--; /*20554*/
				if ($eq($1.ccversion, "a")) { /*20562*/
					$1.ccversion = "b"; /*20556*/
				} else { /*20562*/
					if ($eq($1.ccversion, "b") && $eq($1.lintype, "gs1-128")) { /*20562*/
						$1.ccversion = "c"; /*20559*/
						$1.cccolumns = ~~(($1.linwidth - 52) / 17); /*20560*/
					} else { /*20562*/
						$1.ccversion = -1; /*20562*/
					} /*20562*/
				} /*20562*/
				$k[$j++] = $1.used; /*20565*/
				$1.rembits(); /*20565*/
			} /*20565*/
		}; /*20567*/
		$1.encode = function() {
			var _7w = $k[--$j]; /*20570*/
			$k[$j++] = _7w; /*20570*/
			if ($ne(_7w, "raw")) { /*20570*/
				var _7x = $k[--$j]; /*20570*/
				var _7z = $get(_7x, $k[--$j]); /*20570*/
				$k[$j++] = _7z; /*20570*/
			} else { /*20570*/
				$j--; /*20570*/
			} /*20570*/
			$k[$j++] = Infinity; /*20571*/
			var _80 = $k[--$j]; /*20571*/
			var _81 = $k[--$j]; /*20571*/
			$k[$j++] = _80; /*20571*/
			$forall(_81, function() { /*20571*/
				var _82 = $k[--$j]; /*20571*/
				$k[$j++] = _82 - 48; /*20571*/
			}); /*20571*/
			var _83 = $a(); /*20571*/
			$puti($1.gpfenc, $1.j, _83); /*20573*/
			$1.j = _83.length + $1.j; /*20574*/
		}; /*20575*/
		$k[$j++] = Infinity; /*20578*/
		for (var _88 = 0, _89 = $1.gpf.length; _88 < _89; _88++) { /*20578*/
			$k[$j++] = 0; /*20578*/
		} /*20578*/
		$k[$j++] = 0; /*20578*/
		$k[$j++] = -1; /*20578*/
		$1.numericruns = $a(); /*20578*/
		$k[$j++] = Infinity; /*20579*/
		for (var _8C = 0, _8D = $1.gpf.length; _8C < _8D; _8C++) { /*20579*/
			$k[$j++] = 0; /*20579*/
		} /*20579*/
		$k[$j++] = 0; /*20579*/
		$1.alphanumericruns = $a(); /*20579*/
		$k[$j++] = Infinity; /*20580*/
		for (var _8G = 0, _8H = $1.gpf.length; _8G < _8H; _8G++) { /*20580*/
			$k[$j++] = 0; /*20580*/
		} /*20580*/
		$k[$j++] = 9999; /*20580*/
		$1.nextiso646only = $a(); /*20580*/
		for (var _8K = $1.gpf.length - 1; _8K >= 0; _8K -= 1) { /*20602*/
			$1.i = _8K; /*20582*/
			var _8P = $strcpy($s(2), "00"); /*20584*/
			var _8S = $get($1.gpf, $1.i); /*20585*/
			$k[$j++] = $get($1.gpf, $1.i); /*20585*/
			$k[$j++] = _8P; /*20585*/
			$k[$j++] = _8P; /*20585*/
			$k[$j++] = 0; /*20585*/
			$k[$j++] = _8S; /*20585*/
			if (_8S == $1.fnc1) { /*20585*/
				$j--; /*20585*/
				$k[$j++] = 94; /*20585*/
			} /*20585*/
			var _8U = $k[--$j]; /*20585*/
			var _8V = $k[--$j]; /*20585*/
			$put($k[--$j], _8V, _8U); /*20585*/
			if ($1.i < ($1.gpf.length - 1)) { /*20586*/
				var _8Z = $k[--$j]; /*20586*/
				var _8c = $get($1.gpf, $1.i + 1); /*20586*/
				$k[$j++] = _8Z; /*20586*/
				$k[$j++] = _8Z; /*20586*/
				$k[$j++] = 1; /*20586*/
				$k[$j++] = _8c; /*20586*/
				if (_8c == $1.fnc1) { /*20586*/
					$j--; /*20586*/
					$k[$j++] = 94; /*20586*/
				} /*20586*/
				var _8e = $k[--$j]; /*20586*/
				var _8f = $k[--$j]; /*20586*/
				$put($k[--$j], _8f, _8e); /*20586*/
			} /*20586*/
			var _8j = $get($1.numeric, $k[--$j]) !== undefined; /*20587*/
			if (_8j) { /*20590*/
				$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 2) + 2); /*20588*/
			} else { /*20590*/
				$put($1.numericruns, $1.i, 0); /*20590*/
			} /*20590*/
			var _8r = $k[--$j]; /*20592*/
			var _8t = $get($1.alphanumeric, _8r) !== undefined; /*20592*/
			$k[$j++] = _8r; /*20596*/
			if (_8t) { /*20595*/
				$put($1.alphanumericruns, $1.i, $get($1.alphanumericruns, $1.i + 1) + 1); /*20593*/
			} else { /*20595*/
				$put($1.alphanumericruns, $1.i, 0); /*20595*/
			} /*20595*/
			var _91 = $k[--$j]; /*20597*/
			var _93 = $get($1.iso646, _91) !== undefined; /*20597*/
			var _95 = $get($1.alphanumeric, _91) !== undefined; /*20597*/
			if (_93 && (!_95)) { /*20600*/
				$put($1.nextiso646only, $1.i, 0); /*20598*/
			} else { /*20600*/
				$put($1.nextiso646only, $1.i, $get($1.nextiso646only, $1.i + 1) + 1); /*20600*/
			} /*20600*/
		} /*20600*/
		$1.gpfenc = $a(8296); /*20605*/
		$1.i = 0; /*20606*/
		$1.j = 0; /*20606*/
		for (;;) { /*20696*/
			if ($1.i == $1.gpf.length) { /*20608*/
				break; /*20608*/
			} /*20608*/
			for (;;) { /*20695*/
				if ($eq($1.mode, "numeric")) { /*20644*/
					if ($1.i <= ($1.gpf.length - 2)) { /*20641*/
						var _9J = $s(2); /*20613*/
						var _9M = $get($1.gpf, $1.i); /*20614*/
						$k[$j++] = _9J; /*20614*/
						$k[$j++] = _9J; /*20614*/
						$k[$j++] = 0; /*20614*/
						$k[$j++] = _9M; /*20614*/
						if (_9M == $1.fnc1) { /*20614*/
							$j--; /*20614*/
							$k[$j++] = 94; /*20614*/
						} /*20614*/
						var _9O = $k[--$j]; /*20614*/
						var _9P = $k[--$j]; /*20614*/
						$put($k[--$j], _9P, _9O); /*20614*/
						var _9R = $k[--$j]; /*20615*/
						var _9U = $get($1.gpf, $1.i + 1); /*20615*/
						$k[$j++] = _9R; /*20615*/
						$k[$j++] = _9R; /*20615*/
						$k[$j++] = 1; /*20615*/
						$k[$j++] = _9U; /*20615*/
						if (_9U == $1.fnc1) { /*20615*/
							$j--; /*20615*/
							$k[$j++] = 94; /*20615*/
						} /*20615*/
						var _9W = $k[--$j]; /*20615*/
						var _9X = $k[--$j]; /*20615*/
						$put($k[--$j], _9X, _9W); /*20615*/
						var _9Z = $k[--$j]; /*20616*/
						var _9b = $get($1.numeric, _9Z) !== undefined; /*20616*/
						$k[$j++] = _9Z; /*20620*/
						if (_9b) { /*20620*/
							$k[$j++] = $1.numeric; /*20617*/
							$1.encode(); /*20617*/
							$1.i = $1.i + 2; /*20618*/
							break; /*20619*/
						} /*20619*/
						$j--; /*20621*/
						$k[$j++] = $1.lalphanumeric; /*20622*/
						$k[$j++] = $1.numeric; /*20622*/
						$1.encode(); /*20622*/
						$1.mode = "alphanumeric"; /*20623*/
						break; /*20624*/
					} else { /*20641*/
						var _9i = $get($1.gpf, $1.i); /*20626*/
						if ((_9i < 48) || (_9i > 57)) { /*20630*/
							$k[$j++] = $1.lalphanumeric; /*20627*/
							$k[$j++] = $1.numeric; /*20627*/
							$1.encode(); /*20627*/
							$1.mode = "alphanumeric"; /*20628*/
							break; /*20629*/
						} /*20629*/
						$k[$j++] = "rem"; /*20631*/
						$k[$j++] = $1.cdf.length + $1.j; /*20631*/
						$1.rembits(); /*20631*/
						var _9n = $k[--$j]; /*20631*/
						$1[$k[--$j]] = _9n; /*20631*/
						if (($1.rem >= 4) && ($1.rem <= 6)) { /*20641*/
							var _9u = $geti($strcpy($s(6), "000000"), 0, $1.rem); /*20633*/
							var _9z = $cvrs($s(4), $get($1.gpf, $1.i) - 47, 2); /*20634*/
							$puti(_9u, 4 - _9z.length, _9z); /*20635*/
							$k[$j++] = _9u; /*20635*/
							$k[$j++] = "raw"; /*20635*/
							$1.encode(); /*20635*/
							$1.i = $1.i + 1; /*20636*/
							break; /*20637*/
						} else { /*20641*/
							var _A1 = $s(2); /*20639*/
							$put(_A1, 0, $get($1.gpf, $1.i)); /*20639*/
							$put(_A1, 1, 94); /*20639*/
							$k[$j++] = _A1; /*20639*/
							$k[$j++] = $1.numeric; /*20639*/
							$1.encode(); /*20639*/
							$1.i = $1.i + 1; /*20640*/
							break; /*20641*/
						} /*20641*/
					} /*20641*/
				} /*20641*/
				if ($eq($1.mode, "alphanumeric")) { /*20671*/
					if ($get($1.gpf, $1.i) == $1.fnc1) { /*20652*/
						$k[$j++] = $1.fnc1; /*20648*/
						$k[$j++] = $1.alphanumeric; /*20648*/
						$1.encode(); /*20648*/
						$1.mode = "numeric"; /*20649*/
						$1.i = $1.i + 1; /*20650*/
						break; /*20651*/
					} /*20651*/
					var _AH = $get($1.gpf, $1.i); /*20653*/
					var _AJ = $get($1.iso646, _AH) !== undefined; /*20653*/
					var _AL = $get($1.alphanumeric, _AH) !== undefined; /*20653*/
					if (_AJ && (!_AL)) { /*20657*/
						$k[$j++] = $1.liso646; /*20654*/
						$k[$j++] = $1.alphanumeric; /*20654*/
						$1.encode(); /*20654*/
						$1.mode = "iso646"; /*20655*/
						break; /*20656*/
					} /*20656*/
					if ($get($1.numericruns, $1.i) >= 6) { /*20662*/
						$k[$j++] = $1.lnumeric; /*20659*/
						$k[$j++] = $1.alphanumeric; /*20659*/
						$1.encode(); /*20659*/
						$1.mode = "numeric"; /*20660*/
						break; /*20661*/
					} /*20661*/
					var _AV = $get($1.numericruns, $1.i); /*20663*/
					if ((_AV >= 4) && ((_AV + $1.i) == $1.gpf.length)) { /*20667*/
						$k[$j++] = $1.lnumeric; /*20664*/
						$k[$j++] = $1.alphanumeric; /*20664*/
						$1.encode(); /*20664*/
						$1.mode = "numeric"; /*20665*/
						break; /*20666*/
					} /*20666*/
					$k[$j++] = $get($1.gpf, $1.i); /*20668*/
					$k[$j++] = $1.alphanumeric; /*20668*/
					$1.encode(); /*20668*/
					$1.i = $1.i + 1; /*20669*/
					break; /*20670*/
				} /*20670*/
				if ($eq($1.mode, "iso646")) { /*20693*/
					if ($get($1.gpf, $1.i) == $1.fnc1) { /*20679*/
						$k[$j++] = $1.fnc1; /*20675*/
						$k[$j++] = $1.iso646; /*20675*/
						$1.encode(); /*20675*/
						$1.mode = "numeric"; /*20676*/
						$1.i = $1.i + 1; /*20677*/
						break; /*20678*/
					} /*20678*/
					if (($get($1.numericruns, $1.i) >= 4) && ($get($1.nextiso646only, $1.i) >= 10)) { /*20684*/
						$k[$j++] = $1.lnumeric; /*20681*/
						$k[$j++] = $1.iso646; /*20681*/
						$1.encode(); /*20681*/
						$1.mode = "numeric"; /*20682*/
						break; /*20683*/
					} /*20683*/
					if (($get($1.alphanumericruns, $1.i) >= 5) && ($get($1.nextiso646only, $1.i) >= 10)) { /*20689*/
						$k[$j++] = $1.lalphanumeric; /*20686*/
						$k[$j++] = $1.iso646; /*20686*/
						$1.encode(); /*20686*/
						$1.mode = "alphanumeric"; /*20687*/
						break; /*20688*/
					} /*20688*/
					$k[$j++] = $get($1.gpf, $1.i); /*20690*/
					$k[$j++] = $1.iso646; /*20690*/
					$1.encode(); /*20690*/
					$1.i = $1.i + 1; /*20691*/
					break; /*20692*/
				} /*20692*/
			} /*20692*/
		} /*20692*/
		$1.gpf = $geti($1.gpfenc, 0, $1.j); /*20697*/
		$k[$j++] = "pad"; /*20700*/
		$k[$j++] = $1.cdf.length + $1.gpf.length; /*20700*/
		$1.rembits(); /*20700*/
		var _BE = $a($k[--$j]); /*20700*/
		$1[$k[--$j]] = _BE; /*20700*/
		if ($1.pad.length > 0) { /*20712*/
			for (var _BJ = 0, _BI = $1.pad.length - 1; _BJ <= _BI; _BJ += 5) { /*20705*/
				$1.i = _BJ; /*20703*/
				var _BK = $1.pad; /*20704*/
				var _BL = $1.i; /*20704*/
				var _BM = $a([0, 0, 1, 0, 0]); /*20704*/
				var _BN = $1.pad; /*20704*/
				var _BO = $1.i; /*20704*/
				var _BP = 5; /*20704*/
				var _BQ = _BN.length - _BO; /*20704*/
				if ((_BN.length - _BO) > 5) { /*20704*/
					var _ = _BP; /*20704*/
					_BP = _BQ; /*20704*/
					_BQ = _; /*20704*/
				} /*20704*/
				$puti(_BK, _BL, $geti(_BM, 0, _BQ)); /*20704*/
			} /*20704*/
			if ($eq($1.mode, "numeric")) { /*20708*/
				$k[$j++] = "pad"; /*20707*/
				$k[$j++] = Infinity; /*20707*/
				$k[$j++] = 0; /*20707*/
				$k[$j++] = 0; /*20707*/
				$k[$j++] = 0; /*20707*/
				$k[$j++] = 0; /*20707*/
				$aload($1.pad); /*20707*/
				var _BW = $geti($a(), 0, $1.pad.length); /*20707*/
				$1[$k[--$j]] = _BW; /*20707*/
			} /*20707*/
			if ($eq($1.mode, "alpha")) { /*20711*/
				$k[$j++] = "pad"; /*20710*/
				$k[$j++] = Infinity; /*20710*/
				$k[$j++] = 1; /*20710*/
				$k[$j++] = 1; /*20710*/
				$k[$j++] = 1; /*20710*/
				$k[$j++] = 1; /*20710*/
				$k[$j++] = 1; /*20710*/
				$aload($1.pad); /*20710*/
				var _Bc = $geti($a(), 0, $1.pad.length); /*20710*/
				$1[$k[--$j]] = _Bc; /*20710*/
			} /*20710*/
		} /*20710*/
		$k[$j++] = Infinity; /*20719*/
		$aload($1.cdf); /*20716*/
		$aload($1.gpf); /*20717*/
		$aload($1.pad); /*20718*/
		$1.bits = $a(); /*20719*/
		if ($1.ccversion == "a") { /*20774*/
			$k[$j++] = Infinity; /*20725*/
			$k[$j++] = $a([0, 0, 0, 0, 0, 0, 1]); /*20724*/
			for (var _Bk = 0, _Bl = 68; _Bk < _Bl; _Bk++) { /*20724*/
				$k[$j++] = $a(7); /*20724*/
			} /*20724*/
			$1.pwr928 = $a(); /*20725*/
			for (var _Bo = 1; _Bo <= 68; _Bo += 1) { /*20735*/
				$1.j = _Bo; /*20727*/
				$1.v = 0; /*20728*/
				for (var _Bp = 6; _Bp >= 1; _Bp -= 1) { /*20733*/
					$1.i = _Bp; /*20730*/
					$1.v = ($get($get($1.pwr928, $1.j - 1), $1.i) * 2) + (~~($1.v / 928)); /*20731*/
					$put($get($1.pwr928, $1.j), $1.i, $1.v % 928); /*20732*/
				} /*20732*/
				$put($get($1.pwr928, $1.j), 0, ($get($get($1.pwr928, $1.j - 1), 0) * 2) + (~~($1.v / 928))); /*20734*/
			} /*20734*/
			$k[$j++] = Infinity; /*20736*/
			for (var _C9 = 0, _CA = 28; _C9 < _CA; _C9++) { /*20736*/
				$k[$j++] = 0; /*20736*/
			} /*20736*/
			$1.cws = $a(); /*20736*/
			$1.b = 0; /*20737*/
			$1.c = 0; /*20737*/
			for (;;) { /*20761*/
				if ($1.b == $1.bits.length) { /*20739*/
					break; /*20739*/
				} /*20739*/
				var _CE = $1.bits; /*20740*/
				var _CF = $1.b; /*20740*/
				var _CG = $1.bits; /*20740*/
				var _CH = $1.b; /*20740*/
				var _CI = _CG.length - _CH; /*20740*/
				var _CJ = 69; /*20740*/
				if (69 > (_CG.length - _CH)) { /*20740*/
					var _ = _CI; /*20740*/
					_CI = _CJ; /*20740*/
					_CJ = _; /*20740*/
				} /*20740*/
				$1.bs = $geti(_CE, _CF, _CJ); /*20740*/
				$1.bsl = $1.bs.length; /*20741*/
				$1.cs = $geti($1.cws, $1.c, (~~($1.bsl / 10)) + 1); /*20742*/
				$1.csl = $1.cs.length; /*20743*/
				for (var _CT = 0, _CS = $1.bsl - 1; _CT <= _CS; _CT += 1) { /*20753*/
					$1.i = _CT; /*20745*/
					for (var _CW = 0, _CV = $1.csl - 1; _CW <= _CV; _CW += 1) { /*20752*/
						$1.j = _CW; /*20747*/
						var _CX = $1.cs; /*20748*/
						var _CY = $1.j; /*20748*/
						$put(_CX, _CY, $get(_CX, _CY) + ($get($get($1.pwr928, $1.i), ($1.j + 7) - $1.csl) * $get($1.bs, ($1.bsl - $1.i) - 1))); /*20751*/
					} /*20751*/
				} /*20751*/
				for (var _Cl = $1.csl - 1; _Cl >= 1; _Cl -= 1) { /*20758*/
					$1.i = _Cl; /*20755*/
					var _Cm = $1.cs; /*20756*/
					var _Cn = $1.i; /*20756*/
					$put(_Cm, _Cn - 1, $get(_Cm, _Cn - 1) + (~~($get($1.cs, $1.i) / 928))); /*20756*/
					var _Cs = $1.cs; /*20757*/
					var _Ct = $1.i; /*20757*/
					$put(_Cs, _Ct, $get(_Cs, _Ct) % 928); /*20757*/
				} /*20757*/
				$1.b = $1.b + $1.bsl; /*20759*/
				$1.c = $1.c + $1.csl; /*20760*/
			} /*20760*/
			$1.cws = $geti($1.cws, 0, $1.c); /*20762*/
			$1.barcode = $s($1.cws.length * 4); /*20763*/
			for (var _D6 = 0, _D5 = $1.cws.length - 1; _D6 <= _D5; _D6 += 1) { /*20769*/
				$1.i = _D6; /*20765*/
				var _D8 = $strcpy($s(4), "^   "); /*20766*/
				var _DD = $cvrs($s(4), $get($1.cws, $1.i), 10); /*20766*/
				$puti(_D8, 4 - _DD.length, _DD); /*20767*/
				$puti($1.barcode, $1.i * 4, _D8); /*20768*/
			} /*20768*/
			$1.options.dontdraw = true; /*20770*/
			$1.options.cca = true; /*20771*/
			$1.options.columns = $1.cccolumns; /*20772*/
			$k[$j++] = "args"; /*20773*/
			$k[$j++] = $1.barcode; /*20773*/
			$k[$j++] = $1.options; /*20773*/
			$0.micropdf417(); /*20773*/
			var _DM = $k[--$j]; /*20773*/
			$1[$k[--$j]] = _DM; /*20773*/
		} /*20773*/
		if ($1.ccversion == "b") { /*20787*/
			$1.barcode = $s(~~($1.bits.length / 8)); /*20777*/
			for (var _DT = 0, _DS = $1.barcode.length - 1; _DT <= _DS; _DT += 1) { /*20782*/
				$1.i = _DT; /*20779*/
				$k[$j++] = 0; /*20780*/
				$forall($geti($1.bits, $1.i * 8, 8), function() { /*20780*/
					var _DX = $k[--$j]; /*20780*/
					var _DY = $k[--$j]; /*20780*/
					$k[$j++] = (_DY + _DX) * 2; /*20780*/
				}); /*20780*/
				$put($1.barcode, $1.i, ~~($k[--$j] / 2)); /*20781*/
			} /*20781*/
			$1.options.dontdraw = true; /*20783*/
			$1.options.ccb = true; /*20784*/
			$1.options.columns = $1.cccolumns; /*20785*/
			$k[$j++] = "args"; /*20786*/
			$k[$j++] = $1.barcode; /*20786*/
			$k[$j++] = $1.options; /*20786*/
			$0.micropdf417(); /*20786*/
			var _Di = $k[--$j]; /*20786*/
			$1[$k[--$j]] = _Di; /*20786*/
		} /*20786*/
		if ($1.ccversion == "c") { /*20800*/
			$1.barcode = $s(~~($1.bits.length / 8)); /*20790*/
			for (var _Dp = 0, _Do = $1.barcode.length - 1; _Dp <= _Do; _Dp += 1) { /*20795*/
				$1.i = _Dp; /*20792*/
				$k[$j++] = 0; /*20793*/
				$forall($geti($1.bits, $1.i * 8, 8), function() { /*20793*/
					var _Dt = $k[--$j]; /*20793*/
					var _Du = $k[--$j]; /*20793*/
					$k[$j++] = (_Du + _Dt) * 2; /*20793*/
				}); /*20793*/
				$put($1.barcode, $1.i, ~~($k[--$j] / 2)); /*20794*/
			} /*20794*/
			$1.options.dontdraw = true; /*20796*/
			$1.options.ccc = true; /*20797*/
			$1.options.columns = $1.cccolumns; /*20798*/
			$k[$j++] = "args"; /*20799*/
			$k[$j++] = $1.barcode; /*20799*/
			$k[$j++] = $1.options; /*20799*/
			$0.pdf417(); /*20799*/
			var _E4 = $k[--$j]; /*20799*/
			$1[$k[--$j]] = _E4; /*20799*/
		} /*20799*/
		$k[$j++] = $1.args; /*20803*/
		if (!$1.dontdraw) { /*20803*/
			$0.renmatrix(); /*20803*/
		} /*20803*/
	};
	$0.ean13composite = function() {
		var $1 = {}; /*20833*/
		$1.options = $k[--$j]; /*20835*/
		$1.barcode = $k[--$j]; /*20836*/
		$1.dontdraw = false; /*20838*/
		$forall($1.options, function() { /*20849*/
			var _3 = $k[--$j]; /*20849*/
			$1[$k[--$j]] = _3; /*20849*/
		}); /*20849*/
		$search($1.barcode, "|"); /*20852*/
		if ($k[--$j]) { /*20857*/
			$1.linear = $k[--$j]; /*20853*/
			$j--; /*20854*/
			$1.comp = $k[--$j]; /*20855*/
		} else { /*20857*/
			$j--; /*20857*/
		} /*20857*/
		$$.save(); /*20860*/
		$1.options.lintype = "ean13"; /*20862*/
		$1.options.inkspread = "0"; /*20863*/
		$1.options.dontdraw = true; /*20864*/
		$k[$j++] = $1.linear; /*20867*/
		$k[$j++] = $1.options; /*20867*/
		$0.ean13(); /*20867*/
		$0.renlinear(); /*20867*/
		$$.rmoveto(-1, 72); /*20870*/
		$k[$j++] = Infinity; /*20881*/
		$k[$j++] = "ren"; /*20877*/
		$k[$j++] = $0.renmatrix; /*20877*/
		$k[$j++] = "pixs"; /*20877*/
		$k[$j++] = Infinity; /*20877*/
		$k[$j++] = 0; /*20873*/
		$k[$j++] = 1; /*20873*/
		for (var _E = 0, _F = 93; _E < _F; _E++) { /*20873*/
			$k[$j++] = 0; /*20873*/
		} /*20873*/
		$k[$j++] = 1; /*20874*/
		$k[$j++] = 0; /*20874*/
		$k[$j++] = 1; /*20874*/
		$k[$j++] = 0; /*20874*/
		for (var _G = 0, _H = 93; _G < _H; _G++) { /*20874*/
			$k[$j++] = 0; /*20874*/
		} /*20874*/
		$k[$j++] = 0; /*20875*/
		$k[$j++] = 1; /*20875*/
		$k[$j++] = 0; /*20875*/
		$k[$j++] = 1; /*20875*/
		for (var _I = 0, _J = 93; _I < _J; _I++) { /*20875*/
			$k[$j++] = 0; /*20875*/
		} /*20875*/
		$k[$j++] = 1; /*20875*/
		$k[$j++] = 0; /*20875*/
		var _K = $a(); /*20877*/
		$k[$j++] = _K; /*20881*/
		$k[$j++] = "pixx"; /*20881*/
		$k[$j++] = 97; /*20881*/
		$k[$j++] = "pixy"; /*20881*/
		$k[$j++] = 3; /*20881*/
		$k[$j++] = "height"; /*20881*/
		$k[$j++] = 6 / 72; /*20881*/
		$k[$j++] = "width"; /*20881*/
		$k[$j++] = 97 / 72; /*20881*/
		$k[$j++] = "opt"; /*20881*/
		$k[$j++] = $1.options; /*20881*/
		var _M = $d(); /*20881*/
		$k[$j++] = _M; /*20882*/
		$0.renmatrix(); /*20882*/
		$$.rmoveto(-2, 6); /*20885*/
		$k[$j++] = $1.comp; /*20885*/
		$k[$j++] = $1.options; /*20885*/
		$0["gs1-cc"](); /*20885*/
		$0.renmatrix(); /*20885*/
		$$.restore(); /*20887*/
	};
	$0.ean8composite = function() {
		var $1 = {}; /*20917*/
		$1.options = $k[--$j]; /*20919*/
		$1.barcode = $k[--$j]; /*20920*/
		$1.dontdraw = false; /*20922*/
		$forall($1.options, function() { /*20933*/
			var _3 = $k[--$j]; /*20933*/
			$1[$k[--$j]] = _3; /*20933*/
		}); /*20933*/
		$search($1.barcode, "|"); /*20936*/
		if ($k[--$j]) { /*20941*/
			$1.linear = $k[--$j]; /*20937*/
			$j--; /*20938*/
			$1.comp = $k[--$j]; /*20939*/
		} else { /*20941*/
			$j--; /*20941*/
		} /*20941*/
		$$.save(); /*20944*/
		$1.options.lintype = "ean8"; /*20947*/
		$1.options.inkspread = "0"; /*20948*/
		$1.options.dontdraw = true; /*20949*/
		$k[$j++] = $1.linear; /*20952*/
		$k[$j++] = $1.options; /*20952*/
		$0.ean8(); /*20952*/
		$0.renlinear(); /*20952*/
		$$.rmoveto(-1, 72); /*20955*/
		$k[$j++] = Infinity; /*20966*/
		$k[$j++] = "ren"; /*20962*/
		$k[$j++] = $0.renmatrix; /*20962*/
		$k[$j++] = "pixs"; /*20962*/
		$k[$j++] = Infinity; /*20962*/
		$k[$j++] = 0; /*20958*/
		$k[$j++] = 1; /*20958*/
		for (var _E = 0, _F = 65; _E < _F; _E++) { /*20958*/
			$k[$j++] = 0; /*20958*/
		} /*20958*/
		$k[$j++] = 1; /*20959*/
		$k[$j++] = 0; /*20959*/
		$k[$j++] = 1; /*20959*/
		$k[$j++] = 0; /*20959*/
		for (var _G = 0, _H = 65; _G < _H; _G++) { /*20959*/
			$k[$j++] = 0; /*20959*/
		} /*20959*/
		$k[$j++] = 0; /*20960*/
		$k[$j++] = 1; /*20960*/
		$k[$j++] = 0; /*20960*/
		$k[$j++] = 1; /*20960*/
		for (var _I = 0, _J = 65; _I < _J; _I++) { /*20960*/
			$k[$j++] = 0; /*20960*/
		} /*20960*/
		$k[$j++] = 1; /*20960*/
		$k[$j++] = 0; /*20960*/
		var _K = $a(); /*20962*/
		$k[$j++] = _K; /*20966*/
		$k[$j++] = "pixx"; /*20966*/
		$k[$j++] = 69; /*20966*/
		$k[$j++] = "pixy"; /*20966*/
		$k[$j++] = 3; /*20966*/
		$k[$j++] = "height"; /*20966*/
		$k[$j++] = 6 / 72; /*20966*/
		$k[$j++] = "width"; /*20966*/
		$k[$j++] = 69 / 72; /*20966*/
		$k[$j++] = "opt"; /*20966*/
		$k[$j++] = $1.options; /*20966*/
		var _M = $d(); /*20966*/
		$k[$j++] = _M; /*20967*/
		$0.renmatrix(); /*20967*/
		$k[$j++] = $1.comp; /*20970*/
		$k[$j++] = $1.options; /*20970*/
		$0["gs1-cc"](); /*20970*/
		var _P = $k[--$j]; /*20971*/
		$$.rmoveto(69 - _P.pixx, 6); /*20971*/
		$k[$j++] = _P; /*20972*/
		$0.renmatrix(); /*20972*/
		$$.restore(); /*20974*/
	};
	$0.upcacomposite = function() {
		var $1 = {}; /*21004*/
		$1.options = $k[--$j]; /*21006*/
		$1.barcode = $k[--$j]; /*21007*/
		$1.dontdraw = false; /*21009*/
		$forall($1.options, function() { /*21020*/
			var _3 = $k[--$j]; /*21020*/
			$1[$k[--$j]] = _3; /*21020*/
		}); /*21020*/
		$search($1.barcode, "|"); /*21023*/
		if ($k[--$j]) { /*21028*/
			$1.linear = $k[--$j]; /*21024*/
			$j--; /*21025*/
			$1.comp = $k[--$j]; /*21026*/
		} else { /*21028*/
			$j--; /*21028*/
		} /*21028*/
		$$.save(); /*21031*/
		$1.options.lintype = "ean13"; /*21033*/
		$1.options.inkspread = "0"; /*21034*/
		$1.options.dontdraw = true; /*21035*/
		$k[$j++] = $1.linear; /*21038*/
		$k[$j++] = $1.options; /*21038*/
		$0.upca(); /*21038*/
		$0.renlinear(); /*21038*/
		$$.rmoveto(-1, 72); /*21041*/
		$k[$j++] = Infinity; /*21052*/
		$k[$j++] = "ren"; /*21048*/
		$k[$j++] = $0.renmatrix; /*21048*/
		$k[$j++] = "pixs"; /*21048*/
		$k[$j++] = Infinity; /*21048*/
		$k[$j++] = 0; /*21044*/
		$k[$j++] = 1; /*21044*/
		for (var _E = 0, _F = 93; _E < _F; _E++) { /*21044*/
			$k[$j++] = 0; /*21044*/
		} /*21044*/
		$k[$j++] = 1; /*21045*/
		$k[$j++] = 0; /*21045*/
		$k[$j++] = 1; /*21045*/
		$k[$j++] = 0; /*21045*/
		for (var _G = 0, _H = 93; _G < _H; _G++) { /*21045*/
			$k[$j++] = 0; /*21045*/
		} /*21045*/
		$k[$j++] = 0; /*21046*/
		$k[$j++] = 1; /*21046*/
		$k[$j++] = 0; /*21046*/
		$k[$j++] = 1; /*21046*/
		for (var _I = 0, _J = 93; _I < _J; _I++) { /*21046*/
			$k[$j++] = 0; /*21046*/
		} /*21046*/
		$k[$j++] = 1; /*21046*/
		$k[$j++] = 0; /*21046*/
		var _K = $a(); /*21048*/
		$k[$j++] = _K; /*21052*/
		$k[$j++] = "pixx"; /*21052*/
		$k[$j++] = 97; /*21052*/
		$k[$j++] = "pixy"; /*21052*/
		$k[$j++] = 3; /*21052*/
		$k[$j++] = "height"; /*21052*/
		$k[$j++] = 6 / 72; /*21052*/
		$k[$j++] = "width"; /*21052*/
		$k[$j++] = 97 / 72; /*21052*/
		$k[$j++] = "opt"; /*21052*/
		$k[$j++] = $1.options; /*21052*/
		var _M = $d(); /*21052*/
		$k[$j++] = _M; /*21053*/
		$0.renmatrix(); /*21053*/
		$$.rmoveto(-2, 6); /*21056*/
		$k[$j++] = $1.comp; /*21056*/
		$k[$j++] = $1.options; /*21056*/
		$0["gs1-cc"](); /*21056*/
		$0.renmatrix(); /*21056*/
		$$.restore(); /*21058*/
	};
	$0.upcecomposite = function() {
		var $1 = {}; /*21088*/
		$1.options = $k[--$j]; /*21090*/
		$1.barcode = $k[--$j]; /*21091*/
		$1.dontdraw = false; /*21093*/
		$forall($1.options, function() { /*21104*/
			var _3 = $k[--$j]; /*21104*/
			$1[$k[--$j]] = _3; /*21104*/
		}); /*21104*/
		$search($1.barcode, "|"); /*21107*/
		if ($k[--$j]) { /*21112*/
			$1.linear = $k[--$j]; /*21108*/
			$j--; /*21109*/
			$1.comp = $k[--$j]; /*21110*/
		} else { /*21112*/
			$j--; /*21112*/
		} /*21112*/
		$k[$j++] = "sep"; /*21127*/
		$k[$j++] = Infinity; /*21127*/
		$k[$j++] = "ren"; /*21123*/
		$k[$j++] = $0.renmatrix; /*21123*/
		$k[$j++] = "pixs"; /*21123*/
		$k[$j++] = Infinity; /*21123*/
		$k[$j++] = 0; /*21119*/
		$k[$j++] = 1; /*21119*/
		for (var _9 = 0, _A = 49; _9 < _A; _9++) { /*21119*/
			$k[$j++] = 0; /*21119*/
		} /*21119*/
		$k[$j++] = 1; /*21120*/
		$k[$j++] = 0; /*21120*/
		$k[$j++] = 1; /*21120*/
		$k[$j++] = 0; /*21120*/
		for (var _B = 0, _C = 49; _B < _C; _B++) { /*21120*/
			$k[$j++] = 0; /*21120*/
		} /*21120*/
		$k[$j++] = 0; /*21121*/
		$k[$j++] = 1; /*21121*/
		$k[$j++] = 0; /*21121*/
		$k[$j++] = 1; /*21121*/
		for (var _D = 0, _E = 49; _D < _E; _D++) { /*21121*/
			$k[$j++] = 0; /*21121*/
		} /*21121*/
		$k[$j++] = 1; /*21121*/
		$k[$j++] = 0; /*21121*/
		var _F = $a(); /*21123*/
		$k[$j++] = _F; /*21127*/
		$k[$j++] = "pixx"; /*21127*/
		$k[$j++] = 53; /*21127*/
		$k[$j++] = "pixy"; /*21127*/
		$k[$j++] = 3; /*21127*/
		$k[$j++] = "height"; /*21127*/
		$k[$j++] = 6 / 72; /*21127*/
		$k[$j++] = "width"; /*21127*/
		$k[$j++] = 53 / 72; /*21127*/
		$k[$j++] = "opt"; /*21127*/
		$k[$j++] = $1.options; /*21127*/
		var _H = $d(); /*21127*/
		$1[$k[--$j]] = _H; /*21128*/
		$$.save(); /*21130*/
		$1.options.lintype = "upce"; /*21132*/
		$1.options.inkspread = "0"; /*21133*/
		$1.options.dontdraw = true; /*21134*/
		$k[$j++] = $1.linear; /*21137*/
		$k[$j++] = $1.options; /*21137*/
		$0.upce(); /*21137*/
		$0.renlinear(); /*21137*/
		$$.rmoveto(-1, 72); /*21140*/
		$k[$j++] = Infinity; /*21151*/
		$k[$j++] = "ren"; /*21147*/
		$k[$j++] = $0.renmatrix; /*21147*/
		$k[$j++] = "pixs"; /*21147*/
		$k[$j++] = Infinity; /*21147*/
		$k[$j++] = 0; /*21143*/
		$k[$j++] = 1; /*21143*/
		for (var _O = 0, _P = 49; _O < _P; _O++) { /*21143*/
			$k[$j++] = 0; /*21143*/
		} /*21143*/
		$k[$j++] = 1; /*21144*/
		$k[$j++] = 0; /*21144*/
		$k[$j++] = 1; /*21144*/
		$k[$j++] = 0; /*21144*/
		for (var _Q = 0, _R = 49; _Q < _R; _Q++) { /*21144*/
			$k[$j++] = 0; /*21144*/
		} /*21144*/
		$k[$j++] = 0; /*21145*/
		$k[$j++] = 1; /*21145*/
		$k[$j++] = 0; /*21145*/
		$k[$j++] = 1; /*21145*/
		for (var _S = 0, _T = 49; _S < _T; _S++) { /*21145*/
			$k[$j++] = 0; /*21145*/
		} /*21145*/
		$k[$j++] = 1; /*21145*/
		$k[$j++] = 0; /*21145*/
		var _U = $a(); /*21147*/
		$k[$j++] = _U; /*21151*/
		$k[$j++] = "pixx"; /*21151*/
		$k[$j++] = 53; /*21151*/
		$k[$j++] = "pixy"; /*21151*/
		$k[$j++] = 3; /*21151*/
		$k[$j++] = "height"; /*21151*/
		$k[$j++] = 6 / 72; /*21151*/
		$k[$j++] = "width"; /*21151*/
		$k[$j++] = 53 / 72; /*21151*/
		$k[$j++] = "opt"; /*21151*/
		$k[$j++] = $1.options; /*21151*/
		var _W = $d(); /*21151*/
		$k[$j++] = _W; /*21152*/
		$0.renmatrix(); /*21152*/
		$$.rmoveto(-2, 6); /*21155*/
		$k[$j++] = $1.comp; /*21155*/
		$k[$j++] = $1.options; /*21155*/
		$0["gs1-cc"](); /*21155*/
		$0.renmatrix(); /*21155*/
		$$.restore(); /*21157*/
	};
	$0.databaromnicomposite = function() {
		var $1 = {}; /*21187*/
		$1.options = $k[--$j]; /*21189*/
		$1.barcode = $k[--$j]; /*21190*/
		$1.dontdraw = false; /*21192*/
		$forall($1.options, function() { /*21203*/
			var _3 = $k[--$j]; /*21203*/
			$1[$k[--$j]] = _3; /*21203*/
		}); /*21203*/
		$search($1.barcode, "|"); /*21206*/
		if ($k[--$j]) { /*21211*/
			$1.linear = $k[--$j]; /*21207*/
			$j--; /*21208*/
			$1.comp = $k[--$j]; /*21209*/
		} else { /*21211*/
			$j--; /*21211*/
		} /*21211*/
		$$.save(); /*21214*/
		$1.options.lintype = "databaromni"; /*21216*/
		$1.options.linkage = true; /*21217*/
		$1.options.inkspread = "0"; /*21218*/
		$1.options.dontdraw = true; /*21219*/
		$k[$j++] = $1.linear; /*21222*/
		$k[$j++] = $1.options; /*21222*/
		$0.databaromni(); /*21222*/
		var _F = $k[--$j]; /*21223*/
		$1.linsbs = _F.sbs; /*21223*/
		$1.linheight = $get(_F.bhs, 0) * 72; /*21224*/
		$k[$j++] = _F; /*21225*/
		$0.renlinear(); /*21225*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*21229*/
			for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*21242*/
				$1.i = _N; /*21231*/
				if ($get($1.bot, $1.i) == 0) { /*21239*/
					if ($get($1.bot, $1.i - 1) == 1) { /*21236*/
						$k[$j++] = 1; /*21234*/
					} else { /*21236*/
						var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*21236*/
						$k[$j++] = _X; /*21236*/
					} /*21236*/
				} else { /*21239*/
					$k[$j++] = 0; /*21239*/
				} /*21239*/
				$put($1.sep, $1.i, $k[--$j]); /*21241*/
			} /*21241*/
			$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*21243*/
			$k[$j++] = true; /*21244*/
			for (var _c = 0; _c <= 12; _c += 1) { /*21244*/
				var _i = $k[--$j]; /*21244*/
				$k[$j++] = _i && $eq($get($1.bot, _c + $1.fp), $get($1.f3, _c)); /*21244*/
			} /*21244*/
			if ($k[--$j]) { /*21247*/
				$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*21246*/
			} /*21246*/
		}; /*21248*/
		$k[$j++] = Infinity; /*21249*/
		$k[$j++] = 0; /*21250*/
		$forall($1.linsbs, function() { /*21250*/
			var _o = $k[--$j]; /*21250*/
			var _p = $k[--$j]; /*21250*/
			var _q = (_p == 1) ? 0 : 1; /*21250*/
			$k[$j++] = _p; /*21250*/
			for (var _r = 0, _s = _o; _r < _s; _r++) { /*21250*/
				$k[$j++] = _q /*21250*/
			} /*21250*/
		}); /*21250*/
		$astore($a($counttomark() - 1)); /*21251*/
		$1.bot = $k[--$j]; /*21251*/
		$j -= 2; /*21251*/
		$k[$j++] = Infinity; /*21252*/
		$forall($1.bot, function() { /*21252*/
			var _x = $k[--$j]; /*21252*/
			$k[$j++] = 1 - _x; /*21252*/
		}); /*21252*/
		$1.sep = $a(); /*21252*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*21253*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*21254*/
		$k[$j++] = 18; /*21255*/
		$1.sepfinder(); /*21255*/
		$k[$j++] = 64; /*21255*/
		$1.sepfinder(); /*21255*/
		$$.rmoveto(0, $1.linheight); /*21256*/
		var _19 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*21263*/
		$k[$j++] = _19; /*21264*/
		$0.renmatrix(); /*21264*/
		$$.rmoveto(-5, 1); /*21267*/
		$k[$j++] = $1.comp; /*21267*/
		$k[$j++] = $1.options; /*21267*/
		$0["gs1-cc"](); /*21267*/
		$0.renmatrix(); /*21267*/
		$$.restore(); /*21269*/
	};
	$0.databarstackedcomposite = function() {
		var $1 = {}; /*21298*/
		$1.options = $k[--$j]; /*21300*/
		$1.barcode = $k[--$j]; /*21301*/
		$1.dontdraw = false; /*21303*/
		$forall($1.options, function() { /*21314*/
			var _3 = $k[--$j]; /*21314*/
			$1[$k[--$j]] = _3; /*21314*/
		}); /*21314*/
		$search($1.barcode, "|"); /*21317*/
		if ($k[--$j]) { /*21322*/
			$1.linear = $k[--$j]; /*21318*/
			$j--; /*21319*/
			$1.comp = $k[--$j]; /*21320*/
		} else { /*21322*/
			$j--; /*21322*/
		} /*21322*/
		$$.save(); /*21325*/
		$1.options.lintype = "databarstacked"; /*21327*/
		$1.options.linkage = true; /*21328*/
		$1.options.inkspread = "0"; /*21329*/
		$1.options.dontdraw = true; /*21330*/
		$k[$j++] = $1.linear; /*21333*/
		$k[$j++] = $1.options; /*21333*/
		$0.databarstacked(); /*21333*/
		var _F = $k[--$j]; /*21334*/
		$1.bot = $geti(_F.pixs, 0, _F.pixx); /*21334*/
		$1.linheight = _F.pixy; /*21335*/
		$k[$j++] = _F; /*21336*/
		$0.renmatrix(); /*21336*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*21340*/
			for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*21353*/
				$1.i = _O; /*21342*/
				if ($get($1.bot, $1.i) == 0) { /*21350*/
					if ($get($1.bot, $1.i - 1) == 1) { /*21347*/
						$k[$j++] = 1; /*21345*/
					} else { /*21347*/
						var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*21347*/
						$k[$j++] = _Y; /*21347*/
					} /*21347*/
				} else { /*21350*/
					$k[$j++] = 0; /*21350*/
				} /*21350*/
				$put($1.sep, $1.i, $k[--$j]); /*21352*/
			} /*21352*/
			$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*21354*/
			$k[$j++] = true; /*21355*/
			for (var _d = 0; _d <= 12; _d += 1) { /*21355*/
				var _j = $k[--$j]; /*21355*/
				$k[$j++] = _j && $eq($get($1.bot, _d + $1.fp), $get($1.f3, _d)); /*21355*/
			} /*21355*/
			if ($k[--$j]) { /*21358*/
				$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*21357*/
			} /*21357*/
		}; /*21359*/
		$k[$j++] = Infinity; /*21360*/
		$forall($1.bot, function() { /*21360*/
			var _p = $k[--$j]; /*21360*/
			$k[$j++] = 1 - _p; /*21360*/
		}); /*21360*/
		$1.sep = $a(); /*21360*/
		$puti($1.sep, 0, $a([0, 0, 0, 0])); /*21361*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*21362*/
		$k[$j++] = 18; /*21363*/
		$1.sepfinder(); /*21363*/
		$$.rmoveto(0, $1.linheight); /*21364*/
		var _11 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*21371*/
		$k[$j++] = _11; /*21372*/
		$0.renmatrix(); /*21372*/
		$$.rmoveto(1, 1); /*21375*/
		$k[$j++] = $1.comp; /*21375*/
		$k[$j++] = $1.options; /*21375*/
		$0["gs1-cc"](); /*21375*/
		$0.renmatrix(); /*21375*/
		$$.restore(); /*21377*/
	};
	$0.databarstackedomnicomposite = function() {
		var $1 = {}; /*21406*/
		$1.options = $k[--$j]; /*21408*/
		$1.barcode = $k[--$j]; /*21409*/
		$1.dontdraw = false; /*21411*/
		$forall($1.options, function() { /*21422*/
			var _3 = $k[--$j]; /*21422*/
			$1[$k[--$j]] = _3; /*21422*/
		}); /*21422*/
		$search($1.barcode, "|"); /*21425*/
		if ($k[--$j]) { /*21430*/
			$1.linear = $k[--$j]; /*21426*/
			$j--; /*21427*/
			$1.comp = $k[--$j]; /*21428*/
		} else { /*21430*/
			$j--; /*21430*/
		} /*21430*/
		$$.save(); /*21433*/
		$1.options.lintype = "databarstackedomni"; /*21435*/
		$1.options.linkage = true; /*21436*/
		$1.options.inkspread = "0"; /*21437*/
		$1.options.dontdraw = true; /*21438*/
		$k[$j++] = $1.linear; /*21441*/
		$k[$j++] = $1.options; /*21441*/
		$0.databarstackedomni(); /*21441*/
		var _F = $k[--$j]; /*21442*/
		$1.bot = $geti(_F.pixs, 0, _F.pixx); /*21442*/
		$1.linheight = _F.pixy; /*21443*/
		$k[$j++] = _F; /*21444*/
		$0.renmatrix(); /*21444*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*21448*/
			for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*21461*/
				$1.i = _O; /*21450*/
				if ($get($1.bot, $1.i) == 0) { /*21458*/
					if ($get($1.bot, $1.i - 1) == 1) { /*21455*/
						$k[$j++] = 1; /*21453*/
					} else { /*21455*/
						var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*21455*/
						$k[$j++] = _Y; /*21455*/
					} /*21455*/
				} else { /*21458*/
					$k[$j++] = 0; /*21458*/
				} /*21458*/
				$put($1.sep, $1.i, $k[--$j]); /*21460*/
			} /*21460*/
			$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*21462*/
			$k[$j++] = true; /*21463*/
			for (var _d = 0; _d <= 12; _d += 1) { /*21463*/
				var _j = $k[--$j]; /*21463*/
				$k[$j++] = _j && $eq($get($1.bot, _d + $1.fp), $get($1.f3, _d)); /*21463*/
			} /*21463*/
			if ($k[--$j]) { /*21466*/
				$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*21465*/
			} /*21465*/
		}; /*21467*/
		$k[$j++] = Infinity; /*21468*/
		$forall($1.bot, function() { /*21468*/
			var _p = $k[--$j]; /*21468*/
			$k[$j++] = 1 - _p; /*21468*/
		}); /*21468*/
		$1.sep = $a(); /*21468*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*21469*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*21470*/
		$k[$j++] = 18; /*21471*/
		$1.sepfinder(); /*21471*/
		$$.rmoveto(0, $1.linheight); /*21472*/
		var _11 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*21479*/
		$k[$j++] = _11; /*21480*/
		$0.renmatrix(); /*21480*/
		$$.rmoveto(1, 1); /*21483*/
		$k[$j++] = $1.comp; /*21483*/
		$k[$j++] = $1.options; /*21483*/
		$0["gs1-cc"](); /*21483*/
		$0.renmatrix(); /*21483*/
		$$.restore(); /*21485*/
	};
	$0.databartruncatedcomposite = function() {
		var $1 = {}; /*21515*/
		$1.options = $k[--$j]; /*21517*/
		$1.barcode = $k[--$j]; /*21518*/
		$1.dontdraw = false; /*21520*/
		$forall($1.options, function() { /*21531*/
			var _3 = $k[--$j]; /*21531*/
			$1[$k[--$j]] = _3; /*21531*/
		}); /*21531*/
		$search($1.barcode, "|"); /*21534*/
		if ($k[--$j]) { /*21539*/
			$1.linear = $k[--$j]; /*21535*/
			$j--; /*21536*/
			$1.comp = $k[--$j]; /*21537*/
		} else { /*21539*/
			$j--; /*21539*/
		} /*21539*/
		$$.save(); /*21542*/
		$1.options.lintype = "databartruncated"; /*21544*/
		$1.options.linkage = true; /*21545*/
		$1.options.inkspread = "0"; /*21546*/
		$1.options.dontdraw = true; /*21547*/
		$k[$j++] = $1.linear; /*21550*/
		$k[$j++] = $1.options; /*21550*/
		$0.databartruncated(); /*21550*/
		var _F = $k[--$j]; /*21551*/
		$1.linsbs = _F.sbs; /*21551*/
		$1.linheight = $get(_F.bhs, 0) * 72; /*21552*/
		$k[$j++] = _F; /*21553*/
		$0.renlinear(); /*21553*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*21557*/
			for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*21570*/
				$1.i = _N; /*21559*/
				if ($get($1.bot, $1.i) == 0) { /*21567*/
					if ($get($1.bot, $1.i - 1) == 1) { /*21564*/
						$k[$j++] = 1; /*21562*/
					} else { /*21564*/
						var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*21564*/
						$k[$j++] = _X; /*21564*/
					} /*21564*/
				} else { /*21567*/
					$k[$j++] = 0; /*21567*/
				} /*21567*/
				$put($1.sep, $1.i, $k[--$j]); /*21569*/
			} /*21569*/
			$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*21571*/
			$k[$j++] = true; /*21572*/
			for (var _c = 0; _c <= 12; _c += 1) { /*21572*/
				var _i = $k[--$j]; /*21572*/
				$k[$j++] = _i && $eq($get($1.bot, _c + $1.fp), $get($1.f3, _c)); /*21572*/
			} /*21572*/
			if ($k[--$j]) { /*21575*/
				$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*21574*/
			} /*21574*/
		}; /*21576*/
		$k[$j++] = Infinity; /*21577*/
		$k[$j++] = 0; /*21578*/
		$forall($1.linsbs, function() { /*21578*/
			var _o = $k[--$j]; /*21578*/
			var _p = $k[--$j]; /*21578*/
			var _q = (_p == 1) ? 0 : 1; /*21578*/
			$k[$j++] = _p; /*21578*/
			for (var _r = 0, _s = _o; _r < _s; _r++) { /*21578*/
				$k[$j++] = _q /*21578*/
			} /*21578*/
		}); /*21578*/
		$astore($a($counttomark() - 1)); /*21579*/
		$1.bot = $k[--$j]; /*21579*/
		$j -= 2; /*21579*/
		$k[$j++] = Infinity; /*21580*/
		$forall($1.bot, function() { /*21580*/
			var _x = $k[--$j]; /*21580*/
			$k[$j++] = 1 - _x; /*21580*/
		}); /*21580*/
		$1.sep = $a(); /*21580*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*21581*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*21582*/
		$k[$j++] = 18; /*21583*/
		$1.sepfinder(); /*21583*/
		$k[$j++] = 64; /*21583*/
		$1.sepfinder(); /*21583*/
		$$.rmoveto(0, $1.linheight); /*21584*/
		var _19 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*21591*/
		$k[$j++] = _19; /*21592*/
		$0.renmatrix(); /*21592*/
		$$.rmoveto(-5, 1); /*21595*/
		$k[$j++] = $1.comp; /*21595*/
		$k[$j++] = $1.options; /*21595*/
		$0["gs1-cc"](); /*21595*/
		$0.renmatrix(); /*21595*/
		$$.restore(); /*21597*/
	};
	$0.databarlimitedcomposite = function() {
		var $1 = {}; /*21627*/
		$1.options = $k[--$j]; /*21629*/
		$1.barcode = $k[--$j]; /*21630*/
		$1.dontdraw = false; /*21632*/
		$forall($1.options, function() { /*21643*/
			var _3 = $k[--$j]; /*21643*/
			$1[$k[--$j]] = _3; /*21643*/
		}); /*21643*/
		$search($1.barcode, "|"); /*21646*/
		if ($k[--$j]) { /*21651*/
			$1.linear = $k[--$j]; /*21647*/
			$j--; /*21648*/
			$1.comp = $k[--$j]; /*21649*/
		} else { /*21651*/
			$j--; /*21651*/
		} /*21651*/
		$$.save(); /*21654*/
		$1.options.lintype = "databarlimited"; /*21656*/
		$1.options.linkage = true; /*21657*/
		$1.options.inkspread = "0"; /*21658*/
		$1.options.dontdraw = true; /*21659*/
		$k[$j++] = $1.linear; /*21662*/
		$k[$j++] = $1.options; /*21662*/
		$0.databarlimited(); /*21662*/
		var _F = $k[--$j]; /*21663*/
		$1.linsbs = _F.sbs; /*21663*/
		$1.linheight = $get(_F.bhs, 0) * 72; /*21664*/
		$k[$j++] = _F; /*21665*/
		$0.renlinear(); /*21665*/
		$k[$j++] = Infinity; /*21668*/
		$k[$j++] = 1; /*21669*/
		$forall($1.linsbs, function() { /*21669*/
			var _K = $k[--$j]; /*21669*/
			var _L = $k[--$j]; /*21669*/
			var _M = (_L == 0) ? 1 : 0; /*21669*/
			$k[$j++] = _L; /*21669*/
			for (var _N = 0, _O = _K; _N < _O; _N++) { /*21669*/
				$k[$j++] = _M /*21669*/
			} /*21669*/
		}); /*21669*/
		$astore($a($counttomark() - 1)); /*21670*/
		$1.sep = $k[--$j]; /*21670*/
		$j -= 2; /*21670*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*21671*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*21672*/
		$$.rmoveto(0, $1.linheight); /*21673*/
		var _c = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*21680*/
		$k[$j++] = _c; /*21681*/
		$0.renmatrix(); /*21681*/
		$k[$j++] = $1.comp; /*21684*/
		$k[$j++] = $1.options; /*21684*/
		$0["gs1-cc"](); /*21684*/
		var _f = $k[--$j]; /*21685*/
		$$.rmoveto(72 - _f.pixx, 1); /*21685*/
		$k[$j++] = _f; /*21686*/
		$0.renmatrix(); /*21686*/
		$$.restore(); /*21688*/
	};
	$0.databarexpandedcomposite = function() {
		var $1 = {}; /*21718*/
		$1.options = $k[--$j]; /*21720*/
		$1.barcode = $k[--$j]; /*21721*/
		$1.dontdraw = false; /*21723*/
		$forall($1.options, function() { /*21734*/
			var _3 = $k[--$j]; /*21734*/
			$1[$k[--$j]] = _3; /*21734*/
		}); /*21734*/
		$search($1.barcode, "|"); /*21737*/
		if ($k[--$j]) { /*21742*/
			$1.linear = $k[--$j]; /*21738*/
			$j--; /*21739*/
			$1.comp = $k[--$j]; /*21740*/
		} else { /*21742*/
			$j--; /*21742*/
		} /*21742*/
		$$.save(); /*21745*/
		$1.options.lintype = "databarexpanded"; /*21747*/
		$1.options.linkage = true; /*21748*/
		$1.options.inkspread = "0"; /*21749*/
		$1.options.dontdraw = true; /*21750*/
		$k[$j++] = $1.linear; /*21753*/
		$k[$j++] = $1.options; /*21753*/
		$0.databarexpanded(); /*21753*/
		var _F = $k[--$j]; /*21754*/
		$1.linsbs = _F.sbs; /*21754*/
		$1.linheight = $get(_F.bhs, 0) * 72; /*21755*/
		$k[$j++] = _F; /*21756*/
		$0.renlinear(); /*21756*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*21760*/
			for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*21773*/
				$1.i = _N; /*21762*/
				if ($get($1.bot, $1.i) == 0) { /*21770*/
					if ($get($1.bot, $1.i - 1) == 1) { /*21767*/
						$k[$j++] = 1; /*21765*/
					} else { /*21767*/
						var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*21767*/
						$k[$j++] = _X; /*21767*/
					} /*21767*/
				} else { /*21770*/
					$k[$j++] = 0; /*21770*/
				} /*21770*/
				$put($1.sep, $1.i, $k[--$j]); /*21772*/
			} /*21772*/
		}; /*21774*/
		$k[$j++] = Infinity; /*21775*/
		$k[$j++] = 0; /*21776*/
		$forall($1.linsbs, function() { /*21776*/
			var _c = $k[--$j]; /*21776*/
			var _d = $k[--$j]; /*21776*/
			var _e = (_d == 1) ? 0 : 1; /*21776*/
			$k[$j++] = _d; /*21776*/
			for (var _f = 0, _g = _c; _f < _g; _f++) { /*21776*/
				$k[$j++] = _e /*21776*/
			} /*21776*/
		}); /*21776*/
		$astore($a($counttomark() - 1)); /*21777*/
		$1.bot = $k[--$j]; /*21777*/
		$j -= 2; /*21777*/
		$k[$j++] = Infinity; /*21778*/
		$forall($1.bot, function() { /*21778*/
			var _l = $k[--$j]; /*21778*/
			$k[$j++] = 1 - _l; /*21778*/
		}); /*21778*/
		$1.sep = $a(); /*21778*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*21779*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*21780*/
		$k[$j++] = Infinity; /*21783*/
		for (var _u = 18, _t = $1.bot.length - 13; _u <= _t; _u += 98) { /*21782*/
			$k[$j++] = _u; /*21782*/
		} /*21782*/
		for (var _x = 69, _w = $1.bot.length - 13; _x <= _w; _x += 98) { /*21783*/
			$k[$j++] = _x; /*21783*/
		} /*21783*/
		var _y = $a(); /*21783*/
		for (var _z = 0, _10 = _y.length; _z < _10; _z++) { /*21784*/
			$k[$j++] = $get(_y, _z); /*21784*/
			$1.sepfinder(); /*21784*/
		} /*21784*/
		$$.rmoveto(0, $1.linheight); /*21785*/
		var _17 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*21792*/
		$k[$j++] = _17; /*21793*/
		$0.renmatrix(); /*21793*/
		$$.rmoveto(1, 1); /*21796*/
		$k[$j++] = $1.comp; /*21796*/
		$k[$j++] = $1.options; /*21796*/
		$0["gs1-cc"](); /*21796*/
		$0.renmatrix(); /*21796*/
		$$.restore(); /*21798*/
	};
	$0.databarexpandedstackedcomposite = function() {
		var $1 = {}; /*21827*/
		$1.options = $k[--$j]; /*21829*/
		$1.barcode = $k[--$j]; /*21830*/
		$1.dontdraw = false; /*21832*/
		$forall($1.options, function() { /*21843*/
			var _3 = $k[--$j]; /*21843*/
			$1[$k[--$j]] = _3; /*21843*/
		}); /*21843*/
		$search($1.barcode, "|"); /*21846*/
		if ($k[--$j]) { /*21851*/
			$1.linear = $k[--$j]; /*21847*/
			$j--; /*21848*/
			$1.comp = $k[--$j]; /*21849*/
		} else { /*21851*/
			$j--; /*21851*/
		} /*21851*/
		$$.save(); /*21854*/
		$1.options.lintype = "databarexpandedstacked"; /*21856*/
		$1.options.linkage = true; /*21857*/
		$1.options.inkspread = "0"; /*21858*/
		$1.options.dontdraw = true; /*21859*/
		$k[$j++] = $1.linear; /*21862*/
		$k[$j++] = $1.options; /*21862*/
		$0.databarexpandedstacked(); /*21862*/
		var _F = $k[--$j]; /*21863*/
		$1.bot = $geti(_F.pixs, 0, _F.pixx); /*21863*/
		$1.linheight = _F.pixy; /*21864*/
		$k[$j++] = _F; /*21865*/
		$0.renmatrix(); /*21865*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*21869*/
			for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*21882*/
				$1.i = _O; /*21871*/
				if ($get($1.bot, $1.i) == 0) { /*21879*/
					if ($get($1.bot, $1.i - 1) == 1) { /*21876*/
						$k[$j++] = 1; /*21874*/
					} else { /*21876*/
						var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*21876*/
						$k[$j++] = _Y; /*21876*/
					} /*21876*/
				} else { /*21879*/
					$k[$j++] = 0; /*21879*/
				} /*21879*/
				$put($1.sep, $1.i, $k[--$j]); /*21881*/
			} /*21881*/
		}; /*21883*/
		$k[$j++] = Infinity; /*21884*/
		$forall($1.bot, function() { /*21884*/
			var _d = $k[--$j]; /*21884*/
			$k[$j++] = 1 - _d; /*21884*/
		}); /*21884*/
		$1.sep = $a(); /*21884*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*21885*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*21886*/
		$k[$j++] = Infinity; /*21889*/
		for (var _m = 19, _l = $1.bot.length - 13; _m <= _l; _m += 98) { /*21888*/
			$k[$j++] = _m; /*21888*/
		} /*21888*/
		for (var _p = 70, _o = $1.bot.length - 13; _p <= _o; _p += 98) { /*21889*/
			$k[$j++] = _p; /*21889*/
		} /*21889*/
		var _q = $a(); /*21889*/
		for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*21890*/
			$k[$j++] = $get(_q, _r); /*21890*/
			$1.sepfinder(); /*21890*/
		} /*21890*/
		$$.rmoveto(0, $1.linheight); /*21891*/
		var _z = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*21898*/
		$k[$j++] = _z; /*21899*/
		$0.renmatrix(); /*21899*/
		var _12 = ($get($1.bot, 0) == 0) ? 2 : 0; /*21902*/
		$$.rmoveto(_12, 1); /*21902*/
		$k[$j++] = $1.comp; /*21903*/
		$k[$j++] = $1.options; /*21903*/
		$0["gs1-cc"](); /*21903*/
		$0.renmatrix(); /*21903*/
		$$.restore(); /*21905*/
	};
	$0["gs1-128composite"] = function() {
		var $1 = {}; /*21935*/
		$1.options = $k[--$j]; /*21937*/
		$1.barcode = $k[--$j]; /*21938*/
		$1.dontdraw = false; /*21940*/
		$forall($1.options, function() { /*21951*/
			var _3 = $k[--$j]; /*21951*/
			$1[$k[--$j]] = _3; /*21951*/
		}); /*21951*/
		$search($1.barcode, "|"); /*21954*/
		if ($k[--$j]) { /*21959*/
			$1.linear = $k[--$j]; /*21955*/
			$j--; /*21956*/
			$1.comp = $k[--$j]; /*21957*/
		} else { /*21959*/
			$j--; /*21959*/
		} /*21959*/
		$$.save(); /*21962*/
		$1.options.inkspread = "0"; /*21964*/
		$1.options.dontdraw = true; /*21965*/
		$1.options.linkagea = true; /*21968*/
		$k[$j++] = $1.linear; /*21969*/
		$k[$j++] = Infinity; /*21969*/
		$forall($1.options); /*21969*/
		var _E = $d(); /*21969*/
		$k[$j++] = _E; /*21969*/
		$0["gs1-128"](); /*21969*/
		var _G = $k[--$j].sbs; /*21970*/
		$k[$j++] = 0; /*21970*/
		$forall(_G, function() { /*21970*/
			var _H = $k[--$j]; /*21970*/
			var _I = $k[--$j]; /*21970*/
			$k[$j++] = _I + _H; /*21970*/
		}); /*21970*/
		$1.linwidth = $k[--$j]; /*21970*/
		$1.options.lintype = "gs1-128"; /*21973*/
		$1.options.linwidth = $1.linwidth; /*21974*/
		$k[$j++] = $1.comp; /*21975*/
		$k[$j++] = $1.options; /*21975*/
		$0["gs1-cc"](); /*21975*/
		$1.compsym = $k[--$j]; /*21975*/
		if ($1.compsym.pixx == 99) { /*21976*/
			$k[$j++] = "a"; /*21976*/
		} else { /*21976*/
			$k[$j++] = "c"; /*21976*/
		} /*21976*/
		$1.linktype = $k[--$j]; /*21976*/
		if ($eq($1.linktype, "a")) { /*21984*/
			$1.options.linkagea = true; /*21980*/
			$1.options.linkagec = false; /*21981*/
		} else { /*21984*/
			$1.options.linkagea = false; /*21983*/
			$1.options.linkagec = true; /*21984*/
		} /*21984*/
		$k[$j++] = $1.linear; /*21986*/
		$k[$j++] = Infinity; /*21986*/
		$forall($1.options); /*21986*/
		var _a = $d(); /*21986*/
		$k[$j++] = _a; /*21986*/
		$0["gs1-128"](); /*21986*/
		var _b = $k[--$j]; /*21987*/
		$1.linsbs = _b.sbs; /*21987*/
		$1.linheight = $get(_b.bhs, 0) * 72; /*21988*/
		$k[$j++] = _b; /*21989*/
		$0.renlinear(); /*21989*/
		$k[$j++] = Infinity; /*21992*/
		$k[$j++] = 1; /*21993*/
		$forall($1.linsbs, function() { /*21993*/
			var _g = $k[--$j]; /*21993*/
			var _h = $k[--$j]; /*21993*/
			var _i = (_h == 0) ? 1 : 0; /*21993*/
			$k[$j++] = _h; /*21993*/
			for (var _j = 0, _k = _g; _j < _k; _j++) { /*21993*/
				$k[$j++] = _i /*21993*/
			} /*21993*/
		}); /*21993*/
		$astore($a($counttomark() - 1)); /*21994*/
		$1.sep = $k[--$j]; /*21994*/
		$j -= 2; /*21994*/
		$$.rmoveto(0, $1.linheight); /*21995*/
		var _t = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*22002*/
		$k[$j++] = _t; /*22003*/
		$0.renmatrix(); /*22003*/
		if ($eq($1.linktype, "a")) { /*22012*/
			$1.s = ~~(($1.linwidth - 2) / 11); /*22007*/
			$1.p = ~~(($1.s - 9) / 2); /*22008*/
			$k[$j++] = "x"; /*22009*/
			$k[$j++] = ((($1.s - $1.p) - 1) * 11) + 10; /*22009*/
			if ($1.p == 0) { /*22009*/
				var _10 = $k[--$j]; /*22009*/
				$k[$j++] = _10 + 2; /*22009*/
			} /*22009*/
			var _11 = $k[--$j]; /*22009*/
			$1[$k[--$j]] = _11 - 99; /*22009*/
			$$.rmoveto($1.x, 1); /*22010*/
		} else { /*22012*/
			$$.rmoveto(-7, 1); /*22012*/
		} /*22012*/
		$k[$j++] = $1.compsym; /*22015*/
		$0.renmatrix(); /*22015*/
		$$.restore(); /*22017*/
	};
	$0.gs1datamatrix = function() {
		var $1 = {}; /*22045*/
		$1.options = $k[--$j]; /*22047*/
		$1.barcode = $k[--$j]; /*22048*/
		$1.dontdraw = false; /*22050*/
		$forall($1.options, function() { /*22061*/
			var _3 = $k[--$j]; /*22061*/
			$1[$k[--$j]] = _3; /*22061*/
		}); /*22061*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*22065*/
			$1.out = $s($1.in.length); /*22066*/
			$1.j = 0; /*22067*/
			$k[$j++] = $1.in; /*22081*/
			for (;;) { /*22081*/
				$search($k[--$j], "^"); /*22070*/
				if ($k[--$j]) { /*22079*/
					var _B = $k[--$j]; /*22071*/
					$puti($1.out, $1.j, _B); /*22071*/
					$1.j = (_B.length + $1.j) + 1; /*22072*/
					$j--; /*22073*/
					var _F = $k[--$j]; /*22074*/
					$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*22074*/
					$k[$j++] = $geti(_F, 3, _F.length - 3); /*22075*/
				} else { /*22079*/
					var _K = $k[--$j]; /*22077*/
					$puti($1.out, $1.j, _K); /*22077*/
					$1.j = _K.length + $1.j; /*22078*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*22079*/
					break; /*22079*/
				} /*22079*/
			} /*22079*/
		}; /*22082*/
		$1.ais = $a([]); /*22085*/
		$1.aival = {}; /*22086*/
		var _S = $1.barcode; /*22087*/
		$k[$j++] = $geti(_S, 1, _S.length - 1); /*22099*/
		for (;;) { /*22099*/
			var _U = $k[--$j]; /*22089*/
			$k[$j++] = _U; /*22089*/
			if ($eq(_U, "")) { /*22089*/
				break; /*22089*/
			} /*22089*/
			$search($k[--$j], ")"); /*22090*/
			$j--; /*22090*/
			var _W = $k[--$j]; /*22091*/
			var _X = $k[--$j]; /*22091*/
			var _Y = $k[--$j]; /*22092*/
			$k[$j++] = _W; /*22092*/
			$search(_Y, "("); /*22092*/
			if ($k[--$j]) { /*22095*/
				var _a = $k[--$j]; /*22093*/
				var _b = $k[--$j]; /*22093*/
				var _c = $k[--$j]; /*22093*/
				var _d = $k[--$j]; /*22093*/
				$k[$j++] = _c; /*22093*/
				$k[$j++] = _d; /*22093*/
				$k[$j++] = _a; /*22093*/
			} else { /*22095*/
				var _e = $k[--$j]; /*22095*/
				var _f = $k[--$j]; /*22095*/
				$k[$j++] = ""; /*22095*/
				$k[$j++] = _f; /*22095*/
				$k[$j++] = _e; /*22095*/
			} /*22095*/
			$k[$j++] = Infinity; /*22097*/
			$aload($1.ais); /*22097*/
			var _i = $k[$j - 1 - ($counttomark() + 2)]; /*22097*/
			$k[$j++] = _i; /*22097*/
			$1.ais = $a(); /*22097*/
			var _l = $k[--$j]; /*22098*/
			var _m = $k[--$j]; /*22098*/
			$k[$j++] = $1.aival; /*22098*/
			$k[$j++] = _m; /*22098*/
			$k[$j++] = _l; /*22098*/
			$1.expand(); /*22098*/
			var _n = $k[--$j]; /*22098*/
			var _o = $k[--$j]; /*22098*/
			$put($k[--$j], _o, _n); /*22098*/
		} /*22098*/
		$j--; /*22100*/
		$1.aifixed = {}; /*22105*/
		$k[$j++] = Infinity; /*22107*/
		for (var _q = 0; _q <= 4; _q += 1) { /*22107*/
			$k[$j++] = _q; /*22107*/
		} /*22107*/
		var _r = $a(); /*22107*/
		for (var _s = 0, _t = _r.length; _s < _t; _s++) { /*22110*/
			var _w = $strcpy($s(2), "00"); /*22109*/
			$put(_w, 1, $get(_r, _s) + 48); /*22109*/
			$put($1.aifixed, _w, _w); /*22109*/
		} /*22109*/
		$k[$j++] = Infinity; /*22115*/
		for (var _y = 11; _y <= 20; _y += 1) { /*22112*/
			$k[$j++] = _y; /*22112*/
		} /*22112*/
		$k[$j++] = 23; /*22114*/
		for (var _z = 31; _z <= 36; _z += 1) { /*22114*/
			$k[$j++] = _z; /*22114*/
		} /*22114*/
		$k[$j++] = 41; /*22115*/
		var _10 = $a(); /*22115*/
		for (var _11 = 0, _12 = _10.length; _11 < _12; _11++) { /*22118*/
			var _15 = $cvrs($s(2), $get(_10, _11), 10); /*22117*/
			$put($1.aifixed, _15, _15); /*22117*/
		} /*22117*/
		$1.fnc1 = -1; /*22121*/
		$1.dmtx = $a([$1.fnc1]); /*22122*/
		for (var _1B = 0, _1A = $1.ais.length - 1; _1B <= _1A; _1B += 1) { /*22138*/
			$1.i = _1B; /*22124*/
			$1.ai = $get($1.ais, $1.i); /*22125*/
			$1.val = $get($1.aival, $1.ai); /*22126*/
			var _1L = $a(($1.dmtx.length + $1.ai.length) + $1.val.length); /*22127*/
			$puti(_1L, 0, $1.dmtx); /*22128*/
			$k[$j++] = _1L; /*22129*/
			$k[$j++] = _1L; /*22129*/
			$k[$j++] = $1.dmtx.length; /*22129*/
			$k[$j++] = $1.ai; /*22129*/
			$k[$j++] = Infinity; /*22129*/
			var _1P = $k[--$j]; /*22129*/
			var _1Q = $k[--$j]; /*22129*/
			$k[$j++] = _1P; /*22129*/
			$forall(_1Q); /*22129*/
			var _1R = $a(); /*22129*/
			var _1S = $k[--$j]; /*22129*/
			$puti($k[--$j], _1S, _1R); /*22129*/
			var _1U = $k[--$j]; /*22130*/
			$k[$j++] = _1U; /*22130*/
			$k[$j++] = _1U; /*22130*/
			$k[$j++] = $1.dmtx.length + $1.ai.length; /*22130*/
			$k[$j++] = $1.val; /*22130*/
			$k[$j++] = Infinity; /*22130*/
			var _1Y = $k[--$j]; /*22130*/
			var _1Z = $k[--$j]; /*22130*/
			$k[$j++] = _1Y; /*22130*/
			$forall(_1Z); /*22130*/
			var _1a = $a(); /*22130*/
			var _1b = $k[--$j]; /*22130*/
			$puti($k[--$j], _1b, _1a); /*22130*/
			$1.dmtx = $k[--$j]; /*22131*/
			var _1j = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*22132*/
			if (($1.i != ($1.ais.length - 1)) && (!_1j)) { /*22137*/
				var _1l = $a($1.dmtx.length + 1); /*22133*/
				$puti(_1l, 0, $1.dmtx); /*22134*/
				$put(_1l, $1.dmtx.length, $1.fnc1); /*22135*/
				$1.dmtx = _1l; /*22136*/
			} /*22136*/
		} /*22136*/
		$1.barcode = $s(($1.dmtx.length + 1) * 5); /*22141*/
		$1.i = 0; /*22142*/
		$1.j = 0; /*22142*/
		for (;;) { /*22152*/
			if ($1.i == $1.dmtx.length) { /*22143*/
				break; /*22143*/
			} /*22143*/
			var _1v = $get($1.dmtx, $1.i); /*22144*/
			$k[$j++] = _1v; /*22149*/
			if (_1v == $1.fnc1) { /*22148*/
				$j--; /*22145*/
				$puti($1.barcode, $1.j, "^FNC1"); /*22145*/
				$1.j = $1.j + 4; /*22146*/
			} else { /*22148*/
				$put($1.barcode, $1.j, $k[--$j]); /*22148*/
			} /*22148*/
			$1.i = $1.i + 1; /*22150*/
			$1.j = $1.j + 1; /*22151*/
		} /*22151*/
		$1.barcode = $geti($1.barcode, 0, $1.j); /*22153*/
		$1.options.dontdraw = true; /*22156*/
		$1.options.parsefnc = true; /*22157*/
		$k[$j++] = "args"; /*22158*/
		$k[$j++] = $1.barcode; /*22158*/
		$k[$j++] = $1.options; /*22158*/
		$0.datamatrix(); /*22158*/
		var _2C = $k[--$j]; /*22158*/
		$1[$k[--$j]] = _2C; /*22158*/
		$1.args.opt = $1.options; /*22160*/
		$k[$j++] = $1.args; /*22163*/
		if (!$1.dontdraw) { /*22163*/
			$0.renmatrix(); /*22163*/
		} /*22163*/
	};
	$0.gs1datamatrixrectangular = function() {
		var $1 = {}; /*22191*/
		$1.options = $k[--$j]; /*22193*/
		$1.barcode = $k[--$j]; /*22194*/
		$1.dontdraw = false; /*22196*/
		$forall($1.options, function() { /*22207*/
			var _3 = $k[--$j]; /*22207*/
			$1[$k[--$j]] = _3; /*22207*/
		}); /*22207*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*22211*/
			$1.out = $s($1.in.length); /*22212*/
			$1.j = 0; /*22213*/
			$k[$j++] = $1.in; /*22227*/
			for (;;) { /*22227*/
				$search($k[--$j], "^"); /*22216*/
				if ($k[--$j]) { /*22225*/
					var _B = $k[--$j]; /*22217*/
					$puti($1.out, $1.j, _B); /*22217*/
					$1.j = (_B.length + $1.j) + 1; /*22218*/
					$j--; /*22219*/
					var _F = $k[--$j]; /*22220*/
					$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*22220*/
					$k[$j++] = $geti(_F, 3, _F.length - 3); /*22221*/
				} else { /*22225*/
					var _K = $k[--$j]; /*22223*/
					$puti($1.out, $1.j, _K); /*22223*/
					$1.j = _K.length + $1.j; /*22224*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*22225*/
					break; /*22225*/
				} /*22225*/
			} /*22225*/
		}; /*22228*/
		$1.ais = $a([]); /*22231*/
		$1.aival = {}; /*22232*/
		var _S = $1.barcode; /*22233*/
		$k[$j++] = $geti(_S, 1, _S.length - 1); /*22245*/
		for (;;) { /*22245*/
			var _U = $k[--$j]; /*22235*/
			$k[$j++] = _U; /*22235*/
			if ($eq(_U, "")) { /*22235*/
				break; /*22235*/
			} /*22235*/
			$search($k[--$j], ")"); /*22236*/
			$j--; /*22236*/
			var _W = $k[--$j]; /*22237*/
			var _X = $k[--$j]; /*22237*/
			var _Y = $k[--$j]; /*22238*/
			$k[$j++] = _W; /*22238*/
			$search(_Y, "("); /*22238*/
			if ($k[--$j]) { /*22241*/
				var _a = $k[--$j]; /*22239*/
				var _b = $k[--$j]; /*22239*/
				var _c = $k[--$j]; /*22239*/
				var _d = $k[--$j]; /*22239*/
				$k[$j++] = _c; /*22239*/
				$k[$j++] = _d; /*22239*/
				$k[$j++] = _a; /*22239*/
			} else { /*22241*/
				var _e = $k[--$j]; /*22241*/
				var _f = $k[--$j]; /*22241*/
				$k[$j++] = ""; /*22241*/
				$k[$j++] = _f; /*22241*/
				$k[$j++] = _e; /*22241*/
			} /*22241*/
			$k[$j++] = Infinity; /*22243*/
			$aload($1.ais); /*22243*/
			var _i = $k[$j - 1 - ($counttomark() + 2)]; /*22243*/
			$k[$j++] = _i; /*22243*/
			$1.ais = $a(); /*22243*/
			var _l = $k[--$j]; /*22244*/
			var _m = $k[--$j]; /*22244*/
			$k[$j++] = $1.aival; /*22244*/
			$k[$j++] = _m; /*22244*/
			$k[$j++] = _l; /*22244*/
			$1.expand(); /*22244*/
			var _n = $k[--$j]; /*22244*/
			var _o = $k[--$j]; /*22244*/
			$put($k[--$j], _o, _n); /*22244*/
		} /*22244*/
		$j--; /*22246*/
		$1.aifixed = {}; /*22251*/
		$k[$j++] = Infinity; /*22253*/
		for (var _q = 0; _q <= 4; _q += 1) { /*22253*/
			$k[$j++] = _q; /*22253*/
		} /*22253*/
		var _r = $a(); /*22253*/
		for (var _s = 0, _t = _r.length; _s < _t; _s++) { /*22256*/
			var _w = $strcpy($s(2), "00"); /*22255*/
			$put(_w, 1, $get(_r, _s) + 48); /*22255*/
			$put($1.aifixed, _w, _w); /*22255*/
		} /*22255*/
		$k[$j++] = Infinity; /*22261*/
		for (var _y = 11; _y <= 20; _y += 1) { /*22258*/
			$k[$j++] = _y; /*22258*/
		} /*22258*/
		$k[$j++] = 23; /*22260*/
		for (var _z = 31; _z <= 36; _z += 1) { /*22260*/
			$k[$j++] = _z; /*22260*/
		} /*22260*/
		$k[$j++] = 41; /*22261*/
		var _10 = $a(); /*22261*/
		for (var _11 = 0, _12 = _10.length; _11 < _12; _11++) { /*22264*/
			var _15 = $cvrs($s(2), $get(_10, _11), 10); /*22263*/
			$put($1.aifixed, _15, _15); /*22263*/
		} /*22263*/
		$1.fnc1 = -1; /*22267*/
		$1.dmtx = $a([$1.fnc1]); /*22268*/
		for (var _1B = 0, _1A = $1.ais.length - 1; _1B <= _1A; _1B += 1) { /*22284*/
			$1.i = _1B; /*22270*/
			$1.ai = $get($1.ais, $1.i); /*22271*/
			$1.val = $get($1.aival, $1.ai); /*22272*/
			var _1L = $a(($1.dmtx.length + $1.ai.length) + $1.val.length); /*22273*/
			$puti(_1L, 0, $1.dmtx); /*22274*/
			$k[$j++] = _1L; /*22275*/
			$k[$j++] = _1L; /*22275*/
			$k[$j++] = $1.dmtx.length; /*22275*/
			$k[$j++] = $1.ai; /*22275*/
			$k[$j++] = Infinity; /*22275*/
			var _1P = $k[--$j]; /*22275*/
			var _1Q = $k[--$j]; /*22275*/
			$k[$j++] = _1P; /*22275*/
			$forall(_1Q); /*22275*/
			var _1R = $a(); /*22275*/
			var _1S = $k[--$j]; /*22275*/
			$puti($k[--$j], _1S, _1R); /*22275*/
			var _1U = $k[--$j]; /*22276*/
			$k[$j++] = _1U; /*22276*/
			$k[$j++] = _1U; /*22276*/
			$k[$j++] = $1.dmtx.length + $1.ai.length; /*22276*/
			$k[$j++] = $1.val; /*22276*/
			$k[$j++] = Infinity; /*22276*/
			var _1Y = $k[--$j]; /*22276*/
			var _1Z = $k[--$j]; /*22276*/
			$k[$j++] = _1Y; /*22276*/
			$forall(_1Z); /*22276*/
			var _1a = $a(); /*22276*/
			var _1b = $k[--$j]; /*22276*/
			$puti($k[--$j], _1b, _1a); /*22276*/
			$1.dmtx = $k[--$j]; /*22277*/
			var _1j = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*22278*/
			if (($1.i != ($1.ais.length - 1)) && (!_1j)) { /*22283*/
				var _1l = $a($1.dmtx.length + 1); /*22279*/
				$puti(_1l, 0, $1.dmtx); /*22280*/
				$put(_1l, $1.dmtx.length, $1.fnc1); /*22281*/
				$1.dmtx = _1l; /*22282*/
			} /*22282*/
		} /*22282*/
		$1.barcode = $s(($1.dmtx.length + 1) * 5); /*22287*/
		$1.i = 0; /*22288*/
		$1.j = 0; /*22288*/
		for (;;) { /*22298*/
			if ($1.i == $1.dmtx.length) { /*22289*/
				break; /*22289*/
			} /*22289*/
			var _1v = $get($1.dmtx, $1.i); /*22290*/
			$k[$j++] = _1v; /*22295*/
			if (_1v == $1.fnc1) { /*22294*/
				$j--; /*22291*/
				$puti($1.barcode, $1.j, "^FNC1"); /*22291*/
				$1.j = $1.j + 4; /*22292*/
			} else { /*22294*/
				$put($1.barcode, $1.j, $k[--$j]); /*22294*/
			} /*22294*/
			$1.i = $1.i + 1; /*22296*/
			$1.j = $1.j + 1; /*22297*/
		} /*22297*/
		$1.barcode = $geti($1.barcode, 0, $1.j); /*22299*/
		$1.options.dontdraw = true; /*22302*/
		$1.options.parsefnc = true; /*22303*/
		$1.options.format = "rectangle"; /*22304*/
		$k[$j++] = "args"; /*22305*/
		$k[$j++] = $1.barcode; /*22305*/
		$k[$j++] = $1.options; /*22305*/
		$0.datamatrix(); /*22305*/
		var _2D = $k[--$j]; /*22305*/
		$1[$k[--$j]] = _2D; /*22305*/
		$1.args.opt = $1.options; /*22307*/
		$k[$j++] = $1.args; /*22310*/
		if (!$1.dontdraw) { /*22310*/
			$0.renmatrix(); /*22310*/
		} /*22310*/
	};
	$0.gs1qrcode = function() {
		var $1 = {}; /*22337*/
		$1.options = $k[--$j]; /*22339*/
		$1.barcode = $k[--$j]; /*22340*/
		$1.dontdraw = false; /*22342*/
		$forall($1.options, function() { /*22353*/
			var _3 = $k[--$j]; /*22353*/
			$1[$k[--$j]] = _3; /*22353*/
		}); /*22353*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*22357*/
			$1.out = $s($1.in.length); /*22358*/
			$1.j = 0; /*22359*/
			$k[$j++] = $1.in; /*22373*/
			for (;;) { /*22373*/
				$search($k[--$j], "^"); /*22362*/
				if ($k[--$j]) { /*22371*/
					var _B = $k[--$j]; /*22363*/
					$puti($1.out, $1.j, _B); /*22363*/
					$1.j = (_B.length + $1.j) + 1; /*22364*/
					$j--; /*22365*/
					var _F = $k[--$j]; /*22366*/
					$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*22366*/
					$k[$j++] = $geti(_F, 3, _F.length - 3); /*22367*/
				} else { /*22371*/
					var _K = $k[--$j]; /*22369*/
					$puti($1.out, $1.j, _K); /*22369*/
					$1.j = _K.length + $1.j; /*22370*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*22371*/
					break; /*22371*/
				} /*22371*/
			} /*22371*/
		}; /*22374*/
		$1.ais = $a([]); /*22377*/
		$1.aival = {}; /*22378*/
		var _S = $1.barcode; /*22379*/
		$k[$j++] = $geti(_S, 1, _S.length - 1); /*22391*/
		for (;;) { /*22391*/
			var _U = $k[--$j]; /*22381*/
			$k[$j++] = _U; /*22381*/
			if ($eq(_U, "")) { /*22381*/
				break; /*22381*/
			} /*22381*/
			$search($k[--$j], ")"); /*22382*/
			$j--; /*22382*/
			var _W = $k[--$j]; /*22383*/
			var _X = $k[--$j]; /*22383*/
			var _Y = $k[--$j]; /*22384*/
			$k[$j++] = _W; /*22384*/
			$search(_Y, "("); /*22384*/
			if ($k[--$j]) { /*22387*/
				var _a = $k[--$j]; /*22385*/
				var _b = $k[--$j]; /*22385*/
				var _c = $k[--$j]; /*22385*/
				var _d = $k[--$j]; /*22385*/
				$k[$j++] = _c; /*22385*/
				$k[$j++] = _d; /*22385*/
				$k[$j++] = _a; /*22385*/
			} else { /*22387*/
				var _e = $k[--$j]; /*22387*/
				var _f = $k[--$j]; /*22387*/
				$k[$j++] = ""; /*22387*/
				$k[$j++] = _f; /*22387*/
				$k[$j++] = _e; /*22387*/
			} /*22387*/
			$k[$j++] = Infinity; /*22389*/
			$aload($1.ais); /*22389*/
			var _i = $k[$j - 1 - ($counttomark() + 2)]; /*22389*/
			$k[$j++] = _i; /*22389*/
			$1.ais = $a(); /*22389*/
			var _l = $k[--$j]; /*22390*/
			var _m = $k[--$j]; /*22390*/
			$k[$j++] = $1.aival; /*22390*/
			$k[$j++] = _m; /*22390*/
			$k[$j++] = _l; /*22390*/
			$1.expand(); /*22390*/
			var _n = $k[--$j]; /*22390*/
			var _o = $k[--$j]; /*22390*/
			$put($k[--$j], _o, _n); /*22390*/
		} /*22390*/
		$j--; /*22392*/
		$1.aifixed = {}; /*22397*/
		$k[$j++] = Infinity; /*22399*/
		for (var _q = 0; _q <= 4; _q += 1) { /*22399*/
			$k[$j++] = _q; /*22399*/
		} /*22399*/
		var _r = $a(); /*22399*/
		for (var _s = 0, _t = _r.length; _s < _t; _s++) { /*22402*/
			var _w = $strcpy($s(2), "00"); /*22401*/
			$put(_w, 1, $get(_r, _s) + 48); /*22401*/
			$put($1.aifixed, _w, _w); /*22401*/
		} /*22401*/
		$k[$j++] = Infinity; /*22407*/
		for (var _y = 11; _y <= 20; _y += 1) { /*22404*/
			$k[$j++] = _y; /*22404*/
		} /*22404*/
		$k[$j++] = 23; /*22406*/
		for (var _z = 31; _z <= 36; _z += 1) { /*22406*/
			$k[$j++] = _z; /*22406*/
		} /*22406*/
		$k[$j++] = 41; /*22407*/
		var _10 = $a(); /*22407*/
		for (var _11 = 0, _12 = _10.length; _11 < _12; _11++) { /*22410*/
			var _15 = $cvrs($s(2), $get(_10, _11), 10); /*22409*/
			$put($1.aifixed, _15, _15); /*22409*/
		} /*22409*/
		$1.fnc1 = -1; /*22413*/
		$1.qrc = $a([$1.fnc1]); /*22414*/
		for (var _1B = 0, _1A = $1.ais.length - 1; _1B <= _1A; _1B += 1) { /*22430*/
			$1.i = _1B; /*22416*/
			$1.ai = $get($1.ais, $1.i); /*22417*/
			$1.val = $get($1.aival, $1.ai); /*22418*/
			var _1L = $a(($1.qrc.length + $1.ai.length) + $1.val.length); /*22419*/
			$puti(_1L, 0, $1.qrc); /*22420*/
			$k[$j++] = _1L; /*22421*/
			$k[$j++] = _1L; /*22421*/
			$k[$j++] = $1.qrc.length; /*22421*/
			$k[$j++] = $1.ai; /*22421*/
			$k[$j++] = Infinity; /*22421*/
			var _1P = $k[--$j]; /*22421*/
			var _1Q = $k[--$j]; /*22421*/
			$k[$j++] = _1P; /*22421*/
			$forall(_1Q); /*22421*/
			var _1R = $a(); /*22421*/
			var _1S = $k[--$j]; /*22421*/
			$puti($k[--$j], _1S, _1R); /*22421*/
			var _1U = $k[--$j]; /*22422*/
			$k[$j++] = _1U; /*22422*/
			$k[$j++] = _1U; /*22422*/
			$k[$j++] = $1.qrc.length + $1.ai.length; /*22422*/
			$k[$j++] = $1.val; /*22422*/
			$k[$j++] = Infinity; /*22422*/
			var _1Y = $k[--$j]; /*22422*/
			var _1Z = $k[--$j]; /*22422*/
			$k[$j++] = _1Y; /*22422*/
			$forall(_1Z); /*22422*/
			var _1a = $a(); /*22422*/
			var _1b = $k[--$j]; /*22422*/
			$puti($k[--$j], _1b, _1a); /*22422*/
			$1.qrc = $k[--$j]; /*22423*/
			var _1j = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*22424*/
			if (($1.i != ($1.ais.length - 1)) && (!_1j)) { /*22429*/
				var _1l = $a($1.qrc.length + 1); /*22425*/
				$puti(_1l, 0, $1.qrc); /*22426*/
				$put(_1l, $1.qrc.length, $1.fnc1); /*22427*/
				$1.qrc = _1l; /*22428*/
			} /*22428*/
		} /*22428*/
		$1.barcode = $s(($1.qrc.length + 1) * 5); /*22433*/
		$1.i = 0; /*22434*/
		$1.j = 0; /*22434*/
		for (;;) { /*22444*/
			if ($1.i == $1.qrc.length) { /*22435*/
				break; /*22435*/
			} /*22435*/
			var _1v = $get($1.qrc, $1.i); /*22436*/
			$k[$j++] = _1v; /*22441*/
			if (_1v == $1.fnc1) { /*22440*/
				$j--; /*22437*/
				$puti($1.barcode, $1.j, "^FNC1"); /*22437*/
				$1.j = $1.j + 4; /*22438*/
			} else { /*22440*/
				$put($1.barcode, $1.j, $k[--$j]); /*22440*/
			} /*22440*/
			$1.i = $1.i + 1; /*22442*/
			$1.j = $1.j + 1; /*22443*/
		} /*22443*/
		$1.barcode = $geti($1.barcode, 0, $1.j); /*22445*/
		$1.options.dontdraw = true; /*22448*/
		$1.options.parsefnc = true; /*22449*/
		$k[$j++] = "args"; /*22450*/
		$k[$j++] = $1.barcode; /*22450*/
		$k[$j++] = $1.options; /*22450*/
		$0.qrcode(); /*22450*/
		var _2C = $k[--$j]; /*22450*/
		$1[$k[--$j]] = _2C; /*22450*/
		$1.args.opt = $1.options; /*22452*/
		$k[$j++] = $1.args; /*22455*/
		if (!$1.dontdraw) { /*22455*/
			$0.renmatrix(); /*22455*/
		} /*22455*/
	};
	$0.hibccode39 = function() {
		var $1 = {}; /*22483*/
		$1.options = $k[--$j]; /*22485*/
		$1.barcode = $k[--$j]; /*22486*/
		$1.dontdraw = false; /*22488*/
		$1.textfont = "Courier"; /*22489*/
		$1.textsize = 10; /*22490*/
		$1.textyoffset = -8.5; /*22491*/
		$1.textxoffset = 0; /*22492*/
		$1.validatecheck = false; /*22493*/
		$forall($1.options, function() { /*22504*/
			var _3 = $k[--$j]; /*22504*/
			$1[$k[--$j]] = _3; /*22504*/
		}); /*22504*/
		$1.textfont = "" + $1.textfont; /*22506*/
		$1.textsize = +$1.textsize; /*22507*/
		$1.textyoffset = +$1.textyoffset; /*22508*/
		$1.textxoffset = +$1.textxoffset; /*22509*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*22512*/
		$1.charvals = {}; /*22513*/
		for (var _9 = 0; _9 <= 42; _9 += 1) { /*22514*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*22514*/
		} /*22514*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*22521*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*22518*/
			if (!_J) { /*22520*/
				$k[$j++] = "bwipp.hibccode39badCharacter"; /*22519*/
				$k[$j++] = "HIBC Code 39 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*22519*/
				$0.raiseerror(); /*22519*/
			} /*22519*/
		} /*22519*/
		$k[$j++] = "barlen"; /*22523*/
		$k[$j++] = $1.barcode.length; /*22523*/
		if ($1.validatecheck) { /*22523*/
			var _M = $k[--$j]; /*22523*/
			$k[$j++] = _M - 1; /*22523*/
		} /*22523*/
		var _N = $k[--$j]; /*22523*/
		$1[$k[--$j]] = _N; /*22523*/
		$1.checksum = 41; /*22525*/
		for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*22529*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*22528*/
		} /*22528*/
		$1.checksum = $1.checksum % 43; /*22530*/
		if ($1.validatecheck) { /*22536*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*22534*/
				$k[$j++] = "bwipp.hibccode39badCheckDigit"; /*22533*/
				$k[$j++] = "Incorrect HIBC Code 39 check digit provided"; /*22533*/
				$0.raiseerror(); /*22533*/
			} /*22533*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*22535*/
		} /*22535*/
		var _j = $s($1.barlen + 2); /*22538*/
		$puti(_j, 1, $1.barcode); /*22538*/
		$1.barcode = _j; /*22538*/
		$put($1.barcode, 0, 43); /*22539*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*22540*/
		$1.text = $s($1.barlen + 4); /*22542*/
		$put($1.text, 0, 42); /*22543*/
		$puti($1.text, 1, $1.barcode); /*22544*/
		var _10 = $get($1.barcode, $1.barlen + 1); /*22545*/
		$k[$j++] = $1.text; /*22545*/
		$k[$j++] = $1.barlen + 2; /*22545*/
		$k[$j++] = _10; /*22545*/
		if (_10 == 32) { /*22545*/
			$j--; /*22545*/
			$k[$j++] = 95; /*22545*/
		} /*22545*/
		var _11 = $k[--$j]; /*22545*/
		var _12 = $k[--$j]; /*22545*/
		$put($k[--$j], _12, _11); /*22545*/
		$put($1.text, $1.barlen + 3, 42); /*22546*/
		$1.options.dontdraw = true; /*22549*/
		$1.options.includecheck = false; /*22550*/
		$1.options.validatecheck = false; /*22551*/
		$k[$j++] = "args"; /*22552*/
		$k[$j++] = $1.barcode; /*22552*/
		$k[$j++] = $1.options; /*22552*/
		$0.code39(); /*22552*/
		var _1B = $k[--$j]; /*22552*/
		$1[$k[--$j]] = _1B; /*22552*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*22554*/
		$1.args.textxalign = "center"; /*22555*/
		$1.args.opt = $1.options; /*22556*/
		$k[$j++] = $1.args; /*22559*/
		if (!$1.dontdraw) { /*22559*/
			$0.renlinear(); /*22559*/
		} /*22559*/
	};
	$0.hibccode128 = function() {
		var $1 = {}; /*22587*/
		$1.options = $k[--$j]; /*22589*/
		$1.barcode = $k[--$j]; /*22590*/
		$1.dontdraw = false; /*22592*/
		$1.textfont = "Courier"; /*22593*/
		$1.textsize = 10; /*22594*/
		$1.textyoffset = -8.5; /*22595*/
		$1.textxoffset = 0; /*22596*/
		$1.validatecheck = false; /*22597*/
		$forall($1.options, function() { /*22608*/
			var _3 = $k[--$j]; /*22608*/
			$1[$k[--$j]] = _3; /*22608*/
		}); /*22608*/
		$1.textfont = "" + $1.textfont; /*22610*/
		$1.textsize = +$1.textsize; /*22611*/
		$1.textyoffset = +$1.textyoffset; /*22612*/
		$1.textxoffset = +$1.textxoffset; /*22613*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*22616*/
		$1.charvals = {}; /*22617*/
		for (var _9 = 0; _9 <= 42; _9 += 1) { /*22618*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*22618*/
		} /*22618*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*22625*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*22622*/
			if (!_J) { /*22624*/
				$k[$j++] = "bwipp.hibccode128badCharacter"; /*22623*/
				$k[$j++] = "HIBC Code 128 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*22623*/
				$0.raiseerror(); /*22623*/
			} /*22623*/
		} /*22623*/
		$k[$j++] = "barlen"; /*22627*/
		$k[$j++] = $1.barcode.length; /*22627*/
		if ($1.validatecheck) { /*22627*/
			var _M = $k[--$j]; /*22627*/
			$k[$j++] = _M - 1; /*22627*/
		} /*22627*/
		var _N = $k[--$j]; /*22627*/
		$1[$k[--$j]] = _N; /*22627*/
		$1.checksum = 41; /*22629*/
		for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*22633*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*22632*/
		} /*22632*/
		$1.checksum = $1.checksum % 43; /*22634*/
		if ($1.validatecheck) { /*22640*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*22638*/
				$k[$j++] = "bwipp.hibccode128badCheckDigit"; /*22637*/
				$k[$j++] = "Incorrect HIBC Code 128 check digit provided"; /*22637*/
				$0.raiseerror(); /*22637*/
			} /*22637*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*22639*/
		} /*22639*/
		var _j = $s($1.barlen + 2); /*22642*/
		$puti(_j, 1, $1.barcode); /*22642*/
		$1.barcode = _j; /*22642*/
		$put($1.barcode, 0, 43); /*22643*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*22644*/
		$1.text = $s($1.barlen + 4); /*22646*/
		$put($1.text, 0, 42); /*22647*/
		$puti($1.text, 1, $1.barcode); /*22648*/
		var _10 = $get($1.barcode, $1.barlen + 1); /*22649*/
		$k[$j++] = $1.text; /*22649*/
		$k[$j++] = $1.barlen + 2; /*22649*/
		$k[$j++] = _10; /*22649*/
		if (_10 == 32) { /*22649*/
			$j--; /*22649*/
			$k[$j++] = 95; /*22649*/
		} /*22649*/
		var _11 = $k[--$j]; /*22649*/
		var _12 = $k[--$j]; /*22649*/
		$put($k[--$j], _12, _11); /*22649*/
		$put($1.text, $1.barlen + 3, 42); /*22650*/
		$1.options.dontdraw = true; /*22653*/
		$1.options.validatecheck = false; /*22654*/
		$k[$j++] = "args"; /*22655*/
		$k[$j++] = $1.barcode; /*22655*/
		$k[$j++] = $1.options; /*22655*/
		$0.code128(); /*22655*/
		var _1A = $k[--$j]; /*22655*/
		$1[$k[--$j]] = _1A; /*22655*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*22657*/
		$1.args.textxalign = "center"; /*22658*/
		$1.args.opt = $1.options; /*22659*/
		$k[$j++] = $1.args; /*22662*/
		if (!$1.dontdraw) { /*22662*/
			$0.renlinear(); /*22662*/
		} /*22662*/
	};
	$0.hibcdatamatrix = function() {
		var $1 = {}; /*22690*/
		$1.options = $k[--$j]; /*22692*/
		$1.barcode = $k[--$j]; /*22693*/
		$1.dontdraw = false; /*22695*/
		$1.validatecheck = false; /*22696*/
		$forall($1.options, function() { /*22707*/
			var _3 = $k[--$j]; /*22707*/
			$1[$k[--$j]] = _3; /*22707*/
		}); /*22707*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*22710*/
		$1.charvals = {}; /*22711*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*22712*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*22712*/
		} /*22712*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*22719*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*22716*/
			if (!_F) { /*22718*/
				$k[$j++] = "bwipp.hibcdatamatrixBadCharacter"; /*22717*/
				$k[$j++] = "HIBC Data Matrix must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*22717*/
				$0.raiseerror(); /*22717*/
			} /*22717*/
		} /*22717*/
		$k[$j++] = "barlen"; /*22721*/
		$k[$j++] = $1.barcode.length; /*22721*/
		if ($1.validatecheck) { /*22721*/
			var _I = $k[--$j]; /*22721*/
			$k[$j++] = _I - 1; /*22721*/
		} /*22721*/
		var _J = $k[--$j]; /*22721*/
		$1[$k[--$j]] = _J; /*22721*/
		$1.checksum = 41; /*22723*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*22727*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*22726*/
		} /*22726*/
		$1.checksum = $1.checksum % 43; /*22728*/
		if ($1.validatecheck) { /*22734*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*22732*/
				$k[$j++] = "bwipp.hibcdatamatrixBadCheckDigit"; /*22731*/
				$k[$j++] = "Incorrect HIBC Data Matrix check digit provided"; /*22731*/
				$0.raiseerror(); /*22731*/
			} /*22731*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*22733*/
		} /*22733*/
		var _f = $s($1.barlen + 2); /*22736*/
		$puti(_f, 1, $1.barcode); /*22736*/
		$1.barcode = _f; /*22736*/
		$put($1.barcode, 0, 43); /*22737*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*22738*/
		$1.options.dontdraw = true; /*22741*/
		$1.options.validatecheck = false; /*22742*/
		$k[$j++] = "args"; /*22743*/
		$k[$j++] = $1.barcode; /*22743*/
		$k[$j++] = $1.options; /*22743*/
		$0.datamatrix(); /*22743*/
		var _r = $k[--$j]; /*22743*/
		$1[$k[--$j]] = _r; /*22743*/
		$1.args.opt = $1.options; /*22745*/
		$k[$j++] = $1.args; /*22748*/
		if (!$1.dontdraw) { /*22748*/
			$0.renmatrix(); /*22748*/
		} /*22748*/
	};
	$0.hibcdatamatrixrectangular = function() {
		var $1 = {}; /*22776*/
		$1.options = $k[--$j]; /*22778*/
		$1.barcode = $k[--$j]; /*22779*/
		$1.dontdraw = false; /*22781*/
		$1.validatecheck = false; /*22782*/
		$forall($1.options, function() { /*22793*/
			var _3 = $k[--$j]; /*22793*/
			$1[$k[--$j]] = _3; /*22793*/
		}); /*22793*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*22796*/
		$1.charvals = {}; /*22797*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*22798*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*22798*/
		} /*22798*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*22805*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*22802*/
			if (!_F) { /*22804*/
				$k[$j++] = "bwipp.hibcdatamatrixrectangularBadCharacter"; /*22803*/
				$k[$j++] = "HIBC Data Matrix Rectangular must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*22803*/
				$0.raiseerror(); /*22803*/
			} /*22803*/
		} /*22803*/
		$k[$j++] = "barlen"; /*22807*/
		$k[$j++] = $1.barcode.length; /*22807*/
		if ($1.validatecheck) { /*22807*/
			var _I = $k[--$j]; /*22807*/
			$k[$j++] = _I - 1; /*22807*/
		} /*22807*/
		var _J = $k[--$j]; /*22807*/
		$1[$k[--$j]] = _J; /*22807*/
		$1.checksum = 41; /*22809*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*22813*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*22812*/
		} /*22812*/
		$1.checksum = $1.checksum % 43; /*22814*/
		if ($1.validatecheck) { /*22820*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*22818*/
				$k[$j++] = "bwipp.hibcdatamatrixrectangularBadCheckDigit"; /*22817*/
				$k[$j++] = "Incorrect HIBC Data Matrix Rectangular check digit provided"; /*22817*/
				$0.raiseerror(); /*22817*/
			} /*22817*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*22819*/
		} /*22819*/
		var _f = $s($1.barlen + 2); /*22822*/
		$puti(_f, 1, $1.barcode); /*22822*/
		$1.barcode = _f; /*22822*/
		$put($1.barcode, 0, 43); /*22823*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*22824*/
		$1.options.dontdraw = true; /*22827*/
		$1.options.validatecheck = false; /*22828*/
		$1.options.format = "rectangle"; /*22829*/
		$k[$j++] = "args"; /*22830*/
		$k[$j++] = $1.barcode; /*22830*/
		$k[$j++] = $1.options; /*22830*/
		$0.datamatrix(); /*22830*/
		var _s = $k[--$j]; /*22830*/
		$1[$k[--$j]] = _s; /*22830*/
		$1.args.opt = $1.options; /*22832*/
		$k[$j++] = $1.args; /*22835*/
		if (!$1.dontdraw) { /*22835*/
			$0.renmatrix(); /*22835*/
		} /*22835*/
	};
	$0.hibcpdf417 = function() {
		var $1 = {}; /*22863*/
		$1.options = $k[--$j]; /*22865*/
		$1.barcode = $k[--$j]; /*22866*/
		$1.dontdraw = false; /*22868*/
		$1.columns = 2; /*22869*/
		$1.validatecheck = false; /*22870*/
		$forall($1.options, function() { /*22881*/
			var _3 = $k[--$j]; /*22881*/
			$1[$k[--$j]] = _3; /*22881*/
		}); /*22881*/
		$1.columns = ~~$1.columns; /*22883*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*22886*/
		$1.charvals = {}; /*22887*/
		for (var _6 = 0; _6 <= 42; _6 += 1) { /*22888*/
			$put($1.charvals, $geti($1.barchars, _6, 1), _6); /*22888*/
		} /*22888*/
		for (var _C = 0, _B = $1.barcode.length - 1; _C <= _B; _C += 1) { /*22895*/
			var _G = $get($1.charvals, $geti($1.barcode, _C, 1)) !== undefined; /*22892*/
			if (!_G) { /*22894*/
				$k[$j++] = "bwipp.hibcpdf417BadCharacter"; /*22893*/
				$k[$j++] = "HIBC PDF417 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*22893*/
				$0.raiseerror(); /*22893*/
			} /*22893*/
		} /*22893*/
		$k[$j++] = "barlen"; /*22897*/
		$k[$j++] = $1.barcode.length; /*22897*/
		if ($1.validatecheck) { /*22897*/
			var _J = $k[--$j]; /*22897*/
			$k[$j++] = _J - 1; /*22897*/
		} /*22897*/
		var _K = $k[--$j]; /*22897*/
		$1[$k[--$j]] = _K; /*22897*/
		$1.checksum = 41; /*22899*/
		for (var _O = 0, _N = $1.barlen - 1; _O <= _N; _O += 1) { /*22903*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _O, 1)) + $1.checksum; /*22902*/
		} /*22902*/
		$1.checksum = $1.checksum % 43; /*22904*/
		if ($1.validatecheck) { /*22910*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*22908*/
				$k[$j++] = "bwipp.hibcpdf417BadCheckDigit"; /*22907*/
				$k[$j++] = "Incorrect HIBC PDF417 check digit provided"; /*22907*/
				$0.raiseerror(); /*22907*/
			} /*22907*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*22909*/
		} /*22909*/
		var _g = $s($1.barlen + 2); /*22912*/
		$puti(_g, 1, $1.barcode); /*22912*/
		$1.barcode = _g; /*22912*/
		$put($1.barcode, 0, 43); /*22913*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*22914*/
		$1.options.dontdraw = true; /*22917*/
		$1.options.columns = $1.columns; /*22918*/
		$1.options.validatecheck = false; /*22919*/
		$k[$j++] = "args"; /*22920*/
		$k[$j++] = $1.barcode; /*22920*/
		$k[$j++] = $1.options; /*22920*/
		$0.pdf417(); /*22920*/
		var _u = $k[--$j]; /*22920*/
		$1[$k[--$j]] = _u; /*22920*/
		$1.args.opt = $1.options; /*22922*/
		$k[$j++] = $1.args; /*22925*/
		if (!$1.dontdraw) { /*22925*/
			$0.renmatrix(); /*22925*/
		} /*22925*/
	};
	$0.hibcmicropdf417 = function() {
		var $1 = {}; /*22953*/
		$1.options = $k[--$j]; /*22955*/
		$1.barcode = $k[--$j]; /*22956*/
		$1.dontdraw = false; /*22958*/
		$1.columns = 2; /*22959*/
		$1.validatecheck = false; /*22960*/
		$forall($1.options, function() { /*22971*/
			var _3 = $k[--$j]; /*22971*/
			$1[$k[--$j]] = _3; /*22971*/
		}); /*22971*/
		$1.columns = ~~$1.columns; /*22973*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*22976*/
		$1.charvals = {}; /*22977*/
		for (var _6 = 0; _6 <= 42; _6 += 1) { /*22978*/
			$put($1.charvals, $geti($1.barchars, _6, 1), _6); /*22978*/
		} /*22978*/
		for (var _C = 0, _B = $1.barcode.length - 1; _C <= _B; _C += 1) { /*22985*/
			var _G = $get($1.charvals, $geti($1.barcode, _C, 1)) !== undefined; /*22982*/
			if (!_G) { /*22984*/
				$k[$j++] = "bwipp.hibcmicropdf417BadCharacter"; /*22983*/
				$k[$j++] = "HIBC MicroPDF417 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*22983*/
				$0.raiseerror(); /*22983*/
			} /*22983*/
		} /*22983*/
		$k[$j++] = "barlen"; /*22987*/
		$k[$j++] = $1.barcode.length; /*22987*/
		if ($1.validatecheck) { /*22987*/
			var _J = $k[--$j]; /*22987*/
			$k[$j++] = _J - 1; /*22987*/
		} /*22987*/
		var _K = $k[--$j]; /*22987*/
		$1[$k[--$j]] = _K; /*22987*/
		$1.checksum = 41; /*22989*/
		for (var _O = 0, _N = $1.barlen - 1; _O <= _N; _O += 1) { /*22993*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _O, 1)) + $1.checksum; /*22992*/
		} /*22992*/
		$1.checksum = $1.checksum % 43; /*22994*/
		if ($1.validatecheck) { /*23000*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*22998*/
				$k[$j++] = "bwipp.hibcmicropdf417BadCheckDigit"; /*22997*/
				$k[$j++] = "Incorrect HIBC MicroPDF417 check digit provided"; /*22997*/
				$0.raiseerror(); /*22997*/
			} /*22997*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*22999*/
		} /*22999*/
		var _g = $s($1.barlen + 2); /*23002*/
		$puti(_g, 1, $1.barcode); /*23002*/
		$1.barcode = _g; /*23002*/
		$put($1.barcode, 0, 43); /*23003*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*23004*/
		$1.options.dontdraw = true; /*23007*/
		$1.options.columns = $1.columns; /*23008*/
		$1.options.validatecheck = false; /*23009*/
		$k[$j++] = "args"; /*23010*/
		$k[$j++] = $1.barcode; /*23010*/
		$k[$j++] = $1.options; /*23010*/
		$0.micropdf417(); /*23010*/
		var _u = $k[--$j]; /*23010*/
		$1[$k[--$j]] = _u; /*23010*/
		$1.args.opt = $1.options; /*23012*/
		$k[$j++] = $1.args; /*23015*/
		if (!$1.dontdraw) { /*23015*/
			$0.renmatrix(); /*23015*/
		} /*23015*/
	};
	$0.hibcqrcode = function() {
		var $1 = {}; /*23043*/
		$1.options = $k[--$j]; /*23045*/
		$1.barcode = $k[--$j]; /*23046*/
		$1.dontdraw = false; /*23048*/
		$1.validatecheck = false; /*23049*/
		$forall($1.options, function() { /*23060*/
			var _3 = $k[--$j]; /*23060*/
			$1[$k[--$j]] = _3; /*23060*/
		}); /*23060*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*23063*/
		$1.charvals = {}; /*23064*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*23065*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*23065*/
		} /*23065*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*23072*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*23069*/
			if (!_F) { /*23071*/
				$k[$j++] = "bwipp.hibcqrcodeBadCharacter"; /*23070*/
				$k[$j++] = "HIBC QR Code must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*23070*/
				$0.raiseerror(); /*23070*/
			} /*23070*/
		} /*23070*/
		$k[$j++] = "barlen"; /*23074*/
		$k[$j++] = $1.barcode.length; /*23074*/
		if ($1.validatecheck) { /*23074*/
			var _I = $k[--$j]; /*23074*/
			$k[$j++] = _I - 1; /*23074*/
		} /*23074*/
		var _J = $k[--$j]; /*23074*/
		$1[$k[--$j]] = _J; /*23074*/
		$1.checksum = 41; /*23076*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*23080*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*23079*/
		} /*23079*/
		$1.checksum = $1.checksum % 43; /*23081*/
		if ($1.validatecheck) { /*23087*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*23085*/
				$k[$j++] = "bwipp.hibcqrcodeBadCheckDigit"; /*23084*/
				$k[$j++] = "Incorrect HIBC QR Code check digit provided"; /*23084*/
				$0.raiseerror(); /*23084*/
			} /*23084*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*23086*/
		} /*23086*/
		var _f = $s($1.barlen + 2); /*23089*/
		$puti(_f, 1, $1.barcode); /*23089*/
		$1.barcode = _f; /*23089*/
		$put($1.barcode, 0, 43); /*23090*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*23091*/
		$1.options.dontdraw = true; /*23094*/
		$1.options.validatecheck = false; /*23095*/
		$k[$j++] = "args"; /*23096*/
		$k[$j++] = $1.barcode; /*23096*/
		$k[$j++] = $1.options; /*23096*/
		$0.qrcode(); /*23096*/
		var _r = $k[--$j]; /*23096*/
		$1[$k[--$j]] = _r; /*23096*/
		$1.args.opt = $1.options; /*23098*/
		$k[$j++] = $1.args; /*23101*/
		if (!$1.dontdraw) { /*23101*/
			$0.renmatrix(); /*23101*/
		} /*23101*/
	};
	$0.hibccodablockf = function() {
		var $1 = {}; /*23129*/
		$1.options = $k[--$j]; /*23131*/
		$1.barcode = $k[--$j]; /*23132*/
		$1.dontdraw = false; /*23134*/
		$1.validatecheck = false; /*23135*/
		$forall($1.options, function() { /*23146*/
			var _3 = $k[--$j]; /*23146*/
			$1[$k[--$j]] = _3; /*23146*/
		}); /*23146*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*23149*/
		$1.charvals = {}; /*23150*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*23151*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*23151*/
		} /*23151*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*23158*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*23155*/
			if (!_F) { /*23157*/
				$k[$j++] = "bwipp.codablockfBadCharacter"; /*23156*/
				$k[$j++] = "HIBC Codablock F must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*23156*/
				$0.raiseerror(); /*23156*/
			} /*23156*/
		} /*23156*/
		$k[$j++] = "barlen"; /*23160*/
		$k[$j++] = $1.barcode.length; /*23160*/
		if ($1.validatecheck) { /*23160*/
			var _I = $k[--$j]; /*23160*/
			$k[$j++] = _I - 1; /*23160*/
		} /*23160*/
		var _J = $k[--$j]; /*23160*/
		$1[$k[--$j]] = _J; /*23160*/
		$1.checksum = 41; /*23162*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*23166*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*23165*/
		} /*23165*/
		$1.checksum = $1.checksum % 43; /*23167*/
		if ($1.validatecheck) { /*23173*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*23171*/
				$k[$j++] = "bwipp.hibccodablockfBadCheckDigit"; /*23170*/
				$k[$j++] = "Incorrect HIBC Codablock F check digit provided"; /*23170*/
				$0.raiseerror(); /*23170*/
			} /*23170*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*23172*/
		} /*23172*/
		var _f = $s($1.barlen + 2); /*23175*/
		$puti(_f, 1, $1.barcode); /*23175*/
		$1.barcode = _f; /*23175*/
		$put($1.barcode, 0, 43); /*23176*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*23177*/
		$1.options.dontdraw = true; /*23180*/
		$1.options.validatecheck = false; /*23181*/
		$k[$j++] = "args"; /*23182*/
		$k[$j++] = $1.barcode; /*23182*/
		$k[$j++] = $1.options; /*23182*/
		$0.codablockf(); /*23182*/
		var _r = $k[--$j]; /*23182*/
		$1[$k[--$j]] = _r; /*23182*/
		$1.args.opt = $1.options; /*23184*/
		$k[$j++] = $1.args; /*23187*/
		if (!$1.dontdraw) { /*23187*/
			$0.renmatrix(); /*23187*/
		} /*23187*/
	};
	$0.hibcazteccode = function() {
		var $1 = {}; /*23215*/
		$1.options = $k[--$j]; /*23217*/
		$1.barcode = $k[--$j]; /*23218*/
		$1.dontdraw = false; /*23220*/
		$1.validatecheck = false; /*23221*/
		$forall($1.options, function() { /*23232*/
			var _3 = $k[--$j]; /*23232*/
			$1[$k[--$j]] = _3; /*23232*/
		}); /*23232*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*23235*/
		$1.charvals = {}; /*23236*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*23237*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*23237*/
		} /*23237*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*23244*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*23241*/
			if (!_F) { /*23243*/
				$k[$j++] = "bwipp.hibcazteccodeBadCharacter"; /*23242*/
				$k[$j++] = "HIBC Aztec Code must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*23242*/
				$0.raiseerror(); /*23242*/
			} /*23242*/
		} /*23242*/
		$k[$j++] = "barlen"; /*23246*/
		$k[$j++] = $1.barcode.length; /*23246*/
		if ($1.validatecheck) { /*23246*/
			var _I = $k[--$j]; /*23246*/
			$k[$j++] = _I - 1; /*23246*/
		} /*23246*/
		var _J = $k[--$j]; /*23246*/
		$1[$k[--$j]] = _J; /*23246*/
		$1.checksum = 41; /*23248*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*23252*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*23251*/
		} /*23251*/
		$1.checksum = $1.checksum % 43; /*23253*/
		if ($1.validatecheck) { /*23259*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*23257*/
				$k[$j++] = "bwipp.hibcazteccodeBadCheckDigit"; /*23256*/
				$k[$j++] = "Incorrect HIBC Aztec Code check digit provided"; /*23256*/
				$0.raiseerror(); /*23256*/
			} /*23256*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*23258*/
		} /*23258*/
		var _f = $s($1.barlen + 2); /*23261*/
		$puti(_f, 1, $1.barcode); /*23261*/
		$1.barcode = _f; /*23261*/
		$put($1.barcode, 0, 43); /*23262*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*23263*/
		$1.options.dontdraw = true; /*23266*/
		$1.options.validatecheck = false; /*23267*/
		$k[$j++] = "args"; /*23268*/
		$k[$j++] = $1.barcode; /*23268*/
		$k[$j++] = $1.options; /*23268*/
		$0.azteccode(); /*23268*/
		var _r = $k[--$j]; /*23268*/
		$1[$k[--$j]] = _r; /*23268*/
		$1.args.opt = $1.options; /*23270*/
		$k[$j++] = $1.args; /*23273*/
		if (!$1.dontdraw) { /*23273*/
			$0.renmatrix(); /*23273*/
		} /*23273*/
	};
	$0.renlinear = function() {
		if ($0.bwipjs_dontdraw) { /*23296*/
			return; /*23296*/
		} /*23296*/
		var $1 = {}; /*23298*/
		$1.args = $k[--$j]; /*23300*/
		$1.sbs = $a([]); /*23303*/
		$1.bhs = $a([]); /*23304*/
		$1.bbs = $a([]); /*23305*/
		$1.txt = $a([]); /*23306*/
		$1.barcolor = "unset"; /*23307*/
		$1.includetext = false; /*23308*/
		$1.textcolor = "unset"; /*23309*/
		$1.textxalign = "unset"; /*23310*/
		$1.textyalign = "unset"; /*23311*/
		$1.textfont = "Courier"; /*23312*/
		$1.textsize = 10; /*23313*/
		$1.textxoffset = 0; /*23314*/
		$1.textyoffset = 0; /*23315*/
		$1.textgaps = 0; /*23316*/
		$1.alttext = ""; /*23317*/
		$1.bordercolor = "unset"; /*23318*/
		$1.backgroundcolor = "unset"; /*23319*/
		$1.inkspread = 0; /*23320*/
		$1.width = 0; /*23321*/
		$1.barratio = 1; /*23322*/
		$1.spaceratio = 1; /*23323*/
		$1.showborder = false; /*23324*/
		$1.borderleft = 0; /*23325*/
		$1.borderright = 0; /*23326*/
		$1.bordertop = 0; /*23327*/
		$1.borderbottom = 0; /*23328*/
		$1.borderwidth = 0.5; /*23329*/
		$1.guardwhitespace = false; /*23330*/
		$1.guardleftpos = 0; /*23331*/
		$1.guardleftypos = 0; /*23332*/
		$1.guardrightpos = 0; /*23333*/
		$1.guardrightypos = 0; /*23334*/
		$1.guardwidth = 7; /*23335*/
		$1.guardheight = 7; /*23336*/
		$forall($1.args, function() { /*23339*/
			var _7 = $k[--$j]; /*23339*/
			$1[$k[--$j]] = _7; /*23339*/
		}); /*23339*/
		var _9 = $1.opt; /*23340*/
		for (var _A in _9) { /*23340*/
			$1[_A] = _9[_A]; /*23340*/
		} /*23340*/
		$1.barcolor = "" + $1.barcolor; /*23342*/
		$1.textcolor = "" + $1.textcolor; /*23343*/
		$1.textxalign = "" + $1.textxalign; /*23344*/
		$1.textyalign = "" + $1.textyalign; /*23345*/
		$1.textfont = "" + $1.textfont; /*23346*/
		$1.textsize = +$1.textsize; /*23347*/
		$1.textxoffset = +$1.textxoffset; /*23348*/
		$1.textyoffset = +$1.textyoffset; /*23349*/
		$1.textgaps = +$1.textgaps; /*23350*/
		$1.alttext = "" + $1.alttext; /*23351*/
		$1.bordercolor = "" + $1.bordercolor; /*23352*/
		$1.backgroundcolor = "" + $1.backgroundcolor; /*23353*/
		$1.inkspread = +$1.inkspread; /*23354*/
		$1.width = +$1.width; /*23355*/
		$1.barratio = +$1.barratio; /*23356*/
		$1.spaceratio = +$1.spaceratio; /*23357*/
		$1.borderleft = +$1.borderleft; /*23358*/
		$1.borderright = +$1.borderright; /*23359*/
		$1.bordertop = +$1.bordertop; /*23360*/
		$1.borderbottom = +$1.borderbottom; /*23361*/
		$1.borderwidth = +$1.borderwidth; /*23362*/
		$1.guardleftpos = +$1.guardleftpos; /*23363*/
		$1.guardleftypos = +$1.guardleftypos; /*23364*/
		$1.guardrightpos = +$1.guardrightpos; /*23365*/
		$1.guardrightypos = +$1.guardrightypos; /*23366*/
		$1.guardwidth = +$1.guardwidth; /*23367*/
		$1.guardheight = +$1.guardheight; /*23368*/
		$1.bars = $a(~~(($1.sbs.length + 1) / 2)); /*23371*/
		$1.x = 0; /*23372*/
		$1.maxh = 0; /*23372*/
		for (var _h = 0, _g = ((~~(($1.sbs.length + 1) / 2)) * 2) - 2; _h <= _g; _h += 1) { /*23391*/
			$1.i = _h; /*23374*/
			if (($1.i % 2) == 0) { /*23388*/
				$1.d = (($get($1.sbs, $1.i) * $1.barratio) - $1.barratio) + 1; /*23376*/
				if ($get($1.sbs, $1.i) != 0) { /*23385*/
					$1.h = $get($1.bhs, ~~($1.i / 2)) * 72; /*23378*/
					$1.c = ($1.d / 2) + $1.x; /*23379*/
					$1.y = $get($1.bbs, ~~($1.i / 2)) * 72; /*23380*/
					$1.w = $1.d - $1.inkspread; /*23381*/
					$put($1.bars, ~~($1.i / 2), $a([$1.h, $1.c, $1.y, $1.w])); /*23382*/
					if (($1.h + $1.y) > $1.maxh) { /*23383*/
						$1.maxh = $1.h + $1.y; /*23383*/
					} /*23383*/
				} else { /*23385*/
					$put($1.bars, ~~($1.i / 2), -1); /*23385*/
				} /*23385*/
			} else { /*23388*/
				$1.d = (($get($1.sbs, $1.i) * $1.spaceratio) - $1.spaceratio) + 1; /*23388*/
			} /*23388*/
			$1.x = $1.x + $1.d; /*23390*/
		} /*23390*/
		$$.save(); /*23393*/
		var _1M = $$.currpos(); /*23395*/
		$$.translate(_1M.x, _1M.y); /*23395*/
		if ($1.width != 0) { /*23400*/
			$$.scale(($1.width * 72) / $1.x, 1); /*23399*/
		} /*23399*/
		$$.newpath(); /*23403*/
		$$.moveto(-$1.borderleft, -$1.borderbottom); /*23404*/
		$$.rlineto(($1.x + $1.borderleft) + $1.borderright, 0); /*23405*/
		$$.rlineto(0, ($1.maxh + $1.borderbottom) + $1.bordertop); /*23406*/
		$$.rlineto(-(($1.x + $1.borderleft) + $1.borderright), 0); /*23407*/
		$$.rlineto(0, -(($1.maxh + $1.borderbottom) + $1.bordertop)); /*23408*/
		$$.closepath(); /*23409*/
		$$.setextent(); /*23412*/
		if ($1.showborder) { /*23419*/
			$$.save(); /*23415*/
			if ($ne($1.bordercolor, "unset")) { /*23416*/
				$$.setcolor($1.bordercolor); /*23416*/
			} /*23416*/
			$$.setlinewidth($1.borderwidth); /*23417*/
			$$.stroke(); /*23417*/
			$$.restore(); /*23418*/
		} /*23418*/
		$$.save(); /*23422*/
		if ($ne($1.barcolor, "unset")) { /*23424*/
			$$.setcolor($1.barcolor); /*23424*/
		} /*23424*/
		var _1k = $1.bars; /*23425*/
		for (var _1l = 0, _1m = _1k.length; _1l < _1m; _1l++) { /*23431*/
			var _1n = $get(_1k, _1l); /*23431*/
			$k[$j++] = _1n; /*23430*/
			if (_1n != -1) { /*23429*/
				$aload($k[--$j]); /*23427*/
				$$.newpath(); /*23427*/
				$$.setlinewidth($k[--$j]); /*23427*/
				var _1q = $k[--$j]; /*23427*/
				$$.moveto($k[--$j], _1q); /*23427*/
				$$.rlineto(0, $k[--$j]); /*23427*/
				$$.stroke(); /*23427*/
			} else { /*23429*/
				$j--; /*23429*/
			} /*23429*/
		} /*23429*/
		$$.restore(); /*23432*/
		if ($ne($1.textcolor, "unset")) { /*23435*/
			$$.setcolor($1.textcolor); /*23435*/
		} /*23435*/
		if ($1.includetext) { /*23492*/
			if (($eq($1.textxalign, "unset") && $eq($1.textyalign, "unset")) && $eq($1.alttext, "")) { /*23490*/
				$1.s = 0; /*23438*/
				$1.fn = ""; /*23438*/
				var _1z = $1.txt; /*23439*/
				for (var _20 = 0, _21 = _1z.length; _20 < _21; _20++) { /*23448*/
					$forall($get(_1z, _20)); /*23440*/
					var _23 = $k[--$j]; /*23441*/
					var _24 = $k[--$j]; /*23441*/
					$k[$j++] = _24; /*23446*/
					$k[$j++] = _23; /*23446*/
					if ((_23 != $1.s) || $ne(_24, $1.fn)) { /*23445*/
						var _27 = $k[--$j]; /*23442*/
						var _28 = $k[--$j]; /*23442*/
						$1.s = _27; /*23442*/
						$1.fn = _28; /*23442*/
						var _29 = $$.findfont(_28); /*23443*/
						_29.FontSize = _27; /*23443*/
						$$.setfont(_29); /*23443*/
					} else { /*23445*/
						$j -= 2; /*23445*/
					} /*23445*/
					var _2A = $k[--$j]; /*23447*/
					$$.moveto($k[--$j], _2A); /*23447*/
					$$.show($k[--$j], 0, 0); /*23447*/
				} /*23447*/
			} else { /*23490*/
				var _2E = $$.findfont($1.textfont); /*23450*/
				_2E.FontSize = $1.textsize; /*23450*/
				$$.setfont(_2E); /*23450*/
				if ($eq($1.alttext, "")) { /*23456*/
					$k[$j++] = Infinity; /*23452*/
					var _2H = $1.txt; /*23452*/
					for (var _2I = 0, _2J = _2H.length; _2I < _2J; _2I++) { /*23452*/
						$forall($get($get(_2H, _2I), 0)); /*23452*/
					} /*23452*/
					$1.txt = $a(); /*23452*/
					$1.tstr = $s($1.txt.length); /*23453*/
					for (var _2R = 0, _2Q = $1.txt.length - 1; _2R <= _2Q; _2R += 1) { /*23454*/
						$put($1.tstr, _2R, $get($1.txt, _2R)); /*23454*/
					} /*23454*/
				} else { /*23456*/
					$1.tstr = $1.alttext; /*23456*/
				} /*23456*/
				if ($1.tstr.length == 0) { /*23472*/
					$k[$j++] = 0; /*23461*/
				} else { /*23472*/
					$$.save(); /*23463*/
					$$.newpath(); /*23464*/
					$$.moveto(0, 0); /*23464*/
					$$.charpath("0", false); /*23464*/
					var _2X = $$.pathbbox(); /*23464*/
					$$.restore(); /*23466*/
					var _2Y = $$.currfont(); /*23467*/
					var _2Z = _2Y.PaintType !== undefined; /*23467*/
					$k[$j++] = _2X.ury; /*23467*/
					if (_2Z) { /*23467*/
						var _2a = $$.currfont(); /*23467*/
						$k[$j++] = _2a.PaintType == 2; /*23467*/
					} else { /*23467*/
						$k[$j++] = false; /*23467*/
					} /*23467*/
					var _2c = $$.currfont(); /*23468*/
					var _2d = _2c.StrokeWidth !== undefined; /*23468*/
					if ($k[--$j] && _2d) { /*23473*/
						var _2f = $$.currfont(); /*23469*/
						var _2h = $$.currfont(); /*23470*/
						var _2i = _2h.FontMatrix; /*23470*/
						var _2j = _2f.StrokeWidth / 2; /*23471*/
						var _2k = $k[--$j]; /*23472*/
						$k[$j++] = _2k + (Math.sqrt((_2j * _2j) + (0 * 0))); /*23472*/
					} /*23472*/
				} /*23472*/
				$1.textascent = $k[--$j]; /*23475*/
				var _2n = $$.stringwidth($1.tstr); /*23476*/
				$1.textwidth = _2n.w + (($1.tstr.length - 1) * $1.textgaps); /*23476*/
				$1.textxpos = $1.textxoffset + (($1.x - $1.textwidth) / 2); /*23478*/
				if ($eq($1.textxalign, "left")) { /*23479*/
					$1.textxpos = $1.textxoffset; /*23479*/
				} /*23479*/
				if ($eq($1.textxalign, "right")) { /*23480*/
					$1.textxpos = ($1.x - $1.textxoffset) - $1.textwidth; /*23480*/
				} /*23480*/
				if ($eq($1.textxalign, "offleft")) { /*23481*/
					$1.textxpos = -($1.textwidth + $1.textxoffset); /*23481*/
				} /*23481*/
				if ($eq($1.textxalign, "offright")) { /*23482*/
					$1.textxpos = $1.x + $1.textxoffset; /*23482*/
				} /*23482*/
				if ($eq($1.textxalign, "justify") && ($1.textwidth < $1.x)) { /*23486*/
					$1.textxpos = 0; /*23484*/
					$1.textgaps = ($1.x - $1.textwidth) / ($1.tstr.length - 1); /*23485*/
				} /*23485*/
				$1.textypos = -(($1.textyoffset + $1.textascent) + 1); /*23487*/
				if ($eq($1.textyalign, "above")) { /*23488*/
					$1.textypos = ($1.textyoffset + $1.maxh) + 1; /*23488*/
				} /*23488*/
				if ($eq($1.textyalign, "center")) { /*23489*/
					$1.textypos = $1.textyoffset + (($1.maxh - $1.textascent) / 2); /*23489*/
				} /*23489*/
				$$.moveto($1.textxpos, $1.textypos); /*23490*/
				$$.show($1.tstr, $1.textgaps, 0); /*23490*/
			} /*23490*/
		} /*23490*/
		if ($1.guardwhitespace) { /*23505*/
			var _3P = $$.findfont("OCR-B"); /*23496*/
			_3P.FontSize = ($1.guardheight * 2) - 1; /*23496*/
			$$.setfont(_3P); /*23496*/
			if ($1.guardleftpos != 0) { /*23500*/
				$$.moveto((-$1.guardleftpos) - 1.5, ($1.guardleftypos - ($1.guardheight / 2)) - 1); /*23498*/
				$$.show("<", 0, 0); /*23499*/
			} /*23499*/
			if ($1.guardrightpos != 0) { /*23504*/
				$$.moveto(($1.guardrightpos + $1.x) - $1.guardwidth, ($1.guardrightypos - ($1.guardheight / 2)) - 1); /*23502*/
				$$.show(">", 0, 0); /*23503*/
			} /*23503*/
		} /*23503*/
		$$.restore(); /*23507*/
	};
	$0.renmatrix = function() {
		if ($0.bwipjs_dontdraw) { /*23525*/
			return; /*23525*/
		} /*23525*/
		var $1 = {}; /*23527*/
		$1.args = $k[--$j]; /*23529*/
		$1.width = 1; /*23532*/
		$1.height = 1; /*23533*/
		$1.barcolor = "unset"; /*23534*/
		$1.backgroundcolor = "unset"; /*23535*/
		$forall($1.args, function() { /*23538*/
			var _3 = $k[--$j]; /*23538*/
			$1[$k[--$j]] = _3; /*23538*/
		}); /*23538*/
		var _5 = $1.opt; /*23539*/
		for (var _6 in _5) { /*23539*/
			$1[_6] = _5[_6]; /*23539*/
		} /*23539*/
		$1.width = +$1.width; /*23541*/
		$1.height = +$1.height; /*23542*/
		$1.barcolor = "" + $1.barcolor; /*23543*/
		$1.backgroundcolor = "" + $1.backgroundcolor; /*23544*/
		$1.pixx8 = (~~Math.ceil($1.pixx / 8)) * 8; /*23547*/
		$k[$j++] = Infinity; /*23548*/
		for (var _F = 0, _G = $1.pixx8 * $1.pixy; _F < _G; _F++) { /*23548*/
			$k[$j++] = 0; /*23548*/
		} /*23548*/
		$1.pixs8 = $a(); /*23548*/
		for (var _K = 0, _J = $1.pixy - 1; _K <= _J; _K += 1) { /*23552*/
			$1.i = _K; /*23550*/
			$puti($1.pixs8, $1.pixx8 * $1.i, $geti($1.pixs, $1.pixx * $1.i, $1.pixx)); /*23551*/
		} /*23551*/
		$1.pixs = $1.pixs8; /*23553*/
		$1.imgstr = $s(~~($1.pixs.length / 8)); /*23556*/
		for (var _Y = 0, _X = $1.pixs.length - 1; _Y <= _X; _Y += 1) { /*23560*/
			$1.i = _Y; /*23558*/
			var _Z = $1.imgstr; /*23559*/
			var _a = $1.i; /*23559*/
			$put(_Z, ~~(_a / 8), $get(_Z, ~~(_a / 8)) + ((~~(Math.pow(2, 7 - ($1.i % 8)))) * $get($1.pixs, $1.i))); /*23559*/
		} /*23559*/
		$$.save(); /*23563*/
		var _g = $$.currpos(); /*23564*/
		$$.translate(_g.x, _g.y); /*23564*/
		$$.scale(72 * $1.width, 72 * $1.height); /*23565*/
		$$.moveto(0.0001, 0.0001); /*23566*/
		$$.lineto(0.9999, 0.0001); /*23566*/
		$$.lineto(0.9999, 0.9999); /*23566*/
		$$.lineto(0.0001, 0.9999); /*23566*/
		$$.closepath(); /*23566*/
		$$.setextent(); /*23567*/
		if ($ne($1.barcolor, "unset")) { /*23569*/
			$$.setcolor($1.barcolor); /*23569*/
		} /*23569*/
		$$.imagemask($1.pixx, $1.pixy, $1.imgstr); /*23574*/
		$$.restore(); /*23575*/
	};
	$0.renmaximatrix = function() {
		if ($0.bwipjs_dontdraw) { /*23595*/
			return; /*23595*/
		} /*23595*/
		var $1 = {}; /*23597*/
		$1.args = $k[--$j]; /*23599*/
		$1.barcolor = "unset"; /*23602*/
		$1.backgroundcolor = "unset"; /*23603*/
		$forall($1.args, function() { /*23606*/
			var _3 = $k[--$j]; /*23606*/
			$1[$k[--$j]] = _3; /*23606*/
		}); /*23606*/
		var _5 = $1.opt; /*23607*/
		for (var _6 in _5) { /*23607*/
			$1[_6] = _5[_6]; /*23607*/
		} /*23607*/
		$1.barcolor = "" + $1.barcolor; /*23609*/
		$1.backgroundcolor = "" + $1.backgroundcolor; /*23610*/
		$$.save(); /*23612*/
		var _A = $$.currpos(); /*23614*/
		$$.translate(_A.x, _A.y); /*23614*/
		$$.scale(2.4945, 2.4945); /*23616*/
		$$.moveto(0, 0); /*23618*/
		$$.lineto(30, 0); /*23618*/
		$$.lineto(30, 29); /*23618*/
		$$.lineto(0, 29); /*23618*/
		$$.closepath(); /*23618*/
		$$.setextent(); /*23619*/
		if ($ne($1.barcolor, "unset")) { /*23621*/
			$$.setcolor($1.barcolor); /*23621*/
		} /*23621*/
		$$.translate(0.5, 0.5774); /*23623*/
		var _D = $$.findfont("OCRB"); /*23625*/
		_D.FontSize = 2.8; /*23625*/
		$$.setfont(_D); /*23625*/
		$$.newpath(); /*23627*/
		var _E = $1.pixs; /*23628*/
		for (var _F = 0, _G = _E.length; _F < _G; _F++) { /*23636*/
			var _H = $get(_E, _F); /*23636*/
			$1.x = _H % 30; /*23630*/
			$1.y = ~~(_H / 30); /*23631*/
			if (($1.y % 2) == 0) { /*23632*/
				$k[$j++] = $1.x; /*23632*/
			} else { /*23632*/
				$k[$j++] = $1.x + 0.5; /*23632*/
			} /*23632*/
			$$.moveto($k[--$j], (32 - $1.y) * 0.8661); /*23634*/
			$$.show("\xae", 0, 0); /*23635*/
		} /*23635*/
		var _N = $$.findfont("OCRB"); /*23639*/
		_N.FontSize = 2.85; /*23639*/
		$$.setfont(_N); /*23639*/
		$$.moveto(14, 13.8576); /*23640*/
		$$.show("\xa9", 0, 0); /*23640*/
		$$.restore(); /*23642*/
	};
	// bwip-js/barcode-ftr.js
	//
	// This code is injected below the cross-compiled barcode.ps.

	// The BWIPP symbol is a factory object.  When called, it returns this
	// function, which is a re-usable postscript emulation for BWIPP.
	return function(bwipjs, encoder, text, opts, dontdraw) {
		if (!$0[encoder]) {
			throw new Error('bwipp.unknownEncoder: ' + encoder);
		}
		if (typeof text !== 'string') {
			throw new Error('bwipp.typeError: barcode text not a string (' +
				text + ')');
		}
		opts = opts || {};
		if (typeof opts === 'string') {
			var tmp = opts.split(' ');
			opts = {};
			for (var i = 0; i < tmp.length; i++) {
				if (!tmp[i]) {
					continue;
				}
				var eq = tmp[i].indexOf('=');
				if (eq == -1) {
					opts[tmp[i]] = true;
				} else {
					opts[tmp[i].substr(0, eq)] = tmp[i].substr(eq + 1);
				}
			}
		} else if (typeof opts !== 'object' || opts.constructor !== Object) {
			throw new Error('bwipp.typeError: options not an object');
		}

		// Convert utf-16 to utf-8 but leave binary (8-bit) strings untouched.
		if (/[\u0100-\uffff]/.test(text)) {
			text = unescape(encodeURIComponent(text));
		}

		// Handle the `parse` option here rather than in BWIPP - eliminates
		// conflict with the parsefnc option and allows removing the parsing
		// code from BWIPP.
		if (opts.parse) {
			text = text.replace(/\^(\d\d\d)/g, function($0, $1) {
				var v = +$1;
				if (v > 255) {
					throw new Error('bwipp.rangeError:' +
						' ^NNN out-of-range (' + $0 + ')');
				}
				return String.fromCharCode(v);
			});
			delete opts.parse;
		}

		// Don't draw? (See file runtest)
		$0.bwipjs_dontdraw = dontdraw || false;

		// Invoke the encoder
		$$ = bwipjs;
		$k = [text, opts];
		$j = 2;
		$0[encoder]();

		// Return what is left on the stack.  This branch should only be taken
		// when running tests with the dontdraw option.
		if ($j) {
			return $k.splice(0, $j);
		}
		// Otherwise, just return ok
		return true;
	}
}
if (typeof module === 'object' && module.exports) {
	module.exports = BWIPP;
}